import React, { useReducer, useContext, createContext, useState, useMemo, useEffect, useRef, useCallback, useLayoutEffect } from "react";
import { loadState, saveState, pollLatestId, listEvents, createEvent, reopenEvent, deleteEvent, undeleteEvent, setEventFreigabe, checkBuero, loadGast, pollGast, listTours, loadTour, listAbos, createAbo, setAboAktiv, setEventZweck, kalenderLink, listOrte, createOrt, updateOrt, listStunden, bestaetigeStunde, speicherePerson, einstieg, bueroSitzung, holeSitzung, setzeSitzung, serverJetzt, anmelden, abmelden, ssoEinloesen, academyLoginUrl, zaehleTor, speichereEinsatzteam, academyPersonen, ladeKatalog, listeBeitraege, sendeBild, sendeBeitrag, ladeBeitragBild, setzeEventEinwilligung, ladeBericht, sendeBerichtNeu, outboxErneut, uxBericht, uxStatusSetzen, einsatzAktion } from "./persistence.js";
import qrcode from "qrcode-generator";
import { uxStart, uxMelde, uxKontext, uxBildschirm, uxAktion, uxAbsturz, uxWeg } from "./usability.js"; // Stand 40

/* =====================================================================
   MICROSOCCER — FUNDAMENT   ·   Stufe 0 · Schritt 1 + 2
   ---------------------------------------------------------------------
   EIN zentrales Theme  +  EIN gemeinsames Datenmodell ("eine Wahrheit")
   für alle 15 Bausteine. Bisher lag beides in jeder .jsx-Datei doppelt;
   hier wird es zusammengezogen. Der "Fundament-Check" unten ist ein
   read-only Nachweis: alles, was er zeigt, stammt aus genau EINEM seed()
   und EINEM Theme C.

   Aufbau (später leicht in eigene Dateien trennbar):
     1) THEME          -> theme.js
     2) DATENMODELL    -> dataModel.js  (Fabriken, Regeln, seed)
     3) STORE          -> Naht zu Schritt 3 (Rahmen/Navigation)
     4) FUNDAMENT-CHECK -> Nachweis-Ansicht

   Artefakt-Regeln (Stand vom allerersten Prototyp, Schritt 1+2): nur aus
   "react" importiert, ein Default-Export, kein <form>. Inzwischen laengst
   ueberholt durch die echte Server-Synchronisation (persistence.js) UND
   durch einen bewusst eng begrenzten localStorage-Einsatz (Stand 31,
   Nachtrag 2): NUR die eigene Sitzungs-Identitaet (role/boundTeamId/
   boundDeviceId/view) wird lokal gespiegelt, damit ein Reload nicht wie
   ein fremdes Geraet aussieht -- siehe LOCAL_SESSION_KEY weiter unten.
   Turnierdaten bleiben ausschliesslich im Server-State, nie in
   localStorage.
   ===================================================================== */


/* =====================================================================
   1) ZENTRALES THEME  (Schritt 2)
   ===================================================================== */

// Marke immer als EIN Wort schreiben.
const BRAND = "Microsoccer";

// Konsolidierte Palette: Basis-Tokens (in allen Bausteinen identisch)
// + semantische Tokens (Säulen, Podest, Aufgabentypen) + Beamer-Dunkel.
const C = {
  // Basis
  chalk: "#EEF4F0",
  card: "#FFFFFF",
  ink: "#13241C",
  sub: "#54655D",  // etwas dunkler als zuvor (#5B7268) für bessere Lesbarkeit (Kontrast)
  line: "#D6E4DC",
  play: "#27A661",       // Markengrün
  playSoft: "#E3F4EB",
  fair: "#1B8A54",       // = playDeep
  playDeep: "#1B8A54",   // Alias (einige Bausteine nutzten diesen Namen)
  brk: "#F2A93B",
  brkSoft: "#FCEBCF",
  fixed: "#8CA398",
  whistle: "#E5484D",
  whistleSoft: "#FBE3E3",  // weiche Warnfläche (Live-Zähler: „zählt nicht / 0:0")
  // Drei Säulen der Gesamtwertung
  tore: "#2F6BFF",
  fp: "#27A661",
  auf: "#F2A93B",
  // Podest
  gold: "#E8A100",
  silver: "#9AA7B2",
  bronze: "#C08457",
  // Aufgabentypen
  video: "#8B5CF6",
  foto: "#0EA5E9",
  nennen: "#F2A93B",
  // Tour/Bäder-Akzent
  water: "#2F9BD8",
  paper: "#FCFBF7",
  // Beamer (Showroom, dunkel projiziert)
  beamerBg0: "#0C3823",
  beamerBg1: "#061C13",
  beamerGlow: "#3EE08C",
};

const font = `'Barlow', system-ui, -apple-system, sans-serif`;
const display = `'Barlow Condensed', 'Barlow', system-ui, sans-serif`;
const FONT_IMPORT =
  "https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600;700&family=Barlow+Condensed:wght@600;700&display=swap";

// Logos zentral (weiß = auf Grün / Kopfleisten, grün = auf hell / Urkunden & öffentliche Seiten)
const LOGO_WHITE = "data:image/png;base64,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";
const LOGO_GREEN = "data:image/png;base64,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";

// Gemeinsame Kleinhelfer (waren in jeder Datei einzeln)
const EMOJIS = ["⚽", "🔥", "⭐", "🦁", "🐯", "🦅", "🐺", "🚀", "🐉", "🐝", "🦊", "🐻", "🦈", "🐼", "⚡", "🏆"];
// Vordefinierte Coach-Namen (Nutzer-Vorgabe): als Schnellauswahl-Chips in der
// Team-Verwaltung angeboten, zusaetzlich zum bestehenden freien Eingabefeld
// (eigene/andere Namen bleiben jederzeit moeglich).
const DEFAULT_COACH_NAMES = ["Zapryan", "Amar", "Amo", "Chanel", "Viktoriia", "Hamza", "Daniel", "Gabriel", "Kristian", "Emina", "Iline", "Musti", "Rizvan", "Mohammad"];
const TEAM_COLORS = ["#27A661", "#2F6BFF", "#F2A93B", "#E5484D", "#8B5CF6", "#EC4899", "#0EA5E9", "#65A30D"];

// Stand 37d: IDs sind zufaellig (vorher zaehlte jedes Geraet ab 1000 gleich hoch ->
// Coach und Headcoach bekamen dieselben IDs fuer neue Teams/Einsaetze). Werte, die
// der Reducer erzeugt (IDs, Zeit, Zufall), werden in der Aktion aufgezeichnet, damit
// das Wiederholen nach einem 409 (Zusammenfuehren) exakt dasselbe Ergebnis liefert.
let _aufz = null; // { action, i } waehrend eine Aktion reduziert wird
function aufzWert(gen) {
  if (!_aufz || !_aufz.action || typeof _aufz.action !== "object") return gen();
  const a = _aufz.action;
  if (!Array.isArray(a._rec)) { try { Object.defineProperty(a, "_rec", { value: [], enumerable: false, writable: true }); } catch (_) { return gen(); } }
  if (_aufz.i < a._rec.length) return a._rec[_aufz.i++];
  const v = gen(); a._rec.push(v); _aufz.i++; return v;
}
const uid = () => aufzWert(() => Math.floor(Math.random() * 4e15) + 1e6);
const rnow = () => aufzWert(() => serverJetzt()); // Stand 39: Server-Uhr (alle Handys gleich)
const rrand = () => aufzWert(() => Math.random());


/* =====================================================================
   2) GEMEINSAMES DATENMODELL  (Schritt 1)
   ===================================================================== */

// --- Rollen (steuern, wer was sieht/darf) ---
const ROLES = {
  headcoach: { key: "headcoach", label: "Headcoach / Admin", emo: "🎽", hint: "pfeift an/ab, Zeit & Runden, VAR, Fairplay enthüllen, Live-Steuerung" },
  coach:     { key: "coach",     label: "Coach", emo: "📋", hint: "leitet das Team an, pfeift/zählt an der Box (Schiri-Funktion), zählt selbst keine eigenen Tore · sieht Fairplay & Aufgaben nur (Headcoach vergibt) · Team-Verwaltung nur vor Turnierstart" },
  teamaccess: { key: "teamaccess", label: "Teamzugang", emo: "📱", hint: "Zugang eines Teams · Team aus der Liste wählen (auf 1–2 Handys) · zählen, Fairplay, Medien" },
};
// Publikum ist KEIN Login, sondern eine offene Ansicht (Link teilen).
const PUBLIC_ROLE = { key: "public", label: "Öffentliche Ansicht", emo: "🌐" };
const roleLabel = (r) => (ROLES[r] || (r === "public" ? PUBLIC_ROLE : { emo: "•", label: r }));

// --- Fairplay: 7 Kriterien, rein positiv, je 1–5 Sterne ---
const FAIRPLAY_CRITERIA = [
  { k: "held",      label: "Teamheld:in",       emo: "🦸", hint: "hilft anderen, denkt ans ganze Team" },
  { k: "einbinden", label: "Zusammenhalt",      emo: "🤗", hint: "alle ziehen an einem Strang – feuern an & unterstützen, wer grad spielt" },
  { k: "cool",      label: "Cool geblieben",    emo: "🧊", hint: "ruhig, auch wenn's stressig wird" },
  { k: "feuer",     label: "Anfeuerer:in",      emo: "📣", hint: "feuert alle an – besonders die, die sich weniger trauen" },
  { k: "fair",      label: "Fair verloren",     emo: "🤝", hint: "verliert fair, gönnt dem Gegner" },
  { k: "frieden",   label: "Streitschlichter:in", emo: "🕊️", hint: "beruhigt Zoff, statt mitzumischen" },
  { k: "vibes",     label: "Good Vibes",        emo: "✨", hint: "freundlich & fair zu allen" },
];
// Fairplay-Detail als EINE Wahrheit: pro Kriterium 0–5 ★; fpStars ist immer die
// Summe daraus (nicht getrennt gepflegt), damit Gesamtwertung/Showroom nur lesen.
const emptyFp = () => Object.fromEntries(FAIRPLAY_CRITERIA.map((c) => [c.k, 0]));
const fpSum = (detail) => FAIRPLAY_CRITERIA.reduce((s, c) => s + (detail?.[c.k] || 0), 0);
// Fairplay ist Peer-Bewertung: jedes Team bewertet jedes ANDERE Team (nie sich
// selbst) je Kriterium 0-5 star. team.fpFrom haelt die rohen Bewertungen (wer
// hat wie bewertet); fpDetail/fpStars sind IMMER der Durchschnitt daraus --
// abgeleitet, keine zweite Wahrheit. Ein Team, das noch nicht bewertet hat,
// zaehlt als 0 mit (kein Minus, aber auch kein Frei-Fairplay durchs Nichtstun).
function fpRecompute(team, allTeams) {
  const raterIds = allTeams.filter((o) => o.id !== team.id).map((o) => o.id);
  // Audit-Fix (Stand 31): vorher wurde durch ALLE moeglichen Bewerter geteilt --
  // ein Team, das (noch) nicht bewertet hat, zaehlte automatisch mit 0 Sternen
  // mit, nicht von einer bewusst schlechten Bewertung zu unterscheiden. Jetzt
  // nur ueber die Teams mitteln, die tatsaechlich schon abgegeben haben.
  const submittedIds = raterIds.filter((rid) => team.fpFrom[rid]);
  const n = submittedIds.length;
  const detail = {};
  FAIRPLAY_CRITERIA.forEach((c) => {
    const sum = submittedIds.reduce((s, rid) => s + (team.fpFrom[rid].detail[c.k] || 0), 0);
    detail[c.k] = n ? Math.round((sum / n) * 10) / 10 : 0;
  });
  const stars = Math.round(FAIRPLAY_CRITERIA.reduce((s, c) => s + detail[c.k], 0) * 10) / 10;
  return { detail, stars, submitted: n, expected: raterIds.length };
}

// --- Aufgaben: Typen + Schwerpunkt-Themen (Prävention, unterschwellig) ---
const TASK_TYPES = {
  video:  { key: "video",  label: "Video",  emo: "🎬", color: C.video },
  foto:   { key: "foto",   label: "Foto",   emo: "📸", color: C.foto },
  nennen: { key: "nennen", label: "Nennen", emo: "💬", color: C.nennen },
};
const FOCUS_THEMES = [
  { k: "maedchen",  label: "Mädchen im Zentrum",       emo: "🙋‍♀️" },
  { k: "mobbing",   label: "Gegen Mobbing",            emo: "🛡️" },
  { k: "rassismus", label: "Gegen Rassismus",          emo: "🌍" },
  { k: "religion",  label: "Respekt für jeden Glauben", emo: "🙏" },
  { k: "lgbt",      label: "Jede:r gehört dazu",       emo: "🏳️‍🌈" },
  { k: "frieden",   label: "Frieden & gegen Hass",     emo: "🕊️" },
];

// --- Wertungs-Faktoren (Tore = Basis; Teamspiel-Tore doppelt) ---
// Stand 37d: zerstoerende Alt-Knoepfe (Beispieldaten, "Neues Turnier") nur ausserhalb echter Events.
function NurOhneEvent({ children }) { return useEventNav() ? null : <>{children}</>; }
// Stand 37: Demo-PINs (Demo-Events zeigen sie beim Login an).
const DEMO_PINS = { headcoach: "4711", coach: "2468", team: "1357" }; // Stand 37p: + Team-Code
function istDemoEvent(state) {
  const t = state && state.tournament;
  if (!t) return false;
  if (t.meta && t.meta.demo) return true;
  return !!t.pins && t.pins.headcoach === DEMO_PINS.headcoach && t.pins.coach === DEMO_PINS.coach;
}
const DEFAULT_FACTORS = {
  teamspiel: 2,   // Teamspiel-Tore zählen doppelt
  fairplay: 2,    // Punkte je Fairplay-Stern
  aufgaben: 2,    // Punkte je erledigte Aufgabe
};

// --- Fabriken (eine Stelle, an der Entitäten entstehen) ---
const makePlayer = (name, captain = false, goals = 0) => ({ id: uid(), name, captain, goals });
const makeDevice = (kind, label) => ({ id: uid(), kind, label, connected: false }); // kind: "zaehl" | "medien"
// Einladungs-Token (Stand 30, Team-Selbstanlage): keine echte Kryptografie noetig --
// dieselbe Vertrauensebene wie die PINs (Login ist ohnehin nur UI-Gate, kein
// Server-Auth) -- nur ausreichend eindeutig/erratungsresistent fuer einen
// weitergegebenen Link.
const makeInviteToken = () => `${rnow().toString(36)}${rrand().toString(36).slice(2, 10)}`;
// Audit-Fix (Nutzer-Vorgabe): Logo (Emoji) und Farbe wurden bisher rein nach
// dem Array-Index vergeben (i % Pool-Laenge, wobei i = state.teams.length
// zum Anlage-Zeitpunkt war). Nach einem Loeschen+Neuanlegen -- oder schlicht
// bei mehr Teams als Pool-Eintraegen -- konnten dadurch ZWEI GLEICHZEITIG
// EXISTIERENDE Teams dasselbe Logo/dieselbe Farbe bekommen (z. B.: 4 Teams,
// "Team 2" loeschen, neues Team anlegen -> bekommt exakt "Team 2"s alten
// Emoji-Index zurueck, der aber von "Team 4" schon benutzt wird). Diese
// Helfer suchen stattdessen den ERSTEN noch nicht verwendeten Wert unter
// den TATSAECHLICH existierenden Teams -- kein Duplikat, solange der Pool
// reicht; erst wenn mehr Teams als Pool-Eintraege existieren, bleibt nur
// zyklisches Wiederverwenden uebrig (unvermeidbar, aber dann wenigstens
// gleichmaessig verteilt statt durch Loesch-Luecken zufaellig kollidierend).
function nextUnusedEmoji(existingTeams) {
  const used = new Set(existingTeams.map((t) => t.emoji));
  return EMOJIS.find((e) => !used.has(e)) || EMOJIS[existingTeams.length % EMOJIS.length];
}
function nextUnusedColor(existingTeams) {
  const used = new Set(existingTeams.map((t) => t.color));
  return TEAM_COLORS.find((c) => !used.has(c)) || TEAM_COLORS[existingTeams.length % TEAM_COLORS.length];
}
function nextDefaultTeamName(existingTeams) {
  const used = new Set(existingTeams.map((t) => t.name));
  let n = 1;
  while (used.has(`Team ${n}`)) n++;
  return `Team ${n}`;
}
const makeTeam = (name, existingTeams = []) => ({
  id: uid(),
  name,
  emoji: nextUnusedEmoji(existingTeams),
  color: nextUnusedColor(existingTeams),
  logoImg: null,
  photo: null,
  coach: "",
  players: [],
  devices: [makeDevice("zaehl", "Zähl-Handy"), makeDevice("medien", "Medien-Handy")],  // genau 2 pro Team: zählen + Medien
  gallery: [],           // { id, url, kind:'foto'|'video', star, taskId }
  // Wertungs-Säulen (Basis-"Wahrheit", von der alles ableitet)
  tore: 0,               // Einzelspiel-Tore
  teamspielTore: 0,      // zählen mit Faktor teamspiel
  fpDetail: emptyFp(),   // Fairplay je Kriterium (0–5 ★) — Durchschnitt aus fpFrom (abgeleitet)
  fpFrom: {},            // Peer-Bewertungen: { [raterTeamId]: { detail, fairest } } — die Wahrheit
  fpStars: 0,            // Summe aus fpDetail (Gesamtwertung liest nur diese)
  aufgabenDone: 0,       // erledigte Aufgaben
});
const makeTournament = () => ({
  meta: { title: `${BRAND} Schulturnier`, date: "", ort: "" },
  status: "offen",   // offen (spielbar/nachbereitbar) | abgeschlossen (Archiv, nur öffentliche Seite)
  pins: { ...DEMO_PINS },   // Zugangs-PINs (im echten Betrieb beim Anlegen gesetzt)
  config: {
    context: "schule",   // schule | individuell
    openEnd: false,
    ue: 2,               // 2/3/4 UE à 50 min
    customMin: 90,
    numTeams: 4,         // wird aus teams.length gespiegelt (Team-Verwaltung ist die Quelle)
    mode: "aufgaben",    // dauer = 2 Teams/Box | aufgaben = 4 Teams/Box
    gameDur: 3,          // Minuten
    targetRR: 2,         // ≥2× jeder gegen jeden
    wechsel: 2,
    boxOverride: null,   // null = auto
    // Rundherum-Zeiten (Zeitplaner) — gehören zur Wahrheit, damit Website/Ehrung sie später lesen
    checkin: 5,
    warmup: 15,
    ceremony: 15,
    uePause: 5,
    sommer: false,       // Trinkpausen einplanen
    startClock: 540,     // Startuhrzeit in Minuten (9:00)
    zaehlModus: "eigen", // eigen | gegner -- experimentell, nur vor Turnierstart aenderbar (siehe Zeitplaner)
  },
});
// min = grobe Dauer in Minuten (Wartefenster-Warnung); Default aus dem Typ (Video etwas länger).
// mc = optionale Multiple-Choice-Auswahl für "nennen"-Aufgaben: [{ text, correct }].
// null/undefined = freie Text-Antwort ist nötig (Pflicht-Freitext, siehe AuNennForm).
const makeTask = (type, text, themes = [], min, mc = null) => ({ id: uid(), type, text, themes, min: min ?? (type === "video" ? 3 : 2), mc });
// Kurzform für "nennen"-Aufgaben mit echter Multiple Choice (objektiv beantwortbar).
const makeNennMC = (text, themes, choices) => makeTask("nennen", text, themes, undefined, choices);
const makeTour = (name) => ({
  id: uid(), name,
  zeitraum: "",                               // frei, z. B. "Juli 2026" (Siegerehrung-Tour editiert das)
  kids: [],                                   // { id, name }
  events: [],                                 // { id, datum, ort, results:[{kidId, placement}] }
  scheme: { p1: 10, p2: 7, p3: 5, part: 1 },
  bestOn: false, bestN: 3,
});
// Sonderpreis (Siegerehrung): frei definierbar, verweist optional auf EIN Team.
// Gehört zur Turnier-Wahrheit — Ehrung liest/schreibt hier, baut keine zweite Kopie.
const makeAward = (emoji, title, teamId = null) => ({ id: uid(), emoji, title, teamId });
// Sonderpreis (Siegerehrung-Tour): dieselbe Idee wie makeAward, aber verweist auf
// EIN Kind statt ein Team — eigene, parallele Wahrheit (state.tourAwards), weil
// Team- und Tour-Sonderpreise unterschiedliche Empfänger-Domänen sind (Team vs.
// Kind) und sich in der Praxis nicht überschneiden müssen.
const makeTourAward = (emoji, title, kidId = null) => ({ id: uid(), emoji, title, kidId });

// --- Kern-Regeln (gehören zur "Wahrheit", nicht in einzelne Views) ---
// Rundenplan: jeder gegen jeden (Kreis-Algorithmus, 1 voller Durchgang)
function roundRobin(n) {
  const teams = [];
  for (let i = 0; i < n; i++) teams.push(i);
  if (teams.length % 2 === 1) teams.push(-1);
  const m = teams.length;
  const rounds = [];
  const arr = teams.slice();
  for (let r = 0; r < m - 1; r++) {
    const pairs = [];
    for (let i = 0; i < m / 2; i++) {
      const a = arr[i], b = arr[m - 1 - i];
      if (a !== -1 && b !== -1) pairs.push([a, b]);
    }
    rounds.push(pairs);
    const fixed = arr[0];
    const rest = arr.slice(1);
    rest.unshift(rest.pop());
    arr.splice(0, arr.length, fixed, ...rest);
  }
  return rounds;
}
// Boxen-Vorschlag (parallele Boxen ändern die Spielzeit NICHT)
const teamsPerBox = (mode) => (mode === "dauer" ? 2 : 4);
const boxesNeeded = (numTeams, mode) => Math.max(1, Math.ceil(numTeams / teamsPerBox(mode)));
// Endstand eines Teams: Tore (Basis) + Fairplay-Bonus + Aufgaben-Bonus
const teamScore = (t, f) => {
  const base = t.tore + t.teamspielTore * f.teamspiel;
  return {
    base,
    fp: t.fpStars * f.fairplay,
    auf: t.aufgabenDone * f.aufgaben,
    total: base + t.fpStars * f.fairplay + t.aufgabenDone * f.aufgaben,
  };
};
// Live-Rundenplan aus der Zeitplaner-Wahrheit ableiten: jeder gegen jeden
// (roundRobin) × targetRR Durchgänge, Basisdauer je Runde aus gameDur. Das ist
// die EINE Stelle, an der aus config ein konkreter Rundenplan entsteht — die
// Headcoach-Live-Steuerung überlagert diesen Plan danach mit echter Wahrheit
// (gespielt/gestrichen, live geänderte Dauer, laufende Runde).
// Stand 37e (Nutzer): "Der Zeitplaner bestimmt -- halbe Durchgaenge gibt es nicht,
// dann wird die Spielzeit reduziert." -> EINE Rechnung fuer Zeitplaner UND Live-Plan.
// Spielrunden je Durchgang haengen vom Modus ab (2 Teams/Box: jeder gegen jeden
// parallel; 4 Teams/Box: je Gruppe ein eigenes jgj, immer 1 Spiel pro Box).
function wandRunden(n, mode) {
  n = Math.max(0, n | 0);
  if (mode !== "aufgaben") return roundRobin(n);
  const sizes = []; let left = n;
  while (left > 0) { const sz = Math.min(4, left); sizes.push(sz); left -= sz; }
  let off = 0;
  const gruppen = sizes.map((sz) => { const ms = roundRobin(sz).flat().map(([a, b]) => [a + off, b + off]); off += sz; return ms; });
  const anzahl = Math.max(0, ...gruppen.map((g) => g.length));
  return Array.from({ length: anzahl }, (_, r) => gruppen.map((g) => g[r]).filter(Boolean));
}
function zeitplanRechnung(cfg, numTeams) {
  const c = cfg || {};
  const openEnd = !!c.openEnd, wechsel = Number(c.wechsel) || 0, gameDur = Number(c.gameDur) || 3;
  const passes = Math.max(1, c.targetRR | 0);
  const wallPerRR = wandRunden(numTeams, c.mode).length;
  const uePauseTotal = openEnd || c.context === "individuell" ? 0 : (Number(c.uePause) || 0) * ((c.ue || 1) - 1);
  const grossTotal = openEnd ? Infinity : c.context === "individuell" ? Number(c.customMin) || 0 : (c.ue || 1) * 50;
  const drinkCount = c.sommer && isFinite(grossTotal) ? Math.max(1, Math.round(grossTotal / 35)) : 0;
  const drinkTotal = drinkCount * 3;
  const fixedTotal = (Number(c.checkin) || 0) + (Number(c.warmup) || 0) + (Number(c.ceremony) || 0) + uePauseTotal + drinkTotal;
  const netWindow = openEnd ? Infinity : Math.max(0, grossTotal - fixedTotal);
  const wallRounds = passes * wallPerRR;
  const durForTarget = openEnd ? gameDur : wallRounds > 0 ? (netWindow - (wallRounds - 1) * wechsel) / wallRounds : 0;
  const passt = Math.floor(durForTarget * 2) / 2;           // auf halbe Minuten abgerundet
  const effDur = openEnd ? gameDur : Math.max(1, Math.min(gameDur, passt));
  const gekuerzt = !openEnd && effDur < gameDur;
  const zuKnapp = !openEnd && wallRounds > 0 && durForTarget < 1; // selbst 1 Minute passt nicht
  const usedPlay = wallRounds > 0 ? wallRounds * effDur + (wallRounds - 1) * wechsel : 0;
  const buffer = openEnd ? 0 : netWindow - usedPlay;
  const totalTime = openEnd ? usedPlay + (Number(c.checkin) || 0) + (Number(c.warmup) || 0) + (Number(c.ceremony) || 0) : grossTotal;
  return { wallPerRR, passes, wallRounds, uePauseTotal, grossTotal, drinkCount, drinkTotal, fixedTotal, netWindow, durForTarget, effDur, gekuerzt, zuKnapp, usedPlay, buffer, totalTime };
}
function buildLiveRounds(config) {
  const zp = zeitplanRechnung(config, config.numTeams);
  const perPass = zp.wallPerRR;                                 // Spielrunden je Durchgang (modusabhaengig)
  const passes = zp.passes;                                     // ganze Durchgaenge (jgj)
  const dur = Math.max(30, Math.round(zp.effDur * 60));         // Sekunden je Runde -- ggf. gekuerzt, damit alles passt
  const rounds = [];
  let n = 1;
  for (let p = 0; p < passes; p++) {
    for (let i = 0; i < perPass; i++) {
      rounds.push({ id: uid(), n, phase: `Gruppenphase ${p + 1}`, dur, done: false, skipped: false });
      n++;
    }
  }
  return rounds;
}
// Stand 36 -- Spieluhr ueber Zeitstempel: waehrend die Uhr laeuft, wird NICHT
// jede Sekunde gespeichert (das hat vorher Tore anderer Geraete ueberschrieben),
// sondern nur der Anpfiff-Zeitpunkt (runStartedAt) und die Restzeit dabei
// (runRemainingAtStart). Jedes Geraet rechnet die Restzeit selbst.
function liveRemaining(live, now = serverJetzt()) {
  if (!live) return 0;
  if (live.running && live.runStartedAt) {
    return Math.max(0, (live.runRemainingAtStart || 0) - Math.floor((now - live.runStartedAt) / 1000));
  }
  return Math.max(0, live.remaining || 0);
}
// Nächste noch offene (nicht gespielte / nicht gestrichene) Runde ab from+1.
function hlNextPlanned(rounds, from) {
  for (let i = from + 1; i < rounds.length; i++) if (!rounds[i].done && !rounds[i].skipped) return i;
  return -1;
}

// --- Einzel-KO: KO-Baum aus den eingetragenen Teilnehmer:innen ableiten ---
// (jeder gegen jeden gibt's hier nicht — Ausscheidung bis Sieger, zufällige
// Freilose, kleines Finale um Platz 3 ab Baumgröße 4). Das ist die EINE Stelle,
// an der aus einer Teilnehmer:innen-Liste ein konkreter Baum entsteht.
const koShuffle = (a) => {
  const r = a.slice();
  for (let i = r.length - 1; i > 0; i--) { const j = Math.floor(rrand() * (i + 1)); [r[i], r[j]] = [r[j], r[i]]; }
  return r;
};
const koNextPow2 = (n) => { let s = 2; while (s < n) s *= 2; return Math.min(16, s); };
const koClone = (x) => JSON.parse(JSON.stringify(x));

function koBuildBracket(participants) {
  const players = koShuffle(participants);
  const n = players.length;
  const size = koNextPow2(Math.max(2, n));
  const R = Math.log2(size);
  const M = size / 2;
  const byes = size - n;

  const rounds = [];
  for (let r = 0; r < R; r++) {
    const cnt = size / Math.pow(2, r + 1);
    rounds.push(Array.from({ length: cnt }).map(() => ({ id: uid(), a: null, b: null, sa: 0, sb: 0, done: false, winner: null, loser: null, golden: false })));
  }

  const byeMatches = new Set(koShuffle(Array.from({ length: M }, (_, i) => i)).slice(0, byes));
  let p = 0;
  rounds[0].forEach((m, i) => {
    if (byeMatches.has(i)) { m.a = { ...players[p++] }; m.b = { bye: true }; }
    else { m.a = { ...players[p++] }; m.b = { ...players[p++] }; }
  });

  // Freilose sofort weiterschieben
  rounds[0].forEach((m, i) => {
    if (m.b && m.b.bye) {
      m.done = true; m.winner = m.a; m.byeWin = true;
      if (R > 1) {
        const t = rounds[1][Math.floor(i / 2)];
        if (i % 2 === 0) t.a = m.a; else t.b = m.a;
      }
    }
  });

  const smallFinal = size >= 4 ? { id: uid(), a: null, b: null, sa: 0, sb: 0, done: false, winner: null, loser: null } : null;
  return { rounds, smallFinal, size, byes };
}
const koRoundName = (r, R) => {
  const d = R - 1 - r;
  return d === 0 ? "Finale" : d === 1 ? "Halbfinale" : d === 2 ? "Viertelfinale" : d === 3 ? "Achtelfinale" : `Runde ${r + 1}`;
};
// Platzierungen aus einem fertigen Baum ableiten (Sieger/Zweiter aus dem Finale,
// Dritter/Vierter aus dem kleinen Finale, falls vorhanden) — EINE Stelle, an der
// aus dem Baum ein Ergebnis wird (für die Übernahme in state.tour.events).
function koPlacements(bracket) {
  if (!bracket) return [];
  const R = bracket.rounds.length;
  const finalMatch = R > 0 ? bracket.rounds[R - 1][0] : null;
  if (!finalMatch || !finalMatch.done) return [];
  const out = [
    { placement: 1, name: finalMatch.winner.name, pid: finalMatch.winner.id },
    { placement: 2, name: finalMatch.loser.name, pid: finalMatch.loser.id },
  ];
  if (bracket.smallFinal && bracket.smallFinal.done) {
    out.push({ placement: 3, name: bracket.smallFinal.winner.name, pid: bracket.smallFinal.winner.id });
    out.push({ placement: 4, name: bracket.smallFinal.loser.name, pid: bracket.smallFinal.loser.id });
  }
  return out;
}
// Punkte je Platzierung aus dem Punkteschema der Tour (tour.scheme).
function tourPtFor(scheme, placement) {
  return placement === 1 ? scheme.p1 : placement === 2 ? scheme.p2 : placement === 3 ? scheme.p3 : scheme.part;
}
// Kind per Namensabgleich in einer Kids-Liste finden oder neu anlegen — EINE
// Stelle, die sowohl ko/saveToTour (Übernahme aus Einzel-KO) als auch
// tour/addEvent (manuell erfasste Station) nutzen, damit Kids nicht doppelt
// entstehen, egal auf welchem Weg ein Ergebnis in state.tour landet.
function tourFindOrMakeKid(kids, name) {
  const clean = (name || "").trim();
  const hit = kids.find((k) => k.name.toLowerCase() === clean.toLowerCase());
  if (hit) return { kids, id: hit.id };
  const nk = { id: uid(), name: clean };
  return { kids: [...kids, nk], id: nk.id };
}
// Tour-Rangliste aus tour.events + tour.scheme ableiten — EINE Stelle, an der aus
// den Events (u. a. aus ko/saveToTour) eine Rangliste pro Kind entsteht. Optional
// zählen nur die besten tour.bestN Tage (tour.bestOn). Fundament UND die
// Tour-Rangliste-Ansicht lesen beide nur diese Ableitung, keine zweite Kopie.
function tourStandings(tour) {
  const byKid = new Map();
  tour.events.forEach((e) => {
    e.results.forEach((r) => {
      if (!byKid.has(r.kidId)) byKid.set(r.kidId, []);
      byKid.get(r.kidId).push({ placement: r.placement, pts: tourPtFor(tour.scheme, r.placement), ort: e.ort, datum: e.datum, eventId: e.id });
    });
  });
  const rows = [...byKid.entries()].map(([kidId, entries]) => {
    const idx = entries.map((_, i) => i);
    let total; const counted = new Set();
    if (tour.bestOn) {
      const top = idx.slice().sort((a, b) => entries[b].pts - entries[a].pts).slice(0, tour.bestN);
      total = top.reduce((s, i) => s + entries[i].pts, 0);
      top.forEach((i) => counted.add(i));
    } else {
      total = entries.reduce((s, x) => s + x.pts, 0);
      idx.forEach((i) => counted.add(i));
    }
    return { kid: tour.kids.find((k) => k.id === kidId), tage: entries.length, total, entries, counted };
  }).filter((r) => r.kid);
  return rows.sort((a, b) => b.total - a.total);
}

// --- SEED: EINE konsistente Beispiel-Wahrheit für ALLE Bausteine ---
// (löst die 15 getrennten Demo-Datensätze ab)
function defaultTaskPool() {
  return [
    makeTask("video", "Eine positive Anfeuerung für euer Team"),
    makeNennMC("Nennt gemeinsam 3 Fairplay-Regeln", [], [
      { text: "Wir respektieren die Schiedsrichter-Entscheidung", correct: true },
      { text: "Der Sieger bleibt nach dem Spiel am Platz", correct: true },
      { text: "Wir feuern auch das gegnerische Team fair an", correct: true },
      { text: "Wir schreien den Schiedsrichter an, wenn er sich irrt", correct: false },
      { text: "Nur die Besten dürfen mitspielen", correct: false },
    ]),
    makeTask("video", "„Fair sein heißt für uns…\" – vervollständigt den Satz"),
    makeTask("video", "Feuert das gegnerische Team mit einem netten Spruch an"),
    makeTask("video", "Erklärt in 20 Sekunden eine Microsoccer-Regel"),
    makeTask("video", "Sagt jede:r ein Wort, das euer Team beschreibt"),
    makeTask("video", "Ruft gemeinsam euren Team-Schlachtruf"),
    makeTask("video", "Lobt euch gegenseitig: „Stark war heute, dass du…\""),
    makeTask("foto", "Ein cooles Teamfoto"),
    makeTask("foto", "Ein Jubel-Foto, als hättet ihr gerade gewonnen"),
    makeTask("foto", "Ein Foto, auf dem alle dieselbe Pose machen"),
    makeTask("foto", "Baut mit euren Körpern einen Buchstaben oder eine Zahl"),
    makeTask("foto", "Ein Foto, das „Teamgeist\" zeigt"),
    makeTask("foto", "Ein Foto mit einem Fairplay-Handschlag"),
    makeNennMC("Nennt 3 Dinge, die ein fairer Verlierer macht", [], [
      { text: "Gratuliert dem Gewinner-Team", correct: true },
      { text: "Bleibt ruhig, auch wenn er/sie enttäuscht ist", correct: true },
      { text: "Sucht nicht die Schuld beim Schiedsrichter", correct: true },
      { text: "Wirft den Ball weg", correct: false },
      { text: "Beschimpft die eigenen Mitspieler:innen", correct: false },
    ]),
    makeNennMC("Erklärt kurz: Was heißt „Sieger bleibt am Platz\"?", [], [
      { text: "Das Gewinner-Team spielt gleich die nächste Runde weiter, ohne Pause", correct: true },
      { text: "Das Gewinner-Team darf sich den nächsten Gegner aussuchen", correct: false },
      { text: "Nur der Kapitän des Gewinner-Teams bleibt am Platz", correct: false },
      { text: "Das Verlierer-Team muss das Feld sofort verlassen", correct: false },
    ]),
    makeTask("nennen", "Nennt 3 Länder, aus denen eure Lieblingsspieler:innen kommen"),
    makeTask("nennen", "Findet 3 Gemeinsamkeiten, die alle im Team teilen"),
    makeTask("nennen", "Was habt ihr heute von einem anderen Team gelernt?"),
    makeTask("nennen", "Einigt euch auf ein Team-Motto in 3 Wörtern"),
    makeTask("video", "Sagt jede:r einem anderen im Team etwas Nettes"),
    makeTask("video", "„Wenn jemand ausgeschlossen wird, machen wir…\""),
    makeNennMC("Nennt 3 Wege, wie man jemand Neues willkommen heißt", [], [
      { text: "Sich gegenseitig vorstellen und den Namen fragen", correct: true },
      { text: "Erklären, wie das Spiel bei uns läuft", correct: true },
      { text: "Fragen, ob er/sie mitspielen möchte", correct: true },
      { text: "Warten, bis die neue Person von selbst fragt", correct: false },
      { text: "Nur mit den Leuten reden, die man schon kennt", correct: false },
    ]),
    makeTask("foto", "Zeigt in einem Foto, wie ihr jemandem aufhelft"),
    makeTask("video", "Was tut ihr, wenn jemand ausgelacht wird?"),
    makeTask("nennen", "Ein cooles Wort zum Anfeuern, das niemandem wehtut"),
    makeTask("video", "„Stark ist, wer…\" – mit einer Anti-Mobbing-Idee"),
    makeTask("video", "Erfindet gemeinsam einen kurzen Jubel-Move"),
    makeTask("foto", "Ein Foto, auf dem alle in die gleiche Richtung zeigen"),
    makeTask("nennen", "Nennt 3 Dinge, die Spaß machen, auch wenn man verliert"),
    makeTask("video", "Sagt gemeinsam: „Danke fürs faire Spiel!\""),
    makeTask("foto", "Ein Foto, das eure gute Laune zeigt"),
    makeNennMC("Nennt 3 Wörter, die gute Teamkolleg:innen ausmachen", [], [
      { text: "Hilfsbereit", correct: true },
      { text: "Ehrlich", correct: true },
      { text: "Aufmunternd", correct: true },
      { text: "Egoistisch", correct: false },
      { text: "Nachtragend", correct: false },
    ]),
    makeTask("video", "Zeigt, wie ihr euch nach einem Tor gegenseitig abklatscht"),
    makeTask("nennen", "Was macht ihr, damit sich neue Kinder wohlfühlen?"),
    makeTask("foto", "Ein Foto mit einer selbst erfundenen Team-Pose"),
    makeTask("video", "Jede:r sagt, worauf er/sie im Team stolz ist"),
    makeTask("nennen", "Nennt eine Regel, die ihr besonders wichtig findet – und warum"),
    makeTask("foto", "Ein Foto, das Respekt zeigt (z. B. Handschlag, High-Five)"),
    makeTask("video", "Erklärt in einem Satz, warum Fairplay cool ist"),
    makeTask("nennen", "Findet 3 Dinge, die ihr am heutigen Turnier mögt"),
    makeTask("video", "Motiviert ein Team, das gerade wenig Tore hat"),
    makeTask("foto", "Ein Gruppenfoto, auf dem alle lachen"),
    makeTask("nennen", "Nennt 3 Gefühle, die man beim Spielen haben kann"),
    makeTask("video", "Sagt einem anderen Team ein ehrliches Kompliment"),
    makeTask("nennen", "Was heißt „zusammenhalten\" für euch? Nennt ein Beispiel"),
    makeTask("foto", "Ein Foto, das zeigt: „Wir sind ein Team\""),
    makeTask("video", "Zählt gemeinsam bis 3 und ruft euren Teamnamen"),
    makeTask("nennen", "Nennt 3 Sportarten, die ihr gerne mögt"),
    makeTask("video", "Sagt, was ihr heute Neues gelernt habt"),
    makeTask("video", "Ruft gemeinsam laut: „Fairplay ist cool!\""),
    makeTask("nennen", "Nennt 3 Dinge, die uns Menschen verbinden"),
    makeTask("video", "„Alle dürfen mitspielen, egal…\" – vervollständigt den Satz"),
    makeTask("foto", "Zeigt in einem Foto, dass alle gleich wichtig sind"),
    makeTask("video", "Sagt gemeinsam: „Verschieden sein ist stark!\""),
    makeTask("nennen", "Nennt etwas Cooles von Freund:innen aus anderen Ländern"),
    makeTask("foto", "Zeigt eine Geste, die „Frieden\" bedeutet"),
    makeTask("video", "„Streit lösen wir, indem wir…\" – vervollständigt den Satz"),
    makeNennMC("Nennt 3 Wege, einen Streit ohne Schreien zu lösen", [], [
      { text: "In Ruhe nacheinander erzählen, was passiert ist", correct: true },
      { text: "Tief durchatmen und kurz Abstand nehmen", correct: true },
      { text: "Eine erwachsene Person / den Coach dazuholen", correct: true },
      { text: "Lauter werden, damit man gehört wird", correct: false },
      { text: "Die Situation einfach ignorieren, bis es explodiert", correct: false },
    ]),
    makeTask("foto", "Bildet gemeinsam ein Friedenszeichen mit euren Händen"),
    makeTask("video", "Sagt einem anderen Team: „Schön, dass ihr dabei seid!\""),
    makeTask("nennen", "Einigt euch auf ein Wort für „Zusammenhalt\""),
    makeTask("video", "Feiert gemeinsam ein Tor oder eine starke Aktion einer Mitspielerin", ["maedchen"]),
    makeTask("nennen", "Sagt einer Mitspielerin, was sie heute richtig stark gemacht hat – tippt danach ihren Namen ein", ["maedchen"]),
    makeTask("nennen", "Sorgt dafür, dass jede:r im Team mal aufs Feld kommt – tippt kurz ein, wie ihr das eingeteilt habt", ["maedchen"]),
    makeTask("foto", "Ein Jubel-Foto für das Tor oder die Aktion einer Mitspielerin", ["maedchen"]),
    makeTask("nennen", "Wer war noch nicht am Feld? Schickt sie/ihn als Nächste:n rauf und feuert an – tippt den Namen ein", ["maedchen"]),
    makeTask("video", "Feuert besonders die an, die noch kein Tor gemacht haben", ["maedchen"]),
    makeTask("video", "Jubelt für das Tor einer Mitspielerin so laut wie für euer eigenes", ["maedchen"]),
    makeTask("nennen", "Überlegt gemeinsam: Wie sorgen wir dafür, dass jede:r drankommt?", ["maedchen"]),
    makeTask("foto", "Ein Foto, das zeigt, wie ihr euch gegenseitig unterstützt", ["maedchen"]),
    makeTask("video", "Steht als Team am Rand und feuert die/den an, die/der gerade spielt", ["maedchen"]),
    makeNennMC("Was macht ihr, wenn jemand ausgeschlossen wird?", ["mobbing"], [
      { text: "Die Person einladen mitzumachen", correct: true },
      { text: "Einer erwachsenen Person / dem Coach Bescheid sagen", correct: true },
      { text: "Sich mit der Person solidarisch zeigen", correct: true },
      { text: "Wegschauen, das geht uns nichts an", correct: false },
      { text: "Mitmachen, damit man selbst nicht ausgeschlossen wird", correct: false },
    ]),
    makeTask("video", "„Bei uns wird niemand ausgelacht, weil…\"", ["mobbing"]),
    makeTask("foto", "Ein Foto: alle gehören dazu, niemand steht allein", ["mobbing"]),
    makeNennMC("Nennt 3 Dinge, die man tun kann, wenn man Mobbing sieht", ["mobbing"], [
      { text: "Der betroffenen Person zeigen, dass sie nicht allein ist", correct: true },
      { text: "Eine erwachsene Person informieren", correct: true },
      { text: "Klar sagen: „Das ist nicht ok\"", correct: true },
      { text: "Zuschauen und nichts sagen", correct: false },
      { text: "Mitlachen, um dazuzugehören", correct: false },
    ]),
    makeTask("video", "Holt jemanden dazu, der/die gerade allein steht", ["mobbing"]),
    makeTask("nennen", "Nennt etwas Cooles aus einem anderen Land", ["rassismus"]),
    makeTask("video", "„Egal welche Hautfarbe – wir sind ein Team, weil…\"", ["rassismus"]),
    makeTask("nennen", "Sagt „Hallo\" oder „Danke\" in 3 verschiedenen Sprachen", ["rassismus"]),
    makeTask("foto", "Ein Foto, das zeigt: verschieden sein ist stark", ["rassismus"]),
    makeTask("nennen", "Was verbindet uns alle, egal woher wir kommen?", ["rassismus"]),
    makeTask("nennen", "Nennt etwas, das man an Festen mag (Essen, Musik, Zusammensein)", ["religion"]),
    makeTask("video", "„Jede:r darf glauben, was er/sie will – das ist okay, weil…\"", ["religion"]),
    makeTask("nennen", "Was haben Feste aus verschiedenen Kulturen gemeinsam?", ["religion"]),
    makeTask("foto", "Ein Foto, das gegenseitigen Respekt zeigt", ["religion"]),
    makeTask("video", "Sagt: „Bei uns ist jede:r willkommen, egal woran er/sie glaubt\"", ["religion"]),
    makeTask("nennen", "Nennt 3 Dinge, die alle Familien gemeinsam haben", ["lgbt"]),
    makeTask("video", "„Jede:r darf so sein, wie er/sie ist – bei uns heißt das…\"", ["lgbt"]),
    makeTask("nennen", "Was heißt es, jemanden so zu mögen, wie er/sie ist?", ["lgbt"]),
    makeTask("foto", "Ein Foto: „Bei uns gehören alle dazu\"", ["lgbt"]),
    makeTask("video", "Sagt gemeinsam: „Anders sein ist völlig okay!\"", ["lgbt"]),
    makeNennMC("Nennt 3 Wege, einen Streit ohne Gewalt zu lösen", ["frieden"], [
      { text: "Miteinander reden statt schubsen oder schlagen", correct: true },
      { text: "Eine dritte Person um Hilfe bitten", correct: true },
      { text: "Gemeinsam eine Lösung suchen, mit der beide leben können", correct: true },
      { text: "Zurückschlagen, damit man nicht „schwach\" wirkt", correct: false },
      { text: "Drohen, um recht zu bekommen", correct: false },
    ]),
    makeTask("video", "„Hass hat bei uns keinen Platz, weil…\"", ["frieden"]),
    makeTask("foto", "Bildet gemeinsam ein Friedenszeichen", ["frieden"]),
    makeNennMC("Was tut ihr, wenn jemand versucht, andere aufzuhetzen?", ["frieden"], [
      { text: "Nicht mitmachen und klar Stopp sagen", correct: true },
      { text: "Der betroffenen Person beistehen", correct: true },
      { text: "Eine erwachsene Person holen", correct: true },
      { text: "Mitmachen, damit man dazugehört", correct: false },
      { text: "Sich raushalten und wegsehen", correct: false },
    ]),
  ];
}

function seed() {
  const tournament = makeTournament();

  const t1 = makeTeam("Blitz-Kicker", []);
  t1.coach = "Herr Meier";
  t1.players = [makePlayer("Mia", true, 12), makePlayer("Ali", false, 8), makePlayer("Jon", false, 5), makePlayer("Nele", false, 4), makePlayer("Kaan", false, 3), makePlayer("Lina", false, 2), makePlayer("Ben", false, 2)];
  t1.tore = 30; t1.teamspielTore = 6; t1.aufgabenDone = 5;
  // Fairplay-Demo: siehe fpFrom-Bloecke weiter unten (Peer-Bewertung, nicht mehr Headcoach-Eingabe)

  const t2 = makeTeam("Die Füchse", [t1]);
  t2.coach = "Frau Kaya";
  t2.players = [makePlayer("Lea", true), makePlayer("Tom"), makePlayer("Amir"), makePlayer("Sofia"), makePlayer("Finn"), makePlayer("Paula")];
  t2.tore = 45; t2.teamspielTore = 5; t2.aufgabenDone = 3;
  // Fairplay-Demo: siehe fpFrom-Bloecke weiter unten

  const t3 = makeTeam("Torpedos", [t1, t2]);
  t3.coach = "Herr Meier";
  t3.players = [makePlayer("Sam"), makePlayer("Noa", true), makePlayer("Emre"), makePlayer("Klara"), makePlayer("Yusuf"), makePlayer("Ida")];
  t3.tore = 22; t3.teamspielTore = 4; t3.aufgabenDone = 6;
  // Fairplay-Demo: siehe fpFrom-Bloecke weiter unten

  const t4 = makeTeam("Wirbelwind", [t1, t2, t3]);
  t4.players = [makePlayer("Rosa", true), makePlayer("Max"), makePlayer("Deniz"), makePlayer("Toni")];
  t4.tore = 30; t4.teamspielTore = 4; t4.aufgabenDone = 4;
  // Fairplay-Demo: siehe fpFrom-Bloecke weiter unten

  const teams = [t1, t2, t3, t4];

  // Fairplay-Demo als Peer-Bewertung: jedes Team hat von ALLEN anderen Teams
  // dieselbe Bewertung bekommen (fpFrom), der Durchschnitt (fpRecompute)
  // ergibt dieselben Werte wie frueher die einmalige Headcoach-Eingabe.
  const fpSeed = {
    [t1.id]: { detail: { held: 5, einbinden: 4, cool: 3, feuer: 3, fair: 3, frieden: 2, vibes: 2 }, fairest: "Mia" },
    [t2.id]: { detail: { held: 3, einbinden: 2, cool: 2, feuer: 2, fair: 2, frieden: 2, vibes: 2 }, fairest: "Lea" },
    [t3.id]: { detail: { held: 5, einbinden: 5, cool: 4, feuer: 4, fair: 4, frieden: 3, vibes: 3 }, fairest: "Noa" },
    [t4.id]: { detail: { held: 3, einbinden: 3, cool: 3, feuer: 3, fair: 3, frieden: 2, vibes: 2 }, fairest: "" },
  };
  teams.forEach((ratee) => {
    const seed = fpSeed[ratee.id];
    let fairestAssigned = false;
    teams.forEach((rater) => {
      if (rater.id === ratee.id) return;
      const fairest = !fairestAssigned && seed.fairest ? seed.fairest : "";
      if (fairest) fairestAssigned = true;
      ratee.fpFrom[rater.id] = { detail: { ...seed.detail }, fairest };
    });
    const rec = fpRecompute(ratee, teams);
    ratee.fpDetail = rec.detail;
    ratee.fpStars = rec.stars;
  });

  const roles = {
    coaches: ["Herr Meier", "Frau Kaya"],
    coachMode: "captain",   // captain | boxcoaches (im 4-pro-Box-Modus pfeifen die Coaches)
    minSquad: 6,            // maxSquad = min + 4
  };

  // Aufgaben-Pool (volle Sammlung – rein positiv, kindgerecht; Schwerpunkte via themes)
  const taskPool = defaultTaskPool();

  // Tour (Einzel-KO / Bädertour)
  const tour = makeTour("Bädertour");
  tour.zeitraum = "Juli 2026";
  const k1 = { id: uid(), name: "Janni" };
  const k2 = { id: uid(), name: "Elif" };
  const k3 = { id: uid(), name: "Ben" };
  const k4 = { id: uid(), name: "Marie" };
  tour.kids = [k1, k2, k3, k4];
  tour.events = [
    { id: uid(), datum: "06.07.", ort: "Freibad Ost", results: [
      { kidId: k1.id, placement: 1 }, { kidId: k2.id, placement: 2 }, { kidId: k3.id, placement: 3 }, { kidId: k4.id, placement: 4 } ] },
    { id: uid(), datum: "13.07.", ort: "Naturbad West", results: [
      { kidId: k2.id, placement: 1 }, { kidId: k1.id, placement: 2 }, { kidId: k4.id, placement: 3 } ] },
  ];

  // Sonderpreise (Siegerehrung) — sinnvoll aus den Seed-Daten vorbelegt, jederzeit
  // anpassbar. Torpedos hat die meisten Fairplay-Sterne (28) & Aufgaben (6),
  // Die Füchse die meisten Einzel-Tore (45).
  const awards = [
    makeAward("🤝", "Fairness-Preis", t3.id),
    makeAward("⚽", "Meiste Tore", t2.id),
    makeAward("🎯", "Aufgaben-Profis", t3.id),
  ];

  // Sonderpreise (Siegerehrung-Tour) — eigene, parallele Wahrheit (state.tourAwards),
  // weil sie auf Kids statt Teams verweisen. Janni & Elif waren an beiden Stationen
  // dabei (treueste Teilnahme), Marie/Ben sinnvoll für die übrigen Beispielpreise.
  const tourAwards = [
    makeTourAward("📅", "Treuste:r Teilnehmer:in", k1.id),
    makeTourAward("🤝", "Fairness-Preis", k4.id),
    makeTourAward("✨", "Good-Vibes-Preis", k3.id),
  ];

  // Live-Steuerung (Headcoach): Rundenplan aus der config abgeleitet, dazu die
  // laufende Runde/Uhr. EINE Wahrheit — Website/Showroom lesen daraus später die
  // aktuelle Runde, Phase, Restzeit und ob gerade gespielt wird.
  const liveRounds = buildLiveRounds(tournament.config);
  const live = {
    rounds: liveRounds,
    cur: 0,                                              // Index der aktuellen Runde
    remaining: liveRounds[0] ? liveRounds[0].dur : 0,    // Restsekunden der aktuellen Runde
    running: false,                                      // läuft die Spieluhr gerade?
  };

  return {
    tournament,
    teams,
    roles,
    factors: { ...DEFAULT_FACTORS },
    fairplayCriteria: FAIRPLAY_CRITERIA,
    focusThemes: [],        // aktive Schwerpunkte (Chips), Organisationsebene
    taskPool,
    tour,
    awards,                 // Sonderpreise der Siegerehrung (Turnier-Wahrheit)
    tourAwards,             // Sonderpreise der Siegerehrung-Tour (verweisen auf Kids statt Teams)
    live,                   // Headcoach-Live: Rundenplan + Spieluhr (Turnier-Wahrheit)
    ko: { participants: [], bracket: null, savedEventId: null },  // Einzel-KO: Teilnehmer:innen + Baum (Turnier-Wahrheit)
    archivedTournaments: [], // abgeschlossene Turniere (Endstand-Schnappschuss), siehe snapshotTournament()
    invitations: [],        // Einladungen fuer Team-Selbstanlage (Stand 30) -- { id, token, label, phone, teamId, createdAt }
    trikots: {},            // Stand 35: Leihtrikots je Spieler:in (Champions Birthday)
    aufgabenZiehung: [],    // aktuell gezogene Aufgaben-IDs fuers Turnier (Stand 31) -- EINE Wahrheit statt lokalem useState, sonst sieht jedes Geraet seine eigene Ziehung
    role: null,             // aktive Rolle (Schritt 4) – null = Login-Screen
    view: "uebersicht",     // aktiver Baustein (Schritt 3)
    boundTeamId: null,     // bei Teamzugang: an welches Team gebunden
    boundDeviceId: null,   // welcher der 2 Slots (Handy 1/2)
  };
}

// Komplett leerer Zustand für "Neues Turnier anlegen": keine Teams, keine
// Demo-/Beispieldaten, kein Tour-Verlauf, kein Live-Rundenstand — ein
// unbeschriebenes Blatt. Aufgaben-Pool (Inhalts-Bibliothek, keine
// Teilnehmer-Daten) bleibt über defaultTaskPool() erhalten, genau wie in
// seed(). Reine Struktur-Defaults (Faktoren, Fairplay-Kriterien) auch.
function blankState() {
  const tournament = makeTournament();
  const liveRounds = buildLiveRounds(tournament.config);
  return {
    tournament,
    teams: [],
    roles: { coaches: [], coachMode: "captain", minSquad: 6 },
    factors: { ...DEFAULT_FACTORS },
    fairplayCriteria: FAIRPLAY_CRITERIA,
    focusThemes: [],
    taskPool: defaultTaskPool(),
    tour: makeTour(""),
    awards: [],
    tourAwards: [],
    live: {
      rounds: liveRounds,
      cur: 0,
      remaining: liveRounds[0] ? liveRounds[0].dur : 0,
      running: false,
    },
    ko: { participants: [], bracket: null, savedEventId: null },
    archivedTournaments: [],
    invitations: [],
    aufgabenZiehung: [],
    trikots: {},
    role: null,
    view: "uebersicht",
    boundTeamId: null,
    boundDeviceId: null,
  };
}

// Schnappschuss des AKTUELLEN Turniers fürs Archiv — genommen im Moment von
// "Neues Turnier anlegen" (nicht bei jedem Auf/Zu-Klick von "Turnier
// abschließen", das wäre sonst bei jedem Hin-und-her-Toggle ein neuer
// Archiv-Eintrag). Enthält bereits fertig berechnete Werte (ranked/fairRanked),
// damit die Archiv-Ansicht später unabhängig von Faktoren/Kriterien ist, die
// sich für das NÄCHSTE Turnier ja wieder ändern können.
function snapshotTournament(state) {
  const ranked = state.teams
    .map((t) => {
      const sc = teamScore(t, state.factors);
      return { id: t.id, name: t.name, emoji: t.emoji, color: t.color, base: sc.base, bF: sc.fp, bA: sc.auf, total: sc.total };
    })
    .sort((a, b) => b.total - a.total);
  const fairRanked = state.teams
    .map((t) => ({ id: t.id, name: t.name, emoji: t.emoji, fp: t.fpStars }))
    .sort((a, b) => b.fp - a.fp);
  const awards = state.awards.map((a) => {
    const t = state.teams.find((tt) => tt.id === a.teamId);
    return { id: a.id, emoji: a.emoji, title: a.title, teamName: t ? t.name : "—" };
  });
  return {
    id: uid(),
    meta: { ...state.tournament.meta },
    archivedAt: Date.now(),
    ranked,
    fairRanked,
    awards,
  };
}


/* =====================================================================
   3) STORE — gemeinsamer Speicher (Naht zu Schritt 3)
   Ein Context/Reducer als "eine Wahrheit" im Browser. Views lesen/
   schreiben später hierüber, statt eigene Demo-Daten zu halten.
   ===================================================================== */

const StoreContext = createContext(null);

// Teamzugang belegt genau den gewählten Funktions-Slot (Zähl/Medien). Ist der belegt → kein Beitritt.
// Stand 37d: jedes Geraet hat eine eigene, dauerhafte Kennung -- ein Handy-Platz
// merkt sich, WELCHES Handy ihn belegt (holder). Freigeben/Abmelden trifft nur dieses.
let _geraetIdMem = null;
function geraetId() {
  if (_geraetIdMem) return _geraetIdMem;
  const neu = () => `g${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
  try { _geraetIdMem = window.localStorage.getItem("microsoccer_geraet_v1") || neu(); window.localStorage.setItem("microsoccer_geraet_v1", _geraetIdMem); }
  catch (_) { _geraetIdMem = neu(); }
  return _geraetIdMem;
}
function assignSlot(state, teamId, kind, holder = null) {
  let boundDeviceId = null;
  const teams = state.teams.map((t) => {
    if (t.id !== teamId) return t;
    const slot = t.devices.find((d) => d.kind === kind && !d.connected);
    if (!slot) return t;                 // dieser Slot (Zähl/Medien) ist belegt
    boundDeviceId = slot.id;
    return { ...t, devices: t.devices.map((d) => (d.id === slot.id ? { ...d, connected: true, holder } : d)) };
  });
  return { teams, boundDeviceId };
}
function releaseSlot(state, holder = null) {
  if (!state.boundDeviceId) return state.teams;
  return state.teams.map((t) =>
    t.id === state.boundTeamId
      ? { ...t, devices: t.devices.map((d) => (d.id === state.boundDeviceId && (!d.holder || !holder || d.holder === holder) ? { ...d, connected: false, holder: null } : d)) }
      : t
  );
}

// Team-Verwaltung ist die Quelle der Team-Zahl → config.numTeams gespiegelt halten,
// damit Zeitplaner/Fundament/Slot-Stats dieselbe Wahrheit lesen.
function syncNumTeams(state) {
  if (state.tournament.config.numTeams === state.teams.length) return state;
  return syncLivePlan({ ...state, tournament: { ...state.tournament, config: { ...state.tournament.config, numTeams: state.teams.length } } });
}
// Stand 37: Zeitplaner und Team-Zahl wirken SOFORT auf den Live-Rundenplan
// (vorher nur ueber "Plan neu erzeugen" in Headcoach-Live -> Spiel lief mit 3:00).
// Vor dem Anpfiff: Plan komplett neu. Danach: gespielte/gestrichene Runden und
// die laufende Runde bleiben, alle noch offenen Runden kommen aus dem neuen Plan.
const ZEITPLAN_KEYS = ["gameDur", "targetRR", "numTeams", "mode", "openEnd", "context", "customMin", "ue", "checkin", "warmup", "ceremony", "uePause", "wechsel", "sommer"];
function syncLivePlan(state) {
  const live = state.live || {};
  const old = Array.isArray(live.rounds) ? live.rounds : [];
  const plan = buildLiveRounds(state.tournament.config);
  if (!tournamentStarted(state)) {
    return { ...state, live: { ...live, rounds: plan, cur: 0, remaining: plan[0] ? plan[0].dur : 0, running: false } };
  }
  const cur = live.cur || 0;
  const unberuehrt = (o) => !live.running && live.remaining === o.dur; // aktuelle Runde noch nicht angepfiffen
  const rounds = plan.map((r, i) => {
    const o = old[i];
    if (!o) return r;
    if (o.done || o.skipped) return o;
    if (i === cur && !unberuehrt(o)) return o;
    return { ...o, dur: r.dur, phase: r.phase, n: r.n };
  });
  for (let i = plan.length; i < old.length; i++) if (old[i].done || old[i].skipped || i === cur) rounds.push(old[i]);
  const curR = rounds[cur];
  const remaining = curR && old[cur] && unberuehrt(old[cur]) ? curR.dur : live.remaining;
  return { ...state, live: { ...live, rounds, remaining } };
}
function livePlanVeraltet(state) {
  if (tournamentStarted(state)) return false;
  const plan = buildLiveRounds(state.tournament.config);
  const r = (state.live && state.live.rounds) || [];
  // Stand 37d: nur die Struktur (Rundenzahl) -- manuell geaenderte Zeiten bleiben stehen
  return plan.length !== r.length;
}

/* ---------- Stand 40: Feierabend — Auto-Check-out spätestens 15 Min nach Eventende ----------
   EINE Regel für Geräte und Server (Stunden, Playmaker-Summen):
   Eventende E = Abschluss-Zeitpunkt (Headcoach „Turnier abschließen") — sonst das geplante Ende (Datum + Endzeit,
   oder Start + Ablauf/Katalog-Dauer, in Wiener Zeit). Ohne Verlängerung endet ein offener Einsatz automatisch bei
   E + 15 Min. „Ich arbeite noch" (Abbau/Nachbereitung/…) verlängert bis zur gewählten Uhrzeit — sofort, ohne Warten.
   Freigabe danach: Coaches durch den Headcoach, der Headcoach durchs Büro (Stundenbestätigung). Abgelehnt = zählt
   nur bis E + 15. Ohne bekanntes Ende: Sicherheitsnetz 12 h nach Check-in. */
export const FEIERABEND_MIN = 15;
export const FRAGE_AB_MIN = 5;
function wienVersatz(ms) {
  try {
    const f = new Intl.DateTimeFormat("en-US", { timeZone: "Europe/Vienna", hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" });
    const t = {}; for (const x of f.formatToParts(new Date(ms))) t[x.type] = x.value;
    return Date.UTC(+t.year, +t.month - 1, +t.day, +t.hour % 24, +t.minute, +t.second) - Math.floor(ms / 1000) * 1000;
  } catch (_) { return -new Date(ms).getTimezoneOffset() * 60000; }
}
export function wienMs(datum, hhmm) {
  const d = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(datum || "")); const z = /^(\d{1,2}):(\d{2})$/.exec(String(hhmm || ""));
  if (!d || !z) return null;
  const roh = Date.UTC(+d[1], +d[2] - 1, +d[3], +z[1], +z[2]);
  const v1 = wienVersatz(roh - wienVersatz(roh));
  return roh - v1;
}
const hm2min = (s) => { const m = /^(\d{1,2}):(\d{2})$/.exec(String(s || "")); return m ? +m[1] * 60 + +m[2] : null; };
export function geplantesEnde(state) {
  const t = (state && state.tournament) || {}, m = t.meta || {};
  const start = hm2min(m.startzeit), ende = hm2min(m.endzeit);
  let endMin = null;
  if (ende != null && (start == null || ende > start)) endMin = ende;
  else if (start != null) {
    const ab = Array.isArray(t.ablauf) ? t.ablauf.reduce((s, x) => s + (Number(x && x.min) || 0), 0) : 0;
    const kd = m.katalog && Number(m.katalog.dauerMin) > 0 ? Number(m.katalog.dauerMin) : 0;
    if (ab > 0) endMin = start + ab; else if (kd > 0) endMin = start + kd;
  }
  if (endMin == null || !m.date) return null;
  const h = Math.floor(endMin / 60), mi = endMin % 60;
  return h < 24 ? wienMs(m.date, `${h}:${String(mi).padStart(2, "0")}`) : wienMs(m.date, "23:59");
}
export function eventEndeMs(state) {
  const t = (state && state.tournament) || {};
  if (t.status === "abgeschlossen" && Number(t.abgeschlossenAm) > 0) return Number(t.abgeschlossenAm);
  return geplantesEnde(state);
}
// Eventende für DIESEN Einsatz: wer erst nach Ende + 15 eingecheckt hat (Probelauf, falsches Datum,
// wieder geöffnet), bekommt das Sicherheitsnetz statt eines sofortigen Check-outs.
export function endeFuer(state, e) {
  const E = eventEndeMs(state);
  return E && e && Number(e.von) > 0 && E + FEIERABEND_MIN * 60000 <= Number(e.von) ? null : E;
}
// Wann endet ein noch offener Einsatz automatisch? (null = schon ausgecheckt)
export function einsatzAutoBis(state, e) {
  if (!e || e.bis) return null;
  const E = endeFuer(state, e);
  if (e.verl && e.verl.status !== "nein" && Number(e.verl.bis) > 0) return Math.max(Number(e.verl.bis), E ? E + FEIERABEND_MIN * 60000 : 0);
  if (E) return Math.max(E + FEIERABEND_MIN * 60000, Number(e.von) || 0);
  return (Number(e.von) || 0) + 12 * 3600000;
}
// Effektive Zeiten eines Einsatzes zum Zeitpunkt jetzt (für Stunden/Summen) — ändert den Stand nicht.
export function einsatzEffektiv(state, e, jetzt = Date.now()) {
  if (!e || !e.von) return { bis: null, auto: false, gekappt: false };
  const E = endeFuer(state, e);
  let bis = e.bis || null, auto = !!e.auto, gekappt = false;
  if (!bis) { const a = einsatzAutoBis(state, e); if (a && jetzt >= a) { bis = a; auto = true; } }
  if (bis && e.verl && e.verl.status === "nein" && E) { const cap = Math.max(Number(e.von), E + FEIERABEND_MIN * 60000); if (bis > cap) { bis = cap; gekappt = true; } }
  return { bis, auto, gekappt };
}
// Server: nur diese Aktionen dürfen über /einsatz am (auch abgeschlossenen) Stand etwas ändern
export function einsatzAnwenden(state, action) {
  if (!action || !["einsatz/checkout", "einsatz/verlaengern", "einsatz/verlFreigabe"].includes(action.type)) return state;
  const neu = reducer(state, action);
  return { ...state, einsaetze: neu.einsaetze };
}
const VERL_GRUENDE = [["abbau", "🧹 Abbau"], ["nachbereitung", "📝 Nachbereitung"], ["laeuft", "⚽ Turnier läuft noch"], ["sonstiges", "… Sonstiges"]];

function reducer(state, action) {
  const vorher = _aufz; _aufz = { action, i: 0 };
  try { return reducerInner(state, action); } finally { _aufz = vorher; }
}
function reducerInner(state, action) {
  switch (action.type) {
    // Stufe 1 (Persistenz): kompletter Ersatz durch den vom Server geladenen
    // State beim Start. Keine zweite Wahrheit — der Server liefert exakt das,
    // was zuletzt gespeichert wurde.
    case "hydrate/replace": {
      // Sicherheitsnetz: alter, vor Stand 27 gespeicherter State kennt
      // "archivedTournaments" noch nicht -> ohne Default crasht die App
      // beim ersten Rendern (state.archivedTournaments.length ist dann
      // undefined). Fehlende Felder bekommen hier einen sinnvollen Default,
      // vorhandene Felder aus dem geladenen State haben Vorrang.
      //
      // Audit-Fix (Stand 31, Nachtrag 2) -- Rollen-Isolation: "role",
      // "boundTeamId", "boundDeviceId" und "view" sind WER-BIN-ICH auf
      // DIESEM Geraet, keine Turnierdaten -- die duerfen NIE aus einem
      // fremden gespeicherten Stand uebernommen werden. Vorher wurden sie
      // hier ungeprueft mit ...action.state ueberschrieben: ein frisch
      // geoeffneter Tab (Team-Handy, oeffentlicher Zuschauer-Link, ...) UND
      // jeder spaetere Poll-Tick einer schon offenen Sitzung haetten dann
      // die Rolle irgendeines ANDEREN Geraets geerbt -- z. B. landet ein
      // Team-Handy beim ersten Oeffnen direkt in der vollen Admin-Oberflaeche
      // statt am Login-Screen, einfach weil zuletzt irgendwo ein Headcoach-
      // iPad gespeichert hat. Fix: diese 4 Felder kommen immer aus dem
      // LOKALEN state (bei einem frischen Tab ist das role:null aus seed(),
      // bei einer schon eingeloggten Sitzung die eigene, echte Rolle) --
      // niemals aus dem geladenen/gepollten action.state.
      return { archivedTournaments: [], invitations: [], aufgabenZiehung: [], trikots: {}, einsaetze: [], ...action.state,
        role: state.role, boundTeamId: state.boundTeamId, boundDeviceId: state.boundDeviceId, view: state.view, meinEinsatzId: state.meinEinsatzId || null };
    }
    // Stand 36c: Ergebnis einer Zusammenfuehrung (fremder Stand + eigene Aktionen)
    case "sync/setAll":
      return action.state;
    case "setFactor":
      return { ...state, factors: { ...state.factors, [action.key]: action.value } };
    case "setConfig": {
      const next = { ...state, tournament: { ...state.tournament, config: { ...state.tournament.config, [action.key]: action.value } } };
      return ZEITPLAN_KEYS.includes(action.key) ? syncLivePlan(next) : next;
    }
    case "live/syncPlan": // Stand 37: Alt-Staende -- Plan an den Zeitplaner angleichen (nur vor dem Anpfiff)
      return livePlanVeraltet(state) ? syncLivePlan(state) : state;
    case "toggleTheme": {
      const on = state.focusThemes.includes(action.key);
      return { ...state, focusThemes: on ? state.focusThemes.filter((k) => k !== action.key) : [...state.focusThemes, action.key] };
    }
    case "setRole": {
      if (action.role === "teamaccess" && action.teamId != null) {
        const { teams, boundDeviceId } = assignSlot(state, action.teamId, action.deviceKind, action.holder || null);
        if (!boundDeviceId) return state;   // Team voll → Beitritt abgelehnt
        return { ...state, role: "teamaccess", teams, boundTeamId: action.teamId, boundDeviceId, view: "uebersicht" };
      }
      const defaultView = action.role === "coach" && tournamentStarted(state) ? "live-zaehler" : "uebersicht";
      // Coach wird jetzt beim Login an EIN Team gebunden (welches Team, siehe
      // Login()-Coach-Auswahl: "welcher Coach bist du" -> Team, dessen
      // team.coach diesem Namen entspricht). Bewusst dasselbe Feld
      // boundTeamId wie bei teamaccess -- nur fuer Team-Verwaltung ausgewertet
      // (siehe TeamVerwaltung()); Live-Zähler/Wertung/Fairplay/Aufgaben bleiben
      // fuer Coach unveraendert ueber alle Teams hinweg sichtbar (Box-Schiri-
      // Rolle betreut am Feld typischerweise mehrere Teams gleichzeitig).
      return { ...state, role: action.role, boundTeamId: action.role === "coach" ? (action.teamId ?? null) : null, boundDeviceId: null, view: defaultView };
    }
    case "setStatus": {
      // Stand 40: Abschluss checkt NICHT mehr sofort aus -- er setzt das Eventende (abgeschlossenAm).
      // Wer nicht „Ich arbeite noch" sagt, wird 15 Min danach automatisch ausgecheckt (einsatzAutoBis).
      const at = action.at || rnow();
      const zu = action.value === "abgeschlossen";
      return { ...state, tournament: { ...state.tournament, status: action.value, ...(zu ? { abgeschlossenAm: at } : {}) } };
    }
    case "wertung/enthuellen": // Stand 36: Spannungsbogen -- Gesamtwertung fuer alle sichtbar
      return { ...state, tournament: { ...state.tournament, wertungOffen: action.value !== false, enthStufe: action.value !== false ? enthMax(state) : 0 } };
    case "wertung/stufe": { // Stand 36d: Enthuellung in 4 Stufen vor/zurueck
      const max = enthMax(state);
      const st = Math.min(max, Math.max(0, (Number(state.tournament.enthStufe) || 0) + (Number(action.delta) || 0)));
      return { ...state, tournament: { ...state.tournament, enthStufe: st, wertungOffen: st >= max } };
    }
    case "wertung/neu": // Stand 37: Aufdecken nochmal von vorne (nur vor dem Abschluss)
      if (state.tournament.status === "abgeschlossen") return state;
      return { ...state, tournament: { ...state.tournament, enthStufe: 0, wertungOffen: false } };
    case "wertung/aufdecken": { // Stand 36c (ersetzt durch wertung/stufe, bleibt fuer Alt-Staende)
      const n = state.teams.length;
      const k = Math.min(n, (Number(state.tournament.enthuellt) || 0) + 1);
      return { ...state, tournament: { ...state.tournament, enthuellt: k, wertungOffen: k >= n } };
    }
    case "wertung/zudecken": { // Stand 36c: Versehen -- einen Platz wieder verdecken
      const k = Math.max(0, (Number(state.tournament.enthuellt) || 0) - 1);
      return { ...state, tournament: { ...state.tournament, enthuellt: k, wertungOffen: false } };
    }
    // Turnier-Meta (Titel/Datum/Ort) — EINE Wahrheit, von Website/Showroom/Ehrung gelesen.
    // Stand 35 -- Champions Birthday: Minuten einer Phase (Startzeit ueber meta/patch).
    case "ablauf/aktiv": // Stand 37: Headcoach schaltet die Ablauf-Phase weiter (null = Uhrzeit entscheidet)
      return { ...state, tournament: { ...state.tournament, ablaufAktiv: action.id || null } };
    case "ablauf/setMin":
      return { ...state, tournament: { ...state.tournament, ablauf: (state.tournament.ablauf || []).map((ph) => ph.id === action.id ? { ...ph, min: Math.max(0, Math.min(600, Number(action.min) || 0)) } : ph) } };
    // Stand 35 -- Leihtrikots: { [playerId]: "aus" | "zurueck" | "geschenkt" }
    case "trikot/set":
      return { ...state, trikots: { ...(state.trikots || {}), [action.playerId]: action.status } };
    case "meta/patch":
      return { ...state, tournament: { ...state.tournament, meta: { ...state.tournament.meta, ...action.patch } } };
    // Tour-Meta (Titel/Zeitraum) — analog zu meta/patch, aber für die Tour statt
    // fürs Team-Turnier. Von Tour-Website/Tour-Rangliste/Siegerehrung-Tour gelesen;
    // die Siegerehrung-Tour ist bisher der einzige Ort, an dem editiert wird.
    case "tour/patchMeta":
      return { ...state, tour: { ...state.tour, ...action.patch } };
    case "logout": {
      // Stand 37: Abmelden = Check-out (Einsatzzeit endet)
      const at = action.at || rnow();
      // einsatzId steckt in der Aktion, damit es auch beim Zusammenfuehren (409) wirkt
      const eid = action.einsatzId || state.meinEinsatzId;
      const einsaetze = (state.einsaetze || []).map((e) => (e.id === eid && !e.bis ? { ...e, bis: Math.max(at, e.von || 0), ...(action.auto ? { auto: true } : {}) } : e));
      return { ...state, einsaetze, teams: releaseSlot(state, action.holder || null), role: null, boundTeamId: null, boundDeviceId: null, meinEinsatzId: null };
    }
    case "einsatz/lokalNeu":
      return { ...state, meinEinsatzId: null };
    // Stand 40: Feierabend -- Check-out ohne Abmelden (auch automatisch), Verlängerung, Freigabe
    case "einsatz/checkout": {
      const at = Number(action.at) || rnow();
      return { ...state, einsaetze: (state.einsaetze || []).map((e) => (e.id === action.einsatzId && !e.bis ? { ...e, bis: Math.max(at, e.von || 0), ...(action.auto ? { auto: true } : {}) } : e)) };
    }
    case "einsatz/verlaengern": {
      const bis = Number(action.bis) || 0;
      return { ...state, einsaetze: (state.einsaetze || []).map((e) => (e.id === action.einsatzId && !e.bis && bis > (e.von || 0)
        ? { ...e, verl: { grund: VERL_GRUENDE.some((g) => g[0] === action.grund) ? action.grund : "sonstiges", text: String(action.text || "").slice(0, 140), bis, am: Number(action.at) || rnow(), status: "offen", n: ((e.verl && e.verl.n) || 0) + 1 } }
        : e)) };
    }
    case "einsatz/verlFreigabe": {
      const st = action.status === "nein" ? "nein" : "ok";
      return { ...state, einsaetze: (state.einsaetze || []).map((e) => (e.id === action.einsatzId && e.verl ? { ...e, verl: { ...e.verl, status: st, durch: action.durch === "buero" ? "buero" : "headcoach", am2: Number(action.at) || rnow() } } : e)) };
    }
    // Stand 37: Check-in passiert mit dem Login als Headcoach/Coach (kein eigener Weg).
    case "einsatz/checkin": {
      const list = state.einsaetze || [];
      if (list.some((e) => e.id === action.id)) return { ...state, meinEinsatzId: action.id };
      // Stand 37u: optionale academyId (z. B. "MS-4821") -- kommt mit dem gemeinsamen Login; heute nie gesetzt
      const aid = typeof action.academyId === "string" && /^MS-\d{3,6}$/.test(action.academyId) ? action.academyId : null;
      const gid = typeof action.academyId === "string" && /^G-[A-Z0-9]{2,10}$/.test(action.academyId) ? action.academyId : null; // Stand 40: Gast-Coach
      return { ...state, meinEinsatzId: action.id, einsaetze: [...list, { id: action.id, rolle: action.rolle, name: action.name || "", teamId: action.teamId || null, ...(aid ? { academyId: aid } : {}), ...(gid ? { personId: gid } : {}), von: action.at, bis: null }] };
    }
    case "setView":
      return { ...state, view: action.view };
    // --- Team-Verwaltung: Teams / Personen / Geräte / Galerie / Rollen ---
    case "team/add": {
      // Stand 35: optionaler Name (z. B. Vereinsname beim Champions Birthday)
      const t = makeTeam((action.name || "").trim() || nextDefaultTeamName(state.teams), state.teams);
      return syncNumTeams({ ...state, teams: [...state.teams, t] });
    }
    case "team/addMany": {
      const add = [];
      for (let i = 0; i < Math.max(1, action.count | 0); i++) {
        const soFar = [...state.teams, ...add];
        add.push(makeTeam(nextDefaultTeamName(soFar), soFar));
      }
      return syncNumTeams({ ...state, teams: [...state.teams, ...add] });
    }
    case "team/remove":
      return syncNumTeams({
        ...state,
        teams: state.teams.filter((t) => t.id !== action.id),
        boundTeamId: state.boundTeamId === action.id ? null : state.boundTeamId,
        boundDeviceId: state.boundTeamId === action.id ? null : state.boundDeviceId,
      });
    case "team/duplicate": {
      const src = state.teams.find((t) => t.id === action.id);
      if (!src) return state;
      const copy = {
        ...src,
        id: uid(),
        name: src.name + " (Kopie)",
        emoji: nextUnusedEmoji(state.teams),
        color: nextUnusedColor(state.teams),
        players: src.players.map((p) => ({ ...p, id: uid() })),
        devices: [makeDevice("zaehl", "Zähl-Handy"), makeDevice("medien", "Medien-Handy")],
        gallery: [],
        tore: 0, teamspielTore: 0, fpDetail: emptyFp(), fpFrom: {}, fpStars: 0, aufgabenDone: 0,   // Wertung startet bei Kopie neu
      };
      return syncNumTeams({ ...state, teams: [...state.teams, copy] });
    }
    case "team/patch": {
      // Stand 39: Logo (emoji) und Farbe gibt es je Turnier nur einmal -- auch wenn zwei Handys gleichzeitig waehlen
      // (die zweite Wahl faellt beim Zusammenfuehren hier weg; der Server lehnt Doppelte zusaetzlich ab).
      const patch = { ...(action.patch || {}) };
      const andere = state.teams.filter((t) => t.id !== action.id);
      if (patch.emoji != null && andere.some((t) => t.emoji === patch.emoji)) delete patch.emoji;
      if (patch.color != null && andere.some((t) => t.color === patch.color)) delete patch.color;
      return { ...state, teams: state.teams.map((t) => (t.id === action.id ? { ...t, ...patch } : t)) };
    }
    // Stand 39: Coach (Academy-Nummer oder Gast) einem Team zuordnen -- ein Coach hat genau ein Team
    case "team/coachSetzen": {
      const pid = action.personId || null, name = String(action.name || "").trim();
      const teams = state.teams.map((t) => {
        if (t.id === action.teamId) return { ...t, coachId: pid, coach: pid ? name : "" };
        if (pid && t.coachId === pid) return { ...t, coachId: null, coach: "" };
        return t;
      });
      const coaches = name && !(state.roles.coaches || []).includes(name) ? [...(state.roles.coaches || []), name] : state.roles.coaches;
      return { ...state, teams, roles: { ...state.roles, coaches } };
    }
    // Stand 39: Probelauf zuruecksetzen -- Spielstaende auf null, vor die erste Runde; Teams, Coaches, Check-in bleiben.
    // "lauf" zaehlt hoch: alte oder noch ausstehende Toreingaben (alte Laufnummer) werden ab jetzt verworfen.
    case "turnier/probelaufZurueck": {
      if (state.tournament.status === "abgeschlossen") return state;
      const rounds = (state.live.rounds || []).map((r) => { const { zaehlung, ...rest } = r; return { ...rest, done: false, skipped: false }; });
      const live = { ...state.live, rounds, cur: 0, running: false, angepfiffen: false, remaining: rounds[0] ? rounds[0].dur : 0, runStartedAt: null, runRemainingAtStart: null, lauf: laufVon(state) + 1 };
      const teams = state.teams.map((t) => ({ ...t, tore: 0, teamspielTore: 0, fpDetail: emptyFp(), fpFrom: {}, fpStars: 0, aufgabenDone: 0, players: t.players.map((p) => ({ ...p, goals: 0 })) }));
      const { wertungOffen, enthStufe, ...tRest } = state.tournament;
      return { ...state, teams, live, awards: [], aufgabenZiehung: [], tournament: { ...tRest, ablaufAktiv: null } };
    }

    // --- Einladungen (Stand 30): Headcoach legt einen Team-Slot + personalisierten
    // Link an, die eingeladene Person fuellt ihn ueber InviteTeamSetup selbst aus
    // (team/patch, player/add/remove, player/toggleCaptain -- dieselben Actions wie
    // in der Team-Verwaltung, keine eigenen invite-spezifischen Team-Actions noetig,
    // weil der Reducer ohnehin keine Rollen-Autorisierung kennt). Ein Link = ein
    // Team-Slot: das Loeschen einer Einladung loescht NICHT das Team selbst --
    // das bleibt der Team-Verwaltung vorbehalten.
    case "invite/create": {
      const label = (action.label || "").trim();
      const phone = (action.phone || "").trim();
      const team = makeTeam(label || nextDefaultTeamName(state.teams), state.teams);
      const inv = { id: uid(), token: makeInviteToken(), label, phone, teamId: team.id, createdAt: rnow() };
      return syncNumTeams({ ...state, teams: [...state.teams, team], invitations: [...state.invitations, inv] });
    }
    case "invite/remove":
      return { ...state, invitations: state.invitations.filter((i) => i.id !== action.id) };
    // Audit-Fix (Stand 31): "Aufgaben ziehen" wirkte bisher nur lokal (siehe
    // Aufgaben()) -- die Ziehung landet jetzt im gemeinsamen State, damit
    // Team-Geraete tatsaechlich sehen, was der Headcoach gezogen hat.
    case "aufgaben/ziehen":
      return { ...state, aufgabenZiehung: action.ids };
    // Einladung fuer ein BEREITS bestehendes Team (z.B. "Team 1" aus "+Team"/
    // "Schnell anlegen" oder ein Seed-Team) -- im Unterschied zu invite/create
    // wird HIER kein neuer Team-Slot angelegt, sondern der uebergebene teamId
    // direkt verlinkt. Schuetzt "ein Link = ein Team-Slot": legt keine zweite
    // Einladung fuer ein Team an, das schon eine hat.
    case "invite/createForTeam": {
      const team = state.teams.find((t) => t.id === action.teamId);
      if (!team) return state;
      if (state.invitations.some((i) => i.teamId === action.teamId)) return state;
      const label = (action.label || team.name || "").trim();
      const phone = (action.phone || "").trim();
      const inv = { id: uid(), token: makeInviteToken(), label, phone, teamId: action.teamId, createdAt: rnow() };
      return { ...state, invitations: [...state.invitations, inv] };
    }

    case "player/add": {
      const name = (action.name || "").trim();
      if (!name) return state;
      return { ...state, teams: state.teams.map((t) => (t.id === action.teamId ? { ...t, players: [...t.players, makePlayer(name, false, 0)] } : t)) };
    }
    case "player/remove":
      return { ...state, teams: state.teams.map((t) => (t.id === action.teamId ? { ...t, players: t.players.filter((p) => p.id !== action.playerId) } : t)) };
    case "player/toggleCaptain":
      return { ...state, teams: state.teams.map((t) => (t.id === action.teamId ? { ...t, players: t.players.map((p) => ({ ...p, captain: p.id === action.playerId ? !p.captain : p.captain })) } : t)) };

    case "device/patch":
      return { ...state, teams: state.teams.map((t) => (t.id === action.teamId ? { ...t, devices: t.devices.map((d) => (d.id === action.deviceId ? { ...d, ...action.patch } : d)) } : t)) };

    case "gallery/add":
      return { ...state, teams: state.teams.map((t) => (t.id === action.teamId ? { ...t, gallery: [...t.gallery, { id: uid(), url: action.url, kind: action.kind, star: false, taskId: null }] } : t)) };
    case "gallery/remove":
      return { ...state, teams: state.teams.map((t) => (t.id === action.teamId ? { ...t, gallery: t.gallery.filter((g) => g.id !== action.itemId) } : t)) };
    case "gallery/patch":
      return { ...state, teams: state.teams.map((t) => (t.id === action.teamId ? { ...t, gallery: t.gallery.map((g) => (g.id === action.itemId ? { ...g, ...action.patch } : g)) } : t)) };

    case "roles/patch":
      return { ...state, roles: { ...state.roles, ...action.patch } };

    // --- Live-Zähler: erzeugt echte Tore (Basis-"Wahrheit") ---
    // Einzelspiel → team.tore · Teamspiel → team.teamspielTore · optional Torschütze → player.goals
    case "goal/add": {
      if (!laufPasst(state, action)) return state; // Stand 39: Tor aus einem zurueckgesetzten Probelauf
      const field = action.phase === "team" ? "teamspielTore" : "tore";
      return { ...state, teams: state.teams.map((t) => {
        if (t.id !== action.teamId) return t;
        const nt = { ...t, [field]: (t[field] || 0) + 1 };
        if (action.playerId != null) nt.players = t.players.map((p) => (p.id === action.playerId ? { ...p, goals: (p.goals || 0) + 1 } : p));
        return nt;
      }) };
    }
    case "goal/undo": {   // macht ein zuvor gezähltes Tor (Team + ggf. Torschütze) rückgängig
      if (!laufPasst(state, action)) return state; // Stand 39: Tor aus einem zurueckgesetzten Probelauf
      const field = action.phase === "team" ? "teamspielTore" : "tore";
      return { ...state, teams: state.teams.map((t) => {
        if (t.id !== action.teamId) return t;
        const nt = { ...t, [field]: Math.max(0, (t[field] || 0) - 1) };
        if (action.playerId != null) nt.players = t.players.map((p) => (p.id === action.playerId ? { ...p, goals: Math.max(0, (p.goals || 0) - 1) } : p));
        return nt;
      }) };
    }
    case "goal/adjust": {  // Headcoach-Korrektur (VAR) auf einen Team-Torstand, ± mit Klammerung
      if (!laufPasst(state, action)) return state; // Stand 39: Tor aus einem zurueckgesetzten Probelauf
      const field = action.field === "teamspielTore" ? "teamspielTore" : "tore";
      return { ...state, teams: state.teams.map((t) => (t.id === action.teamId ? { ...t, [field]: Math.max(0, (t[field] || 0) + action.delta) } : t)) };
    }
    case "player/adjustGoals":  // VAR-Korrektur auf einen Torschützen
      if (!laufPasst(state, action)) return state;
      return { ...state, teams: state.teams.map((t) => (t.id === action.teamId ? { ...t, players: t.players.map((p) => (p.id === action.playerId ? { ...p, goals: Math.max(0, (p.goals || 0) + action.delta) } : p)) } : t)) };

    // --- Fairplay: rein positive Peer-Bewertung (jedes Team bewertet jedes
    // ANDERE Team), je Kriterium 0–5 ★ ---
    // Schreibt in team.fpFrom[raterTeamId]; fpDetail/fpStars des bewerteten
    // Teams werden danach aus ALLEN Bewertungen neu verdichtet (fpRecompute)
    // — abgeleitet, keine zweite Wahrheit. Der Headcoach nutzt dieselbe
    // Action, um im Bedarfsfall fuer ein Team einzuspringen/zu korrigieren
    // (er waehlt dabei selbst, als welches Team er eingibt).
    case "fairplay/set": {
      const { rateeTeamId, raterTeamId } = action;
      if (rateeTeamId == null || raterTeamId == null || rateeTeamId === raterTeamId) return state;
      const teamsNext = state.teams.map((t) => {
        if (t.id !== rateeTeamId) return t;
        const prevFrom = t.fpFrom[raterTeamId] || { detail: emptyFp(), fairest: "" };
        const detail = action.crit != null
          ? { ...prevFrom.detail, [action.crit]: Math.max(0, Math.min(5, action.value | 0)) }
          : prevFrom.detail;
        const fairest = action.fairest !== undefined ? action.fairest : prevFrom.fairest;
        return { ...t, fpFrom: { ...t.fpFrom, [raterTeamId]: { detail, fairest } } };
      });
      const teams = teamsNext.map((t) => {
        const rec = fpRecompute(t, teamsNext);
        return { ...t, fpDetail: rec.detail, fpStars: rec.stars };
      });
      return { ...state, teams };
    }

    // --- Aufgaben: erledigt = +1 auf team.aufgabenDone (Basis-"Wahrheit", die die
    // Gesamtwertung schon liest). Video/Foto legen zusätzlich EIN Galerie-Medium mit
    // taskId an (das Showroom später über gallery.star zieht). Keine zweite Aufgaben-
    // Wahrheit: Punkte = aufgabenDone, Medien = gallery — getrennte, nicht doppelte Größen.
    case "aufgaben/complete": {
      return { ...state, teams: state.teams.map((t) => {
        if (t.id !== action.teamId) return t;
        const nt = { ...t, aufgabenDone: (t.aufgabenDone || 0) + 1 };
        if (action.url) nt.gallery = [...t.gallery, { id: uid(), url: action.url, kind: action.kind, star: false, taskId: action.taskId ?? null }];
        return nt;
      }) };
    }
    // Aufgaben-Pool pflegen (eine Wahrheit: state.taskPool). Schwerpunkte laufen über toggleTheme.
    case "task/add": {
      const text = (action.text || "").trim();
      if (!text) return state;
      return { ...state, taskPool: [...state.taskPool, makeTask(action.taskType || "video", text, action.themes || [])] };
    }
    case "task/remove":
      return { ...state, taskPool: state.taskPool.filter((p) => p.id !== action.id) };

    // --- Siegerehrung: Sonderpreise (frei definierbar, EINE Wahrheit: state.awards) ---
    case "award/add":
      return { ...state, awards: [...state.awards, makeAward(action.emoji || "🏆", action.title || "Sonderpreis", action.teamId ?? (state.teams[0] && state.teams[0].id) ?? null)] };
    case "award/remove":
      return { ...state, awards: state.awards.filter((a) => a.id !== action.id) };
    case "award/patch":
      return { ...state, awards: state.awards.map((a) => (a.id === action.id ? { ...a, ...action.patch } : a)) };

    // --- Siegerehrung-Tour: Sonderpreise für Kids (EINE Wahrheit: state.tourAwards) ---
    // Eigene, parallele Liste zu state.awards — verweist auf Kids statt Teams,
    // sonst identisches Muster (add/remove/patch).
    case "tourAward/add":
      return { ...state, tourAwards: [...state.tourAwards, makeTourAward(action.emoji || "🏆", action.title || "Sonderpreis", action.kidId ?? (state.tour.kids[0] && state.tour.kids[0].id) ?? null)] };
    case "tourAward/remove":
      return { ...state, tourAwards: state.tourAwards.filter((a) => a.id !== action.id) };
    case "tourAward/patch":
      return { ...state, tourAwards: state.tourAwards.map((a) => (a.id === action.id ? { ...a, ...action.patch } : a)) };

    // --- Headcoach-Live: Spieluhr + Runden LIVE steuern (EINE Wahrheit: state.live) ---
    // Der Rundenplan kommt aus buildLiveRounds(config); hier wird er mit der echten
    // Turnier-Wahrheit überlagert (gespielt/gestrichen, live geänderte Dauer, laufende
    // Runde/Uhr). Kein zweiter Rundenplan, keine zweite Uhr.
    case "live/start":         // Anpfiff — nur wenn noch Zeit übrig ist
      // Stand 36: "angepfiffen" merkt sich den ersten Anpfiff -- sonst sprang eine
      // Pause in Runde 1 zurueck in die Vorbereitung (tournamentStarted).
      if (state.live.running || state.live.remaining <= 0) return state;
      return { ...state, live: { ...state.live, running: true, angepfiffen: true, runStartedAt: rnow(), runRemainingAtStart: state.live.remaining } };
    case "live/pause":         // Uhr anhalten (Restzeit aus dem Zeitstempel festhalten)
      if (!state.live.running) return state;
      return { ...state, live: { ...state.live, running: false, remaining: liveRemaining(state.live, rnow()) } };
    case "live/tick": {        // 1 Sekunde herunterzählen (vom laufenden View getaktet)
      // Stand 36: aendert den Stand NUR, wenn die Zeit abgelaufen ist -- sonst
      // gleicher State (kein Speichern, kein Ueberschreiben fremder Tore).
      if (!state.live.running || liveRemaining(state.live, rnow()) > 0) return state;
      return { ...state, live: { ...state.live, remaining: 0, running: false } };
    }
    case "live/resetClock": {  // Uhr der aktuellen Runde auf deren Dauer zurücksetzen
      const r = state.live.rounds[state.live.cur];
      return { ...state, live: { ...state.live, remaining: r ? r.dur : 0, running: false } };
    }
    case "live/adjust": {      // Zeit der laufenden Runde live ± (Rest UND geplante Dauer)
      const rem = Math.max(0, liveRemaining(state.live, rnow()) + action.delta);
      const rounds = state.live.rounds.map((r, i) => (i === state.live.cur ? { ...r, dur: Math.max(30, r.dur + action.delta) } : r));
      const run = state.live.running ? { runStartedAt: rnow(), runRemainingAtStart: rem } : {};
      return { ...state, live: { ...state.live, ...run, remaining: rem, rounds } };
    }
    case "live/setDur":        // Dauer einer (geplanten) Runde in der Übersicht setzen
      return { ...state, live: { ...state.live, rounds: state.live.rounds.map((r) => (r.id === action.id ? { ...r, dur: Math.max(30, action.dur) } : r)) } };
    case "live/whistleEnd": {  // Abpfiff: aktuelle Runde = gespielt → nächste offene laden
      // Stand 37d: idx in der Aktion -- zwei Geraete beenden nicht zwei Runden
      if (action.idx != null && (action.idx !== state.live.cur || (state.live.rounds[action.idx] && state.live.rounds[action.idx].done))) return state;
      const rounds = state.live.rounds.map((r, i) => (i === state.live.cur ? { ...r, done: true } : r));
      const nx = hlNextPlanned(rounds, state.live.cur);
      const cur = nx >= 0 ? nx : state.live.cur;
      const remaining = nx >= 0 ? rounds[nx].dur : liveRemaining(state.live, rnow());
      return { ...state, live: { ...state.live, rounds, cur, remaining, running: false } };
    }
    case "live/skip": {        // Runde streichen → nächste offene laden
      if (action.idx != null && action.idx !== state.live.cur) return state;
      const rounds = state.live.rounds.map((r, i) => (i === state.live.cur ? { ...r, skipped: true } : r));
      const nx = hlNextPlanned(rounds, state.live.cur);
      const cur = nx >= 0 ? nx : state.live.cur;
      const remaining = nx >= 0 ? rounds[nx].dur : liveRemaining(state.live, rnow());
      return { ...state, live: { ...state.live, rounds, cur, remaining, running: false } };
    }
    case "live/reopen": {      // gespielte/gestrichene Runde wieder öffnen und laden
      const rounds = state.live.rounds.map((r, i) => (i === action.idx ? { ...r, done: false, skipped: false } : r));
      const r = rounds[action.idx];
      return { ...state, live: { ...state.live, rounds, cur: action.idx, remaining: r ? r.dur : 0, running: false } };
    }
    case "live/rebuild": {     // Plan neu aus der Zeitplaner-Wahrheit erzeugen (Fortschritt geht verloren)
      const rounds = buildLiveRounds(state.tournament.config);
      return { ...state, live: { rounds, cur: 0, remaining: rounds[0] ? rounds[0].dur : 0, running: false, angepfiffen: !!(state.live && state.live.angepfiffen) } };
    }

    // --- Einzel-KO: Teilnehmer:innen, KO-Baum, Ergebnisse (EINE Wahrheit: state.ko) ---
    // Spontane Namen vor dem Start; sobald gestartet, ist der Baum (koBuildBracket)
    // die Wahrheit. Ergebnisse wandern über ko/saveToTour in state.tour (Kids +
    // ein neues Event), damit die Tour-Rangliste sie später übernehmen kann.
    // ---------- Stand 37l: Afterwork-Abend mit Runden (Sieger bleibt · Einzel-KO · Firmen-Teams) ----------
    case "abend/runde/start": {
      const ab = state.abend || ABEND_LEER;
      if (ab.aktivId) return state; // erst die laufende Runde beenden
      const alle = state.ko.participants;
      const ids = Array.isArray(action.teilnehmer) && action.teilnehmer.length ? action.teilnehmer : alle.map((p) => p.id);
      const tn = alle.filter((p) => ids.includes(p.id));
      const id = uid();
      let runde = null; let ko = state.ko;
      if (action.form === "sieger") {
        if (tn.length < 2) return state;
        const q = koShuffle(tn.map((p) => p.id));
        runde = { id, form: "sieger", status: "laeuft", box: [q[0], q[1]], queue: q.slice(2), siege: {}, serie: {}, log: [], maxSerie: 3 };
      } else if (action.form === "ko") {
        if (tn.length < 2 || state.ko.bracket) return state;
        runde = { id, form: "ko", status: "laeuft", teilnehmer: tn.map((p) => p.id) };
        ko = { ...state.ko, bracket: koBuildBracket(tn), savedEventId: null };
      } else if (action.form === "firmen") {
        const gruppen = {};
        tn.forEach((p) => { const f = (p.firma || "").trim() || "Ohne Firma"; (gruppen[f] = gruppen[f] || []).push(p.id); });
        const teams = Object.entries(gruppen).map(([name, mitglieder]) => ({ name, mitglieder }));
        if (teams.length < 2) return state;
        const spiele = roundRobin(teams.length).flat().map(([a, b]) => ({ a, b, ta: 0, tb: 0, done: false }));
        runde = { id, form: "firmen", status: "laeuft", teams, spiele };
      } else return state;
      return { ...state, ko, abend: { ...ab, runden: [...ab.runden, runde], aktivId: id, beendet: false } };
    }
    case "abend/sieger/ergebnis": {
      const ab = state.abend || ABEND_LEER;
      const r = ab.runden.find((x) => x.id === action.rundeId);
      if (!r || r.form !== "sieger" || r.status !== "laeuft" || !r.box.includes(action.gewinnerId)) return state;
      const w = action.gewinnerId, l = r.box[0] === w ? r.box[1] : r.box[0];
      const siege = { ...r.siege, [w]: (r.siege[w] || 0) + 1 };
      const serie = { ...r.serie, [w]: (r.serie[w] || 0) + 1, [l]: 0 };
      let queue = [...r.queue, l]; let box;
      if (serie[w] >= r.maxSerie && queue.length >= 2) { // nach 3 Siegen in Folge Pause -- alle kommen dran
        serie[w] = 0; queue = [...queue, w]; box = [queue[0], queue[1]]; queue = queue.slice(2);
      } else { box = [w, queue[0]]; queue = queue.slice(1); }
      const nr = { ...r, siege, serie, box, queue, log: [...r.log, { a: r.box[0], b: r.box[1], w }] };
      return { ...state, abend: { ...ab, runden: ab.runden.map((x) => (x.id === r.id ? nr : x)) } };
    }
    case "abend/sieger/rueckgaengig": {
      const ab = state.abend || ABEND_LEER;
      const r = ab.runden.find((x) => x.id === action.rundeId);
      if (!r || r.form !== "sieger" || !r.log.length) return state;
      const last = r.log[r.log.length - 1];
      // einfach: Sieg zuruecknehmen, das letzte Duell wieder in die Box, Warteschlange ohne die beiden
      const siege = { ...r.siege, [last.w]: Math.max(0, (r.siege[last.w] || 0) - 1) };
      const queue = [...r.box, ...r.queue].filter((x) => x !== last.a && x !== last.b);
      return { ...state, abend: { ...ab, runden: ab.runden.map((x) => (x.id === r.id ? { ...r, siege, box: [last.a, last.b], queue, log: r.log.slice(0, -1), serie: { ...r.serie, [last.w]: Math.max(0, (r.serie[last.w] || 0) - 1) } } : x)) } };
    }
    case "abend/firmen/tor": {
      const ab = state.abend || ABEND_LEER;
      return { ...state, abend: { ...ab, runden: ab.runden.map((r) => (r.id !== action.rundeId ? r : { ...r, spiele: r.spiele.map((m, i) => (i !== action.mi || m.done ? m : { ...m, [action.seite]: Math.max(0, m[action.seite] + (action.delta || 0)) })) })) } };
    }
    case "abend/firmen/fertig": {
      const ab = state.abend || ABEND_LEER;
      return { ...state, abend: { ...ab, runden: ab.runden.map((r) => (r.id !== action.rundeId ? r : { ...r, spiele: r.spiele.map((m, i) => (i === action.mi ? { ...m, done: !m.done } : m)) })) } };
    }
    case "abend/runde/ende": {
      const ab = state.abend || ABEND_LEER;
      const r = ab.runden.find((x) => x.id === ab.aktivId);
      if (!r) return state;
      const fertig = r.form === "ko" ? { ...r, status: "fertig", bracket: state.ko.bracket } : { ...r, status: "fertig" };
      return { ...state, ko: r.form === "ko" ? { ...state.ko, bracket: null } : state.ko, abend: { ...ab, aktivId: null, runden: ab.runden.map((x) => (x.id === r.id ? fertig : x)) } };
    }
    case "abend/beenden":
      return { ...state, abend: { ...(state.abend || ABEND_LEER), beendet: !!action.wert } };
    case "ko/addParticipant": {
      const name = (action.name || "").trim();
      const awAbend = (state.tournament.meta && state.tournament.meta.format) === "afterwork"; // Stand 37l: Nachzuegler jederzeit
      if (!name || state.ko.participants.length >= (awAbend ? 60 : 16) || (state.ko.bracket && !awAbend)) return state;
      // Stand 37h (Afterwork): Firma (optional) + Ticket-Art (team = Teamticket der Firma, einzel = Einzelticket)
      const firma = (action.firma || "").trim();
      // Stand 37i: Teamticket = Abo der Firma (aboId); sonst Einzelticket
      const extra = action.ticket ? (action.ticket === "abo" && action.aboId && firma ? { firma, ticket: "abo", aboId: action.aboId } : { firma, ticket: "einzel" }) : {};
      const neuId = uid();
      const ab0 = state.abend || ABEND_LEER;
      const abend = ab0.aktivId ? { ...ab0, runden: ab0.runden.map((r) => (r.id === ab0.aktivId && r.form === "sieger" ? { ...r, queue: [...r.queue, neuId] } : r)) } : state.abend;
      return { ...state, abend, ko: { ...state.ko, participants: [...state.ko.participants, { id: neuId, name, ...extra }] } };
    }
    case "ko/removeParticipant":
      if (state.ko.bracket) return state;
      return { ...state, ko: { ...state.ko, participants: state.ko.participants.filter((p) => p.id !== action.id) } };
    case "ko/start": {
      if (state.ko.participants.length < 2 || state.ko.bracket) return state; // Stand 37d: laufenden Baum nie ersetzen
      const bracket = koBuildBracket(state.ko.participants);
      return { ...state, ko: { ...state.ko, bracket, savedEventId: null } };
    }
    case "ko/score": {  // Zwischenstand eines laufenden Matches ± (Baum- oder kleines Finale)
      const b = state.ko.bracket;
      if (!b) return state;
      if (action.loc === "sf") {
        if (!b.smallFinal || b.smallFinal.done || !b.smallFinal.a || !b.smallFinal.b) return state;
        const sf = { ...b.smallFinal, [action.slot]: Math.max(0, b.smallFinal[action.slot] + action.delta) };
        sf.golden = sf.sa === sf.sb && (sf.sa > 0 || sf.sb > 0);
        return { ...state, ko: { ...state.ko, bracket: { ...b, smallFinal: sf } } };
      }
      const c = koClone(b);
      const m = c.rounds[action.ri][action.mi];
      if (m.done || !m.a || !m.b || m.b.bye) return state;
      m[action.slot] = Math.max(0, m[action.slot] + action.delta);
      m.golden = m.sa === m.sb && (m.sa > 0 || m.sb > 0);
      return { ...state, ko: { ...state.ko, bracket: c } };
    }
    case "ko/confirm": {  // Sieger bestätigen → Baum (bzw. kleines Finale) einen Schritt weiter
      const b = state.ko.bracket;
      if (!b) return state;
      if (action.loc === "sf") {
        const sf = b.smallFinal;
        if (!sf || sf.done || !sf.a || !sf.b || sf.sa === sf.sb) return state;
        const aWins = sf.sa > sf.sb;
        return { ...state, ko: { ...state.ko, bracket: { ...b, smallFinal: { ...sf, winner: aWins ? sf.a : sf.b, loser: aWins ? sf.b : sf.a, done: true } } } };
      }
      const c = koClone(b);
      const { ri, mi } = action;
      const m = c.rounds[ri][mi];
      if (!m.a || !m.b || m.b.bye || m.sa === m.sb) return state;
      const aWins = m.sa > m.sb;
      m.winner = aWins ? m.a : m.b; m.loser = aWins ? m.b : m.a; m.done = true;
      if (ri < c.rounds.length - 1) { const t = c.rounds[ri + 1][Math.floor(mi / 2)]; if (mi % 2 === 0) t.a = m.winner; else t.b = m.winner; }
      if (ri === c.rounds.length - 2 && c.smallFinal) { if (mi % 2 === 0) c.smallFinal.a = m.loser; else c.smallFinal.b = m.loser; }
      return { ...state, ko: { ...state.ko, bracket: c } };
    }
    case "ko/reset":  // "Neues Turnier": Baum verwerfen, Teilnehmer:innen-Liste bleibt (schnell neu starten)
      return { ...state, ko: { ...state.ko, bracket: null, savedEventId: null } };
    case "ko/clearParticipants":
      if (state.ko.bracket) return state;
      return { ...state, ko: { ...state.ko, participants: [] } };
    case "ko/saveToTour": {  // Ergebnis (Platz 1–4) in state.tour heben: Kids anlegen/wiederverwenden + neues Event
      const b = state.ko.bracket;
      const placements0 = koPlacements(b);
      if (!placements0.length || state.ko.savedEventId) return state;
      // Stand 37d: alle Teilnehmenden kommen in die Tour (Teilnahme-Punkte), nicht nur Platz 1-4
      const vergeben = new Set(placements0.map((p) => (p.name || "").trim().toLowerCase()));
      const placements = [...placements0, ...state.ko.participants.filter((pp) => !vergeben.has((pp.name || "").trim().toLowerCase())).map((pp) => ({ placement: 0, name: pp.name }))];
      let kids = state.tour.kids;
      const results = placements.map((p) => {
        const found = tourFindOrMakeKid(kids, p.name);
        kids = found.kids;
        return { kidId: found.id, placement: p.placement };
      });
      const eventId = uid();
      const event = { id: eventId, datum: action.datum || "", ort: action.ort || "", results };
      return { ...state, tour: { ...state.tour, kids, events: [...state.tour.events, event] }, ko: { ...state.ko, savedEventId: eventId } };
    }
    // Station manuell erfassen (ohne Einzel-KO, z. B. ein spontanes Spiel) —
    // dieselbe Kid-Anlage/Wiederverwendung wie ko/saveToTour (EIN Helfer:
    // tourFindOrMakeKid), damit Kids nicht doppelt entstehen. Von der
    // Tour-Rangliste (Headcoach/Coach) genutzt; die Tour-Rangliste selbst
    // liest die Wahrheit sonst nur (tourStandings).
    case "tour/addEvent": {
      const entries = (action.results || []).filter((r) => r.name && r.name.trim());
      if (!entries.length) return state;
      let kids = state.tour.kids;
      const results = entries.map((r) => {
        const found = tourFindOrMakeKid(kids, r.name);
        kids = found.kids;
        return { kidId: found.id, placement: r.placement };
      });
      const event = { id: uid(), datum: action.datum || "", ort: action.ort || "", results };
      return { ...state, tour: { ...state.tour, kids, events: [...state.tour.events, event] } };
    }

    case "reset": {
      const s = seed();
      return { ...s, role: state.role, view: state.view, tournament: { ...s.tournament, status: state.tournament.status }, archivedTournaments: state.archivedTournaments };
    }
    // "Neues Turnier anlegen": komplett leer (keine Teams, kein Verlauf) —
    // anders als "reset" (lädt Beispieldaten) und anders als "ko/reset"
    // (nur die kleine Einzel-KO-Nebenschiene). Bleibt eingeloggt (role),
    // landet aber wieder auf Übersicht zum Neu-Einrichten.
    case "tournament/new": {
      const hasData = state.teams.length > 0;
      const closed = state.tournament.status === "abgeschlossen";
      if (hasData && !closed) return state; // Sicherheitsnetz: zuerst abschließen (siehe NeuesTurnierAktion)
      const archivedTournaments = hasData
        ? [snapshotTournament(state), ...state.archivedTournaments]
        : state.archivedTournaments;
      const s = blankState();
      s.tournament.meta.title = (action.title || "").trim() || s.tournament.meta.title;
      s.tournament.meta.ort = (action.ort || "").trim();
      return { ...s, role: state.role, archivedTournaments };
    }
    default:
      return state;
  }
}

// Wie oft ein Gerät beim Server nachfragt, ob ein ANDERES Gerät inzwischen
// einen neueren Stand gespeichert hat (Stufe 2, einfaches Polling statt
// echtem Push — robust auch auf einfachem Shared Hosting).
const POLL_INTERVAL_MS = 4000;

// Audit-Fix (Stand 31, Nachtrag 2) -- Rollen-Isolation, Teil 2: "role" /
// "boundTeamId" / "boundDeviceId" / "view" sind WER-BIN-ICH AUF DIESEM
// GERAET, keine Turnierdaten -- die duerfen nie mit anderen Geraeten
// synchronisiert werden (siehe hydrate/replace oben). Ein einfacher
// Reducer-Fix allein wuerde aber "Seite neu laden" kaputt machen: ein
// Reload startet die App komplett neu (lokaler State wieder aus seed()),
// und ohne diesen kleinen, bewusst NICHT synchronisierten localStorage-
// Spiegel wuerde jeder Reload wie ein frisches, unbekanntes Geraet
// aussehen und zurueck zum Login-Screen springen. localStorage bleibt
// strikt lokal in diesem Browser (wird nie an den Server geschickt, nie
// aus einem geladenen/gepollten Stand befuellt) -- es beantwortet nur
// "wer war ICH auf DIESEM Geraet zuletzt", nichts weiter. Ein echtes
// Abmelden (dispatch "logout", auch automatisch bei "trennen"/
// "abschließen", siehe Fix #5/#6) loescht diesen Eintrag wieder, damit
// das naechste Kind, das dasselbe Handy in die Hand bekommt, wieder den
// normalen Auswahlbildschirm sieht.
const LOCAL_SESSION_KEY = "microsoccer_session_v1";
// Stand 34: die Sitzung gilt JE EVENT (wer auf diesem Geraet in Event A
// Headcoach ist, ist es in Event B nicht automatisch). Event e1 (das
// bisherige Turnier) liest zusaetzlich noch den alten, eventlosen Schluessel,
// damit nach dem Deploy niemand ausgeloggt wird.
const sessionKey = (eventId) => `${LOCAL_SESSION_KEY}:${eventId || LEGACY_EVENT_ID}`;
function readLocalSession(eventId) {
  try {
    const raw = window.localStorage.getItem(sessionKey(eventId))
      || ((eventId || LEGACY_EVENT_ID) === LEGACY_EVENT_ID ? window.localStorage.getItem(LOCAL_SESSION_KEY) : null);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch (_) {
    return null; // z. B. privates Fenster, Storage deaktiviert -- dann einfach wie ein frisches Geraet behandeln
  }
}
function writeLocalSession(eventId, role, boundTeamId, boundDeviceId, view, meinEinsatzId) {
  try {
    window.localStorage.setItem(sessionKey(eventId), JSON.stringify({ role, boundTeamId, boundDeviceId, view, meinEinsatzId: meinEinsatzId || null }));
  } catch (_) {
    // kein Beinbruch -- ohne funktionierenden localStorage verhaelt sich
    // ein Reload dann wieder wie vor diesem Fix (zurueck zum Login).
  }
}

function StoreProvider({ eventId = LEGACY_EVENT_ID, children }) {
  const [state, dispatch] = useReducer(reducer, undefined, () => {
    const s = seed();
    const local = readLocalSession(eventId);
    if (!local) return s;
    return {
      ...s,
      role: local.role ?? null,
      boundTeamId: local.boundTeamId ?? null,
      boundDeviceId: local.boundDeviceId ?? null,
      view: local.view || s.view,
      meinEinsatzId: local.meinEinsatzId || null,
    };
  });

  // Stand 36c -- keine verlorenen Aktionen mehr: jede lokale Aktion wird
  // mitgeschrieben, bis der Server sie bestaetigt hat. Hat inzwischen ein anderes
  // Geraet gespeichert (Server antwortet 409), holen wir dessen Stand, spielen
  // unsere eigenen Aktionen darauf noch einmal ab und speichern das Ergebnis.
  const stateRef = useRef(state);
  stateRef.current = state;
  const actionLogRef = useRef([]);
  const sofortRef = useRef(false); // Stand 39: Anpfiff/Stopp sofort speichern (kein Warten)
  const dispatchLog = useCallback((a) => {
    if (a && a.type !== "hydrate/replace" && a.type !== "sync/setAll" && a.type !== "live/tick") actionLogRef.current.push(a);
    if (a && (/^live\//.test(a.type) || a.type === "turnier/probelaufZurueck") && a.type !== "live/tick") sofortRef.current = true;
    if (a && a.type === "logout") abmelden(eventId); // Stand 39: Abmelden beendet auch die Sitzung
    if (a && a.type !== "hydrate/replace" && a.type !== "sync/setAll" && a.type !== "live/tick" && a.type !== "setView") uxAktion(); // Stand 40
    dispatch(a);
  }, [eventId]);
  // Stand 39: Rolle aus der Sitzung (Academy-Login, Gast-Code): Coach landet direkt bei seinem Team.
  // Ordnet der Headcoach um, zieht das Handy beim nächsten Laden mit.
  const rolleAusSitzung = useCallback((loaded) => {
    if (!loaded || !holeSitzung(eventId)) return;
    const st = stateRef.current;
    if (loaded.rolle === "headcoach" && st.role !== "headcoach") dispatch({ type: "setRole", role: "headcoach" });
    else if (loaded.rolle === "coach" && (st.role !== "coach" || (loaded.teamId && st.boundTeamId !== loaded.teamId))) dispatch({ type: "setRole", role: "coach", teamId: loaded.teamId || null });
  }, [eventId]);

  // Lokale Sitzungs-Identitaet (siehe Kommentar oben) bei jeder Aenderung
  // in localStorage spiegeln -- rein lokal, nie Teil von saveState()/
  // hydrate/replace.
  useEffect(() => {
    writeLocalSession(eventId, state.role, state.boundTeamId, state.boundDeviceId, state.view, state.meinEinsatzId);
  }, [eventId, state.role, state.boundTeamId, state.boundDeviceId, state.view, state.meinEinsatzId]);

  // Stufe 1 (Persistenz, eigener Server statt Google Drive) + Stufe 2
  // (Echtzeit via Polling):
  //   - Beim Start EINMAL laden (hydrate/replace) — bis dahin läuft die App
  //     mit dem lokalen seed() weiter, damit die Oberfläche sofort da ist.
  //   - Danach nach JEDER Änderung speichern, aber debounced (nicht auf
  //     jeden einzelnen Tastenanschlag) und niemals parallel doppelt.
  //   - Zusätzlich alle paar Sekunden beim Server nachfragen (nur die
  //     leichte `id`, kein voller State), ob ein ANDERES Gerät inzwischen
  //     etwas gespeichert hat — wenn ja, den vollen Stand nachladen und
  //     hier übernehmen. So sehen Team-Handys, Headcoach und Beamer
  //     denselben Stand, ohne dass jemand manuell neu lädt.
  //   - Um eine eigene, noch nicht gespeicherte Änderung NICHT durch einen
  //     Poll zu überschreiben: ein Poll-Ergebnis wird nur übernommen, wenn
  //     gerade weder gespeichert wird noch eine Speicherung ansteht
  //     (savingRef/pendingRef/debounceRef alle leer).
  //   - "saveStatus" ist reiner UI-Hinweis (siehe SaveStatusBadge unten),
  //     keine zweite Wahrheit — er spiegelt nur, was hier gerade passiert.
  const hydratedRef = useRef(false);
  const savingRef = useRef(false);
  const pendingRef = useRef(false);
  const debounceRef = useRef(null);
  const lastKnownIdRef = useRef(null); // Versions-`id` des Stands, den WIR gerade zeigen
  const [saveStatus, setSaveStatus] = useState("loading"); // loading | saved | saving | offline | locked
  // Stand 34: ist DIESES Event abgeschlossen (Archiv, schreibgeschuetzt)?
  // Der Server lehnt Speichern dann mit 423 ab -- hier gemerkt, damit wir es
  // nicht bei jeder lokalen Klick-Aenderung erneut versuchen.
  const lockedRef = useRef(false);
  const [notFound, setNotFound] = useState(false);
  const [gastToken, setGastToken] = useState(null); // Stand 35: fuer den Gaeste-QR (nur Team)
  // Stufe 3 (Politur): solange der allererste Ladeversuch läuft, zeigen wir
  // einen Ladebildschirm statt der Oberfläche — sonst würde kurz der lokale
  // seed() (Platzhalter-Teams/-Ergebnisse) aufblitzen, bevor der echte
  // Turnierstand vom Server da ist. "ready" wird sowohl bei Erfolg als auch
  // bei Fehlschlag (dann läuft die App offline mit dem lokalen Stand weiter,
  // siehe SaveStatusBadge) gesetzt — nur einmal, beim allerersten Laden.
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const loaded = await loadState(eventId);
        if (cancelled) return;
        lockedRef.current = !!(loaded.event && loaded.event.status === "abgeschlossen");
        setGastToken((loaded.event && loaded.event.gastToken) || null);
        if (loaded.state) {
          dispatch({ type: "hydrate/replace", state: loaded.state });
          lastKnownIdRef.current = loaded.id;
          rolleAusSitzung(loaded);
        } else if (eventId !== LEGACY_EVENT_ID) {
          // Event existiert, aber noch nie gespeichert: leeres Blatt mit den
          // Eckdaten aus der Event-Liste (statt Demo-Daten aus seed()).
          const blank = blankState();
          const e = loaded.event || {};
          blank.tournament.meta = { ...blank.tournament.meta, title: e.title || blank.tournament.meta.title, ort: e.ort || "", date: e.datum || "", format: e.format || undefined };
          dispatch({ type: "hydrate/replace", state: blank });
        }
        setSaveStatus(lockedRef.current ? "locked" : "saved");
      } catch (err) {
        if (cancelled) return;
        if (err && err.status === 404) { setNotFound(true); return; }
        console.warn("Stufe 1: Laden vom Server fehlgeschlagen, starte mit lokalem Stand.", err);
        setSaveStatus("offline");
      } finally {
        if (!cancelled) { hydratedRef.current = true; setReady(true); }
      }
    })();
    return () => { cancelled = true; };
  }, [eventId]);

  const flushSave = useCallback(async () => {
    // Archiv (abgeschlossen): nicht speichern, der Server wuerde ohnehin mit
    // 423 ablehnen. Wieder oeffnen geht nur ueber reopen() (siehe unten).
    if (lockedRef.current && state.tournament.status === "abgeschlossen") { setSaveStatus("locked"); return; }
    if (savingRef.current) { pendingRef.current = true; return; }
    savingRef.current = true;
    setSaveStatus("saving");
    try {
      let toSave = state;
      let sent = actionLogRef.current.length;
      let res = null;
      for (let versuch = 0; versuch < 4; versuch++) {
        try {
          res = await saveState(eventId, toSave, lastKnownIdRef.current);
          break;
        } catch (e) {
          if (!(e && e.status === 409) || versuch === 3) throw e;
          // Jemand anderes war schneller: dessen Stand + unsere Aktionen
          const loaded = await loadState(eventId);
          let merged = reducer(stateRef.current, { type: "hydrate/replace", state: loaded.state });
          for (const a of actionLogRef.current) merged = reducer(merged, a);
          lastKnownIdRef.current = loaded.id;
          sent = actionLogRef.current.length;
          dispatch({ type: "sync/setAll", state: merged });
          toSave = merged;
        }
      }
      if (res && res.id != null) lastKnownIdRef.current = res.id;
      actionLogRef.current = actionLogRef.current.slice(sent);
      // Stand 39: Der Server hat nur übernommen, was dieses Gerät ändern darf → frischen Stand holen
      if (res && res.angepasst && !actionLogRef.current.length) {
        try { const l = await loadState(eventId); if (l && l.state) { dispatch({ type: "hydrate/replace", state: l.state }); lastKnownIdRef.current = l.id; } } catch (_) { /* nächster Poll */ }
      }
      // Dieser Save hat das Event abgeschlossen -> ab jetzt Archiv.
      if (toSave.tournament.status === "abgeschlossen") { lockedRef.current = true; setSaveStatus("locked"); }
      else setSaveStatus("saved");
    } catch (err) {
      if (err && err.status === 423) {
        lockedRef.current = true;
        setSaveStatus("locked");
        return;
      }
      console.warn("Stufe 1: Speichern fehlgeschlagen, versuche es bei der nächsten Änderung erneut.", err);
      setSaveStatus("offline");
    } finally {
      savingRef.current = false;
      if (pendingRef.current) { pendingRef.current = false; flushSave(); }
    }
  }, [state, eventId]);

  useEffect(() => {
    if (!hydratedRef.current) return; // vor dem ersten Laden nichts speichern
    if (debounceRef.current) clearTimeout(debounceRef.current);
    const warten = sofortRef.current ? 0 : 800; sofortRef.current = false;
    debounceRef.current = setTimeout(() => {
      debounceRef.current = null;
      flushSave();
    }, warten);
    return () => { if (debounceRef.current) { clearTimeout(debounceRef.current); debounceRef.current = null; } };
  }, [state, flushSave]);

  // Stufe 2: leichtes Polling auf einen neueren Stand von einem anderen Gerät.
  const laeuftRef = useRef(false);
  laeuftRef.current = !!(state.live && state.live.running);
  useEffect(() => {
    let letzter = 0;
    const timer = setInterval(async () => {
      if (!hydratedRef.current) return; // vor dem ersten Laden nicht pollen
      // Stand 39: während einer Runde jede Sekunde, sonst alle 4 Sekunden
      const jetzt = Date.now();
      if (!laeuftRef.current && jetzt - letzter < POLL_INTERVAL_MS - 50) return;
      letzter = jetzt;
      // Eigene, noch nicht (vollständig) gespeicherte Änderung hat Vorrang —
      // sonst würden wir uns selbst überschreiben, bevor unser Save durch ist.
      if (savingRef.current || pendingRef.current || debounceRef.current) return;
      try {
        const meta = await pollLatestId(eventId);
        if (!meta) return; // noch nie gespeichert (Erststart) — nichts zu holen
        if (meta.id === lastKnownIdRef.current) return; // schon aktuell
        const loaded = await loadState(eventId);
        if (!loaded || !loaded.state || loaded.id === lastKnownIdRef.current) return;
        lockedRef.current = !!(loaded.event && loaded.event.status === "abgeschlossen");
        if (actionLogRef.current.length && !lockedRef.current) {
          // Stand 37d: noch nicht gespeicherte eigene Aktionen (z. B. nach "offline")
          // nicht verwerfen, sondern auf den neuen Stand legen -- der naechste Save folgt.
          let merged = reducer(stateRef.current, { type: "hydrate/replace", state: loaded.state });
          for (const a of actionLogRef.current) merged = reducer(merged, a);
          lastKnownIdRef.current = loaded.id;
          dispatch({ type: "sync/setAll", state: merged });
          return;
        }
        dispatch({ type: "hydrate/replace", state: loaded.state });
        lastKnownIdRef.current = loaded.id;
        rolleAusSitzung(loaded);
        if (loaded.event && loaded.event.gastToken) setGastToken(loaded.event.gastToken);
        setSaveStatus(lockedRef.current ? "locked" : "saved");
      } catch (err) {
        // Poll-Fehler sind kein Beinbruch (nächster Tick versucht es wieder) —
        // nicht denselben "offline"-Status wie beim Speichern verwenden, das
        // würde bei einem kurzen Hänger unnötig alarmieren.
        console.warn("Stufe 2: Polling auf neueren Stand fehlgeschlagen.", err);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [eventId]);
  // Stand 39: nach dem Anmelden den Stand neu holen (mit Sitzung → je nach Rolle volle Daten)
  const neuLaden = useCallback(async () => {
    try {
      const l = await loadState(eventId);
      if (l && l.state) {
        if (actionLogRef.current.length) { // noch nicht gespeicherte eigene Aktionen oben drauf (nichts geht verloren)
          let m = reducer(stateRef.current, { type: "hydrate/replace", state: l.state });
          for (const a of actionLogRef.current) m = reducer(m, a);
          dispatch({ type: "sync/setAll", state: m });
        } else dispatch({ type: "hydrate/replace", state: l.state });
        lastKnownIdRef.current = l.id; rolleAusSitzung(l);
        if (l.event && l.event.gastToken) setGastToken(l.event.gastToken); // Stand 39: QR erst mit Headcoach-Sitzung
      }
      return l;
    } catch (_) { return null; }
  }, [eventId, rolleAusSitzung]);

  // Stand 34: Wieder oeffnen geht NICHT mehr ueber ein lokales setStatus
  // (das wuerde der Server bei einem gesperrten Event ablehnen), sondern
  // ueber den Server -- mit der Headcoach-PIN DIESES Events oder dem
  // Buero-Code. Der Server haengt eine neue Version mit status "offen" an;
  // alle anderen Geraete bekommen das ueber das normale Polling mit.
  const reopen = useCallback(async ({ pin, bueroCode } = {}) => {
    const res = await reopenEvent(eventId, { pin, bueroCode });
    lockedRef.current = false;
    actionLogRef.current = [];
    if (res && res.state) {
      dispatch({ type: "hydrate/replace", state: res.state });
      lastKnownIdRef.current = res.id;
    } else {
      dispatch({ type: "setStatus", value: "offen" });
    }
    setSaveStatus("saved");
    return res;
  }, [eventId]);

  if (notFound) return <EventNotFound eventId={eventId} />;
  return (
    <StoreContext.Provider value={{ state, dispatch: dispatchLog, eventId, reopen, gastToken, neuLaden }}>
      {ready ? children : <InitialLoadScreen />}
      {ready && <SaveStatusBadge status={saveStatus} role={state.role} lifted={state.role === "headcoach" || state.role === "coach"} />}
    </StoreContext.Provider>
  );
}

// Stufe 3 (Politur): Ladebildschirm für den allerersten Start, bis geklärt
// ist, ob der echte Turnierstand vom Server kommt oder (bei Fehlschlag) mit
// dem lokalen Stand weitergemacht wird. Reine UI, keine eigene Wahrheit.
function InitialLoadScreen() {
  return (
    <div style={{
      position: "fixed", inset: 0, background: C.chalk, zIndex: 10000,
      display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
      gap: 18, fontFamily: font,
    }}>
      <style>{`
        @import url('${FONT_IMPORT}');
        @keyframes msRahmenSpin { to { transform: rotate(360deg); } }
      `}</style>
      <img src={LOGO_GREEN} alt={BRAND} style={{ height: 40, width: "auto" }} />
      <div style={{
        width: 34, height: 34, borderRadius: "50%",
        border: `4px solid ${C.line}`, borderTopColor: C.play,
        animation: "msRahmenSpin 0.8s linear infinite",
      }} />
      <div style={{ color: C.sub, fontSize: 14, fontWeight: 600 }}>Turnierstand wird geladen…</div>
    </div>
  );
}

// Kleiner, unaufdringlicher Hinweis unten rechts — nur UI, keine eigene
// Wahrheit. Sinnvoll bei einem Live-Turnier: sichtbar, ob der Stand gerade
// wirklich auf dem Server ankommt oder ob das Gerät offline ist.
function SaveStatusBadge({ status, lifted, role }) {
  const map = {
    loading: { label: "Lädt…", bg: "#EEF4F0", fg: "#5B7268" },
    saving: { label: "Speichert…", bg: "#EEF4F0", fg: "#5B7268" },
    saved: { label: "Gespeichert ✓", bg: "#E3F4EB", fg: "#1E7A46" },
    offline: { label: "Offline — wird erneut versucht", bg: "#FDECEC", fg: "#B23B3B" },
    locked: { label: "🔒 Archiv · schreibgeschützt", bg: "#FFF4E0", fg: "#8A5A00" },
  };
  const s = map[status] || map.saved;
  if (status === "saved") return null; // im Normalfall unsichtbar, keine Ablenkung
  if (status === "locked" && role !== "headcoach") return null; // Hinweis nur fuer den Headcoach, Zuschauer stoert er nicht
  return (
    <div style={{
      position: "fixed", right: 12, bottom: lifted ? 84 : 12, zIndex: 9999, // Stand 33: ueber der Tab-Leiste
      background: s.bg, color: s.fg, fontSize: 12.5, fontWeight: 700,
      padding: "6px 12px", borderRadius: 999, boxShadow: "0 2px 10px rgba(20,35,27,.12)",
      pointerEvents: "none",
    }}>{s.label}</div>
  );
}
const useStore = () => useContext(StoreContext);
// Stand 37f (Nutzer: "ja, aber nur bei Touren"): Community Tour und Kick & Splash
// zaehlen ueber mehrere Events (Stationen) mit demselben Tour-Namen zusammen.
const TOUR_UEBER_EVENTS = ["community-tour", "kick-splash"];
// Stand 37g (OEKOSYSTEM §2.3/§3d): jedes Event traegt Traeger + Projekt/Foerderung
// -> Wirkung je Foerderung, Abrechnung je Gesellschaft. Vorschlag nach Format.
const TRAEGER = { verein: "Verein", gmbh: "GmbH" };
function traegerVorschlag(formatId) { return ["geburtstag", "afterwork", "business-cup"].includes(formatId) ? "gmbh" : "verein"; }
function zweckText(meta) {
  if (!meta) return "";
  return [meta.traeger ? TRAEGER[meta.traeger] || meta.traeger : null, (meta.projekt || "").trim() || null].filter(Boolean).join(" · ");
}
// Traeger & Projekt im Event aendern (Headcoach/Buero, in den Einstellungen)
function ZweckKarte() {
  const { state, dispatch } = useStore();
  const m = state.tournament.meta || {};
  const [proj, setProj] = useState(m.projekt || "");
  if (state.role !== "headcoach") return null;
  const tr = m.traeger || traegerVorschlag(m.format);
  return (
    <div data-zweck-karte="true" style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: "12px 14px", margin: "0 0 16px", display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", fontFamily: font }}>
      <b style={{ fontSize: 13.5 }}>Träger & Projekt</b>
      <select data-zweck-traeger value={tr} onChange={(e) => dispatch({ type: "meta/patch", patch: { traeger: e.target.value } })} style={{ border: `1px solid ${C.line}`, borderRadius: 8, padding: "6px 8px", fontFamily: font }}>
        {Object.entries(TRAEGER).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      <input data-zweck-projekt value={proj} onChange={(e) => setProj(e.target.value)} placeholder="Projekt/Förderung, z. B. SBS #1700" style={{ flex: 1, minWidth: 180, border: `1px solid ${C.line}`, borderRadius: 8, padding: "6px 10px", fontFamily: font }} />
      <button data-zweck-speichern disabled={proj.trim() === (m.projekt || "").trim() && !!m.traeger} onClick={() => dispatch({ type: "meta/patch", patch: { traeger: tr, projekt: proj.trim() } })}
        style={{ border: "none", background: C.play, color: "#fff", borderRadius: 8, padding: "6px 12px", fontWeight: 700, cursor: "pointer", fontFamily: font }}>Speichern</button>
      <span style={{ width: "100%", fontSize: 12, color: C.sub }}>Damit Wirkung je Förderung und Abrechnung je Gesellschaft automatisch stimmen.</span>
    </div>
  );
}
function tourKeyVon(state) {
  const m = state && state.tournament && state.tournament.meta;
  return m && TOUR_UEBER_EVENTS.includes(m.format) ? String(m.tourKey || "").trim() : "";
}
// Headcoach legt fest, zu welcher Tour dieses Event (diese Station) gehoert.
function TourZuordnung() {
  const { state, dispatch } = useStore();
  const m = state.tournament.meta || {};
  const [v, setV] = useState(m.tourKey || "");
  const [touren, setTouren] = useState([]);
  useEffect(() => { listTours().then(setTouren).catch(() => {}); }, []);
  if (!TOUR_UEBER_EVENTS.includes(m.format) || state.role !== "headcoach") return null;
  const gesetzt = String(m.tourKey || "").trim();
  return (
    <div data-tour-zuordnung="true" style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", background: "#fff", border: `1px solid ${C.line}`, borderRadius: 12, padding: "8px 12px", margin: "8px 0 4px", fontSize: 13.5 }}>
      <span style={{ color: C.sub, fontWeight: 700 }}>Gehört zur Tour:</span>
      <input data-tour-key list="ms-touren-z" value={v} onChange={(e) => setV(e.target.value)} placeholder="z. B. Bädertour 2027" style={{ flex: 1, minWidth: 160, border: `1px solid ${C.line}`, borderRadius: 8, padding: "6px 10px", fontFamily: font, fontSize: 14 }} />
      <datalist id="ms-touren-z">{touren.map((t) => <option key={t.name} value={t.name}>{t.stationen} Stationen</option>)}</datalist>
      <button data-tour-key-speichern disabled={v.trim() === gesetzt} onClick={() => { dispatch({ type: "meta/patch", patch: { tourKey: v.trim() } }); if (v.trim()) dispatch({ type: "tour/patchMeta", patch: { name: v.trim() } }); }}
        style={{ border: "none", background: v.trim() === gesetzt ? "#C7D3CC" : C.play, color: "#fff", borderRadius: 8, padding: "6px 12px", fontWeight: 700, cursor: v.trim() === gesetzt ? "default" : "pointer", fontFamily: font }}>{v.trim() ? "Speichern" : "Lösen"}</button>
    </div>
  );
}
// Rangliste der ganzen Tour (alle Stationen) -- faellt auf die eigene Tour zurueck.
function useTourAnsicht() {
  const { state } = useStore();
  const key = tourKeyVon(state);
  const [gesamt, setGesamt] = useState(null);
  const eigeneStationen = (state.tour && state.tour.events || []).length;
  useEffect(() => {
    if (!key) { setGesamt(null); return; }
    let aus = false;
    const hol = () => loadTour(key).then((t) => { if (!aus && t) setGesamt(t); }).catch(() => {});
    hol();
    const iv = setInterval(hol, 20000);
    return () => { aus = true; clearInterval(iv); };
  }, [key, eigeneStationen]);
  return key && gesamt && gesamt.scheme && (gesamt.events || []).length >= eigeneStationen ? gesamt : state.tour;
}


/* =====================================================================
   4) FUNDAMENT-CHECK — read-only Nachweis
   ===================================================================== */

function Section({ title, hint, children }) {
  return (
    <section style={{ marginBottom: 36 }}>
      <div style={{ display: "flex", alignItems: "baseline", gap: 10, marginBottom: 14, flexWrap: "wrap" }}>
        <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, color: C.ink, margin: 0, letterSpacing: 0.2 }}>{title}</h2>
        {hint && <span style={{ fontSize: 12.5, color: C.sub, fontWeight: 500 }}>{hint}</span>}
      </div>
      {children}
    </section>
  );
}

function Card({ children, style }) {
  return (
    <div style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 16, padding: 20, ...style }}>{children}</div>
  );
}

function Chip({ emo, label, active }) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 6,
      border: `2px solid ${active ? C.play : C.line}`,
      background: active ? C.playSoft : "#fff",
      color: active ? C.fair : C.sub,
      borderRadius: 999, padding: "6px 11px", fontSize: 13, fontWeight: 700,
    }}>{emo} {label}{active ? " ✓" : ""}</span>
  );
}

function Stepper({ label, value, onDec, onInc, color, readOnly = false }) {
  const btn = { width: 30, height: 30, borderRadius: 8, border: `1px solid ${C.line}`, background: "#fff", color: C.ink, fontFamily: display, fontWeight: 700, fontSize: 18, cursor: "pointer", lineHeight: 1 };
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <span style={{ fontSize: 12.5, fontWeight: 700, color, minWidth: 116 }}>{label}</span>
      {!readOnly && <button style={btn} onClick={onDec}>−</button>}
      <span style={{ fontFamily: display, fontWeight: 700, fontSize: 20, width: 26, textAlign: "center" }}>{value}</span>
      {!readOnly && <button style={btn} onClick={onInc}>+</button>}
    </div>
  );
}

function Bar({ frac, color }) {
  return (
    <div style={{ height: 12, background: C.chalk, borderRadius: 999, overflow: "hidden" }}>
      <div style={{ width: `${Math.max(2, frac * 100)}%`, height: "100%", background: color, borderRadius: 999 }} />
    </div>
  );
}

/* ---------------------------------------------------------------------
   "Neues Turnier anlegen" + Archiv — geteilt zwischen Übersicht (Fundament)
   und Team-Verwaltung. Name+Ort sind Pflicht (Erkennungsmerkmal im Archiv).
   Sicherheitsnetz: lässt sich nur anlegen, wenn nichts verloren geht (noch
   keine Teams) ODER das aktuelle Turnier schon explizit "abgeschlossen" ist —
   sonst würden Daten stillschweigend verschwinden, ohne im Archiv zu landen.
   --------------------------------------------------------------------- */
function NeuesTurnierDialog({ open, onClose, onCreate }) {
  const [title, setTitle] = useState("");
  const [ort, setOrt] = useState("");
  useEffect(() => { if (open) { setTitle(""); setOrt(""); } }, [open]);
  if (!open) return null;
  const canSubmit = title.trim().length > 0 && ort.trim().length > 0;
  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 200, background: "rgba(18,36,28,.45)", display: "grid", placeItems: "center", padding: 20 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: C.card, borderRadius: 18, padding: 24, width: "100%", maxWidth: 420, boxShadow: "0 20px 60px rgba(19,36,28,.25)" }}>
        <div style={{ fontFamily: display, fontWeight: 700, fontSize: 20, marginBottom: 4 }}>🆕 Neues Turnier anlegen</div>
        <div style={{ fontSize: 13, color: C.sub, marginBottom: 18, lineHeight: 1.5 }}>
          Name und Ort sind Pflicht — damit ihr das Turnier später im Archiv wiedererkennt.
        </div>
        <label style={{ display: "block", fontSize: 12.5, fontWeight: 600, color: C.sub, marginBottom: 6 }}>Turniername</label>
        <input autoFocus value={title} onChange={(e) => setTitle(e.target.value)} placeholder="z. B. Herbstturnier 2026"
          style={{ width: "100%", border: `1px solid ${C.line}`, borderRadius: 10, padding: "10px 12px", fontSize: 15, fontFamily: font, marginBottom: 14, boxSizing: "border-box" }} />
        <label style={{ display: "block", fontSize: 12.5, fontWeight: 600, color: C.sub, marginBottom: 6 }}>Ort</label>
        <input value={ort} onChange={(e) => setOrt(e.target.value)} placeholder="z. B. VS Wasnergasse, Wien"
          style={{ width: "100%", border: `1px solid ${C.line}`, borderRadius: 10, padding: "10px 12px", fontSize: 15, fontFamily: font, marginBottom: 18, boxSizing: "border-box" }} />
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={onClose} style={{ flex: 1, border: `1px solid ${C.line}`, background: "#fff", color: C.ink, borderRadius: 10, padding: "11px", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: font }}>Abbrechen</button>
          <button disabled={!canSubmit} onClick={() => onCreate(title.trim(), ort.trim())}
            style={{ flex: 2, border: "none", background: canSubmit ? C.play : "#C7D3CC", color: "#fff", borderRadius: 10, padding: "11px", fontSize: 14, fontWeight: 700, cursor: canSubmit ? "pointer" : "default", fontFamily: display, letterSpacing: 0.5 }}>
            Anlegen
          </button>
        </div>
      </div>
    </div>
  );
}
// Stand 34: "Neues Turnier" legt ein EIGENES Event an (Konzept §10) statt
// den Stand dieses Events zu leeren -- dadurch kann nie etwas verloren gehen,
// das alte Sicherheitsnetz ("zuerst abschließen") ist nicht mehr nötig. Wer
// anlegt, ist im neuen Event Headcoach und landet direkt dort.
// (Reducer-Fall "tournament/new" bleibt für Alt-Stände bestehen, wird aber
// von der Oberfläche nicht mehr ausgelöst.)
function NeuesTurnierAktion({ style, label = "🆕 Neues Event anlegen" }) {
  const nav = useEventNav();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button data-neues-event-aktion="true" onClick={() => setOpen(true)} style={style}>{label}</button>
      <NeuesEventDialog open={open} onClose={() => setOpen(false)}
        onCreated={(ev) => { setOpen(false); if (nav) nav.choose(ev.id, { asHeadcoach: true }); }} />
    </>
  );
}
// Ein archiviertes Turnier — Klick klappt Endstand/Fairplay/Sonderpreise auf.
// Rein aus dem Schnappschuss (entry) gespeist, braucht keinen Live-State —
// funktioniert identisch in der Headcoach-Übersicht und auf der öffentlichen
// Website.
function ArchivKarte({ entry }) {
  const [open, setOpen] = useState(false);
  const dateStr = entry.meta.date
    ? (() => { try { return new Date(entry.meta.date).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" }); } catch (_) { return entry.meta.date; } })()
    : (() => { try { return new Date(entry.archivedAt).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" }); } catch (_) { return ""; } })();
  const winner = entry.ranked[0];
  return (
    <Card>
      <div onClick={() => setOpen((o) => !o)} style={{ display: "flex", alignItems: "center", gap: 12, cursor: "pointer" }}>
        <div style={{ width: 40, height: 40, borderRadius: 10, background: C.play, display: "grid", placeItems: "center", fontSize: 18, color: "#fff", flexShrink: 0 }}>🏁</div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontFamily: display, fontWeight: 700, fontSize: 16 }}>{entry.meta.title}</div>
          <div style={{ fontSize: 12.5, color: C.sub }}>
            {[entry.meta.ort, dateStr].filter(Boolean).join(" · ")}{winner ? ` · Sieger: ${winner.emoji} ${winner.name}` : ""}
          </div>
        </div>
        <span style={{ color: C.play, fontFamily: display, fontWeight: 700, fontSize: 20, flexShrink: 0 }}>{open ? "−" : "+"}</span>
      </div>
      {open && (
        <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 10 }}>
          {entry.ranked.map((r, i) => (
            <div key={r.id} style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontFamily: display, fontWeight: 700, fontSize: 15, width: 20, color: i === 0 ? C.gold : i === 1 ? C.silver : i === 2 ? C.bronze : C.sub }}>{i + 1}</span>
              <span style={{ fontSize: 18 }}>{r.emoji}</span>
              <span style={{ flex: 1, fontWeight: 600, fontSize: 14 }}>{r.name}</span>
              <span style={{ fontFamily: display, fontWeight: 700, fontSize: 15, color: C.play }}>{r.total} Pkt</span>
            </div>
          ))}
          {entry.awards.length > 0 && (
            <div style={{ marginTop: 6, display: "flex", flexWrap: "wrap", gap: 6 }}>
              {entry.awards.map((a) => (
                <span key={a.id} style={{ fontSize: 12, background: C.chalk, borderRadius: 999, padding: "4px 10px", fontWeight: 600 }}>{a.emoji} {a.title} — {a.teamName}</span>
              ))}
            </div>
          )}
        </div>
      )}
    </Card>
  );
}

function Fundament({ embedded = false }) {
  const { state, dispatch } = useStore();
  const { tournament, teams, roles, factors, tour, taskPool, focusThemes } = state;
  const cfg = tournament.config;
  const canEditFactors = state.role === "headcoach"; // nur Headcoach darf Parameter aendern

  const boxes = boxesNeeded(cfg.numTeams, cfg.mode);
  const rrRounds = roundRobin(cfg.numTeams);

  // Standings live aus dem Modell berechnet
  const standings = teams
    .map((t) => ({ team: t, score: teamScore(t, factors) }))
    .sort((a, b) => b.score.total - a.score.total);
  const maxTotal = Math.max(...standings.map((r) => r.score.total), 1);

  // Tour: Punkte je Kind (EINE Ableitung, siehe tourStandings — auch von der
  // Tour-Rangliste-Ansicht genutzt)
  const tourStand = tourStandings(tour).map((r) => ({ kid: r.kid, total: r.total, days: r.tage }));
  // Stand 37b: im Event kein "Neues Event anlegen" (gibt es in der Uebersicht),
  // bei Tour-Formaten keine Teamturnier-Abschnitte.
  const imEvent = !!useEventNav();
  const fmtF = formatById(tournament.meta && tournament.meta.format);
  const tourFmt = !!fmtF && fmtF.kind === "tour";

  const step = (key, delta, min = 0, max = 9) => {
    const v = Math.min(max, Math.max(min, factors[key] + delta));
    dispatch({ type: "setFactor", key, value: v });
  };

  return (
    <div style={{ background: embedded ? "transparent" : C.chalk, minHeight: embedded ? undefined : "100%", fontFamily: font, color: C.ink }}>
      <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;} button:focus-visible{outline:2px solid ${C.play};outline-offset:2px;}`}</style>

      <div style={{ maxWidth: 960, margin: "0 auto", padding: embedded ? "22px 20px 60px" : "26px 20px 64px" }}>

        {/* HERO — Markenkopf (weißes Logo auf Grün), nur im Standalone-Modus */}
        {!embedded && (
        <div style={{ background: C.play, borderRadius: 18, padding: "18px 22px", marginBottom: 22, display: "flex", alignItems: "center", gap: 18, flexWrap: "wrap", boxShadow: "0 6px 20px rgba(39,166,97,.25)" }}>
          <img src={LOGO_WHITE} alt={BRAND} style={{ height: 44, width: "auto" }} />
          <div style={{ height: 34, width: 2, background: "rgba(255,255,255,.4)" }} />
          <div>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: 24, color: "#fff", lineHeight: 1 }}>{BRAND} · Fundament</div>
            <div style={{ color: "rgba(255,255,255,.9)", fontSize: 13, marginTop: 3 }}>Stufe 0 · Schritt 1 + 2 — ein Datenmodell, ein Theme</div>
          </div>
        </div>
        )}

        {imEvent && <ZweckKarte />}
        {/* TURNIER-START — sofort verfügbar, direkt nach dem Login: neues
            Turnier anlegen + Archiv abgeschlossener Turniere. Nur Headcoach,
            da hier destruktiv (siehe NeuesTurnierAktion) bzw. Verwaltungssicht. */}
        {state.role === "headcoach" && (!imEvent || state.archivedTournaments.length > 0) && (
          <Section title={imEvent ? "Archiv" : "Turnier-Start"} hint={imEvent ? "frühere Turniere in diesem Event" : "sofort verfügbar"}>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: state.archivedTournaments.length ? 18 : 0 }}>
              {!imEvent && <NeuesTurnierAktion style={tvBtnPrimary} />}
            </div>
            {state.archivedTournaments.length > 0 && (
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {state.archivedTournaments.map((entry) => <ArchivKarte key={entry.id} entry={entry} />)}
              </div>
            )}
          </Section>
        )}

        {!tourFmt && (<>
        {/* TURNIER */}
        <Section title="Turnier" hint="Konfiguration + Ableitungen">
          <Card>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: 14 }}>
              {[
                ["Titel", tournament.meta.title],
                ["Kontext", cfg.context === "schule" ? "Schule" : "Individuell"],
                ["Box-Modus", `${cfg.mode === "dauer" ? "2" : "4"} Teams/Box`],
                ["Teams", cfg.numTeams],
                ["Boxen (auto)", boxes],
                ["RR-Runden (1×)", rrRounds.length],
                ["Durchgänge", `${cfg.targetRR}× jeder gegen jeden`],
                ["Spieldauer", `${cfg.gameDur} min`],
              ].map(([k, v]) => (
                <div key={k}>
                  <div style={{ fontSize: 11.5, color: C.sub, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.4 }}>{k}</div>
                  <div style={{ fontFamily: display, fontWeight: 700, fontSize: 20 }}>{v}</div>
                </div>
              ))}
            </div>
            <div style={{ marginTop: 12, fontSize: 12.5, color: C.sub }}>
              Parallele Boxen ändern die Spielzeit nicht — nur Teams × Durchgänge zählen.
            </div>
          </Card>
        </Section>

        {/* TEAMS */}
        <Section title="Teams" hint="einmal angelegt → überall verfügbar">
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(210px,1fr))", gap: 12 }}>
            {teams.map((t) => (
              <Card key={t.id} style={{ padding: 14 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                  <span style={{ width: 34, height: 34, borderRadius: 9, background: t.color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>{t.emoji}</span>
                  <div>
                    <div style={{ fontFamily: display, fontWeight: 700, fontSize: 18, lineHeight: 1 }}>{t.name}</div>
                    <div style={{ fontSize: 12, color: C.sub }}>{t.coach || "ohne Coach"}</div>
                  </div>
                </div>
                <div style={{ fontSize: 12.5, color: C.sub, marginBottom: 6 }}>
                  {t.players.length} Kinder · Captain: {t.players.find((p) => p.captain)?.name || "—"}
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                  {t.devices.map((d) => (
                    <span key={d.id} style={{ fontSize: 11.5, background: C.playSoft, color: C.fair, borderRadius: 6, padding: "2px 7px", fontWeight: 700 }}>📱 {d.label}</span>
                  ))}
                </div>
              </Card>
            ))}
          </div>
        </Section>

        {/* Stand 35: Bonus-Wertung, Fairplay, Aufgaben nur im Kontext Schule */}
        {!isSchlank(state) && (state.role === "headcoach" || !wertungVerborgen(state)) && (<>
        {/* GESAMTWERTUNG (interaktiv) */}
        <Section title="Gesamtwertung" hint="Tore (Basis) + Fairplay + Aufgaben">
          <Card>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 18, marginBottom: 16 }}>
              <Stepper label="Teamspiel-Faktor" value={factors.teamspiel} color={C.tore} onDec={() => step("teamspiel", -1, 1)} onInc={() => step("teamspiel", +1, 1)} readOnly={!canEditFactors} />
              <Stepper label="Fairplay je ★" value={factors.fairplay} color={C.fp} onDec={() => step("fairplay", -1)} onInc={() => step("fairplay", +1)} readOnly={!canEditFactors} />
              <Stepper label="Aufgabe je ✓" value={factors.aufgaben} color={C.auf} onDec={() => step("aufgaben", -1)} onInc={() => step("aufgaben", +1)} readOnly={!canEditFactors} />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {standings.map((r, i) => (
                <div key={r.team.id}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
                    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                      <b style={{ fontFamily: display, fontSize: 17, color: i === 0 ? C.gold : C.sub, width: 22 }}>{i + 1}.</b>
                      <span style={{ width: 24, height: 24, borderRadius: 7, background: r.team.color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 13 }}>{r.team.emoji}</span>
                      <b>{r.team.name}</b>
                    </span>
                    <span style={{ fontFamily: display, fontWeight: 700, fontSize: 20 }}>{r.score.total}</span>
                  </div>
                  <div style={{ display: "flex", height: 12, borderRadius: 999, overflow: "hidden", background: C.chalk }}>
                    <div style={{ width: `${(r.score.base / maxTotal) * 100}%`, background: C.tore }} />
                    <div style={{ width: `${(r.score.fp / maxTotal) * 100}%`, background: C.fp }} />
                    <div style={{ width: `${(r.score.auf / maxTotal) * 100}%`, background: C.auf }} />
                  </div>
                </div>
              ))}
            </div>
            <div style={{ marginTop: 12, fontSize: 12.5, color: C.sub }}>
              <span style={{ color: C.tore, fontWeight: 700 }}>■ Tore</span>{"  "}
              <span style={{ color: C.fp, fontWeight: 700 }}>■ Fairplay</span>{"  "}
              <span style={{ color: C.auf, fontWeight: 700 }}>■ Aufgaben</span> — hohe Bonus-Faktoren lassen Fairplay die Tore überholen.
            </div>
          </Card>
        </Section>

        {/* FAIRPLAY-KRITERIEN */}
        <Section title="Fairplay" hint="7 Kriterien · rein positiv · je 1–5 ★">
          <Card>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {FAIRPLAY_CRITERIA.map((c) => (
                <span key={c.k} title={c.hint} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: C.playSoft, color: C.fair, borderRadius: 999, padding: "6px 11px", fontSize: 13, fontWeight: 700 }}>{c.emo} {c.label}</span>
              ))}
            </div>
          </Card>
        </Section>

        {/* AUFGABEN + SCHWERPUNKTE */}
        <Section title="Aufgaben & Schwerpunkte" hint="Prävention: unterschwellig, auf Organisationsebene">
          <Card>
            <div style={{ fontSize: 12.5, color: C.sub, fontWeight: 700, marginBottom: 8 }}>Schwerpunkte (Chips – kombinierbar)</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 16 }}>
              {FOCUS_THEMES.map((th) => (
                <button key={th.k} onClick={() => dispatch({ type: "toggleTheme", key: th.k })} style={{ border: "none", background: "none", padding: 0, cursor: "pointer" }}>
                  <Chip emo={th.emo} label={th.label} active={focusThemes.includes(th.k)} />
                </button>
              ))}
            </div>
            <div style={{ fontSize: 12.5, color: C.sub, fontWeight: 700, marginBottom: 8 }}>Aufgaben-Pool (Auszug)</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
              {taskPool.slice(0, 5).map((task) => {
                const tm = TASK_TYPES[task.type];
                return (
                  <div key={task.id} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13.5 }}>
                    <span style={{ background: tm.color, color: "#fff", borderRadius: 6, padding: "2px 7px", fontSize: 11.5, fontWeight: 700, whiteSpace: "nowrap" }}>{tm.emo} {tm.label}</span>
                    <span>{task.text}</span>
                  </div>
                );
              })}
            </div>
          </Card>
        </Section>
        </>)}
        </>)}

        {/* TOUR */}
        <Section title="Tour (Einzel-KO)" hint={tour.name}>
          <Card>
            <div style={{ fontSize: 12.5, color: C.sub, marginBottom: 10 }}>
              Punkteschema: 🥇 {tour.scheme.p1} · 🥈 {tour.scheme.p2} · 🥉 {tour.scheme.p3} · Teilnahme {tour.scheme.part} — {tour.events.length} Stationen
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {tourStand.map((r, i) => (
                <div key={r.kid.id} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <b style={{ fontFamily: display, fontSize: 16, color: i === 0 ? C.gold : C.sub, width: 22 }}>{i + 1}.</b>
                  <b style={{ minWidth: 70 }}>{r.kid.name}</b>
                  <div style={{ flex: 1 }}><Bar frac={r.total / (tourStand[0].total || 1)} color={C.water} /></div>
                  <span style={{ fontFamily: display, fontWeight: 700, fontSize: 18, width: 34, textAlign: "right" }}>{r.total}</span>
                  <span style={{ fontSize: 11.5, color: C.sub, width: 52 }}>{r.days} Tage</span>
                </div>
              ))}
            </div>
          </Card>
        </Section>

        {/* FOOTER — der eigentliche Punkt */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: "14px 16px" }}>
          <img src={LOGO_GREEN} alt={BRAND} style={{ height: 26, width: "auto" }} />
          <div style={{ fontSize: 12.5, color: C.sub, flex: 1, minWidth: 220 }}>
            Microsoccer Matchday · Rolle, Abmelden und Einstellungen findest du unten unter „Ich".
          </div>
          {state.role === "headcoach" && !imEvent && (
            <button onClick={() => { let ok = true; try { ok = window.confirm("Alles auf Beispieldaten (Seed) zurücksetzen? Aktuelle Eingaben gehen verloren."); } catch (_) { ok = true; } if (ok) dispatch({ type: "reset" }); }}
              style={{ border: `1px solid ${C.line}`, background: C.chalk, color: C.ink, borderRadius: 9, padding: "8px 14px", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>Auf Beispieldaten zurücksetzen</button>
          )}
        </div>

      </div>
    </div>
  );
}

/* =====================================================================
   SCHRITT 3 + 4 — APP-RAHMEN (Navigation/Router) + ROLLEN-LOGIN
   Alle 15 Bausteine sind als Slots registriert. Sie hängen an EINEM
   Store; jeder Slot zeigt bereits eine echte Live-Zahl aus dem Modell
   (Nachweis: eine Wahrheit erreicht jede Ansicht). Die vollen Views
   werden pro Runde hier eingesetzt (Reihenfolge: Wert zuerst).
   ===================================================================== */

// Registry: id · Label · Emoji · Gruppe · sichtbar für Rollen · Kurzbeschreibung
const BAUSTEINE = [
  { id: "uebersicht",      label: "Übersicht (Fundament)", emo: "🧭", group: "basis", roles: ["headcoach", "coach"], desc: "Datenmodell + Theme live." },
  // Teamturnier (Wert-zuerst-Reihenfolge). `phase` gruppiert die
  // Headcoach-Navigation ab Stand 29 in drei Turnierphasen (siehe PHASES/
  // currentPhase() unten) - fuer Coach ungenutzt, dessen eigene Nav bleibt
  // unveraendert die bisherige flache, priorisierte Liste.
  { id: "team-verwaltung", label: "Team-Verwaltung",  emo: "👥", group: "team", phase: "vorbereitung", roles: ["headcoach", "coach"], desc: "Teams, Kinder, Coaches, Geräte, Beitrittscodes." },
  { id: "zeitplaner",      label: "Zeitplaner",       emo: "🗓️", group: "team", phase: "vorbereitung", roles: ["headcoach", "coach"], desc: "Zeitrahmen, Boxen, Runden, Wegweiser." },
  { id: "live-zaehler",    label: "Live-Zähler",      emo: "🔢", group: "team", phase: "laeuft", roles: ["headcoach", "coach", "teamaccess"], desc: "Tore zählen, Doppel-Zählung, VAR." },
  { id: "wertung",         label: "Wertung & Torschützen", emo: "⚽", group: "team", phase: "laeuft", roles: ["headcoach", "coach"], desc: "Tore erfassen (Einzel/Team, Phase 1/2) + Torschützen-Rangliste." },
  { id: "gesamtwertung",   label: "Gesamtwertung",    emo: "🏅", group: "team", phase: "laeuft", roles: ["headcoach", "coach", "public"], desc: "Tore + Fairplay + Aufgaben additiv." },
  { id: "fairplay",        label: "Fairplay",         emo: "🤝", group: "team", phase: "laeuft", roles: ["headcoach", "coach", "teamaccess"], desc: "7 Kriterien, rein positiv, Headcoach-geführt." },
  { id: "aufgaben",        label: "Aufgaben",         emo: "🎯", group: "team", phase: "laeuft", roles: ["headcoach", "coach", "teamaccess"], desc: "Aufgaben-Pool + Schwerpunkt-System." },
  { id: "headcoach-live",  label: "Headcoach-Live",   emo: "🎽", group: "team", phase: "laeuft", roles: ["headcoach"], desc: "Spieluhr, An-/Abpfiff, Runden verlängern/streichen." },
  { id: "showroom",        label: "Showroom (Beamer)", emo: "📽️", group: "team", phase: "abschluss", roles: ["headcoach"], desc: "Balken-Rennen → Podest → Fairplay → Highlights." },
  { id: "website",         label: "Website (öffentlich)", emo: "🌐", group: "team", phase: "abschluss", roles: ["headcoach", "coach", "public"], desc: "Öffentliche Team-Turnierseite." },
  { id: "siegerehrung",    label: "Siegerehrung",     emo: "🏆", group: "team", phase: "abschluss", roles: ["headcoach"], desc: "Medaillen für alle, Urkunde je Team, Sonderpreise." },
  // Einzel-KO / Tour - komplett eigenes Turnierformat mit eigenem Ablauf,
  // bewusst NICHT in die 3 Phasen einsortiert (siehe Stand 29). Fuer den
  // Headcoach ein eigener Umschalter "Teamturnier" / "Einzel-KO / Tour".
  { id: "aw-spieler",      label: "Mitspielende",     emo: "👥", group: "tour", roles: ["headcoach", "coach"], nurFormat: "afterwork", desc: "Firma + Name, Ticket." },
  { id: "aw-runde",        label: "Laufende Runde",   emo: "⚽", group: "tour", roles: ["headcoach", "coach"], nurFormat: "afterwork", desc: "Sieger bleibt · KO · Firmen-Teams." },
  { id: "aw-ehrung",       label: "Tages- & Firmenwertung", emo: "🏆", group: "tour", roles: ["headcoach", "coach", "public"], nurFormat: "afterwork", desc: "Wertung des Abends." },
  { id: "einzel-ko",       label: "Einzel-KO",        emo: "🥅", group: "tour", roles: ["headcoach", "coach"], desc: "Ohne Teams: spontane Namen, KO, Golden Goal." },
  { id: "tour-rangliste",  label: "Tour-Rangliste",   emo: "📊", group: "tour", roles: ["headcoach", "coach", "public"], desc: "Tour über mehrere Events, Tagessieger, Verlauf." },
  { id: "tour-website",    label: "Tour-Website",     emo: "🏊", group: "tour", roles: ["headcoach", "coach", "public"], desc: "Öffentliche Microsite je Tour." },
  { id: "siegerehrung-tour", label: "Siegerehrung Tour", emo: "🎖️", group: "tour", roles: ["headcoach"], desc: "Urkunde je Kind, Medaillen für alle." },
];
const GROUPS = { team: "Teamturnier", tour: "Einzel-KO / Tour", basis: "" };

// Stand 29: drei Turnierphasen fuer die Headcoach-Navigation (Nutzer-
// Feedback: die bisherige flache Liste aus 16 Buttons war "zu kleinteilig",
// man wusste nicht wo man anfangen soll). Nur fuer die Rolle Headcoach
// wirksam (Shell()) - Coach behaelt seine bereits reduzierte, sortierte
// Liste unveraendert.
const PHASES = [
  { id: "vorbereitung", label: "Vorbereitung", emo: "🧰", hint: "Teams, Zeitplan" },
  { id: "laeuft",       label: "Turnier läuft", emo: "⏱️", hint: "Zählen, werten, bewerten" },
  { id: "abschluss",    label: "Abschluss & Veröffentlichung", emo: "🏆", hint: "Siegerehrung, Showroom, Website" },
];
// Leitet die "gerade relevante" Phase rein aus vorhandener Wahrheit ab
// (kein neues Store-Feld noetig): noch nicht angepfiffen -> Vorbereitung;
// angepfiffen bzw. mind. eine Runde gespielt/gestrichen -> Turnier läuft
// (siehe tournamentStarted()); explizit abgeschlossen -> Abschluss &
// Veröffentlichung (identischer Status, der auch das Archiv befuellt).
function currentPhase(state) {
  if (state.tournament.status === "abgeschlossen") return "abschluss";
  if (tournamentStarted(state)) return "laeuft";
  return "vorbereitung";
}

// Phase-Erkennung (Basis fuer die reduzierte Coach-Navigation): ist das
// Turnier schon "live" unterwegs? Haengt bewusst NUR an der zentralen
// Live-Steuerung des Headcoach (Anpfiff/gespielte oder gestrichene Runde) -
// nicht an Nebenwirkungen wie irgendwo schon eingetragenen Toren. Der
// Headcoach gibt die naechste Phase also aktiv frei, indem er zentral
// Spiele startet. Rein abgeleitet, keine eigene Wahrheit noetig.
function tournamentStarted(state) {
  if (state.live && (state.live.running || state.live.angepfiffen)) return true;
  if (state.live && Array.isArray(state.live.rounds) && state.live.rounds.some((r) => r.done || r.skipped)) return true;
  return false;
}

// Aktueller Gegner im laufenden Live-Rundenplan (fuers Zaehl-Handy im
// Gegner-Modus, state.tournament.config.zaehlModus) -- abgeleitet aus
// DERSELBEN Paarungs-Wahrheit wie der Zeitplaner (roundRobin ueber alle
// Teams), keine zweite Paarungs-Datenbank. state.live kennt nur
// Runde/Dauer/Status, keine Teams -- die Paarung je Runde ergibt sich rein
// aus der Position im Rundenplan (derselbe Rundenplan wiederholt sich pro
// Durchgang/targetRR).
function currentOpponentTeamId(state, teamId) {
  const teams = state.teams;
  if (teams.length < 2 || !state.live || !Array.isArray(state.live.rounds) || !state.live.rounds.length) return null;
  const rr = wandRunden(teams.length, state.tournament.config.mode);
  if (!rr.length) return null;
  const idx = teams.findIndex((t) => t.id === teamId);
  if (idx < 0) return null;
  const within = ((state.live.cur % rr.length) + rr.length) % rr.length;
  const pairs = rr[within] || [];
  const pair = pairs.find((p) => p[0] === idx || p[1] === idx);
  if (!pair) return null; // Freilos in dieser Runde
  const oppIdx = pair[0] === idx ? pair[1] : pair[0];
  return teams[oppIdx] ? teams[oppIdx].id : null;
}

/* Stand 39 — Begegnungen je Runde mit fester Box-Nummer (Server und Geräte rechnen gleich).
   2 Teams/Box (mode "dauer"): jeder gegen jeden parallel, Box = Nummer der Paarung.
   4 Teams/Box (mode "aufgaben"): Gruppen zu je 4, jede Gruppe hat ihre Box; die 2 anderen Teams der Gruppe haben Pause. */
export function begegnungenDerRunde(state, idx) {
  const teams = (state && state.teams) || [];
  const n = teams.length;
  const mode = state && state.tournament && state.tournament.config ? state.tournament.config.mode : "aufgaben";
  if (n < 2) return { spiele: [], pausen: teams.map((t) => ({ teamId: t.id, box: null })) };
  const i0 = Math.max(0, Number(idx) || 0);
  const spiele = [], imSpiel = new Set(), boxVon = {};
  if (mode === "aufgaben") {
    const sizes = []; let left = n;
    while (left > 0) { const sz = Math.min(4, left); sizes.push(sz); left -= sz; }
    let off = 0;
    const gruppen = sizes.map((sz) => { const ms = roundRobin(sz).flat().map(([a, b]) => [a + off, b + off]); const g = { von: off, sz, ms }; off += sz; return g; });
    const anzahl = Math.max(1, ...gruppen.map((g) => g.ms.length));
    const r = i0 % anzahl;
    gruppen.forEach((g, gi) => {
      for (let k = g.von; k < g.von + g.sz; k++) boxVon[teams[k].id] = gi + 1;
      const m = g.ms[r];
      if (m) { spiele.push({ box: gi + 1, a: teams[m[0]].id, b: teams[m[1]].id }); imSpiel.add(teams[m[0]].id); imSpiel.add(teams[m[1]].id); }
    });
  } else {
    const rr = roundRobin(n);
    const pairs = rr.length ? rr[i0 % rr.length] : [];
    pairs.forEach((p, pi) => { spiele.push({ box: pi + 1, a: teams[p[0]].id, b: teams[p[1]].id }); imSpiel.add(teams[p[0]].id); imSpiel.add(teams[p[1]].id); });
  }
  const pausen = teams.filter((t) => !imSpiel.has(t.id)).map((t) => ({ teamId: t.id, box: boxVon[t.id] || null }));
  return { spiele, pausen };
}
// Wo spielt dieses Team in Runde idx? → { box, gegnerId } oder { pause: true, box }
export function spielVon(state, teamId, idx) {
  const b = begegnungenDerRunde(state, idx);
  const sp = b.spiele.find((x) => x.a === teamId || x.b === teamId);
  if (sp) return { box: sp.box, gegnerId: sp.a === teamId ? sp.b : sp.a };
  const pa = b.pausen.find((x) => x.teamId === teamId);
  return { pause: true, box: pa ? pa.box : null };
}
// Ist die Runde gerade zum Zählen offen? (Server-Uhr, gleiche Rechnung überall)
export function rundeOffen(state, jetzt) {
  const live = (state && state.live) || {};
  if (!live.running || !live.runStartedAt) return false;
  return Number(live.runStartedAt) + Number(live.runRemainingAtStart || 0) * 1000 > jetzt;
}
// Sind Ergebnisse schon aufgedeckt (Siegerehrung gestartet oder abgeschlossen)?
export function ergebnisseOffen(state) {
  const t = (state && state.tournament) || {};
  return t.status === "abgeschlossen" || !!t.wertungOffen || Number(t.enthStufe || 0) > 0;
}
const laufVon = (state) => Number((state.live && state.live.lauf) || 0);
const laufPasst = (state, action) => action.lauf == null || Number(action.lauf) === laufVon(state);

// Live-Kennzahl je Slot — beweist, dass jeder Baustein aus dem Store liest
function slotStat(id, s) {
  const kids = s.teams.reduce((n, t) => n + t.players.length, 0);
  const boxes = boxesNeeded(s.tournament.config.numTeams, s.tournament.config.mode);
  const standings = s.teams.map((t) => ({ t, sc: teamScore(t, s.factors) })).sort((a, b) => b.sc.total - a.sc.total);
  const scorers = s.teams.flatMap((t) => t.players).sort((a, b) => b.goals - a.goals);
  const stars = s.teams.reduce((n, t) => n + t.gallery.filter((g) => g.star).length, 0);
  switch (id) {
    case "team-verwaltung": return `${s.teams.length} Teams · ${kids} Kinder`;
    case "zeitplaner":      return `${boxes} Box${boxes > 1 ? "en" : ""} · ${roundRobin(s.tournament.config.numTeams).length} RR-Runden · ${s.tournament.config.targetRR}× jgj`;
    case "live-zaehler":    return `${s.teams.reduce((n, t) => n + t.devices.filter((d) => d.connected).length, 0)} Handys verbunden`;
    case "wertung":         return `Torschützen-Spitze: ${scorers[0]?.name || "—"} (${scorers[0]?.goals ?? 0} Tore)`;
    case "gesamtwertung":   return `Spitze: ${standings[0].t.name} · ${standings[0].sc.total} Pkt`;
    case "fairplay":        return `${s.fairplayCriteria.length} Kriterien · rein positiv`;
    case "aufgaben":        return `Pool: ${s.taskPool.length} · aktive Schwerpunkte: ${s.focusThemes.length}`;
    case "headcoach-live":  return `${s.live.rounds.length} Runden steuerbar`;
    case "showroom":        return `${stars} ⭐-Highlights markiert`;
    case "website":         return s.tournament.meta.title;
    case "siegerehrung":    return `${s.teams.length} Urkunden (jedes Team)`;
    case "einzel-ko":       return `${s.tour.kids.length} Teilnehmer:innen`;
    case "tour-rangliste":  return `${s.tour.name} · ${s.tour.events.length} Stationen`;
    case "tour-website":    return s.tour.name;
    case "siegerehrung-tour": return `${s.tour.kids.length} Urkunden (jedes Kind)`;
    default: return "";
  }
}

// Platzhalter-Ansicht je Baustein (bis die volle View eingesetzt wird)
// Team-bezogene Kennzahl je Slot (Teamzugang sieht nur das eigene Team)
function teamStat(id, team) {
  switch (id) {
    case "live-zaehler": return `Eure Tore bisher: ${team.tore + team.teamspielTore} (Teamspiel zählt doppelt)`;
    case "fairplay":     return `Eure Fairplay-Sterne: ${team.fpStars} ⭐`;
    case "aufgaben":     return `Eure erledigten Aufgaben: ${team.aufgabenDone}`;
    default:             return "";
  }
}

function SlotView({ meta }) {
  const { state } = useStore();
  const boundTeam = state.role === "teamaccess" ? state.teams.find((t) => t.id === state.boundTeamId) : null;
  const scoped = !!boundTeam;
  const stat = scoped ? teamStat(meta.id, boundTeam) : slotStat(meta.id, state);
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
        <span style={{ fontSize: 30 }}>{meta.emo}</span>
        <div>
          <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: 0 }}>{meta.label}</h2>
          <div style={{ fontSize: 13, color: C.sub }}>{meta.desc}</div>
        </div>
      </div>
      {scoped && (
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12, background: C.playSoft, border: `1px solid ${C.play}`, borderRadius: 12, padding: "10px 14px" }}>
          <span style={{ width: 30, height: 30, borderRadius: 8, background: boundTeam.color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>{boundTeam.emoji}</span>
          <span style={{ fontSize: 13.5, color: C.fair, fontWeight: 700 }}>Dein Team: {boundTeam.name} — du siehst nur euch.</span>
        </div>
      )}
      <Card>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
          <span style={{ background: C.playSoft, color: C.fair, borderRadius: 8, padding: "4px 10px", fontSize: 12.5, fontWeight: 700 }}>aus dem Store</span>
          <span style={{ fontFamily: display, fontWeight: 700, fontSize: 20 }}>{stat}</span>
        </div>
        <div style={{ fontSize: 13, color: C.sub, lineHeight: 1.5 }}>
          Slot bereit — die volle Oberfläche aus <code>{meta.id}.jsx</code> wird hier eingesetzt und liest/schreibt
          dann über denselben Store{scoped ? ", auf euer Team beschränkt" : " (keine eigenen Demo-Daten mehr)"}.
        </div>
        {!scoped && (
          <div style={{ marginTop: 12, fontSize: 12.5, color: C.sub }}>
            Sichtbar für: {meta.roles.map((r) => roleLabel(r).emo + " " + roleLabel(r).label.split(" ")[0]).join(" · ")}
          </div>
        )}
      </Card>
    </div>
  );
}

// Rollen-Login (leichtgewichtig): Operatoren + Teambeitritt (Team antippen) + offene Ansicht
// Stand 32 -- Nutzer-Vorgabe: "wir brauchen auch eine ordentliche startseite
// mit erklärung von der aus man sich dann einloggt bzw. die rolle auswählt
// bevor man reinkommt". Bewusst ein EIGENER, vorgeschalteter Schritt (nicht
// nur ein Absatz oben in Login()) -- wer den Link zum ersten Mal oeffnet
// (Eltern, ein Ersatz-Coach, Zuschauer:innen), soll zuerst verstehen, was
// das hier ueberhaupt ist, bevor die Rollen-Auswahl kommt. Gilt bewusst JEDES
// Mal, wenn gerade niemand eingeloggt ist (auch nach "Abmelden") -- siehe
// Gate() weiter unten -- nicht nur beim allerersten Besuch je Geraet.
function Startseite({ onContinue }) {
  const { state } = useStore();
  const nav = useEventNav();
  const meta = state.tournament.meta;
  const niceDate = meta.date
    ? (() => { try { return new Date(meta.date).toLocaleDateString("de-DE", { day: "numeric", month: "long", year: "numeric" }); } catch (_) { return meta.date; } })()
    : "";
  const fmt = formatById(meta.format);
  const heroSub = [fmt ? `${fmt.emo} ${fmt.label}` : null, niceDate, meta.ort].filter(Boolean).join(" · ");
  return (
    <div style={{ background: C.chalk, minHeight: "100%", fontFamily: font, color: C.ink }}>
      <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
      <div style={{ maxWidth: 560, margin: "0 auto", padding: "56px 20px" }}>
        {nav && (
          <button data-alle-events="true" onClick={nav.leave}
            style={{ border: "none", background: "none", color: C.sub, fontSize: 13.5, fontWeight: 700, cursor: "pointer", fontFamily: font, padding: 0, marginBottom: 14 }}>
            ← Alle Events
          </button>
        )}
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ display: "inline-flex", background: C.play, borderRadius: 18, padding: "16px 20px", boxShadow: "0 6px 20px rgba(39,166,97,.25)" }}>
            <img src={LOGO_WHITE} alt={BRAND} style={{ height: 44, width: "auto" }} />
          </div>
          <h1 style={{ fontFamily: display, fontWeight: 700, fontSize: 27, margin: "18px 0 4px" }}>{meta.title || BRAND}</h1>
          {heroSub && <div style={{ color: C.sub, fontSize: 14 }}>{heroSub}</div>}
        </div>

        <div style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 18, padding: "26px 22px" }}>
          <p style={{ fontSize: 15, lineHeight: 1.6, color: C.ink, margin: "0 0 18px" }}>
            Diese App begleitet euer Microsoccer-Turnier heute — von der
            Anmeldung bis zur Siegerehrung. Hier wird gezählt, Fairplay
            bewertet, es gibt Aufgaben zwischendurch, und alle Ergebnisse sind
            live einsehbar.
          </p>
          <div style={{ display: "grid", gap: 12, marginBottom: 22 }}>
            {[
              { emo: "🎽", text: "Headcoach & Coaches steuern das Turnier und die Boxen." },
              isSchlank(state)
                ? { emo: "⚽", text: "Gezählt werden die Tore — das macht der Coach direkt an der Box." }
                : { emo: "📱", text: "Teams zählen Tore, bewerten Fairplay und lösen Aufgaben — auf 1–2 Handys pro Team." },
              { emo: "🌐", text: "Alle anderen schauen einfach zu — live und ganz ohne Anmeldung." },
            ].map((row) => (
              <div key={row.text} style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
                <span style={{ fontSize: 20, lineHeight: 1.4 }}>{row.emo}</span>
                <span style={{ fontSize: 13.5, color: C.sub, lineHeight: 1.5, paddingTop: 2 }}>{row.text}</span>
              </div>
            ))}
          </div>
          <button onClick={onContinue}
            style={{ width: "100%", border: "none", background: C.play, color: "#fff", borderRadius: 12, padding: "15px 22px", fontSize: 15.5, fontWeight: 700, cursor: "pointer", fontFamily: display, letterSpacing: 0.5 }}>
            Los geht's →
          </button>
        </div>
      </div>
    </div>
  );
}

function CoachNameFrei({ onName }) {
  const [v, setV] = useState("");
  return (
    <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
      <input data-coach-name-frei value={v} onChange={(e) => setV(e.target.value)} placeholder="anderer Name" style={{ flex: 1, border: `1px solid ${C.line}`, borderRadius: 10, padding: "10px 12px", fontSize: 15, fontFamily: font }} />
      <button disabled={!v.trim()} onClick={() => onName(v.trim())} style={{ border: "none", background: v.trim() ? C.play : "#C7D3CC", color: "#fff", borderRadius: 10, padding: "0 16px", fontWeight: 700, cursor: v.trim() ? "pointer" : "default", fontFamily: font }}>Los</button>
    </div>
  );
}
function Login({ intent = null }) {
  const loginNav = useEventNav(); // Stand 37d: kein Sackgassen-Login
  const einstiegsCode = loginNav && loginNav.code; // Stand 37v
  const { state, dispatch, eventId, neuLaden } = useStore();
  const codeRef = useRef(""); // Stand 39: geprüfter Coach-Code (Notweg „Code + Name")
  const [bestaetige, setBestaetige] = useState(null); // Stand 39: { team, name } — „Bist du das?"
  // Stand 35: Absicht aus der Kachel-Uebersicht fuehrt direkt zum richtigen Schritt.
  const [mode, setMode] = useState(intent === "team" && !isSchlank(state) ? "team" : "choose"); // choose | team
  useEffect(() => {
    if (intent === "public") dispatch({ type: "setRole", role: "public" });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const [pending, setPending] = useState(null); // ausgewähltes Team (Bestätigung)

  const operators = [ROLES.headcoach, ROLES.coach];
  const [pinFor, setPinFor] = useState(intent === "coach" ? "coach" : null); // Rolle, für die gerade die PIN abgefragt wird
  const [pin, setPin] = useState("");
  const [pinErr, setPinErr] = useState("");
  const askPin = (roleKey) => { setPin(""); setPinErr(""); setPinFor(roleKey); };
  // Coach wird jetzt einem Team zugeordnet (Nachtrag Stand 30): nach der PIN
  // nicht mehr direkt einloggen, sondern erst "welcher Coach bist du" fragen
  // -- das Team ergibt sich daraus, welchem Team dieser Coach-Name in der
  // Team-Verwaltung zugeordnet ist (team.coach). Headcoach bleibt unveraendert
  // ungebunden (sieht/verwaltet ohnehin alles).
  const [coachPickMode, setCoachPickMode] = useState(false);
  const [coachPickErr, setCoachPickErr] = useState("");
  // Stand 39: Codes prüft der Server (das Handy kennt sie nicht mehr). Er gibt eine Sitzung für dieses Event zurück.
  // Headcoach- und Gast-Code: direkt hinein (Gast landet bei seinem Team). Gemeinsamer Coach-Code: Notweg mit Namen.
  const codePruefen = async (code, gewuenscht, erwartet = null) => {
    try {
      const s = await anmelden(eventId, { code });
      // PIN-Abfrage für eine bestimmte Rolle: ein anderer gültiger Code zählt dort nicht (z. B. Coach-Code statt Team-Code)
      const passt = !erwartet || s.rolle === erwartet || (erwartet === "coach" && s.rolle === "coach");
      if (!passt) { if (s.token) abmelden(eventId); if (gewuenscht) setPinErr("Falsche PIN."); return false; }
      if (s.rolle === "team") { setPending(null); setMode("team"); return true; }
      if (s.rolle === "headcoach") { await neuLaden(); dispatch({ type: "setRole", role: "headcoach" }); return true; }
      if (s.rolle === "coach" && s.personId) { await neuLaden(); dispatch({ type: "setRole", role: "coach", teamId: s.teamId || null }); return true; }
      if (s.rolle === "coach") { abmelden(eventId); codeRef.current = code; setCoachPickErr(""); setCoachPickMode(isSchlank(state) ? "name" : true); return true; }
    } catch (e) {
      if (gewuenscht) setPinErr(e && e.status === 429 ? "Zu viele falsche Codes — bitte später nochmal." : e && e.status === 423 ? "Dieses Event ist schon abgeschlossen." : "Falsche PIN.");
    }
    return false;
  };
  // Stand 37v: Code aus Link/Code-Feld einlösen -- genau wie die Code-Eingabe hier, nur ohne Tippen
  useEffect(() => {
    if (!einstiegsCode) return;
    codePruefen(einstiegsCode, false);
    if (loginNav && loginNav.codeVerbraucht) loginNav.codeVerbraucht();
  }, [einstiegsCode]); // eslint-disable-line react-hooks/exhaustive-deps
  const submitPin = async () => {
    const ok = await codePruefen(pin.trim(), true, pinFor);
    if (ok) { setPinFor(null); setPinErr(""); }
  };
  // Notweg: Name antippen → erst bestätigen („Du bist Coach von …"), dann anmelden
  const pickCoachTeam = (coachName) => {
    const team = state.teams.find((t) => (t.coach || "").trim() === coachName);
    if (!team) { setCoachPickErr(`${coachName} ist noch keinem Team zugeordnet — bitte beim Headcoach nachfragen.`); return; }
    setBestaetige({ team, name: coachName });
  };
  const coachBestaetigt = async () => {
    const { team, name } = bestaetige;
    try { await anmelden(eventId, { code: codeRef.current, name, personId: team.coachId || undefined }); } catch (_) { /* ohne Sitzung: zählen geht dann nicht */ }
    setBestaetige(null); setCoachPickMode(false);
    await neuLaden();
    dispatch({ type: "setRole", role: "coach", teamId: team.id });
  };

  // PIN-Abfrage für Operatoren (nur Berechtigte kommen rein)
  if (pinFor) {
    return (
      <div style={{ background: C.chalk, minHeight: "100%", fontFamily: font, color: C.ink }}>
        <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
        <div style={{ maxWidth: 420, margin: "0 auto", padding: "64px 20px", textAlign: "center" }}>
          <div style={{ fontSize: 30 }}>{(ROLES[pinFor] || ROLES.teamaccess).emo}</div>
          <h1 style={{ fontFamily: display, fontWeight: 700, fontSize: 22, margin: "10px 0 4px" }}>{pinFor === "team" ? "Team-Handy" : ROLES[pinFor].label}</h1>
          <p style={{ color: C.sub, fontSize: 13.5, margin: "0 0 18px" }}>PIN eingeben — nur Berechtigte kommen rein.</p>
          <input value={pin} onChange={(e) => { setPin(e.target.value); setPinErr(""); }}
            inputMode="numeric" maxLength={6} placeholder="••••"
            style={{ width: "100%", textAlign: "center", fontFamily: display, fontWeight: 700, fontSize: 30, letterSpacing: 8, padding: "12px 10px", border: `2px solid ${pinErr ? C.whistle : C.line}`, borderRadius: 12, color: C.ink, outline: "none" }} />
          {pinErr && <div style={{ color: C.whistle, fontSize: 13, marginTop: 8 }}>{pinErr}</div>}
          <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
            <button onClick={() => setPinFor(null)} style={{ flex: 1, border: `1px solid ${C.line}`, background: C.chalk, color: C.ink, borderRadius: 10, padding: "11px", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: font }}>Zurück</button>
            <button onClick={submitPin} style={{ flex: 2, border: "none", background: C.play, color: "#fff", borderRadius: 10, padding: "11px", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: display, letterSpacing: 0.5 }}>Anmelden</button>
          </div>
          {istDemoEvent(state)
            ? <div data-demo-pin style={{ fontSize: 12.5, color: C.ink, marginTop: 12, background: "#FFF4E0", borderRadius: 10, padding: "8px 10px" }}>🧪 Demo-Event · PIN: <b style={{ letterSpacing: 2 }}>{state.tournament.pins[pinFor]}</b></div>
            : <div style={{ fontSize: 11.5, color: C.sub, marginTop: 12 }}>{pinFor === "team" ? "Den Team-Code bekommt ihr von eurem Coach." : "Der Code gilt nur für dieses Event — du bekommst ihn vom Headcoach bzw. Büro."}</div>}
        </div>
      </div>
    );
  }

  // Coach: nach korrekter PIN erst "welcher Coach bist du" -- Team ergibt
  // sich daraus, welchem Team dieser Name zugeordnet ist (siehe Team-
  // Verwaltung, Feld "Coach"). Kein Name in der Liste ohne Team-Zuordnung
  // bedeutet: dieser Coach kann sich (noch) nicht einloggen.
  if (coachPickMode === "name") {
    // Stand 37d: schlanke Formate -- Coach ohne Team, nur der Name fuer Check-in/Einsatzzeit
    const namen = Array.from(new Set([...(state.roles.coaches || []), ...DEFAULT_COACH_NAMES]));
    const los = async (name) => {
      try { await anmelden(eventId, { code: codeRef.current, name: name || "" }); } catch (_) { /* weiter ohne Sitzung */ }
      dispatch({ type: "setRole", role: "coach" });
      dispatch({ type: "einsatz/checkin", id: uid(), rolle: "coach", name: name || "", at: Date.now() });
      setCoachPickMode(false);
    };
    return (
      <div style={{ background: C.chalk, minHeight: "100%", fontFamily: font, color: C.ink }}>
        <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
        <div data-coach-name-wahl="true" style={{ maxWidth: 460, margin: "0 auto", padding: "56px 20px", textAlign: "center" }}>
          <div style={{ fontSize: 30 }}>{ROLES.coach.emo}</div>
          <h1 style={{ fontFamily: display, fontWeight: 700, fontSize: 22, margin: "10px 0 4px" }}>Wer bist du?</h1>
          <p style={{ color: C.sub, fontSize: 13.5, margin: "0 0 16px" }}>Dein Name gilt als Check-in für deine Einsatzzeit.</p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center" }}>
            {namen.map((n) => <button key={n} data-coach-name={n} onClick={() => los(n)} style={{ border: `1px solid ${C.line}`, background: "#fff", borderRadius: 999, padding: "8px 14px", fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: font, color: C.ink }}>{n}</button>)}
          </div>
          <CoachNameFrei onName={los} />
          <div style={{ marginTop: 16 }}>
            <button onClick={() => setCoachPickMode(false)} style={{ border: "none", background: "none", color: C.sub, fontSize: 13.5, fontWeight: 700, cursor: "pointer", fontFamily: font }}>← Zurück</button>
          </div>
        </div>
      </div>
    );
  }
  if (bestaetige) {
    const tm = bestaetige.team;
    return (
      <div style={{ background: C.chalk, minHeight: "100%", fontFamily: font, color: C.ink }}>
        <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
        <div data-coach-bestaetigen="true" style={{ maxWidth: 420, margin: "0 auto", padding: "64px 20px", textAlign: "center" }}>
          <div style={{ width: 96, height: 96, borderRadius: 28, background: tm.color || C.play, display: "grid", placeItems: "center", fontSize: 52, margin: "0 auto 14px" }}>{tm.emoji || "⚽"}</div>
          <h1 style={{ fontFamily: display, fontWeight: 800, fontSize: 24, margin: "0 0 6px" }}>Du bist Coach von {tm.name}?</h1>
          <p style={{ color: C.sub, fontSize: 14, margin: "0 0 20px" }}>{bestaetige.name} · nur dieses Handy zählt dann für dein Team.</p>
          <button data-coach-ja onClick={coachBestaetigt} style={{ width: "100%", border: 0, borderRadius: 14, padding: 14, fontFamily: display, fontWeight: 800, fontSize: 18, color: "#fff", background: C.play, cursor: "pointer" }}>✅ Ja, das bin ich</button>
          <button data-coach-nein onClick={() => setBestaetige(null)} style={{ width: "100%", marginTop: 10, border: `1.5px solid ${C.line}`, borderRadius: 14, padding: 12, fontWeight: 700, fontSize: 15, background: "#fff", cursor: "pointer", fontFamily: font }}>Nein, zurück</button>
        </div>
      </div>
    );
  }
  if (coachPickMode) {
    const coachNames = state.roles.coaches;
    return (
      <div style={{ background: C.chalk, minHeight: "100%", fontFamily: font, color: C.ink }}>
        <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
        <div style={{ maxWidth: 460, margin: "0 auto", padding: "64px 20px", textAlign: "center" }}>
          <div style={{ fontSize: 30 }}>{ROLES.coach.emo}</div>
          <h1 style={{ fontFamily: display, fontWeight: 700, fontSize: 22, margin: "10px 0 4px" }}>Welcher Coach bist du?</h1>
          <p style={{ color: C.sub, fontSize: 13.5, margin: "0 0 18px" }}>Damit du nur dein eigenes Team siehst und verwaltest.</p>
          {coachNames.length === 0 ? (
            <p style={{ color: C.sub, fontSize: 13.5 }}>Es sind noch keine Coaches angelegt — bitte beim Headcoach nachfragen (Team-Verwaltung → Turnier-Rollen).</p>
          ) : (
            <div style={{ display: "grid", gap: 10 }}>
              {coachNames.map((name) => (
                <button key={name} onClick={() => pickCoachTeam(name)}
                  style={{ display: "flex", alignItems: "center", gap: 14, textAlign: "left", background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: "14px 16px", cursor: "pointer", fontFamily: font }}>
                  <span style={{ fontSize: 22 }}>🎽</span>
                  <span style={{ flex: 1, fontWeight: 700, fontSize: 16, color: C.ink }}>{name}</span>
                  <span style={{ color: C.play, fontFamily: display, fontWeight: 700, fontSize: 18 }}>→</span>
                </button>
              ))}
            </div>
          )}
          {coachPickErr && <div style={{ color: C.whistle, fontSize: 13, marginTop: 14 }}>{coachPickErr}</div>}
          <div style={{ marginTop: 18 }}>
            <button onClick={() => { setCoachPickMode(false); setCoachPickErr(""); }}
              style={{ border: "none", background: "none", color: C.sub, fontSize: 13.5, fontWeight: 700, cursor: "pointer", fontFamily: font }}>← Zurück</button>
          </div>
        </div>
      </div>
    );
  }

  // Turnier abgeschlossen: nur noch öffentliche Ansicht; Headcoach diskret zum Wiederöffnen
  if (state.tournament.status === "abgeschlossen") {
    return (
      <div style={{ background: C.chalk, minHeight: "100%", fontFamily: font, color: C.ink }}>
        <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
        <div style={{ maxWidth: 480, margin: "0 auto", padding: "64px 20px", textAlign: "center" }}>
          <div style={{ display: "inline-flex", background: C.play, borderRadius: 18, padding: "16px 20px", boxShadow: "0 6px 20px rgba(39,166,97,.25)" }}>
            <img src={LOGO_GREEN} alt={BRAND} style={{ height: 40, width: "auto" }} />
          </div>
          <h1 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: "18px 0 6px" }}>Turnier abgeschlossen</h1>
          <p style={{ color: C.sub, fontSize: 14.5, lineHeight: 1.55, margin: "0 auto 22px", maxWidth: 360 }}>
            {state.tournament.meta.title} ist abgeschlossen und im Archiv.
          </p>
          <div style={{ fontSize: 13.5, color: C.sub }}>Ergebnisse gibt es über den Gäste-QR/Link des Events.</div>
          <div style={{ marginTop: 22 }}>
            <button onClick={() => askPin("headcoach")}
              style={{ border: "none", background: "none", color: C.sub, fontSize: 12.5, fontWeight: 700, cursor: "pointer", textDecoration: "underline", fontFamily: font }}>
              Headcoach: Turnier verwalten / wieder öffnen
            </button>
          </div>
        </div>
      </div>
    );
  }

  const subtitle = mode === "team"
    ? (pending ? "Stimmt das?" : "Tippt euer Team an.")
    : "Wer bist du? Rein kommst du mit dem Code für dieses Event.";

  return (
    <div style={{ background: C.chalk, minHeight: "100%", fontFamily: font, color: C.ink }}>
      <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
      <div style={{ maxWidth: 560, margin: "0 auto", padding: "48px 20px" }}>
        {loginNav && (
          <button data-login-alle-events="true" onClick={loginNav.leave}
            style={{ border: "none", background: "none", color: C.sub, fontSize: 13.5, fontWeight: 700, cursor: "pointer", fontFamily: font, padding: 0, marginBottom: 14 }}>← Start</button>
        )}
        <div style={{ textAlign: "center", marginBottom: 26 }}>
          <div style={{ display: "inline-flex", background: C.play, borderRadius: 18, padding: "16px 20px", boxShadow: "0 6px 20px rgba(39,166,97,.25)" }}>
            <img src={LOGO_WHITE} alt={BRAND} style={{ height: 40, width: "auto" }} />
          </div>
          <h1 data-login-event-titel style={{ fontFamily: display, fontWeight: 700, fontSize: 26, margin: "16px 0 4px" }}>{state.tournament.meta.title || BRAND}</h1>
          <div style={{ color: C.sub, fontSize: 14 }}>{subtitle}</div>
        </div>

        {mode === "choose" && (
          <>
            <div style={{ display: "grid", gap: 10 }}>
              {/* Teamzugang: Team aus Liste wählen -- nur im Kontext Schule (Stand 35); Stand 37p: mit Team-Code */}
              {!isSchlank(state) && <button data-login-team onClick={() => { if (state.tournament.pins && state.tournament.pins.team) askPin("team"); else { setPending(null); setMode("team"); } }}
                style={{ display: "flex", alignItems: "center", gap: 14, textAlign: "left", background: C.playSoft, border: `1px solid ${C.play}`, borderRadius: 16, padding: "14px 16px", cursor: "pointer", fontFamily: font }}>
                <span style={{ fontSize: 26 }}>{ROLES.teamaccess.emo}</span>
                <span style={{ flex: 1 }}>
                  <span style={{ display: "block", fontWeight: 700, fontSize: 16, color: C.ink }}>Ich spiele mit · Team beitreten</span>
                  <span style={{ display: "block", fontSize: 12.5, color: C.sub, marginTop: 2 }}>{ROLES.teamaccess.hint}</span>
                </span>
                <span style={{ color: C.play, fontFamily: display, fontWeight: 700, fontSize: 18 }}>→</span>
              </button>}
              {operators.map((r) => (
                <button key={r.key} onClick={() => askPin(r.key)}
                  style={{ display: "flex", alignItems: "center", gap: 14, textAlign: "left", background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: "14px 16px", cursor: "pointer", fontFamily: font }}>
                  <span style={{ fontSize: 26 }}>{r.emo}</span>
                  <span style={{ flex: 1 }}>
                    <span style={{ display: "block", fontWeight: 700, fontSize: 16, color: C.ink }}>{r.label}</span>
                    <span style={{ display: "block", fontSize: 12.5, color: C.sub, marginTop: 2 }}>{r.hint}</span>
                  </span>
                  <span style={{ color: C.play, fontFamily: display, fontWeight: 700, fontSize: 18 }}>→</span>
                </button>
              ))}
            </div>

            {/* Stand 37p: Zuschauen nur ueber den Gaeste-QR/Link des Events (Nutzer-Entscheidung) */}
            <div data-login-zuschauen-hinweis style={{ textAlign: "center", marginTop: 18, fontSize: 13, color: C.sub, lineHeight: 1.5 }}>
              👀 Zuschauen? Scanne den QR-Code beim Event — dort siehst du Live-Tabelle und Ergebnisse.
            </div>
          </>
        )}

        {mode === "team" && !pending && (
          <>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: 10 }}>
              {state.teams.map((t) => (
                <button key={t.id} onClick={() => setPending(t)}
                  style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8, background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: "18px 12px", cursor: "pointer", fontFamily: font }}>
                  <span style={{ width: 46, height: 46, borderRadius: 12, background: t.color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}>{t.emoji}</span>
                  <span style={{ fontFamily: display, fontWeight: 700, fontSize: 17, color: C.ink, textAlign: "center", lineHeight: 1.1 }}>{t.name}</span>
                  {t.coach && <span style={{ fontSize: 11.5, color: C.sub }}>{t.coach}</span>}
                </button>
              ))}
            </div>
            <div style={{ textAlign: "center", marginTop: 16 }}>
              <button onClick={() => setMode("choose")} style={{ border: "none", background: "none", color: C.sub, fontSize: 13.5, fontWeight: 700, cursor: "pointer", fontFamily: font }}>← Zurück</button>
            </div>
          </>
        )}

        {mode === "team" && pending && (
          <div style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: 22, textAlign: "center" }}>
            <span style={{ width: 64, height: 64, borderRadius: 16, background: pending.color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 34 }}>{pending.emoji}</span>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: 24, marginTop: 12 }}>{pending.name}</div>
            {pending.coach && <div style={{ fontSize: 13.5, color: C.sub, marginTop: 2 }}>Coach: {pending.coach}</div>}
            <div style={{ fontSize: 13, color: C.sub, marginTop: 16, marginBottom: 8 }}>Als was tretet ihr bei?</div>
            <div style={{ display: "grid", gap: 8 }}>
              {[{ k: "zaehl", emo: "📱", label: "Zähl-Handy", desc: "Tore zählen + Fairplay" }, { k: "medien", emo: "📷", label: "Medien-Handy", desc: "Fotos/Videos für Aufgaben + Fairplay" }].map((f) => {
                const slot = pending.devices.find((d) => d.kind === f.k);
                const taken = slot && slot.connected;
                return (
                  <button key={f.k} disabled={taken}
                    onClick={() => dispatch({ type: "setRole", role: "teamaccess", teamId: pending.id, deviceKind: f.k, holder: geraetId() })}
                    style={{ display: "flex", alignItems: "center", gap: 12, textAlign: "left", background: taken ? C.chalk : C.playSoft, border: `1px solid ${taken ? C.line : C.play}`, borderRadius: 12, padding: "12px 14px", cursor: taken ? "not-allowed" : "pointer", opacity: taken ? 0.55 : 1, fontFamily: font }}>
                    <span style={{ fontSize: 22 }}>{f.emo}</span>
                    <span style={{ flex: 1 }}>
                      <span style={{ display: "block", fontWeight: 700, fontSize: 15, color: C.ink }}>{f.label}{taken ? " · belegt" : ""}</span>
                      <span style={{ display: "block", fontSize: 12, color: C.sub }}>{taken ? "Schon ein Handy verbunden. Falsch? Der Headcoach kann den Platz freigeben." : f.desc}</span>
                    </span>
                  </button>
                );
              })}
            </div>
            <div style={{ marginTop: 14 }}>
              <button onClick={() => setPending(null)}
                style={{ border: "none", background: "none", color: C.sub, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: font }}>← Anderes Team</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
// Rahmen: Kopf + Navigation + aktiver Slot
/* =====================================================================
   STAND 33: Hauptnavigation unten (Tab-Leiste wie in der Academy)
   Heute · Schule · Freizeit · Business · Ich — nur fuer Headcoach & Coach.
   Teamzugang (Station am Teamhandy) und oeffentliche Ansicht bleiben
   unveraendert ohne Tab-Leiste. Welches Format "heute" laeuft, steht in
   tournament.meta.format (EINE Wahrheit, synchronisiert wie Titel/Ort);
   welcher Tab gerade offen ist, ist reiner Geraete-UI-Zustand (lokal).
   Siehe KONZEPT-Ich-und-Event-App.md im MIC_APPS-Ordner.
   ===================================================================== */
// Stand 37: im Event nur noch Jetzt · Tabelle · Ich. Schule/Freizeit/Business
// gibt es nur in der Event-Uebersicht (Format wird beim Anlegen festgelegt).
const MAIN_TABS = [
  { id: "heute",   label: "Jetzt",   emo: "⚡" },
  { id: "tabelle", label: "Tabelle", emo: "📊" },
  { id: "ich",     label: "Ich",     emo: "★" },
];
const BEREICH_TABS = [
  { id: "heute",    label: "Heute",    emo: "⚽" },
  { id: "schule",   label: "Schule",   emo: "🏫" },
  { id: "freizeit", label: "Freizeit", emo: "🌳" },
  { id: "business", label: "Business", emo: "💼" },
];
// Matchday-Guide hat (noch) genau EIN Zuhause: das interne Tool am
// Apps-Portal. Hier nur verlinkt, nicht kopiert -- Eingliederung als
// echte Event-Art folgt spaeter (Konzept, Etappe "Vorlagen").
const MATCHDAY_GUIDE_URL = "https://apps.microsoccer.social/intern/matchday-guide/";
// kind: "team" = Teamturnier-Ablauf · "tour" = Einzel-KO / Tour-Ablauf ·
//       "link" = eigenes Tool (neuer Tab) · "bald" = Vorlage folgt
const FORMATE = [
  { id: "matchday",         bereich: "schule",   label: "Matchday-Guide",   emo: "🧩", kind: "link", href: MATCHDAY_GUIDE_URL, sub: "Stundenworkshop planen + Sozialsituationsrunde (Kartenspiel)." },
  { id: "fairplay-turnier", bereich: "schule",   label: "Fairplay-Turnier", emo: "🤝", kind: "team", tiefe: "voll", sub: "Teamturnier mit Fairplay-Wertung, Aufgaben, Siegerehrung und Website." },
  { id: "community-tour",   bereich: "freizeit", label: "Community Tour",   emo: "🏙️", kind: "tour", sub: "Mehrere Stationen, eine Tour-Rangliste über alle Termine." },
  { id: "freies-turnier",   bereich: "freizeit", label: "Freies Turnier",   emo: "⚽", kind: "team", sub: "Teamturnier ohne Schulrahmen — z. B. im Park oder Jugendzentrum." },
  { id: "kick-splash",      bereich: "freizeit", label: "Kick & Splash",    emo: "🏊", kind: "tour", sub: "Bädertour: spontane Namen, Einzel-KO, Tour-Rangliste." },
  { id: "geburtstag",       bereich: "freizeit", label: "Kindergeburtstag", emo: "🎂", kind: "team", ablauf: "birthday", sub: "Champions Birthday Experience: 4 Stunden mit Training, Team Draft, Champions Cup, Siegerehrung, Pressekonferenz & Party." },
  { id: "afterwork",        bereich: "business", label: "Afterwork",        emo: "🍻", kind: "tour", sub: "Spontan anmelden, KO-Runden, Rangliste — leichtgewichtig." },
  { id: "business-cup",     bereich: "business", label: "Business Cup",     emo: "🏆", kind: "team", sub: "Firmen-Teamturnier mit Showroom und Siegerehrung." },
];
const BEREICHE = {
  schule:   { title: "Schulformate",    intro: "Workshops und Turniere für Schulen — Verein, Fairplay und soziales Lernen im Mittelpunkt." },
  freizeit: { title: "Freizeitformate", intro: "Touren, freie Turniere und Feste — offen für alle, draußen und drinnen." },
  business: { title: "Businessformate", intro: "Afterwork und Firmenturniere — Teamgeist für Unternehmen." },
};
function formatById(id) { return FORMATE.find((f) => f.id === id) || null; }
// Stand 35 (Nachtrag) -- Grundregel: die volle Turnier-Tiefe (Team-Verwaltung,
// Coaches/Einladungen/Team-Handys, Fairplay-Punkte, Aufgaben, Gesamtwertung mit
// Bonus) gibt es NUR im Kontext Schule = Fairplay-Turnier. Alle anderen Formate
// sind "schlank": Teams nur mit Namen, Wertung nur Tore, der Coach zaehlt an der
// Box; Spielzeit, Runden und Boxen bleiben anpassbar. Ohne Format (Alt-Stand)
// bleibt alles voll, damit nichts verschwindet.
function isSchlank(state) {
  const f = formatById(state && state.tournament && state.tournament.meta && state.tournament.meta.format);
  return !!f && (f.kind === "team" || f.kind === "tour") && f.tiefe !== "voll";
}
const SCHUL_BAUSTEINE = ["fairplay", "aufgaben", "gesamtwertung"];
// Stand 36 -- Spannungsbogen (Nutzer-Vorgabe): Tore, Fairplay und Aufgaben
// werden erst bei der Siegerehrung zusammengefuehrt. Bis dahin sieht niemand
// ausser dem Headcoach die Gesamtwertung oder Fairplay-Rangliste; Website,
// Coaches und Teams sehen nur Tore. Enthuellt wird ueber "wertung/enthuellen"
// (Siegerehrung/Beamer/Jetzt) oder automatisch mit dem Abschluss.
function wertungVerborgen(state) {
  const t = state && state.tournament;
  if (!t || isSchlank(state)) return false; // schlank: Wertung = nur Tore, nichts zu verbergen
  return !t.wertungOffen && t.status !== "abgeschlossen";
}
/* ---------- Stand 36d: Enthüllung in 4 Stufen ----------
   Wahrheit: tournament.enthStufe (0 = noch nicht gestartet).
     1 = Zwischenstand Tore · 2 = + Aufgaben · 3 = Fairplay aufgedeckt (daneben,
     noch nicht verrechnet) · 4 = zusammengezählt → Endstand (wertungOffen).
   "wertung/stufe" { delta } blättert vor/zurück. Alle Geräte ziehen per Polling mit. */
// Stand 36e: nach den 3 Stufen wird der Endstand Platz fuer Platz von hinten
// aufgedeckt -> enthStufe 3 + k (k = aufgedeckte Plaetze), fertig bei 3 + n.
const ENTH_FIX = 3;
// Stand 37: Aufdecken gibt es in JEDEM Team-Format. Schlank (nur Tore) hat
// keine Vorstufen -> sofort Platz fuer Platz von hinten (enthFix = 0).
function enthFix(state) { return isSchlank(state) ? 0 : ENTH_FIX; }
function enthMax(state) { return enthFix(state) + Math.max(1, state.teams.length); }
const ENTH_TEXTE = {
  0: { titel: "🥁 Die große Enthüllung", sub: "Tore, Aufgaben und Fairplay — Schritt für Schritt.", knopf: "⚽ Zwischenstand Tore zeigen" },
  1: { titel: "⚽ Zwischenstand: Tore", sub: "So steht es nach allen Spielen. Aber das ist noch nicht alles …", knopf: "🎯 Aufgaben dazuzählen" },
  2: { titel: "🎯 + Aufgaben", sub: "Die gelösten Aufgaben sind dazugezählt. Und jetzt: Fairplay!", knopf: "🤝 Fairplay aufdecken" },
  3: { titel: "🤝 Fairplay", sub: "So fair war jedes Team. Was passiert, wenn wir zusammenzählen?", knopf: "✨ Zusammenzählen" },
};
function enthText(state, stufe) {
  const n = state.teams.length, max = enthMax(state), fix = enthFix(state);
  if (fix === 0) { // schlank: nur Tore, Platz fuer Platz
    if (stufe >= max) return { titel: "🏆 Endstand", sub: "Die Sieger stehen fest!", knopf: null };
    const naechster = n - stufe;
    const knopf = naechster === 1 ? "🏆 Und der Sieger ist …" : `Platz ${naechster} aufdecken`;
    if (stufe === 0) return { titel: "🥁 Wer hat gewonnen?", sub: "Wir decken von hinten auf — Platz für Platz.", knopf };
    return { titel: "✨ Der Endstand", sub: `Noch ${naechster} ${naechster === 1 ? "Platz" : "Plätze"} geheim …`, knopf };
  }
  if (stufe < ENTH_FIX) return ENTH_TEXTE[stufe];
  if (stufe >= max) return { titel: "🏆 Endstand", sub: "Tore + Aufgaben + Fairplay — die Sieger stehen fest!", knopf: null };
  const k = stufe - ENTH_FIX; const naechster = n - k;
  const knopf = naechster === 1 ? "🏆 Und der Sieger ist …" : `Platz ${naechster} aufdecken`;
  if (stufe === ENTH_FIX) return { ...ENTH_TEXTE[3], knopf: `✨ Zusammenzählen · Platz ${naechster} aufdecken` };
  return { titel: "✨ Der Endstand", sub: `Alles zusammengezählt — noch ${naechster} ${naechster === 1 ? "Platz" : "Plätze"} geheim …`, knopf };
}
function enthStufe(state) { return Math.min(enthMax(state), Math.max(0, Number(state.tournament.enthStufe) || 0)); }
// Steht die Enthuellung noch aus? (nicht abgeschlossen, nicht offen, Teams da)
function enthAusstehend(state) {
  const t = state && state.tournament;
  if (!t || state.teams.length < 1) return false;
  const f = formatById(t.meta && t.meta.format);
  if (f && f.kind !== "team") return false;
  return !t.wertungOffen && t.status !== "abgeschlossen";
}
function enthZeilen(state, stufe) {
  const fix = enthFix(state);
  return state.teams.map((t) => {
    const sc = teamScore(t, state.factors);
    const wert = fix === 0 ? sc.total : stufe <= 1 ? sc.base : stufe <= ENTH_FIX ? sc.base + sc.auf : sc.total;
    return { t, sc, wert };
  }).sort((a, b) => b.wert - a.wert);
}
// Zahl, die zum neuen Wert hochzählt (fuer das "Dazuzählen").
function useHochzaehlen(ziel, ms = 900) {
  const [wert, setWert] = useState(ziel);
  const vonRef = useRef(ziel);
  useEffect(() => {
    const von = vonRef.current;
    if (von === ziel) return;
    let raf; const t0 = performance.now();
    const step = (now) => {
      const p = Math.min(1, (now - t0) / ms);
      const v = Math.round(von + (ziel - von) * (1 - Math.pow(1 - p, 3)));
      setWert(v);
      if (p < 1) raf = requestAnimationFrame(step); else vonRef.current = ziel;
    };
    raf = requestAnimationFrame(step);
    return () => { cancelAnimationFrame(raf); vonRef.current = ziel; };
  }, [ziel, ms]);
  return wert;
}
function EnthZahl({ wert, groesse }) {
  const v = useHochzaehlen(wert);
  return <span style={{ fontFamily: display, fontWeight: 800, fontSize: groesse, minWidth: groesse * 1.4, textAlign: "right" }}>{v}</span>;
}
// Tabelle mit Umsortier-Animation (FLIP): jede Zeile gleitet an ihren neuen Platz.
function EnthTabelle({ stufe, dunkel, gross }) {
  const { state } = useStore();
  const zeilen = enthZeilen(state, stufe);
  const refs = useRef({});
  const posRef = useRef({});
  useLayoutEffect(() => {
    const neu = {};
    Object.entries(refs.current).forEach(([id, el]) => { if (el) neu[id] = el.getBoundingClientRect().top; });
    Object.entries(neu).forEach(([id, top]) => {
      const alt = posRef.current[id];
      const el = refs.current[id];
      if (alt != null && el && Math.abs(alt - top) > 2) {
        el.style.transition = "none";
        el.style.transform = `translateY(${alt - top}px)`;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          el.style.transition = "transform 1.1s cubic-bezier(.2,.8,.2,1)";
          el.style.transform = "";
        }));
      }
    });
    posRef.current = neu;
  });
  const fg = dunkel ? "#fff" : C.ink;
  const fs = gross ? { name: 26, zahl: 34, klein: 15, pad: "14px 16px", medal: 32 } : { name: 17, zahl: 22, klein: 12, pad: "9px 10px", medal: 22 };
  const meins = state.boundTeamId;
  const fix = enthFix(state);
  const nurTore = fix === 0;
  return (
    <div data-enth-tabelle={stufe} style={{ color: fg }}>
      <div style={{ display: "flex", gap: 10, padding: `0 ${gross ? 16 : 10}px 6px`, fontSize: fs.klein - 1, opacity: 0.75, fontWeight: 700 }}>
        <span style={{ width: fs.medal * 1.5 }} /><span style={{ flex: 1 }} />
        {!nurTore && <span style={{ width: fs.zahl * 1.5, textAlign: "right" }}>⚽</span>}
        {!nurTore && <span style={{ width: fs.zahl * 1.5, textAlign: "right" }}>🎯</span>}
        {!nurTore && <span style={{ width: fs.zahl * 1.6, textAlign: "right" }}>🤝</span>}
        <span style={{ width: fs.zahl * 1.8, textAlign: "right" }}>{nurTore ? "⚽ Tore" : "Summe"}</span>
      </div>
      {zeilen.map(({ t, sc, wert }, i) => {
        const platz = i + 1;
        const ende = stufe >= enthMax(state);
        const k = stufe - fix; // aufgedeckte Endstand-Plaetze von hinten
        if (stufe > fix && i < zeilen.length - k) {
          return (
            <div key={t.id} ref={(el) => { refs.current[t.id] = el; }} data-enth-verdeckt={platz}
              style={{ display: "flex", alignItems: "center", gap: 10, padding: fs.pad, borderRadius: 16, marginBottom: 8, background: dunkel ? "rgba(255,255,255,.05)" : C.chalk, border: dunkel ? "1px dashed rgba(255,255,255,.22)" : `1px dashed ${C.line}` }}>
              <span style={{ width: fs.medal * 1.5, textAlign: "center", fontFamily: display, fontWeight: 800, fontSize: fs.medal, opacity: 0.6 }}>{platz}.</span>
              <span style={{ flex: 1, fontFamily: display, fontWeight: 800, fontSize: fs.name, opacity: 0.35, letterSpacing: 4 }}>? ? ?</span>
            </div>
          );
        }
        const medal = ende ? (platz === 1 ? "🥇" : platz === 2 ? "🥈" : platz === 3 ? "🥉" : `${platz}.`) : `${platz}.`;
        const hell = dunkel ? (ende && platz === 1 ? "rgba(227,179,65,.22)" : "rgba(255,255,255,.08)") : (ende && platz === 1 ? "#FFF6DA" : "#fff");
        return (
          <div key={t.id} ref={(el) => { refs.current[t.id] = el; }} data-enth-zeile={t.id} data-enth-platz={platz}
            style={{ display: "flex", alignItems: "center", gap: 10, padding: fs.pad, borderRadius: 16, marginBottom: 8, background: hell,
              border: dunkel ? `1px solid ${ende && platz === 1 ? "#E3B341" : "rgba(255,255,255,.15)"}` : `1px solid ${C.line}`,
              outline: meins === t.id ? `3px solid ${C.play}` : "none", position: "relative" }}>
            <span style={{ width: fs.medal * 1.5, textAlign: "center", fontFamily: display, fontWeight: 800, fontSize: fs.medal }}>{medal}</span>
            <span style={{ flex: 1, minWidth: 0, display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: fs.name + 4 }}>{t.emoji}</span>
              <span style={{ fontFamily: display, fontWeight: 800, fontSize: fs.name, lineHeight: 1.05, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t.name}</span>
            </span>
            {!nurTore && <span style={{ width: fs.zahl * 1.5, textAlign: "right", fontSize: fs.klein + 3, opacity: 0.9 }}>{sc.base}</span>}
            {!nurTore && <span style={{ width: fs.zahl * 1.5, textAlign: "right", fontSize: fs.klein + 3, opacity: stufe >= 2 ? 0.9 : 0.35 }}>{stufe >= 2 ? `+${sc.auf}` : "–"}</span>}
            {!nurTore && <span data-enth-fp={stufe >= 3 ? "offen" : "zu"} style={{ width: fs.zahl * 1.6, textAlign: "right" }}>
              {stufe >= 3
                ? <span style={{ display: "inline-block", fontWeight: 800, fontSize: fs.klein + 4, color: dunkel ? "#9BE7BE" : C.play, animation: "msEnthIn .6s ease-out" }}>+{sc.fp}</span>
                : <span style={{ display: "inline-block", background: dunkel ? "rgba(255,255,255,.14)" : C.chalk, borderRadius: 8, padding: "2px 10px", fontWeight: 800, fontSize: fs.klein + 2 }}>?</span>}
            </span>}
            <span style={{ width: fs.zahl * 1.8, textAlign: "right" }}><EnthZahl wert={wert} groesse={fs.zahl} /></span>
          </div>
        );
      })}
    </div>
  );
}
// Grosse Show fuer den Headcoach (Beamer/Laptop).
function EnthuellungsShow({ onFertig, weiterText }) {
  const { state, dispatch } = useStore();
  const stufe = enthStufe(state);
  const txt = enthText(state, stufe);
  const fertig = stufe >= enthMax(state);
  const fix = enthFix(state);
  const goldKnopf = !fertig && state.teams.length - (stufe - fix) === 1 && stufe >= fix;
  return (
    <div data-enth-show="true" data-enth-stufe={stufe} style={{ background: `radial-gradient(circle at 50% 0%, #1F4A35 0%, ${C.ink} 60%)`, minHeight: "100vh", color: "#fff", fontFamily: font, padding: "22px 16px 60px" }}>
      <style>{`@import url('${FONT_IMPORT}'); @keyframes msEnthIn{from{opacity:0;transform:translateY(10px) scale(.9)}to{opacity:1;transform:none}} @keyframes msPop{0%{transform:scale(.6);opacity:0}60%{transform:scale(1.15);opacity:1}100%{transform:scale(1)}}`}</style>
      <div style={{ maxWidth: 820, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: 18 }}>
          <div style={{ fontSize: 12, letterSpacing: 2, opacity: 0.7, textTransform: "uppercase" }}>{state.tournament.meta.title}</div>
          {fix > 0 && <div style={{ display: "flex", gap: 6, justifyContent: "center", margin: "10px 0" }}>
            {[1, 2, 3, 4].map((s) => <i key={s} style={{ width: 34, height: 6, borderRadius: 3, background: (s <= 3 ? s <= stufe : fertig) ? C.play : s === 4 && stufe > ENTH_FIX ? "rgba(39,166,97,.5)" : "rgba(255,255,255,.2)" }} />)}
          </div>}
          {fix === 0 && <div style={{ height: 10 }} />}
          <div style={{ fontFamily: display, fontWeight: 800, fontSize: 40, lineHeight: 1.05 }}>{txt.titel}</div>
          <div style={{ fontSize: 15, opacity: 0.8, marginTop: 6 }}>{txt.sub}</div>
        </div>
        {stufe >= 1 ? <EnthTabelle stufe={stufe} dunkel gross /> : (
          <div style={{ textAlign: "center", fontSize: 80, margin: "30px 0", animation: "msPop 1s ease-out" }}>🥁</div>
        )}
        {fertig && <div style={{ textAlign: "center", fontSize: 54, margin: "6px 0", animation: "msPop .8s ease-out" }}>🎉🏆🎉</div>}
        <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 18, flexWrap: "wrap" }}>
          {!fertig && (
            <button data-aufdecken={stufe + 1} onClick={() => dispatch({ type: "wertung/stufe", delta: 1 })}
              style={{ border: 0, borderRadius: 18, padding: "18px 30px", fontFamily: display, fontWeight: 800, fontSize: 26, color: C.ink, background: goldKnopf ? "#E3B341" : "#fff", boxShadow: "0 6px 0 rgba(0,0,0,.35)", cursor: "pointer" }}>
              {txt.knopf}
            </button>
          )}
          {stufe > 0 && !fertig && (
            <button data-enth-zurueck onClick={() => dispatch({ type: "wertung/stufe", delta: -1 })} style={{ border: "1px solid rgba(255,255,255,.35)", background: "transparent", color: "#fff", borderRadius: 14, padding: "12px 16px", fontWeight: 700, cursor: "pointer", fontFamily: font }}>↩︎ einen Schritt zurück</button>
          )}
          {fertig && onFertig && (
            <button data-enth-weiter onClick={onFertig} style={{ border: 0, borderRadius: 18, padding: "16px 26px", fontFamily: display, fontWeight: 800, fontSize: 22, color: "#fff", background: C.play, boxShadow: "0 6px 0 #1E8A4F", cursor: "pointer" }}>{weiterText || "🥇 Weiter zu Urkunden & Medaillen"}</button>
          )}
        </div>
      </div>
    </div>
  );
}
// Fuer alle anderen (Team-Handys, Coaches, Website, Gaeste): live mitverfolgen.
function EnthuellungLive() {
  const { state } = useStore();
  const stufe = enthStufe(state);
  if (stufe === 0) return null;
  const txt = enthText(state, stufe);
  const max = enthMax(state);
  return (
    <div data-enth-live={stufe} style={{ maxWidth: 560, margin: "14px auto", padding: "0 12px", fontFamily: font }}>
      <style>{`@keyframes msEnthIn{from{opacity:0;transform:translateY(10px) scale(.9)}to{opacity:1;transform:none}}`}</style>
      <div style={{ fontSize: 12, fontWeight: 800, color: stufe >= max ? C.play : C.whistle, textTransform: "uppercase", letterSpacing: 0.8, margin: "0 0 4px" }}>{stufe >= max ? "🏆 Endstand" : "● Live-Enthüllung"}</div>
      <div style={{ fontFamily: display, fontWeight: 800, fontSize: 20, margin: "0 0 8px", color: C.ink }}>{txt.titel}</div>
      <EnthTabelle stufe={stufe} />
    </div>
  );
}

// Stand 37: Siegerehrung und Beamer beginnen mit dem Aufdecken -- in JEDEM
// Team-Format (schlank: nur Tore, Platz fuer Platz). Der Headcoach sieht die
// Show, bis er nach dem Endstand selbst auf "Weiter" tippt.
function MitEnthuellung({ children, weiterText }) {
  const { state } = useStore();
  const hc = state.role === "headcoach";
  const aus = enthAusstehend(state);
  const warAusstehend = useRef(aus);
  if (aus) warAusstehend.current = true;
  const [weiter, setWeiter] = useState(false);
  const [frueh, setFrueh] = useState(null); // Stand 37d: Aufdecken waehrend das Turnier noch laeuft?
  if (hc && aus && enthStufe(state) === 0 && jetztPhaseVon(state) !== "ende" && frueh !== "ja") {
    if (frueh === "nein") return <>{children}</>;
    return (
      <div data-enth-frueh="true" style={{ maxWidth: 520, margin: "20px auto", background: "#fff", border: `1px solid ${C.line}`, borderRadius: 20, padding: 20, textAlign: "center", fontFamily: font }}>
        <div style={{ fontSize: 38 }}>⏳</div>
        <b style={{ display: "block", fontSize: 18, margin: "6px 0 4px" }}>Das Turnier läuft noch</b>
        <div style={{ fontSize: 14, color: C.sub, lineHeight: 1.5, marginBottom: 14 }}>Das Aufdecken sehen sofort alle Handys und die Website. Normalerweise erst, wenn alle Spiele vorbei sind.</div>
        <div style={{ display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
          <button data-enth-frueh-nein onClick={() => setFrueh("nein")} style={{ ...J.ghost, flex: "none" }}>Nur vorbereiten (Urkunden …)</button>
          <button data-enth-frueh-ja onClick={() => setFrueh("ja")} style={{ ...J.ghost, flex: "none", color: C.whistle, borderColor: C.whistle }}>Trotzdem jetzt aufdecken</button>
        </div>
      </div>
    );
  }
  if (hc && (aus || (warAusstehend.current && !weiter))) {
    return <EnthuellungsShow weiterText={weiterText} onFertig={() => { warAusstehend.current = false; setWeiter(true); }} />;
  }
  if (!hc && wertungVerborgen(state)) return <EnthuellungsKarte />;
  return <>{children}</>;
}

function EnthuellungsKarte({ was = "die Siegerehrung" }) {
  const { state, dispatch } = useStore();
  const hc = state.role === "headcoach";
  // Stand 36c: Headcoach bekommt die grosse Show (Platz fuer Platz von hinten)
  if (hc) return <EnthuellungsShow />;
  if (enthStufe(state) > 0) return <EnthuellungLive />;
  return (
    <div data-enthuellung="true" style={{ maxWidth: 520, margin: "20px auto", background: C.ink, color: "#fff", borderRadius: 22, padding: "26px 20px", textAlign: "center", fontFamily: font }}>
      <div style={{ fontSize: 44 }}>🤫</div>
      <div style={{ fontFamily: display, fontWeight: 800, fontSize: 28, margin: "8px 0 6px" }}>Noch geheim!</div>
      <div style={{ fontSize: 14.5, opacity: 0.9, lineHeight: 1.5 }}>Tore, Fairplay und Aufgaben werden erst bei der Siegerehrung zusammengezählt — das ist der große Moment.</div>
      {hc && (
        <button data-enthuellen="true" onClick={() => dispatch({ type: "wertung/enthuellen" })}
          style={{ marginTop: 18, border: 0, borderRadius: 16, padding: "15px 22px", fontFamily: display, fontWeight: 800, fontSize: 21, color: "#fff", background: C.play, boxShadow: "0 6px 0 #1E8A4F", cursor: "pointer" }}>
          🎉 Wertung enthüllen
        </button>
      )}
      {hc && <div style={{ fontSize: 12, opacity: 0.7, marginTop: 10 }}>Danach sehen alle Geräte, die Website und der Beamer die Gesamtwertung.</div>}
      {!hc && <div style={{ fontSize: 13, opacity: 0.8, marginTop: 12 }}>Bis dahin zählt: Tore schießen, fair spielen, Aufgaben lösen. 💪</div>}
    </div>
  );
}

function BereichView({ bereich, currentFormatId, canPick, onPick, pickLabel = "Als heutiges Event wählen", nurAnsehen = false }) {
  const meta = BEREICHE[bereich];
  const items = FORMATE.filter((f) => f.bereich === bereich);
  return (
    <div style={{ maxWidth: 1000, margin: "0 auto", padding: "22px 20px 24px" }}>
      <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 22, margin: "0 0 4px" }}>{meta.title}</h2>
      <p style={{ color: C.sub, fontSize: 14, margin: "0 0 18px", lineHeight: 1.5 }}>{meta.intro}</p>
      <div style={{ display: "grid", gap: 12, gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))" }}>
        {items.map((f) => {
          const isNow = f.id === currentFormatId;
          const bald = f.kind === "bald";
          const action = f.kind === "link" ? "Öffnen ↗"
            : bald ? "Kommt bald"
            : isNow ? "Zu Heute →"
            : canPick ? pickLabel : nurAnsehen ? null : "Zu Heute →";
          const tot = nurAnsehen && !canPick && f.kind !== "link" && !isNow; // Stand 37o: ansehen ja, anlegen nur das Büro
          return (
            <button key={f.id} data-format={f.id} disabled={bald} onClick={() => onPick(f)}
              style={{ textAlign: "left", fontFamily: font, cursor: bald || tot ? "default" : "pointer", background: "#fff", color: C.ink,
                border: isNow ? `2px solid ${C.play}` : bald ? `2px dashed ${C.line}` : `1px solid ${C.line}`,
                opacity: bald ? 0.7 : 1, borderRadius: 16, padding: "16px 16px 14px", display: "flex", flexDirection: "column", gap: 8 }}>
              <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 28, lineHeight: 1 }}>{f.emo}</span>
                <span style={{ fontFamily: display, fontWeight: 700, fontSize: 17, flex: 1 }}>{f.label}</span>
                {isNow && <span style={{ background: C.play, color: "#fff", borderRadius: 999, padding: "3px 9px", fontSize: 11, fontWeight: 700 }}>heute</span>}
              </span>
              <span style={{ fontSize: 13.5, color: C.sub, lineHeight: 1.45 }}>{f.sub}</span>
              {action && <span style={{ fontSize: 13, fontWeight: 700, color: bald ? C.sub : C.play, marginTop: 2 }}>{action}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}

// Stand 37: "Ich" aufgeraeumt -- nur noch wer bin ich, Abmelden, Event wechseln.
// Codes und Gaeste-QR stehen jetzt in "Jetzt" (Vorbereitung) bzw. unter "Alle Werkzeuge".
const fmtUhr = (ms) => { const d = new Date(ms); return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`; };
const fmtDauer = (ms) => { const m = Math.max(0, Math.round(ms / 60000)); return `${Math.floor(m / 60)}:${String(m % 60).padStart(2, "0")} h`; };
function IchView({ role, boundTeam, onSettings, onLogout, buero = false }) {
  const r = buero ? { emo: "🗂️", label: "Büro (volle Rechte)" } : roleLabel(role);
  const evCtx = useEventNav();
  const { state } = useStore();
  const now = useMinuteTick();
  const einsaetze = state.einsaetze || [];
  const mein = einsaetze.find((e) => e.id === state.meinEinsatzId);
  const checkout = () => {
    if (mein && !mein.bis) {
      let ok = false;
      try { ok = window.confirm(`Check-out um ${fmtUhr(Date.now())}? Eingecheckt seit ${fmtUhr(mein.von)} (${fmtDauer(Date.now() - mein.von)}).`); } catch (_) { ok = false; }
      if (!ok) return;
    }
    onLogout();
  };
  const card = { background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: 16 };
  const btn = { border: `1.5px solid ${C.line}`, background: "#fff", color: C.ink, fontFamily: font, fontWeight: 700, fontSize: 14, padding: "12px 14px", borderRadius: 12, cursor: "pointer", textAlign: "left" };
  return (
    <div data-ich="true" style={{ maxWidth: 560, margin: "0 auto", padding: "22px 16px 24px", display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={{ ...card, display: "flex", alignItems: "center", gap: 12 }}>
        <span style={{ fontSize: 30 }}>{r.emo}</span>
        <span>
          <span style={{ display: "block", fontFamily: display, fontWeight: 700, fontSize: 18 }}>{r.label}</span>
          <span style={{ display: "block", fontSize: 13, color: C.sub }}>{boundTeam ? `Team: ${boundTeam.name}` : "Angemeldet auf diesem Gerät"}</span>
        </span>
      </div>
      {mein && (
        <div data-checkin={mein.bis ? "aus" : "ein"} style={{ ...card, display: "flex", alignItems: "center", gap: 12, borderColor: mein.bis ? C.line : C.play }}>
          <span style={{ fontSize: 26 }}>{mein.bis ? "🏁" : "✅"}</span>
          <span style={{ flex: 1 }}>
            <b style={{ display: "block", fontSize: 15 }}>{mein.bis ? `Ausgecheckt um ${fmtUhr(mein.bis)}` : `Eingecheckt seit ${fmtUhr(mein.von)}`}</b>
            <span style={{ fontSize: 13, color: C.sub }}>{mein.bis ? `Einsatz ${fmtDauer(mein.bis - mein.von)}` : `Bisher ${fmtDauer(now.getTime() - mein.von)} · Check-in war dein Login`}</span>
          </span>
        </div>
      )}
      <DeineAufgabe />
      <EventBeitraege role={role} />
      {evCtx && role === "headcoach" && <button style={btn} data-event-wechseln="true" onClick={() => {
        if (mein && !mein.bis) { let ok = true; try { ok = window.confirm("Zu einem anderen Event? Du bleibst in diesem Event eingecheckt, bis du hier auscheckst."); } catch (_) { ok = true; } if (!ok) return; }
        evCtx.leave();
      }}>🔑 Anderes Event (Code)</button>}
      {role === "headcoach" && <button style={btn} onClick={onSettings}>⚙️ Turnier-Einstellungen & Archiv</button>}
      <button data-checkout style={{ ...btn, ...(mein && !mein.bis ? { background: C.ink, color: "#fff", border: "none" } : {}) }} onClick={checkout}>{mein && !mein.bis ? "🏁 Check-out & abmelden" : "↩︎ Abmelden / Rolle wechseln"}</button>
      {role === "headcoach" && einsaetze.length > 0 && (
        <div data-einsaetze style={card}>
          <div style={{ fontSize: 11, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Wer ist im Einsatz</div>
          {einsaetze.map((e) => (
            <div key={e.id} style={{ display: "flex", gap: 8, fontSize: 13.5, padding: "4px 0", borderTop: `1px solid ${C.line}`, flexWrap: "wrap" }}>
              <span style={{ flex: 1 }}>{e.rolle === "headcoach" ? "🎽 Headcoach" : `🧢 ${e.name || "Coach"}`}{e.id === state.meinEinsatzId ? " (du)" : ""}</span>
              <span style={{ color: C.sub }}>{fmtUhr(e.von)}–{e.bis ? fmtUhr(e.bis) + (e.auto ? " (auto)" : "") : "jetzt"}</span>
              {e.verl && <span data-verl-info={e.verl.status} style={{ width: "100%", fontSize: 12, color: e.verl.status === "nein" ? C.whistle : C.sub }}>🔧 {verlGrund(e.verl.grund)} bis {fmtUhr(e.verl.bis)} · {e.verl.status === "ok" ? "✓ freigegeben" : e.verl.status === "nein" ? "✗ nicht freigegeben" : "wartet auf Freigabe"}</span>}
            </div>
          ))}
          <div style={{ marginTop: 8 }}><VerlFreigaben /></div>
        </div>
      )}
      <div data-ich-bald="true" style={{ fontSize: 12.5, color: C.sub, lineHeight: 1.5, border: `2px dashed ${C.line}`, borderRadius: 14, padding: "10px 12px" }}>
        Kommt mit dem gemeinsamen Login (Academy): 📅 Meine Einsätze · ⏱️ Meine Stunden · 📝 Erklärungen
      </div>
    </div>
  );
}

/* ---------- Stand 38: Bilder & Beiträge vom Event (Schnittstellen-Vertrag v1) ----------
   Headcoach/Coach laden Fotos hoch (Handy-tauglich), dazu Texte/Video-Links aus den Fairplay-Aufgaben.
   Alles geht an den Matchday-Server (Ausgangskorb) und von dort an den Playmaker-Eingang — nie direkt auf die Website.
   Der Eventtag hängt nie davon ab, ob der Playmaker erreichbar ist. */
const EINW = [["liegt_vor", "✅ liegt vor"], ["fehlt", "⛔ fehlt"], ["unklar", "❔ unklar"]];
const PM_STATUS = {
  eingegangen: ["📥 im Playmaker eingegangen", C.sub], in_pruefung: ["🔎 in Prüfung", C.sub], redaktion_empfohlen: ["🔎 von der Redaktion empfohlen", C.sub],
  freigegeben: ["✅ freigegeben", C.play], veroeffentlicht: ["🌐 veröffentlicht", C.play], abgelehnt: ["✋ abgelehnt", "#B23B3B"],
  zurueckgezogen: ["🚫 zurückgezogen", "#B23B3B"], quarantaene: ["⚠️ Playmaker: Quarantäne", "#B23B3B"],
};
function beitragStatus(b) {
  if (b.gesperrt) return ["🚫 zurückgezogen — gesperrt", "#B23B3B"];
  if (b.lokalStatus === "quarantaene") return ["⚠️ Quarantäne: " + (b.grund || "Datei fehlerhaft"), "#B23B3B"];
  if (b.pmStatus && PM_STATUS[b.pmStatus]) return [PM_STATUS[b.pmStatus][0] + (b.pmGrund ? " — " + b.pmGrund : ""), PM_STATUS[b.pmStatus][1]];
  const a = b.ausgang || {};
  if (a.status === "nicht_zugestellt") return ["📭 nicht zugestellt (7 Tage ohne Erfolg)", "#B23B3B"];
  if (a.status === "abgelehnt") return ["✋ vom Playmaker nicht angenommen" + (a.fehler ? " — " + a.fehler : ""), "#B23B3B"];
  if (a.status === "zugestellt") return ["📥 zugestellt", C.sub];
  return ["⏳ im Ausgang — wird gesendet", C.sub];
}
function BeitragBild({ eventId, b, zugang }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (b.art !== "bild" || b.gesperrt || b.lokalStatus !== "ok") return undefined;
    let weg = false, u = null;
    ladeBeitragBild(eventId, b.id, zugang).then((x) => { u = x; if (!weg) setUrl(x); }).catch(() => {});
    return () => { weg = true; if (u) try { URL.revokeObjectURL(u); } catch (_) { /* noop */ } };
  }, [eventId, b.id, b.art, b.gesperrt, b.lokalStatus]); // eslint-disable-line react-hooks/exhaustive-deps
  const box = { width: 64, height: 64, borderRadius: 10, flexShrink: 0, background: C.playSoft, display: "grid", placeItems: "center", fontSize: 24, overflow: "hidden" };
  if (b.art === "text") return <span style={box}>✍️</span>;
  if (b.art === "video") return <span style={box}>🎬</span>;
  if (!url) return <span style={box}>{b.gesperrt ? "🚫" : b.lokalStatus === "ok" ? "📷" : "⚠️"}</span>;
  return <img src={url} alt={b.bildunterschrift || "Foto vom Event"} style={{ ...box, objectFit: "cover" }} />;
}
function EventBeitraege({ role }) {
  const { state, eventId } = useStore();
  const [offen, setOffen] = useState(false);
  const [daten, setDaten] = useState(null); // { beitraege, einwilligung, bericht }
  const [fehler, setFehler] = useState("");
  const [laeuft, setLaeuft] = useState("");
  const [unterschrift, setUnterschrift] = useState("");
  const [aufgabe, setAufgabe] = useState(false);
  const [einwBild, setEinwBild] = useState(""); // "" = wie das Event
  const [extra, setExtra] = useState(null); // null | "text" | "video"
  const [extraText, setExtraText] = useState("");
  const dateiRef = useRef(null);
  const pins = (state.tournament && state.tournament.pins) || {};
  const zugang = { code: pins[role] || "" };
  const hc = role === "headcoach";
  const laden = useCallback(() => {
    if (!eventId) return;
    listeBeitraege(eventId, zugang).then((d) => { setDaten(d); setFehler(""); }).catch((e) => setFehler(e.serverMessage || "Bilder konnten nicht geladen werden (Netz?)"));
  }, [eventId, zugang.code]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { if (!offen) return undefined; laden(); const h = setInterval(laden, 30000); return () => clearInterval(h); }, [offen, laden]);
  if (!eventId || (role !== "headcoach" && role !== "coach")) return null;
  const evEinw = (daten && daten.einwilligung) || "fehlt";
  const meta = () => ({ bildunterschrift: unterschrift.trim(), einwilligung: einwBild || evEinw, tags: aufgabe ? ["fairplay-aufgabe"] : [] });
  const hochladen = async (files) => {
    const liste = Array.from(files || []);
    if (!liste.length) return;
    const fehl = [];
    for (let i = 0; i < liste.length; i++) {
      setLaeuft(`Lädt ${i + 1} von ${liste.length} …`);
      try { await sendeBild(eventId, liste[i], meta(), zugang); }
      catch (e) { fehl.push(`${liste[i].name}: ${e.serverMessage || "nicht geklappt"}`); }
    }
    setLaeuft(""); setUnterschrift(""); setFehler(fehl.join(" · ")); laden();
  };
  const sendeExtra = async () => {
    if (!extraText.trim()) return;
    setLaeuft("Sendet …");
    try {
      await sendeBeitrag(eventId, { typ: extra, ...(extra === "video" ? { url: extraText.trim() } : { text: extraText.trim() }), titel: unterschrift.trim(), einwilligung: einwBild || evEinw, tags: aufgabe ? ["fairplay-aufgabe"] : [] }, zugang);
      setExtra(null); setExtraText(""); setUnterschrift(""); setFehler("");
    } catch (e) { setFehler(e.serverMessage || "Senden hat nicht geklappt"); }
    setLaeuft(""); laden();
  };
  const setzeEinw = async (w) => { try { await setzeEventEinwilligung(eventId, w, zugang); laden(); } catch (e) { setFehler(e.serverMessage || "nicht gespeichert"); } };
  const erneut = async (id) => { try { await outboxErneut(eventId, id, zugang); laden(); } catch (e) { setFehler(e.serverMessage || "nicht geklappt"); } };
  const berichtNeu = async () => { try { await sendeBerichtNeu(eventId, zugang); laden(); } catch (e) { setFehler(e.serverMessage || "nicht geklappt"); } };
  const card = { background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: 16 };
  const chip = (on) => ({ border: `1.5px solid ${on ? C.play : C.line}`, background: on ? C.playSoft : "#fff", color: C.ink, borderRadius: 999, padding: "6px 11px", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: font });
  const klein = { border: `1px solid ${C.line}`, background: "#fff", borderRadius: 10, padding: "6px 10px", fontSize: 12.5, fontWeight: 700, cursor: "pointer", fontFamily: font };
  const beitraege = (daten && daten.beitraege) || [];
  const bericht = daten && daten.bericht;
  if (!offen) {
    return (
      <button data-beitraege-oeffnen onClick={() => setOffen(true)} style={{ ...card, display: "flex", alignItems: "center", gap: 12, cursor: "pointer", textAlign: "left", fontFamily: font, color: C.ink }}>
        <span style={{ fontSize: 26 }}>📷</span>
        <span style={{ flex: 1 }}>
          <b style={{ display: "block", fontSize: 15 }}>Bilder & Beiträge</b>
          <span style={{ fontSize: 13, color: C.sub }}>Fotos vom Event und Ergebnisse der Fairplay-Aufgaben ans Büro schicken</span>
        </span>
        <span style={{ color: C.sub }}>›</span>
      </button>
    );
  }
  return (
    <div data-beitraege="true" style={{ ...card, display: "flex", flexDirection: "column", gap: 10 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ fontSize: 22 }}>📷</span>
        <b style={{ flex: 1, fontSize: 15.5 }}>Bilder & Beiträge</b>
        <button style={klein} onClick={() => setOffen(false)}>schließen</button>
      </div>
      <div data-einwilligung-event={evEinw} style={{ fontSize: 13, color: C.sub, lineHeight: 1.45 }}>
        <b style={{ color: C.ink }}>Einwilligung (Fotos) für dieses Event:</b>{" "}
        {hc ? (
          <span style={{ display: "inline-flex", gap: 6, flexWrap: "wrap", marginTop: 4 }}>
            {EINW.map(([k, l]) => <button key={k} data-einw-event={k} onClick={() => setzeEinw(k)} style={chip(evEinw === k)}>{l}</button>)}
          </span>
        ) : <span>{(EINW.find((x) => x[0] === evEinw) || EINW[1])[1]}</span>}
        <div style={{ fontSize: 12, marginTop: 4 }}>Nichts geht ohne Prüfung im Büro hinaus. Ohne Einwilligung bleiben Fotos intern.</div>
      </div>
      <input data-bild-beschriftung value={unterschrift} onChange={(e) => setUnterschrift(e.target.value)} placeholder="Bildunterschrift (optional, keine Kindernamen)" maxLength={300}
        style={{ border: `1px solid ${C.line}`, borderRadius: 10, padding: "9px 11px", fontSize: 14.5, fontFamily: font }} />
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
        <button data-bild-aufgabe={aufgabe ? "ja" : "nein"} onClick={() => setAufgabe(!aufgabe)} style={chip(aufgabe)}>🤝 Fairplay-Aufgabe</button>
        <select data-bild-einw value={einwBild} onChange={(e) => setEinwBild(e.target.value)} style={{ ...klein, padding: "6px 8px" }}>
          <option value="">Einwilligung wie Event</option>
          {EINW.map(([k, l]) => <option key={k} value={k}>nur dieses: {l}</option>)}
        </select>
      </div>
      <input ref={dateiRef} data-bild-datei type="file" accept="image/jpeg,image/png,image/webp" multiple style={{ display: "none" }}
        onChange={(e) => { const f = e.target.files; hochladen(f).finally(() => { try { e.target.value = ""; } catch (_) { /* noop */ } }); }} />
      <button data-bild-hochladen disabled={!!laeuft} onClick={() => dateiRef.current && dateiRef.current.click()}
        style={{ border: 0, borderRadius: 14, padding: "13px 16px", fontFamily: display, fontWeight: 800, fontSize: 17, color: "#fff", background: C.play, boxShadow: "0 4px 0 #1E8A4F", cursor: laeuft ? "default" : "pointer", opacity: laeuft ? 0.6 : 1 }}>
        {laeuft || "📷 Fotos auswählen & hochladen"}
      </button>
      <div style={{ display: "flex", gap: 6 }}>
        <button data-beitrag-text onClick={() => { setExtra(extra === "text" ? null : "text"); setExtraText(""); }} style={chip(extra === "text")}>✍️ Text</button>
        <button data-beitrag-video onClick={() => { setExtra(extra === "video" ? null : "video"); setExtraText(""); }} style={chip(extra === "video")}>🎬 Video-Link</button>
      </div>
      {extra && (
        <div style={{ display: "flex", gap: 6 }}>
          {extra === "text"
            ? <textarea data-beitrag-eingabe value={extraText} onChange={(e) => setExtraText(e.target.value)} maxLength={2000} rows={3} placeholder="z. B. Ergebnis der Fairplay-Aufgabe (keine Kindernamen)" style={{ flex: 1, border: `1px solid ${C.line}`, borderRadius: 10, padding: 9, fontSize: 14, fontFamily: font }} />
            : <input data-beitrag-eingabe value={extraText} onChange={(e) => setExtraText(e.target.value)} placeholder="https://… (YouTube, Vimeo …)" style={{ flex: 1, border: `1px solid ${C.line}`, borderRadius: 10, padding: 9, fontSize: 14, fontFamily: font }} />}
          <button data-beitrag-senden onClick={sendeExtra} disabled={!!laeuft || !extraText.trim()} style={{ ...klein, background: C.play, color: "#fff", border: 0 }}>Senden</button>
        </div>
      )}
      {fehler && <div data-beitraege-fehler style={{ fontSize: 12.5, color: "#B23B3B", lineHeight: 1.4 }}>{fehler}</div>}
      {hc && bericht && bericht.fassung > 0 && (
        <div data-bericht={(bericht.ausgang && bericht.ausgang.status) || "-"} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 13, borderTop: `1px solid ${C.line}`, paddingTop: 8, flexWrap: "wrap" }}>
          <span style={{ flex: 1 }}>📝 Eventbericht · Fassung {bericht.fassung} · <span style={{ color: beitragStatus({ ...bericht, lokalStatus: "ok" })[1] }}>{beitragStatus({ ...bericht, lokalStatus: "ok" })[0]}</span></span>
          {bericht.ausgang && bericht.ausgang.status === "nicht_zugestellt" && <button style={klein} onClick={() => erneut(bericht.ausgang.id)}>erneut senden</button>}
          <button data-bericht-neu style={klein} onClick={berichtNeu}>aktualisieren</button>
        </div>
      )}
      <div data-beitraege-liste style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {beitraege.length === 0 && <div style={{ fontSize: 13, color: C.sub }}>Noch nichts hochgeladen.</div>}
        {beitraege.map((b) => {
          const [txt, farbe] = beitragStatus(b);
          return (
            <div key={b.id} data-beitrag={b.id} data-beitrag-status={b.gesperrt ? "gesperrt" : b.lokalStatus === "quarantaene" ? "quarantaene" : b.pmStatus || (b.ausgang && b.ausgang.status) || "wartet"}
              style={{ display: "flex", gap: 10, alignItems: "center", borderTop: `1px solid ${C.line}`, paddingTop: 8 }}>
              <BeitragBild eventId={eventId} b={b} zugang={zugang} />
              <span style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: "block", fontSize: 13.5, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {(b.tags || []).includes("fairplay-aufgabe") ? "🤝 " : ""}{b.bildunterschrift || b.titel || (b.art === "text" ? (b.text || "").slice(0, 60) : b.art === "video" ? b.url : "Foto")}
                </span>
                <span style={{ display: "block", fontSize: 12, color: farbe }}>{txt}</span>
                <span style={{ display: "block", fontSize: 11.5, color: C.sub }}>Einwilligung: {(EINW.find((x) => x[0] === b.einwilligung) || ["", b.einwilligung])[1]}</span>
              </span>
              {b.ausgang && b.ausgang.status === "nicht_zugestellt" && <button style={klein} onClick={() => erneut(b.ausgang.id)}>erneut</button>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

/* =====================================================================
   STAND 39 — TURNIERBETRIEB: Coach-Handy, Endsignal, Spielplan, Einsatzteam
   ===================================================================== */
// --- Ton: muss im Handy-Browser einmal durch einen Tipp freigeschaltet werden ---
let _audio = null;
function tonKontext() {
  try { if (!_audio) { const AC = window.AudioContext || window.webkitAudioContext; if (AC) _audio = new AC(); } if (_audio && _audio.state === "suspended") _audio.resume(); } catch (_) { _audio = null; }
  return _audio;
}
function tonAn() { try { return window.sessionStorage.getItem("microsoccer_ton") === "1"; } catch (_) { return false; } }
function spieleSignal(art = "ende") {
  const ac = tonKontext();
  try { if (navigator.vibrate) navigator.vibrate(art === "ende" ? [400, 120, 400, 120, 600] : [200]); } catch (_) { /* noop */ }
  if (!ac) return;
  const tone = art === "ende" ? [[880, 0, 0.25], [880, 0.35, 0.25], [660, 0.7, 0.7]] : art === "test" ? [[660, 0, 0.15], [880, 0.2, 0.25]] : [[520, 0, 0.3]];
  const t0 = ac.currentTime + 0.02;
  for (const [f, ab, dauer] of tone) {
    const o = ac.createOscillator(), g = ac.createGain();
    o.type = "square"; o.frequency.value = f;
    g.gain.setValueAtTime(0.0001, t0 + ab); g.gain.exponentialRampToValueAtTime(0.35, t0 + ab + 0.02); g.gain.exponentialRampToValueAtTime(0.0001, t0 + ab + dauer);
    o.connect(g); g.connect(ac.destination); o.start(t0 + ab); o.stop(t0 + ab + dauer + 0.05);
  }
}
function TonTesten() {
  const [an, setAn] = useState(tonAn());
  if (an) return null;
  return (
    <button data-ton-testen onClick={() => { spieleSignal("test"); try { window.sessionStorage.setItem("microsoccer_ton", "1"); } catch (_) { /* noop */ } setAn(true); }}
      style={{ width: "100%", display: "flex", alignItems: "center", gap: 10, background: "#FFF4E0", border: `2px solid ${C.brk}`, borderRadius: 16, padding: "12px 14px", marginBottom: 10, cursor: "pointer", fontFamily: font, textAlign: "left", color: C.ink }}>
      <span style={{ fontSize: 26 }}>🔊</span>
      <span style={{ flex: 1 }}><b style={{ display: "block", fontSize: 15 }}>Ton testen und aktivieren</b><span style={{ fontSize: 12.5, color: C.sub }}>Einmal antippen — dann pfeift dein Handy beim Spielende. Bildschirm bitte anlassen.</span></span>
    </button>
  );
}
// --- Endsignal: gemeinsame Endzeit (Server-Uhr) oder Stopp durch den Headcoach ---
function useEndsignal() {
  const { state } = useStore();
  const live = state.live || {};
  const key = `${live.lauf || 0}:${live.cur}:${live.runStartedAt || ""}`;
  const [anzeige, setAnzeige] = useState(null); // null | "ende" | "pause"
  const gemeldet = useRef(new Set());
  const vorher = useRef({ running: !!live.running, cur: live.cur, key });
  const melde = useCallback((k, art) => {
    if (gemeldet.current.has(k)) return;
    gemeldet.current.add(k); spieleSignal(art); setAnzeige(art);
    setTimeout(() => setAnzeige(null), art === "ende" ? 4500 : 2500);
  }, []);
  useEffect(() => { // Zeit abgelaufen (jedes Handy rechnet selbst mit der Server-Uhr)
    if (!live.running || !live.runStartedAt) return undefined;
    const ende = Number(live.runStartedAt) + Number(live.runRemainingAtStart || 0) * 1000;
    const t = setInterval(() => { if (serverJetzt() >= ende) melde(key, "ende"); }, 200);
    return () => clearInterval(t);
  }, [live.running, live.runStartedAt, live.runRemainingAtStart, key, melde]);
  useEffect(() => { // Stopp/Abpfiff/Pause kommt vom Headcoach
    const v = vorher.current;
    if (v.running && !live.running) {
      const rd = (live.rounds || [])[v.cur];
      const fertig = live.cur !== v.cur || (rd && (rd.done || rd.skipped)) || liveRemaining(live) <= 0;
      melde(v.key, fertig ? "ende" : "pause");
    }
    vorher.current = { running: !!live.running, cur: live.cur, key };
  }, [live.running, live.cur, key]); // eslint-disable-line react-hooks/exhaustive-deps
  return anzeige;
}
function EndsignalAnzeige({ art }) {
  if (!art) return null;
  return (
    <div data-endsignal={art} style={{ position: "fixed", inset: 0, zIndex: 300, background: art === "ende" ? "rgba(229,72,77,.94)" : "rgba(19,36,28,.88)", color: "#fff", display: "grid", placeItems: "center", textAlign: "center", padding: 24, fontFamily: display }}>
      <div><div style={{ fontSize: 80, lineHeight: 1 }}>{art === "ende" ? "🏁" : "⏸"}</div>
        <div style={{ fontWeight: 800, fontSize: 40, marginTop: 10 }}>{art === "ende" ? "SPIELENDE" : "UNTERBROCHEN"}</div>
        <div style={{ fontFamily: font, fontSize: 16, marginTop: 8, opacity: 0.9 }}>{art === "ende" ? "Keine Tore mehr zählen." : "Der Headcoach hat angehalten."}</div></div>
    </div>
  );
}
function useUhr(aktiv, ms = 300) {
  const [, f] = useState(0);
  useEffect(() => { if (!aktiv) return undefined; const t = setInterval(() => f((x) => x + 1), ms); return () => clearInterval(t); }, [aktiv, ms]);
}
function TeamMarke({ team, gross = false }) {
  if (!team) return null;
  const g = gross ? 56 : 34;
  return <span style={{ width: g, height: g, borderRadius: gross ? 18 : 11, background: team.color || C.play, display: "inline-grid", placeItems: "center", fontSize: gross ? 32 : 19, flexShrink: 0 }}>{team.emoji || "⚽"}</span>;
}

// --- Spielplan ohne Ergebnisse (Coaches, Teams, Öffentlichkeit bis zur Siegerehrung) ---
function SpielplanAnsicht({ eigeneTeamId = null }) {
  const { state } = useStore();
  const live = state.live || {};
  const rounds = live.rounds || [];
  const teams = state.teams;
  const byId = Object.fromEntries(teams.map((t) => [t.id, t]));
  const name = (id) => (byId[id] ? `${byId[id].emoji || ""} ${byId[id].name}` : "?");
  if (teams.length < 2 || !rounds.length) return <div style={{ ...J.card, color: C.sub, fontSize: 14 }}>Der Spielplan erscheint, sobald die Teams feststehen.</div>;
  const zeige = rounds.map((r, i) => ({ r, i })).filter(({ r, i }) => !(r.done || r.skipped) || i === live.cur);
  return (
    <div data-spielplan="true">
      <div style={{ fontFamily: display, fontWeight: 800, fontSize: 22, margin: "0 0 4px" }}>📋 Spielplan</div>
      <div style={{ fontSize: 13, color: C.sub, margin: "0 0 12px" }}>Ergebnisse gibt es erst bei der Siegerehrung. 🤫</div>
      {zeige.map(({ r, i }) => {
        const b = begegnungenDerRunde(state, i);
        const jetzt = i === live.cur;
        return (
          <div key={r.id || i} data-spielplan-runde={r.n} style={{ ...J.card, marginBottom: 8, borderColor: jetzt ? C.play : C.line, borderWidth: jetzt ? 2 : 1 }}>
            <div style={{ ...J.lbl, marginBottom: 6, color: jetzt ? C.play : C.sub }}>Runde {r.n}{jetzt ? (live.running ? " · läuft" : " · als Nächstes") : ""}</div>
            {b.spiele.map((sp) => (
              <div key={sp.box + sp.a} data-spielplan-box={sp.box} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 14, padding: "4px 0", fontWeight: sp.a === eigeneTeamId || sp.b === eigeneTeamId ? 800 : 500 }}>
                <span style={{ fontSize: 11.5, fontWeight: 800, color: C.sub, width: 46 }}>BOX {sp.box}</span>
                <span style={{ flex: 1 }}>{name(sp.a)}</span><span style={{ color: C.sub }}>gegen</span><span style={{ flex: 1, textAlign: "right" }}>{name(sp.b)}</span>
              </div>
            ))}
            {b.pausen.length > 0 && <div style={{ fontSize: 12.5, color: C.sub, marginTop: 4 }}>☕ Pause: {b.pausen.map((p) => name(p.teamId)).join(", ")}</div>}
          </div>
        );
      })}
    </div>
  );
}

// --- Check-in: Spieler, Logo, Farbe (Logo und Farbe gibt es nur einmal) ---
function TeamCheckin({ team }) {
  const { state, dispatch } = useStore();
  const [neu, setNeu] = useState("");
  const andere = state.teams.filter((t) => t.id !== team.id);
  const logosFrei = EMOJIS.filter((e) => e === team.emoji || !andere.some((t) => t.emoji === e));
  const farbenFrei = TEAM_COLORS.filter((c) => c === team.color || !andere.some((t) => t.color === c));
  const add = () => { if (neu.trim()) { dispatch({ type: "player/add", teamId: team.id, name: neu.trim() }); setNeu(""); } };
  return (
    <div data-team-checkin={team.id} style={{ ...J.card, marginBottom: 10 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
        <TeamMarke team={team} gross />
        <div style={{ flex: 1 }}><div style={J.lbl}>Check-in · dein Team</div><b style={{ fontSize: 18 }}>{team.name}</b></div>
      </div>
      <div style={{ ...J.lbl, marginBottom: 6 }}>Logo</div>
      <div data-logo-wahl style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 10 }}>
        {logosFrei.map((e) => <button key={e} data-logo={e} onClick={() => dispatch({ type: "team/patch", id: team.id, patch: { emoji: e } })}
          style={{ width: 40, height: 40, borderRadius: 12, border: `2px solid ${e === team.emoji ? C.ink : C.line}`, background: "#fff", fontSize: 21, cursor: "pointer" }}>{e}</button>)}
      </div>
      <div style={{ ...J.lbl, marginBottom: 6 }}>Farbe</div>
      <div data-farb-wahl style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 12 }}>
        {farbenFrei.map((c) => <button key={c} data-farbe={c} aria-label={c} onClick={() => dispatch({ type: "team/patch", id: team.id, patch: { color: c } })}
          style={{ width: 36, height: 36, borderRadius: "50%", border: c === team.color ? `3px solid ${C.ink}` : "3px solid #fff", boxShadow: `0 0 0 1px ${C.line}`, background: c, cursor: "pointer" }} />)}
      </div>
      <div style={{ ...J.lbl, marginBottom: 6 }}>Spieler:innen ({team.players.length})</div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 8 }}>
        {team.players.map((p) => <span key={p.id} data-spieler={p.name} style={{ display: "inline-flex", alignItems: "center", gap: 6, background: C.chalk, borderRadius: 999, padding: "5px 6px 5px 11px", fontSize: 13.5, fontWeight: 600 }}>
          {p.name}<button onClick={() => dispatch({ type: "player/remove", teamId: team.id, playerId: p.id })} aria-label={`${p.name} entfernen`} style={{ border: 0, background: "#fff", borderRadius: "50%", width: 22, height: 22, cursor: "pointer", color: C.sub }}>×</button></span>)}
      </div>
      <form onSubmit={(e) => { e.preventDefault(); add(); }} style={{ display: "flex", gap: 6 }}>
        <input data-spieler-neu value={neu} onChange={(e) => setNeu(e.target.value)} placeholder="Vorname" maxLength={40} style={{ flex: 1, border: `1px solid ${C.line}`, borderRadius: 10, padding: "9px 11px", fontSize: 15, fontFamily: font }} />
        <button data-spieler-add type="submit" style={{ border: 0, background: C.play, color: "#fff", borderRadius: 10, padding: "0 16px", fontWeight: 800, fontSize: 15, cursor: "pointer" }}>+</button>
      </form>
    </div>
  );
}

// --- Coach-Handy im Turnier: Box, Gegner, Tor-Knopf — alles automatisch aus dem Spielplan ---
function CoachSpiel() {
  const { state, eventId } = useStore();
  const team = state.teams.find((t) => t.id === state.boundTeamId);
  const live = state.live || {};
  const rounds = live.rounds || [];
  const lauf = Number(live.lauf || 0);
  useUhr(!!live.running, 250);
  const signal = useEndsignal();
  const [zahl, setZahl] = useState({ key: "", n: 0, offen: 0 });
  const [hinweis, setHinweis] = useState("");
  if (!team) return <div style={{ ...J.card, margin: 16 }}>Du bist noch keinem Team zugeordnet — bitte beim Headcoach melden.</div>;
  const cur = live.cur || 0;
  const round = rounds[cur];
  const allDone = rounds.length > 0 && rounds.every((r) => r.done || r.skipped);
  const offen = rundeOffen(state, serverJetzt());
  const gestartet = tournamentStarted(state);
  const sp = spielVon(state, team.id, cur);
  const gegner = sp.gegnerId ? state.teams.find((t) => t.id === sp.gegnerId) : null;
  const key = `${lauf}:${cur}:${sp.gegnerId || "-"}`;
  const amServer = round && round.zaehlung && round.zaehlung[team.id] && round.zaehlung[team.id].fuer === sp.gegnerId ? Number(round.zaehlung[team.id].n || 0) : 0;
  const z = zahl.key === key ? zahl : { key, n: amServer, offen: 0 };
  const anzeigeN = Math.max(z.n, amServer) + z.offen;
  const tor = async (delta) => {
    if (!offen || !gegner) return;
    if (delta < 0 && anzeigeN <= 0) return;
    setHinweis("");
    setZahl({ ...z, offen: z.offen + delta });
    try { if (navigator.vibrate) navigator.vibrate(40); } catch (_) { /* noop */ }
    try {
      const r = await zaehleTor(eventId, { runde: cur, lauf, delta });
      setZahl((alt) => (alt.key === key ? { key, n: r.n, offen: alt.offen - delta } : alt));
    } catch (e) {
      setZahl((alt) => (alt.key === key ? { ...alt, offen: alt.offen - delta } : alt));
      setHinweis(e.serverMessage || "Keine Verbindung — Tor nicht gezählt. Nochmal tippen.");
    }
  };
  const restSek = liveRemaining(live);
  const kopf = (
    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
      <TeamMarke team={team} />
      <div style={{ flex: 1 }}><div style={J.lbl}>Coach von</div><b style={{ fontSize: 16 }}>{team.name}</b></div>
      {round && <span style={{ fontSize: 12, fontWeight: 800, color: C.sub }}>Runde {round.n}/{rounds.length}</span>}
    </div>
  );
  const naechstes = (titel) => (
    <div data-naechstes-spiel={sp.pause ? "pause" : sp.box} style={{ background: C.ink, color: "#fff", borderRadius: 20, padding: 16, textAlign: "center", marginBottom: 10 }}>
      <div style={{ fontSize: 11, letterSpacing: 1.3, opacity: 0.75, textTransform: "uppercase" }}>{titel}</div>
      {sp.pause
        ? <><div style={{ fontFamily: display, fontWeight: 800, fontSize: 30, margin: "6px 0 2px" }}>☕ Spielpause</div><div style={{ fontSize: 14, opacity: 0.85 }}>{sp.box ? `Bleibt bei Box ${sp.box}.` : "Ihr setzt diese Runde aus."}</div></>
        : <><div style={{ fontFamily: display, fontWeight: 800, fontSize: 30, margin: "6px 0 2px" }}>Box {sp.box}</div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, fontSize: 17, fontWeight: 700 }}>gegen <TeamMarke team={gegner} /> {gegner ? gegner.name : "?"}</div></>}
    </div>
  );
  let body;
  if (state.tournament.status === "abgeschlossen" || allDone) {
    body = <div data-coach-phase="ende" style={{ ...J.card, textAlign: "center", padding: 20 }}><div style={{ fontSize: 40 }}>🥁</div><b style={{ fontSize: 18 }}>Alle Spiele sind vorbei</b><div style={{ fontSize: 14, color: C.sub, marginTop: 4 }}>Wer gewonnen hat, gibt es bei der Siegerehrung. Bring dein Team zusammen.</div></div>;
  } else if (offen) {
    body = (
      <div data-coach-phase="laeuft">
        <div style={{ textAlign: "center", fontSize: 13, fontWeight: 800, color: C.sub, marginBottom: 6 }}>⏱ noch {fmtClock(restSek)} · Box {sp.box || "–"}</div>
        {sp.pause || !gegner ? (
          <div data-coach-pause style={{ ...J.card, textAlign: "center", padding: 22 }}><div style={{ fontSize: 40 }}>☕</div><b style={{ fontSize: 18 }}>Dein Team hat Pause</b><div style={{ fontSize: 14, color: C.sub, marginTop: 4 }}>Nächste Runde gibt es wieder ein Spiel.</div></div>
        ) : (<>
          <div style={{ background: gegner.color || C.play, color: "#fff", borderRadius: 20, padding: 12, textAlign: "center", marginBottom: 10 }}>
            <div style={{ fontSize: 11, letterSpacing: 1.2, opacity: 0.92, textTransform: "uppercase" }}>Du zählst die Tore von</div>
            <div style={{ fontWeight: 800, fontSize: 19, marginTop: 2 }}>{gegner.emoji} {gegner.name}</div>
            <div data-coach-zahl style={{ fontFamily: display, fontWeight: 800, fontSize: 64, lineHeight: 1, marginTop: 4 }}>{anzeigeN}</div>
            <div style={{ fontSize: 12, opacity: 0.9 }}>in diesem Spiel</div>
          </div>
          <button data-coach-tor onClick={() => tor(1)} style={{ width: "100%", height: 200, borderRadius: 28, border: 0, background: gegner.color || C.play, color: "#fff", cursor: "pointer", fontFamily: display, fontWeight: 800, fontSize: 52, boxShadow: "0 8px 0 rgba(0,0,0,.18)" }}>
            ⚽ TOR<span style={{ display: "block", fontFamily: font, fontSize: 16, fontWeight: 800 }}>für {gegner.name}</span>
          </button>
          <button data-coach-undo onClick={() => tor(-1)} disabled={anzeigeN <= 0} style={{ ...J.ghost, width: "100%", marginTop: 10, opacity: anzeigeN > 0 ? 1 : 0.5 }}>↩︎ Letztes Tor zurücknehmen</button>
        </>)}
      </div>
    );
  } else {
    const unterbrochen = gestartet && round && !round.done && restSek > 0 && restSek < round.dur;
    body = (
      <div data-coach-phase={gestartet ? "zwischen" : "vor"}>
        {naechstes(unterbrochen ? "Unterbrochen · gleich geht's weiter" : gestartet ? "Als Nächstes" : "Dein erstes Spiel")}
        <div data-coach-gesperrt style={{ ...J.card, textAlign: "center", fontSize: 14, color: C.sub }}>🔒 Tore zählen geht erst, wenn der Headcoach die Runde startet.</div>
      </div>
    );
  }
  return (
    <div data-coach-spiel={team.id} style={{ maxWidth: 520, margin: "0 auto", padding: "14px 14px 30px", fontFamily: font, color: C.ink }}>
      <EndsignalAnzeige art={signal} />
      <TonTesten />
      {kopf}
      {body}
      {hinweis && <div data-coach-hinweis role="alert" style={{ marginTop: 10, background: "#FDECEC", color: "#B23B3B", borderRadius: 12, padding: "9px 12px", fontSize: 13.5, fontWeight: 700 }}>{hinweis}</div>}
      {!gestartet && state.tournament.status !== "abgeschlossen" && <div style={{ marginTop: 12 }}><TeamCheckin team={team} /></div>}
    </div>
  );
}

// --- Headcoach: Einsatzteam (aus Academy + Gäste) und Coach → Team ---
function EinsatzteamPanel() {
  const { state, dispatch, eventId, neuLaden } = useStore();
  const et = (state.tournament.meta && state.tournament.meta.einsatzteam) || { headcoach: null, coaches: [], gaeste: [] };
  const codes = (state.tournament.pins && state.tournament.pins.gaeste) || {};
  const [liste, setListe] = useState(null);
  const [suche, setSuche] = useState("");
  const [gast, setGast] = useState("");
  const [fehler, setFehler] = useState("");
  const [busy, setBusy] = useState(false);
  const alle = [...(et.coaches || []), ...(et.gaeste || [])];
  const speichern = async (neu) => {
    setBusy(true); setFehler("");
    try { await speichereEinsatzteam(eventId, neu); await neuLaden(); } catch (e) { setFehler(e.serverMessage || "Nicht gespeichert"); }
    setBusy(false);
  };
  const ladeListe = async () => { setFehler(""); try { setListe((await academyPersonen({ eventId })).personen || []); } catch (e) { setFehler(e.serverMessage || "Academy-Liste nicht erreichbar"); setListe([]); } };
  const treffer = (liste || []).filter((p) => !alle.some((c) => c.id === p.id) && (!suche.trim() || `${p.name} ${p.id}`.toLowerCase().includes(suche.trim().toLowerCase()))).slice(0, 12);
  const sel = { border: `1px solid ${C.line}`, borderRadius: 10, padding: "7px 9px", fontSize: 14, fontFamily: font, background: "#fff", maxWidth: "100%" };
  return (
    <div data-einsatzteam-panel style={{ ...J.card, marginBottom: 8, display: "flex", flexDirection: "column", gap: 10 }}>
      <div style={J.lbl}>🧢 Einsatzteam {et.headcoach ? `· Headcoach ${et.headcoach.name}` : ""}</div>
      {alle.length === 0 && <div style={{ fontSize: 13, color: C.sub }}>Noch niemand eingeteilt. Kommt normal aus dem Playmaker — oder hier aus der Academy-Liste wählen.</div>}
      {alle.map((c) => (
        <div key={c.id} data-einsatz-person={c.id} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14 }}>
          <span style={{ flex: 1 }}><b>{c.name}</b> <span style={{ color: C.sub, fontSize: 12 }}>{c.gast ? `Gast · Code ${codes[c.id] || "–"}` : c.id}</span></span>
          <button onClick={() => speichern({ coaches: (et.coaches || []).filter((x) => x.id !== c.id), gaeste: (et.gaeste || []).filter((x) => x.id !== c.id) })} disabled={busy}
            style={{ border: 0, background: "none", color: C.sub, cursor: "pointer", fontSize: 12.5, fontWeight: 700 }}>entfernen</button>
        </div>
      ))}
      <div style={{ borderTop: `1px solid ${C.line}`, paddingTop: 8 }}>
        <div style={{ ...J.lbl, marginBottom: 6 }}>Coach → Team</div>
        {state.teams.map((t) => (
          <div key={t.id} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
            <TeamMarke team={t} /><span style={{ flex: 1, fontWeight: 700, fontSize: 14 }}>{t.name}</span>
            <select data-coach-fuer={t.id} value={t.coachId || ""} style={sel}
              onChange={(e) => { const p = alle.find((x) => x.id === e.target.value); dispatch({ type: "team/coachSetzen", teamId: t.id, personId: p ? p.id : null, name: p ? p.name : "" }); }}>
              <option value="">— niemand —</option>
              {alle.map((c) => <option key={c.id} value={c.id}>{c.name}{state.teams.some((x) => x.id !== t.id && x.coachId === c.id) ? " (anderes Team)" : ""}</option>)}
            </select>
          </div>
        ))}
      </div>
      <div style={{ borderTop: `1px solid ${C.line}`, paddingTop: 8, display: "flex", flexDirection: "column", gap: 6 }}>
        {liste === null
          ? <button data-academy-liste onClick={ladeListe} style={J.ghost}>🎓 Coach aus der Academy hinzufügen</button>
          : <>
            <input data-academy-suche value={suche} onChange={(e) => setSuche(e.target.value)} placeholder="Name oder MS-Nummer suchen" style={{ ...sel, padding: "9px 11px" }} />
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {treffer.map((p) => <button key={p.id} data-academy-person={p.id} disabled={busy} onClick={() => speichern({ coaches: [...(et.coaches || []), { id: p.id, name: p.name }] })}
                style={{ border: `1px solid ${C.line}`, background: "#fff", borderRadius: 999, padding: "6px 11px", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: font }}>+ {p.name} <span style={{ color: C.sub, fontWeight: 600 }}>{p.id}</span></button>)}
              {treffer.length === 0 && <span style={{ fontSize: 12.5, color: C.sub }}>Keine Treffer.</span>}
            </div>
          </>}
        <form onSubmit={(e) => { e.preventDefault(); if (gast.trim()) { speichern({ gaeste: [...(et.gaeste || []), { name: gast.trim() }] }); setGast(""); } }} style={{ display: "flex", gap: 6 }}>
          <input data-gast-name value={gast} onChange={(e) => setGast(e.target.value)} placeholder="+ Gast (ohne Academy), Name" maxLength={60} style={{ ...sel, flex: 1, padding: "9px 11px" }} />
          <button data-gast-add type="submit" disabled={busy || !gast.trim()} style={{ border: 0, background: C.play, color: "#fff", borderRadius: 10, padding: "0 14px", fontWeight: 800, cursor: "pointer" }}>+</button>
        </form>
        <div style={{ fontSize: 12, color: C.sub }}>Gäste melden sich mit ihrem Code an (Startseite „Code“) und landen direkt bei ihrem Team.</div>
      </div>
      {fehler && <div style={{ color: "#B23B3B", fontSize: 13 }}>{fehler}</div>}
    </div>
  );
}
// --- Headcoach: Probelauf zurücksetzen ---
function ProbelaufZuruecksetzen() {
  const { state, dispatch } = useStore();
  if (state.role !== "headcoach" || state.tournament.status === "abgeschlossen" || !tournamentStarted(state)) return null;
  return (
    <button data-probelauf-zurueck onClick={() => {
      let ok = false;
      try { ok = window.confirm("Probelauf zurücksetzen?\n\nAlle Spielstände dieses Turniers werden auf 0 gesetzt, das Turnier steht wieder vor Runde 1.\nTeams, Spieler:innen, Logos, Farben und Coach-Zuordnungen bleiben.\nAndere Turniere sind nicht betroffen."); } catch (_) { ok = false; }
      if (!ok) return;
      try { ok = window.prompt("Zum Bestätigen bitte NULL eintippen:") === "NULL"; } catch (_) { ok = false; }
      if (ok) dispatch({ type: "turnier/probelaufZurueck" });
    }} style={{ display: "block", margin: "16px auto 0", border: `1.5px solid ${C.whistle}`, background: "#fff", color: C.whistle, borderRadius: 12, padding: "9px 14px", fontSize: 13.5, fontWeight: 800, cursor: "pointer", fontFamily: font }}>🔄 Probelauf zurücksetzen (Stände auf 0)</button>
  );
}

// Stand 37: "Tabelle" -- haelt den Spannungsbogen ein (bis zum Aufdecken nur Tore).
function TabelleView() {
  const { state } = useStore();
  const f = formatById(state.tournament.meta && state.tournament.meta.format);
  if (f && f.id === "afterwork") return <div style={{ maxWidth: 560, margin: "0 auto", padding: "16px 14px 40px" }}><AwWertung /></div>;
  if (f && f.kind === "tour") return <div style={{ maxWidth: 1000, margin: "0 auto", padding: "22px 20px 60px" }}><TourRangliste /></div>;
  const stufe = enthStufe(state);
  const aus = enthAusstehend(state);
  const wrap = (inner) => <div data-tabelle="true" style={{ maxWidth: 560, margin: "0 auto", padding: "16px 14px 40px", fontFamily: font, color: C.ink }}>{inner}</div>;
  if (state.teams.length === 0) return wrap(<div style={{ ...J.card, color: C.sub, fontSize: 14 }}>Noch keine Teams.</div>);
  if (aus && stufe > 0) return wrap(<EnthuellungLive />);
  // Stand 39: Ergebnisse sieht vor der Siegerehrung nur der Headcoach
  if (state.role !== "headcoach" && !ergebnisseOffen(state)) return wrap(<SpielplanAnsicht eigeneTeamId={state.boundTeamId} />);
  const nurTore = aus && !isSchlank(state); // Fairplay-Turnier vor dem Aufdecken
  const zeilen = state.teams.map((t) => { const sc = teamScore(t, state.factors); return { t, sc, wert: nurTore ? sc.base : sc.total }; })
    .sort((a, b) => b.wert - a.wert);
  const ende = !aus;
  return wrap(<>
    <div style={{ fontFamily: display, fontWeight: 800, fontSize: 22, margin: "0 0 4px" }}>{ende ? "🏆 Endstand" : "⚽ Tabelle"}</div>
    <div style={{ fontSize: 13, color: C.sub, margin: "0 0 12px" }}>
      {nurTore ? "Nur Tore. Fairplay und Aufgaben kommen erst bei der Siegerehrung dazu. 🤫" : ende ? "Aufgedeckt bei der Siegerehrung." : "Tore aus allen Spielen. Wer gewinnt, wird bei der Siegerehrung aufgedeckt."}
    </div>
    {zeilen.map(({ t, sc, wert }, i) => (
      <div key={t.id} data-tabelle-zeile={t.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 14, marginBottom: 7, background: "#fff", border: `1px solid ${C.line}`, outline: state.boundTeamId === t.id ? `3px solid ${C.play}` : "none" }}>
        <span style={{ width: 30, textAlign: "center", fontFamily: display, fontWeight: 800, fontSize: 18 }}>{ende && i < 3 ? ["🥇", "🥈", "🥉"][i] : `${i + 1}.`}</span>
        <span style={{ fontSize: 20 }}>{t.emoji}</span>
        <span style={{ flex: 1, minWidth: 0, fontWeight: 700, fontSize: 15, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t.name}</span>
        <span style={{ fontFamily: display, fontWeight: 800, fontSize: 22 }}>{wert}</span>
        <span style={{ fontSize: 11, color: C.sub, width: 30 }}>{nurTore || isSchlank(state) ? "Tore" : "Pkt"}</span>
      </div>
    ))}
  </>);
}

function MainTabBar({ tab, onTab, tabs = MAIN_TABS }) {
  return (
    <nav aria-label="Hauptnavigation" data-tabbar="true"
      style={{ position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 30, background: "#fff", borderTop: `1px solid ${C.line}`, boxShadow: "0 -8px 24px -18px rgba(0,0,0,.4)" }}>
      <div style={{ maxWidth: 640, margin: "0 auto", display: "grid", gridTemplateColumns: `repeat(${tabs.length}, 1fr)`, padding: "6px 6px calc(6px + env(safe-area-inset-bottom, 0px))" }}>
        {tabs.map((t) => {
          const on = t.id === tab;
          return (
            <button key={t.id} data-tab={t.id} aria-current={on ? "page" : undefined} onClick={() => onTab(t.id)}
              style={{ border: 0, background: on ? C.playSoft : "none", color: on ? C.ink : C.sub, borderRadius: 12, padding: "6px 0", display: "flex", flexDirection: "column", alignItems: "center", gap: 2, fontFamily: font, fontSize: 11.5, fontWeight: 700, cursor: "pointer" }}>
              <span style={{ fontSize: 20, lineHeight: 1, filter: on ? "none" : "grayscale(1)", opacity: on ? 1 : 0.7 }}>{t.emo}</span>
              {t.label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}

function Shell() {
  const { state, dispatch, reopen } = useStore();
  const eventNav = useEventNav();
  const role = state.role;
  // Stand 34: Wieder oeffnen ueber den Server (Headcoach-PIN dieses Events).
  const reopenHere = async () => {
    try {
      await reopen({ pin: state.tournament.pins.headcoach });
      // Stand 37 (Nutzer-Vorgabe): nach dem Wieder-Oeffnen landet der Headcoach bei der Siegerehrung.
      const fm = formatById(state.tournament.meta && state.tournament.meta.format);
      dispatch({ type: "setView", view: fm && fm.kind === "tour" ? "siegerehrung-tour" : "siegerehrung" });
      setFokus(null); setVonJetzt(true); setWerkzeuge(true); setMainTab("heute");
      dispatch({ type: "einsatz/lokalNeu" }); // Stand 37d: nach Wieder-Oeffnen neu einchecken
    }
    catch (err) { try { window.alert("Wieder öffnen hat nicht geklappt: " + (err.serverMessage || err.message)); } catch (_) { /* noop */ } }
  };
  // Abschliessen / Wieder oeffnen -- EIN Block, im Teamturnier in der Phase
  // "Abschluss & Veroeffentlichung", bei Tour-Formaten unter den Tour-Bausteinen.
  const abschlussLeise = enthAusstehend(state) || ((formatById(state.tournament.meta && state.tournament.meta.format) || {}).kind === "tour" ? tourPhaseVon(state) !== "ende" : jetztPhaseVon(state) !== "ende");
  const abschlussBlock = (
    <div data-abschluss-status="true" style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", borderTop: `1px solid ${C.line}`, paddingTop: 10 }}>
      {state.tournament.status === "abgeschlossen"
        ? <button onClick={reopenHere} style={{ border: `1.5px solid ${C.play}`, background: "#fff", color: C.play, borderRadius: 10, padding: "9px 14px", fontSize: 13.5, fontWeight: 700, cursor: "pointer", fontFamily: font }}>🔓 Turnier wieder öffnen</button>
        : <button data-abschliessen onClick={() => {
            // Stand 37: erst aufdecken, dann abschliessen -- sonst ist der Spannungsbogen weg
            const laeuftNoch = (formatById(state.tournament.meta && state.tournament.meta.format) || {}).kind === "tour" ? tourPhaseVon(state) !== "ende" : jetztPhaseVon(state) !== "ende";
            if (laeuftNoch) {
              let ok = false;
              try { ok = window.confirm("Das Turnier läuft noch (nicht alle Spiele fertig). Trotzdem jetzt abschließen? Danach ist es schreibgeschützt."); } catch (_) { ok = false; }
              if (!ok) return;
            } else if (enthAusstehend(state)) {
              let ok = false;
              try { ok = window.confirm("Die Platzierungen wurden noch nicht aufgedeckt. Trotzdem abschließen? Dann ist das Aufdecken bei der Siegerehrung nicht mehr möglich."); } catch (_) { ok = false; }
              if (!ok) return;
            }
            // Stand 37d: Tour-Formate -- KO-Ergebnis vor dem Abschluss in die Tour-Rangliste
            { const b = state.ko && state.ko.bracket; const fin = b && b.rounds.length ? b.rounds[b.rounds.length - 1][0] : null;
              if (fin && fin.done && !state.ko.savedEventId && !istAfterwork(state)) dispatch({ type: "ko/saveToTour", datum: state.tournament.meta.date || "", ort: state.tournament.meta.ort || "" }); }
            dispatch({ type: "setStatus", value: "abgeschlossen" });
          }} style={{ border: abschlussLeise ? `1.5px solid ${C.line}` : "none", background: abschlussLeise ? "#fff" : C.play, color: abschlussLeise ? C.sub : "#fff", borderRadius: 10, padding: "9px 14px", fontSize: 13.5, fontWeight: 700, cursor: "pointer", fontFamily: font }}>🔒 Turnier abschließen</button>}
      <span style={{ fontSize: 12, color: C.sub }}>{state.tournament.status === "abgeschlossen" ? "Abgeschlossen — Archiv, schreibgeschützt. Nur noch öffentliche Ansicht aktiv." : enthAusstehend(state) ? "Erst die Siegerehrung mit Aufdecken, danach abschließen (Archiv, schreibgeschützt)." : "Danach Archiv, schreibgeschützt. Teamhandys werden abgemeldet, Coaches bekommen den Check-out (oder „Ich arbeite noch“)."}</span>
    </div>
  );
  const started = tournamentStarted(state);

  // Audit-Fix (Stand 31) -- "trennen muss trennen sein": trennt der
  // Headcoach ein verbundenes Geraet remote (device/patch connected:false),
  // bekommt GENAU DIESES Geraet den neuen Stand automatisch per Polling mit
  // (siehe StoreProvider), musste das aber bisher selbst nicht bemerken und
  // blieb einfach eingeloggt. Jetzt erzwingt das betroffene Geraet fuer sich
  // selbst ein "logout", sobald sein eigener gebundener Slot nicht mehr
  // "connected" ist (oder das Team/Geraet gar nicht mehr existiert).
  useEffect(() => {
    if (role !== "teamaccess" || !state.boundDeviceId) return;
    const team = state.teams.find((t) => t.id === state.boundTeamId);
    const device = team && team.devices.find((d) => d.id === state.boundDeviceId);
    if (!device || !device.connected || (device.holder && device.holder !== geraetId())) dispatch({ type: "logout", einsatzId: state.meinEinsatzId, at: Date.now(), holder: geraetId() });
  }, [role, state.boundDeviceId, state.boundTeamId, state.teams, dispatch]);

  // Audit-Fix (Stand 31) -- "abschliessen ist abgeschlossen": bisher pruefte
  // NUR der Login-Screen tournament.status; eine bereits offene Coach- oder
  // Teamzugang-Sitzung lief nach dem Abschluss unveraendert weiter (Tore/
  // Bewertungen liessen sich noch eintragen, bevor spaeter archiviert wurde).
  // Jetzt wirkt der Abschluss auch auf schon offene Sitzungen -- exakt
  // dieselbe Rollen-Grenze, die ein NEUER Login-Versuch ohnehin schon
  // durchsetzt (siehe Login()): nur Headcoach (fuers Archivieren/
  // Veroeffentlichen) und die oeffentliche Ansicht bleiben aktiv.
  useEffect(() => {
    // Stand 40: Coaches mit offenem Einsatz bleiben -- sie sehen nur noch den Feierabend (Check-out / Ich arbeite noch)
    const offen = (state.einsaetze || []).some((e) => e.id === state.meinEinsatzId && !e.bis);
    if (state.tournament.status === "abgeschlossen" && (role === "teamaccess" || (role === "coach" && !offen))) {
      dispatch({ type: "logout", einsatzId: state.meinEinsatzId, at: Date.now(), holder: geraetId() });
    }
  }, [state.tournament.status, role, dispatch, state.einsaetze, state.meinEinsatzId]);

  // Stand 37f: Buero im Event (ueber "Als Büro öffnen") -- volle Headcoach-Rechte, kein Check-in
  const { eventId: shellEventId } = useStore();
  const bueroKey = `microsoccer_buero_ev:${shellEventId}`;
  const istBuero = role === "headcoach" && lsGet(bueroKey) === "1";
  useEffect(() => { if (!role) { try { window.localStorage.removeItem(bueroKey); } catch (_) { /* noop */ } } }, [role, bueroKey]);
  // Stand 37: Check-in = Anmelden als Headcoach/Coach. Check-out = Abmelden
  // (oder automatisch beim Abschluss). Vor dem Schliessen warnt der Browser.
  useEffect(() => {
    if ((role !== "headcoach" && role !== "coach") || istBuero || state.meinEinsatzId || state.tournament.status === "abgeschlossen") return;
    const team = state.teams.find((t) => t.id === state.boundTeamId);
    const sz = holeSitzung(shellEventId) || {}; // Stand 39: Academy-Nummer (MS-xxxx) aus dem Login gleich beim Einsatz
    dispatch({ type: "einsatz/checkin", id: uid(), rolle: role, name: role === "coach" && team ? (team.coach || sz.name || "") : (sz.name || ""), teamId: role === "coach" ? state.boundTeamId : null, academyId: sz.personId || undefined, at: Date.now() });
  }, [role, istBuero, state.meinEinsatzId, state.tournament.status, state.boundTeamId, state.teams, dispatch]);
  const eingecheckt = !!(state.meinEinsatzId && (state.einsaetze || []).some((e) => e.id === state.meinEinsatzId && !e.bis));
  useEffect(() => {
    if (!eingecheckt) return;
    const h = (e) => { e.preventDefault(); e.returnValue = "Du bist noch eingecheckt — bitte vorher in „Ich“ auschecken."; return e.returnValue; };
    window.addEventListener("beforeunload", h);
    return () => window.removeEventListener("beforeunload", h);
  }, [eingecheckt]);

  // Stand 37: Alt-Staende -- Rundenplan an Zeitplaner/Team-Zahl angleichen (nur Headcoach, nur vor dem Anpfiff).
  useEffect(() => {
    if (role !== "headcoach" || state.tournament.status === "abgeschlossen" || tournamentStarted(state)) return;
    if (state.teams.length >= 2 && state.tournament.config.numTeams !== state.teams.length) { dispatch({ type: "setConfig", key: "numTeams", value: state.teams.length }); return; }
    if (livePlanVeraltet(state)) dispatch({ type: "live/syncPlan" });
  }, [role, state, dispatch]);

  // Stand 29 - nur fuer Headcoach: welche Turnierphase ist gerade
  // aufgeklappt (null = automatisch der echten Turnierphase folgen), und
  // Teamturnier- vs. Einzel-KO/Tour-Umschalter. Springt automatisch auf die
  // neue Phase, sobald sich der echte Turnierstand aendert (z. B. Anpfiff,
  // Abschluss) - ein manueller Blick in eine andere Phase dazwischen wird
  // dadurch nicht staendig zurueckgeworfen, nur bei einem echten Phasenwechsel.
  const [manualPhase, setManualPhase] = useState(null);
  const curFormat = formatById(state.tournament.meta && state.tournament.meta.format);
  const [hcMode, setHcMode] = useState(curFormat && curFormat.kind === "tour" ? "tour" : "team");
  // Stand 33: Haupt-Tab (nur Headcoach/Coach) -- lokal pro Geraet.
  const operator = role === "headcoach" || role === "coach";
  const [mainTab, setMainTab] = useState("heute");
  const [werkzeuge, setWerkzeuge] = useState(false); // Stand 36: false = "Jetzt", true = alle Bausteine
  const [vonJetzt, setVonJetzt] = useState(false); // Stand 37c: Werkzeug direkt aus "Jetzt" geoeffnet -> keine Pillen
  const [zeigeCodes, setZeigeCodes] = useState(false); // Stand 37: Codes & Gaeste-QR unter "Alle Werkzeuge"
  const [fokus, setFokus] = useState(null); // Stand 36: Vollbild-Werkzeug aus "Jetzt" (z. B. Zaehlen) ohne Baustein-Navigation
  // Stand 36: "Jetzt" ist der Startbildschirm fuer Headcoach/Coach bei Team-
  // Formaten (Turnier, Business Cup, Geburtstag ...). Tour-Formate behalten
  // ihren eigenen Ablauf. "Alle Werkzeuge" zeigt die bisherigen Bausteine.
  const jetztMoeglich = operator && (!curFormat || curFormat.kind === "team" || curFormat.kind === "tour"); // Stand 37b: auch Tour-Formate
  const tourFormat = !!curFormat && curFormat.kind === "tour";
  const jetztAktiv = jetztMoeglich && mainTab === "heute" && !werkzeuge;
  const pickFormat = (f) => {
    if (f.kind === "bald") return;
    if (f.kind === "link") { try { window.open(f.href, "_blank", "noopener"); } catch (_) {} return; }
    // Nur der Headcoach legt fest, was heute laeuft; ein Coach springt nur hin.
    // Stand 37: Format liegt beim Anlegen fest -- nur Alt-Events ohne Format waehlen einmal.
    if (role === "headcoach" && !curFormat) {
      dispatch({ type: "meta/patch", patch: { format: f.id } });
      // Schlank = nur Tore zaehlen; Schule = Fairplay-/Aufgaben-Bonus wieder an.
      const voll = f.tiefe === "voll";
      dispatch({ type: "setFactor", key: "fairplay", value: voll ? DEFAULT_FACTORS.fairplay : 0 });
      dispatch({ type: "setFactor", key: "aufgaben", value: voll ? DEFAULT_FACTORS.aufgaben : 0 });
    }
    setHcMode(f.kind === "tour" ? "tour" : "team");
    setMainTab("heute");
  };
  const derivedPhase = currentPhase(state);
  const prevDerivedPhaseRef = useRef(derivedPhase);
  useEffect(() => {
    if (prevDerivedPhaseRef.current !== derivedPhase) {
      prevDerivedPhaseRef.current = derivedPhase;
      setManualPhase(null);
    }
  }, [derivedPhase]);
  const openPhase = manualPhase || derivedPhase;

  const schlank = isSchlank(state);
  let visible = BAUSTEINE.filter((b) => b.roles.includes(role));
  if (schlank) visible = visible.filter((b) => !SCHUL_BAUSTEINE.includes(b.id));
  visible = visible.filter((b) => !b.nurFormat || (curFormat && curFormat.id === b.nurFormat)); // Stand 37l
  // Stand 37d: nur die Bausteine des eigenen Formats (Team vs. Tour) -- auch fuer die oeffentliche Ansicht
  if (curFormat && (curFormat.kind === "team" || curFormat.kind === "tour")) visible = visible.filter((b) => b.group === "basis" || b.group === curFormat.kind);
  if (role === "coach") {
    // Sobald das Turnier laeuft, braucht der Coach die Team-Verwaltung nicht
    // mehr im Menue (Teams aendern sich live nicht mehr) - weniger Ablenkung.
    if (started) visible = visible.filter((b) => b.id !== "team-verwaltung");
    // Live-Zaehler ist das Kernwerkzeug des Coaches waehrend des Turniers -
    // im Menue nach vorne holen statt gleichrangig zwischen allen anderen.
    const coachPriority = ["live-zaehler", "wertung", "gesamtwertung", "fairplay", "aufgaben"];
    visible = [...visible].sort((a, b) => {
      const ia = coachPriority.includes(a.id) ? coachPriority.indexOf(a.id) : 999;
      const ib = coachPriority.includes(b.id) ? coachPriority.indexOf(b.id) : 999;
      return ia - ib;
    });
  }
  if (role === "teamaccess") {
    const bt = state.teams.find((t) => t.id === state.boundTeamId);
    const bd = bt && bt.devices.find((d) => d.id === state.boundDeviceId);
    const allow = bd && bd.kind === "medien" ? ["aufgaben", "fairplay"] : ["live-zaehler", "fairplay"];
    visible = visible.filter((b) => allow.includes(b.id));
  }
  const active = visible.find((b) => b.id === state.view) || visible[0];
  // Stand 40: Usability-Schleife -- welcher Bildschirm ist gerade sichtbar (ohne Namen)
  const coachSpielSichtbar = jetztAktiv && !fokus && !tourFormat && role === "coach" && !!state.boundTeamId && state.teams.some((t) => t.id === state.boundTeamId);
  const uxName = !operator ? `${role}/${active ? active.id : "?"}`
    : mainTab !== "heute" ? `${role}/${mainTab}`
    : jetztAktiv ? (fokus ? `${role}/jetzt/${fokus}` : coachSpielSichtbar ? "coach/spiel" : `${role}/jetzt`)
    : `${role}/werkzeug/${active ? active.id : "?"}`;
  useEffect(() => { uxKontext({ rolle: istBuero ? "buero" : role }); uxBildschirm(uxName); }, [uxName, role, istBuero]);
  const boundTeam = role === "teamaccess" ? state.teams.find((t) => t.id === state.boundTeamId) : null;
  const boundDevice = boundTeam ? boundTeam.devices.find((d) => d.id === state.boundDeviceId) : null;
  const badge = role === "public"
    ? { emo: "🌐", label: "Öffentliche Ansicht" }
    : role === "teamaccess"
      ? { emo: "📱", label: `Teamzugang · ${boundTeam ? boundTeam.name : "?"}${boundDevice ? " · " + boundDevice.label : ""}` }
      : roleLabel(role);
  const exitLabel = role === "public" ? "Anmelden" : role === "teamaccess" ? "Abmelden" : "Rolle wechseln";

  // Stand 40: Feierabend -- Coach nach dem Abschluss sieht nur noch Check-out / „Ich arbeite noch"
  const meinOffen = (state.einsaetze || []).some((e) => e.id === state.meinEinsatzId && !e.bis);
  const feierabendVoll = role === "coach" && !istBuero && state.tournament.status === "abgeschlossen" && meinOffen;
  useEffect(() => { if (feierabendVoll) uxBildschirm("coach/feierabend"); }, [feierabendVoll]);
  const groupsInOrder = ["basis", "team", "tour"];
  const navBtn = (b) => {
    const on = b.id === active.id;
    return (
      <button key={b.id} onClick={() => dispatch({ type: "setView", view: b.id })}
        style={{ display: "inline-flex", alignItems: "center", gap: 6, border: `1px solid ${on ? C.play : C.line}`, background: on ? C.play : "#fff", color: on ? "#fff" : C.ink, borderRadius: 999, padding: "7px 12px", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: font, whiteSpace: "nowrap" }}>
        <span>{b.emo}</span>{b.label}
      </button>
    );
  };

  if (feierabendVoll) return (
    <div data-feierabend-seite style={{ background: C.chalk, minHeight: "100vh", fontFamily: font, color: C.ink }}>
      <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
      <div style={{ background: C.play, padding: "12px 20px", display: "flex", alignItems: "center", gap: 12 }}>
        <img src={LOGO_WHITE} alt={BRAND} style={{ height: 30, width: "auto" }} />
        <span style={{ color: "#fff", fontWeight: 700, fontSize: 14 }}>{(state.tournament.meta && state.tournament.meta.title) || ""}</span>
      </div>
      <FeierabendLeiste voll />
      <HaktKnopf unten={12} />
    </div>
  );
  return (
    <div style={{ background: C.chalk, minHeight: "100%", fontFamily: font, color: C.ink, paddingBottom: operator ? 84 : 0 }}>
      <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;} button:focus-visible{outline:2px solid ${C.play};outline-offset:2px;}`}</style>

      {/* Kopfleiste */}
      <div style={{ background: C.play, boxShadow: "0 4px 14px rgba(39,166,97,.25)" }}>
        <div style={{ maxWidth: 1000, margin: "0 auto", padding: "12px 20px", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
          <img src={LOGO_WHITE} alt={BRAND} style={{ height: 30, width: "auto" }} />
          <div style={{ fontFamily: display, fontWeight: 700, fontSize: 19, color: "#fff", flex: 1 }}>{BRAND}</div>
          {/* Stand 33b: Rolle, Rolle wechseln und Abschluss stehen bei Headcoach/Coach
              jetzt im Tab "Ich" bzw. in der Phase "Abschluss" -- oben nur noch Marke + Event. */}
          {operator ? (<>
            {state.tournament.meta && state.tournament.meta.title ? <span style={{ color: "rgba(255,255,255,.85)", fontSize: 13, fontWeight: 600 }}>{state.tournament.meta.title}</span> : null}
            {/* Stand 39: der Headcoach kommt aus JEDER Ansicht mit einem Tipp zum Turnierüberblick (ändert nichts am Turnier) */}
            {role === "headcoach" && <button data-ueberblick onClick={() => { setFokus(null); setWerkzeuge(false); setVonJetzt(false); setMainTab("heute"); try { window.scrollTo(0, 0); } catch (_) { /* noop */ } }}
              style={{ border: "none", background: "#fff", color: C.play, borderRadius: 999, padding: "6px 12px", fontSize: 13, fontWeight: 800, cursor: "pointer", fontFamily: font }}>🏟️ Überblick</button>}
          </>) : (<>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "rgba(255,255,255,.18)", color: "#fff", borderRadius: 999, padding: "5px 11px", fontSize: 13, fontWeight: 700 }}>{badge.emo} {badge.label}</span>
          {role === "headcoach" && (
            state.tournament.status === "abgeschlossen"
              ? <button onClick={reopenHere} style={{ border: "none", background: "#fff", color: C.play, borderRadius: 9, padding: "6px 12px", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>🔓 Wieder öffnen</button>
              : <button onClick={() => dispatch({ type: "setStatus", value: "abgeschlossen" })} style={{ border: "1px solid rgba(255,255,255,.5)", background: "transparent", color: "#fff", borderRadius: 9, padding: "6px 12px", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>🔒 Turnier abschließen</button>
          )}
          <button onClick={() => dispatch({ type: "logout", einsatzId: state.meinEinsatzId, at: Date.now(), holder: geraetId() })} style={{ border: "1px solid rgba(255,255,255,.5)", background: "transparent", color: "#fff", borderRadius: 9, padding: "6px 12px", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>{exitLabel}</button>
          </>)}
        </div>
      </div>

      {operator && !istBuero && <FeierabendLeiste />}
      {jetztAktiv && fokus && (
        <div data-fokus={fokus}>
          <div style={{ maxWidth: 520, margin: "0 auto", padding: "12px 12px 0" }}>
            <button data-fokus-zurueck="true" onClick={() => setFokus(null)}
              style={{ border: "none", background: C.play, color: "#fff", borderRadius: 999, padding: "8px 14px", fontWeight: 800, fontSize: 14, cursor: "pointer", fontFamily: font }}>⚡ Zurück zu „Jetzt"</button>
          </div>
          {fokus === "live-zaehler" ? <LiveZaehler />
            : fokus === "enthuellung" ? <EnthuellungsShow onFertig={() => { setFokus(null); dispatch({ type: "setView", view: "siegerehrung" }); setWerkzeuge(true); }} />
            : null}
        </div>
      )}
      {jetztAktiv && !fokus && tourFormat && (
        (curFormat && curFormat.id === "afterwork")
          ? <AfterworkJetzt abschlussBlock={abschlussBlock} onWerkzeug={(view) => { dispatch({ type: "setView", view: view || "aw-runde" }); setVonJetzt(!!view); setWerkzeuge(true); }} />
          : <TourJetztView abschlussBlock={abschlussBlock} onWerkzeug={(view) => { dispatch({ type: "setView", view: view || "einzel-ko" }); setVonJetzt(!!view); setWerkzeuge(true); }} />
      )}
      {jetztAktiv && !fokus && !tourFormat && role === "coach" && state.boundTeamId && state.teams.some((t) => t.id === state.boundTeamId) && <CoachSpiel />}
      {jetztAktiv && !fokus && !tourFormat && !(role === "coach" && state.boundTeamId && state.teams.some((t) => t.id === state.boundTeamId)) && (
        <JetztView abschlussBlock={abschlussBlock}
          onWerkzeug={(view) => {
            if (view === "live-zaehler" || view === "enthuellung") { setFokus(view); return; }
            if (view) dispatch({ type: "setView", view });
            setVonJetzt(!!view);
            setWerkzeuge(true);
          }} />
      )}
      {operator && mainTab === "heute" && !jetztAktiv && jetztMoeglich && vonJetzt && (
        // Stand 37c (Nutzer): im Event keine Pillen -- ein Werkzeug aus "Jetzt" hat nur "Zurueck".
        <div data-werkzeug-schlicht="true" style={{ background: "#fff", borderBottom: `1px solid ${C.line}` }}>
          <div style={{ maxWidth: 1000, margin: "0 auto", padding: "10px 20px", display: "flex", alignItems: "center", gap: 10 }}>
            <button data-zurueck-jetzt="true" onClick={() => setWerkzeuge(false)}
              style={{ border: "none", background: C.play, color: "#fff", borderRadius: 999, padding: "7px 14px", fontWeight: 800, fontSize: 13.5, cursor: "pointer", fontFamily: font }}>⚡ Zurück zu „Jetzt"</button>
            <span style={{ fontFamily: display, fontWeight: 700, fontSize: 16 }}>{active.emo} {active.label}</span>
          </div>
        </div>
      )}
      {(!operator || mainTab === "heute") && !jetztAktiv && !(operator && jetztMoeglich && vonJetzt) && (<>
      {/* Navigation */}
      <div style={{ background: "#fff", borderBottom: `1px solid ${C.line}` }}>
        <div style={{ maxWidth: 1000, margin: "0 auto", padding: "12px 20px", display: "flex", flexDirection: "column", gap: 10 }}>
          {(role === "headcoach" || role === "coach") ? (
            <>
              {jetztMoeglich && (
                <button data-zurueck-jetzt="true" onClick={() => setWerkzeuge(false)}
                  style={{ alignSelf: "flex-start", border: "none", background: C.play, color: "#fff", borderRadius: 999, padding: "7px 14px", fontWeight: 800, fontSize: 13.5, cursor: "pointer", fontFamily: font }}>⚡ Zurück zu „Jetzt"</button>
              )}
              <div data-heute-banner="true" style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                <span style={{ fontSize: 12, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.5 }}>Heute</span>
                <span style={{ fontFamily: display, fontWeight: 700, fontSize: 16 }}>
                  {curFormat ? `${curFormat.emo} ${curFormat.label}` : "Format noch nicht gewählt"}
                </span>
                {role === "headcoach" && !curFormat && (
                  <select data-format-waehlen value="" onChange={(e) => { const f = formatById(e.target.value); if (f) pickFormat(f); }}
                    style={{ border: `1px solid ${C.line}`, borderRadius: 8, padding: "4px 8px", fontSize: 13, fontFamily: font }}>
                    <option value="">Format wählen …</option>
                    {FORMATE.filter((f) => f.kind === "team" || f.kind === "tour").map((f) => <option key={f.id} value={f.id}>{f.emo} {f.label}</option>)}
                  </select>
                )}
                {eventNav && role === "headcoach" && ( // Stand 37p: Coaches & darunter bleiben in IHREM Event
                  <button data-heute-alle-events="true" onClick={eventNav.leave}
                    style={{ marginLeft: "auto", border: `1px solid ${C.line}`, background: "#fff", color: C.ink, borderRadius: 999, padding: "5px 11px", fontWeight: 700, fontSize: 12.5, cursor: "pointer", fontFamily: font }}>
                    🔑 Anderes Event
                  </button>
                )}
              </div>
              {role === "headcoach" && (
                <button data-werkzeug-codes onClick={() => setZeigeCodes((v) => !v)}
                  style={{ alignSelf: "flex-start", border: `1px solid ${C.line}`, background: zeigeCodes ? C.playSoft : "#fff", color: C.ink, borderRadius: 999, padding: "6px 12px", fontWeight: 700, fontSize: 12.5, cursor: "pointer", fontFamily: font }}>🔑 Codes & Gäste-QR {zeigeCodes ? "▾" : "▸"}</button>
              )}
              {role === "headcoach" && zeigeCodes && (<div><ZugangsCodes /><GastQrKarte /></div>)}
              <GeburtstagPanel />
              <div style={{ alignSelf: "flex-start" }}>{navBtn({ ...BAUSTEINE.find((b) => b.id === "uebersicht"), label: "Einstellungen & Archiv", emo: "⚙️" })}</div>
              {!curFormat && <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {[["team", "🧭 Teamturnier"], ["tour", "🥅 Einzel-KO / Tour"]].map(([m, lbl]) => (
                  <button key={m} data-mode-toggle={m} onClick={() => setHcMode(m)}
                    style={{ border: `1px solid ${hcMode === m ? C.play : C.line}`, background: hcMode === m ? C.play : "#fff", color: hcMode === m ? "#fff" : C.ink, borderRadius: 999, padding: "7px 14px", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: font }}>
                    {lbl}
                  </button>
                ))}
              </div>}
              {(curFormat ? curFormat.kind !== "tour" : hcMode === "team") ? (() => {
                // Stand 30: echter Schritt-für-Schritt-Assistent statt
                // Akkordeon (Nutzer-Feedback: "nacheinander, Schritt für
                // Schritt" auf den Bildschirm) - immer nur EINE Phase ist
                // zu sehen, dazu eine Fortschritts-Leiste oben (klickbar,
                // ersetzt die frueheren einzelnen Phasen-Header 1:1 als
                // data-phase-header) und Zurück/Weiter darunter.
                const phaseIdx = PHASES.findIndex((p) => p.id === openPhase);
                const activePhaseMeta = PHASES[phaseIdx];
                const activeItems = visible.filter((b) => b.group === "team" && b.phase === openPhase);
                const wizBtn = (label, target, kind) => (
                  <button key={kind} disabled={!target} onClick={() => target && setManualPhase(target.id)}
                    style={{ border: kind === "next" ? "none" : `1.5px solid ${C.line}`, background: kind === "next" ? C.play : "#fff", color: kind === "next" ? "#fff" : C.ink, borderRadius: 10, padding: "9px 16px", fontSize: 13.5, fontWeight: 700, fontFamily: font, cursor: target ? "pointer" : "default", opacity: target ? 1 : 0, visibility: target ? "visible" : "hidden" }}>
                    {kind === "back" ? `◀ ${target ? target.label : ""}` : `${target ? target.label : ""} ▶`}
                  </button>
                );
                return (
                  <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                    {/* Fortschritts-Leiste: 3 klickbare Schritte + Verbindungslinie */}
                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                      {PHASES.map((p, i) => {
                        const st = i < phaseIdx ? "done" : i === phaseIdx ? "active" : "todo";
                        return (
                          <React.Fragment key={p.id}>
                            <button data-phase-header="true" onClick={() => setManualPhase(p.id)}
                              style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3, border: "none", background: "none", cursor: "pointer", fontFamily: font, padding: "2px 8px", opacity: st === "todo" ? 0.55 : 1 }}>
                              <span style={{ width: 28, height: 28, borderRadius: "50%", display: "grid", placeItems: "center", background: st === "active" ? C.play : st === "done" ? C.playSoft : C.chalk, color: st === "active" ? "#fff" : st === "done" ? C.play : C.sub, border: `1.5px solid ${st === "todo" ? C.line : C.play}`, fontWeight: 700, fontSize: 13 }}>
                                {st === "done" ? "✓" : i + 1}
                              </span>
                              <span style={{ fontSize: 11, fontWeight: st === "active" ? 700 : 600, color: st === "active" ? C.ink : C.sub, whiteSpace: "nowrap" }}>{p.label}</span>
                            </button>
                            {i < PHASES.length - 1 && <div style={{ flex: 1, height: 2, marginTop: 13, background: i < phaseIdx ? C.play : C.line }} />}
                          </React.Fragment>
                        );
                      })}
                    </div>
                    {/* Aktuelle Phase */}
                    <div style={{ border: `1px solid ${C.play}`, background: C.playSoft, borderRadius: 14, padding: 14, display: "flex", flexDirection: "column", gap: 10 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontSize: 20 }}>{activePhaseMeta.emo}</span>
                        <span>
                          <span style={{ display: "block", fontFamily: display, fontWeight: 700, fontSize: 15.5 }}>{activePhaseMeta.label}</span>
                          <span style={{ display: "block", fontSize: 12, color: C.sub }}>{activePhaseMeta.hint}</span>
                        </span>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                        {activeItems.map(navBtn)}
                      </div>
                      {/* Stand 33b: Abschluss gehoert in die Phase Abschluss, nicht in die Kopfleiste */}
                      {role === "headcoach" && openPhase === "abschluss" && abschlussBlock}
                    </div>
                    {/* Zurück / Weiter */}
                    <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                      {wizBtn(null, phaseIdx > 0 ? PHASES[phaseIdx - 1] : null, "back")}
                      {wizBtn(null, phaseIdx < PHASES.length - 1 ? PHASES[phaseIdx + 1] : null, "next")}
                    </div>
                  </div>
                );
              })() : (<>
                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                  {visible.filter((b) => b.group === "tour").map(navBtn)}
                </div>
                {/* Stand 34: auch Tour-Events (Kick & Splash, Afterwork, Community Tour) muessen sich abschliessen lassen */}
                {role === "headcoach" && abschlussBlock}
              </>)}
            </>
          ) : (
            groupsInOrder.map((g) => {
              const items = visible.filter((b) => b.group === g);
              if (!items.length) return null;
              return (
                <div key={g} style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                  {GROUPS[g] && <span style={{ fontSize: 11, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.5, minWidth: 92 }}>{GROUPS[g]}</span>}
                  {items.map(navBtn)}
                </div>
              );
            })
          )}
        </div>
      </div>
      </>)}

      {(!operator || mainTab === "heute") && !jetztAktiv && (<>
      {role === "teamaccess" && <div style={{ maxWidth: 1000, margin: "0 auto", padding: "14px 20px 0" }}><DeineAufgabe /></div>}
      {/* Aktiver Slot */}
      <div style={{ maxWidth: 1000, margin: "0 auto", padding: active.id === "uebersicht" ? 0 : "22px 20px 60px" }}>
        {active.id === "uebersicht" ? <Fundament embedded />
          : active.id === "team-verwaltung" ? <TeamVerwaltung />
          : active.id === "zeitplaner" ? <Zeitplaner />
          : active.id === "live-zaehler" ? <LiveZaehler />
          : active.id === "wertung" ? <Wertung />
          : active.id === "gesamtwertung" ? <Gesamtwertung />
          : active.id === "fairplay" ? <Fairplay />
          : active.id === "aufgaben" ? <Aufgaben />
          : active.id === "headcoach-live" ? <HeadcoachLive />
          : active.id === "showroom" ? <Showroom />
          : active.id === "siegerehrung" ? <Siegerehrung />
          : active.id === "website" ? <Website />
          : active.id === "einzel-ko" ? <EinzelKO />
          : active.id === "aw-spieler" ? <EinzelKO nurEintragen />
          : active.id === "aw-runde" ? <AwRunde />
          : active.id === "aw-ehrung" ? <AwEhrung />
          : active.id === "tour-rangliste" ? <TourRangliste />
          : active.id === "tour-website" ? <TourWebsite />
          : active.id === "siegerehrung-tour" ? <SiegerehrungTour />
          : <SlotView meta={active} />}
      </div>
      </>)}

      {operator && mainTab === "tabelle" && <TabelleView />}
      {operator && mainTab === "ich" && (
        <IchView buero={istBuero} role={role} boundTeam={role === "coach" ? state.teams.find((t) => t.id === state.boundTeamId) : null}
          onSettings={() => { dispatch({ type: "setView", view: "uebersicht" }); setVonJetzt(role !== "headcoach"); setWerkzeuge(true); setMainTab("heute"); }}
          onLogout={() => { const at = serverJetzt(); if (meinOffen) einsatzSenden(state, shellEventId, { aktion: "checkout", einsatzId: state.meinEinsatzId, at }); dispatch({ type: "logout", einsatzId: state.meinEinsatzId, at, holder: geraetId() }); }} />
      )}
      {operator && <MainTabBar tab={mainTab} onTab={(tb) => { if (tb === "heute") { setWerkzeuge(false); setFokus(null); } setMainTab(tb); }} />}
      {operator && <HaktKnopf unten={84} />}
    </div>
  );
}


/* ---------- Stand 40: Feierabend-Leiste ----------
   Ab 5 Min nach Eventende (oder sofort nach dem Abschluss): „Check-out" oder „Ich arbeite noch".
   Ohne Antwort: automatischer Check-out um Ende + 15 Min (bzw. zur gewählten Zeit). Nie blockierend:
   Weiterarbeiten gilt sofort, die Freigabe (Headcoach für Coaches, Büro für den Headcoach) kommt danach. */
function useJetzt(ms = 15000) {
  const [t, setT] = useState(() => serverJetzt());
  useEffect(() => { const i = setInterval(() => setT(serverJetzt()), ms); return () => clearInterval(i); }, [ms]);
  return t;
}
const verlGrund = (k) => (VERL_GRUENDE.find((g) => g[0] === k) || [0, k])[1];
function einsatzSenden(state, eventId, body) {
  // offenes Event: der normale Speicherweg trägt die Aktion; abgeschlossen (Archiv): direkt an den Server
  if (state.tournament.status === "abgeschlossen") einsatzAktion(eventId, body).catch((e) => uxMelde("fehler", { art: "einsatz", text: (e && (e.serverMessage || e.message)) || "?" }));
}
// Nach einem automatischen Check-out: einmal erklären, warum man abgemeldet ist
function FeierabendHinweis() {
  const [info, setInfo] = useState(() => { try { const x = JSON.parse(window.localStorage.getItem("microsoccer_feierabend_info") || "null"); window.localStorage.removeItem("microsoccer_feierabend_info"); return x; } catch (_) { return null; } });
  if (!info) return null;
  return (
    <div data-feierabend-hinweis style={{ position: "fixed", top: 10, left: "50%", transform: "translateX(-50%)", zIndex: 70, maxWidth: 420, width: "calc(100% - 24px)", background: C.ink, color: "#fff", borderRadius: 14, padding: "10px 14px", fontFamily: font, fontSize: 13.5, display: "flex", gap: 10, alignItems: "center" }}>
      <span style={{ flex: 1 }}>🏁 Du wurdest um {fmtUhr(info.at)} automatisch ausgecheckt{info.titel ? ` (${info.titel})` : ""}. Danke für deinen Einsatz!</span>
      <button onClick={() => setInfo(null)} style={{ border: "none", background: "none", color: "#fff", fontSize: 18, cursor: "pointer" }}>✕</button>
    </div>
  );
}
function VerlFreigaben({ kompakt = false }) {
  const { state, dispatch, eventId } = useStore();
  const offen = (state.einsaetze || []).filter((e) => e.rolle === "coach" && e.verl && e.verl.status === "offen");
  if (!offen.length) return null;
  const setze = (e, status) => {
    const at = serverJetzt();
    dispatch({ type: "einsatz/verlFreigabe", einsatzId: e.id, status, durch: "headcoach", at });
    einsatzSenden(state, eventId, { aktion: "freigabe", einsatzId: e.id, status, at });
  };
  const klein = { border: `1px solid ${C.line}`, background: "#fff", color: C.ink, borderRadius: 8, padding: "6px 10px", fontSize: 13, fontWeight: 800, cursor: "pointer", fontFamily: font };
  return (
    <div data-verl-freigaben style={{ marginTop: kompakt ? 8 : 0, background: "#fff", border: `1px solid ${C.line}`, borderRadius: 12, padding: "8px 10px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
        <b style={{ flex: 1, fontSize: 13.5 }}>Verlängerungen freigeben ({offen.length})</b>
        {offen.length > 1 && <button data-verl-alle onClick={() => offen.forEach((e) => setze(e, "ok"))} style={{ ...klein, background: C.play, color: "#fff", borderColor: C.play }}>✓ Alle</button>}
      </div>
      {offen.map((e) => (
        <div key={e.id} data-verl-zeile={e.id} style={{ display: "flex", alignItems: "center", gap: 6, padding: "4px 0", borderTop: `1px solid ${C.line}`, fontSize: 13.5 }}>
          <span style={{ flex: 1 }}>🧢 {e.name || "Coach"} · {verlGrund(e.verl.grund)}{e.verl.text ? ` (${e.verl.text})` : ""} · bis {fmtUhr(e.verl.bis)}</span>
          <button data-verl-ok={e.id} onClick={() => setze(e, "ok")} style={{ ...klein, color: C.play }}>✓</button>
          <button data-verl-nein={e.id} onClick={() => setze(e, "nein")} style={{ ...klein, color: C.whistle }}>✗</button>
        </div>
      ))}
      <div style={{ fontSize: 11.5, color: C.sub, marginTop: 4 }}>Die Zeit läuft so oder so weiter — ✗ heißt: zählt nur bis Ende + 15 Min. Was du nicht entscheidest, klärt das Büro bei den Stunden.</div>
    </div>
  );
}
function FeierabendLeiste({ voll = false, onAus }) {
  const { state, dispatch, eventId } = useStore();
  const jetzt = useJetzt(15000);
  const [wahl, setWahl] = useState(false);
  const [grund, setGrund] = useState("");
  const [minuten, setMinuten] = useState(30);
  const [text, setText] = useState("");
  const mein = (state.einsaetze || []).find((e) => e.id === state.meinEinsatzId);
  const offenerEinsatz = !!(mein && !mein.bis);
  const zu = state.tournament.status === "abgeschlossen";
  const E = offenerEinsatz ? endeFuer(state, mein) : null;
  const autoBis = offenerEinsatz ? einsatzAutoBis(state, mein) : null;
  const rundeLaeuft = !zu && !!(state.live && state.live.running);
  const verl = offenerEinsatz && mein.verl && mein.verl.status !== "nein" ? mein.verl : null;
  const frageAb = !offenerEinsatz ? null : verl ? verl.bis - 10 * 60000 : E ? E + FRAGE_AB_MIN * 60000 : autoBis - 10 * 60000;
  const auschecken = useCallback((auto, at) => {
    const t = at || serverJetzt();
    einsatzSenden(state, eventId, { aktion: "checkout", einsatzId: mein.id, at: t, auto: !!auto });
    if (auto) { try { window.localStorage.setItem("microsoccer_feierabend_info", JSON.stringify({ at: t, titel: (state.tournament.meta && state.tournament.meta.title) || "" })); } catch (_) { /* noop */ } }
    dispatch({ type: "logout", einsatzId: mein.id, at: t, auto: !!auto, holder: geraetId() });
    if (onAus) onAus();
  }, [state, eventId, mein, dispatch, onAus]);
  // automatischer Check-out (nie während eine Runde läuft)
  const autoGemacht = useRef(false);
  useEffect(() => {
    if (!offenerEinsatz || !autoBis || rundeLaeuft || autoGemacht.current) return;
    if (jetzt >= autoBis) { autoGemacht.current = true; auschecken(true, autoBis); }
  }, [jetzt, autoBis, offenerEinsatz, rundeLaeuft, auschecken]);
  const hc = state.role === "headcoach";
  const freigabenOffen = hc && (state.einsaetze || []).some((e) => e.rolle === "coach" && e.verl && e.verl.status === "offen");
  const zeigen = offenerEinsatz && (zu || (frageAb != null && jetzt >= frageAb));
  const freigabeText0 = !mein || !mein.verl ? "" : mein.verl.status === "ok" ? "✓ freigegeben" : mein.verl.status === "nein" ? "✗ nicht freigegeben" : (state.role === "headcoach" ? "Freigabe durchs Büro" : "Freigabe durch den Headcoach");
  // Verlängert, aber noch nicht kurz vor dem neuen Ende: nur eine schmale Zeile
  if (!zeigen && verl && !wahl) return (
    <div style={{ maxWidth: 560, margin: "10px auto 0", padding: "0 12px" }}>
      <div data-feierabend="verlaengert" style={{ display: "flex", alignItems: "center", gap: 8, background: "#FFF8E6", border: "1px solid #F2D27A", borderRadius: 12, padding: "7px 10px", fontSize: 13 }}>
        <span style={{ flex: 1 }}>🔧 {verlGrund(verl.grund)} bis {fmtUhr(verl.bis)} · {freigabeText0}</span>
        <button data-feierabend-checkout onClick={() => auschecken(false)} style={{ border: `1px solid ${C.line}`, background: "#fff", borderRadius: 8, padding: "5px 9px", fontSize: 12.5, fontWeight: 700, cursor: "pointer", fontFamily: font }}>🏁 Auschecken</button>
      </div>
      {hc && <VerlFreigaben kompakt />}
    </div>
  );
  if (!zeigen && !freigabenOffen) return null;
  const verlaengern = () => {
    const at = serverJetzt();
    const bis = Math.max(at, (verl && verl.bis) || 0) + minuten * 60000;
    dispatch({ type: "einsatz/verlaengern", einsatzId: mein.id, grund: grund || "sonstiges", text, bis, at });
    einsatzSenden(state, eventId, { aktion: "verlaengern", einsatzId: mein.id, grund: grund || "sonstiges", text, bis, at });
    setWahl(false); setText("");
  };
  const chip = (on) => ({ border: `1.5px solid ${on ? C.play : C.line}`, background: on ? C.playSoft : "#fff", color: C.ink, borderRadius: 999, padding: "8px 12px", fontSize: 13.5, fontWeight: 700, cursor: "pointer", fontFamily: font });
  const gross = { border: "none", borderRadius: 999, padding: "12px 16px", fontSize: 15, fontWeight: 800, cursor: "pointer", fontFamily: font };
  const freigabeText = !mein || !mein.verl ? "" : mein.verl.status === "ok" ? "✓ freigegeben" : mein.verl.status === "nein" ? "✗ nicht freigegeben — zählt bis Ende + 15 Min" : (state.role === "headcoach" ? "Freigabe durchs Büro" : "Freigabe durch den Headcoach");
  return (
    <div data-feierabend={zeigen ? (verl ? "verlaengert" : "frage") : "freigaben"} style={voll
      ? { maxWidth: 460, margin: "0 auto", padding: "40px 16px" }
      : { maxWidth: 560, margin: "10px auto 0", padding: "0 12px" }}>
      {zeigen && (
        <div style={{ background: "#FFF8E6", border: "1.5px solid #F2D27A", borderRadius: 16, padding: voll ? 20 : 12, textAlign: voll ? "center" : "left" }}>
          {voll && <div style={{ fontSize: 44 }}>🏁</div>}
          <b style={{ display: "block", fontFamily: display, fontSize: voll ? 24 : 17 }}>{verl ? `🔧 ${verlGrund(verl.grund)} bis ${fmtUhr(verl.bis)}` : zu ? "Event abgeschlossen" : "Das Event ist vorbei"}</b>
          <div style={{ fontSize: 13.5, color: C.sub, margin: "4px 0 10px" }}>
            {rundeLaeuft ? "Es läuft noch eine Runde — der Check-out wartet." : `Automatischer Check-out um ${fmtUhr(autoBis)}.`}
            {freigabeText ? ` ${freigabeText}.` : ""}
          </div>
          {!wahl ? (
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: voll ? "center" : "flex-start" }}>
              <button data-feierabend-checkout onClick={() => auschecken(false)} style={{ ...gross, background: C.ink, color: "#fff" }}>🏁 Jetzt auschecken</button>
              <button data-feierabend-weiter onClick={() => { setWahl(true); if (verl) setGrund(verl.grund); }} style={{ ...gross, background: "#fff", color: C.ink, border: `1.5px solid ${C.line}` }}>🔧 {verl ? "Länger" : "Ich arbeite noch"}</button>
            </div>
          ) : (
            <div data-feierabend-wahl style={{ display: "flex", flexDirection: "column", gap: 8, alignItems: voll ? "center" : "stretch" }}>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", justifyContent: voll ? "center" : "flex-start" }}>
                {VERL_GRUENDE.filter((g) => g[0] !== "laeuft" || !zu).map(([k, l]) => <button key={k} data-verl-grund={k} onClick={() => setGrund(k)} style={chip(grund === k)}>{l}</button>)}
              </div>
              {grund === "sonstiges" && <input data-verl-text value={text} onChange={(e) => setText(e.target.value)} placeholder="Was noch?" maxLength={140} style={{ border: `1.5px solid ${C.line}`, borderRadius: 10, padding: "9px 10px", fontSize: 15, fontFamily: font }} />}
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", justifyContent: voll ? "center" : "flex-start" }}>
                {[15, 30, 60, 90].map((m) => <button key={m} data-verl-min={m} onClick={() => setMinuten(m)} style={chip(minuten === m)}>+{m} Min</button>)}
              </div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: voll ? "center" : "flex-start" }}>
                <button data-verl-ok-senden disabled={!grund} onClick={verlaengern} style={{ ...gross, background: grund ? C.play : "#C7D3CC", color: "#fff" }}>Weiter bis {fmtUhr(Math.max(jetzt, (verl && verl.bis) || 0) + minuten * 60000)}</button>
                <button onClick={() => setWahl(false)} style={{ ...gross, background: "none", color: C.sub }}>Abbrechen</button>
              </div>
              <div style={{ fontSize: 12, color: C.sub }}>{state.role === "headcoach" ? "Das Büro bestätigt das später bei den Stunden." : "Der Headcoach gibt das frei — du kannst sofort weiterarbeiten."}</div>
            </div>
          )}
        </div>
      )}
      {hc && <VerlFreigaben kompakt={zeigen} />}
    </div>
  );
}
/* ---------- Stand 40: „Hier hakt's" — ein Tipp, kurzer Text, Bildschirm + Weg gehen automatisch mit ---------- */
const HAKT_ARTEN = [["finde", "🔎 Finde etwas nicht"], ["unlogisch", "🤔 Unlogisch / verwirrend"], ["geht-nicht", "⛔ Geht nicht / Fehler"], ["langsam", "🐢 Zu viele Schritte"], ["idee", "💡 Idee"]];
function HaktKnopf({ unten = 20 }) {
  const [auf, setAuf] = useState(false);
  const [art, setArt] = useState("");
  const [text, setText] = useState("");
  const [danke, setDanke] = useState(false);
  const senden = () => {
    uxMelde("hakt", { kategorie: art || "sonstiges", text: text.trim().slice(0, 600) }, { sofort: true });
    setAuf(false); setArt(""); setText(""); setDanke(true);
    setTimeout(() => setDanke(false), 2500);
  };
  const chip = (on) => ({ border: `1.5px solid ${on ? C.play : C.line}`, background: on ? C.playSoft : "#fff", color: C.ink, borderRadius: 999, padding: "8px 12px", fontSize: 13.5, fontWeight: 700, cursor: "pointer", fontFamily: font });
  return (<>
    <button data-hakt-knopf aria-label="Hier hakt's" onClick={() => setAuf(true)}
      style={{ position: "fixed", left: 10, bottom: unten + 8, zIndex: 40, border: `1px solid ${C.line}`, background: "rgba(255,255,255,.92)", color: C.sub, borderRadius: 999, padding: "6px 10px", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: font, boxShadow: "0 2px 8px rgba(0,0,0,.08)" }}>💬 Hakt's?</button>
    {danke && <div data-hakt-danke style={{ position: "fixed", left: "50%", transform: "translateX(-50%)", bottom: unten + 52, zIndex: 41, background: C.ink, color: "#fff", borderRadius: 999, padding: "9px 16px", fontSize: 13.5, fontWeight: 700, fontFamily: font }}>Danke — ist angekommen 🙌</div>}
    {auf && (
      <div data-hakt-dialog onClick={(e) => { if (e.target === e.currentTarget) setAuf(false); }} style={{ position: "fixed", inset: 0, zIndex: 60, background: "rgba(0,0,0,.35)", display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
        <div style={{ width: "100%", maxWidth: 520, background: "#fff", borderRadius: "20px 20px 0 0", padding: "18px 16px 22px", fontFamily: font, color: C.ink }}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
            <b style={{ fontFamily: display, fontSize: 19, flex: 1 }}>💬 Hier hakt's</b>
            <button onClick={() => setAuf(false)} style={{ border: "none", background: "none", fontSize: 20, cursor: "pointer", color: C.sub }}>✕</button>
          </div>
          <div style={{ fontSize: 13, color: C.sub, marginBottom: 10 }}>Was war los? Der Bildschirm und deine letzten Schritte gehen automatisch mit.</div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
            {HAKT_ARTEN.map(([k, l]) => <button key={k} data-hakt-art={k} onClick={() => setArt(art === k ? "" : k)} style={chip(art === k)}>{l}</button>)}
          </div>
          <textarea data-hakt-text value={text} onChange={(e) => setText(e.target.value)} rows={3} placeholder="Kurz: Was wolltest du machen? (optional)"
            style={{ width: "100%", border: `1.5px solid ${C.line}`, borderRadius: 12, padding: 10, fontSize: 15, fontFamily: font, resize: "vertical" }} />
          <button data-hakt-senden disabled={!art && !text.trim()} onClick={senden}
            style={{ width: "100%", marginTop: 10, border: "none", background: art || text.trim() ? C.play : "#C7D3CC", color: "#fff", borderRadius: 999, padding: "13px", fontSize: 15.5, fontWeight: 800, cursor: "pointer", fontFamily: font }}>Senden</button>
        </div>
      </div>
    )}
  </>);
}

/* =====================================================================
   VIEW: TEAM-VERWALTUNG  (eingehängter Baustein 1)
   Portiert aus team-verwaltung.jsx — eigenes Theme & Demo-Daten raus,
   alles über useStore(). Geräte = 2 feste Funktions-Slots (Zähl/Medien),
   Beitritt code-frei übers Login. Galerie in Store-Form (star/taskId).
   ===================================================================== */

const tvReadFile = (e, cb) => {
  const f = e.target.files && e.target.files[0];
  if (!f) return;
  cb(URL.createObjectURL(f), f.type.startsWith("video") ? "video" : "foto");
  e.target.value = "";
};

const tvBtnPrimary = { border: "none", background: C.play, color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 15, padding: "9px 16px", borderRadius: 10, cursor: "pointer" };
const tvBtnGhost = { border: `1.5px solid ${C.line}`, background: "#fff", color: C.ink, fontFamily: font, fontWeight: 600, fontSize: 13.5, padding: "7px 14px", borderRadius: 10, cursor: "pointer" };
const tvBtnTiny = { border: "none", background: "none", color: C.whistle, fontSize: 12, cursor: "pointer", textAlign: "left", padding: 0 };
const tvFileBtn = { border: `1.5px solid ${C.line}`, background: "#fff", color: C.ink, fontFamily: font, fontWeight: 600, fontSize: 13, padding: "6px 12px", borderRadius: 9, cursor: "pointer", display: "inline-flex", alignItems: "center" };
const tvBtnTinyGhost = { border: `1.5px solid ${C.line}`, background: "#fff", color: C.ink, fontFamily: font, fontWeight: 600, fontSize: 12, padding: "4px 10px", borderRadius: 8, cursor: "pointer" };

// Selbst-Anlage ueber einen Einladungs-Link (Stand 30): bewusst NUR die
// Team-Felder (Name, Logo, Coach, Spieler:innen) -- kein Zugriff auf Geraete/
// Galerie/Fairplay/Aufgaben, das bleibt exklusiv dem PIN-losen Team-Zugang
// (Team antippen im Login) am Turniertag vorbehalten. Dieselben Actions wie
// TvTeamEditor (team/patch, player/add, player/remove, player/toggleCaptain) --
// bewusst keine eigene "Wahrheit", nur ein eingeschraenktes Formular darauf.
function InviteTeamSetup({ invitation }) {
  const { state, dispatch } = useStore();
  const team = state.teams.find((t) => t.id === invitation.teamId);
  const [playerName, setPlayerName] = useState("");
  if (!team) return <InviteInvalid />;
  const { coachMode, minSquad } = state.roles;
  const maxSquad = minSquad + 4;
  const patchTeam = (patch) => dispatch({ type: "team/patch", id: team.id, patch });
  const addPlayer = () => { dispatch({ type: "player/add", teamId: team.id, name: playerName }); setPlayerName(""); };
  // Stand 31, Nachtrag 4 -- Namens-Konflikt-Warnung (Nutzer-Meldung: "ich habe
  // nun Blitz-Kicker 2x in den teams ohne fehlermeldung allerdings"): der
  // bisherige Doppelverwendungs-Fix deckte nur AUTOMATISCH vergebene Namen ab
  // (Default "Team N", Duplizieren) -- freies Umbenennen hier auf der
  // Selbst-Anlage-Seite blieb ungeprueft. Bewusst NICHT blockierend (das Team
  // koennte z. B. gerade erst "Blitz" tippen, bevor "-Kicker 2" folgt) --
  // stattdessen ein deutlich sichtbarer Hinweis, den man auch als Team ohne
  // Turnierleitungs-Erfahrung sofort versteht.
  const nameConflict = team.name.trim()
    ? state.teams.find((other) => other.id !== team.id && other.name.trim().toLowerCase() === team.name.trim().toLowerCase())
    : null;

  return (
    <div style={{ background: C.chalk, minHeight: "100%", fontFamily: font, color: C.ink }}>
      <style>{`
        @import url('${FONT_IMPORT}'); *{box-sizing:border-box;}
        .tv-in { border:1px solid ${C.line}; border-radius:9px; padding:8px 10px; font-family:${font}; font-size:14px; color:${C.ink}; background:#fff; width:100%; }
        .tv-in:focus { outline:none; border-color:${C.play}; }
      `}</style>
      <div style={{ maxWidth: 560, margin: "0 auto", padding: "40px 20px 60px" }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{ display: "inline-flex", background: C.play, borderRadius: 18, padding: "16px 20px", boxShadow: "0 6px 20px rgba(39,166,97,.25)" }}>
            <img src={LOGO_WHITE} alt={BRAND} style={{ height: 40, width: "auto" }} />
          </div>
          <h1 style={{ fontFamily: display, fontWeight: 700, fontSize: 22, margin: "16px 0 4px" }}>
            Team anlegen{invitation.label ? ` · ${invitation.label}` : ""}
          </h1>
          <div style={{ color: C.sub, fontSize: 13.5, maxWidth: 420, margin: "0 auto" }}>
            Hier könnt ihr euer Team ausfüllen — Name, Logo, Coach und Spieler:innen. Alles wird sofort gespeichert, kein extra „Speichern“-Knopf nötig.
          </div>
        </div>

        <div style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: 18 }}>
          <TvLabel>Teamname</TvLabel>
          <input className="tv-in" value={team.name} onChange={(e) => patchTeam({ name: e.target.value })} />
          {nameConflict && (
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#8a5a12", background: C.brkSoft, border: `1px solid ${C.brk}`, borderRadius: 8, padding: "6px 10px", marginTop: 6 }}>
              ⚠️ Diesen Namen gibt es schon bei {nameConflict.emoji} {nameConflict.name} — bitte einen eindeutigen Namen wählen.
            </div>
          )}

          <TvLabel style={{ marginTop: 14 }}>Logo</TvLabel>
          <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            <TvLogo t={team} size={54} />
            <div style={{ display: "flex", flexWrap: "wrap", gap: 4, maxWidth: 220 }}>
              {EMOJIS.map((e) => (
                <button key={e} onClick={() => patchTeam({ emoji: e, logoImg: null })}
                  style={{ width: 30, height: 30, borderRadius: 7, border: `1px solid ${team.emoji === e && !team.logoImg ? C.play : C.line}`, background: "#fff", fontSize: 16, cursor: "pointer", padding: 0 }}>{e}</button>
              ))}
            </div>
          </div>
          <div style={{ display: "flex", gap: 6, marginTop: 8, flexWrap: "wrap" }}>
            {TEAM_COLORS.map((c) => (
              <button key={c} onClick={() => patchTeam({ color: c })}
                style={{ width: 24, height: 24, borderRadius: "50%", background: c, border: team.color === c ? "3px solid #fff" : "none", boxShadow: team.color === c ? `0 0 0 2px ${c}` : "none", cursor: "pointer" }} />
            ))}
          </div>

          <TvLabel style={{ marginTop: 14 }}>Coach</TvLabel>
          <div style={{ border: `1px solid ${C.line}`, borderRadius: 9, padding: "8px 10px", fontSize: 14, color: team.coach ? C.ink : C.sub, background: C.chalk }}>
            {team.coach || "— wird vom Headcoach zugewiesen —"}
          </div>
          <div style={{ fontSize: 11.5, color: C.sub, marginTop: 4 }}>
            Den Coach legt der Headcoach fest, nicht ihr selbst — meldet euch bei ihm/ihr, falls hier noch niemand steht.
          </div>

          <TvLabel style={{ marginTop: 14 }}>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              Spieler:innen · {team.players.length}/{minSquad}–{maxSquad}
              {coachMode === "captain" && <span style={{ fontWeight: 500 }}>· ⭐ = Playing Captain</span>}
            </span>
          </TvLabel>
          <div style={{ display: "flex", gap: 6 }}>
            <input className="tv-in" placeholder="Name + Enter" value={playerName}
              onChange={(e) => setPlayerName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addPlayer()} />
            <button onClick={addPlayer} style={tvBtnGhost}>+</button>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 5, marginTop: 8 }}>
            {team.players.length === 0 && <span style={{ fontSize: 12.5, color: C.sub }}>Noch keine Spieler:innen.</span>}
            {team.players.map((pl) => (
              <div key={pl.id} style={{ display: "flex", alignItems: "center", gap: 8, background: C.chalk, borderRadius: 8, padding: "6px 8px 6px 10px" }}>
                {coachMode === "captain" && (
                  <button title="Playing Captain" onClick={() => dispatch({ type: "player/toggleCaptain", teamId: team.id, playerId: pl.id })}
                    style={{ border: "none", background: "none", cursor: "pointer", fontSize: 15, opacity: pl.captain ? 1 : 0.25, padding: 0 }}>⭐</button>
                )}
                <span style={{ flex: 1, fontSize: 14, fontWeight: pl.captain ? 700 : 500 }}>{pl.name}</span>
                <TvX onClick={() => dispatch({ type: "player/remove", teamId: team.id, playerId: pl.id })} />
              </div>
            ))}
          </div>
        </div>

        <p style={{ textAlign: "center", color: C.sub, fontSize: 12, marginTop: 20 }}>
          Fürs eigentliche Zählen, Fairplay und die Aufgaben beim Turnier meldet ihr euch am Turniertag über den normalen Team-Zugang an (Team antippen, Handy wählen).
        </p>
      </div>
    </div>
  );
}

function InviteInvalid() {
  return (
    <div style={{ background: C.chalk, minHeight: "100%", fontFamily: font, color: C.ink }}>
      <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
      <div style={{ maxWidth: 420, margin: "0 auto", padding: "64px 20px", textAlign: "center" }}>
        <div style={{ fontSize: 30 }}>🔗</div>
        <h1 style={{ fontFamily: display, fontWeight: 700, fontSize: 22, margin: "10px 0 4px" }}>Link ungültig</h1>
        <p style={{ color: C.sub, fontSize: 13.5 }}>Diese Einladung wurde nicht gefunden — sie wurde vermutlich schon gelöscht. Bitte beim Headcoach nach einem neuen Link fragen.</p>
      </div>
    </div>
  );
}

function TeamVerwaltung() {
  const { state } = useStore();
  // Stand 35: Team-Verwaltung mit Coaches, Einladungen, Geraeten, Kadergroesse
  // gibt es nur im Kontext Schule -- sonst die schlanke Teamliste.
  return isSchlank(state) ? <TeamsSchlank /> : <TeamVerwaltungVoll />;
}
function TeamsSchlank() {
  const { state, dispatch } = useStore();
  const [neu, setNeu] = useState({});
  const [name, setName] = useState("");
  const add = () => { dispatch({ type: "team/add", name }); setName(""); };
  const inp = { border: `1px solid ${C.line}`, borderRadius: 9, padding: "8px 10px", fontFamily: font, fontSize: 14, color: C.ink, background: "#fff" };
  return (
    <div data-teams-schlank="true" style={{ fontFamily: font, color: C.ink }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: C.play, display: "grid", placeItems: "center", fontSize: 22, flexShrink: 0 }}>👥</div>
        <div>
          <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: 0 }}>Teams</h2>
          <div style={{ fontSize: 13, color: C.sub }}>Nur Teamname, Spieler:innen optional. Gewertet werden nur Tore.</div>
        </div>
      </div>
      <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
        <input data-team-neu value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") add(); }} placeholder="Teamname (leer = Team N)" style={{ ...inp, flex: 1, minWidth: 180 }} />
        <button data-team-add onClick={add} style={tvBtnPrimary}>+ Team</button>
      </div>
      <div style={{ display: "grid", gap: 10 }}>
        {state.teams.map((t) => (
          <div key={t.id} data-team-karte={t.id} style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 24 }}>{t.emoji}</span>
              <input value={t.name} onChange={(e) => dispatch({ type: "team/patch", id: t.id, patch: { name: e.target.value } })} style={{ ...inp, flex: 1, fontWeight: 700 }} />
              <button aria-label={`${t.name} entfernen`} onClick={() => { let ok = true; try { ok = window.confirm(`Team „${t.name}" entfernen?`); } catch (_) { ok = true; } if (ok) dispatch({ type: "team/remove", id: t.id }); }}
                style={{ border: `1px solid ${C.line}`, background: "#fff", color: C.whistle, borderRadius: 9, padding: "7px 10px", cursor: "pointer", fontWeight: 700 }}>✕</button>
            </div>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 8, alignItems: "center" }}>
              {t.players.map((pl) => (
                <span key={pl.id} style={{ background: C.playSoft, borderRadius: 999, padding: "4px 6px 4px 10px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 4 }}>
                  {pl.name}
                  <button aria-label={`${pl.name} entfernen`} onClick={() => dispatch({ type: "player/remove", teamId: t.id, playerId: pl.id })} style={{ border: "none", background: "none", color: C.sub, cursor: "pointer", fontWeight: 700 }}>×</button>
                </span>
              ))}
              <input data-spieler-neu={t.id} value={neu[t.id] || ""} placeholder="+ Name" onChange={(e) => setNeu({ ...neu, [t.id]: e.target.value })}
                onKeyDown={(e) => { if (e.key === "Enter" && (neu[t.id] || "").trim()) { dispatch({ type: "player/add", teamId: t.id, name: neu[t.id] }); setNeu({ ...neu, [t.id]: "" }); } }}
                style={{ ...inp, padding: "4px 8px", fontSize: 13, width: 110 }} />
            </div>
          </div>
        ))}
        {state.teams.length === 0 && <div style={{ color: C.sub, fontSize: 14 }}>Noch keine Teams.</div>}
      </div>
    </div>
  );
}
function TeamVerwaltungVoll() {
  const { state, dispatch } = useStore();
  const teams = state.teams;
  const invitations = state.invitations;
  const { coaches, coachMode, minSquad } = state.roles;
  const maxSquad = minSquad + 4;
  const squadStatus = (n) => (n < minSquad ? "low" : n > maxSquad ? "high" : "ok");

  const [selectedId, setSelectedId] = useState(null);
  const [coachInput, setCoachInput] = useState("");
  const [quick, setQuick] = useState(4);

  const rolesPatch = (patch) => dispatch({ type: "roles/patch", patch });
  const addCoach = () => {
    const n = coachInput.trim();
    if (n && !coaches.includes(n)) rolesPatch({ coaches: [...coaches, n] });
    setCoachInput("");
  };
  const addCoachName = (n) => { if (n && !coaches.includes(n)) rolesPatch({ coaches: [...coaches, n] }); };
  const removeCoach = (name) => {
    rolesPatch({ coaches: coaches.filter((c) => c !== name) });
  };
  const setMin = (v) => rolesPatch({ minSquad: Math.max(4, Math.min(12, v)) });

  const addTeam = () => { dispatch({ type: "team/add" }); };
  const quickAdd = () => dispatch({ type: "team/addMany", count: quick });

  // Coach ist seit Stand 30 (Nachtrag) beim Login an GENAU EIN Team gebunden
  // (siehe Login() -> "welcher Coach bist du" -> team.coach-Zuordnung) --
  // sieht/bearbeitet hier deshalb NUR dieses eine Team, keine Turnier-weiten
  // Einstellungen (Coaches-Liste, Coach-Modus, Kadergröße), keine Einladungen-
  // Verwaltung, kein Anlegen/Löschen anderer Teams -- das bleibt exklusiv dem
  // Headcoach vorbehalten (unveränderte Weiche unten fürs Headcoach-eigene
  // Team-Verwaltungs-Rendering).
  if (state.role === "coach") {
    const myTeam = teams.find((t) => t.id === state.boundTeamId);
    if (!myTeam) {
      return (
        <div style={{ fontFamily: font, color: C.ink, textAlign: "center", padding: "48px 20px" }}>
          <div style={{ fontSize: 30 }}>🎽</div>
          <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 20, margin: "10px 0 6px" }}>Kein Team zugeordnet</h2>
          <p style={{ color: C.sub, fontSize: 13.5, maxWidth: 380, margin: "0 auto" }}>
            Bitte über „Rolle wechseln" neu einloggen und dein Team auswählen,
            oder den Headcoach bitten, dich im Feld „Coach" einem Team
            zuzuordnen (Team-Verwaltung).
          </p>
        </div>
      );
    }
    return (
      <div style={{ fontFamily: font, color: C.ink }}>
        <style>{`
          .tv-in { border:1px solid ${C.line}; border-radius:9px; padding:8px 10px; font-family:${font}; font-size:14px; color:${C.ink}; background:#fff; width:100%; }
          .tv-in:focus { outline:none; border-color:${C.play}; }
        `}</style>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
          <div style={{ width: 44, height: 44, borderRadius: 12, background: C.play, display: "grid", placeItems: "center", fontSize: 22, flexShrink: 0 }}>👥</div>
          <div>
            <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: 0 }}>Mein Team</h2>
            <div style={{ fontSize: 13, color: C.sub }}>Name, Logo, Foto, Spieler:innen und Geräte von {myTeam.name}.</div>
          </div>
        </div>
        <TvTeamEditor t={myTeam} dispatch={dispatch} coachMode={coachMode} coaches={coaches} teams={teams} minSquad={minSquad} maxSquad={maxSquad}
          status={squadStatus(myTeam.players.length)} invitations={invitations} canDangerZone={false} />
      </div>
    );
  }

  return (
    <div style={{ fontFamily: font, color: C.ink }}>
      <style>{`
        .tv-in { border:1px solid ${C.line}; border-radius:9px; padding:8px 10px; font-family:${font}; font-size:14px; color:${C.ink}; background:#fff; width:100%; }
        .tv-in:focus { outline:none; border-color:${C.play}; }
        .tv-card:hover { border-color:${C.play}; }
      `}</style>

      {/* Slot-Kopf (konsistent mit den anderen Bausteinen) */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: C.play, display: "grid", placeItems: "center", fontSize: 22, flexShrink: 0 }}>👥</div>
        <div>
          <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: 0 }}>Team-Verwaltung</h2>
          <div style={{ fontSize: 13, color: C.sub }}>Teams, Kinder, Coaches, Geräte — das Fundament, auf das Zähler, Fairplay und Showroom zugreifen.</div>
        </div>
      </div>

      {/* SETUP / ROLLEN */}
      <TvCard title="Turnier-Rollen">
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(230px,1fr))", gap: 16 }}>
          <div>
            <TvLabel>Coaches</TvLabel>
            <input className="tv-in" placeholder="Coach-Name + Enter" value={coachInput}
              onChange={(e) => setCoachInput(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter") addCoach(); }} />
            {DEFAULT_COACH_NAMES.some((n) => !coaches.includes(n)) && (
              <div style={{ marginTop: 8 }}>
                <span style={{ fontSize: 11.5, color: C.sub }}>Schnellauswahl:</span>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 4 }}>
                  {DEFAULT_COACH_NAMES.filter((n) => !coaches.includes(n)).map((n) => (
                    <button key={n} onClick={() => addCoachName(n)}
                      style={{ border: `1px dashed ${C.line}`, background: "#fff", color: C.ink, borderRadius: 8, padding: "3px 10px", fontSize: 12.5, cursor: "pointer", fontFamily: font }}>
                      + {n}
                    </button>
                  ))}
                </div>
              </div>
            )}
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8 }}>
              {coaches.length === 0 && <span style={{ fontSize: 12, color: C.sub }}>Coach anklicken oder eigenen Namen eintragen — dann überall auswählbar.</span>}
              {coaches.map((c) => (
                <span key={c} style={{ background: C.chalk, borderRadius: 8, padding: "3px 8px 3px 10px", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 6 }}>
                  {c}
                  <TvX onClick={() => removeCoach(c)} />
                </span>
              ))}
            </div>
          </div>
          <div>
            <TvLabel>Coach-Modus</TvLabel>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <TvToggle active={coachMode === "captain"} onClick={() => rolesPatch({ coachMode: "captain" })}>Playing Captain</TvToggle>
              <TvToggle active={coachMode === "boxcoaches"} onClick={() => rolesPatch({ coachMode: "boxcoaches" })}>2 Coaches / Box</TvToggle>
            </div>
            <div style={{ fontSize: 12, color: C.sub, marginTop: 6 }}>
              {coachMode === "captain" ? "Ein Kind leitet als Captain mit an." : "Zwei Coaches pro Box, eher in der Schiri-Rolle."}
            </div>
          </div>
          <div>
            <TvLabel>Kadergröße</TvLabel>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <TvStepBtn onClick={() => setMin(minSquad - 1)}>–</TvStepBtn>
              <div style={{ fontFamily: display, fontWeight: 700, fontSize: 24, minWidth: 34, textAlign: "center" }}>{minSquad}</div>
              <TvStepBtn onClick={() => setMin(minSquad + 1)}>+</TvStepBtn>
              <span style={{ fontSize: 12.5, color: C.sub, marginLeft: 4 }}>Min. · Empfehlung 6–8</span>
            </div>
            <div style={{ fontSize: 12, color: C.sub, marginTop: 6 }}>
              Stärkere Teams max. <b style={{ color: C.ink }}>{maxSquad}</b> (Minimum + 4).
            </div>
          </div>
        </div>
      </TvCard>

      <InvitesCard />

      {/* Aktionen */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", margin: "18px 0 6px" }}>
        <button onClick={addTeam} style={tvBtnPrimary}>+ Team</button>
        <div style={{ display: "flex", alignItems: "center", gap: 6, background: "#fff", border: `1px solid ${C.line}`, borderRadius: 10, padding: "4px 6px 4px 12px" }}>
          <span style={{ fontSize: 13, color: C.sub }}>Schnell anlegen</span>
          <input type="number" min={1} max={40} value={quick} onChange={(e) => setQuick(Math.max(1, Math.min(40, +e.target.value || 1)))}
            style={{ width: 46, textAlign: "center", border: `1px solid ${C.line}`, borderRadius: 7, padding: "4px", fontFamily: display, fontWeight: 700, fontSize: 15 }} />
          <button onClick={quickAdd} style={tvBtnGhost}>los</button>
        </div>
        <NurOhneEvent><NeuesTurnierAktion style={{ ...tvBtnGhost, borderColor: C.whistle, color: C.whistle }} /></NurOhneEvent>
        <NurOhneEvent><button onClick={() => { let ok = true; try { ok = window.confirm("Alles auf Beispieldaten (Seed) zurücksetzen? Aktuelle Eingaben gehen verloren."); } catch (_) { ok = true; } if (ok) dispatch({ type: "reset" }); }} style={tvBtnGhost}>Beispieldaten neu laden</button></NurOhneEvent>
        <span style={{ marginLeft: "auto", fontFamily: display, fontWeight: 700, fontSize: 22, color: C.ink }}>
          {teams.length} <span style={{ fontSize: 13, color: C.sub, fontFamily: font, fontWeight: 500 }}>Teams</span>
        </span>
      </div>

      {/* TEAM-LISTE */}
      <div style={{ display: "grid", gap: 12, marginTop: 10 }}>
        {teams.map((t) => (
          <div key={t.id}>
            <div className="tv-card"
              onClick={() => setSelectedId(selectedId === t.id ? null : t.id)}
              style={{ background: C.card, border: `1px solid ${selectedId === t.id ? C.play : C.line}`, borderRadius: 16, padding: 14, cursor: "pointer", display: "flex", alignItems: "center", gap: 14 }}>
              <TvLogo t={t} size={46} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontFamily: display, fontWeight: 700, fontSize: 20, lineHeight: 1, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                  {t.name}
                  <TvSquadBadge status={squadStatus(t.players.length)} />
                </div>
                <div style={{ fontSize: 12.5, color: C.sub, marginTop: 3 }}>
                  {t.players.length} Spieler:in{t.players.length === 1 ? "" : "nen"}
                  {t.coach
                    ? ` · Coach ${t.coach}`
                    : <span style={{ color: "#8a5a12", fontWeight: 700 }}> · Coach fehlt</span>}
                  {` · ${t.devices.filter((d) => d.connected).length}/${t.devices.length} Handys verbunden`}
                  {t.gallery.length > 0 && ` · ${t.gallery.length} Medien`}
                </div>
              </div>
              {t.photo && <img src={t.photo} alt="" style={{ width: 46, height: 46, borderRadius: 10, objectFit: "cover", border: `1px solid ${C.line}` }} />}
              <span style={{ fontFamily: display, fontWeight: 700, color: C.sub, fontSize: 22, transform: selectedId === t.id ? "rotate(90deg)" : "none", transition: "transform .15s" }}>›</span>
            </div>

            {selectedId === t.id && (
              <TvTeamEditor t={t} dispatch={dispatch} coachMode={coachMode} coaches={coaches} teams={teams} minSquad={minSquad} maxSquad={maxSquad} status={squadStatus(t.players.length)} invitations={invitations} />
            )}
          </div>
        ))}
      </div>

      <p style={{ textAlign: "center", color: C.sub, fontSize: 12, marginTop: 30 }}>
        Baustein 1 · Geräte-Beitritt läuft übers Login (Team antippen). Medien halten nur für die Sitzung — echter Speicher folgt in Stufe 1.
      </p>
    </div>
  );
}

/* ---------------- Einladungen (Stand 30) ---------------- */
// Headcoach-Ansicht: Einladungen (Label + optionale Telefonnummer nur als
// eigene Notiz) anlegen -> jede erzeugt sofort einen neuen, leeren Team-Slot
// UND einen personalisierten Link dorthin. Der Link wird NICHT automatisch
// verschickt (kein SMS-Anbieter angebunden) -- Headcoach kopiert ihn selbst
// und verschickt ihn z.B. per WhatsApp/SMS/E-Mail an Lehrer:in/Team-Captain.
function InvitesCard() {
  const { state, dispatch } = useStore();
  const invitations = state.invitations;
  const [label, setLabel] = useState("");
  const [phone, setPhone] = useState("");
  const create = () => {
    dispatch({ type: "invite/create", label, phone });
    setLabel(""); setPhone("");
  };
  return (
    <TvCard title="Einladungen · Teams selbst anlegen lassen">
      <div style={{ fontSize: 12.5, color: C.sub, marginBottom: 12, lineHeight: 1.5 }}>
        Für jede Einladung entsteht ein eigener Team-Slot mit eigenem Link. Den Link selbst per WhatsApp, SMS oder E-Mail verschicken — die App verschickt nichts automatisch. Über den Link kann die eingeladene Person nur dieses eine Team ausfüllen (Name, Logo, Coach, Spieler:innen); fürs Zählen/Fairplay/Aufgaben am Turniertag gilt weiterhin der normale Team-Zugang.
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 14 }}>
        <div style={{ flex: "1 1 180px" }}>
          <TvLabel>Label (z. B. Klasse oder Name)</TvLabel>
          <input className="tv-in" placeholder="z. B. Frau Kaya, 3b" value={label}
            onChange={(e) => setLabel(e.target.value)} onKeyDown={(e) => e.key === "Enter" && create()} />
        </div>
        <div style={{ flex: "1 1 160px" }}>
          <TvLabel>Telefonnummer (nur eigene Notiz)</TvLabel>
          <input className="tv-in" placeholder="optional" value={phone}
            onChange={(e) => setPhone(e.target.value)} onKeyDown={(e) => e.key === "Enter" && create()} />
        </div>
        <button onClick={create} style={tvBtnPrimary}>+ Link erzeugen</button>
      </div>
      <div style={{ display: "grid", gap: 10 }}>
        {invitations.length === 0 && <span style={{ fontSize: 12.5, color: C.sub }}>Noch keine Einladungen erzeugt.</span>}
        {invitations.map((inv) => (
          <InviteRow key={inv.id} inv={inv} team={state.teams.find((t) => t.id === inv.teamId)} dispatch={dispatch} />
        ))}
      </div>
    </TvCard>
  );
}

function InviteRow({ inv, team, dispatch }) {
  const [copied, setCopied] = useState(false);
  const url = inviteUrl(inv.token);
  // Drei Zustaende statt nur zwei: "ausgefuellt" heisst nur, dass die
  // eingeladene Person etwas eingetragen hat -- den Coach darf sie nicht
  // selbst setzen (Headcoach-exklusiv, siehe InviteTeamSetup), das bleibt
  // eine offene To-do fuer den Headcoach und wird jetzt auch so angezeigt.
  const dataFilled = !!(team && (team.players.length > 0 || (team.name && !/^Team \d+$/.test(team.name))));
  const hasCoach = !!(team && team.coach && team.coach.trim());
  const status = !dataFilled ? "wartet" : !hasCoach ? "coach" : "fertig";
  const statusMeta = {
    wartet: { label: "wartet noch", color: C.sub, bg: C.chalk, border: C.line },
    coach:  { label: "Coach fehlt noch", color: "#8a5a12", bg: C.brkSoft, border: C.brk },
    fertig: { label: "ausgefüllt ✓", color: C.fair, bg: C.playSoft, border: C.play },
  }[status];
  const copy = () => {
    (async () => {
      try {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 1600);
      } catch (_) {
        // Zwischenablage evtl. gesperrt/nicht verfuegbar -- Link steht im Feld
        // darunter zum manuellen Markieren/Kopieren.
      }
    })();
  };
  return (
    <div style={{ border: `1px solid ${C.line}`, borderRadius: 10, padding: 10 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        <span style={{ fontWeight: 700, fontSize: 14 }}>{inv.label || "(ohne Namen)"}</span>
        {inv.phone && <span style={{ fontSize: 12, color: C.sub }}>· {inv.phone}</span>}
        {team && <span style={{ fontSize: 12, color: C.sub }}>· {team.name}</span>}
        <span style={{ fontSize: 11.5, fontWeight: 700, color: statusMeta.color, background: statusMeta.bg, border: `1px solid ${statusMeta.border}`, borderRadius: 6, padding: "2px 8px", marginLeft: "auto" }}>
          {statusMeta.label}
        </span>
        <TvX onClick={() => dispatch({ type: "invite/remove", id: inv.id })} />
      </div>
      <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
        <input className="tv-in" readOnly value={url} onFocus={(e) => e.target.select()} style={{ fontSize: 12 }} />
        <button onClick={copy} style={tvBtnGhost}>{copied ? "kopiert ✓" : "kopieren"}</button>
      </div>
    </div>
  );
}

/* ---------------- Team-Editor ---------------- */
function TvTeamEditor({ t, dispatch, coachMode, coaches, teams, minSquad, maxSquad, status, invitations, canDangerZone = true }) {
  const [playerName, setPlayerName] = useState("");
  const patchTeam = (patch) => dispatch({ type: "team/patch", id: t.id, patch });
  const addPlayer = () => { dispatch({ type: "player/add", teamId: t.id, name: playerName }); setPlayerName(""); };

  // Ein Coach kann immer nur einem Team zugeordnet sein (Nutzer-Vorgabe) -- vor
  // allem wichtig, weil der Coach-PIN-Login ueber team.coach genau EIN Team
  // findet (siehe Login() -> "Welcher Coach bist du?"). Coaches, die bereits
  // einem ANDEREN Team zugeordnet sind, werden hier ausgeblendet; der eigene,
  // schon gesetzte Coach bleibt trotzdem immer waehlbar sichtbar.
  const otherTeamOf = {};
  (teams || []).forEach((team) => {
    if (team.id !== t.id && team.coach) otherTeamOf[team.coach] = team.name;
  });
  const availableCoaches = coaches.filter((c) => c === t.coach || !otherTeamOf[c]);
  const takenElsewhere = coaches.filter((c) => c !== t.coach && otherTeamOf[c]);

  // Stand 31, Nachtrag 4 -- siehe InviteTeamSetup: dieselbe Namens-Konflikt-
  // Warnung auch im Headcoach/Coach-Editor (hier tritt der Fall am ehesten
  // durch manuelles Umbenennen im Team-Verwaltung-Bildschirm auf).
  const nameConflict = t.name.trim()
    ? (teams || []).find((other) => other.id !== t.id && other.name.trim().toLowerCase() === t.name.trim().toLowerCase())
    : null;

  return (
    <div style={{ background: C.card, border: `1px solid ${C.play}`, borderTop: "none", borderRadius: "0 0 14px 14px", marginTop: -6, padding: 18, position: "relative" }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))", gap: 22 }}>
        {/* Identität */}
        <div>
          <TvSubHead>Identität</TvSubHead>
          <TvLabel>Teamname</TvLabel>
          <input className="tv-in" value={t.name} onChange={(e) => patchTeam({ name: e.target.value })} />
          {nameConflict && (
            <div style={{ fontSize: 12.5, fontWeight: 600, color: "#8a5a12", background: C.brkSoft, border: `1px solid ${C.brk}`, borderRadius: 8, padding: "6px 10px", marginTop: 6 }}>
              ⚠️ Diesen Namen gibt es schon bei {nameConflict.emoji} {nameConflict.name} — bitte einen eindeutigen Namen wählen.
            </div>
          )}

          <TvLabel style={{ marginTop: 12 }}>Logo</TvLabel>
          <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
            <TvLogo t={t} size={54} />
            <div style={{ display: "flex", flexWrap: "wrap", gap: 4, maxWidth: 220 }}>
              {EMOJIS.map((e) => (
                <button key={e} onClick={() => patchTeam({ emoji: e, logoImg: null })}
                  style={{ width: 30, height: 30, borderRadius: 7, border: `1px solid ${t.emoji === e && !t.logoImg ? C.play : C.line}`, background: "#fff", fontSize: 16, cursor: "pointer", padding: 0 }}>{e}</button>
              ))}
            </div>
          </div>
          <div style={{ display: "flex", gap: 6, marginTop: 8, flexWrap: "wrap" }}>
            {TEAM_COLORS.map((c) => (
              <button key={c} onClick={() => patchTeam({ color: c })}
                style={{ width: 24, height: 24, borderRadius: "50%", background: c, border: t.color === c ? "3px solid #fff" : "none", boxShadow: t.color === c ? `0 0 0 2px ${c}` : "none", cursor: "pointer" }} />
            ))}
            <label style={tvFileBtn}>
              Bild…
              <input type="file" accept="image/*" style={{ display: "none" }} onChange={(e) => tvReadFile(e, (url) => patchTeam({ logoImg: url }))} />
            </label>
          </div>

          <TvLabel style={{ marginTop: 14 }}>Teamfoto</TvLabel>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {t.photo ? (
              <img src={t.photo} alt="" style={{ width: 88, height: 66, borderRadius: 10, objectFit: "cover", border: `1px solid ${C.line}` }} />
            ) : (
              <div style={{ width: 88, height: 66, borderRadius: 10, background: C.chalk, display: "flex", alignItems: "center", justifyContent: "center", color: C.sub, fontSize: 12, textAlign: "center", border: `1px dashed ${C.line}` }}>kein Foto</div>
            )}
            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              <label style={tvFileBtn}>
                {t.photo ? "Neu aufnehmen" : "Foto aufnehmen"}
                <input type="file" accept="image/*" capture="environment" style={{ display: "none" }} onChange={(e) => tvReadFile(e, (url) => patchTeam({ photo: url }))} />
              </label>
              {t.photo && <button onClick={() => patchTeam({ photo: null })} style={tvBtnTiny}>entfernen</button>}
            </div>
          </div>
        </div>

        {/* Personen */}
        <div>
          <TvSubHead>Personen</TvSubHead>
          <TvLabel>Coach {coachMode === "captain" ? "(leitet an)" : "(Box-Coach)"}</TvLabel>
          <select className="tv-in" value={t.coach} onChange={(e) => patchTeam({ coach: e.target.value })}>
            <option value="">— Coach wählen —</option>
            {availableCoaches.map((c) => <option key={c} value={c}>{c}</option>)}
            {t.coach && !coaches.includes(t.coach) && <option value={t.coach}>{t.coach} (nicht in Liste)</option>}
          </select>
          {coaches.length === 0 && <div style={{ fontSize: 11.5, color: C.sub, marginTop: 4 }}>Erst oben Coaches anlegen.</div>}
          {takenElsewhere.length > 0 && (
            <div style={{ fontSize: 11.5, color: C.sub, marginTop: 4 }}>
              Bereits vergeben: {takenElsewhere.map((c) => `${c} (${otherTeamOf[c]})`).join(", ")}
            </div>
          )}

          <TvLabel style={{ marginTop: 14 }}>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
              Spieler:innen · {t.players.length}/{minSquad}–{maxSquad}
              <TvSquadBadge status={status} />
              {coachMode === "captain" && <span style={{ fontWeight: 500 }}>· ⭐ = Playing Captain</span>}
            </span>
          </TvLabel>
          <div style={{ display: "flex", gap: 6 }}>
            <input className="tv-in" placeholder="Name + Enter" value={playerName}
              onChange={(e) => setPlayerName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addPlayer()} />
            <button onClick={addPlayer} style={tvBtnGhost}>+</button>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 5, marginTop: 8 }}>
            {t.players.length === 0 && <span style={{ fontSize: 12.5, color: C.sub }}>Noch keine Spieler:innen.</span>}
            {t.players.map((p) => (
              <div key={p.id} style={{ display: "flex", alignItems: "center", gap: 8, background: C.chalk, borderRadius: 8, padding: "6px 8px 6px 10px" }}>
                {coachMode === "captain" && (
                  <button title="Playing Captain" onClick={() => dispatch({ type: "player/toggleCaptain", teamId: t.id, playerId: p.id })}
                    style={{ border: "none", background: "none", cursor: "pointer", fontSize: 15, opacity: p.captain ? 1 : 0.25, padding: 0 }}>⭐</button>
                )}
                <span style={{ flex: 1, fontSize: 14, fontWeight: p.captain ? 700 : 500 }}>{p.name}</span>
                {p.goals > 0 && <span title="Tore" style={{ fontSize: 11.5, color: C.sub, fontWeight: 700 }}>⚽ {p.goals}</span>}
                <TvX onClick={() => dispatch({ type: "player/remove", teamId: t.id, playerId: p.id })} />
              </div>
            ))}
          </div>
        </div>

        {/* Geräte — 2 feste Funktions-Slots, Beitritt übers Login */}
        <div>
          <TvSubHead>Team-Geräte · Zähl + Medien</TvSubHead>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {t.devices.map((d) => (
              <div key={d.id} style={{ border: `1px solid ${d.connected ? C.fair : C.line}`, borderRadius: 10, padding: 10 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                  <span style={{ fontSize: 11.5, fontWeight: 700, color: C.fair, background: C.playSoft, borderRadius: 6, padding: "3px 8px", whiteSpace: "nowrap" }}>
                    {d.kind === "zaehl" ? "📱 Zählen" : "📷 Medien"}
                  </span>
                  <input className="tv-in" style={{ flex: 1 }} value={d.label}
                    onChange={(e) => dispatch({ type: "device/patch", teamId: t.id, deviceId: d.id, patch: { label: e.target.value } })} />
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 10, background: C.chalk, borderRadius: 8, padding: "8px 10px", flexWrap: "wrap" }}>
                  <span style={{ fontSize: 11.5, fontWeight: 700, color: d.connected ? C.fair : C.sub, background: "#fff", border: `1px solid ${d.connected ? C.fair : C.line}`, borderRadius: 6, padding: "2px 8px" }}>
                    {d.connected ? "verbunden ✓" : "offen"}
                  </span>
                  <span style={{ fontSize: 11.5, color: C.sub }}>
                    {d.connected ? "Handy ist als dieser Slot beigetreten." : "Beitritt: übers Login, Team antippen."}
                  </span>
                  {d.connected && (
                    <button onClick={() => dispatch({ type: "device/patch", teamId: t.id, deviceId: d.id, patch: { connected: false } })}
                      style={{ ...tvBtnTinyGhost, color: C.whistle, borderColor: "#F3C9C9", marginLeft: "auto" }}>trennen</button>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div style={{ fontSize: 11.5, color: C.sub, marginTop: 8 }}>
            Genau zwei Slots je Team. Die echte Geräte-Freigabe (mehrere Handys gleichzeitig) kommt in Stufe 2.
          </div>
        </div>
      </div>

      {/* Galerie */}
      <div style={{ marginTop: 20, paddingTop: 16, borderTop: `1px solid ${C.line}` }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
          <TvSubHead style={{ margin: 0 }}>Galerie · Fotos &amp; Videos</TvSubHead>
          <div style={{ display: "flex", gap: 6 }}>
            <label style={tvFileBtn}>+ Foto
              <input type="file" accept="image/*" capture="environment" style={{ display: "none" }} onChange={(e) => tvReadFile(e, (url, kind) => dispatch({ type: "gallery/add", teamId: t.id, url, kind }))} />
            </label>
            <label style={tvFileBtn}>+ Video
              <input type="file" accept="video/*" capture="environment" style={{ display: "none" }} onChange={(e) => tvReadFile(e, (url, kind) => dispatch({ type: "gallery/add", teamId: t.id, url, kind }))} />
            </label>
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(130px,1fr))", gap: 10, marginTop: 12 }}>
          {t.gallery.length === 0 && <span style={{ fontSize: 12.5, color: C.sub }}>Noch nichts hochgeladen. ⭐ markiert Highlights fürs Showroom.</span>}
          {t.gallery.map((g) => (
            <div key={g.id} style={{ border: `1px solid ${g.star ? C.brk : C.line}`, borderRadius: 10, overflow: "hidden", background: "#fff" }}>
              {g.kind === "video" ? (
                <video src={g.url} style={{ width: "100%", height: 84, objectFit: "cover", background: "#000", display: "block" }} controls />
              ) : (
                <img src={g.url} alt="" style={{ width: "100%", height: 84, objectFit: "cover", display: "block" }} />
              )}
              <div style={{ padding: 8, display: "flex", alignItems: "center", gap: 6 }}>
                <button onClick={() => dispatch({ type: "gallery/patch", teamId: t.id, itemId: g.id, patch: { star: !g.star } })}
                  title="Highlight fürs Showroom"
                  style={{ border: `1px solid ${g.star ? C.brk : C.line}`, background: g.star ? C.brkSoft : "#fff", color: g.star ? "#8a5a12" : C.sub, borderRadius: 6, padding: "2px 8px", fontSize: 11.5, fontWeight: 700, cursor: "pointer" }}>
                  {g.star ? "⭐ Highlight" : "☆ markieren"}
                </button>
                <span style={{ marginLeft: "auto" }}><TvX onClick={() => dispatch({ type: "gallery/remove", teamId: t.id, itemId: g.id })} /></span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <TeamInviteBlock team={t} invitations={invitations} dispatch={dispatch} />

      {canDangerZone && (
        <div style={{ display: "flex", gap: 8, marginTop: 18 }}>
          <button onClick={() => dispatch({ type: "team/duplicate", id: t.id })} style={tvBtnGhost}>Team duplizieren</button>
          <button onClick={() => dispatch({ type: "team/remove", id: t.id })} style={{ ...tvBtnGhost, color: C.whistle, borderColor: "#F3C9C9" }}>Team löschen</button>
        </div>
      )}
    </div>
  );
}

// Einladungslink direkt aus dem Team-Editor heraus (Stand 30, Nachtrag):
// beantwortet "wie ordne ich z.B. Team 1 einem Link zu?" -- dieses Team hier
// aufklappen, ein Klick erzeugt den Link fuer GENAU dieses (schon bestehende)
// Team, statt wie in der "Einladungen"-Karte oben einen neuen Team-Slot
// anzulegen. Weiterhin "ein Link = ein Team-Slot": Button verschwindet,
// sobald eine Einladung fuer dieses Team existiert.
function TeamInviteBlock({ team, invitations, dispatch }) {
  const [copied, setCopied] = useState(false);
  const inv = invitations.find((i) => i.teamId === team.id);
  if (!inv) {
    return (
      <div style={{ marginTop: 18, paddingTop: 16, borderTop: `1px solid ${C.line}` }}>
        <button
          onClick={() => dispatch({ type: "invite/createForTeam", teamId: team.id, label: team.name })}
          style={tvBtnGhost}>
          🔗 Einladungslink für {team.name} erzeugen
        </button>
        <div style={{ fontSize: 11.5, color: C.sub, marginTop: 6 }}>
          Damit kann z. B. der:die Coach dieses Team später selbst ausfüllen (Name, Logo, Spieler:innen) — ohne PIN.
        </div>
      </div>
    );
  }
  const url = inviteUrl(inv.token);
  const copy = () => {
    (async () => {
      try {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 1600);
      } catch (_) {
        // Zwischenablage evtl. gesperrt -- Link steht im Feld darunter zum manuellen Kopieren.
      }
    })();
  };
  return (
    <div style={{ marginTop: 18, paddingTop: 16, borderTop: `1px solid ${C.line}` }}>
      <TvLabel>Einladungslink für {team.name}</TvLabel>
      <div style={{ display: "flex", gap: 6, marginTop: 4 }}>
        <input className="tv-in" readOnly value={url} onFocus={(e) => e.target.select()} style={{ fontSize: 12 }} />
        <button onClick={copy} style={tvBtnGhost}>{copied ? "kopiert ✓" : "kopieren"}</button>
        <TvX onClick={() => dispatch({ type: "invite/remove", id: inv.id })} />
      </div>
    </div>
  );
}

/* ---------------- kleine Bausteine (Tv-präfixiert) ---------------- */
function TvCard({ title, children }) {
  return (
    <div style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 16, padding: 18 }}>
      {title && <div style={{ fontFamily: display, fontWeight: 700, fontSize: 13, letterSpacing: 1, textTransform: "uppercase", color: C.sub, marginBottom: 14 }}>{title}</div>}
      {children}
    </div>
  );
}
function TvLogo({ t, size }) {
  if (t.logoImg) return <img src={t.logoImg} alt="" style={{ width: size, height: size, borderRadius: 12, objectFit: "cover", border: `1px solid ${C.line}` }} />;
  return (
    <div style={{ width: size, height: size, borderRadius: 12, background: t.color, display: "flex", alignItems: "center", justifyContent: "center", fontSize: size * 0.5, flexShrink: 0 }}>{t.emoji}</div>
  );
}
function TvLabel({ children, style }) {
  return <div style={{ fontSize: 12.5, fontWeight: 600, color: C.sub, marginBottom: 6, ...style }}>{children}</div>;
}
function TvSubHead({ children, style }) {
  return <div style={{ fontFamily: display, fontWeight: 700, fontSize: 15, letterSpacing: 0.5, textTransform: "uppercase", color: C.ink, marginBottom: 12, ...style }}>{children}</div>;
}
function TvToggle({ active, onClick, children }) {
  return (
    <button onClick={onClick} style={{ border: `2px solid ${active ? C.play : C.line}`, background: active ? C.play : "#fff", color: active ? "#fff" : C.ink, borderRadius: 10, padding: "7px 12px", fontSize: 13.5, fontWeight: 600, cursor: "pointer", fontFamily: font }}>{children}</button>
  );
}
function TvX({ onClick }) {
  return (
    <button onClick={(e) => { e.stopPropagation(); onClick(); }} style={{ border: "none", background: "none", cursor: "pointer", color: C.sub, fontSize: 16, lineHeight: 1, padding: 2 }} title="entfernen">×</button>
  );
}
function TvStepBtn({ children, onClick }) {
  return (
    <button onClick={onClick} style={{ width: 30, height: 30, borderRadius: 8, border: `1px solid ${C.line}`, background: "#fff", fontSize: 18, lineHeight: 1, cursor: "pointer", color: C.ink, fontWeight: 700 }}>{children}</button>
  );
}
function TvSquadBadge({ status }) {
  const map = {
    ok: { c: C.fair, t: "Kader ok" },
    low: { c: C.brk, t: "unterbesetzt" },
    high: { c: C.whistle, t: "zu viele" },
  };
  const m = map[status];
  return (
    <span style={{ fontSize: 11, fontWeight: 700, color: m.c, background: "#fff", border: `1px solid ${m.c}`, borderRadius: 6, padding: "2px 7px", whiteSpace: "nowrap" }}>{m.t}</span>
  );
}

/* =====================================================================
   VIEW: ZEITPLANER  (eingehängter Baustein)
   Portiert aus zeitplaner.jsx — alle Regler laufen über tournament.config
   (via setConfig). Teams-Zahl kommt aus teams.length (Team-Verwaltung).
   Rundenplan zeigt echte Teamnamen. curRound bleibt lokale UI.
   ===================================================================== */

const zpFmtClock = (min) => {
  const h = Math.floor(min / 60) % 24;
  const m = Math.round(min % 60);
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};
const zpFmtDur = (min) => {
  const v = Math.round(min * 10) / 10;
  return Number.isInteger(v) ? `${v} min` : `${v.toFixed(1)} min`;
};
const zpNavBtnStyle = (disabled) => ({
  border: `2px solid ${disabled ? C.line : C.ink}`, background: disabled ? "#fff" : C.ink,
  color: disabled ? C.sub : "#fff", borderRadius: 10, padding: "8px 16px", fontFamily: font,
  fontWeight: 600, fontSize: 14, cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.6 : 1,
});
// Round-robin per Kreismethode; -1 = Freilos (bye-aware, für die "frei"-Anzeige)
function zpRoundRobin(n) {
  const teams = [];
  for (let i = 0; i < n; i++) teams.push(i);
  if (teams.length % 2 === 1) teams.push(-1);
  const m = teams.length;
  const rounds = [];
  const arr = teams.slice();
  for (let r = 0; r < m - 1; r++) {
    const pairs = [];
    for (let i = 0; i < m / 2; i++) {
      const a = arr[i], b = arr[m - 1 - i];
      if (a !== -1 && b !== -1) pairs.push([a, b]);
      else pairs.push([a === -1 ? b : a, -1]);
    }
    rounds.push(pairs);
    const fixed = arr[0];
    const rest = arr.slice(1);
    rest.unshift(rest.pop());
    arr.splice(0, arr.length, fixed, ...rest);
  }
  return rounds;
}

function Zeitplaner() {
  const { state, dispatch } = useStore();
  const cfg = state.tournament.config;
  const teams = state.teams;
  const numTeams = teams.length;
  const [curRound, setCurRound] = useState(0);
  const role = state.role;
  const canEditConfig = role === "headcoach"; // nur Headcoach darf die Zeitplanung aendern
  const zStarted = tournamentStarted(state);
  const canEditZaehlModus = canEditConfig && !zStarted; // Zaehl-Modus (Gegner-Test) nur vor Turnierstart aenderbar, auch fuer den Headcoach

  const setCfg = (key, value) => dispatch({ type: "setConfig", key, value });

  // echte Teamnamen statt "Team N"
  const tName = (i) => (i === -1 ? "frei" : (teams[i] ? teams[i].name : `Team ${i + 1}`));
  const tEmoji = (i) => (i === -1 || !teams[i] ? "" : teams[i].emoji);

  const { openEnd, context, customMin, ue, mode, checkin, warmup, ceremony, uePause, wechsel, sommer, gameDur, targetRR, startClock, boxOverride, zaehlModus } = cfg;

  const perBox = mode === "dauer" ? 2 : 4;
  const needBoxes = Math.max(1, Math.ceil(numTeams / perBox));
  const maxBoxes = context === "schule" ? 6 : 999;
  const boxes = Math.min(maxBoxes, Math.max(1, boxOverride ?? 1));

  const baseRounds = useMemo(() => zpRoundRobin(numTeams), [numTeams]);

  // Stand 37e: EINE Rechnung mit dem Live-Plan (zeitplanRechnung). Ganze Durchgaenge
  // (targetRR) sind fix -- passt die Zeit nicht, wird die Spieldauer gekuerzt.
  const zp = useMemo(() => zeitplanRechnung(cfg, numTeams), [cfg, numTeams]);
  const { wallPerRR, uePauseTotal, grossTotal, drinkCount, drinkTotal, fixedTotal, netWindow, durForTarget } = zp;
  const result = { repeats: zp.passes, wallRounds: zp.wallRounds, gameDur: zp.effDur, usedPlay: zp.usedPlay, totalTime: zp.totalTime, buffer: zp.buffer, tooShort: zp.effDur < 1.5, gekuerzt: zp.gekuerzt, zuKnapp: zp.zuKnapp };

  const segments = useMemo(() => {
    const segs = [];
    segs.push({ type: "fixed", label: "Check-in + Foto", dur: checkin });
    segs.push({ type: "fixed", label: "Einspielen", dur: warmup });
    const wr = result.wallRounds;
    const playPerRound = result.gameDur;
    const drinkEvery = drinkCount > 0 ? Math.ceil(wr / (drinkCount + 1)) : Infinity;
    for (let r = 0; r < wr; r++) {
      segs.push({ type: "play", label: `Runde ${r + 1}`, dur: playPerRound });
      if (r < wr - 1) segs.push({ type: "brk", label: "Wechsel", dur: wechsel });
      if (drinkEvery !== Infinity && (r + 1) % drinkEvery === 0 && r < wr - 1) segs.push({ type: "brk", label: "Trinkpause", dur: 3 });
    }
    segs.push({ type: "fixed", label: "Siegerehrung + Feedback", dur: ceremony });
    return segs;
  }, [result, checkin, warmup, ceremony, wechsel, drinkCount]);

  const timelineTotal = segments.reduce((a, s) => a + s.dur, 0);

  const scheduleDauer = useMemo(() => {
    if (mode !== "dauer") return [];
    const out = [];
    let idx = 0;
    baseRounds.forEach((pairs) => {
      const real = pairs.filter((p) => p[1] !== -1);
      const byes = pairs.filter((p) => p[1] === -1).map((p) => p[0]);
      out.push({ n: ++idx, boxes: real.map((p, bi) => ({ box: (bi % boxes) + 1, a: p[0], b: p[1] })), frei: byes });
    });
    return out;
  }, [mode, baseRounds, boxes]);

  const cur = Math.min(curRound, Math.max(0, scheduleDauer.length - 1));
  const curRoundData = scheduleDauer[cur] || { boxes: [], frei: [] };

  return (
    <div style={{ fontFamily: font, color: C.ink }}>
      <style>{`
        .zp-slider { -webkit-appearance:none; appearance:none; width:100%; height:6px; border-radius:6px; background:${C.line}; outline:none; }
        .zp-slider::-webkit-slider-thumb { -webkit-appearance:none; width:20px; height:20px; border-radius:50%; background:${C.play}; cursor:pointer; border:3px solid #fff; box-shadow:0 1px 4px rgba(16,32,58,.25); }
        .zp-slider::-moz-range-thumb { width:20px; height:20px; border-radius:50%; background:${C.play}; cursor:pointer; border:3px solid #fff; }
        .zp-seg:hover { filter:brightness(0.96); }
        .zp-chip { transition: all .12s ease; cursor:pointer; }
      `}</style>

      {/* Slot-Kopf */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: C.play, display: "grid", placeItems: "center", fontSize: 22, flexShrink: 0 }}>🗓️</div>
        <div>
          <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: 0 }}>Zeitplaner</h2>
          <div style={{ fontSize: 13, color: C.sub }}>Zeitrahmen wählen, Rundherum-Zeiten abziehen — die App findet die Spieldauer, in der jeder mindestens {targetRR}× gegen jeden spielt.</div>
        </div>
      </div>

      {numTeams < 2 ? (
        <ZpCard>
          <p style={{ margin: 0, fontSize: 14.5, color: C.sub }}>
            Noch zu wenige Teams für einen Spielplan. Lege zuerst in der <b style={{ color: C.ink }}>Team-Verwaltung</b> mindestens 2 Teams an — der Zeitplaner rechnet dann automatisch.
          </p>
        </ZpCard>
      ) : (
      <>
        {!canEditConfig && (
          <div style={{ background: C.playSoft, border: `1px solid ${C.line}`, borderRadius: 12, padding: "10px 14px", marginBottom: 14, fontSize: 13, color: C.fair }}>
            Nur der Headcoach kann die Zeitplan-Einstellungen ändern. Du siehst hier den aktuellen Plan.
          </div>
        )}
        {/* ---- EINGABEN ---- */}
        <fieldset disabled={!canEditConfig} style={{ border: "none", padding: 0, margin: 0, minWidth: 0 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 14 }}>
          {/* Turnier-Art */}
          <ZpCard title="Turnier-Art">
            <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
              <ZpModeChip active={context === "schule"} onClick={() => setCfg("context", "schule")} title="Schulturnier" sub="Feste UE · max. 6 Boxen" />
              <ZpModeChip active={context === "individuell"} onClick={() => setCfg("context", "individuell")} title="Individuell" sub="Freie Zeit · Boxen ohne Limit" />
            </div>

            {context === "schule" ? (
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                {[{ v: 2, s: "100 min" }, { v: 3, s: "150 min" }, { v: 4, s: "200 min" }, { v: 8, s: "400 min" }].map((o) => (
                  <ZpChip key={o.v} active={!openEnd && ue === o.v} onClick={() => { setCfg("openEnd", false); setCfg("ue", o.v); }}>
                    <span style={{ fontFamily: display, fontWeight: 700, fontSize: 18 }}>{o.v} UE</span>
                    <span style={{ fontSize: 12, opacity: 0.7, marginLeft: 6 }}>{o.s}</span>
                  </ZpChip>
                ))}
              </div>
            ) : (
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }}>
                <ZpChip active={!openEnd} onClick={() => setCfg("openEnd", false)}>Feste Zeit</ZpChip>
                {!openEnd && <ZpNumberField label="Minuten gesamt" value={customMin} set={(v) => setCfg("customMin", v)} min={20} max={600} step={5} />}
                <ZpChip active={openEnd} onClick={() => setCfg("openEnd", true)} accent={C.fair}>Open End</ZpChip>
              </div>
            )}

            {!openEnd && (
              <label style={{ display: "inline-flex", alignItems: "center", gap: 8, marginTop: 12, fontSize: 14, color: C.sub, cursor: "pointer" }}>
                <input type="checkbox" checked={sommer} onChange={(e) => setCfg("sommer", e.target.checked)} />
                Trinkpausen einplanen ({drinkCount}× 3 min)
              </label>
            )}
          </ZpCard>

          {/* Teams + Boxen */}
          <ZpCard title="Teams & Boxen">
            <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "flex-end" }}>
              <div style={{ background: C.playSoft, borderRadius: 10, padding: "8px 12px" }}>
                <div style={{ fontSize: 12, color: C.fair, marginBottom: 4, fontWeight: 700 }}>Teams (aus Team-Verwaltung)</div>
                <div style={{ fontFamily: display, fontWeight: 700, fontSize: 26, color: C.ink, lineHeight: 1 }}>{numTeams}</div>
              </div>
              <div style={{ display: "flex", alignItems: "flex-end", gap: 10 }}>
                <ZpNumberField label="Boxen" value={boxes} set={(v) => setCfg("boxOverride", v)} min={1} max={maxBoxes} big />
                <ZpChip small active={boxOverride === null} onClick={() => setCfg("boxOverride", null)} accent={C.fair}>Auto (1)</ZpChip>
              </div>
            </div>

            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 14 }}>
              <ZpModeChip active={mode === "dauer"} onClick={() => setCfg("mode", "dauer")} title="2 Teams / Box" sub="Alle spielen durchgehend" />
              <ZpModeChip active={mode === "aufgaben"} onClick={() => setCfg("mode", "aufgaben")} title="4 Teams / Box" sub="Wartende lösen Fairplay-Aufgaben" />
            </div>

            <div style={{ marginTop: 12, fontSize: 13, color: C.sub, background: C.chalk, padding: "8px 12px", borderRadius: 10 }}>
              {boxes >= needBoxes ? (
                <>Alle {mode === "dauer" ? "Paarungen" : "Gruppen"} laufen <b style={{ color: C.ink }}>parallel</b> — mehr Boxen ändern die Spielzeit nicht, nur wie viele Teams gleichzeitig dran sind.{context === "schule" && " Im Schulturnier max. 6 Boxen."}</>
              ) : (
                <span style={{ color: C.whistle }}>Für alle gleichzeitig bräuchtest du {needBoxes} Boxen — mit {boxes} spielen nicht alle parallel.{context === "schule" && " (Schulturnier: max. 6. Für mehr auf Individuell wechseln.)"}</span>
              )}
            </div>
          </ZpCard>

          {/* Zaehl-Modus (experimentell): eigenes oder gegnerisches Team zaehlen */}
          <fieldset disabled={!canEditZaehlModus} style={{ border: "none", padding: 0, margin: 0, minWidth: 0 }}>
          <ZpCard title="Zähl-Modus (Zähl-Handy)">
            <div style={{ fontSize: 13, color: C.sub, marginBottom: 12 }}>
              Experimentell: zählt das Zähl-Handy an der Box das <b>eigene</b> Team
              oder das <b>gegnerische</b> Team (den jeweils aktuellen Gegner laut
              Rundenplan)? Gilt für alle Zähl-Handys gleichzeitig und lässt sich
              nur <b>vor Turnierstart</b> festlegen.
            </div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <ZpModeChip active={zaehlModus !== "gegner"} onClick={() => setCfg("zaehlModus", "eigen")} title="Eigenes Team" sub="wie bisher" />
              <ZpModeChip active={zaehlModus === "gegner"} onClick={() => setCfg("zaehlModus", "gegner")} title="Gegnerisches Team" sub="testweise: zählt den aktuellen Gegner" />
            </div>
            {zStarted && (
              <div style={{ marginTop: 10, fontSize: 12.5, color: C.whistle }}>Turnier läuft bereits — der Zähl-Modus ist jetzt fix.</div>
            )}
          </ZpCard>
          </fieldset>

          {/* Rundherum-Zeiten */}
          <ZpCard title="Rundherum-Zeiten (fix, editierbar)">
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(140px,1fr))", gap: 10 }}>
              <ZpStepper label="Check-in + Foto" value={checkin} set={(v) => setCfg("checkin", v)} min={0} max={20} />
              <ZpStepper label="Einspielen" value={warmup} set={(v) => setCfg("warmup", v)} min={0} max={30} />
              <ZpStepper label="Siegerehrung" value={ceremony} set={(v) => setCfg("ceremony", v)} min={0} max={30} />
              <ZpStepper label="Wechselpause" value={wechsel} set={(v) => setCfg("wechsel", v)} min={1} max={2} step={0.5} />
              {!openEnd && context === "schule" && <ZpStepper label="Pause / UE" value={uePause} set={(v) => setCfg("uePause", v)} min={0} max={15} />}
            </div>
          </ZpCard>
        </div>
        </fieldset>

        {/* ---- STELLSCHRAUBE ---- */}
        <ZpSectionLabel>Stellschraube</ZpSectionLabel>
        <fieldset disabled={!canEditConfig} style={{ border: "none", padding: 0, margin: 0, minWidth: 0 }}>
        <ZpCard>
          <ZpRow label={`Spieldauer pro Match: ${zpFmtDur(gameDur)}`}>
            <input className="zp-slider" type="range" min={1} max={8} step={0.5} value={gameDur} onChange={(e) => setCfg("gameDur", +e.target.value)} />
          </ZpRow>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 12, alignItems: "center" }}>
            <span style={{ fontSize: 13, color: C.sub }}>Ziel „jeder gegen jeden":</span>
            {[1, 2, 3, 4].map((r) => (
              <ZpChip key={r} small active={targetRR === r} onClick={() => setCfg("targetRR", r)}>{r}×</ZpChip>
            ))}
            {!openEnd && durForTarget > 0 && (
              <button onClick={() => setCfg("gameDur", Math.max(1, Math.floor(durForTarget * 2) / 2))}
                style={{ marginLeft: "auto", border: "none", background: C.play, color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 14, padding: "8px 14px", borderRadius: 10, cursor: "pointer" }}>
                Auf {targetRR}× einpassen ({zpFmtDur(durForTarget)})
              </button>
            )}
          </div>
        </ZpCard>
        </fieldset>

        {/* ---- ERGEBNIS ---- */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: 12, marginTop: 16 }}>
          <ZpStat big value={`${result.repeats}×`} label="jeder gegen jeden" tone={result.zuKnapp ? C.whistle : C.fair} />
          <ZpStat value={zpFmtDur(result.gameDur)} label={result.gekuerzt ? "pro Match (gekürzt)" : "pro Match"} tone={result.gekuerzt ? C.brk : C.play} />
          <ZpStat value={`${result.wallRounds}`} label="Spielrunden" tone={C.ink} />
          <ZpStat value={openEnd ? zpFmtDur(result.totalTime) : zpFmtDur(Math.max(0, result.buffer))} label={openEnd ? "Gesamtdauer" : "Zeitpuffer"} tone={C.ink} />
        </div>

        {result.gekuerzt && !result.zuKnapp && (
          <ZpNote tone={C.brk}>Damit {targetRR}× jeder gegen jeden ganz ins Zeitfenster passt, wird pro Match <b>{zpFmtDur(result.gameDur)}</b> gespielt (statt {zpFmtDur(gameDur)}). Halbe Durchgänge gibt es nicht.</ZpNote>
        )}
        {result.zuKnapp && (
          <ZpNote tone={C.whistle}>Selbst mit 1-Minuten-Matches passen {targetRR}× jeder gegen jeden nicht ins Zeitfenster. Weniger Durchgänge oder mehr Zeit wählen.</ZpNote>
        )}
        {result.buffer > 12 && !openEnd && !result.gekuerzt && (
          <ZpNote tone={C.fair}>{zpFmtDur(result.buffer)} übrig — Platz für längere Matches oder einen weiteren Durchgang.</ZpNote>
        )}

        {/* ---- ZEITLEISTE ---- */}
        <ZpSectionLabel>So läuft der Tag</ZpSectionLabel>
        <ZpCard>
          <div style={{ display: "flex", height: 34, borderRadius: 8, overflow: "hidden", border: `1px solid ${C.line}` }}>
            {segments.map((s, i) => {
              const bg = s.type === "play" ? C.play : s.type === "brk" ? C.brk : C.fixed;
              const w = timelineTotal > 0 ? (s.dur / timelineTotal) * 100 : 0;
              return <div key={i} className="zp-seg" title={`${s.label} · ${zpFmtDur(s.dur)}`} style={{ width: `${w}%`, background: bg, minWidth: w > 0 ? 2 : 0 }} />;
            })}
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6, fontSize: 12, color: C.sub }}>
            <span>{zpFmtClock(startClock)}</span>
            <span>{isFinite(timelineTotal) ? zpFmtClock(startClock + timelineTotal) : "—"}</span>
          </div>
          <div style={{ display: "flex", gap: 16, marginTop: 12, flexWrap: "wrap", fontSize: 12 }}>
            <ZpLegend color={C.fixed} label="Fix (Check-in, Einspielen, Ehrung)" />
            <ZpLegend color={C.play} label="Spielrunden" />
            <ZpLegend color={C.brk} label="Pausen" />
          </div>
        </ZpCard>

        {/* ---- TEAM-WEGWEISER ---- */}
        {mode === "dauer" && scheduleDauer.length > 0 && (
          <>
            <ZpSectionLabel>Wohin als Nächstes?</ZpSectionLabel>
            <ZpCard>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
                <button onClick={() => setCurRound(Math.max(0, cur - 1))} disabled={cur === 0} style={zpNavBtnStyle(cur === 0)}>◀ zurück</button>
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontFamily: display, fontWeight: 700, fontSize: 28, color: C.ink, lineHeight: 1 }}>Runde {cur + 1}</div>
                  <div style={{ fontSize: 12.5, color: C.sub }}>von {scheduleDauer.length} im Durchgang</div>
                </div>
                <button onClick={() => setCurRound(Math.min(scheduleDauer.length - 1, cur + 1))} disabled={cur === scheduleDauer.length - 1} style={zpNavBtnStyle(cur === scheduleDauer.length - 1)}>weiter ▶</button>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(160px,1fr))", gap: 10 }}>
                {Array.from({ length: numTeams }).map((_, t) => {
                  const slot = curRoundData.boxes.find((m) => m.a === t || m.b === t);
                  const opp = slot ? (slot.a === t ? slot.b : slot.a) : null;
                  const paused = !slot;
                  return (
                    <div key={t} style={{ display: "flex", alignItems: "center", gap: 10, border: `1px solid ${C.line}`, borderRadius: 12, padding: "10px 12px", background: paused ? C.chalk : "#fff" }}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontWeight: 700, fontSize: 15 }}>{tEmoji(t)} {tName(t)}</div>
                        <div style={{ fontSize: 12, color: C.sub }}>{paused ? "Pause / Aufgabe" : `vs ${tName(opp)}`}</div>
                      </div>
                      <div style={{ fontFamily: display, fontWeight: 700, fontSize: 15, color: "#fff", background: paused ? C.fixed : C.play, borderRadius: 9, padding: "6px 10px", whiteSpace: "nowrap" }}>
                        {paused ? "—" : `BOX ${slot.box}`}
                      </div>
                    </div>
                  );
                })}
              </div>
              <p style={{ fontSize: 12, color: C.sub, marginTop: 12, marginBottom: 0 }}>
                Nach jedem Spiel eine Runde weiterklicken — jedes Team sieht sofort seine nächste Box. Das Muster wiederholt sich jeden Durchgang und läuft auf Beamer oder Tablet.
              </p>
            </ZpCard>
          </>
        )}

        {/* ---- RUNDENPLAN ---- */}
        <ZpSectionLabel>Rundenplan {mode === "dauer" ? "(1. Durchgang)" : ""}</ZpSectionLabel>
        {mode === "dauer" ? (
          <ZpCard>
            <div style={{ display: "grid", gap: 8 }}>
              {scheduleDauer.map((rnd) => (
                <div key={rnd.n} style={{ display: "flex", gap: 10, alignItems: "center", padding: "10px 12px", background: C.chalk, borderRadius: 10, flexWrap: "wrap" }}>
                  <div style={{ fontFamily: display, fontWeight: 700, fontSize: 20, color: C.play, minWidth: 32 }}>{rnd.n}</div>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap", flex: 1 }}>
                    {rnd.boxes.map((m) => (
                      <div key={m.box} style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 8, padding: "4px 10px", fontSize: 13, display: "flex", alignItems: "center", gap: 8 }}>
                        <span style={{ fontFamily: display, fontWeight: 700, fontSize: 11, color: "#fff", background: C.ink, borderRadius: 5, padding: "1px 6px" }}>BOX {m.box}</span>
                        <b>{tName(m.a)}</b><span style={{ color: C.sub }}>vs</span><b>{tName(m.b)}</b>
                      </div>
                    ))}
                    {rnd.frei.length > 0 && <div style={{ fontSize: 12, color: C.sub, alignSelf: "center" }}>frei: {rnd.frei.map(tName).join(", ")}</div>}
                  </div>
                </div>
              ))}
            </div>
            <p style={{ fontSize: 12, color: C.sub, marginTop: 10, marginBottom: 0 }}>
              Ein voller Durchgang = {scheduleDauer.length} Spielrunden. Bei {result.repeats}× wird der Plan {result.repeats}-mal wiederholt.
            </p>
          </ZpCard>
        ) : (
          <ZpCard>
            <p style={{ margin: 0, fontSize: 14, color: C.sub }}>
              4 Teams pro Box: je Box läuft ein eigenes „jeder gegen jeden". Immer 2 Teams spielen, die anderen 2 lösen währenddessen die Fairplay-Gruppenaufgaben. Der Match-Plan pro Box und die Aufgaben-Zuteilung kommen mit den Bausteinen Live-Zähler/Aufgaben — hier ist die Zeitrechnung dafür schon korrekt ({result.wallRounds} Spielrunden).
            </p>
          </ZpCard>
        )}
      </>
      )}
    </div>
  );
}

/* ---------- Zeitplaner-Helfer (Zp-präfixiert) ---------- */
function ZpCard({ title, children }) {
  return (
    <div style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 16, padding: 18, boxShadow: "0 1px 2px rgba(16,32,58,.04)" }}>
      {title && <div style={{ fontFamily: display, fontWeight: 700, fontSize: 13, letterSpacing: 1, textTransform: "uppercase", color: C.sub, marginBottom: 12 }}>{title}</div>}
      {children}
    </div>
  );
}
function ZpSectionLabel({ children }) {
  return (
    <div style={{ fontFamily: display, fontWeight: 700, fontSize: 15, letterSpacing: 1, textTransform: "uppercase", color: C.ink, margin: "26px 0 12px", display: "flex", alignItems: "center", gap: 10 }}>
      {children}
      <div style={{ height: 3, flex: 1, background: C.line, borderRadius: 3 }} />
    </div>
  );
}
function ZpChip({ children, active, onClick, small, accent = C.play }) {
  return (
    <button className="zp-chip" onClick={onClick} style={{ border: `2px solid ${active ? accent : C.line}`, background: active ? accent : "#fff", color: active ? "#fff" : C.ink, borderRadius: 12, padding: small ? "6px 12px" : "8px 14px", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: font }}>{children}</button>
  );
}
function ZpModeChip({ active, onClick, title, sub }) {
  return (
    <button className="zp-chip" onClick={onClick} style={{ flex: "1 1 180px", textAlign: "left", border: `2px solid ${active ? C.play : C.line}`, background: active ? C.playSoft : "#fff", borderRadius: 12, padding: "10px 14px", cursor: "pointer" }}>
      <div style={{ fontFamily: display, fontWeight: 700, fontSize: 17, color: C.ink }}>{title}</div>
      <div style={{ fontSize: 12.5, color: C.sub, marginTop: 2 }}>{sub}</div>
    </button>
  );
}
function ZpRow({ label, children }) {
  return (<div><div style={{ fontSize: 14, fontWeight: 600, marginBottom: 8 }}>{label}</div>{children}</div>);
}
function ZpNumberField({ label, value, set, min, max, step = 1, big }) {
  const clamp = (v) => Math.min(max, Math.max(min, v));
  return (
    <div style={{ background: C.chalk, borderRadius: 10, padding: "8px 10px", display: "inline-block" }}>
      {label && <div style={{ fontSize: 12, color: C.sub, marginBottom: 6 }}>{label}</div>}
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <ZpStepBtn onClick={() => set(clamp(Math.round((value - step) * 10) / 10))}>–</ZpStepBtn>
        <input type="number" value={value} min={min} max={max} onChange={(e) => set(clamp(e.target.value === "" ? min : +e.target.value))}
          style={{ width: big ? 68 : 60, textAlign: "center", fontFamily: display, fontWeight: 700, fontSize: big ? 22 : 20, border: `1px solid ${C.line}`, borderRadius: 8, padding: "4px 2px", color: C.ink, background: "#fff" }} />
        <ZpStepBtn onClick={() => set(clamp(Math.round((value + step) * 10) / 10))}>+</ZpStepBtn>
      </div>
    </div>
  );
}
function ZpStepper({ label, value, set, min, max, step = 1 }) {
  return (
    <div style={{ background: C.chalk, borderRadius: 10, padding: "8px 10px" }}>
      <div style={{ fontSize: 12, color: C.sub, marginBottom: 6 }}>{label}</div>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <ZpStepBtn onClick={() => set(Math.max(min, Math.round((value - step) * 10) / 10))}>–</ZpStepBtn>
        <div style={{ fontFamily: display, fontWeight: 700, fontSize: 20, minWidth: 44, textAlign: "center" }}>
          {value}<span style={{ fontSize: 11, color: C.sub, fontFamily: font, fontWeight: 500 }}> min</span>
        </div>
        <ZpStepBtn onClick={() => set(Math.min(max, Math.round((value + step) * 10) / 10))}>+</ZpStepBtn>
      </div>
    </div>
  );
}
function ZpStepBtn({ children, onClick }) {
  return (<button onClick={onClick} style={{ width: 30, height: 30, borderRadius: 8, border: `1px solid ${C.line}`, background: "#fff", fontSize: 18, lineHeight: 1, cursor: "pointer", color: C.ink, fontWeight: 700 }}>{children}</button>);
}
function ZpStat({ value, label, tone, big }) {
  return (
    <div style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 16, padding: "14px 16px" }}>
      <div style={{ fontFamily: display, fontWeight: 700, fontSize: big ? 34 : 28, color: tone, lineHeight: 1 }}>{value}</div>
      <div style={{ fontSize: 12.5, color: C.sub, marginTop: 4 }}>{label}</div>
    </div>
  );
}
function ZpNote({ children, tone }) {
  return (<div style={{ marginTop: 12, background: "#fff", border: `1px solid ${C.line}`, borderLeftWidth: 4, borderLeftColor: tone, borderRadius: 10, padding: "10px 14px", fontSize: 13.5, color: C.ink }}>{children}</div>);
}
function ZpLegend({ color, label }) {
  return (<span style={{ display: "inline-flex", alignItems: "center", gap: 6, color: C.sub }}><span style={{ width: 12, height: 12, borderRadius: 3, background: color }} />{label}</span>);
}

/* =====================================================================
   BAUSTEIN: LIVE-ZÄHLER  (an den Store gehängt · Stand 5)
   Erster View, der echte Tore ERZEUGT und in die "Wahrheit" schreibt:
   Einzelspiel → team.tore · Teamspiel → team.teamspielTore (zählt doppelt)
   · Torschütze → player.goals. Wertung & Gesamtwertung lesen daraus.
   Rolle kommt aus dem Login (kein eigener Umschalter/Hero/Logo mehr):
   • Teamzugang (Zähl-Handy): zählt NUR das eigene Team.
   • Coach: dieselbe Oberfläche, Team an der Box wählbar.
   • Headcoach: alle Teams live + VAR-Korrektur + Doppel-Zählung/Abgleich.
   ===================================================================== */

// Abgleich (Anti-Schummel-Staffel, Regel unverändert):
// pro Seite gleich → gilt · Diff < Ø-Schwelle → höhere Zahl · sonst Ø aufgerundet.
// Weicht eine Seite um ≥ Null-Schwelle ab → ganzes Spiel 0:0 (zählt nicht).
function lzResolveSide(x, y, avgThr) {
  if (x === y) return { v: x, s: "ok" };
  const diff = Math.abs(x - y);
  if (diff < avgThr) return { v: Math.max(x, y), s: "auto" };
  return { v: Math.ceil((x + y) / 2), s: "avg" };
}
function lzResolveScore(A, B, avgThr, nullThr) {
  const dA = Math.abs(A.sa - B.sa);
  const dC = Math.abs(A.sb - B.sb);
  if (dA >= nullThr || dC >= nullThr) return { final: { sa: 0, sb: 0 }, status: "null" };
  const a = lzResolveSide(A.sa, B.sa, avgThr);
  const c = lzResolveSide(A.sb, B.sb, avgThr);
  const status = a.s === "avg" || c.s === "avg" ? "avg" : a.s === "auto" || c.s === "auto" ? "auto" : "ok";
  return { final: { sa: a.v, sb: c.v }, status };
}
const lzBasis = (t, f) => t.tore + t.teamspielTore * (f && f.teamspiel != null ? f.teamspiel : 2);
const lzSelStyle = { border: `1px solid ${C.line}`, background: "#fff", borderRadius: 9, padding: "8px 10px", fontFamily: font, fontWeight: 600, fontSize: 14, color: C.ink };

function LiveZaehler() {
  const { state } = useStore();
  const role = state.role;
  // Stand 36: grosse Daumen-Ansicht (alte LzTeamGeraet bleibt als Fallback im Code)
  if (role === "teamaccess") return <ZaehlenGross lockedTeamId={state.boundTeamId} />;
  if (role === "coach") return <ZaehlenGross />;
  return <LzHeadcoach />; // headcoach (und Fallback)
}

// Slot-Kopf (konsistent mit den anderen Bausteinen)
function LzHead({ sub }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
      <div style={{ width: 44, height: 44, borderRadius: 12, background: C.play, display: "grid", placeItems: "center", fontSize: 22, flexShrink: 0 }}>🔢</div>
      <div>
        <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: 0 }}>Live-Zähler</h2>
        <div style={{ fontSize: 13, color: C.sub }}>{sub}</div>
      </div>
    </div>
  );
}

/* ================= TEAM-GERÄT (Teamzugang / Coach) ================= */
function LzTeamGeraet({ lockedTeamId = null }) {
  const { state, dispatch } = useStore();
  const teams = state.teams;
  const locked = lockedTeamId != null;
  const f = state.factors;
  const zaehlModus = state.tournament.config.zaehlModus || "eigen";

  const [selId, setSelId] = useState(lockedTeamId != null ? lockedTeamId : (teams[0] ? teams[0].id : null));
  const teamId = locked ? lockedTeamId : selId;
  const team = teams.find((t) => t.id === teamId) || null;

  // Gegner-Modus (experimentell, state.tournament.config.zaehlModus): zaehlt
  // NICHT das eigene (gebundene) Team, sondern das gerade tatsaechliche
  // gegnerische Team, abgeleitet aus derselben Paarungs-Wahrheit wie der
  // Zeitplaner (currentOpponentTeamId) -- kein zweiter Paarungs-Speicher.
  // Ohne Gegner (Freilos / Turnier noch nicht gestartet) faellt es aufs
  // eigene Team zurueck.
  const opponentId = team && zaehlModus === "gegner" ? currentOpponentTeamId(state, team.id) : null;
  const opponent = opponentId ? teams.find((t) => t.id === opponentId) : null;
  const creditTeam = opponent || team;

  // Kein Einzelspiel/Teamspiel-Umschalter mehr am Zaehl-Handy: es zaehlt immer
  // nur das laufende Spiel (Einzelspiel). Teamspiel-Tore bleiben eine reine
  // Nachtrags-Korrektur des Headcoach in "Wertung" (goal/adjust).
  const [hist, setHist] = useState([]);           // sitzungsweise: [{ playerId }]
  const [pending, setPending] = useState(-1);     // Index in hist, der auf Torschützen-Tipp wartet

  if (!team) {
    return (
      <div style={{ fontFamily: font, color: C.ink }}>
        <LzHead sub="Tore zählen — die Basis für Wertung & Gesamtwertung." />
        <Card><div style={{ color: C.sub, fontSize: 14 }}>Noch keine Teams angelegt. Erst in der <b>Team-Verwaltung</b> Teams anlegen.</div></Card>
      </div>
    );
  }

  const addGoal = () => {
    dispatch({ type: "goal/add", teamId: creditTeam.id, phase: "einzel", playerId: null });
    setPending(hist.length);                                  // neues Tor sitzt am Ende
    setHist((h) => [...h, { playerId: null }]);
  };
  const attribute = (playerId) => {
    if (pending < 0) return;
    dispatch({ type: "player/adjustGoals", teamId: creditTeam.id, playerId, delta: +1 });
    setHist((h) => h.map((g, i) => (i === pending ? { ...g, playerId } : g)));
    setPending(-1);
  };
  const undo = () => {
    if (!hist.length) return;
    const idx = hist.length - 1;
    const last = hist[idx];
    dispatch({ type: "goal/undo", teamId: creditTeam.id, phase: "einzel", playerId: last.playerId });
    setHist((h) => h.slice(0, -1));
    setPending((p) => (p >= idx ? -1 : p));
  };

  const scorers = [...creditTeam.players].sort((a, b) => b.goals - a.goals);

  return (
    <div style={{ fontFamily: font, color: C.ink }}>
      <LzHead sub={locked ? "Ihr zählt nur euer eigenes Team." : "Coach: Team an deiner Box wählen und mitzählen."} />

      {!locked ? (
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14, flexWrap: "wrap" }}>
          <span style={{ fontSize: 13.5, color: C.sub }}>Team an der Box</span>
          <select value={team.id} onChange={(e) => { setSelId(+e.target.value); setHist([]); setPending(-1); }} style={lzSelStyle}>
            {teams.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
        </div>
      ) : (
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14, background: C.playSoft, border: `1px solid ${C.play}`, borderRadius: 12, padding: "10px 14px" }}>
          <span style={{ width: 30, height: 30, borderRadius: 8, background: team.color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>{team.emoji}</span>
          <span style={{ fontSize: 13.5, color: C.fair, fontWeight: 700 }}>Euer Team: {team.name} — nur ihr zählt hier.</span>
        </div>
      )}

      {/* Gegner-Modus (experimentell): macht sichtbar, wofuer der Zaehler gerade laeuft */}
      {zaehlModus === "gegner" && (
        opponent ? (
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14, background: C.chalk, border: `1px solid ${C.line}`, borderRadius: 12, padding: "10px 14px" }}>
            <span style={{ width: 26, height: 26, borderRadius: 7, background: opponent.color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>{opponent.emoji}</span>
            <span style={{ fontSize: 13, color: C.ink }}>Gegner-Modus: ihr zählt jetzt für den aktuellen Gegner — <b>{opponent.name}</b>.</span>
          </div>
        ) : (
          <div style={{ marginBottom: 14, background: C.chalk, border: `1px solid ${C.line}`, borderRadius: 12, padding: "10px 14px", fontSize: 13, color: C.sub }}>
            Gegner-Modus: kein Gegner in dieser Runde (Freilos oder Turnier noch nicht gestartet) — zählt für euer eigenes Team.
          </div>
        )
      )}

      {/* Großer Zähl-Bereich — zählt immer das laufende Spiel (Einzelspiel) */}
      <div style={{ borderRadius: 18, overflow: "hidden", border: `1px solid ${C.play}`, background: "#fff", marginBottom: 14 }}>
        <div style={{ background: creditTeam.color, padding: "10px 14px", display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 22 }}>{creditTeam.emoji}</span>
          <span style={{ color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 20, textTransform: "uppercase", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{creditTeam.name}</span>
          <span style={{ color: "#fff", fontSize: 12.5, fontWeight: 700, background: "rgba(255,255,255,.22)", borderRadius: 999, padding: "3px 10px" }}>Einzelspiel</span>
        </div>
        <button onClick={addGoal} style={{ width: "100%", border: "none", background: "#fff", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 2, padding: "22px 6px 12px" }}>
          <div style={{ fontFamily: display, fontWeight: 700, fontSize: 96, lineHeight: 0.9, color: C.ink }}>{creditTeam.tore}</div>
          <div style={{ fontFamily: display, fontWeight: 700, fontSize: 22, color: creditTeam.color, textTransform: "uppercase", letterSpacing: 1 }}>+ Tor</div>
        </button>

        {/* Torschützen-Tipp nach einem Tor */}
        {pending >= 0 && (
          <div style={{ background: C.playSoft, borderTop: `1px solid ${C.line}`, padding: "10px 12px" }}>
            <div style={{ fontSize: 12.5, color: C.ink, marginBottom: 8, fontWeight: 600 }}>Wer hat getroffen? <span style={{ color: C.sub, fontWeight: 400 }}>(optional — fürs Torschützen-Ranking)</span></div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {creditTeam.players.map((p) => (
                <button key={p.id} onClick={() => attribute(p.id)} style={{ border: `1px solid ${C.line}`, background: "#fff", color: C.ink, borderRadius: 999, padding: "6px 12px", fontFamily: font, fontWeight: 600, fontSize: 13.5, cursor: "pointer" }}>
                  {p.captain ? "🎽 " : ""}{p.name}
                </button>
              ))}
              <button onClick={() => setPending(-1)} style={{ border: "none", background: "none", color: C.sub, fontSize: 12.5, fontWeight: 700, cursor: "pointer", padding: "6px 8px" }}>ohne Namen</button>
            </div>
          </div>
        )}

        <div style={{ display: "flex", alignItems: "center", gap: 12, borderTop: `1px solid ${C.line}`, padding: "10px 12px", flexWrap: "wrap" }}>
          <button onClick={undo} disabled={!hist.length} style={{ border: `1px solid ${C.line}`, background: hist.length ? "#fff" : C.chalk, color: hist.length ? C.ink : C.sub, borderRadius: 10, padding: "8px 14px", fontFamily: font, fontWeight: 600, fontSize: 13.5, cursor: hist.length ? "pointer" : "not-allowed" }}>− letztes Tor zurück</button>
          <span style={{ marginLeft: "auto", fontSize: 12.5, color: C.sub }}>Basis gesamt: <b style={{ color: C.ink }}>{lzBasis(creditTeam, f)}</b> <span>(Einzel {creditTeam.tore} + Team {creditTeam.teamspielTore}×{f.teamspiel})</span></span>
        </div>
      </div>

      {/* Torschützen (aus dem Store) */}
      <Card>
        <div style={{ fontFamily: display, fontWeight: 700, fontSize: 16, marginBottom: 8 }}>Torschützen — {creditTeam.name}</div>
        {scorers.some((p) => p.goals > 0) ? (
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {scorers.filter((p) => p.goals > 0).map((p) => (
              <div key={p.id} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontFamily: display, fontWeight: 700, fontSize: 15, minWidth: 26, textAlign: "right", color: C.play }}>{p.goals}</span>
                <span style={{ fontSize: 14 }}>{p.captain ? "🎽 " : ""}{p.name}</span>
              </div>
            ))}
          </div>
        ) : <div style={{ fontSize: 13, color: C.sub }}>Noch keine namentlichen Tore. Team-Tore zählen trotzdem (oben).</div>}
      </Card>

      <p style={{ textAlign: "center", color: C.sub, fontSize: 12, marginTop: 16 }}>
        Doppel-Zählung übers zweite Handy & VAR sind Sache des Headcoach (Echtzeit folgt in Stufe 2).
      </p>
    </div>
  );
}

function LzSeg({ active, onClick, title, sub }) {
  return (
    <button onClick={onClick} style={{ flex: 1, minWidth: 150, border: `1.5px solid ${active ? C.play : C.line}`, background: active ? C.playSoft : "#fff", borderRadius: 12, padding: "10px 14px", cursor: "pointer", textAlign: "left", fontFamily: font }}>
      <div style={{ fontFamily: display, fontWeight: 700, fontSize: 16, color: active ? C.fair : C.ink }}>{title}</div>
      <div style={{ fontSize: 12, color: C.sub, marginTop: 2 }}>{sub}</div>
    </button>
  );
}

/* ================= HEADCOACH (alle Teams + VAR + Abgleich) ================= */
function LzHeadcoach() {
  const { state, dispatch } = useStore();
  const teams = state.teams;
  const f = state.factors;

  return (
    <div style={{ fontFamily: font, color: C.ink }}>
      <LzHead sub="Alle Teams live · VAR-Korrektur · Doppel-Zählung bestätigen." />

      {teams.length === 0 ? (
        <Card><div style={{ color: C.sub, fontSize: 14 }}>Noch keine Teams — erst in der <b>Team-Verwaltung</b> anlegen.</div></Card>
      ) : (
        <>
          {/* Live-Stand aller Teams aus dem Store + VAR */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(260px,1fr))", gap: 12, marginBottom: 18 }}>
            {teams.map((t) => (
              <div key={t.id} style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 16, overflow: "hidden" }}>
                <div style={{ background: t.color, padding: "8px 12px", display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontSize: 18 }}>{t.emoji}</span>
                  <span style={{ color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 16, textTransform: "uppercase", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t.name}</span>
                  <span style={{ color: "#fff", fontSize: 12, fontWeight: 700, background: "rgba(255,255,255,.22)", borderRadius: 999, padding: "2px 9px" }}>Basis {lzBasis(t, f)}</span>
                </div>
                <div style={{ display: "flex", gap: 8, padding: 12 }}>
                  <LzVarField label="Einzelspiel" hint="team.tore" v={t.tore} onC={(d) => dispatch({ type: "goal/adjust", teamId: t.id, field: "tore", delta: d })} />
                  <LzVarField label="Teamspiel" hint={`×${f.teamspiel}`} v={t.teamspielTore} onC={(d) => dispatch({ type: "goal/adjust", teamId: t.id, field: "teamspielTore", delta: d })} />
                </div>
              </div>
            ))}
          </div>

          <LzAbgleich teams={teams} dispatch={dispatch} />
        </>
      )}
    </div>
  );
}

function LzVarField({ label, hint, v, onC }) {
  return (
    <div style={{ flex: 1, background: C.chalk, borderRadius: 10, padding: 8 }}>
      <div style={{ fontSize: 10.5, fontWeight: 700, color: C.sub, textAlign: "center", letterSpacing: 0.5 }}>{label} <span style={{ fontWeight: 400 }}>· {hint}</span></div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginTop: 4 }}>
        <LzSB onClick={() => onC(-1)}>−</LzSB>
        <b style={{ fontFamily: display, fontSize: 26, minWidth: 28, textAlign: "center", color: C.ink }}>{v}</b>
        <LzSB onClick={() => onC(1)} plus>+</LzSB>
      </div>
    </div>
  );
}

/* Doppel-Zählung / Abgleich: zwei Zähler → bereinigter Stand → in den Store bestätigen */
function LzAbgleich({ teams, dispatch }) {
  const [aTeam, setATeam] = useState(teams[0] ? teams[0].id : null);
  const [bTeam, setBTeam] = useState(teams[1] ? teams[1].id : (teams[0] ? teams[0].id : null));
  const [phase, setPhase] = useState("einzel");
  const [avgThr, setAvgThr] = useState(3);
  const [nullThr, setNullThr] = useState(6);
  const [A, setA] = useState({ sa: 0, sb: 0 });
  const [B, setB] = useState({ sa: 0, sb: 0 });
  const [done, setDone] = useState("");

  const res = lzResolveScore(A, B, avgThr, nullThr);
  const tone = res.status === "null" ? C.whistle : res.status === "avg" || res.status === "auto" ? C.brk : C.fair;
  const bg = res.status === "null" ? C.whistleSoft : res.status === "avg" || res.status === "auto" ? C.brkSoft : C.playSoft;
  const label = res.status === "null" ? "große Abweichung · zählt nicht (0:0)" : res.status === "avg" ? "Durchschnitt (aufgerundet)" : res.status === "auto" ? "aufgerundet (höhere Zahl)" : "deckt sich ✓";
  const tA = teams.find((t) => t.id === aTeam);
  const tB = teams.find((t) => t.id === bTeam);
  const field = phase === "team" ? "teamspielTore" : "tore";
  const sameTeam = aTeam === bTeam;

  const commit = () => {
    if (!tA || !tB || sameTeam) return;
    if (res.final.sa > 0) dispatch({ type: "goal/adjust", teamId: tA.id, field, delta: res.final.sa });
    if (res.final.sb > 0) dispatch({ type: "goal/adjust", teamId: tB.id, field, delta: res.final.sb });
    setDone(`Übernommen: ${tA.name} +${res.final.sa} · ${tB.name} +${res.final.sb} (${phase === "team" ? "Teamspiel" : "Einzelspiel"})`);
    setA({ sa: 0, sb: 0 }); setB({ sa: 0, sb: 0 });
  };

  return (
    <Card>
      <div style={{ fontFamily: display, fontWeight: 700, fontSize: 18, marginBottom: 4 }}>Doppel-Zählung / Abgleich</div>
      <div style={{ fontSize: 12.5, color: C.sub, marginBottom: 12 }}>Beide Team-Handys zählen den vollen Stand. Hier eintragen, prüfen und den bereinigten Stand in den Store übernehmen.</div>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginBottom: 12 }}>
        <select value={aTeam != null ? aTeam : ""} onChange={(e) => { setATeam(+e.target.value); setDone(""); }} style={lzSelStyle}>{teams.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}</select>
        <span style={{ color: C.sub, fontWeight: 700 }}>vs.</span>
        <select value={bTeam != null ? bTeam : ""} onChange={(e) => { setBTeam(+e.target.value); setDone(""); }} style={lzSelStyle}>{teams.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}</select>
        <div style={{ display: "flex", gap: 6, marginLeft: "auto" }}>
          <LzSeg active={phase === "einzel"} onClick={() => setPhase("einzel")} title="Einzelspiel" sub="team.tore" />
          <LzSeg active={phase === "team"} onClick={() => setPhase("team")} title="Teamspiel" sub="teamspielTore" />
        </div>
      </div>

      {/* Zwei Zählungen */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <LzCounter title="Zähler A" tA={tA} tB={tB} c={A} onC={(side, d) => setA((s) => ({ ...s, [side]: Math.max(0, s[side] + d) }))} />
        <LzCounter title="Zähler B" tA={tA} tB={tB} c={B} onC={(side, d) => setB((s) => ({ ...s, [side]: Math.max(0, s[side] + d) }))} />
      </div>

      {/* Ergebnis */}
      <div style={{ background: bg, border: `1px solid ${tone}`, borderRadius: 12, padding: "12px 14px", marginTop: 12, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <span style={{ fontSize: 11.5, fontWeight: 700, color: tone, background: "#fff", borderRadius: 6, padding: "2px 8px" }}>{label}</span>
        <span style={{ display: "flex", alignItems: "center", gap: 10, marginLeft: "auto" }}>
          <b style={{ fontFamily: display, fontWeight: 700, fontSize: 30, color: C.ink }}>{res.final.sa}</b>
          <span style={{ color: C.sub, fontWeight: 700 }}>:</span>
          <b style={{ fontFamily: display, fontWeight: 700, fontSize: 30, color: C.ink }}>{res.final.sb}</b>
        </span>
      </div>

      {/* Schwellen + Bestätigen */}
      <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "center", marginTop: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: C.sub }}>Ø ab
          <LzSB onClick={() => setAvgThr(Math.max(1, avgThr - 1))}>−</LzSB>
          <b style={{ fontFamily: display, fontSize: 18, color: C.ink, minWidth: 16, textAlign: "center" }}>{avgThr}</b>
          <LzSB onClick={() => setAvgThr(Math.min(nullThr - 1, avgThr + 1))} plus>+</LzSB>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: C.sub }}>0:0 ab
          <LzSB onClick={() => setNullThr(Math.max(avgThr + 1, nullThr - 1))}>−</LzSB>
          <b style={{ fontFamily: display, fontSize: 18, color: C.ink, minWidth: 16, textAlign: "center" }}>{nullThr}</b>
          <LzSB onClick={() => setNullThr(nullThr + 1)} plus>+</LzSB>
        </div>
        <button onClick={commit} disabled={sameTeam} style={{ marginLeft: "auto", border: "none", background: sameTeam ? C.fixed : C.play, color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 15, padding: "10px 18px", borderRadius: 10, cursor: sameTeam ? "not-allowed" : "pointer", letterSpacing: 0.5 }}>In den Store übernehmen ▸</button>
      </div>
      {sameTeam && <div style={{ fontSize: 12, color: C.whistle, marginTop: 8 }}>Bitte zwei verschiedene Teams wählen.</div>}
      {done && <div style={{ fontSize: 12.5, color: C.fair, marginTop: 8, fontWeight: 600 }}>{done}</div>}
    </Card>
  );
}

function LzCounter({ title, tA, tB, c, onC }) {
  return (
    <div style={{ flex: 1, minWidth: 220, background: C.chalk, borderRadius: 12, padding: 10 }}>
      <div style={{ fontSize: 10.5, fontWeight: 700, color: C.sub, textAlign: "center", marginBottom: 6, letterSpacing: 0.5 }}>{title}</div>
      <div style={{ display: "flex", justifyContent: "space-around", gap: 8 }}>
        {[["sa", tA], ["sb", tB]].map(([side, t]) => (
          <div key={side} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
            <span style={{ fontSize: 11, color: C.sub, fontWeight: 600, maxWidth: 84, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t ? t.name : "—"}</span>
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <LzSB onClick={() => onC(side, -1)}>−</LzSB>
              <b style={{ fontFamily: display, fontSize: 20, minWidth: 18, textAlign: "center", color: C.ink }}>{c[side]}</b>
              <LzSB onClick={() => onC(side, 1)} plus>+</LzSB>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function LzSB({ children, onClick, plus }) {
  return <button onClick={onClick} style={{ width: 28, height: 28, borderRadius: 7, border: `1px solid ${plus ? C.play : C.line}`, background: plus ? C.play : "#fff", color: plus ? "#fff" : C.ink, fontSize: 16, lineHeight: 1, cursor: "pointer", fontWeight: 700, padding: 0 }}>{children}</button>;
}


/* =====================================================================
   WERTUNG & TORSCHÜTZEN  ·  eingehängt an useStore()
   ---------------------------------------------------------------------
   LIEST die Tore, die der Live-Zähler schon in die Wahrheit schreibt
   (team.tore · team.teamspielTore · player.goals) und ERGÄNZT die
   nachbereitende Erfassung/Korrektur — über goal/* bzw.
   player/adjustGoals. KEINE zweite Wertungs-Wahrheit.

   Hinweis Phase 1/2: Das Datenmodell trennt die Tore in Einzelspiel
   (team.tore) und Teamspiel (team.teamspielTore) — nicht nach Gruppen-
   phase 1/2. Um keine zweite Wahrheit aufzubauen, arbeitet die Wertung
   auf genau diesen beiden Feldern. Helfer sind Wt-präfixiert.
   ===================================================================== */
function Wertung() {
  const { state, dispatch } = useStore();
  const teams = state.teams;
  const f = state.factors;

  // Torschützen-Rangliste je Kind (über alle Teams, aus dem Store)
  const scorers = teams
    .flatMap((t) => t.players.map((p) => ({ ...p, team: t })))
    .filter((p) => p.goals > 0)
    .sort((a, b) => b.goals - a.goals);

  return (
    <div style={{ fontFamily: font, color: C.ink }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: C.play, display: "grid", placeItems: "center", fontSize: 22, flexShrink: 0 }}>⚽</div>
        <div>
          <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: 0 }}>Wertung &amp; Torschützen</h2>
          <div style={{ fontSize: 13, color: C.sub }}>Tore nachtragen/korrigieren — und die Torschützen-Rangliste je Kind.</div>
        </div>
      </div>

      {teams.length === 0 ? (
        <Card><div style={{ color: C.sub, fontSize: 14 }}>Noch keine Teams — erst in der <b>Team-Verwaltung</b> anlegen. Die Wertung liest dann automatisch aus dem Store.</div></Card>
      ) : (
        <>
          <div style={{ background: C.playSoft, border: `1px solid ${C.line}`, borderRadius: 12, padding: "10px 14px", marginBottom: 16, fontSize: 12.5, color: C.fair }}>
            Der <b>Live-Zähler</b> schreibt schon live. Hier geht es um <b>Nachtragen &amp; Korrigieren</b> — der Stand bleibt EINE Wahrheit.
          </div>

          <Section title="Tore je Team" hint="Einzelspiel + Teamspiel (zählt doppelt)">
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {teams.map((t) => <WtTeamCard key={t.id} t={t} f={f} dispatch={dispatch} />)}
            </div>
          </Section>

          <Section title="Torschützen-Rangliste" hint="je Kind · über alle Teams">
            <Card>
              {scorers.length ? (
                <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  {scorers.map((p, i) => (
                    <div key={p.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 4px", borderTop: i === 0 ? "none" : `1px solid ${C.line}` }}>
                      <span style={{ fontFamily: display, fontWeight: 700, fontSize: 16, color: C.sub, minWidth: 26, textAlign: "right" }}>{i + 1}.</span>
                      <span style={{ width: 26, height: 26, borderRadius: 7, background: p.team.color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>{p.team.emoji}</span>
                      <span style={{ fontSize: 14.5, fontWeight: 600 }}>{p.captain ? "🎽 " : ""}{p.name}</span>
                      <span style={{ fontSize: 12, color: C.sub }}>· {p.team.name}</span>
                      <span style={{ marginLeft: "auto", fontFamily: display, fontWeight: 700, fontSize: 20, color: C.play }}>{p.goals}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ fontSize: 13, color: C.sub }}>Noch keine namentlich zugeordneten Tore. Torschützen entstehen im Live-Zähler (Torschützen-Tipp) oder werden je Kind unten nachgetragen.</div>
              )}
            </Card>
          </Section>
        </>
      )}
    </div>
  );
}

/* ---------- Wertungs-Helfer (Wt-präfixiert) ---------- */
function WtTeamCard({ t, f, dispatch }) {
  const [open, setOpen] = useState(false);
  const base = t.tore + t.teamspielTore * f.teamspiel;
  // Nachbereitende Erfassung/Korrektur direkt auf die Wahrheit (VAR-artig).
  const adj = (field, delta) => dispatch({ type: "goal/adjust", teamId: t.id, field, delta });
  const adjPlayer = (playerId, delta) => dispatch({ type: "player/adjustGoals", teamId: t.id, playerId, delta });
  // Echtes Tor mit Torschütze nachtragen: hebt Team-Feld UND Spieler-Tor (goal/add).
  const addWithScorer = (playerId) => dispatch({ type: "goal/add", teamId: t.id, phase: "einzel", playerId });

  return (
    <Card style={{ padding: 0, overflow: "hidden" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", borderBottom: open ? `1px solid ${C.line}` : "none" }}>
        <span style={{ width: 30, height: 30, borderRadius: 8, background: t.color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>{t.emoji}</span>
        <span style={{ fontFamily: display, fontWeight: 700, fontSize: 18, flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t.name}</span>
        <span style={{ fontSize: 12.5, color: C.sub }}>Basis <b style={{ color: C.ink, fontFamily: display, fontSize: 16 }}>{base}</b></span>
        <button onClick={() => setOpen((o) => !o)} style={{ border: `1px solid ${C.line}`, background: "#fff", color: C.sub, borderRadius: 8, padding: "5px 10px", fontFamily: font, fontWeight: 700, fontSize: 12.5, cursor: "pointer" }}>{open ? "Torschützen ▲" : "Torschützen ▼"}</button>
      </div>

      <div style={{ display: "flex", gap: 10, padding: "12px 14px", flexWrap: "wrap" }}>
        <WtField label="Einzelspiel" hint="→ team.tore" value={t.tore} color={C.tore} onDec={() => adj("tore", -1)} onInc={() => adj("tore", +1)} />
        <WtField label="Teamspiel" hint={`→ zählt ${f.teamspiel}×`} value={t.teamspielTore} color={C.play} onDec={() => adj("teamspielTore", -1)} onInc={() => adj("teamspielTore", +1)} />
      </div>

      {open && (
        <div style={{ background: C.chalk, borderTop: `1px solid ${C.line}`, padding: "12px 14px" }}>
          {t.players.length === 0 ? (
            <div style={{ fontSize: 13, color: C.sub }}>Keine Kinder im Kader. In der <b>Team-Verwaltung</b> anlegen.</div>
          ) : (
            <>
              <div style={{ fontSize: 12.5, color: C.sub, marginBottom: 8 }}>Torschützen je Kind — nachtragen/korrigieren. <b style={{ color: C.ink }}>+ Tor</b> hebt zusätzlich das Einzelspiel-Konto des Teams.</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {[...t.players].sort((a, b) => b.goals - a.goals).map((p) => (
                  <div key={p.id} style={{ display: "flex", alignItems: "center", gap: 8, background: "#fff", border: `1px solid ${C.line}`, borderRadius: 10, padding: "6px 10px" }}>
                    <span style={{ fontSize: 14, flex: 1 }}>{p.captain ? "🎽 " : ""}{p.name}</span>
                    <span style={{ fontFamily: display, fontWeight: 700, fontSize: 18, color: C.play, minWidth: 22, textAlign: "center" }}>{p.goals}</span>
                    <button onClick={() => adjPlayer(p.id, -1)} disabled={p.goals <= 0} title="nur Torschützen-Korrektur" style={{ width: 28, height: 28, borderRadius: 7, border: `1px solid ${C.line}`, background: p.goals > 0 ? "#fff" : C.chalk, color: p.goals > 0 ? C.ink : C.sub, fontSize: 16, lineHeight: 1, fontWeight: 700, cursor: p.goals > 0 ? "pointer" : "not-allowed", padding: 0 }}>−</button>
                    <button onClick={() => addWithScorer(p.id)} title="Tor (Einzelspiel) für dieses Kind nachtragen" style={{ border: "none", background: C.play, color: "#fff", borderRadius: 8, padding: "6px 12px", fontFamily: display, fontWeight: 700, fontSize: 13, cursor: "pointer", letterSpacing: 0.5 }}>+ Tor</button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </Card>
  );
}

function WtField({ label, hint, value, color, onDec, onInc }) {
  const btn = { width: 34, height: 34, borderRadius: 8, border: `1px solid ${C.line}`, background: "#fff", color: C.ink, fontFamily: display, fontWeight: 700, fontSize: 20, cursor: "pointer", lineHeight: 1, padding: 0 };
  return (
    <div style={{ flex: 1, minWidth: 200, border: `1px solid ${C.line}`, borderRadius: 12, padding: "10px 12px" }}>
      <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginBottom: 8 }}>
        <span style={{ fontFamily: display, fontWeight: 700, fontSize: 15, color }}>{label}</span>
        <span style={{ fontSize: 11.5, color: C.sub }}>{hint}</span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <button style={btn} onClick={onDec}>−</button>
        <span style={{ fontFamily: display, fontWeight: 700, fontSize: 28, minWidth: 34, textAlign: "center", color: C.ink }}>{value}</span>
        <button style={btn} onClick={onInc}>+</button>
      </div>
    </div>
  );
}


/* =====================================================================
   GESAMTWERTUNG (additiv)  ·  eingehängt an useStore()
   ---------------------------------------------------------------------
   Führt die drei Säulen zusammen — LIEST alles aus der einen Wahrheit
   und rechnet über das gemeinsame teamScore(t, factors):
     base  = tore + teamspielTore × factors.teamspiel   (Tore = Basis)
     + Fairplay-Sterne × factors.fairplay
     + erledigte Aufgaben × factors.aufgaben
   Rohwerte sind hier READ-ONLY (kommen aus Wertung/Fairplay/Aufgaben —
   keine zweite Wahrheit). Nur die drei Faktoren sind einstellbar,
   zentral über setFactor. Helfer sind Gw-präfixiert.
   ===================================================================== */
function Gesamtwertung() {
  const { state } = useStore();
  if (wertungVerborgen(state) && state.role !== "headcoach") return <EnthuellungsKarte />;
  return <GesamtwertungInhalt />;
}
function GesamtwertungInhalt() {
  const { state, dispatch } = useStore();
  const f = state.factors;
  const canEditFactors = state.role === "headcoach"; // nur Headcoach darf Parameter aendern

  const rows = useMemo(() => {
    return state.teams
      .map((t) => ({ t, sc: teamScore(t, f) }))
      .sort((a, b) => b.sc.total - a.sc.total);
  }, [state.teams, f]);
  const maxTotal = Math.max(1, ...rows.map((r) => r.sc.total));

  const setF = (key, val) => dispatch({ type: "setFactor", key, value: Math.max(0, val) });

  return (
    <div style={{ fontFamily: font, color: C.ink }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: C.play, display: "grid", placeItems: "center", fontSize: 22, flexShrink: 0 }}>🏅</div>
        <div>
          <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: 0 }}>Gesamtwertung</h2>
          <div style={{ fontSize: 13, color: C.sub }}>Tore = Basis · Fairplay &amp; Aufgaben kommen als Bonus oben drauf.</div>
        </div>
      </div>

      {state.teams.length === 0 ? (
        <Card><div style={{ color: C.sub, fontSize: 14 }}>Noch keine Teams — erst in der <b>Team-Verwaltung</b> anlegen. Die Gesamtwertung rechnet dann live aus dem Store.</div></Card>
      ) : (
        <>
          {/* Bonus-Faktoren (zentral über setFactor) */}
          <Section title="Faktoren" hint="wie stark Verhalten die Tore überstimmen kann">
            <Card>
              <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "flex-start" }}>
                <GwFac label="Teamspiel-Tore" unit="je Tor" color={C.play} v={f.teamspiel} set={(x) => setF("teamspiel", x)} readOnly={!canEditFactors} />
                <GwFac label="Fairplay-Bonus" unit="je ★" color={C.fp} v={f.fairplay} set={(x) => setF("fairplay", x)} readOnly={!canEditFactors} />
                <GwFac label="Aufgaben-Bonus" unit="je Aufgabe" color={C.auf} v={f.aufgaben} set={(x) => setF("aufgaben", x)} readOnly={!canEditFactors} />
              </div>
              <div style={{ fontSize: 12.5, color: C.sub, marginTop: 12 }}>
                Endstand = <b style={{ color: C.tore }}>Einzelspiel-Tore</b> + <b style={{ color: C.play }}>Teamspiel-Tore × {f.teamspiel}</b> + <b style={{ color: C.fp }}>Fairplay-★ × {f.fairplay}</b> + <b style={{ color: C.auf }}>Aufgaben × {f.aufgaben}</b>.
              </div>
              {!canEditFactors && (
                <div style={{ fontSize: 12, color: C.fair, marginTop: 8 }}>Nur der Headcoach kann die Faktoren ändern.</div>
              )}
            </Card>
          </Section>

          {/* Rohwerte je Team (read-only aus der Wahrheit) */}
          <Section title="Rohwerte je Team" hint="read-only · aus Wertung, Fairplay & Aufgaben">
            <Card style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 520 }}>
                <thead>
                  <tr style={{ color: C.sub, fontSize: 12 }}>
                    <GwTh style={{ textAlign: "left" }}>Team</GwTh>
                    <GwTh><span style={{ color: C.tore }}>Einzel</span></GwTh>
                    <GwTh><span style={{ color: C.play }}>Teamspiel</span></GwTh>
                    <GwTh><span style={{ color: C.fp }}>Fairplay ★</span></GwTh>
                    <GwTh><span style={{ color: C.auf }}>Aufgaben</span></GwTh>
                    <GwTh>Basis</GwTh>
                  </tr>
                </thead>
                <tbody>
                  {state.teams.map((t) => {
                    const sc = teamScore(t, f);
                    return (
                      <tr key={t.id} style={{ borderTop: `1px solid ${C.line}` }}>
                        <GwTd style={{ textAlign: "left" }}>
                          <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                            <span style={{ width: 26, height: 26, borderRadius: 7, background: t.color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>{t.emoji}</span>
                            <b>{t.name}</b>
                          </span>
                        </GwTd>
                        <GwTd>{t.tore}</GwTd>
                        <GwTd>{t.teamspielTore}</GwTd>
                        <GwTd>{t.fpStars}</GwTd>
                        <GwTd>{t.aufgabenDone}</GwTd>
                        <GwTd><b style={{ fontFamily: display, fontSize: 16 }}>{sc.base}</b></GwTd>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div style={{ fontSize: 11.5, color: C.sub, marginTop: 10 }}>Diese Werte werden hier nicht bearbeitet — sie stammen aus <b>Wertung &amp; Torschützen</b>, <b>Fairplay</b> und <b>Aufgaben</b>.</div>
            </Card>
          </Section>

          {/* Endstand */}
          <Section title="Endstand" hint="additiv · gestapelt nach Säulen">
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {rows.map((r, i) => (
                <div key={r.t.id} style={{ background: C.card, border: `1px solid ${i === 0 ? C.gold : C.line}`, borderRadius: 16, padding: "12px 14px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                    <span style={{ fontFamily: display, fontWeight: 700, fontSize: 24, color: i === 0 ? C.gold : C.sub, minWidth: 28 }}>{i + 1}</span>
                    <span style={{ width: 30, height: 30, borderRadius: 8, background: r.t.color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>{r.t.emoji}</span>
                    <b style={{ flex: 1, fontSize: 17 }}>{r.t.name}</b>
                    <span style={{ fontFamily: display, fontWeight: 700, fontSize: 26, color: C.ink }}>{r.sc.total}<span style={{ fontSize: 13, color: C.sub, fontWeight: 600 }}> Pkt</span></span>
                  </div>
                  <div style={{ display: "flex", height: 16, borderRadius: 8, overflow: "hidden", background: C.chalk }}>
                    <div style={{ width: `${(r.sc.base / maxTotal) * 100}%`, background: C.tore }} />
                    <div style={{ width: `${(r.sc.fp / maxTotal) * 100}%`, background: C.fp }} />
                    <div style={{ width: `${(r.sc.auf / maxTotal) * 100}%`, background: C.auf }} />
                  </div>
                  <div style={{ display: "flex", gap: 14, marginTop: 6, fontSize: 11.5, color: C.sub, flexWrap: "wrap" }}>
                    <GwLeg c={C.tore} t={`Basis ${r.sc.base} Pkt`} />
                    <GwLeg c={C.fp} t={`${r.t.fpStars} ★ × ${f.fairplay} = ${r.sc.fp} Pkt`} />
                    <GwLeg c={C.auf} t={`${r.t.aufgabenDone} Aufg. × ${f.aufgaben} = ${r.sc.auf} Pkt`} />
                  </div>
                </div>
              ))}
            </div>
          </Section>

          <div style={{ background: C.playSoft, border: `1px solid ${C.line}`, borderRadius: 12, padding: "12px 14px", fontSize: 13, color: C.ink }}>
            <b>So liest du's:</b> Die <span style={{ color: C.tore, fontWeight: 700 }}>blaue</span> Basis sind die Tore. Darauf kommen <span style={{ color: C.fp, fontWeight: 700 }}>Fairplay</span> und <span style={{ color: C.auf, fontWeight: 700 }}>Aufgaben</span> als Bonus. Über die Faktoren stellst du ein, wie stark das Verhalten die reinen Tore überstimmen kann.
          </div>
        </>
      )}
    </div>
  );
}

/* ---------- Gesamtwertung-Helfer (Gw-präfixiert) ---------- */
function GwFac({ label, unit, color, v, set, readOnly = false }) {
  return (
    <div style={{ background: C.chalk, borderRadius: 10, padding: "10px 14px" }}>
      <div style={{ fontSize: 12.5, fontWeight: 700, color, marginBottom: 6 }}>{label} <span style={{ color: C.sub, fontWeight: 500 }}>{unit}</span></div>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {!readOnly && <GwSB onClick={() => set(v - 1)}>−</GwSB>}
        <div style={{ fontFamily: display, fontWeight: 700, fontSize: 26, minWidth: 40, textAlign: "center" }}>×{v}</div>
        {!readOnly && <GwSB onClick={() => set(v + 1)} plus>+</GwSB>}
      </div>
    </div>
  );
}
function GwSB({ children, onClick, plus }) {
  return <button onClick={onClick} style={{ width: 30, height: 30, borderRadius: 7, border: `1px solid ${plus ? C.play : C.line}`, background: plus ? C.play : "#fff", color: plus ? "#fff" : C.ink, fontSize: 18, lineHeight: 1, cursor: "pointer", fontWeight: 700, padding: 0 }}>{children}</button>;
}
function GwTh({ children, style }) { return <th style={{ padding: "8px 10px", fontWeight: 600, textAlign: "right", ...style }}>{children}</th>; }
function GwTd({ children, style }) { return <td style={{ padding: "8px 10px", textAlign: "right", fontSize: 14, ...style }}>{children}</td>; }
function GwLeg({ c, t }) { return <span style={{ display: "inline-flex", alignItems: "center", gap: 5 }}><span style={{ width: 10, height: 10, borderRadius: 3, background: c }} />{t}</span>; }


/* =====================================================================
   FAIRPLAY  ·  eingehängt an useStore()
   ---------------------------------------------------------------------
   Headcoach-/Coach-geführte, rein positive Runde in Phase 2. Team für
   Team werden die 7 Kriterien (je 0–5 ★) vergeben — nur nach oben, kein
   Schlechtmachen. Schreibt über fairplay/set in team.fpDetail; fpStars
   bleibt die Summe daraus (die Gesamtwertung liest sie schon). KEINE
   zweite Fairplay-Wahrheit. Teamzugang sieht nur das eigene Team,
   read-only. Helfer sind Fp-präfixiert.
   ===================================================================== */
const FP_MAX = FAIRPLAY_CRITERIA.length * 5;

function Fairplay() {
  const { state, dispatch } = useStore();
  const teams = state.teams;
  const role = state.role;
  const fpFactor = state.factors.fairplay;
  const boundTeam = role === "teamaccess" ? teams.find((t) => t.id === state.boundTeamId) : null;
  const canEdit = role === "headcoach";

  const [view, setView] = useState("runde"); // runde | ergebnis
  const [idx, setIdx] = useState(0);         // Teamzugang: Index in "andere Teams" · Headcoach: Index in "alle Teams" (bewertetes Team)
  const [raterId, setRaterId] = useState(null); // Headcoach: als welches Team er gerade bewertet/korrigiert

  const ranking = useMemo(
    () => teams.map((t) => ({ t, tot: t.fpStars, submitted: Object.keys(t.fpFrom || {}).length })).sort((a, b) => b.tot - a.tot),
    [teams]
  );
  const expectedRaters = Math.max(0, teams.length - 1);
  // Fairste:r Spieler:in — jetzt ueber ALLE abgegebenen Peer-Bewertungen
  // (team.fpFrom[*].fairest) verdichtet, nicht mehr ein einzelnes Feld je Team.
  const fairestTally = useMemo(() => {
    const m = new Map();
    teams.forEach((t) => {
      Object.values(t.fpFrom || {}).forEach((entry) => {
        const n = (entry.fairest || "").trim();
        if (!n) return;
        const k = n.toLowerCase();
        if (!m.has(k)) m.set(k, { name: n, n: 0 });
        m.get(k).n++;
      });
    });
    return [...m.values()].sort((a, b) => b.n - a.n);
  }, [teams]);

  const header = (
    <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
      <div style={{ width: 44, height: 44, borderRadius: 12, background: C.play, display: "grid", placeItems: "center", fontSize: 22, flexShrink: 0 }}>🤝</div>
      <div>
        <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: 0 }}>Fairplay</h2>
        <div style={{ fontSize: 13, color: C.sub }}>Phase 2 · Teams bewerten sich gegenseitig · rein positiv · {FAIRPLAY_CRITERIA.length} Kriterien à 1–5 ★</div>
      </div>
    </div>
  );

  if (teams.length === 0) {
    return (
      <div style={{ fontFamily: font, color: C.ink }}>
        {header}
        <Card><div style={{ color: C.sub, fontSize: 14 }}>Noch keine Teams — erst in der <b>Team-Verwaltung</b> anlegen. Die Fairplay-Runde liest dann automatisch aus dem Store.</div></Card>
      </div>
    );
  }

  // --- Teamzugang: bewertet alle ANDEREN Teams (nie sich selbst) ---
  if (role === "teamaccess") {
    const others = teams.filter((t) => !boundTeam || t.id !== boundTeam.id);
    if (others.length === 0) {
      return (
        <div style={{ fontFamily: font, color: C.ink }}>
          {header}
          <Card><div style={{ color: C.sub, fontSize: 14 }}>Noch keine anderen Teams zum Bewerten — sobald mehr Teams angelegt sind, geht's hier los.</div></Card>
        </div>
      );
    }
    const rateeIdx = Math.min(idx, others.length - 1);
    const ratee = others[rateeIdx];
    const mine = boundTeam ? (ratee.fpFrom[boundTeam.id] || { detail: emptyFp(), fairest: "" }) : { detail: emptyFp(), fairest: "" };
    const setStar = (crit, v) => {
      if (!boundTeam) return;
      const cur = mine.detail[crit] || 0;
      dispatch({ type: "fairplay/set", rateeTeamId: ratee.id, raterTeamId: boundTeam.id, crit, value: cur === v ? 0 : v });
    };
    const setFairest = (name) => {
      if (!boundTeam) return;
      dispatch({ type: "fairplay/set", rateeTeamId: ratee.id, raterTeamId: boundTeam.id, fairest: name });
    };
    return (
      <div style={{ fontFamily: font, color: C.ink }}>
        {header}

        <div style={{ display: "flex", gap: 6, background: C.play, borderRadius: 12, padding: 4, marginBottom: 16, width: "fit-content" }}>
          <FpSeg active={view === "runde"} onClick={() => setView("runde")}>Bewerten</FpSeg>
          <FpSeg active={view === "ergebnis"} onClick={() => setView("ergebnis")}>Ergebnis</FpSeg>
        </div>

        {view === "runde" ? (
          <>
            <div style={{ background: C.playSoft, border: `1px solid ${C.line}`, borderRadius: 12, padding: "10px 14px", marginBottom: 14, fontSize: 13, color: C.ink }}>
              Ihr bewertet die <b>anderen Teams</b> — nicht euch selbst. Für jedes gute Verhalten gebt ihr Sterne — <b>nur nach oben</b>, es gibt kein Schlechtmachen.
            </div>

            {/* Andere Teams antippen */}
            <div style={{ display: "flex", gap: 6, marginBottom: 14, flexWrap: "wrap" }}>
              {others.map((t, i) => {
                const on = i === rateeIdx;
                return (
                  <button key={t.id} onClick={() => setIdx(i)} style={{ flex: 1, minWidth: 64, border: `2px solid ${on ? C.play : C.line}`, background: on ? C.play : "#fff", color: on ? "#fff" : C.sub, borderRadius: 9, padding: "6px 4px", fontFamily: display, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
                    {t.emoji} {t.name}
                  </button>
                );
              })}
            </div>

            <FpTeamCard team={ratee} detail={mine.detail} fairest={mine.fairest} onStar={setStar} onFairest={setFairest} />

            <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
              <button onClick={() => setIdx(Math.max(0, rateeIdx - 1))} disabled={rateeIdx === 0} style={{ ...fpBtnGhost, opacity: rateeIdx === 0 ? 0.5 : 1, cursor: rateeIdx === 0 ? "not-allowed" : "pointer" }}>◀ zurück</button>
              {rateeIdx < others.length - 1 ? (
                <button onClick={() => setIdx(rateeIdx + 1)} style={{ ...fpBtnPrimary, marginLeft: "auto" }}>nächstes Team ▶</button>
              ) : (
                <button onClick={() => setView("ergebnis")} style={{ ...fpBtnPrimary, marginLeft: "auto" }}>🏆 Zur Rangliste</button>
              )}
            </div>

            <div style={{ background: C.playSoft, border: `1px solid ${C.line}`, borderRadius: 12, padding: "12px 14px", marginTop: 16, fontSize: 12.5, color: C.sub }}>
              {wertungVerborgen(state)
                ? <>Wie viele Fairplay-Sterne ihr bekommen habt, wird erst bei der Siegerehrung verraten. 🤫</>
                : <>Euer eigener Fairplay-Stand: <b style={{ color: C.ink }}>{boundTeam ? boundTeam.fpStars : 0}/{FP_MAX}</b> ★ — der Durchschnitt aus den Bewertungen aller anderen Teams für euch.</>}
            </div>
          </>
        ) : (
          <FpRankingBlock ranking={ranking} fairestTally={fairestTally} expected={expectedRaters} />
        )}
      </div>
    );
  }

  // --- Coach: read-only Ueberblick ueber alle Teams (Teams bewerten sich gegenseitig) ---
  if (!canEdit) {
    return (
      <div style={{ fontFamily: font, color: C.ink }}>
        {header}
        <div style={{ background: C.playSoft, border: `1px solid ${C.line}`, borderRadius: 12, padding: "10px 14px", marginBottom: 14, fontSize: 13, color: C.fair }}>
          Die Fairplay-Sterne vergeben sich die Teams gegenseitig. Hier siehst du den <b>Stand aller Teams</b>.
        </div>
        <FpRankingBlock ranking={ranking} fairestTally={fairestTally} expected={expectedRaters} />
      </div>
    );
  }

  // --- Headcoach: kann fuer jedes Team-Paar (wer bewertet wen) eingreifen/korrigieren ---
  const ratee = teams[Math.min(idx, teams.length - 1)];
  const raters = teams.filter((t) => t.id !== ratee.id);
  const activeRaterId = raters.some((t) => t.id === raterId) ? raterId : (raters[0] ? raters[0].id : null);
  const activeRater = raters.find((t) => t.id === activeRaterId) || null;
  const entry = activeRater ? (ratee.fpFrom[activeRater.id] || { detail: emptyFp(), fairest: "" }) : { detail: emptyFp(), fairest: "" };
  const setStar = (crit, v) => {
    if (!activeRater) return;
    const cur = entry.detail[crit] || 0;
    dispatch({ type: "fairplay/set", rateeTeamId: ratee.id, raterTeamId: activeRater.id, crit, value: cur === v ? 0 : v });
  };
  const setFairest = (name) => {
    if (!activeRater) return;
    dispatch({ type: "fairplay/set", rateeTeamId: ratee.id, raterTeamId: activeRater.id, fairest: name });
  };

  return (
    <div style={{ fontFamily: font, color: C.ink }}>
      {header}

      <div style={{ display: "flex", gap: 6, background: C.play, borderRadius: 12, padding: 4, marginBottom: 16, width: "fit-content" }}>
        <FpSeg active={view === "runde"} onClick={() => setView("runde")}>Runde</FpSeg>
        <FpSeg active={view === "ergebnis"} onClick={() => setView("ergebnis")}>Ergebnis</FpSeg>
      </div>

      {view === "runde" ? (
        <>
          <div style={{ background: C.playSoft, border: `1px solid ${C.line}`, borderRadius: 12, padding: "10px 14px", marginBottom: 14, fontSize: 13, color: C.ink }}>
            Die Teams bewerten sich normalerweise selbst gegenseitig (über den Teamzugang). Hier kannst du als Headcoach für ein Team nachtragen oder korrigieren — <b>nur nach oben</b>, es gibt kein Schlechtmachen.
          </div>

          <div style={{ borderLeft: `3px solid ${C.play}`, background: "#fff", borderRadius: "0 10px 10px 0", padding: "8px 12px", marginBottom: 14, fontSize: 12.5, color: C.sub, lineHeight: 1.5 }}>
            <b style={{ color: C.ink }}>Nur für dich (Headcoach):</b> Achte still darauf, dass alle dazugehören — niemand wird wegen Geschlecht, Herkunft, Glaube oder Aussehen ausgeschlossen; die Mädchen dürfen ruhig im Zentrum stehen. Lass es in „Zusammenhalt" und „Anfeuerer:in" einfließen, ohne es anzusagen.
          </div>

          {/* Fortschritt: bewertetes Team antippen */}
          <div style={{ display: "flex", gap: 6, marginBottom: 10, flexWrap: "wrap" }}>
            {teams.map((t, i) => {
              const on = i === Math.min(idx, teams.length - 1);
              return (
                <button key={t.id} onClick={() => { setIdx(i); setRaterId(null); }} style={{ flex: 1, minWidth: 64, border: `2px solid ${on ? C.play : C.line}`, background: on ? C.play : "#fff", color: on ? "#fff" : C.sub, borderRadius: 9, padding: "6px 4px", fontFamily: display, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
                  {t.emoji} {t.fpStars}
                </button>
              );
            })}
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
            <span style={{ fontSize: 13, color: C.sub }}>Bewertung von Team</span>
            <select value={activeRaterId || ""} onChange={(e) => setRaterId(+e.target.value)} style={lzSelStyle}>
              {raters.map((t) => <option key={t.id} value={t.id}>{t.emoji} {t.name}</option>)}
            </select>
            <span style={{ fontSize: 13, color: C.sub }}>für <b style={{ color: C.ink }}>{ratee.name}</b></span>
          </div>

          <FpTeamCard team={ratee} detail={entry.detail} fairest={entry.fairest} onStar={setStar} onFairest={setFairest} />

          <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
            <button onClick={() => { setIdx(Math.max(0, idx - 1)); setRaterId(null); }} disabled={idx === 0} style={{ ...fpBtnGhost, opacity: idx === 0 ? 0.5 : 1, cursor: idx === 0 ? "not-allowed" : "pointer" }}>◀ zurück</button>
            {idx < teams.length - 1 ? (
              <button onClick={() => { setIdx(idx + 1); setRaterId(null); }} style={{ ...fpBtnPrimary, marginLeft: "auto" }}>nächstes Team ▶</button>
            ) : (
              <button onClick={() => setView("ergebnis")} style={{ ...fpBtnPrimary, marginLeft: "auto" }}>🏆 Zur Rangliste</button>
            )}
          </div>

          <div style={{ background: C.playSoft, border: `1px solid ${C.line}`, borderRadius: 12, padding: "12px 14px", marginTop: 16, fontSize: 12.5, color: C.sub }}>
            Jeder Stern zählt aktuell <b style={{ color: C.fp }}>×{fpFactor}</b> in der Gesamtwertung — als Durchschnitt aus den Bewertungen aller anderen Teams. Wie stark Fairplay die Tore überstimmt, stellst du dort über den Fairplay-Faktor ein.
          </div>
        </>
      ) : (
        <FpRankingBlock ranking={ranking} fairestTally={fairestTally} expected={expectedRaters} />
      )}
    </div>
  );
}

/* ---------- Fairplay-Helfer (Fp-präfixiert) ---------- */
// team: wessen Karte (Name/Farbe/Emoji); detail/fairest: die anzuzeigende
// Bewertung -- entweder eine einzelne Peer-Bewertung (rater->ratee, editierbar)
// oder der verdichtete Durchschnitt (team.fpDetail/team.fpFairest-Ersatz,
// read-only in FpRankingBlock/aggregierten Ansichten).
function FpTeamCard({ team, detail, fairest, onStar, onFairest, readOnly = false }) {
  const shown = FAIRPLAY_CRITERIA.reduce((s, c) => s + (detail?.[c.k] || 0), 0);
  return (
    <Card style={{ padding: 0, overflow: "hidden" }}>
      <div style={{ background: team.color, padding: "12px 16px", display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontSize: 24 }}>{team.emoji}</span>
        <span style={{ fontFamily: display, fontWeight: 700, fontSize: 22, color: "#fff", textTransform: "uppercase", flex: 1 }}>{team.name}</span>
        <span style={{ fontFamily: display, fontWeight: 700, fontSize: 22, color: "#fff" }}>{shown}<span style={{ fontSize: 13, opacity: 0.8 }}>/{FP_MAX}</span></span>
      </div>
      <div style={{ padding: "6px 14px 14px" }}>
        {FAIRPLAY_CRITERIA.map((c) => {
          const val = detail?.[c.k] || 0;
          return (
            <div key={c.k} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 0", borderBottom: `1px solid ${C.line}` }}>
              <span style={{ fontSize: 22 }}>{c.emo}</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 14.5 }}>{c.label}</div>
                <div style={{ fontSize: 11.5, color: C.sub }}>{c.hint}</div>
              </div>
              <div style={{ display: "flex", gap: 2 }}>
                {[1, 2, 3, 4, 5].map((s) => (
                  <button key={s} onClick={readOnly ? undefined : () => onStar(c.k, s)} disabled={readOnly}
                    style={{ border: "none", background: "none", cursor: readOnly ? "default" : "pointer", fontSize: 24, lineHeight: 1, filter: s <= val ? "none" : "grayscale(1) opacity(.25)", padding: 0 }}>⭐</button>
                ))}
              </div>
            </div>
          );
        })}
        <div style={{ marginTop: 12 }}>
          <div style={{ fontSize: 12.5, fontWeight: 600, color: C.sub, marginBottom: 6 }}>Fairste:r Spieler:in bei diesem Team (optional)</div>
          {readOnly ? (
            <div style={{ fontSize: 14, fontWeight: 600 }}>{fairest ? `🥇 ${fairest}` : <span style={{ color: C.sub, fontWeight: 400 }}>— noch keine Nennung —</span>}</div>
          ) : (
            <input value={fairest || ""} onChange={(e) => onFairest(e.target.value)} placeholder="Name"
              style={{ width: "100%", border: `1px solid ${C.line}`, borderRadius: 9, padding: "8px 10px", fontFamily: font, fontSize: 14, color: C.ink, background: "#fff", outline: "none" }} />
          )}
        </div>
        {!readOnly && (
          <div style={{ fontSize: 11.5, color: C.sub, marginTop: 10 }}>Tipp: Sterne lassen sich durch erneutes Antippen zurücksetzen (gleicher Wert = 0).</div>
        )}
      </div>
    </Card>
  );
}

function FpRankingBlock({ ranking, fairestTally, expected }) {
  const { state } = useStore();
  if (wertungVerborgen(state) && state.role !== "headcoach") return <EnthuellungsKarte />;
  return (
    <>
      <Section title="Fairplay-Rangliste" hint="je Team · Summe der Sterne">
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {ranking.map((row, i) => {
            const pct = FP_MAX ? (row.tot / FP_MAX) * 100 : 0;
            return (
              <div key={row.t.id} style={{ background: C.card, border: `1px solid ${i === 0 ? C.gold : C.line}`, borderRadius: 16, padding: "12px 14px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
                  <span style={{ fontFamily: display, fontWeight: 700, fontSize: 22, color: i === 0 ? C.gold : C.sub, minWidth: 26 }}>{i + 1}</span>
                  <span style={{ width: 28, height: 28, borderRadius: 7, background: row.t.color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 15 }}>{row.t.emoji}</span>
                  <b style={{ flex: 1, fontSize: 16 }}>{row.t.name}</b>
                  <span style={{ fontFamily: display, fontWeight: 700, fontSize: 22, color: C.play }}>{row.tot}<span style={{ fontSize: 12, color: C.sub }}>/{FP_MAX}</span></span>
                </div>
                <div style={{ height: 8, background: C.chalk, borderRadius: 5, overflow: "hidden" }}>
                  <div style={{ width: `${pct}%`, height: "100%", background: i === 0 ? C.gold : C.play, borderRadius: 5 }} />
                </div>
                {expected != null && row.submitted < expected && (
                  <div style={{ fontSize: 11.5, color: "#8a5a12", marginTop: 6 }}>
                    {row.submitted}/{expected} Teams haben bisher bewertet — Sterne beruhen nur auf den abgegebenen Bewertungen.
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </Section>

      {fairestTally.length > 0 && (
        <Section title="Fairste Spieler:innen" hint="aus den Team-Runden">
          <Card>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {fairestTally.map((f, i) => (
                <span key={f.name} style={{ background: C.chalk, border: `1px solid ${C.line}`, borderRadius: 20, padding: "5px 12px", fontSize: 14, fontWeight: i === 0 ? 700 : 500 }}>
                  {i === 0 && "🥇 "}{f.name}{f.n > 1 && <span style={{ color: C.sub }}> · {f.n}×</span>}
                </span>
              ))}
            </div>
          </Card>
        </Section>
      )}
    </>
  );
}

function FpSeg({ active, onClick, children }) {
  return (
    <button onClick={onClick} style={{ border: "none", background: active ? "#fff" : "transparent", color: active ? C.play : "#fff", borderRadius: 8, padding: "6px 14px", fontFamily: display, fontWeight: 700, fontSize: 13, cursor: "pointer", letterSpacing: 0.5 }}>{children}</button>
  );
}
const fpBtnPrimary = { border: "none", background: C.play, color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 16, padding: "10px 18px", borderRadius: 10, cursor: "pointer", letterSpacing: 0.5 };
const fpBtnGhost = { border: `1.5px solid ${C.line}`, background: "#fff", color: C.ink, fontFamily: display, fontWeight: 700, fontSize: 15, padding: "9px 16px", borderRadius: 10, letterSpacing: 0.5 };


/* =====================================================================
   VIEW: AUFGABEN  (eingehängter Baustein 7)
   Portiert aus aufgaben.jsx — eigenes Theme, Demo-Teams & Demo-Pool raus,
   alles über useStore(). Aufgaben-Pool = state.taskPool, Schwerpunkte =
   state.focusThemes (Chips via toggleTheme). Erledigt = +1 auf
   team.aufgabenDone (das die Gesamtwertung schon liest) über die neue
   Action aufgaben/complete; Video/Foto legen zusätzlich ein Galerie-
   Medium mit taskId an (Showroom zieht es über gallery.star). Keine
   zweite Aufgaben-Wahrheit. Teamzugang: nur das eigene Team. Wartefenster,
   Spielrunden & die aktuelle Turnier-Auswahl (Ziehung) bleiben reine
   UI-/Sitzungs-States. Helfer Au-präfixiert.
   ===================================================================== */

const auTypeMeta = TASK_TYPES;  // { video|foto|nennen: { key, label, emo, color } }
const auReadFile = (e, cb) => {
  const f = e.target.files && e.target.files[0];
  if (!f) return;
  cb(URL.createObjectURL(f), f.type.startsWith("video") ? "video" : "foto");
  e.target.value = "";
};

function Aufgaben() {
  const { state, dispatch } = useStore();
  const teams = state.teams;
  const pool = state.taskPool;
  const focusThemes = state.focusThemes;
  const aufFactor = state.factors.aufgaben;
  const role = state.role;
  const canEdit = role === "headcoach";
  const isCoachReadOnly = role === "coach";
  const boundTeam = role === "teamaccess" ? teams.find((t) => t.id === state.boundTeamId) : null;

  // reine UI-/Sitzungs-States (gehören NICHT in die Wahrheit)
  const [fenster, setFenster] = useState(4);                 // Wartefenster in Minuten
  const [runden, setRunden] = useState(6);                   // Spielrunden → so viele Aufgaben
  // Audit-Fix (Stand 31): war vorher lokaler useState -- jedes Geraet hatte
  // dadurch seine eigene, unabhaengige Standardauswahl statt der tatsaechlich
  // vom Headcoach gezogenen Aufgaben. Jetzt EINE Wahrheit in state.aufgabenZiehung;
  // Fallback auf die ersten 6 Pool-Eintraege, solange noch nie gezogen wurde.
  const turnierIds = (state.aufgabenZiehung && state.aufgabenZiehung.length) ? state.aufgabenZiehung : pool.slice(0, 6).map((p) => p.id);
  const [tab, setTab] = useState("erledigen");               // erledigen | punkte | showroom | pool
  const [teamId, setTeamId] = useState(null);                // Team-Auswahl (Headcoach/Coach)
  const [taskId, setTaskId] = useState(null);
  const [newTask, setNewTask] = useState("");
  const [newType, setNewType] = useState("video");
  const [log, setLog] = useState([]);                        // Sitzungs-Protokoll „zuletzt erledigt"

  const teamById = (id) => teams.find((t) => t.id === id);
  const taskById = (id) => pool.find((p) => p.id === id);

  // Teamzugang zählt/filmt fürs eigene Team; Headcoach/Coach wählen frei.
  const activeTeamId = canEdit ? teamId : (boundTeam ? boundTeam.id : null);

  const ziehen = (n) => {
    const sh = (arr) => [...arr].sort(() => Math.random() - 0.5);
    const hit = (p) => p.themes && p.themes.some((k) => focusThemes.includes(k));
    const match = pool.filter(hit);
    let picked;
    if (focusThemes.length && match.length) {
      const nFoc = Math.min(match.length, Math.max(1, Math.round(n * 0.6)));
      const rest = pool.filter((p) => !hit(p));
      picked = sh([...sh(match).slice(0, nFoc), ...sh(rest).slice(0, Math.max(0, n - nFoc))]);
    } else {
      picked = sh(pool).slice(0, Math.min(n, pool.length));
    }
    dispatch({ type: "aufgaben/ziehen", ids: picked.slice(0, Math.min(n, pool.length)).map((p) => p.id) });
  };

  const turnierTasks = turnierIds.map(taskById).filter(Boolean);
  const taskIdx = turnierTasks.findIndex((p) => p.id === taskId);
  const task = taskById(taskId);

  const complete = (url, kind, answer) => {
    if (!activeTeamId || !task) return;
    dispatch({ type: "aufgaben/complete", teamId: activeTeamId, taskId: task.id, url: url || null, kind: kind || null });
    setLog((l) => [...l, { id: uid(), teamId: activeTeamId, taskId: task.id, type: task.type, answer: answer || null }]);
    setTaskId(null);
  };

  const points = useMemo(
    () => teams.map((t) => ({ t, p: t.aufgabenDone || 0 })).sort((a, b) => b.p - a.p),
    [teams]
  );

  // Nur task-erzeugte Medien (taskId gesetzt) — im Rollen-Scope.
  const scopeTeams = (canEdit || isCoachReadOnly) ? teams : (boundTeam ? [boundTeam] : []);
  const media = scopeTeams.flatMap((t) => t.gallery.filter((g) => g.taskId != null).map((g) => ({ ...g, teamId: t.id })));
  const showroomCount = media.filter((m) => m.star).length;

  const header = (
    <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
      <div style={{ width: 44, height: 44, borderRadius: 12, background: C.play, display: "grid", placeItems: "center", fontSize: 22, flexShrink: 0 }}>🎯</div>
      <div>
        <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: 0 }}>Aufgaben</h2>
        <div style={{ fontSize: 13, color: C.sub }}>Wartezeit im 4-pro-Box-Modus · rein positiv · jede erledigte Aufgabe zählt in der Gesamtwertung</div>
      </div>
    </div>
  );

  if (teams.length === 0) {
    return (
      <div style={{ fontFamily: font, color: C.ink }}>
        {header}
        <Card><div style={{ color: C.sub, fontSize: 14 }}>Noch keine Teams — erst in der <b>Team-Verwaltung</b> anlegen. Die Aufgaben lesen dann automatisch aus dem Store.</div></Card>
      </div>
    );
  }

  // Gemeinsamer „Erledigen"-Block (Headcoach/Coach & Teamzugang)
  const erledigenPanel = (
    <Card>
      <div style={{ display: "grid", gridTemplateColumns: canEdit ? "1fr 1fr" : "1fr", gap: 12, marginBottom: 14 }}>
        {canEdit && (
          <div>
            <AuLabel>Welches Team?</AuLabel>
            <select className="au-in" style={{ width: "100%" }} value={teamId || ""} onChange={(e) => setTeamId(+e.target.value)}>
              <option value="">Team wählen…</option>
              {teams.map((t) => <option key={t.id} value={t.id}>{t.emoji} {t.name}</option>)}
            </select>
          </div>
        )}
        <div>
          <AuLabel>Aufgabe ({turnierTasks.length} fürs Turnier gezogen)</AuLabel>
          <select className="au-in" style={{ width: "100%" }} value={taskId || ""} onChange={(e) => setTaskId(+e.target.value)}>
            <option value="">Aufgabe wählen…</option>
            {turnierTasks.map((p) => <option key={p.id} value={p.id}>{auTypeMeta[p.type].emo} {p.text}</option>)}
          </select>
          {turnierTasks.length > 0 && (
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 8 }}>
              <button disabled={taskIdx <= 0}
                onClick={() => setTaskId(turnierTasks[taskIdx - 1].id)}
                style={{ border: `1.5px solid ${C.line}`, background: "#fff", color: C.ink, borderRadius: 8, padding: "5px 12px", fontSize: 13, fontWeight: 700, fontFamily: font, cursor: taskIdx > 0 ? "pointer" : "default", opacity: taskIdx > 0 ? 1 : 0.35 }}>
                ◀ Zurück
              </button>
              <span style={{ fontSize: 12.5, color: C.sub }}>{taskIdx >= 0 ? `Aufgabe ${taskIdx + 1} von ${turnierTasks.length}` : "noch keine gewählt"}</span>
              <button disabled={taskIdx >= turnierTasks.length - 1}
                onClick={() => setTaskId(turnierTasks[taskIdx < 0 ? 0 : taskIdx + 1].id)}
                style={{ border: "none", background: C.play, color: "#fff", borderRadius: 8, padding: "5px 12px", fontSize: 13, fontWeight: 700, fontFamily: font, cursor: taskIdx < turnierTasks.length - 1 ? "pointer" : "default", opacity: taskIdx < turnierTasks.length - 1 ? 1 : 0.35, marginLeft: "auto" }}>
                Weiter ▶
              </button>
            </div>
          )}
        </div>
      </div>

      {!canEdit && (
        <div style={{ background: C.playSoft, border: `1px solid ${C.line}`, borderRadius: 10, padding: "8px 12px", marginBottom: 14, fontSize: 12.5, color: C.fair }}>
          Ihr erledigt Aufgaben für <b>{boundTeam ? boundTeam.name : "euer Team"}</b>. Jede erledigte Aufgabe = +1.
        </div>
      )}

      {task && (
        <div style={{ border: `1px solid ${C.line}`, borderRadius: 12, padding: 14, background: C.chalk }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
            <AuTypeTag t={task.type} />
            {task.min > fenster && <span style={{ fontSize: 11.5, fontWeight: 700, color: C.whistle, background: C.card, border: `1px solid ${C.whistle}`, borderRadius: 6, padding: "2px 8px" }}>⚠ länger als Wartefenster ({task.min} min)</span>}
          </div>
          <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 12 }}>{task.text}</div>

          {!activeTeamId ? (
            <div style={{ fontSize: 13, color: C.sub }}>Zuerst ein Team wählen.</div>
          ) : task.type === "nennen" ? (
            <AuNennForm task={task} onDone={(answer) => complete(null, null, answer)} />
          ) : (
            <label style={{ ...auBtnPrimary, display: "inline-flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
              {auTypeMeta[task.type].emo} {task.type === "video" ? "Video" : "Foto"} aufnehmen & erledigen
              <input type="file" accept={task.type === "video" ? "video/*" : "image/*"} capture="environment" style={{ display: "none" }} onChange={(e) => auReadFile(e, (url, kind) => complete(url, kind))} />
            </label>
          )}
        </div>
      )}

      {log.length > 0 && (
        <div style={{ marginTop: 16 }}>
          <AuLabel>Zuletzt erledigt (diese Sitzung)</AuLabel>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {log.slice(-5).reverse().map((d) => (
              <div key={d.id} style={{ display: "flex", flexDirection: "column", gap: 2, fontSize: 13.5, background: C.playSoft, borderRadius: 8, padding: "6px 10px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span>{auTypeMeta[d.type].emo}</span>
                  <b>{teamById(d.teamId)?.name}</b>
                  <span style={{ color: C.sub, flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{taskById(d.taskId)?.text || "—"}</span>
                  <span style={{ color: C.fair, fontWeight: 700 }}>+1</span>
                </div>
                {d.answer && <div style={{ color: C.ink, fontSize: 12, paddingLeft: 26, fontStyle: "italic" }}>„{d.answer}“</div>}
              </div>
            ))}
          </div>
        </div>
      )}
    </Card>
  );

  // --- Teamzugang: schlanke Ansicht (eigenes Team + eigene Medien) ---
  if (role === "teamaccess") {
    return (
      <div style={{ fontFamily: font, color: C.ink }}>
        <style>{`.au-in{border:1px solid ${C.line};border-radius:9px;padding:8px 10px;font-family:${font};font-size:14px;color:${C.ink};background:#fff;}`}</style>
        {header}
        {erledigenPanel}
        {media.length > 0 && (
          <Section title="Eure Medien" hint="Highlights markiert der Headcoach fürs Beamer-Finale">
            <AuMediaGrid media={media} teamById={teamById} taskById={taskById} onStar={null} />
          </Section>
        )}
      </div>
    );
  }

  // --- Coach: read-only Ueberblick (Punkte aller Teams + Showroom-Medien) ---
  if (isCoachReadOnly) {
    return (
      <div style={{ fontFamily: font, color: C.ink }}>
        {header}
        <div style={{ background: C.playSoft, border: `1px solid ${C.line}`, borderRadius: 10, padding: "8px 12px", marginBottom: 14, fontSize: 12.5, color: C.fair }}>
          Wartefenster, Aufgaben-Ziehung und Pool verwaltet der Headcoach. Hier siehst du den aktuellen Punktestand aller Teams und die Showroom-Highlights.
        </div>
        <Section title="Punkte" hint="erledigte Aufgaben je Team">
          <div style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 16, padding: 8, overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 360 }}>
              <thead><tr style={{ color: C.sub, fontSize: 12 }}><AuTh style={{ textAlign: "left" }}>#</AuTh><AuTh style={{ textAlign: "left" }}>Team</AuTh><AuTh>Erledigt</AuTh><AuTh>Bonus (×{aufFactor})</AuTh></tr></thead>
              <tbody>
                {points.map((row, i) => (
                  <tr key={row.t.id} style={{ borderTop: `1px solid ${C.line}` }}>
                    <AuTd style={{ textAlign: "left", fontFamily: display, fontWeight: 700, color: i === 0 ? C.gold : C.sub, fontSize: 18 }}>{i + 1}</AuTd>
                    <AuTd style={{ textAlign: "left" }}><span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}><span style={{ width: 26, height: 26, borderRadius: 7, background: row.t.color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>{row.t.emoji}</span><b>{row.t.name}</b></span></AuTd>
                    <AuTd>{row.p}</AuTd>
                    <AuTd style={{ fontFamily: display, fontWeight: 700, fontSize: 22, color: C.auf }}>{row.p * aufFactor}</AuTd>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Section>
        {media.length > 0 && (
          <Section title="Showroom-Highlights" hint="markiert der Headcoach fürs Beamer-Finale">
            <AuMediaGrid media={media} teamById={teamById} taskById={taskById} onStar={null} />
          </Section>
        )}
      </div>
    );
  }

  // --- Headcoach: volle Ansicht ---
  return (
    <div style={{ fontFamily: font, color: C.ink }}>
      <style>{`.au-in{border:1px solid ${C.line};border-radius:9px;padding:8px 10px;font-family:${font};font-size:14px;color:${C.ink};background:#fff;}`}</style>
      {header}

      {/* Wartefenster */}
      <Card style={{ marginBottom: 14, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <span style={{ fontSize: 14, fontWeight: 600 }}>Wartefenster</span>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <AuSB onClick={() => setFenster(Math.max(1, fenster - 1))}>−</AuSB>
          <b style={{ fontFamily: display, fontSize: 22, minWidth: 28, textAlign: "center" }}>{fenster}</b>
          <AuSB onClick={() => setFenster(fenster + 1)} plus>+</AuSB>
          <span style={{ fontSize: 13, color: C.sub }}>Min</span>
        </div>
        <span style={{ fontSize: 12.5, color: C.sub, marginLeft: 4 }}>Aufgaben, die länger dauern, werden markiert.</span>
      </Card>

      {/* Spielrunden → Anzahl Aufgaben */}
      <Card style={{ marginBottom: 14, display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 14, fontWeight: 600 }}>Spielrunden</span>
          <AuSB onClick={() => setRunden(Math.max(1, runden - 1))}>−</AuSB>
          <b style={{ fontFamily: display, fontSize: 22, minWidth: 28, textAlign: "center" }}>{runden}</b>
          <AuSB onClick={() => setRunden(runden + 1)} plus>+</AuSB>
        </div>
        <span style={{ fontSize: 13, color: C.sub }}>→ es werden <b style={{ color: C.ink }}>{runden}</b> Aufgaben vergeben (eine pro Runde für die Pausierenden)</span>
        <button onClick={() => ziehen(runden)} style={{ ...auBtnPrimary, marginLeft: "auto" }}>🎲 {runden} Aufgaben ziehen</button>
      </Card>

      {/* Schwerpunkte (Organisationsebene) — eine Wahrheit: state.focusThemes via toggleTheme */}
      <Card style={{ marginBottom: 14 }}>
        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>Schwerpunkte {focusThemes.length > 0 && <span style={{ color: C.sub, fontWeight: 600, fontSize: 12.5 }}>· {focusThemes.length} aktiv</span>}</div>
        <div style={{ fontSize: 12.5, color: C.sub, marginBottom: 10, lineHeight: 1.5 }}>
          Wählt Themen — beim Ziehen kommen dann bevorzugt passende Aufgaben (rund 60 %). Alle sind positiv & kindgerecht formuliert; für die Kinder liest sich das als normales Teamspiel. Einfach mitlaufen lassen, nicht ansagen.
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
          {FOCUS_THEMES.map((th) => (
            <button key={th.k} onClick={() => dispatch({ type: "toggleTheme", key: th.k })} style={{ border: "none", background: "none", padding: 0, cursor: "pointer" }}>
              <Chip emo={th.emo} label={th.label} active={focusThemes.includes(th.k)} />
            </button>
          ))}
        </div>
      </Card>

      {/* Tabs */}
      <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
        <AuTab active={tab === "erledigen"} onClick={() => setTab("erledigen")}>Erledigen</AuTab>
        <AuTab active={tab === "punkte"} onClick={() => setTab("punkte")}>Punkte</AuTab>
        <AuTab active={tab === "showroom"} onClick={() => setTab("showroom")}>Showroom ({showroomCount})</AuTab>
        <AuTab active={tab === "pool"} onClick={() => setTab("pool")}>Pool ({pool.length})</AuTab>
      </div>

      {tab === "erledigen" && erledigenPanel}

      {tab === "punkte" && (
        <div style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 16, padding: 8, overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 360 }}>
            <thead><tr style={{ color: C.sub, fontSize: 12 }}><AuTh style={{ textAlign: "left" }}>#</AuTh><AuTh style={{ textAlign: "left" }}>Team</AuTh><AuTh>Erledigt</AuTh><AuTh>Bonus (×{aufFactor})</AuTh></tr></thead>
            <tbody>
              {points.map((row, i) => (
                <tr key={row.t.id} style={{ borderTop: `1px solid ${C.line}` }}>
                  <AuTd style={{ textAlign: "left", fontFamily: display, fontWeight: 700, color: i === 0 ? C.gold : C.sub, fontSize: 18 }}>{i + 1}</AuTd>
                  <AuTd style={{ textAlign: "left" }}><span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}><span style={{ width: 26, height: 26, borderRadius: 7, background: row.t.color, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 14 }}>{row.t.emoji}</span><b>{row.t.name}</b></span></AuTd>
                  <AuTd>{row.p}</AuTd>
                  <AuTd style={{ fontFamily: display, fontWeight: 700, fontSize: 22, color: C.auf }}>{row.p * aufFactor}</AuTd>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ fontSize: 12, color: C.sub, padding: "8px 10px 4px" }}>
            Jede erledigte Aufgabe zählt aktuell <b style={{ color: C.auf }}>×{aufFactor}</b> in der Gesamtwertung. Wie stark die Aufgaben die Tore überstimmen, stellst du dort über den Aufgaben-Faktor ein.
          </div>
        </div>
      )}

      {tab === "showroom" && (
        <Card>
          <div style={{ fontSize: 13.5, color: C.sub, marginBottom: 12 }}>Markiere die Highlights (⭐) fürs Beamer-Finale. Nur Video-/Foto-Aufgaben erscheinen hier — der Showroom zieht die markierten automatisch.</div>
          {media.length === 0 ? (
            <div style={{ fontSize: 13.5, color: C.sub }}>Noch keine Medien. Erledigt Video-/Foto-Aufgaben, dann erscheinen sie hier.</div>
          ) : (
            <AuMediaGrid media={media} teamById={teamById} taskById={taskById}
              onStar={(m) => dispatch({ type: "gallery/patch", teamId: m.teamId, itemId: m.id, patch: { star: !m.star } })} />
          )}
        </Card>
      )}

      {tab === "pool" && (
        <Card>
          <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap", alignItems: "center" }}>
            <input className="au-in" style={{ flex: 1, minWidth: 200 }} placeholder="Neue Aufgabe…" value={newTask}
              onChange={(e) => setNewTask(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter" && newTask.trim()) { dispatch({ type: "task/add", taskType: newType, text: newTask.trim() }); setNewTask(""); } }} />
            {["video", "foto", "nennen"].map((tt) => (
              <button key={tt} onClick={() => setNewType(tt)} style={{ border: `2px solid ${newType === tt ? auTypeMeta[tt].color : C.line}`, background: newType === tt ? auTypeMeta[tt].color : "#fff", color: newType === tt ? "#fff" : C.sub, borderRadius: 8, padding: "6px 10px", fontSize: 12.5, fontWeight: 700, cursor: "pointer" }}>{auTypeMeta[tt].emo} {auTypeMeta[tt].label}</button>
            ))}
            <button onClick={() => { if (newTask.trim()) { dispatch({ type: "task/add", taskType: newType, text: newTask.trim() }); setNewTask(""); } }} style={auBtnPrimary}>+</button>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {pool.map((p) => (
              <div key={p.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 10px", background: C.chalk, borderRadius: 8 }}>
                <AuTypeTag t={p.type} />
                <span style={{ flex: 1, fontSize: 14 }}>{p.text}</span>
                {p.themes && p.themes.length > 0 && <span style={{ fontSize: 12, color: C.sub }}>{p.themes.map((k) => (FOCUS_THEMES.find((f) => f.k === k) || {}).emo).join(" ")}</span>}
                {p.min > fenster && <span title="länger als Wartefenster" style={{ color: C.whistle, fontSize: 13 }}>⚠</span>}
                <button onClick={() => dispatch({ type: "task/remove", id: p.id })} style={{ border: "none", background: "none", color: C.sub, cursor: "pointer", fontSize: 16 }}>×</button>
              </div>
            ))}
          </div>
        </Card>
      )}

      <p style={{ textAlign: "center", color: C.sub, fontSize: 12, marginTop: 26 }}>Baustein · Medien halten im Prototyp nur für die Sitzung · Showroom nutzt die markierten Highlights (gallery.star)</p>
    </div>
  );
}

/* ---------- Aufgaben-Helfer (Au-präfixiert) ---------- */
function AuMediaGrid({ media, teamById, taskById, onStar }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(150px,1fr))", gap: 10 }}>
      {media.map((m) => (
        <div key={m.id} style={{ border: `2px solid ${m.star ? C.gold : C.line}`, borderRadius: 12, overflow: "hidden", background: "#fff" }}>
          {m.kind === "video"
            ? <video src={m.url} style={{ width: "100%", height: 96, objectFit: "cover", background: "#000", display: "block" }} controls />
            : <img src={m.url} alt="" style={{ width: "100%", height: 96, objectFit: "cover", display: "block" }} />}
          <div style={{ padding: 8 }}>
            <div style={{ fontSize: 11.5, color: C.sub, marginBottom: 6, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{teamById(m.teamId)?.name}{taskById(m.taskId) ? ` · ${taskById(m.taskId).text}` : ""}</div>
            {onStar
              ? <button onClick={() => onStar(m)} style={{ width: "100%", border: `1px solid ${m.star ? C.gold : C.line}`, background: m.star ? C.gold : "#fff", color: m.star ? "#fff" : C.sub, borderRadius: 8, padding: "5px 0", fontSize: 12.5, fontWeight: 700, cursor: "pointer" }}>{m.star ? "★ im Showroom" : "☆ zeigen"}</button>
              : <div style={{ fontSize: 12.5, fontWeight: 700, color: m.star ? C.gold : C.sub, textAlign: "center" }}>{m.star ? "★ im Showroom" : "☆ noch nicht"}</div>}
          </div>
        </div>
      ))}
    </div>
  );
}
// Sperre gegen Leer-Abhaken: MC-Aufgaben (task.mc gesetzt) verlangen alle
// richtigen (und keine falschen) Auswahlen; alle anderen "nennen"-Aufgaben
// verlangen einen echten Freitext (keine leere/1-Zeichen-Eingabe).
function AuNennForm({ task, onDone }) {
  const mc = task && task.mc;
  const [sel, setSel] = useState([]);
  const [text, setText] = useState("");

  if (mc && mc.length) {
    const correctIdx = mc.map((o, i) => (o.correct ? i : null)).filter((i) => i !== null);
    const needed = correctIdx.length;
    const toggle = (i) => setSel((s) => (s.includes(i) ? s.filter((x) => x !== i) : [...s, i]));
    const allCorrectSelected = correctIdx.every((i) => sel.includes(i));
    const noWrongSelected = sel.every((i) => mc[i].correct);
    const canSubmit = allCorrectSelected && noWrongSelected;
    return (
      <div>
        <div style={{ fontSize: 12.5, color: C.sub, marginBottom: 8 }}>
          Wählt {needed === 1 ? "die richtige Antwort" : `die ${needed} richtigen Antworten`} aus:
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 10 }}>
          {mc.map((o, i) => (
            <button
              key={i}
              type="button"
              onClick={() => toggle(i)}
              style={{
                textAlign: "left",
                padding: "8px 12px",
                borderRadius: 8,
                border: `1.5px solid ${sel.includes(i) ? C.play : C.line}`,
                background: sel.includes(i) ? C.playSoft : "#fff",
                fontSize: 13.5,
                cursor: "pointer",
                fontFamily: font,
              }}
            >
              {sel.includes(i) ? "☑" : "☐"} {o.text}
            </button>
          ))}
        </div>
        {sel.length > 0 && !canSubmit && (
          <div style={{ fontSize: 12, color: C.whistle, marginBottom: 8 }}>Noch nicht ganz richtig — schaut nochmal genau hin.</div>
        )}
        <button
          disabled={!canSubmit}
          onClick={() => onDone(mc.filter((_, i) => sel.includes(i)).map((o) => o.text).join(", "))}
          style={{ ...auBtnPrimary, opacity: canSubmit ? 1 : 0.4, cursor: canSubmit ? "pointer" : "not-allowed" }}
        >
          ✓ Erledigt (+1)
        </button>
      </div>
    );
  }

  const trimmed = text.trim();
  const valid = trimmed.length >= 3;
  return (
    <div>
      <textarea
        className="au-in"
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Eure Antwort eintippen…"
        rows={2}
        style={{ width: "100%", resize: "vertical", marginBottom: 8, fontFamily: font }}
      />
      <button
        disabled={!valid}
        onClick={() => onDone(trimmed)}
        style={{ ...auBtnPrimary, opacity: valid ? 1 : 0.4, cursor: valid ? "pointer" : "not-allowed" }}
      >
        ✓ Erledigt (+1)
      </button>
      {!valid && text.length > 0 && <div style={{ fontSize: 12, color: C.sub, marginTop: 6 }}>Schreibt kurz eure Antwort, bevor ihr abhakt.</div>}
    </div>
  );
}
function AuLabel({ children }) { return <div style={{ fontSize: 12.5, fontWeight: 600, color: C.sub, marginBottom: 6 }}>{children}</div>; }
function AuTypeTag({ t }) { const m = auTypeMeta[t]; return <span style={{ fontSize: 11.5, fontWeight: 700, color: "#fff", background: m.color, borderRadius: 6, padding: "2px 8px" }}>{m.emo} {m.label}</span>; }
function AuTab({ active, onClick, children }) {
  return <button onClick={onClick} style={{ border: "none", borderBottom: `3px solid ${active ? C.play : "transparent"}`, background: "none", color: active ? C.ink : C.sub, fontFamily: display, fontWeight: 700, fontSize: 16, textTransform: "uppercase", letterSpacing: 0.5, padding: "4px 8px 8px", cursor: "pointer" }}>{children}</button>;
}
function AuTh({ children, style }) { return <th style={{ padding: "8px 10px", fontWeight: 600, textAlign: "right", ...style }}>{children}</th>; }
function AuTd({ children, style }) { return <td style={{ padding: "8px 10px", textAlign: "right", fontSize: 14, ...style }}>{children}</td>; }
function AuSB({ children, onClick, plus }) { return <button onClick={onClick} style={{ width: 30, height: 30, borderRadius: 7, border: `1px solid ${plus ? C.play : C.line}`, background: plus ? C.play : "#fff", color: plus ? "#fff" : C.ink, fontSize: 18, lineHeight: 1, cursor: "pointer", fontWeight: 700, padding: 0 }}>{children}</button>; }
const auBtnPrimary = { border: "none", background: C.play, color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 15, padding: "9px 16px", borderRadius: 10, cursor: "pointer", letterSpacing: 0.5 };


/* =====================================================================
   VIEW: HEADCOACH-LIVE-STEUERUNG  (eingehängter Baustein 9)
   Portiert aus headcoach-live.jsx — eigenes Theme, Fonts, Logo & Demo-
   Daten raus; alles über useStore(). Das Eingriffs-Werkzeug des Headcoachs:
   laufende Spieluhr, An-/Abpfiff, Runden live verlängern / kürzen / streichen
   und eine Rundenübersicht.

   EINE Wahrheit: der Rundenplan wird aus der Zeitplaner-config abgeleitet
   (buildLiveRounds: jeder gegen jeden × targetRR, Basisdauer aus gameDur) und
   liegt zusammen mit der laufenden Runde/Uhr in state.live — die „aktuelle
   Live-Runde", die Website & Showroom später lesen. Es gibt keinen zweiten
   Rundenplan und keine zweite Uhr; jeder Eingriff schreibt über live/* in den
   Store. Nur-Headcoach. Helfer Hl…-präfixiert. Die Spieluhr wohnt HIER (der
   Live-Zähler bringt bewusst keine eigene mit).
   ===================================================================== */
const hlMmss = (s) => `${Math.floor(Math.max(0, s) / 60)}:${String(Math.max(0, s) % 60).padStart(2, "0")}`;

function HlBigBtn({ children, onClick, bg, disabled }) {
  return <button onClick={onClick} disabled={disabled} style={{ border: "none", background: disabled ? "#C7D3CC" : bg, color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 20, padding: "16px 12px", borderRadius: 16, cursor: disabled ? "default" : "pointer", textTransform: "uppercase", letterSpacing: 0.5 }}>{children}</button>;
}
function HlAdj({ children, onClick, c }) {
  return <button onClick={onClick} style={{ border: `1.5px solid ${c}`, background: "#fff", color: c, borderRadius: 10, padding: "7px 12px", fontFamily: display, fontWeight: 700, fontSize: 13.5, cursor: "pointer" }}>{children}</button>;
}
function HlMiniBtn({ children, onClick, plus }) {
  return <button onClick={onClick} style={{ width: 28, height: 28, borderRadius: 7, border: `1px solid ${plus ? C.play : C.line}`, background: plus ? C.play : "#fff", color: plus ? "#fff" : C.ink, fontSize: 16, fontWeight: 700, cursor: "pointer", padding: 0 }}>{children}</button>;
}
function HlStatusPill({ st }) {
  const map = { live: ["läuft", C.play, C.playSoft], done: ["gespielt ✓", C.sub, C.chalk], skipped: ["gestrichen", C.whistle, C.whistleSoft], planned: ["geplant", C.sub, C.chalk] };
  const [txt, col, bg] = map[st];
  return <span style={{ background: bg, color: col, borderRadius: 999, padding: "4px 10px", fontSize: 12, fontWeight: 700 }}>{txt}</span>;
}
const hlGhost = { border: `1.5px solid ${C.line}`, background: "#fff", color: C.ink, fontFamily: display, fontWeight: 700, fontSize: 14, padding: "10px 14px", borderRadius: 10, cursor: "pointer", letterSpacing: 0.5 };

function HeadcoachLive() {
  const { state, dispatch } = useStore();
  const { rounds, cur, running } = state.live;
  const remaining = useLiveRemaining(); // Stand 36: aus dem Zeitstempel
  const round = rounds[cur];
  const timeUp = remaining <= 0;
  // Spieluhr: taktet die EINE Wahrheit im Store (live/tick) — Stand 36: derselbe
  // Helfer wie in "Jetzt", damit nie zwei Uhren auf einem Geraet laufen.
  useLiveTicker(true);

  const statusOf = (i) => rounds[i].skipped ? "skipped" : rounds[i].done ? "done" : i === cur ? "live" : "planned";
  const remainingRounds = useMemo(() => rounds.filter((r, i) => !r.done && !r.skipped && i !== cur).length, [rounds, cur]);
  const progress = round ? 1 - remaining / round.dur : 0;
  const allDone = rounds.every((r) => r.done || r.skipped);

  const cfg = state.tournament.config;
  const rebuild = () => {
    if (typeof window !== "undefined" && window.confirm && !window.confirm("Rundenplan neu aus dem Zeitplaner erzeugen? Der aktuelle Live-Fortschritt (gespielt/gestrichen, live geänderte Zeiten) geht dabei verloren.")) return;
    dispatch({ type: "live/rebuild" });
  };

  return (
    <div style={{ maxWidth: 720, margin: "0 auto" }}>
      <style>{`@keyframes hlPulse{0%,100%{opacity:1;}50%{opacity:.35;}}`}</style>

      {/* Kopf */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: C.play, display: "grid", placeItems: "center", fontSize: 22, flexShrink: 0 }}>🎽</div>
        <div>
          <div style={{ fontFamily: display, fontWeight: 700, fontSize: 24, textTransform: "uppercase", letterSpacing: 0.5, lineHeight: 1 }}>Headcoach-Live-Steuerung</div>
          <div style={{ color: C.sub, fontSize: 13, marginTop: 3 }}>Spieluhr · An-/Abpfiff · Runden live verlängern, kürzen, streichen</div>
        </div>
      </div>

      {allDone ? (
        <div style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 18, padding: 36, textAlign: "center" }}>
          <div style={{ fontSize: 52 }}>🏁</div>
          <div style={{ fontFamily: display, fontWeight: 700, fontSize: 30, textTransform: "uppercase" }}>Alle Runden gespielt</div>
          <div style={{ color: C.sub, marginTop: 6 }}>Weiter zur Siegerehrung.</div>
        </div>
      ) : (
        <>
          {/* SPIELUHR */}
          <div style={{ background: C.card, border: `2px solid ${timeUp ? C.whistle : running ? C.play : C.line}`, borderRadius: 20, padding: "22px 22px 20px", textAlign: "center", transition: "border-color .3s" }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 10, marginBottom: 8 }}>
              <span style={{ fontFamily: display, fontWeight: 700, fontSize: 22, textTransform: "uppercase", letterSpacing: 0.5 }}>Runde {round.n}</span>
              <span style={{ fontSize: 13, color: C.sub, background: C.chalk, borderRadius: 20, padding: "3px 10px" }}>{round.phase}</span>
            </div>

            <div style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(64px,18vw,120px)", lineHeight: 0.9, color: timeUp ? C.whistle : C.ink, fontVariantNumeric: "tabular-nums", animation: timeUp ? "hlPulse 1s infinite" : "none" }}>{hlMmss(remaining)}</div>

            <div style={{ height: 8, background: C.chalk, borderRadius: 6, overflow: "hidden", margin: "10px 0 4px" }}>
              <div style={{ width: `${Math.min(100, progress * 100)}%`, height: "100%", background: timeUp ? C.whistle : C.play, transition: "width .5s linear" }} />
            </div>
            <div style={{ fontSize: 12.5, color: C.sub }}>{timeUp ? "Zeit um — abpfeifen!" : `von ${hlMmss(round.dur)}`}</div>

            {/* Zeit-Eingriff */}
            <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 16, flexWrap: "wrap" }}>
              <HlAdj onClick={() => dispatch({ type: "live/adjust", delta: -30 })} c={C.brk}>−30 s kürzen</HlAdj>
              <HlAdj onClick={() => dispatch({ type: "live/adjust", delta: -10 })} c={C.brk}>−10 s</HlAdj>
              <HlAdj onClick={() => dispatch({ type: "live/adjust", delta: 10 })} c={C.play}>+10 s</HlAdj>
              <HlAdj onClick={() => dispatch({ type: "live/adjust", delta: 30 })} c={C.play}>+30 s verlängern</HlAdj>
            </div>
          </div>

          {/* Hauptknöpfe */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 12 }}>
            {running
              ? <HlBigBtn onClick={() => dispatch({ type: "live/pause" })} bg={C.brk}>❚❚ Pause</HlBigBtn>
              : <HlBigBtn onClick={() => dispatch({ type: "live/start" })} bg={C.play} disabled={timeUp}>▶ Anpfiff</HlBigBtn>}
            <HlBigBtn onClick={() => dispatch({ type: "live/whistleEnd", idx: state.live.cur })} bg={C.whistle}>⏹ Abpfiff → nächste</HlBigBtn>
          </div>
          <div style={{ display: "flex", gap: 10, marginTop: 10, flexWrap: "wrap" }}>
            <button onClick={() => dispatch({ type: "live/resetClock" })} style={{ ...hlGhost, flex: 1 }}>↺ Uhr zurücksetzen</button>
            <button onClick={() => dispatch({ type: "live/skip", idx: state.live.cur })} style={{ ...hlGhost, flex: 1, color: C.whistle, borderColor: "#F3C9C9" }}>✕ Runde streichen</button>
          </div>
          <div style={{ textAlign: "center", color: C.sub, fontSize: 12.5, marginTop: 10 }}>Noch {remainingRounds} Runde{remainingRounds === 1 ? "" : "n"} nach dieser geplant.</div>
        </>
      )}

      {/* RUNDENÜBERSICHT */}
      <div style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 12, margin: "24px 0 10px", flexWrap: "wrap" }}>
        <div style={{ fontFamily: display, fontWeight: 700, fontSize: 20, textTransform: "uppercase", letterSpacing: 0.5 }}>Runden</div>
        <button onClick={rebuild} title="Plan neu aus dem Zeitplaner erzeugen (jeder gegen jeden × Durchgänge, Basisdauer aus der Spielzeit)" style={{ border: `1px solid ${C.line}`, background: C.chalk, color: C.sub, borderRadius: 999, padding: "5px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: font }}>⟳ Plan aus Zeitplaner ({cfg.targetRR}× jgj · {cfg.gameDur} min)</button>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {rounds.map((r, i) => {
          const st = statusOf(i);
          const c = st === "live" ? C.play : st === "done" ? C.sub : st === "skipped" ? C.whistle : C.line;
          return (
            <div key={r.id} style={{ background: C.card, border: `1px solid ${st === "live" ? C.play : C.line}`, borderRadius: 12, padding: "10px 14px", display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", opacity: st === "skipped" ? 0.6 : 1, boxShadow: st === "live" ? "0 4px 14px rgba(39,166,97,.18)" : "none" }}>
              <div style={{ width: 34, height: 34, borderRadius: "50%", display: "grid", placeItems: "center", background: st === "live" ? C.play : "transparent", border: `2px solid ${c}`, color: st === "live" ? "#fff" : c, fontFamily: display, fontWeight: 700, fontSize: 16, flexShrink: 0 }}>{r.n}</div>
              <div style={{ flex: 1, minWidth: 120 }}>
                <div style={{ fontWeight: 600, fontSize: 14.5 }}>Runde {r.n}</div>
                <div style={{ fontSize: 12, color: C.sub }}>{r.phase}</div>
              </div>
              <HlStatusPill st={st} />
              {st === "planned" && (
                <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  <HlMiniBtn onClick={() => dispatch({ type: "live/setDur", id: r.id, dur: r.dur - 30 })}>−</HlMiniBtn>
                  <span style={{ fontFamily: display, fontWeight: 700, fontSize: 15, minWidth: 44, textAlign: "center" }}>{hlMmss(r.dur)}</span>
                  <HlMiniBtn onClick={() => dispatch({ type: "live/setDur", id: r.id, dur: r.dur + 30 })} plus>+</HlMiniBtn>
                </div>
              )}
              {st === "live" && <span style={{ fontFamily: display, fontWeight: 700, fontSize: 15, color: C.play }}>{hlMmss(remaining)}</span>}
              {(st === "done" || st === "skipped") && <button onClick={() => dispatch({ type: "live/reopen", idx: i })} style={{ ...hlGhost, padding: "5px 10px", fontSize: 12.5 }}>↩ neu</button>}
            </div>
          );
        })}
      </div>

      <p style={{ textAlign: "center", color: C.sub, fontSize: 12, marginTop: 24 }}>
        Die aktuelle Live-Runde entsteht hier. Im fertigen Turnier wirken diese Eingriffe per Echtzeit sofort auf allen Geräten (Boxen, Beamer, Team-Handys); Website & Showroom lesen die laufende Runde aus derselben Wahrheit.
      </p>
    </div>
  );
}


/* =====================================================================
   VIEW: SHOWROOM (Beamer-Finale)  (eingehängter Baustein 8)
   Portiert aus showroom.jsx — eigenes Theme, Fonts, Logo & Demo-Daten
   raus; alles über useStore(). Presenter-gesteuerte Slideshow, dunkel
   projiziert (weißes Logo bleibt on-brand).
   EINE Wahrheit: Punkte kommen über teamScore aus den Store-Feldern
   (identisch zur Gesamtwertung), Fairplay aus fpStars, die ⭐-Highlights
   aus gallery.star (markiert in den Aufgaben), die Faktoren aus
   state.factors (einstellbar in der Gesamtwertung). Showroom RECHNET und
   PFLEGT nichts eigenes — nur die reine Show-Steuerung (welche Abschnitte,
   welche Slide, Tempo, Vollbild) bleibt lokaler UI-State. Helfer Sr…-präfixiert.
   ===================================================================== */

// Beamer-Tokens (nur Darstellung, keine Wahrheit): dunkle Basis aus dem
// zentralen Theme, dazu die halbtransparenten Panel-/Text-Töne der Show.
const SR = {
  bg0: C.beamerBg0, bg1: C.beamerBg1, glow: C.beamerGlow,
  panel: "rgba(255,255,255,.06)", panelLine: "rgba(255,255,255,.14)", inkDim: "rgba(255,255,255,.62)",
};

function Showroom() {
  return <MitEnthuellung weiterText="📽️ Weiter zur Beamer-Show"><ShowroomInhalt /></MitEnthuellung>;
}
function ShowroomInhalt() {
  const { state } = useStore();
  const tName = state.tournament.meta.title;

  // Punkte aus der EINEN Wahrheit (teamScore, wie die Gesamtwertung):
  // base = Tore (inkl. Teamspiel×Faktor) · bF = Fairplay-Bonus · bA = Aufgaben-Bonus.
  const ranked = useMemo(() => state.teams
    .map((t) => {
      const sc = teamScore(t, state.factors);
      return { id: t.id, name: t.name, emoji: t.emoji, color: t.color, base: sc.base, bF: sc.fp, bA: sc.auf, total: sc.total, fp: t.fpStars };
    })
    .sort((a, b) => b.total - a.total), [state.teams, state.factors]);
  const maxTotal = Math.max(1, ...ranked.map((r) => r.total));
  const fairRanked = useMemo(() => state.teams
    .map((t) => ({ id: t.id, name: t.name, emoji: t.emoji, fp: t.fpStars }))
    .sort((a, b) => b.fp - a.fp), [state.teams]);

  // ⭐-Highlights aus den Aufgaben (gallery.star). Bildunterschrift = Aufgabentext.
  const taskById = useCallback((id) => state.taskPool.find((p) => p.id === id), [state.taskPool]);
  const media = useMemo(() => state.teams.flatMap((t) =>
    t.gallery.filter((g) => g.star).map((g) => ({
      id: g.id, type: g.kind, url: g.url, caption: taskById(g.taskId)?.text || "", team: t.name, emoji: t.emoji,
    }))
  ), [state.teams, taskById]);

  // reine Show-Steuerung (lokaler UI-State)
  // Stand 35: Fairplay-/Highlight-Folien nur im Kontext Schule vorbelegt.
  const [show, setShow] = useState(() => { const v = !isSchlank(state); return { race: true, podium: true, fairplay: v, highlights: v }; });
  const [idx, setIdx] = useState(0);
  const [playing, setPlaying] = useState(true);
  const [secs, setSecs] = useState(8);
  const [edit, setEdit] = useState(false);
  const stageRef = useRef(null);

  // Slides dynamisch bauen — Highlights werden zu je einer Slide expandiert
  const slides = useMemo(() => {
    const s = [{ kind: "intro" }];
    if (show.race) s.push({ kind: "race" });
    if (show.podium) s.push({ kind: "podium" });
    if (show.fairplay) s.push({ kind: "fairplay" });
    if (show.highlights) {
      if (media.length) media.forEach((m, i) => s.push({ kind: "highlight", m, n: i + 1, of: media.length }));
      else s.push({ kind: "highlight-empty" });
    }
    s.push({ kind: "outro" });
    return s;
  }, [show, media]);

  const count = slides.length;
  const cur = Math.min(idx, count - 1);
  const go = useCallback((d) => setIdx((i) => (((i + d) % count) + count) % count), [count]);
  const jump = useCallback((n) => setIdx(Math.max(0, Math.min(count - 1, n))), [count]);

  // Auto-Advance (Rennen etwas länger, Videos etwas länger)
  useEffect(() => {
    if (!playing || edit || count <= 1) return;
    const kind = slides[cur]?.kind;
    const isVideo = kind === "highlight" && slides[cur].m?.type === "video";
    const base = kind === "race" ? Math.max(secs, 11) : isVideo ? secs + 6 : secs;
    const t = setTimeout(() => go(1), base * 1000);
    return () => clearTimeout(t);
  }, [playing, edit, cur, secs, count, slides, go]);

  // Tastatur: Pfeile blättern, Leertaste pausiert
  useEffect(() => {
    const h = (e) => {
      if (e.target.matches && e.target.matches("input,textarea,select")) return;
      if (e.key === "ArrowRight") go(1);
      else if (e.key === "ArrowLeft") go(-1);
      else if (e.key === " ") { e.preventDefault(); setPlaying((p) => !p); }
    };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [go]);

  const fullscreen = () => {
    const el = stageRef.current; if (!el) return;
    if (document.fullscreenElement) document.exitFullscreen?.();
    else el.requestFullscreen?.();
  };

  const s = slides[cur];

  return (
    <div ref={stageRef} style={{ position: "relative", minHeight: "100%", fontFamily: font, color: "#fff", overflow: "hidden",
      background: `radial-gradient(120% 120% at 50% 28%, ${SR.bg0} 0%, ${SR.bg1} 72%)` }}>
      <style>{`
        .sr-fade{animation:srFade .5s ease both;}
        @keyframes srFade{from{opacity:0;transform:translateY(14px);}to{opacity:1;transform:none;}}
        @keyframes srRise{from{transform:scaleY(0);}to{transform:scaleY(1);}}
        .sr-dot{width:9px;height:9px;border-radius:50%;border:none;cursor:pointer;padding:0;transition:transform .15s;}
        .sr-dot:hover{transform:scale(1.3);}
        @media (prefers-reduced-motion: reduce){.sr-fade{animation:none;} }
      `}</style>

      {/* Ambient „Box"-Feldlinien */}
      <svg viewBox="0 0 1000 600" preserveAspectRatio="xMidYMid slice" aria-hidden="true"
        style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0.09, pointerEvents: "none" }}>
        <rect x="60" y="40" width="880" height="520" rx="10" fill="none" stroke="#fff" strokeWidth="2" />
        <line x1="500" y1="40" x2="500" y2="560" stroke="#fff" strokeWidth="2" />
        <circle cx="500" cy="300" r="90" fill="none" stroke="#fff" strokeWidth="2" />
        <circle cx="500" cy="300" r="4" fill="#fff" />
      </svg>

      {/* Kopf: Logo + Turniername */}
      <div style={{ position: "relative", zIndex: 2, display: "flex", alignItems: "center", gap: 12, padding: "18px 22px" }}>
        <img src={LOGO_WHITE} alt={BRAND} style={{ height: 30 }} />
        <div style={{ width: 1, height: 20, background: SR.panelLine }} />
        <span style={{ fontFamily: display, fontWeight: 700, letterSpacing: 1.5, textTransform: "uppercase", fontSize: 14, color: SR.inkDim }}>Showroom</span>
        <span style={{ marginLeft: "auto", fontSize: 13, color: SR.inkDim }}>{tName}</span>
      </div>

      {/* BÜHNE */}
      <div style={{ position: "relative", zIndex: 2, minHeight: "min(78vh, 620px)", display: "grid", placeItems: "center", padding: "10px 22px 120px" }}>
        <div key={cur} className="sr-fade" style={{ width: "100%", maxWidth: 980 }}>
          {s.kind === "intro" && <SrIntro name={tName} />}
          {s.kind === "race" && <SrRaceReveal ranked={ranked} maxTotal={maxTotal} />}
          {s.kind === "podium" && <SrPodium ranked={ranked} />}
          {s.kind === "fairplay" && <SrFairplay fairRanked={fairRanked} />}
          {s.kind === "highlight" && <SrHighlight slide={s} />}
          {s.kind === "highlight-empty" && <SrHighlightEmpty />}
          {s.kind === "outro" && <SrOutro name={tName} />}
        </div>
      </div>

      {/* STEUERLEISTE */}
      <div style={{ position: "fixed", left: "50%", bottom: 16, transform: "translateX(-50%)", zIndex: 5,
        display: "flex", alignItems: "center", gap: 10, background: "rgba(6,20,15,.72)", backdropFilter: "blur(8px)",
        border: `1px solid ${SR.panelLine}`, borderRadius: 16, padding: "8px 12px", maxWidth: "calc(100% - 24px)", flexWrap: "wrap", justifyContent: "center" }}>
        <SrCtrl onClick={() => go(-1)} title="Zurück (◀)">◀</SrCtrl>
        <SrCtrl onClick={() => setPlaying((p) => !p)} title="Pause / Weiter (Leertaste)" wide>{playing ? "❚❚" : "▶"}</SrCtrl>
        <SrCtrl onClick={() => go(1)} title="Weiter (▶)">▶</SrCtrl>
        <div style={{ display: "flex", gap: 6, alignItems: "center", padding: "0 6px" }}>
          {slides.map((_, i) => (
            <button key={i} className="sr-dot" onClick={() => jump(i)} aria-label={`Slide ${i + 1}`}
              style={{ background: i === cur ? SR.glow : "rgba(255,255,255,.28)", width: i === cur ? 22 : 9, borderRadius: 20 }} />
          ))}
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <SrCtrl onClick={() => setSecs((v) => Math.max(3, v - 1))} title="Kürzer">−</SrCtrl>
          <span style={{ fontFamily: display, fontWeight: 700, fontSize: 15, minWidth: 34, textAlign: "center" }}>{secs}s</span>
          <SrCtrl onClick={() => setSecs((v) => Math.min(30, v + 1))} title="Länger">+</SrCtrl>
        </div>
        <SrCtrl onClick={fullscreen} title="Vollbild">⛶</SrCtrl>
        <SrCtrl onClick={() => setEdit((e) => !e)} title="Show einstellen" active={edit}>✎</SrCtrl>
      </div>

      {/* EINSTELL-SCHUBLADE (nur Show-Steuerung — keine zweite Wahrheit) */}
      {edit && <SrEditor show={show} setShow={setShow} factors={state.factors} mediaCount={media.length} close={() => setEdit(false)} />}
    </div>
  );
}

/* ---------- Showroom-Slides (Sr-präfixiert) ---------- */

function SrEyebrow({ children }) {
  return <div style={{ fontFamily: display, fontWeight: 700, letterSpacing: 3, textTransform: "uppercase", fontSize: 15, color: SR.glow, marginBottom: 10, textAlign: "center" }}>{children}</div>;
}
function SrBig({ children, style }) {
  return <div style={{ fontFamily: display, fontWeight: 700, textTransform: "uppercase", lineHeight: 0.98, textAlign: "center", fontSize: "clamp(40px, 8vw, 96px)", ...style }}>{children}</div>;
}
function SrLegend({ c, children }) {
  return <span style={{ display: "inline-flex", alignItems: "center", gap: 7 }}><span style={{ width: 12, height: 12, borderRadius: 3, background: c }} />{children}</span>;
}

function SrIntro({ name }) {
  return (
    <div style={{ textAlign: "center" }}>
      <img src={LOGO_WHITE} alt={BRAND} style={{ height: "clamp(56px,10vw,120px)", marginBottom: 26, filter: `drop-shadow(0 0 30px rgba(62,224,140,.4))` }} />
      <SrBig>{name}</SrBig>
      <div style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(20px,3vw,32px)", color: SR.glow, letterSpacing: 2, marginTop: 14, textTransform: "uppercase" }}>Siegerehrung &amp; Showroom</div>
      <div style={{ color: SR.inkDim, fontSize: 15, marginTop: 18 }}>Los geht's — Leertaste zum Pausieren, ◀ ▶ zum Blättern.</div>
    </div>
  );
}

// Reality-Show-Reveal: alle Teams als Balken-Rennen. Erst rennen die Balken
// (mit hochzählenden Punkten), dann — wenn sie stehen — klappen die Namen rein.
function SrRaceReveal({ ranked, maxTotal }) {
  const reduce = useRef(typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)").matches : false).current;
  const RACE = 2800;
  const [p, setP] = useState(reduce ? 1 : 0);        // Renn-Fortschritt 0..1
  const [revealed, setRevealed] = useState(reduce);   // Namen sichtbar?

  useEffect(() => {
    if (reduce) return;
    let raf, hold, start = null;
    const step = (ts) => {
      if (start === null) start = ts;
      const t = Math.min(1, (ts - start) / RACE);
      setP(1 - Math.pow(1 - t, 3)); // ease-out cubic
      if (t < 1) raf = requestAnimationFrame(step);
      else hold = setTimeout(() => setRevealed(true), 220);
    };
    raf = requestAnimationFrame(step);
    return () => { cancelAnimationFrame(raf); clearTimeout(hold); };
  }, [reduce]);

  const medal = ["🥇", "🥈", "🥉"];
  const ring = [C.gold, C.silver, C.bronze];
  const winner = ranked[0];

  return (
    <div>
      <SrEyebrow>Gesamtwertung</SrEyebrow>
      <div style={{ textAlign: "center", height: 30, marginBottom: 10 }}>
        {revealed
          ? <span style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(18px,2.6vw,26px)", color: C.gold, textTransform: "uppercase", letterSpacing: 1 }}>🥇 {winner?.name} gewinnt!</span>
          : <span style={{ fontFamily: display, fontWeight: 700, fontSize: 16, color: SR.inkDim, letterSpacing: 2, textTransform: "uppercase" }}>Die Wertung läuft&nbsp;…</span>}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 2 }}>
        {ranked.map((r, i) => {
          const tot = r.total || 1;
          const w = (r.total / maxTotal) * 100 * p;   // Balkenlänge folgt dem Rennen
          const pts = Math.round(r.total * p);         // Punkte zählen mit hoch
          const isWin = i === 0;
          return (
            <div key={r.id} style={{ display: "flex", alignItems: "center", gap: 14 }}>
              <div style={{ width: "clamp(150px,26vw,240px)", display: "flex", alignItems: "center", gap: 10, flexShrink: 0,
                opacity: revealed ? 1 : 0, transform: revealed ? "none" : "translateX(-10px)",
                transition: `opacity .5s ease ${i * 110}ms, transform .5s ease ${i * 110}ms` }}>
                <span style={{ fontFamily: display, fontWeight: 700, fontSize: 26, width: 32, textAlign: "right", color: i < 3 ? ring[i] : "rgba(255,255,255,.5)" }}>{i < 3 ? medal[i] : i + 1}</span>
                <span style={{ fontSize: 26 }}>{r.emoji}</span>
                <span style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(15px,2vw,22px)", textTransform: "uppercase", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.name}</span>
              </div>
              <div style={{ flex: 1, minWidth: 0, position: "relative", height: isWin ? 26 : 20, borderRadius: 8, background: "rgba(255,255,255,.08)",
                boxShadow: revealed && isWin ? `0 0 0 2px ${C.gold}, 0 0 24px rgba(232,161,0,.4)` : "none", transition: "box-shadow .4s ease" }}>
                <div style={{ position: "absolute", left: 0, top: 0, bottom: 0, width: `${w}%`, display: "flex", borderRadius: 8, overflow: "hidden" }}>
                  <div style={{ width: `${(r.base / tot) * 100}%`, background: C.tore }} />
                  <div style={{ width: `${(r.bF / tot) * 100}%`, background: C.fp }} />
                  <div style={{ width: `${(r.bA / tot) * 100}%`, background: C.auf }} />
                </div>
                <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", fontFamily: display, fontWeight: 700,
                  fontSize: isWin ? 18 : 15, color: "#fff", textShadow: "0 1px 4px rgba(0,0,0,.6)" }}>{pts}<span style={{ fontSize: 11, color: SR.inkDim, fontWeight: 600 }}> Pkt</span></span>
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ display: "flex", gap: 18, justifyContent: "center", marginTop: 18, fontSize: 13.5, color: SR.inkDim, flexWrap: "wrap",
        opacity: revealed ? 1 : 0.35, transition: "opacity .5s ease" }}>
        <SrLegend c={C.tore}>Tore</SrLegend>
        <SrLegend c={C.fp}>Fairplay</SrLegend>
        <SrLegend c={C.auf}>Aufgaben</SrLegend>
      </div>
    </div>
  );
}

// Klassisches Podest (Top 3, Säulen 2·1·3) — die Auflösung nach dem Rennen.
function SrPodium({ ranked }) {
  const top = ranked.slice(0, 3);
  const order = [top[1], top[0], top[2]].filter(Boolean); // 2 · 1 · 3
  const heights = { 0: 210, 1: 150, 2: 116 }; // per Platzierung
  const medal = ["🥇", "🥈", "🥉"];
  const ring = [C.gold, C.silver, C.bronze];
  return (
    <div>
      <SrEyebrow>Das Podest</SrEyebrow>
      <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "center", gap: "clamp(10px,3vw,34px)", marginTop: 10 }}>
        {order.map((t) => {
          const place = ranked.indexOf(t); // 0/1/2
          return (
            <div key={t.id} style={{ textAlign: "center", flex: "0 1 220px" }}>
              <div style={{ fontSize: "clamp(30px,6vw,54px)", marginBottom: 6 }}>{medal[place]}</div>
              <div style={{ width: "clamp(56px,9vw,84px)", height: "clamp(56px,9vw,84px)", margin: "0 auto 10px", borderRadius: "50%",
                display: "grid", placeItems: "center", fontSize: "clamp(28px,5vw,44px)", background: t.color,
                boxShadow: `0 0 0 4px ${ring[place]}, 0 10px 30px rgba(0,0,0,.4)` }}>{t.emoji}</div>
              <div style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(18px,2.4vw,26px)", textTransform: "uppercase", lineHeight: 1 }}>{t.name}</div>
              <div style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(26px,4vw,40px)", color: SR.glow, marginTop: 2 }}>{t.total}<span style={{ fontSize: 14, color: SR.inkDim, fontWeight: 600 }}> Pkt</span></div>
              <div style={{ height: heights[place], background: `linear-gradient(180deg, ${t.color}, ${t.color}22)`, borderRadius: "10px 10px 0 0",
                marginTop: 12, transformOrigin: "bottom", animation: "srRise .6s ease both", position: "relative", border: `1px solid ${SR.panelLine}`, borderBottom: "none" }}>
                <div style={{ position: "absolute", top: 10, left: 0, right: 0, textAlign: "center", fontFamily: display, fontWeight: 700, fontSize: 34, color: "rgba(255,255,255,.9)" }}>{place + 1}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function SrFairplay({ fairRanked }) {
  const top = fairRanked[0];
  return (
    <div>
      <SrEyebrow>Fairplay-Stars</SrEyebrow>
      {top && (
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{ fontSize: "clamp(40px,7vw,64px)" }}>{top.emoji}</div>
          <SrBig style={{ fontSize: "clamp(30px,5vw,60px)" }}>{top.name}</SrBig>
          <div style={{ fontFamily: display, fontWeight: 700, color: C.gold, fontSize: "clamp(22px,3vw,34px)", letterSpacing: 1 }}>★ {top.fp} Fairplay-Sterne</div>
        </div>
      )}
      <div style={{ display: "flex", flexDirection: "column", gap: 10, maxWidth: 560, margin: "0 auto" }}>
        {fairRanked.slice(1).map((t) => (
          <div key={t.id} style={{ display: "flex", alignItems: "center", gap: 12, background: SR.panel, border: `1px solid ${SR.panelLine}`, borderRadius: 12, padding: "10px 14px" }}>
            <span style={{ fontSize: 24 }}>{t.emoji}</span>
            <span style={{ fontFamily: display, fontWeight: 700, fontSize: 20, textTransform: "uppercase", flex: 1 }}>{t.name}</span>
            <span style={{ color: C.gold, fontWeight: 700 }}>{"★".repeat(Math.min(5, Math.max(1, Math.round(t.fp / 6))))}</span>
            <span style={{ fontFamily: display, fontWeight: 700, fontSize: 20 }}>{t.fp}</span>
          </div>
        ))}
      </div>
      <div style={{ textAlign: "center", color: SR.inkDim, fontSize: 13.5, marginTop: 18 }}>Fairplay wird nur gesammelt — hier gewinnt niemand auf Kosten anderer.</div>
    </div>
  );
}

function SrHighlight({ slide }) {
  const { m, n, of } = slide;
  return (
    <div style={{ textAlign: "center" }}>
      <SrEyebrow>Highlight aus den Aufgaben · {n}/{of}</SrEyebrow>
      <div style={{ maxWidth: 760, margin: "0 auto", borderRadius: 18, overflow: "hidden", border: `1px solid ${SR.panelLine}`, boxShadow: "0 20px 60px rgba(0,0,0,.45)", background: "#000" }}>
        {m.url
          ? (m.type === "video"
            ? <video src={m.url} autoPlay muted loop playsInline style={{ width: "100%", maxHeight: "48vh", objectFit: "contain", display: "block", background: "#000" }} />
            : <img src={m.url} alt={m.caption} style={{ width: "100%", maxHeight: "48vh", objectFit: "contain", display: "block", background: "#000" }} />)
          : <div style={{ height: "min(40vh,320px)", background: `linear-gradient(135deg, ${SR.bg0}, ${C.play})`, display: "grid", placeItems: "center" }}>
              <div style={{ fontSize: 52 }}>{m.type === "video" ? "🎬" : "📸"}</div>
            </div>}
      </div>
      <div style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(22px,3.4vw,38px)", marginTop: 18, textTransform: "uppercase" }}>{m.caption || "Highlight"}</div>
      {m.team && <div style={{ display: "inline-flex", alignItems: "center", gap: 8, marginTop: 8, background: SR.panel, border: `1px solid ${SR.panelLine}`, borderRadius: 20, padding: "6px 14px" }}>
        <span style={{ fontSize: 18 }}>{m.emoji || "⚽"}</span><span style={{ fontWeight: 600 }}>{m.team}</span>
      </div>}
    </div>
  );
}

function SrHighlightEmpty() {
  return (
    <div style={{ textAlign: "center" }}>
      <SrEyebrow>Aufgaben-Highlights</SrEyebrow>
      <div style={{ fontSize: 60, marginBottom: 10 }}>📸</div>
      <SrBig style={{ fontSize: "clamp(26px,4vw,44px)" }}>Noch keine Highlights</SrBig>
      <div style={{ color: SR.inkDim, fontSize: 15, marginTop: 14, maxWidth: 520, marginInline: "auto" }}>
        Markiert in den <b style={{ color: "#fff" }}>Aufgaben</b> die ⭐-Highlights — sie erscheinen dann automatisch hier.
      </div>
    </div>
  );
}

function SrOutro({ name }) {
  return (
    <div style={{ textAlign: "center" }}>
      <SrBig>Danke fürs<br />faire Spiel!</SrBig>
      <img src={LOGO_WHITE} alt={BRAND} style={{ height: "clamp(44px,8vw,84px)", marginTop: 28, filter: `drop-shadow(0 0 24px rgba(62,224,140,.35))` }} />
      <div style={{ color: SR.inkDim, fontSize: 15, marginTop: 16 }}>{name} · bis zum nächsten Mal</div>
    </div>
  );
}

/* ---------- Showroom-Steuerung + Einstell-Schublade ---------- */

function SrCtrl({ children, onClick, title, wide, active }) {
  return <button onClick={onClick} title={title} style={{ minWidth: wide ? 46 : 38, height: 38, border: `1px solid ${active ? SR.glow : SR.panelLine}`,
    background: active ? "rgba(62,224,140,.18)" : "rgba(255,255,255,.05)", color: "#fff", borderRadius: 10, cursor: "pointer",
    fontSize: 16, fontWeight: 700, padding: "0 10px", display: "grid", placeItems: "center" }}>{children}</button>;
}
function SrGroup({ title, children }) {
  return <div style={{ marginBottom: 20 }}>
    <div style={{ fontFamily: display, fontWeight: 700, fontSize: 12.5, letterSpacing: 1, textTransform: "uppercase", color: SR.glow, marginBottom: 10 }}>{title}</div>
    {children}
  </div>;
}
const srCtrlLike = { border: `1px solid ${SR.panelLine}`, background: "rgba(255,255,255,.06)", color: "#fff", borderRadius: 9, padding: "8px 12px", cursor: "pointer", fontFamily: display, fontWeight: 700, fontSize: 14 };

// Schublade: NUR Show-Steuerung. Die Zahlen/Highlights kommen aus dem Store —
// hier gibt es bewusst keine editierbaren Punkte/Faktoren/Medien (keine zweite Wahrheit).
function SrEditor({ show, setShow, factors, mediaCount, close }) {
  const sections = [["race", "Balken-Rennen"], ["podium", "Podest (Top 3)"], ["fairplay", "Fairplay-Stars"], ["highlights", "Aufgaben-Highlights"]];
  return (
    <div style={{ position: "fixed", top: 0, right: 0, bottom: 0, width: "min(420px, 92vw)", zIndex: 20, overflowY: "auto",
      background: "rgba(6,20,15,.96)", backdropFilter: "blur(10px)", borderLeft: `1px solid ${SR.panelLine}`, padding: "18px 18px 40px", color: "#fff" }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
        <span style={{ fontFamily: display, fontWeight: 700, fontSize: 20, textTransform: "uppercase", letterSpacing: 1 }}>Show einstellen</span>
        <button onClick={close} style={{ marginLeft: "auto", ...srCtrlLike }}>Fertig</button>
      </div>

      <SrGroup title="Was wird gezeigt">
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {sections.map(([k, label]) => (
            <label key={k} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 14.5, cursor: "pointer" }}>
              <input type="checkbox" checked={show[k]} onChange={(e) => setShow((v) => ({ ...v, [k]: e.target.checked }))} />
              {label}
            </label>
          ))}
        </div>
        <div style={{ fontSize: 12, color: SR.inkDim, marginTop: 8 }}>Intro und Abschluss laufen immer.</div>
      </SrGroup>

      <SrGroup title="Woher die Zahlen kommen">
        <div style={{ fontSize: 13, color: SR.inkDim, lineHeight: 1.55 }}>
          Punkte&nbsp;= Tore + Fairplay ×<b style={{ color: C.fp }}>{factors.fairplay}</b> + Aufgaben ×<b style={{ color: C.auf }}>{factors.aufgaben}</b>.
          Die <b style={{ color: "#fff" }}>Gewichtung</b> stellt ihr in der <b style={{ color: "#fff" }}>Gesamtwertung</b> ein — der Showroom liest sie nur.
        </div>
        <div style={{ fontSize: 13, color: SR.inkDim, lineHeight: 1.55, marginTop: 10 }}>
          <b style={{ color: "#fff" }}>{mediaCount}</b> ⭐-Highlight{mediaCount === 1 ? "" : "s"} — markiert in den <b style={{ color: "#fff" }}>Aufgaben</b> (Foto/Video). Sie erscheinen automatisch hier.
        </div>
      </SrGroup>
    </div>
  );
}

/* =====================================================================
   VIEW: SIEGEREHRUNG (Teamturnier)  ·  eingehängt an useStore()
   Portiert aus siegerehrung.jsx — eigenes Theme, Fonts, Logos und Demo-
   Daten raus; alles über den Store. Der Abschluss zum Anfassen:
   Medaillen für ALLE (= Zahl aller Kinder), eine druckbare Urkunde je
   Team (Platz OHNE „von N") und frei definierbare Sonderpreise.

   Eine Wahrheit — nur lesen bei den Zahlen: der Endstand kommt aus
   teamScore(t, factors) (identisch zu Gesamtwertung/Showroom), Teamname/
   Emoji/Farbe/Coach/Foto aus teams, Turniername/Datum aus tournament.meta.
   Geschrieben wird nur die echte Turnier-Wahrheit: Sonderpreise über
   award/* (state.awards) und Titel/Datum über meta/patch (die EINE
   tournament.meta, die auch Website/Showroom lesen) — keine zweite Kopie.
   Nur-Headcoach. Drucken über den Browser (@media print, je Urkunde eine
   Seite, A4 quer). Helfer Se…-präfixiert.
   ===================================================================== */
function Siegerehrung() {
  return <MitEnthuellung weiterText="🥇 Weiter zu Urkunden & Medaillen"><SiegerehrungMitNeustart /></MitEnthuellung>;
}
// Stand 37: Headcoach kann das Aufdecken nochmal von vorne zeigen (vor dem Abschluss).
function SiegerehrungMitNeustart() {
  const { state, dispatch } = useStore();
  const kann = state.role === "headcoach" && state.tournament.status !== "abgeschlossen" && enthStufe(state) > 0;
  return (<>
    {kann && (
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
        <button data-enth-neustart onClick={() => dispatch({ type: "wertung/neu" })}
          style={{ border: `1px solid ${C.line}`, background: "#fff", color: C.sub, borderRadius: 999, padding: "6px 12px", fontSize: 12.5, fontWeight: 700, cursor: "pointer", fontFamily: font }}>↺ Aufdecken nochmal zeigen</button>
      </div>
    )}
    <SiegerehrungInhalt />
  </>);
}
function SiegerehrungInhalt() {
  const { state, dispatch } = useStore();
  const { teams, factors, tournament, awards } = state;
  const meta = tournament.meta;

  // Endstand: read-only aus teamScore — dieselbe Rechnung wie die Gesamtwertung.
  const ranked = useMemo(
    () => teams.map((t) => ({ t, sc: teamScore(t, factors) })).sort((a, b) => b.sc.total - a.sc.total),
    [teams, factors]
  );
  const placeOf = (id) => ranked.findIndex((r) => r.t.id === id) + 1;
  const teamById = (id) => teams.find((t) => t.id === id);
  // Medaillen für ALLE Mitspielenden = Summe aller Kinder.
  const medals = useMemo(() => teams.reduce((s, t) => s + t.players.length, 0), [teams]);

  const niceDate = meta.date
    ? (() => { try { return new Date(meta.date).toLocaleDateString("de-DE", { day: "numeric", month: "long", year: "numeric" }); } catch (_) { return meta.date; } })()
    : "";

  const setMeta = (patch) => dispatch({ type: "meta/patch", patch });
  const patchAward = (id, patch) => dispatch({ type: "award/patch", id, patch });

  const print = () => { try { window.print(); } catch (_) {} };

  return (
    <div>
      <style>{`
        .se-in{border:1px solid ${C.line};border-radius:9px;padding:8px 10px;font-family:${font};font-size:14px;color:${C.ink};background:#fff;}
        .se-in:focus{outline:none;border-color:${C.play};}
        .se-certs{display:grid;grid-template-columns:repeat(auto-fit,minmax(360px,1fr));gap:18px;}
        @media print {
          .se-noprint{display:none !important;}
          body *{visibility:hidden;}
          .se-certs, .se-certs *{visibility:visible;}
          .se-certs{position:absolute;left:0;top:0;width:100%;display:block;margin:0;padding:0;}
          .se-cert{break-after:page;page-break-after:always;box-shadow:none !important;border:1px solid #ccc !important;margin:0;}
          .se-cert:last-child{break-after:auto;page-break-after:auto;}
          @page{size:A4 landscape;margin:14mm;}
        }
      `}</style>

      {/* Kopf (konsistent mit den anderen Bausteinen) */}
      <div className="se-noprint" style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: C.play, display: "grid", placeItems: "center", fontSize: 22, flexShrink: 0 }}>🏆</div>
        <div style={{ flex: 1 }}>
          <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: 0 }}>Siegerehrung</h2>
          <div style={{ fontSize: 13, color: C.sub }}>Medaillen für alle · eine Urkunde je Team · Sonderpreise</div>
        </div>
        <button onClick={print} style={{ border: "none", background: C.play, color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 15, padding: "10px 18px", borderRadius: 11, cursor: "pointer", letterSpacing: 0.5, textTransform: "uppercase" }}>🖨 Alle Urkunden drucken</button>
      </div>

      {/* SETUP */}
      <div className="se-noprint">
        <Card>
          <div style={{ fontFamily: display, fontWeight: 700, fontSize: 13, letterSpacing: 1, textTransform: "uppercase", color: C.sub, marginBottom: 14 }}>Turnier</div>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
            <input className="se-in" style={{ flex: 1, minWidth: 220, fontFamily: display, fontWeight: 700, fontSize: 18 }} value={meta.title} onChange={(e) => setMeta({ title: e.target.value })} placeholder="Turniername" />
            <input className="se-in" type="date" style={{ fontFamily: display, fontWeight: 700 }} value={meta.date || ""} onChange={(e) => setMeta({ date: e.target.value })} />
            <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: C.playSoft, border: `1px solid ${C.play}`, color: C.fair, borderRadius: 999, padding: "8px 14px", fontWeight: 700, fontSize: 14 }}>🏅 {medals} Medaillen — für alle Mitspielenden</div>
          </div>
          <div style={{ marginTop: 12, fontSize: 12, color: C.sub }}>
            Titel und Datum sind die gemeinsame Turnier-Info (die auch Website &amp; Showroom nutzen). Der Endstand kommt aus der Gesamtwertung — hier nur zum Anzeigen.
          </div>
        </Card>

        {/* SONDERPREISE bearbeiten (award/*) */}
        <div style={{ marginTop: 14 }}>
          <Card>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: 13, letterSpacing: 1, textTransform: "uppercase", color: C.sub, marginBottom: 14 }}>Sonderpreise</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {awards.map((p) => (
                <div key={p.id} style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                  <input className="se-in" value={p.emoji} onChange={(e) => patchAward(p.id, { emoji: e.target.value })} style={{ width: 52, textAlign: "center", fontSize: 18 }} />
                  <input className="se-in" value={p.title} onChange={(e) => patchAward(p.id, { title: e.target.value })} style={{ flex: 1, minWidth: 150, fontWeight: 600 }} />
                  <select className="se-in" value={p.teamId ?? ""} onChange={(e) => patchAward(p.id, { teamId: e.target.value ? +e.target.value : null })} style={{ minWidth: 170 }}>
                    <option value="">— (frei / kein Team)</option>
                    {teams.map((t) => <option key={t.id} value={t.id}>{t.emoji} {t.name}</option>)}
                  </select>
                  <button onClick={() => dispatch({ type: "award/remove", id: p.id })} style={{ border: "none", background: "none", color: C.sub, cursor: "pointer", fontSize: 20, lineHeight: 1 }} title="Sonderpreis entfernen">×</button>
                </div>
              ))}
              {awards.length === 0 && <div style={{ fontSize: 13, color: C.sub }}>Noch keine Sonderpreise — leg unten welche an.</div>}
            </div>
            <button onClick={() => dispatch({ type: "award/add" })} style={{ ...seBtnGhost, marginTop: 12, padding: "8px 14px" }}>+ Sonderpreis</button>
            <div style={{ fontSize: 12, color: C.sub, marginTop: 10 }}>Frei definierbar — jeder Sonderpreis wird als eigene Urkunde gedruckt. Ohne Team bleibt das Empfänger-Feld auf der Urkunde leer.</div>
          </Card>
        </div>

        {/* ABLAUF */}
        <div style={{ marginTop: 14 }}>
          <Card>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: 13, letterSpacing: 1, textTransform: "uppercase", color: C.sub, marginBottom: 14 }}>Ablauf der Ehrung</div>
            <ol style={{ margin: 0, paddingLeft: 20, color: C.ink, fontSize: 14, lineHeight: 1.9 }}>
              <li><b>Medaillen an alle</b> — jedes Kind kommt nach vorn und bekommt seine Medaille ({medals} insgesamt).</li>
              <li><b>Sonderpreise</b> — {awards.length} Auszeichnung{awards.length === 1 ? "" : "en"} überreichen{awards.length ? ` (${awards.map((p) => p.emoji).join(" ")})` : ""}.</li>
              <li><b>Urkunden je Team</b> — von Platz {ranked.length} rückwärts bis Platz 1 aufrufen.</li>
            </ol>
          </Card>
        </div>

        <div style={{ fontFamily: display, fontWeight: 700, fontSize: 22, textTransform: "uppercase", letterSpacing: 0.5, margin: "26px 0 4px" }}>Vorschau — so wird gedruckt</div>
        <div style={{ color: C.sub, fontSize: 13, marginBottom: 14 }}>Jede Urkunde landet auf einer eigenen Seite (A4 quer). Sonderpreise zuerst, dann jedes Team.</div>
      </div>

      {/* DRUCKBEREICH: Urkunden */}
      <div className="se-certs">
        {awards.map((p) => {
          const t = p.teamId != null ? teamById(p.teamId) : null;
          return <SeCertificate key={"p" + p.id} kind="prize" meta={meta} niceDate={niceDate} team={t} prize={p} />;
        })}
        {ranked.map(({ t, sc }) => (
          <SeCertificate key={"t" + t.id} kind="team" meta={meta} niceDate={niceDate} team={t} sc={sc} place={placeOf(t.id)} />
        ))}
      </div>
    </div>
  );
}

/* ---------- Urkunde (Se…) ---------- */
function SeRibbon({ color = C.gold }) {
  return (
    <svg width="60" height="76" viewBox="0 0 60 76" aria-hidden="true">
      <path d="M20 44 L12 74 L26 66 L30 76 L34 66 L48 74 L40 44 Z" fill={color} opacity="0.9" />
      <circle cx="30" cy="26" r="24" fill="#fff" stroke={color} strokeWidth="4" />
      <circle cx="30" cy="26" r="16" fill={color} opacity="0.15" />
      <text x="30" y="34" textAnchor="middle" fontSize="24">🏅</text>
    </svg>
  );
}

function SeChip({ c, label, v, strong }) {
  return (
    <div style={{ background: strong ? c : "#fff", border: `1.5px solid ${c}`, color: strong ? "#fff" : C.ink, borderRadius: 10, padding: "6px 12px", display: "flex", alignItems: "baseline", gap: 6 }}>
      <b style={{ fontFamily: display, fontSize: 20 }}>{v}</b>
      <span style={{ fontSize: 11.5, color: strong ? "rgba(255,255,255,.85)" : C.sub }}>{label}</span>
    </div>
  );
}

function SeCertificate({ kind, meta, niceDate, team, sc, place, prize }) {
  const accent = team ? team.color : C.play;
  const ribbon = place === 1 ? C.gold : place === 2 ? C.silver : place === 3 ? C.bronze : C.play;
  const medalTxt = place === 1 ? "🥇 Platz 1" : place === 2 ? "🥈 Platz 2" : place === 3 ? "🥉 Platz 3" : `Platz ${place}`;
  return (
    <div className="se-cert" style={{ background: C.paper, border: `1px solid ${C.line}`, borderRadius: 16, padding: 4, boxShadow: "0 8px 26px rgba(19,36,28,.10)" }}>
      <div style={{ border: `2px solid ${accent}`, borderRadius: 10, padding: "26px 30px", height: "100%", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: -40, right: -40, width: 120, height: 120, borderRadius: "50%", background: accent, opacity: 0.08 }} />

        {/* Kopf: grünes Logo auf hell */}
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
          <img src={LOGO_GREEN} alt={BRAND} style={{ height: 26 }} />
          <div style={{ marginLeft: "auto", textAlign: "right", fontSize: 12, color: C.sub }}>
            <div style={{ fontWeight: 700, color: C.ink }}>{meta.title}</div>
            {(niceDate || meta.ort) && <div>{[niceDate, meta.ort].filter(Boolean).join(" · ")}</div>}
          </div>
        </div>

        <div style={{ fontFamily: display, fontWeight: 700, letterSpacing: 4, textTransform: "uppercase", color: C.play, fontSize: 15 }}>
          {kind === "prize" ? "Sonderpreis" : "Urkunde"}
        </div>

        {kind === "prize" ? (
          <>
            <div style={{ fontSize: 54, margin: "8px 0 2px" }}>{prize.emoji}</div>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: 40, textTransform: "uppercase", lineHeight: 1 }}>{prize.title}</div>
            <div style={{ color: C.sub, fontSize: 14, margin: "14px 0 4px" }}>{team ? "verliehen an" : "\u00A0"}</div>
          </>
        ) : (
          <>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: 44, textTransform: "uppercase", lineHeight: 1, marginTop: 4 }}>{medalTxt}</div>
            <div style={{ color: C.sub, fontSize: 14, margin: "14px 0 4px" }}>verliehen an das Team</div>
          </>
        )}

        {/* Team-Zeile (Emoji/Foto + Name) */}
        {team ? (
          <div style={{ display: "flex", alignItems: "center", gap: 14, margin: "2px 0 10px" }}>
            {team.photo
              ? <img src={team.photo} alt={team.name} style={{ width: 56, height: 56, borderRadius: "50%", objectFit: "cover", flexShrink: 0, border: `2px solid ${team.color}` }} />
              : <div style={{ width: 56, height: 56, borderRadius: "50%", background: team.color, display: "grid", placeItems: "center", fontSize: 30, flexShrink: 0 }}>{team.emoji}</div>}
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: 40, textTransform: "uppercase", lineHeight: 1 }}>{team.name}</div>
            {kind !== "prize" && <div style={{ marginLeft: "auto" }}><SeRibbon color={ribbon} /></div>}
          </div>
        ) : (
          <div style={{ margin: "2px 0 10px", height: 44, borderBottom: `2px dashed ${C.line}` }} />
        )}

        {/* Endstand — read-only aus teamScore (Tore + Fairplay + Aufgaben = Gesamt) */}
        {kind === "team" && sc && (
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", margin: "6px 0 14px" }}>
            <SeChip c={C.tore} label="Tore" v={sc.base} />
            <SeChip c={C.fp} label="Fairplay" v={sc.fp} />
            <SeChip c={C.auf} label="Aufgaben" v={sc.auf} />
            <SeChip c={C.play} label="Gesamt" v={sc.total} strong />
          </div>
        )}

        <div style={{ color: C.ink, fontSize: 14.5, fontStyle: "italic", marginTop: kind === "prize" ? 18 : 4 }}>
          {kind === "prize" ? "Für einen ganz besonderen Beitrag zum Turnier." : "Für faires Spiel, tollen Teamgeist und starke Tore."}
        </div>

        {/* Fuß: Coach-Signatur (aus teams) + Medaillen-Hinweis */}
        <div style={{ display: "flex", alignItems: "flex-end", gap: 20, marginTop: 22, flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: 140 }}>
            <div style={{ borderTop: `1.5px solid ${C.ink}`, paddingTop: 4, fontSize: 12.5, color: C.sub }}>
              {team && team.coach ? `Coach: ${team.coach}` : "Turnierleitung"}
            </div>
          </div>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: C.playSoft, border: `1px solid ${C.play}`, color: C.fair, borderRadius: 999, padding: "6px 14px", fontSize: 12.5, fontWeight: 700 }}>🏅 Alle bekommen eine Medaille</div>
        </div>
      </div>
    </div>
  );
}
const seBtnGhost = { border: `1.5px solid ${C.line}`, background: "#fff", color: C.ink, fontFamily: display, fontWeight: 700, fontSize: 15, padding: "10px 16px", borderRadius: 10, cursor: "pointer", letterSpacing: 0.5 };

/* =====================================================================
   VIEW: WEBSITE (öffentliche Team-Turnierseite)  (eingehängter Baustein 11)
   Portiert aus website.jsx — eigenes Theme, Fonts, Logo & Demo-Daten raus,
   alles über useStore(). REIN LESEND: keine zweite Wahrheit, kein Schreiben.
     · Endstand   → teamScore(t, factors)      (wie Gesamtwertung/Showroom)
     · Fairplay   → team.fpStars
     · Highlights → team.gallery.star          (wie Showroom)
     · Spielsystem→ roundRobin(numTeams) × config.targetRR (aus state.live)
     · Titel/Datum/Ort → tournament.meta
     · Status     → tournament.status
     · Laufende Runde/Phase/Restzeit → state.live (cur/running/remaining)
   Sichtbar für Publikum/Headcoach/Coach. Helfer We…-präfixiert. Nur reiner
   UI-State bleibt lokal (Lightbox, Sprungziel). Grünes Logo auf hell (Marke).
   ===================================================================== */

const WE_NAV = [["wertung", "Wertung"], ["teams", "Teams"], ["zeitplan", "Zeitplan"], ["fairplay", "Fairplay"], ["highlights", "Highlights"], ["archiv", "Archiv"]];
// Platzhalter-Verlauf für Highlights ohne echtes Medium (bis Stufe 1 Medien ablegt)
const WE_GRAD = [
  "linear-gradient(135deg,#0f6b43,#27A661)",
  "linear-gradient(135deg,#b9821a,#E8A100)",
  "linear-gradient(135deg,#1c3f8a,#2F6BFF)",
];
const weFmtDur = (s) => `${Math.floor(Math.max(0, s) / 60)}:${String(Math.max(0, s) % 60).padStart(2, "0")}`;
// Fairplay-Sterne (0–35 aus fpDetail) auf 1–5 ★ für die Anzeige verdichten.
const weStars = (fp) => "★".repeat(Math.min(5, Math.max(1, Math.round(fp / 7))));
// Zeitplan aus der EINEN Wahrheit: Runden/Phase/Status aus state.live, die
// Paarungen aus roundRobin(numTeams) (Spielsystem). Zeiten werden NICHT als
// zweite Wahrheit gehalten — je Runde die geplante Dauer (round.dur) anzeigen.
function weBuildSchedule(state) {
  const teams = state.teams;
  const nTeams = state.tournament.config.numTeams;
  const rr = wandRunden(nTeams, state.tournament.config.mode); // Paarungen je Durchgang (Team-Indizes)
  const perPass = Math.max(1, rr.length);
  const cur = state.live.cur;
  return state.live.rounds.map((r, gi) => {
    const pairs = rr[gi % perPass] || [];
    const matches = pairs.map(([a, b], k) => ({
      a: teams[a] ? teams[a].name : "—",
      b: teams[b] ? teams[b].name : "—",
      box: `Box ${k + 1}`,
    }));
    let status = "geplant";
    if (r.skipped) status = "gestrichen";
    else if (r.done) status = "gespielt";
    else if (gi === cur) status = state.live.running ? "läuft" : "bereit";
    return { id: r.id, n: r.n, phase: r.phase, dur: r.dur, matches, status };
  });
}

function Website() {
  const { state } = useStore();
  // Stand 37d: waehrend des Aufdeckens zeigt die Website die Live-Enthuellung statt Podest/Endstand
  if (enthAusstehend(state) && enthStufe(state) > 0) return <div style={{ padding: "10px 0 40px" }}><EnthuellungLive /></div>;
  // Stand 39: Öffentlichkeit, Teams und Coaches sehen vor der Siegerehrung nur Begegnungen, Boxen und Pausen
  if (state.role !== "headcoach" && !ergebnisseOffen(state) && state.teams.length > 0) {
    const m = state.tournament.meta || {};
    return (
      <div data-website-spielplan="true" style={{ maxWidth: 620, margin: "0 auto", padding: "22px 16px 50px", fontFamily: font, color: C.ink }}>
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <div style={{ fontFamily: display, fontWeight: 800, fontSize: 26 }}>{m.title || "Turnier"}</div>
          <div style={{ fontSize: 13.5, color: C.sub }}>{[m.ort, m.date ? fmtEventDate(m.date) : ""].filter(Boolean).join(" · ")}</div>
        </div>
        <SpielplanAnsicht />
      </div>
    );
  }
  return <WebsiteInhalt />;
}
function WebsiteInhalt() {
  const { state } = useStore();
  const verborgen = wertungVerborgen(state); // Stand 36: Spannungsbogen
  const schlank = isSchlank(state) || verborgen; // Stand 35/36: nur Tore, ohne Fairplay/Highlights
  const liveRem = useLiveRemaining(); // Stand 36
  const { teams, factors, tournament, live, archivedTournaments } = state;
  const meta = tournament.meta;
  const status = tournament.status;              // "offen" | "abgeschlossen"
  const isLive = status !== "abgeschlossen";

  // reiner UI-State (kein Schreiben in den Store)
  const [lightbox, setLightbox] = useState(null);

  // Endstand: read-only über teamScore — identisch zu Gesamtwertung/Showroom.
  const teamRows = useMemo(
    () => teams.map((t) => ({ t, sc: teamScore(t, factors) })),
    [teams, factors]
  );
  const ranked = useMemo(
    () => teamRows.map(({ t, sc }) => ({ id: t.id, name: t.name, emoji: t.emoji, color: t.color, base: sc.base, bF: verborgen ? 0 : sc.fp, bA: verborgen ? 0 : sc.auf, total: verborgen ? sc.base : sc.total }))
      .sort((a, b) => b.total - a.total),
    [teamRows, verborgen]
  );
  const maxTotal = Math.max(1, ...ranked.map((r) => r.total));
  const fairRanked = useMemo(
    () => teams.map((t) => ({ id: t.id, name: t.name, emoji: t.emoji, fp: t.fpStars })).sort((a, b) => b.fp - a.fp),
    [teams]
  );

  // ⭐-Highlights aus den Aufgaben (gallery.star) — wie im Showroom.
  const taskById = useCallback((id) => state.taskPool.find((p) => p.id === id), [state.taskPool]);
  const media = useMemo(() => teams.flatMap((t) =>
    t.gallery.filter((g) => g.star).map((g) => ({
      id: g.id, type: g.kind, url: g.url, caption: taskById(g.taskId)?.text || "Highlight", team: t.name, emoji: t.emoji,
    }))
  ), [teams, taskById]);

  const schedule = useMemo(() => weBuildSchedule(state), [state]);
  const curRound = live.rounds[live.cur];

  const niceDate = meta.date
    ? (() => { try { return new Date(meta.date).toLocaleDateString("de-DE", { day: "numeric", month: "long", year: "numeric" }); } catch (_) { return meta.date; } })()
    : "";
  const heroSub = [niceDate, meta.ort].filter(Boolean).join(" · ");

  const ff = factors.fairplay, af = factors.aufgaben;
  const teamBy = (name) => teams.find((t) => t.name === name);
  const jump = (id) => { const el = typeof document !== "undefined" && document.getElementById(id); if (el) el.scrollIntoView({ behavior: "smooth", block: "start" }); };

  return (
    <div style={{ background: C.chalk, minHeight: "100%", fontFamily: font, color: C.ink }}>
      <style>{`@import url('${FONT_IMPORT}');
        .we-navlink{position:relative;background:none;border:none;font-family:${display};font-weight:700;font-size:15px;letter-spacing:.5px;text-transform:uppercase;color:${C.sub};cursor:pointer;padding:6px 2px;}
        .we-navlink:hover{color:${C.play};}
        .we-navlink::after{content:"";position:absolute;left:0;right:0;bottom:0;height:2px;background:${C.play};transform:scaleX(0);transition:transform .18s;}
        .we-navlink:hover::after{transform:scaleX(1);}
        .we-tile{cursor:pointer;transition:transform .18s, box-shadow .18s;}
        .we-tile:hover{transform:translateY(-3px);box-shadow:0 12px 30px rgba(19,36,28,.12);}
        .we-teamcard{transition:transform .18s, box-shadow .18s;}
        .we-teamcard:hover{transform:translateY(-3px);box-shadow:0 12px 30px rgba(19,36,28,.12);}
      `}</style>

      {/* NAVIGATION (öffentliche Seite · grünes Logo auf hell) */}
      <header style={{ position: "sticky", top: 0, zIndex: 30, background: "rgba(238,244,240,.9)", backdropFilter: "blur(8px)", borderBottom: `1px solid ${C.line}` }}>
        <div style={{ maxWidth: 1080, margin: "0 auto", padding: "12px 20px", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
          <button onClick={() => jump("we-top")} style={{ background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center" }}>
            <img src={LOGO_GREEN} alt={BRAND} style={{ height: 30 }} />
          </button>
          <nav style={{ marginLeft: "auto", display: "flex", gap: 18, flexWrap: "wrap" }}>
            {WE_NAV.filter(([id]) => !schlank || (id !== "fairplay" && id !== "highlights")).map(([id, label]) => <button key={id} className="we-navlink" onClick={() => jump("we-" + id)}>{label}</button>)}
          </nav>
        </div>
      </header>

      <div id="we-top" />

      {/* HERO */}
      <section style={{ position: "relative", overflow: "hidden", borderBottom: `1px solid ${C.line}` }}>
        <svg viewBox="0 0 1000 300" preserveAspectRatio="xMidYMid slice" aria-hidden="true" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0.06 }}>
          <rect x="40" y="20" width="920" height="260" rx="10" fill="none" stroke={C.play} strokeWidth="3" />
          <line x1="500" y1="20" x2="500" y2="280" stroke={C.play} strokeWidth="3" />
          <circle cx="500" cy="150" r="70" fill="none" stroke={C.play} strokeWidth="3" />
        </svg>
        <div style={{ position: "relative", maxWidth: 1080, margin: "0 auto", padding: "54px 20px 46px", textAlign: "center" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: isLive ? C.playSoft : "#F0EDE6", color: isLive ? C.playDeep : "#9A7B2E", border: `1px solid ${isLive ? "#BFE6D2" : "#E4D8B8"}`, borderRadius: 999, padding: "6px 14px", fontWeight: 700, fontSize: 13, marginBottom: 16 }}>
            <span style={{ width: 8, height: 8, borderRadius: "50%", background: isLive ? C.play : C.gold, boxShadow: isLive ? `0 0 0 4px rgba(39,166,97,.2)` : "none" }} />
            {isLive
              ? (curRound ? `Live · Runde ${curRound.n} ${live.running ? `läuft · ${weFmtDur(liveRem)}` : "– bereit"}` : "Live")
              : "Turnier beendet"}
          </div>
          <h1 style={{ fontFamily: display, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, lineHeight: 0.95, margin: 0, fontSize: "clamp(38px,7vw,80px)" }}>{meta.title}</h1>
          <p style={{ color: C.sub, fontSize: "clamp(15px,2vw,19px)", marginTop: 12 }}>{heroSub ? heroSub + " · " : ""}{teams.length} Teams · „Sieger bleibt am Platz"</p>
          <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 22, flexWrap: "wrap" }}>
            <button onClick={() => jump("we-wertung")} style={weBtnPrimary}>Zur Wertung</button>
            {!schlank && <button onClick={() => jump("we-highlights")} style={weBtnGhost}>Highlights ansehen</button>}
          </div>
        </div>
      </section>

      <main style={{ maxWidth: 1080, margin: "0 auto", padding: "8px 20px 40px" }}>

        {/* WERTUNG */}
        {verborgen && <EnthuellungLive />}
        <WeSection id="we-wertung" eyebrow={verborgen ? "Fairplay & Aufgaben kommen bei der Siegerehrung dazu 🤫" : "Aktueller Stand"} title={verborgen ? "Tore-Tabelle" : "Gesamtwertung"}>
          <WePodium ranked={ranked} />
          <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 22 }}>
            {ranked.map((r, i) => (
              <div key={r.id} style={{ display: "flex", alignItems: "center", gap: 14, background: C.card, border: `1px solid ${C.line}`, borderRadius: 16, padding: "12px 16px" }}>
                <div style={{ fontFamily: display, fontWeight: 700, fontSize: 24, width: 28, textAlign: "right", color: i === 0 ? C.gold : i === 1 ? C.silver : i === 2 ? C.bronze : C.sub }}>{i + 1}</div>
                <div style={{ fontSize: 26 }}>{r.emoji}</div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 5 }}>
                    <span style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(16px,2vw,21px)", textTransform: "uppercase" }}>{r.name}</span>
                    <span style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(19px,2.4vw,26px)", color: C.play }}>{r.total}<span style={{ fontSize: 13, color: C.sub, fontWeight: 600 }}> Pkt</span></span>
                  </div>
                  <div style={{ display: "flex", height: 14, borderRadius: 7, overflow: "hidden", background: C.chalk }}>
                    <div style={{ width: `${(r.base / maxTotal) * 100}%`, background: C.tore }} />
                    <div style={{ width: `${(r.bF / maxTotal) * 100}%`, background: C.fp }} />
                    <div style={{ width: `${(r.bA / maxTotal) * 100}%`, background: C.auf }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ display: "flex", gap: 18, justifyContent: "center", marginTop: 16, fontSize: 13, color: C.sub, flexWrap: "wrap" }}>
            <WeLegend c={C.tore}>Tore{schlank ? "" : " (Basis)"}</WeLegend>{!schlank && <><WeLegend c={C.fp}>Fairplay ★ × {ff}</WeLegend><WeLegend c={C.auf}>Aufgaben × {af}</WeLegend></>}
          </div>
        </WeSection>

        {/* TEAMS */}
        <WeSection id="we-teams" eyebrow="Wer spielt mit" title="Teams">
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(210px,1fr))", gap: 14 }}>
            {teamRows.map(({ t, sc }) => (
              <div key={t.id} className="we-teamcard" style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 16, padding: 18, borderTop: `4px solid ${t.color}` }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{ width: 52, height: 52, borderRadius: "50%", background: t.color, display: "grid", placeItems: "center", fontSize: 28 }}>{t.emoji}</div>
                  <div>
                    <div style={{ fontFamily: display, fontWeight: 700, fontSize: 21, textTransform: "uppercase", lineHeight: 1 }}>{t.name}</div>
                    <div style={{ color: C.sub, fontSize: 13, marginTop: 3 }}>{t.players.length} Spieler:innen{t.coach ? ` · ${t.coach}` : ""}</div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 14, marginTop: 14, fontSize: 13 }}>
                  <WeStat label="Tore" v={sc.base} c={C.tore} />{!schlank && <><WeStat label="Fairplay ★" v={t.fpStars} c={C.fp} /><WeStat label="Aufgaben" v={t.aufgabenDone} c={C.auf} /></>}
                </div>
              </div>
            ))}
          </div>
        </WeSection>

        {/* ZEITPLAN */}
        <WeSection id="we-zeitplan" eyebrow="Spielsystem & Runden" title="Zeitplan">
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {schedule.map((r) => {
              const isNow = isLive && r.status === "läuft";
              const done = r.status === "gespielt";
              const skipped = r.status === "gestrichen";
              return (
                <div key={r.id} style={{ background: C.card, border: `1px solid ${isNow ? C.play : C.line}`, borderRadius: 16, padding: "12px 16px", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap", opacity: done || skipped ? 0.6 : 1, boxShadow: isNow ? `0 6px 18px rgba(39,166,97,.18)` : "none" }}>
                  <div style={{ textAlign: "center", minWidth: 58 }}>
                    <div style={{ fontFamily: display, fontWeight: 700, fontSize: 22, color: isNow ? C.play : C.ink }}>{r.n}</div>
                    <div style={{ fontSize: 11, color: C.sub, textTransform: "uppercase", letterSpacing: .5 }}>Runde · {weFmtDur(r.dur)}</div>
                  </div>
                  <div style={{ width: 1, alignSelf: "stretch", background: C.line }} />
                  <div style={{ flex: 1, minWidth: 200 }}>
                    <div style={{ fontSize: 12, color: C.sub, marginBottom: 4 }}>{r.phase}</div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {r.matches.length ? r.matches.map((m, i) => (
                        <span key={i} style={{ background: C.chalk, borderRadius: 8, padding: "5px 10px", fontSize: 13.5, textDecoration: skipped ? "line-through" : "none" }}>
                          <b>{m.a}</b> vs <b>{m.b}</b> <span style={{ color: C.sub }}>· {m.box}</span>
                        </span>
                      )) : <span style={{ color: C.sub, fontSize: 13 }}>—</span>}
                    </div>
                  </div>
                  {isNow && <span style={{ background: C.playSoft, color: C.playDeep, borderRadius: 999, padding: "5px 12px", fontWeight: 700, fontSize: 12.5 }}>läuft gerade</span>}
                  {done && <span style={{ color: C.sub, fontWeight: 700, fontSize: 12.5 }}>✓ gespielt</span>}
                  {skipped && <span style={{ color: C.whistle, fontWeight: 700, fontSize: 12.5 }}>gestrichen</span>}
                </div>
              );
            })}
          </div>
          <p style={{ color: C.sub, fontSize: 13, textAlign: "center", marginTop: 14 }}>Jeder gegen jeden · {tournament.config.targetRR}× · parallele Boxen. Runden &amp; Restzeit kommen live aus der Headcoach-Steuerung.</p>
        </WeSection>

        {/* FAIRPLAY */}
        {!schlank && <WeSection id="we-fairplay" eyebrow="Rein positiv gesammelt" title="Fairplay-Stars">
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: 14 }}>
            {fairRanked.map((t, i) => (
              <div key={t.id} style={{ background: i === 0 ? C.playSoft : C.card, border: `1px solid ${i === 0 ? "#BFE6D2" : C.line}`, borderRadius: 16, padding: 18, display: "flex", alignItems: "center", gap: 14 }}>
                <div style={{ fontSize: 34 }}>{i === 0 ? "🏆" : t.emoji}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontFamily: display, fontWeight: 700, fontSize: 20, textTransform: "uppercase", lineHeight: 1 }}>{t.name}</div>
                  <div style={{ color: C.gold, fontSize: 16, marginTop: 3 }}>{weStars(t.fp)}</div>
                </div>
                <div style={{ fontFamily: display, fontWeight: 700, fontSize: 26, color: C.play }}>{t.fp}</div>
              </div>
            ))}
          </div>
          <p style={{ color: C.sub, fontSize: 13.5, textAlign: "center", marginTop: 14 }}>Fairplay wird nur gesammelt — hier verliert niemand Punkte.</p>
        </WeSection>}

        {/* HIGHLIGHTS */}
        {!schlank && <WeSection id="we-highlights" eyebrow="Aus den Aufgaben" title="Highlights">
          {media.length ? (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))", gap: 14 }}>
              {media.map((m, mi) => {
                const t = teamBy(m.team);
                return (
                  <div key={m.id} className="we-tile" onClick={() => setLightbox({ ...m, gi: mi })} style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 16, overflow: "hidden" }}>
                    <div style={{ height: 140, background: m.url ? "#0C1712" : WE_GRAD[mi % WE_GRAD.length], display: "grid", placeItems: "center", position: "relative" }}>
                      {m.url && m.type === "foto"
                        ? <img src={m.url} alt={m.caption} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        : <span style={{ fontSize: 40 }}>{m.type === "video" ? "🎬" : "📸"}</span>}
                      <span style={{ position: "absolute", top: 8, right: 8, background: "rgba(0,0,0,.35)", color: "#fff", borderRadius: 6, padding: "2px 8px", fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>{m.type}</span>
                    </div>
                    <div style={{ padding: "12px 14px" }}>
                      <div style={{ fontWeight: 600, fontSize: 14.5, lineHeight: 1.3 }}>{m.caption}</div>
                      <div style={{ display: "inline-flex", alignItems: "center", gap: 6, marginTop: 8, color: C.sub, fontSize: 13 }}>
                        <span>{t?.emoji}</span>{m.team}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div style={{ background: C.card, border: `1px dashed ${C.line}`, borderRadius: 16, padding: "34px 20px", textAlign: "center", color: C.sub }}>
              <div style={{ fontSize: 40, marginBottom: 8 }}>📸</div>
              <div style={{ fontFamily: display, fontWeight: 700, fontSize: 20, color: C.ink, textTransform: "uppercase" }}>Noch keine Highlights</div>
              <div style={{ fontSize: 13.5, marginTop: 6 }}>Sobald Aufgaben-Medien im Showroom mit ⭐ markiert sind, erscheinen sie hier.</div>
            </div>
          )}
        </WeSection>}

        <WeSection id="we-archiv" eyebrow="Vergangene Turniere" title="Archiv">
          {archivedTournaments.length ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {archivedTournaments.map((entry) => <ArchivKarte key={entry.id} entry={entry} />)}
            </div>
          ) : (
            <div style={{ background: C.card, border: `1px dashed ${C.line}`, borderRadius: 16, padding: "34px 20px", textAlign: "center", color: C.sub }}>
              <div style={{ fontSize: 40, marginBottom: 8 }}>🗄️</div>
              <div style={{ fontFamily: display, fontWeight: 700, fontSize: 20, color: C.ink, textTransform: "uppercase" }}>Noch kein Archiv</div>
              <div style={{ fontSize: 13.5, marginTop: 6 }}>Abgeschlossene Turniere erscheinen hier, sobald ein neues angelegt wird.</div>
            </div>
          )}
        </WeSection>
      </main>

      {/* FOOTER */}
      <footer style={{ borderTop: `1px solid ${C.line}`, background: C.card }}>
        <div style={{ maxWidth: 1080, margin: "0 auto", padding: "28px 20px", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
          <img src={LOGO_GREEN} alt={BRAND} style={{ height: 26 }} />
          <span style={{ color: C.sub, fontSize: 13 }}>Öffentliche Turnierseite · {BRAND}</span>
          <span style={{ marginLeft: "auto", color: C.sub, fontSize: 12.5 }}>{isLive ? "Live · aktualisiert sich mit dem Turnier" : "Turnier abgeschlossen · Archiv"}</span>
        </div>
      </footer>

      {/* LIGHTBOX (reiner UI-State) */}
      {lightbox && (
        <div onClick={() => setLightbox(null)} style={{ position: "fixed", inset: 0, zIndex: 50, background: "rgba(6,20,15,.82)", display: "grid", placeItems: "center", padding: 20 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ maxWidth: 720, width: "100%", background: C.card, borderRadius: 18, overflow: "hidden" }}>
            <div style={{ height: "min(46vh,360px)", background: lightbox.url ? "#0C1712" : WE_GRAD[lightbox.gi % WE_GRAD.length], display: "grid", placeItems: "center" }}>
              {lightbox.url && lightbox.type === "foto"
                ? <img src={lightbox.url} alt={lightbox.caption} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                : lightbox.url && lightbox.type === "video"
                  ? <video src={lightbox.url} controls style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                  : (
                    <div style={{ textAlign: "center", color: "#fff" }}>
                      <div style={{ fontSize: 64 }}>{lightbox.type === "video" ? "🎬" : "📸"}</div>
                      <div style={{ fontFamily: display, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", opacity: 0.85, marginTop: 6 }}>Highlight</div>
                    </div>
                  )}
            </div>
            <div style={{ padding: "18px 20px", display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontFamily: display, fontWeight: 700, fontSize: 22, textTransform: "uppercase" }}>{lightbox.caption}</div>
                <div style={{ color: C.sub, fontSize: 14, marginTop: 4 }}>{teamBy(lightbox.team)?.emoji} {lightbox.team}</div>
              </div>
              <button onClick={() => setLightbox(null)} style={{ ...weBtnGhost, padding: "8px 14px" }}>Schließen</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

/* ---------- Website-Helfer (We…) ---------- */
function WeSection({ id, eyebrow, title, children }) {
  return (
    <section id={id} style={{ padding: "40px 0", scrollMarginTop: 70, borderBottom: `1px solid ${C.line}` }}>
      <div style={{ marginBottom: 22 }}>
        <div style={{ fontFamily: display, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", fontSize: 13, color: C.play }}>{eyebrow}</div>
        <h2 style={{ fontFamily: display, fontWeight: 700, textTransform: "uppercase", letterSpacing: .5, fontSize: "clamp(28px,4vw,44px)", margin: "4px 0 0" }}>{title}</h2>
      </div>
      {children}
    </section>
  );
}
function WePodium({ ranked }) {
  const top = ranked.slice(0, 3);
  const order = [top[1], top[0], top[2]].filter(Boolean); // 2 · 1 · 3
  const heights = { 0: 116, 1: 84, 2: 62 };
  const medal = ["🥇", "🥈", "🥉"];
  const ring = [C.gold, C.silver, C.bronze];
  return (
    <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "center", gap: "clamp(10px,3vw,30px)" }}>
      {order.map((t) => {
        const place = ranked.indexOf(t);
        return (
          <div key={t.id} style={{ textAlign: "center", flex: "0 1 200px" }}>
            <div style={{ fontSize: "clamp(26px,5vw,40px)", marginBottom: 4 }}>{medal[place]}</div>
            <div style={{ width: "clamp(48px,8vw,68px)", height: "clamp(48px,8vw,68px)", margin: "0 auto 8px", borderRadius: "50%", display: "grid", placeItems: "center", fontSize: "clamp(24px,4vw,36px)", background: t.color, boxShadow: `0 0 0 4px ${ring[place]}` }}>{t.emoji}</div>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(15px,2vw,20px)", textTransform: "uppercase", lineHeight: 1 }}>{t.name}</div>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(20px,3vw,30px)", color: C.play }}>{t.total}<span style={{ fontSize: 12, color: C.sub, fontWeight: 600 }}> Pkt</span></div>
            <div style={{ height: heights[place], background: `linear-gradient(180deg, ${t.color}, ${t.color}22)`, borderRadius: "10px 10px 0 0", marginTop: 10, border: `1px solid ${C.line}`, borderBottom: "none", position: "relative" }}>
              <div style={{ position: "absolute", top: 8, left: 0, right: 0, textAlign: "center", fontFamily: display, fontWeight: 700, fontSize: 26, color: "rgba(255,255,255,.9)" }}>{place + 1}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
function WeLegend({ c, children }) { return <span style={{ display: "inline-flex", alignItems: "center", gap: 7 }}><span style={{ width: 12, height: 12, borderRadius: 3, background: c }} />{children}</span>; }
function WeStat({ label, v, c }) { return <div><div style={{ fontFamily: display, fontWeight: 700, fontSize: 20, color: c }}>{v}</div><div style={{ color: C.sub, fontSize: 11.5 }}>{label}</div></div>; }
const weBtnPrimary = { border: "none", background: C.play, color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 16, padding: "11px 20px", borderRadius: 11, cursor: "pointer", letterSpacing: .5, textTransform: "uppercase" };
const weBtnGhost = { border: `1.5px solid ${C.line}`, background: C.card, color: C.ink, fontFamily: display, fontWeight: 700, fontSize: 16, padding: "11px 20px", borderRadius: 11, cursor: "pointer", letterSpacing: .5, textTransform: "uppercase" };

/* =====================================================================
   VIEW: EINZEL-KO  (eingehängter Baustein · Tour-Schiene, Start)
   Portiert aus einzel-ko.jsx — eigenes Theme, Logo, Fonts & der lokale
   useState-Baum raus, alles über useStore(). Ohne Teams: spontane Namen
   (state.ko.participants), KO-Baum + Ergebnisse EINE Wahrheit
   (state.ko.bracket über koBuildBracket), Golden Goal bei Gleichstand,
   kleines Finale um Platz 3 ab Baumgröße 4. Ein fertiges Ergebnis
   (Platz 1–4) hebt sich über ko/saveToTour in state.tour (Kids anlegen/
   wiederverwenden + ein neues Event) — Grundlage für die Tour-Rangliste
   (KO-Übernahme), die als Nächstes drankommt. Sichtbar für Headcoach/
   Coach (kein Publikum — läuft direkt an der Box). Helfer `Ko…`.
   ===================================================================== */

function EinzelKO({ nurEintragen = false }) {
  const { state, dispatch } = useStore();
  const { participants, bracket, savedEventId } = state.ko;
  const [input, setInput] = useState("");   // reiner UI-State: nur das Eingabefeld
  // Stand 37h: Afterwork -- Erwachsene, zuerst Firma (optional), dann Name, Ticket-Art
  const afterwork = (state.tournament.meta && state.tournament.meta.format) === "afterwork";
  const [firma, setFirma] = useState("");
  const [ticket, setTicket] = useState(null); // null = automatisch (gueltiges Abo -> Abo, sonst Einzelticket)
  const [abos, setAbos] = useState([]);
  useEffect(() => { if (afterwork) listAbos().then(setAbos).catch(() => setAbos([])); }, [afterwork]);
  const ort = String((state.tournament.meta && state.tournament.meta.ort) || "").toLowerCase();
  const heute = (state.tournament.meta && state.tournament.meta.date) || todayIso();
  const aboFuer = (f) => {
    const lf = (f || "").trim().toLowerCase(); if (!lf) return null;
    return abos.find((a) => a.aktiv && a.firma.trim().toLowerCase() === lf
      // Stand 37j (Nutzer: "all of them"): Abos gelten bei allen Partnerlokalen
      && (!a.von || heute >= a.von) && (!a.bis || heute <= a.bis)
      && (a.rest > 0 || participants.some((p) => p.aboId === a.id))) || null; // dieser Termin zaehlt schon
  };
  const abo = aboFuer(firma);
  const aboHeute = abo ? participants.filter((p) => p.aboId === abo.id).length : 0;
  const aboVoll = abo && aboHeute >= abo.plaetze;
  const ticketJetzt = ticket === "abo" && abo && !aboVoll ? "abo" : ticket === "einzel" ? "einzel" : abo && !aboVoll ? "abo" : "einzel";
  const firmen = Array.from(new Set([...participants.map((p) => (p.firma || "").trim()), ...abos.filter((a) => a.aktiv).map((a) => a.firma)].filter(Boolean)));
  const wer = afterwork ? { einz: "Person", mehr: "Personen", feld: "Name + Enter" } : { einz: "Kind", mehr: "Kinder", feld: "Name des Kindes + Enter" };

  const addName = () => {
    const v = input.trim();
    if (!v || participants.length >= 16 || bracket) return;
    dispatch(afterwork ? { type: "ko/addParticipant", name: v, firma: abo ? abo.firma : firma.trim(), ticket: ticketJetzt, aboId: ticketJetzt === "abo" && abo ? abo.id : null } : { type: "ko/addParticipant", name: v });
    setInput(""); // Firma bleibt stehen -- oft kommen mehrere aus derselben Firma
  };

  const R = bracket ? bracket.rounds.length : 0;
  const finalMatch = bracket && R > 0 ? bracket.rounds[R - 1][0] : null;
  const champion = finalMatch && finalMatch.done ? finalMatch.winner : null;
  const runnerUp = finalMatch && finalMatch.done ? finalMatch.loser : null;
  const third = bracket && bracket.smallFinal && bracket.smallFinal.done ? bracket.smallFinal.winner : null;
  const canSave = !!champion && !savedEventId && !afterwork; // Afterwork: keine Tour, Wertung des Abends sammelt alles

  const header = (
    <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 14 }}>
      <div style={{ width: 44, height: 44, borderRadius: 12, background: C.play, display: "grid", placeItems: "center", fontSize: 22, flexShrink: 0 }}>🥅</div>
      <div>
        <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: 0 }}>Einzel-KO</h2>
        <div style={{ fontSize: 13, color: C.sub }}>Event-Modus · ohne Teams · spontane Namen, Golden Goal, Freilose</div>
      </div>
    </div>
  );

  if (!bracket || (nurEintragen && afterwork)) {
    return (
      <div style={{ fontFamily: font, color: C.ink }}>
        {afterwork ? <div style={{ fontFamily: display, fontWeight: 800, fontSize: 22, marginBottom: 10 }}>👥 Mitspielende</div> : header}
        <p style={{ color: C.sub, margin: "0 0 16px", fontSize: 14.5, maxWidth: 560 }}>
          {afterwork ? "Mitspielende eintragen, wie sie kommen" : "Kinder eintragen, wie sie kommen"} — 2 bis 16. Der Baum stellt sich auf die nächste Größe (4/8/16) ein,
          Freilose werden zufällig verlost. Jedes Spiel 2 Minuten, bei Gleichstand Golden Goal.
        </p>
        <Card>
          {afterwork && (
            <div data-aw-firma="true" style={{ display: "flex", gap: 8, marginBottom: 8, flexWrap: "wrap", alignItems: "center" }}>
              <input data-aw-firma-feld list="ms-aw-firmen" style={{ flex: 1, minWidth: 160, border: `1px solid ${C.line}`, borderRadius: 10, padding: "10px 12px", fontFamily: font, fontSize: 15, color: C.ink }}
                placeholder="1. Firma (kann frei bleiben)" value={firma} onChange={(e) => { setFirma(e.target.value); setTicket(null); }} />
              <datalist id="ms-aw-firmen">{firmen.map((f) => <option key={f} value={f} />)}</datalist>
              {[["abo", "👥 Teamticket (Abo)"], ["einzel", "🎟️ Einzelticket"]].map(([k, l]) => {
                const aus = k === "abo" && (!abo || aboVoll);
                return (
                  <button key={k} data-aw-ticket={k} disabled={aus} onClick={() => setTicket(k)}
                    style={{ border: `1.5px solid ${ticketJetzt === k ? C.play : C.line}`, background: ticketJetzt === k ? C.playSoft : "#fff", color: C.ink, borderRadius: 999, padding: "8px 12px", fontWeight: 700, fontSize: 13, cursor: aus ? "default" : "pointer", opacity: aus ? 0.45 : 1, fontFamily: font }}>{l}</button>
                );
              })}
              {firma.trim() && (
                <div data-aw-abo-info={abo ? (aboVoll ? "voll" : "ok") : "kein"} style={{ width: "100%", fontSize: 12.5, color: abo && !aboVoll ? C.play : C.sub }}>
                  {abo
                    ? (aboVoll
                      ? `Abo-Plätze für heute voll (${abo.plaetze}/${abo.plaetze}) — weitere Personen zahlen ein Einzelticket.`
                      : `✅ Abo ${abo.firma}: ${aboHeute}/${abo.plaetze} Plätze heute · ${participants.some((p) => p.aboId === abo.id) ? "" : "dieser Termin zählt · "}noch ${abo.rest} von ${abo.termine} Terminen frei · 🍽️ reservierter Tisch · 🥤 Getränkegutschein`)
                    : "Kein gültiges Abo für diese Firma — Einzelticket. Die Firma wird fürs Büro notiert."}
                </div>
              )}
            </div>
          )}
          <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
            <input data-ko-name style={{ flex: 1, border: `1px solid ${C.line}`, borderRadius: 10, padding: "10px 12px", fontFamily: font, fontSize: 15, color: C.ink }}
              placeholder={afterwork ? "2. Name + Enter" : wer.feld} value={input}
              onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && addName()} />
            <button onClick={addName} disabled={participants.length >= 16} style={{ ...koBtnPrimary, opacity: participants.length >= 16 ? 0.5 : 1 }}>+</button>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(150px,1fr))", gap: 8 }}>
            {participants.length === 0 && <span style={{ fontSize: 13, color: C.sub }}>Noch keine {wer.mehr} eingetragen.</span>}
            {participants.map((p, i) => (
              <div key={p.id} data-ko-teilnehmer={p.ticket || ""} style={{ display: "flex", alignItems: "center", gap: 8, background: C.chalk, borderRadius: 10, padding: "8px 10px" }}>
                <span style={{ fontFamily: display, fontWeight: 700, color: C.play, fontSize: 15, minWidth: 20 }}>{i + 1}</span>
                <span style={{ flex: 1, minWidth: 0 }}>
                  <span style={{ display: "block", fontSize: 14, fontWeight: 600 }}>{p.name}</span>
                  {afterwork && <span style={{ display: "block", fontSize: 11.5, color: C.sub }}>{p.ticket === "abo" || p.ticket === "team" ? `👥 Abo · ${p.firma} · 🥤` : `🎟️ Einzelticket${p.firma ? ` · ${p.firma}` : ""}`}</span>}
                </span>
                <button onClick={() => dispatch({ type: "ko/removeParticipant", id: p.id })} style={{ border: "none", background: "none", color: C.sub, cursor: "pointer", fontSize: 16 }}>×</button>
              </div>
            ))}
          </div>
          {afterwork && participants.length > 0 && (() => {
            const team = participants.filter((p) => p.ticket === "abo" || p.ticket === "team");
            const proFirma = {}; team.forEach((p) => { proFirma[p.firma] = (proFirma[p.firma] || 0) + 1; });
            const einzel = participants.length - team.length;
            return (
              <div data-aw-tickets="true" style={{ fontSize: 12.5, color: C.sub, marginTop: 12, lineHeight: 1.6 }}>
                👥 Abo-Plätze: <b style={{ color: C.ink }}>{team.length}</b>{Object.keys(proFirma).length ? ` (${Object.entries(proFirma).map(([f, n]) => `${f} ${n}`).join(", ")})` : ""} · 🎟️ Einzeltickets: <b style={{ color: C.ink }}>{einzel}</b>
                {team.length > 0 && <><br />🍽️ Tisch reservieren für {Object.keys(proFirma).join(", ")} · 🥤 {team.length} Getränkegutscheine</>}
              </div>
            );
          })()}
          <div style={{ display: "flex", alignItems: "center", gap: 14, marginTop: 18, flexWrap: "wrap" }}>
            {afterwork ? <span style={{ fontSize: 13, color: C.sub }}>Runden (Sieger bleibt · KO · Firmen) startest du in „Jetzt". Nachzügler kannst du jederzeit eintragen.</span>
              : state.role !== "coach" ? <button onClick={() => dispatch({ type: "ko/start" })} disabled={participants.length < 2} style={{ ...koBtnPrimary, fontSize: 17, padding: "11px 22px", opacity: participants.length < 2 ? 0.5 : 1 }}>Turnier starten</button>
              : <span style={{ fontSize: 13, color: C.sub }}>Der Headcoach startet das KO.</span>}
            {participants.length >= 2 && (
              <span style={{ fontSize: 13.5, color: C.sub }}>
                {participants.length} {wer.mehr} → Baum für <b style={{ color: C.ink }}>{koNextPow2(participants.length)}</b>, {koNextPow2(participants.length) - participants.length} Freilos(e) zufällig
              </span>
            )}
            {participants.length < 2 && <span style={{ fontSize: 13, color: C.sub }}>Mindestens 2 {wer.mehr}.</span>}
            {participants.length > 0 && <button onClick={() => dispatch({ type: "ko/clearParticipants" })} style={koBtnGhost}>Liste leeren</button>}
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div style={{ fontFamily: font, color: C.ink }}>
      {header}
      {champion && (
        <div style={{ background: C.play, borderRadius: 16, padding: "16px 20px", marginBottom: 18, color: "#fff", display: "flex", gap: 22, alignItems: "center", flexWrap: "wrap" }}>
          <KoPodium place="1." name={champion.name} big />
          {runnerUp && <KoPodium place="2." name={runnerUp.name} />}
          {third && <KoPodium place="3." name={third.name} />}
        </div>
      )}

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14, flexWrap: "wrap", gap: 10 }}>
        <span style={{ fontSize: 13.5, color: C.sub }}>
          Baum für {bracket.size} · {bracket.byes} Freilos(e) · <b style={{ color: C.gold }}>Golden Goal</b> bei Gleichstand
        </span>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {canSave && <button onClick={() => dispatch({ type: "ko/saveToTour" })} style={{ ...koBtnPrimary, background: C.fair }}>In Tour-Rangliste übernehmen</button>}
          {state.role === "headcoach" && <button onClick={() => { let ok = false; try { ok = window.confirm("KO-Baum verwerfen und neu auslosen? Alle Ergebnisse dieses Baums gehen verloren (die Namen bleiben)."); } catch (_) { ok = false; } if (ok) dispatch({ type: "ko/reset" }); }} style={koBtnGhost}>Neu auslosen</button>}
        </div>
      </div>
      {savedEventId && (
        <div style={{ background: C.playSoft, border: `1px solid ${C.play}`, borderRadius: 12, padding: "10px 14px", marginBottom: 14, fontSize: 13, color: C.fair }}>
          Ergebnis in der Tour „{state.tour.name}" gespeichert — {state.tour.events.length} Station(en) bisher.
        </div>
      )}

      <div style={{ overflowX: "auto", paddingBottom: 8 }}>
        <div style={{ display: "flex", gap: 18, minWidth: "min-content" }}>
          {bracket.rounds.map((round, ri) => (
            <div key={ri} style={{ display: "flex", flexDirection: "column", justifyContent: "space-around", gap: 12, minWidth: 210 }}>
              <div style={{ fontFamily: display, fontWeight: 700, fontSize: 15, textTransform: "uppercase", letterSpacing: 1, color: C.sub, textAlign: "center" }}>{koRoundName(ri, R)}</div>
              {round.map((m, mi) => (
                <KoMatchCard key={m.id} m={m}
                  onScore={(slot, d) => dispatch({ type: "ko/score", loc: "r", ri, mi, slot, delta: d })}
                  onConfirm={() => dispatch({ type: "ko/confirm", loc: "r", ri, mi })} />
              ))}
            </div>
          ))}
        </div>
      </div>

      {bracket.smallFinal && (
        <div style={{ marginTop: 22 }}>
          <div style={{ fontFamily: display, fontWeight: 700, fontSize: 15, textTransform: "uppercase", letterSpacing: 1, color: C.sub, marginBottom: 10 }}>Kleines Finale · Platz 3</div>
          <div style={{ maxWidth: 240 }}>
            <KoMatchCard m={bracket.smallFinal}
              onScore={(slot, d) => dispatch({ type: "ko/score", loc: "sf", slot, delta: d })}
              onConfirm={() => dispatch({ type: "ko/confirm", loc: "sf" })} small />
          </div>
        </div>
      )}
    </div>
  );
}

function KoMatchCard({ m, onScore, onConfirm }) {
  const bothReal = m.a && m.b && !m.b.bye;
  const canConfirm = bothReal && !m.done && m.sa !== m.sb;
  const golden = bothReal && !m.done && m.sa === m.sb && (m.sa > 0 || m.sb > 0);
  return (
    <div style={{ background: C.card, border: `1px solid ${m.done ? C.play : C.line}`, borderRadius: 12, overflow: "hidden" }}>
      <KoSlot p={m.a} score={m.sa} slot="sa" win={m.done && m.winner === m.a} onScore={onScore} live={bothReal && !m.done} />
      <div style={{ height: 1, background: C.line }} />
      <KoSlot p={m.b} score={m.sb} slot="sb" win={m.done && m.winner === m.b} bye={m.b && m.b.bye} onScore={onScore} live={bothReal && !m.done} />
      {golden && <div style={{ background: "#FFF6E0", color: C.gold, fontSize: 12, fontWeight: 700, textAlign: "center", padding: "4px 0", borderTop: `1px solid ${C.line}` }}>⚽ Golden Goal — nächstes Tor entscheidet</div>}
      {canConfirm && <button onClick={onConfirm} style={{ width: "100%", border: "none", background: C.play, color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 14, padding: "7px 0", cursor: "pointer", letterSpacing: 0.5 }}>Sieger bestätigen ▸</button>}
      {m.byeWin && <div style={{ background: C.playSoft, color: C.fair, fontSize: 11.5, fontWeight: 700, textAlign: "center", padding: "3px 0" }}>Freilos — weiter</div>}
    </div>
  );
}

function KoSlot({ p, score, slot, win, bye, onScore, live }) {
  const empty = !p;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 10px", background: win ? C.playSoft : "transparent" }}>
      <span style={{ flex: 1, fontSize: 14, fontWeight: win ? 700 : 600, color: empty ? C.sub : bye ? C.sub : C.ink, fontStyle: empty || bye ? "italic" : "normal", minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {empty ? "wartet…" : bye ? "Freilos" : p.name}
      </span>
      {!bye && !empty && (
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          {live && <button onClick={() => onScore(slot, -1)} style={koMiniBtn}>−</button>}
          <span style={{ fontFamily: display, fontWeight: 700, fontSize: 20, minWidth: 22, textAlign: "center", color: win ? C.play : C.ink }}>{score}</span>
          {live && <button onClick={() => onScore(slot, +1)} style={{ ...koMiniBtn, background: C.play, color: "#fff", borderColor: C.play }}>+</button>}
        </div>
      )}
    </div>
  );
}

function KoPodium({ place, name, big }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <span style={{ fontFamily: display, fontWeight: 700, fontSize: big ? 40 : 26, color: "#fff", lineHeight: 1 }}>{place}</span>
      <span style={{ fontFamily: display, fontWeight: 700, fontSize: big ? 26 : 18, color: "#fff", textTransform: "uppercase" }}>{name}</span>
    </div>
  );
}

const koBtnPrimary = { border: "none", background: C.play, color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 16, padding: "9px 16px", borderRadius: 10, cursor: "pointer", letterSpacing: 0.5 };
const koBtnGhost = { border: `1.5px solid ${C.line}`, background: "#fff", color: C.ink, fontFamily: font, fontWeight: 600, fontSize: 13.5, padding: "8px 14px", borderRadius: 10, cursor: "pointer" };
const koMiniBtn = { width: 26, height: 26, borderRadius: 7, border: `1px solid ${C.line}`, background: "#fff", fontSize: 16, lineHeight: 1, cursor: "pointer", color: C.ink, fontWeight: 700, padding: 0 };

/* =====================================================================
   VIEW: TOUR-RANGLISTE  (eingehängter Baustein · Tour-Schiene, weiter)
   Portiert aus tour-rangliste.jsx — eigenes Theme, Logo, Fonts, die
   Mehr-Touren-Verwaltung (der Rahmen kennt nur EINE Tour, state.tour) &
   die Demo-Daten der Einzeldatei raus, alles über useStore(). KO-
   Übernahme ist bereits Wahrheit (ko/saveToTour hebt Kids + Event in
   state.tour) — diese Ansicht wertet nur noch aus:
     · Gesamt-Rangliste + Verlauf je Kind  → EINE Ableitung: tourStandings(tour)
       (Punkteschema tour.scheme, optional nur die besten tour.bestN Tage,
       tour.bestOn) — dieselbe Stelle, die auch der Fundament-Check liest.
     · Tagessieger je Event                → direkt aus event.results
       (placement 1), keine zweite Ableitung nötig.
   Headcoach/Coach können zusätzlich eine Station manuell erfassen (ohne
   Einzel-KO, z. B. ein spontanes Spiel) — neue, namespaced Action
   tour/addEvent; Kids werden dabei über denselben Helfer wie
   ko/saveToTour angelegt/wiederverwendet (tourFindOrMakeKid), also keine
   zweite Wahrheit. Sichtbar für Headcoach/Coach/Publikum, Erfassen nur
   Headcoach/Coach (canEdit, wie bei Fairplay/Aufgaben). Helfer `Tr…`.
   ===================================================================== */

function TourRangliste() {
  const { state, dispatch } = useStore();
  const tour = useTourAnsicht(); // Stand 37f: ganze Tour ueber alle Stationen
  const role = state.role;
  const canEdit = role === "headcoach" || role === "coach";

  // Gesamt-Rangliste + Verlauf: EINE Ableitung (tourStandings), keine Kopie hier.
  const standings = useMemo(() => tourStandings(tour), [tour]);
  const kidById = useCallback((id) => tour.kids.find((k) => k.id === id), [tour.kids]);

  // Tagessieger je Event: direkt aus den Rohdaten (results, placement 1).
  const eventRows = useMemo(() => tour.events.map((e) => {
    const sorted = e.results.slice().sort((a, b) => (a.placement || 9) - (b.placement || 9));
    const win = sorted.find((r) => r.placement === 1) || null;
    return { event: e, sorted, winner: win ? kidById(win.kidId) : null };
  }), [tour.events, kidById]);

  const [openKid, setOpenKid] = useState(null);   // reiner UI-State: aufgeklappter Verlauf
  const [form, setForm] = useState(null);         // reiner UI-State: Station-Erfassung offen?

  const startForm = () => setForm({ datum: "", ort: "", rows: [{ name: "", placement: 1 }] });
  const closeForm = () => setForm(null);
  const patchForm = (patch) => setForm((f) => ({ ...f, ...patch }));
  const setRow = (i, patch) => setForm((f) => ({ ...f, rows: f.rows.map((r, ix) => (ix === i ? { ...r, ...patch } : r)) }));
  const addRow = () => setForm((f) => ({ ...f, rows: [...f.rows, { name: "", placement: 0 }] }));
  const removeRow = (i) => setForm((f) => ({ ...f, rows: f.rows.filter((_, ix) => ix !== i) }));
  const saveForm = () => {
    const results = form.rows.filter((r) => r.name.trim());
    if (!results.length) return;
    dispatch({ type: "tour/addEvent", datum: form.datum, ort: form.ort, results });
    closeForm();
  };

  const maxTotal = Math.max(1, ...standings.map((r) => r.total));
  const isEmpty = tour.events.length === 0 || standings.length === 0;

  return (
    <div style={{ fontFamily: font, color: C.ink }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 6 }}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: C.play, display: "grid", placeItems: "center", fontSize: 22, flexShrink: 0 }}>📊</div>
        <div>
          <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: 0 }}>Tour-Rangliste</h2>
          <div style={{ fontSize: 13, color: C.sub }}>{tour.name} · Einzel-KO über mehrere Events{tour.stationen ? ` · ${tour.stationen} Events` : ""}</div>
        </div>
      </div>
      <TourZuordnung />
      <p style={{ color: C.sub, fontSize: 13.5, margin: "6px 0 18px", maxWidth: 640 }}>
        Punkteschema: 🥇 {tour.scheme.p1} · 🥈 {tour.scheme.p2} · 🥉 {tour.scheme.p3} · Teilnahme {tour.scheme.part}
        {tour.bestOn ? ` — es zählen nur die besten ${tour.bestN} Tage je Kind.` : " — es zählen alle Tage."}
      </p>

      {isEmpty ? (
        <Card>
          <div style={{ textAlign: "center", padding: "30px 10px", color: C.sub }}>
            <div style={{ fontSize: 34, marginBottom: 8 }}>📊</div>
            <div style={{ fontWeight: 700, color: C.ink, marginBottom: 4 }}>Noch keine Stationen</div>
            <div style={{ fontSize: 13.5 }}>
              Sobald ein Einzel-KO-Ergebnis über „In Tour-Rangliste übernehmen" gespeichert wird{canEdit ? " oder eine Station manuell erfasst wird" : ""}, erscheint hier die Rangliste.
            </div>
          </div>
        </Card>
      ) : (
        <>
          <TrSection title="Gesamt-Rangliste" hint={`${tour.events.length} Station(en) · ${standings.length} Kinder`}>
            <TrPodium rows={standings} />
            <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 18 }}>
              {standings.map((r, i) => (
                <TrRow key={r.kid.id} r={r} i={i} maxTotal={maxTotal} open={openKid === r.kid.id}
                  onToggle={() => setOpenKid(openKid === r.kid.id ? null : r.kid.id)} />
              ))}
            </div>
          </TrSection>

          <TrSection title="Tagessieger je Event" hint="je Station der 1. Platz">
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {eventRows.map(({ event, sorted, winner }) => (
                <Card key={event.id} style={{ padding: "12px 16px" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
                    <div>
                      <b style={{ fontFamily: display, fontSize: 15 }}>{event.ort || "Station"}</b>
                      {event.datum && <span style={{ color: C.sub, fontSize: 12.5, marginLeft: 8 }}>{event.datum}</span>}
                    </div>
                    <div style={{ fontSize: 13.5 }}>
                      {winner ? <><span style={{ fontSize: 16 }}>🥇</span> <b>{winner.name}</b></> : <span style={{ color: C.sub }}>kein Sieger erfasst</span>}
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: 14, marginTop: 8, flexWrap: "wrap", fontSize: 12.5, color: C.sub }}>
                    {sorted.map((r) => {
                      const kid = kidById(r.kidId);
                      if (!kid) return null;
                      return (
                        <span key={r.kidId}>{r.placement === 1 ? "🥇" : r.placement === 2 ? "🥈" : r.placement === 3 ? "🥉" : "•"} {kid.name}</span>
                      );
                    })}
                  </div>
                </Card>
              ))}
            </div>
          </TrSection>
        </>
      )}

      {canEdit && (
        <TrSection title="Station manuell erfassen" hint="ohne Einzel-KO, z. B. ein spontanes Spiel">
          {!form ? (
            <button onClick={startForm} style={trBtnPrimary}>+ Neue Station</button>
          ) : (
            <Card>
              <div style={{ display: "flex", gap: 10, marginBottom: 12, flexWrap: "wrap" }}>
                <input placeholder="Datum (z. B. 20.07.)" value={form.datum} onChange={(e) => patchForm({ datum: e.target.value })} style={trInput} />
                <input placeholder="Ort" value={form.ort} onChange={(e) => patchForm({ ort: e.target.value })} style={trInput} />
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {form.rows.map((row, i) => (
                  <div key={i} style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <input placeholder="Name des Kindes" value={row.name} onChange={(e) => setRow(i, { name: e.target.value })} style={{ ...trInput, flex: 1 }} />
                    <select value={row.placement} onChange={(e) => setRow(i, { placement: Number(e.target.value) })} style={trInput}>
                      <option value={1}>🥇 1.</option>
                      <option value={2}>🥈 2.</option>
                      <option value={3}>🥉 3.</option>
                      <option value={0}>dabei</option>
                    </select>
                    {form.rows.length > 1 && <button onClick={() => removeRow(i)} style={{ border: "none", background: "none", color: C.sub, cursor: "pointer", fontSize: 16 }}>×</button>}
                  </div>
                ))}
              </div>
              <div style={{ display: "flex", gap: 10, marginTop: 14, flexWrap: "wrap" }}>
                <button onClick={addRow} style={trBtnGhost}>+ Kind</button>
                <button onClick={saveForm} style={trBtnPrimary}>Station speichern</button>
                <button onClick={closeForm} style={trBtnGhost}>Abbrechen</button>
              </div>
            </Card>
          )}
        </TrSection>
      )}
    </div>
  );
}

/* ---------- Tour-Rangliste-Helfer (Tr…) ---------- */
function TrSection({ title, hint, children }) {
  return (
    <div style={{ marginBottom: 26 }}>
      <div style={{ display: "flex", alignItems: "baseline", gap: 10, marginBottom: 12, flexWrap: "wrap" }}>
        <h3 style={{ fontFamily: display, fontWeight: 700, fontSize: 19, margin: 0 }}>{title}</h3>
        {hint && <span style={{ fontSize: 12.5, color: C.sub }}>{hint}</span>}
      </div>
      {children}
    </div>
  );
}
function TrPodium({ rows }) {
  const top = rows.slice(0, 3);
  if (!top.length) return null;
  const order = [top[1], top[0], top[2]].filter(Boolean); // 2 · 1 · 3
  const heights = { 0: 96, 1: 70, 2: 52 };
  const medal = ["🥇", "🥈", "🥉"];
  const ring = [C.gold, C.silver, C.bronze];
  return (
    <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "center", gap: "clamp(10px,3vw,26px)" }}>
      {order.map((r) => {
        const place = rows.indexOf(r);
        return (
          <div key={r.kid.id} style={{ textAlign: "center", flex: "0 1 160px" }}>
            <div style={{ fontSize: "clamp(22px,4vw,32px)", marginBottom: 4 }}>{medal[place]}</div>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(14px,2vw,17px)", textTransform: "uppercase" }}>{r.kid.name}</div>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(17px,2.6vw,22px)", color: C.play }}>{r.total}<span style={{ fontSize: 11, color: C.sub, fontWeight: 600 }}> Pkt</span></div>
            <div style={{ height: heights[place], background: `linear-gradient(180deg, ${C.play}, ${C.play}22)`, borderRadius: "10px 10px 0 0", marginTop: 8, border: `1px solid ${C.line}`, borderBottom: "none", boxShadow: `0 0 0 3px ${ring[place]} inset` }} />
          </div>
        );
      })}
    </div>
  );
}
function TrRow({ r, i, maxTotal, open, onToggle }) {
  return (
    <div style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 12, padding: "10px 14px" }}>
      <button onClick={onToggle} style={{ width: "100%", border: "none", background: "none", cursor: "pointer", padding: 0, display: "flex", alignItems: "center", gap: 10, textAlign: "left", fontFamily: font, color: C.ink }}>
        <b style={{ fontFamily: display, fontSize: 16, color: i === 0 ? C.gold : i === 1 ? C.silver : i === 2 ? C.bronze : C.sub, width: 22 }}>{i + 1}.</b>
        <b style={{ minWidth: 80 }}>{r.kid.name}</b>
        <div style={{ flex: 1 }}><Bar frac={r.total / maxTotal} color={C.water} /></div>
        <span style={{ fontFamily: display, fontWeight: 700, fontSize: 17 }}>{r.total}</span>
        <span style={{ fontSize: 11.5, color: C.sub, width: 56, textAlign: "right" }}>{r.tage} Tage</span>
        <span style={{ color: C.sub, fontSize: 13 }}>{open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div style={{ marginTop: 10, paddingTop: 10, borderTop: `1px solid ${C.line}`, display: "flex", flexDirection: "column", gap: 6 }}>
          {r.entries.map((e, ix) => (
            <div key={e.eventId} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 12.5, color: r.counted.has(ix) ? C.ink : C.sub, opacity: r.counted.has(ix) ? 1 : 0.55 }}>
              <span style={{ width: 20 }}>{e.placement === 1 ? "🥇" : e.placement === 2 ? "🥈" : e.placement === 3 ? "🥉" : "•"}</span>
              <span style={{ flex: 1 }}>{e.ort || "Station"}{e.datum ? ` · ${e.datum}` : ""}</span>
              <b>{e.pts} Pkt</b>
              {!r.counted.has(ix) && <span style={{ fontSize: 11 }}>(zählt nicht)</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
const trBtnPrimary = { border: "none", background: C.play, color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 15, padding: "10px 18px", borderRadius: 10, cursor: "pointer", letterSpacing: 0.5 };
const trBtnGhost = { border: `1.5px solid ${C.line}`, background: "#fff", color: C.ink, fontFamily: font, fontWeight: 600, fontSize: 13.5, padding: "9px 16px", borderRadius: 10, cursor: "pointer" };
const trInput = { border: `1px solid ${C.line}`, borderRadius: 9, padding: "8px 10px", fontFamily: font, fontSize: 14, color: C.ink };

/* =====================================================================
   VIEW: TOUR-WEBSITE (öffentliche Microsite je Tour)  (eingehängter Baustein
   · Tour-Schiene, weiter)
   Portiert aus tour-website.jsx — eigenes Theme, Fonts, Logo, Demo-Kinder
   (K/KIDS) & Demo-Stationen (EVENTS) raus, alles über useStore(). REIN
   LESEND, wie Website: keine zweite Wahrheit, kein Schreiben.
     · Rangliste + Verlauf je Kind → derselbe Helfer wie Tour-Rangliste:
       tourStandings(tour) (Punkteschema tour.scheme, optional nur die
       besten tour.bestN Tage über tour.bestOn — „(zählt nicht)“ markiert).
     · Stationen  → direkt aus tour.events (Ort/Datum/Teilnehmer:innenzahl),
       Tagessieger direkt aus event.results (Platzierung 1).
     · Titel      → tour.name (echte Wahrheit, keine editierbare Kopie).
   Der Prototyp-Editor „✎ Seite bearbeiten“ (lokale, nirgends gespeicherte
   Zeitraum/Art-Felder — eine Schein-Wahrheit) ist entfallen, analog zum
   entfallenen Live/Beendet-Umschalter der Website.
   Sichtbar für Publikum/Headcoach/Coach. Helfer `Tw…`-präfixiert.
   ===================================================================== */
function TourWebsite() {
  const { state } = useStore();
  const tour = useTourAnsicht(); // Stand 37f: ganze Tour ueber alle Stationen

  const standings = useMemo(() => tourStandings(tour), [tour]);
  const kidById = useCallback((id) => tour.kids.find((k) => k.id === id), [tour.kids]);
  const maxTotal = Math.max(1, ...standings.map((r) => r.total));
  const isEmpty = tour.events.length === 0 || standings.length === 0;

  const stations = useMemo(() => tour.events.map((e) => {
    const sorted = e.results.slice().sort((a, b) => (a.placement || 9) - (b.placement || 9));
    const win = sorted.find((r) => r.placement === 1) || null;
    return { event: e, winner: win ? kidById(win.kidId) : null, count: e.results.length };
  }), [tour.events, kidById]);

  const [openKid, setOpenKid] = useState(null);
  const jump = (id) => { const el = typeof document !== "undefined" && document.getElementById(id); if (el) el.scrollIntoView({ behavior: "smooth", block: "start" }); };

  return (
    <div style={{ background: C.chalk, minHeight: "100%", fontFamily: font, color: C.ink }}>
      <style>{`
        .tw-navlink{position:relative;background:none;border:none;font-family:${display};font-weight:700;font-size:15px;letter-spacing:.5px;text-transform:uppercase;color:${C.sub};cursor:pointer;padding:6px 2px;}
        .tw-navlink:hover{color:${C.play};}
        .tw-stat{transition:transform .18s, box-shadow .18s;}
        .tw-stat:hover{transform:translateY(-3px);box-shadow:0 12px 30px rgba(19,36,28,.12);}
      `}</style>

      {/* NAVIGATION (öffentliche Seite · grünes Logo auf hell) */}
      <header style={{ position: "sticky", top: 0, zIndex: 30, background: "rgba(238,244,240,.9)", backdropFilter: "blur(8px)", borderBottom: `1px solid ${C.line}` }}>
        <div style={{ maxWidth: 1000, margin: "0 auto", padding: "12px 20px", display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
          <button onClick={() => jump("tw-top")} style={{ background: "none", border: "none", cursor: "pointer", display: "flex" }}>
            <img src={LOGO_GREEN} alt={BRAND} style={{ height: 30 }} />
          </button>
          <nav style={{ marginLeft: "auto", display: "flex", gap: 18, flexWrap: "wrap" }}>
            <button className="tw-navlink" onClick={() => jump("tw-rangliste")}>Rangliste</button>
            <button className="tw-navlink" onClick={() => jump("tw-stationen")}>Stationen</button>
          </nav>
        </div>
      </header>
      <div id="tw-top" />

      {/* HERO */}
      <section style={{ position: "relative", overflow: "hidden", borderBottom: `1px solid ${C.line}` }}>
        <svg viewBox="0 0 1000 300" preserveAspectRatio="xMidYMid slice" aria-hidden="true" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", opacity: 0.07 }}>
          {[80, 140, 200, 260].map((y, i) => <path key={i} d={`M0 ${y} Q 125 ${y - 22} 250 ${y} T 500 ${y} T 750 ${y} T 1000 ${y}`} fill="none" stroke={C.water} strokeWidth="3" />)}
        </svg>
        <div style={{ position: "relative", maxWidth: 1000, margin: "0 auto", padding: "54px 20px 46px", textAlign: "center" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: C.playSoft, color: C.playDeep, border: "1px solid #BFE6D2", borderRadius: 999, padding: "6px 14px", fontWeight: 700, fontSize: 13, marginBottom: 16 }}>
            🏊 Einzel-KO-Tour · {tour.events.length} Station{tour.events.length === 1 ? "" : "en"}
          </div>
          <h1 style={{ fontFamily: display, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, lineHeight: 0.95, margin: 0, fontSize: "clamp(38px,7vw,78px)" }}>{tour.name}</h1>
          <p style={{ color: C.sub, fontSize: "clamp(15px,2vw,19px)", marginTop: 12 }}>Einzel-Turniere über mehrere Stationen · „Sieger bleibt am Platz“</p>
          <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 22, flexWrap: "wrap" }}>
            <button onClick={() => jump("tw-rangliste")} style={twBtnPrimary}>Zur Rangliste</button>
            <button onClick={() => jump("tw-stationen")} style={twBtnGhost}>Alle Stationen</button>
          </div>
        </div>
      </section>

      <main style={{ maxWidth: 1000, margin: "0 auto", padding: "8px 20px 40px" }}>
        {/* RANGLISTE */}
        <TwSection id="tw-rangliste" eyebrow="Über die ganze Tour" title="Tour-Rangliste">
          {isEmpty ? (
            <Card><div style={{ textAlign: "center", padding: "24px 10px", color: C.sub }}>Noch keine Stationen — sobald ein Einzel-KO-Ergebnis übernommen oder eine Station erfasst wird, erscheint hier die Rangliste.</div></Card>
          ) : (
            <>
              <TwPodium ranking={standings} />
              <div style={{ display: "flex", alignItems: "baseline", gap: 10, margin: "22px 0 10px", flexWrap: "wrap" }}>
                <span style={{ fontSize: 13, color: C.sub }}>Summe aller Tage{tour.bestOn ? ` (beste ${tour.bestN} zählen)` : ""}</span>
                {standings.length > 3 && <span style={{ marginLeft: "auto", fontSize: 12, color: C.sub }}>Zeile antippen für den Verlauf</span>}
              </div>
              <div style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 16, padding: 8, overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 340 }}>
                  <thead><tr style={{ color: C.sub, fontSize: 12 }}><TwTh l>#</TwTh><TwTh l>Kind</TwTh><TwTh>Tage</TwTh><TwTh>Punkte</TwTh></tr></thead>
                  <tbody>
                    {standings.map((r, i) => {
                      const open = openKid === r.kid.id;
                      return (
                        <React.Fragment key={r.kid.id}>
                          <tr onClick={() => setOpenKid(open ? null : r.kid.id)} style={{ borderTop: `1px solid ${C.line}`, cursor: "pointer", background: open ? C.playSoft : "transparent" }}>
                            <TwTd l style={{ fontFamily: display, fontWeight: 700, fontSize: 18, color: i === 0 ? C.gold : i === 1 ? C.silver : i === 2 ? C.bronze : C.sub }}>{i + 1}</TwTd>
                            <TwTd l><b>{i < 3 && ["🥇", "🥈", "🥉"][i] + " "}{r.kid.name}</b> <span style={{ color: C.sub, fontSize: 12 }}>{open ? "▾" : "▸"}</span></TwTd>
                            <TwTd>{r.tage}</TwTd>
                            <TwTd style={{ fontFamily: display, fontWeight: 700, fontSize: 22, color: C.play }}>{r.total}</TwTd>
                          </tr>
                          {open && (
                            <tr style={{ background: C.playSoft }}><TwTd l colSpan={4}>
                              <div style={{ display: "flex", flexWrap: "wrap", gap: 6, padding: "2px 0 6px" }}>
                                {r.entries.map((en, ix) => (
                                  <span key={en.eventId} style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 20, padding: "4px 10px", fontSize: 12.5, display: "inline-flex", alignItems: "center", gap: 6, opacity: r.counted.has(ix) ? 1 : 0.55 }}>
                                    {en.placement === 1 ? "🥇" : en.placement === 2 ? "🥈" : en.placement === 3 ? "🥉" : "•"} <b>{en.ort || "Station"}</b>
                                    <span style={{ color: C.play, fontWeight: 700 }}>+{en.pts}</span>
                                    {!r.counted.has(ix) && <span style={{ color: C.sub }}>(zählt nicht)</span>}
                                  </span>
                                ))}
                              </div>
                            </TwTd></tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </TwSection>

        {/* STATIONEN */}
        <TwSection id="tw-stationen" eyebrow="Wo gespielt wurde" title="Stationen">
          {tour.events.length === 0 ? (
            <Card><div style={{ textAlign: "center", padding: "24px 10px", color: C.sub }}>Noch keine Stationen erfasst.</div></Card>
          ) : (
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(230px,1fr))", gap: 14 }}>
              {stations.map(({ event, winner, count }, i) => (
                <div key={event.id} className="tw-stat" style={{ background: C.card, border: `1px solid ${C.line}`, borderRadius: 16, overflow: "hidden" }}>
                  <div style={{ background: `linear-gradient(135deg, ${C.water}, #1c6ea3)`, color: "#fff", padding: "14px 16px" }}>
                    <div style={{ fontSize: 12, opacity: 0.9, textTransform: "uppercase", letterSpacing: .5 }}>Station {i + 1}{event.datum ? ` · ${event.datum}` : ""}</div>
                    <div style={{ fontFamily: display, fontWeight: 700, fontSize: 24, textTransform: "uppercase", lineHeight: 1.05 }}>{event.ort || "Station"}</div>
                  </div>
                  <div style={{ padding: "12px 16px" }}>
                    {winner && <div style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#FFF6DE", border: "1px solid #F0DFA8", color: "#8A6A12", borderRadius: 20, padding: "4px 12px", fontSize: 13, fontWeight: 700, marginBottom: 8 }}>🥇 {winner.name}</div>}
                    <div style={{ color: C.sub, fontSize: 13 }}>{count} Kind{count === 1 ? "" : "er"} am Start</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </TwSection>
      </main>

      {/* FOOTER */}
      <footer style={{ borderTop: `1px solid ${C.line}`, background: C.card }}>
        <div style={{ maxWidth: 1000, margin: "0 auto", padding: "28px 20px", display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
          <img src={LOGO_GREEN} alt={BRAND} style={{ height: 26 }} />
          <span style={{ color: C.sub, fontSize: 13 }}>Öffentliche Tour-Seite · {BRAND}</span>
          <span style={{ marginLeft: "auto", color: C.sub, fontSize: 12.5 }}>{isEmpty ? "Noch keine Ergebnisse" : "Aktueller Stand"}</span>
        </div>
      </footer>
    </div>
  );
}

/* ---------- Tour-Website-Helfer (Tw…-präfixiert) ---------- */
function TwSection({ id, eyebrow, title, children }) {
  return (
    <section id={id} style={{ padding: "40px 0", scrollMarginTop: 70, borderBottom: `1px solid ${C.line}` }}>
      <div style={{ marginBottom: 22 }}>
        <div style={{ fontFamily: display, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", fontSize: 13, color: C.play }}>{eyebrow}</div>
        <h2 style={{ fontFamily: display, fontWeight: 700, textTransform: "uppercase", letterSpacing: .5, fontSize: "clamp(28px,4vw,44px)", margin: "4px 0 0" }}>{title}</h2>
      </div>
      {children}
    </section>
  );
}
function TwPodium({ ranking }) {
  const top = ranking.slice(0, 3);
  if (!top.length) return null;
  const order = [top[1], top[0], top[2]].filter(Boolean);
  const heights = { 0: 100, 1: 72, 2: 54 };
  const medal = ["🥇", "🥈", "🥉"];
  const ring = [C.gold, C.silver, C.bronze];
  return (
    <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "center", gap: "clamp(10px,3vw,30px)" }}>
      {order.map((r) => {
        const place = ranking.indexOf(r);
        return (
          <div key={r.kid.id} style={{ textAlign: "center", flex: "0 1 190px" }}>
            <div style={{ fontSize: "clamp(26px,5vw,40px)", marginBottom: 4 }}>{medal[place]}</div>
            <div style={{ width: "clamp(44px,7vw,60px)", height: "clamp(44px,7vw,60px)", margin: "0 auto 8px", borderRadius: "50%", background: C.playSoft, border: `3px solid ${ring[place]}`, display: "grid", placeItems: "center", fontFamily: display, fontWeight: 700, fontSize: "clamp(18px,3vw,26px)", color: C.playDeep }}>{r.kid.name[0]}</div>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(15px,2vw,20px)", textTransform: "uppercase", lineHeight: 1 }}>{r.kid.name}</div>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: "clamp(20px,3vw,28px)", color: C.play }}>{r.total}<span style={{ fontSize: 12, color: C.sub, fontWeight: 600 }}> Pkt</span></div>
            <div style={{ height: heights[place], background: `linear-gradient(180deg, ${C.play}, ${C.playSoft})`, borderRadius: "10px 10px 0 0", marginTop: 10, border: `1px solid ${C.line}`, borderBottom: "none", position: "relative" }}>
              <div style={{ position: "absolute", top: 8, left: 0, right: 0, textAlign: "center", fontFamily: display, fontWeight: 700, fontSize: 24, color: "#fff" }}>{place + 1}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
function TwTh({ children, l }) { return <th style={{ padding: "8px 10px", fontWeight: 600, textAlign: l ? "left" : "right" }}>{children}</th>; }
function TwTd({ children, l, colSpan, style }) { return <td colSpan={colSpan} style={{ padding: "8px 10px", textAlign: l ? "left" : "right", fontSize: 14, ...style }}>{children}</td>; }
const twBtnPrimary = { border: "none", background: C.play, color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 16, padding: "11px 20px", borderRadius: 11, cursor: "pointer", letterSpacing: .5, textTransform: "uppercase" };
const twBtnGhost = { border: `1.5px solid ${C.line}`, background: C.card, color: C.ink, fontFamily: display, fontWeight: 700, fontSize: 16, padding: "11px 20px", borderRadius: 11, cursor: "pointer", letterSpacing: .5, textTransform: "uppercase" };

/* =====================================================================
   VIEW: SIEGEREHRUNG-TOUR (Einzel-KO / Tour)  (eingehängter Baustein ·
   letzter der 15 Bausteine)
   Portiert aus siegerehrung-tour.jsx — eigenes Theme, Fonts, Logo und Demo-
   Kinder (START_KIDS) raus; alles über den Store. Analog zu Siegerehrung()
   (Team-Version), aber Urkunden für EINZELNE KINDER statt Teams:
     · Endstand   → tourStandings(tour) — dieselbe Ableitung wie
       Tour-Rangliste/Tour-Website, keine zweite Kopie.
     · Medaillen für ALLE = tour.kids.length (jedes Kind, das je an einer
       Station teilgenommen hat).
     · Eine Urkunde je Kind (Platz OHNE „von N"), plus frei definierbare
       Sonderpreise.
   Store-Entscheidung (bewusst getroffen): Team- und Tour-Sonderpreise sind
   ZWEI parallele, aber eigenständige Wahrheiten — state.awards (verweist auf
   Teams) bleibt unverändert der Team-Siegerehrung vorbehalten, state.tourAwards
   (verweist auf Kids) ist die neue, gleich aufgebaute Wahrheit hier
   (tourAward/add · tourAward/remove · tourAward/patch, Helfer makeTourAward —
   identisches Muster zu award/add, award/remove, award/patch, makeAward, nur
   andere Empfänger-Domäne, da Team- und Tour-Sonderpreise sich inhaltlich
   nicht decken müssen).
   Titel/Zeitraum kommen aus der Tour selbst (tour.name/tour.zeitraum) über
   die neue Action tour/patchMeta (analog zu meta/patch) — dieselbe Tour-
   Wahrheit, die auch Tour-Rangliste/Tour-Website lesen.
   Drucken über den Browser (@media print, wie Siegerehrung()). Nur-Headcoach.
   Helfer St…-präfixiert.
   ===================================================================== */
function SiegerehrungTour() {
  const { state, dispatch } = useStore();
  const { tour, tourAwards } = state;

  // Endstand: read-only aus tourStandings — dieselbe Rechnung wie Tour-Rangliste/Tour-Website.
  const ranked = useMemo(() => tourStandings(tour), [tour]);
  const N = ranked.length;
  const placeOf = (id) => ranked.findIndex((r) => r.kid.id === id) + 1;
  const kidById = (id) => tour.kids.find((k) => k.id === id);
  // Medaillen für ALLE Kinder, die je an einer Station teilgenommen haben.
  const medals = tour.kids.length;

  const setMeta = (patch) => dispatch({ type: "tour/patchMeta", patch });
  const patchPrize = (id, patch) => dispatch({ type: "tourAward/patch", id, patch });

  const print = () => { try { window.print(); } catch (_) {} };

  return (
    <div>
      <style>{`
        .st-in{border:1px solid ${C.line};border-radius:9px;padding:8px 10px;font-family:${font};font-size:14px;color:${C.ink};background:#fff;}
        .st-in:focus{outline:none;border-color:${C.play};}
        .st-certs{display:grid;grid-template-columns:repeat(auto-fit,minmax(360px,1fr));gap:18px;}
        @media print {
          .st-noprint{display:none !important;}
          body *{visibility:hidden;}
          .st-certs, .st-certs *{visibility:visible;}
          .st-certs{position:absolute;left:0;top:0;width:100%;display:block;margin:0;padding:0;}
          .st-cert{break-after:page;page-break-after:always;box-shadow:none !important;border:1px solid #ccc !important;margin:0;}
          .st-cert:last-child{break-after:auto;page-break-after:auto;}
          @page{size:A4 landscape;margin:14mm;}
        }
      `}</style>

      {/* Kopf (konsistent mit den anderen Bausteinen) */}
      <div className="st-noprint" style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
        <div style={{ width: 44, height: 44, borderRadius: 12, background: C.play, display: "grid", placeItems: "center", fontSize: 22, flexShrink: 0 }}>🎖️</div>
        <div style={{ flex: 1 }}>
          <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: 0 }}>Siegerehrung · Tour</h2>
          <div style={{ fontSize: 13, color: C.sub }}>Medaillen für alle · eine Urkunde je Kind · Sonderpreise</div>
        </div>
        <button onClick={print} style={{ border: "none", background: C.play, color: "#fff", fontFamily: display, fontWeight: 700, fontSize: 15, padding: "10px 18px", borderRadius: 11, cursor: "pointer", letterSpacing: 0.5, textTransform: "uppercase" }}>🖨 Alle Urkunden drucken</button>
      </div>

      {/* SETUP */}
      <div className="st-noprint">
        <Card>
          <div style={{ fontFamily: display, fontWeight: 700, fontSize: 13, letterSpacing: 1, textTransform: "uppercase", color: C.sub, marginBottom: 14 }}>Tour</div>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
            <input className="st-in" style={{ flex: 1, minWidth: 220, fontFamily: display, fontWeight: 700, fontSize: 18 }} value={tour.name} onChange={(e) => setMeta({ name: e.target.value })} placeholder="Tour-Name" />
            <input className="st-in" style={{ minWidth: 140, fontFamily: display, fontWeight: 700 }} value={tour.zeitraum || ""} onChange={(e) => setMeta({ zeitraum: e.target.value })} placeholder="Zeitraum (z. B. Juli 2026)" />
            <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: C.playSoft, border: `1px solid ${C.play}`, color: C.fair, borderRadius: 999, padding: "8px 14px", fontWeight: 700, fontSize: 14 }}>🏅 {medals} Medaillen — für alle Kinder</div>
          </div>
          <div style={{ marginTop: 12, fontSize: 12, color: C.sub }}>
            Titel und Zeitraum sind die Tour-Info (die auch Tour-Rangliste &amp; Tour-Website nutzen). Der Endstand kommt aus der Tour-Rangliste — hier nur zum Anzeigen.
          </div>
        </Card>

        {/* SONDERPREISE bearbeiten (tourAward/*) */}
        <div style={{ marginTop: 14 }}>
          <Card>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: 13, letterSpacing: 1, textTransform: "uppercase", color: C.sub, marginBottom: 14 }}>Sonderpreise</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {tourAwards.map((p) => (
                <div key={p.id} style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                  <input className="st-in" value={p.emoji} onChange={(e) => patchPrize(p.id, { emoji: e.target.value })} style={{ width: 52, textAlign: "center", fontSize: 18 }} />
                  <input className="st-in" value={p.title} onChange={(e) => patchPrize(p.id, { title: e.target.value })} style={{ flex: 1, minWidth: 150, fontWeight: 600 }} />
                  <select className="st-in" value={p.kidId ?? ""} onChange={(e) => patchPrize(p.id, { kidId: e.target.value ? +e.target.value : null })} style={{ minWidth: 170 }}>
                    <option value="">— (frei / kein Kind)</option>
                    {tour.kids.map((k) => <option key={k.id} value={k.id}>{k.name}</option>)}
                  </select>
                  <button onClick={() => dispatch({ type: "tourAward/remove", id: p.id })} style={{ border: "none", background: "none", color: C.sub, cursor: "pointer", fontSize: 20, lineHeight: 1 }} title="Sonderpreis entfernen">×</button>
                </div>
              ))}
              {tourAwards.length === 0 && <div style={{ fontSize: 13, color: C.sub }}>Noch keine Sonderpreise — leg unten welche an.</div>}
            </div>
            <button onClick={() => dispatch({ type: "tourAward/add" })} style={{ ...stBtnGhost, marginTop: 12, padding: "8px 14px" }}>+ Sonderpreis</button>
            <div style={{ fontSize: 12, color: C.sub, marginTop: 10 }}>Frei definierbar — jeder Sonderpreis wird als eigene Urkunde gedruckt. Ohne Kind bleibt das Empfänger-Feld auf der Urkunde leer.</div>
          </Card>
        </div>

        {/* ABLAUF */}
        <div style={{ marginTop: 14 }}>
          <Card>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: 13, letterSpacing: 1, textTransform: "uppercase", color: C.sub, marginBottom: 14 }}>Ablauf der Ehrung</div>
            <ol style={{ margin: 0, paddingLeft: 20, color: C.ink, fontSize: 14, lineHeight: 1.9 }}>
              <li><b>Medaillen an alle</b> — jedes Kind kommt nach vorn und bekommt seine Medaille ({medals} insgesamt).</li>
              <li><b>Sonderpreise</b> — {tourAwards.length} Auszeichnung{tourAwards.length === 1 ? "" : "en"} überreichen{tourAwards.length ? ` (${tourAwards.map((p) => p.emoji).join(" ")})` : ""}.</li>
              <li><b>Urkunden je Kind</b> — von Platz {N} rückwärts bis Platz 1 aufrufen.</li>
            </ol>
          </Card>
        </div>

        <div style={{ fontFamily: display, fontWeight: 700, fontSize: 22, textTransform: "uppercase", letterSpacing: 0.5, margin: "26px 0 4px" }}>Vorschau — so wird gedruckt</div>
        <div style={{ color: C.sub, fontSize: 13, marginBottom: 14 }}>Jede Urkunde landet auf einer eigenen Seite (A4 quer). Sonderpreise zuerst, dann jedes Kind.</div>
      </div>

      {/* DRUCKBEREICH: Urkunden */}
      <div className="st-certs">
        {tourAwards.map((p) => {
          const k = p.kidId != null ? kidById(p.kidId) : null;
          return <StCertificate key={"p" + p.id} kind="prize" tour={tour} kid={k} prize={p} />;
        })}
        {ranked.map((r) => (
          <StCertificate key={"k" + r.kid.id} kind="kid" tour={tour} kid={r.kid} tage={r.tage} total={r.total} place={placeOf(r.kid.id)} />
        ))}
      </div>
    </div>
  );
}

/* ---------- Urkunde (St…) ---------- */
function StRibbon({ color = C.gold }) {
  return (
    <svg width="60" height="76" viewBox="0 0 60 76" aria-hidden="true">
      <path d="M20 44 L12 74 L26 66 L30 76 L34 66 L48 74 L40 44 Z" fill={color} opacity="0.9" />
      <circle cx="30" cy="26" r="24" fill="#fff" stroke={color} strokeWidth="4" />
      <circle cx="30" cy="26" r="16" fill={color} opacity="0.15" />
      <text x="30" y="34" textAnchor="middle" fontSize="24">🏅</text>
    </svg>
  );
}
function StChip({ c, label, v, strong }) {
  return (
    <div style={{ background: strong ? c : "#fff", border: `1.5px solid ${c}`, color: strong ? "#fff" : C.ink, borderRadius: 10, padding: "6px 12px", display: "flex", alignItems: "baseline", gap: 6 }}>
      <b style={{ fontFamily: display, fontSize: 20 }}>{v}</b>
      <span style={{ fontSize: 11.5, color: strong ? "rgba(255,255,255,.85)" : C.sub }}>{label}</span>
    </div>
  );
}
function StCertificate({ kind, tour, kid, prize, place, tage, total }) {
  const ribbon = place === 1 ? C.gold : place === 2 ? C.silver : place === 3 ? C.bronze : C.play;
  const medalTxt = place === 1 ? "🥇 Platz 1" : place === 2 ? "🥈 Platz 2" : place === 3 ? "🥉 Platz 3" : `Platz ${place}`;
  return (
    <div className="st-cert" style={{ background: C.paper, border: `1px solid ${C.line}`, borderRadius: 16, padding: 4, boxShadow: "0 8px 26px rgba(19,36,28,.10)" }}>
      <div style={{ border: `2px solid ${kind === "prize" ? C.play : ribbon}`, borderRadius: 10, padding: "26px 30px", height: "100%", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", top: -40, right: -40, width: 120, height: 120, borderRadius: "50%", background: C.water, opacity: 0.08 }} />

        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
          <img src={LOGO_GREEN} alt={BRAND} style={{ height: 26 }} />
          <div style={{ marginLeft: "auto", textAlign: "right", fontSize: 12, color: C.sub }}>
            <div style={{ fontWeight: 700, color: C.ink }}>{tour.name}</div>
            {tour.zeitraum && <div>{tour.zeitraum}</div>}
          </div>
        </div>

        <div style={{ fontFamily: display, fontWeight: 700, letterSpacing: 4, textTransform: "uppercase", color: C.play, fontSize: 15 }}>
          {kind === "prize" ? "Sonderpreis" : "Urkunde"}
        </div>

        {kind === "prize" ? (
          <>
            <div style={{ fontSize: 54, margin: "8px 0 2px" }}>{prize.emoji}</div>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: 40, textTransform: "uppercase", lineHeight: 1 }}>{prize.title}</div>
            <div style={{ color: C.sub, fontSize: 14, margin: "14px 0 4px" }}>{kid ? "verliehen an" : " "}</div>
          </>
        ) : (
          <>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: 44, textTransform: "uppercase", lineHeight: 1, marginTop: 4 }}>{medalTxt}</div>
            <div style={{ color: C.sub, fontSize: 14, margin: "14px 0 4px" }}>verliehen an</div>
          </>
        )}

        {kid ? (
          <div style={{ display: "flex", alignItems: "center", gap: 14, margin: "2px 0 10px" }}>
            <div style={{ width: 56, height: 56, borderRadius: "50%", background: C.playSoft, border: `3px solid ${C.play}`, display: "grid", placeItems: "center", fontFamily: display, fontWeight: 700, fontSize: 26, color: C.playDeep, flexShrink: 0 }}>{kid.name[0]}</div>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: 40, textTransform: "uppercase", lineHeight: 1 }}>{kid.name}</div>
            {kind !== "prize" && <div style={{ marginLeft: "auto" }}><StRibbon color={ribbon} /></div>}
          </div>
        ) : (
          <div style={{ margin: "2px 0 10px", height: 44, borderBottom: `2px dashed ${C.line}` }} />
        )}

        {kind === "kid" && (
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", margin: "6px 0 14px" }}>
            <StChip c={C.play} label="Punkte" v={total} strong />
            <StChip c={C.water} label="Tage dabei" v={tage} />
          </div>
        )}

        <div style={{ color: C.ink, fontSize: 14.5, fontStyle: "italic", marginTop: kind === "prize" ? 18 : 4 }}>
          {kind === "prize" ? "Für einen ganz besonderen Beitrag zur Tour." : "Für faires Spiel und tolle Einsätze über die ganze Tour."}
        </div>

        <div style={{ display: "flex", alignItems: "flex-end", gap: 20, marginTop: 22, flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: 140 }}>
            <div style={{ borderTop: `1.5px solid ${C.ink}`, paddingTop: 4, fontSize: 12.5, color: C.sub }}>Turnierleitung</div>
          </div>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: C.playSoft, border: `1px solid ${C.play}`, color: C.fair, borderRadius: 999, padding: "6px 14px", fontSize: 12.5, fontWeight: 700 }}>🏅 Alle bekommen eine Medaille</div>
        </div>
      </div>
    </div>
  );
}
const stBtnGhost = { border: `1.5px solid ${C.line}`, background: "#fff", color: C.ink, fontFamily: display, fontWeight: 700, fontSize: 15, padding: "10px 16px", borderRadius: 10, cursor: "pointer", letterSpacing: 0.5 };


/* =====================================================================
   STAND 34 — MEHRERE EVENTS (Konzept §10, Schritt a + Einstieg)
   ---------------------------------------------------------------------
   Formate sind fix, EVENTS sind die Arbeitseinheit. Jedes Event hat eine
   eigene ID und eigene Daten auf dem Server (append-only, jede Version
   bleibt) — ein Event kann nie ein anderes überschreiben.

   Ablauf: EventGate -> (kein Event gewählt) EventListe ("Heute": laufende
   Events, + Neues Event, Archiv, Büro) -> Event gewählt -> StoreProvider
   NUR für dieses Event -> wie bisher Startseite/Login mit den Codes
   (PINs) DIESES Events -> Shell.

   Event e1 = das bisherige, einzige Turnier (alle alten Stände wurden
   beim Server-Start automatisch e1 zugeordnet; alte Geräte/Links laufen
   über die Alt-Endpunkte weiter auf e1).
   ===================================================================== */
const LEGACY_EVENT_ID = "e1";
const EVENT_PICK_KEY = "microsoccer_event_v1";
const EventNavContext = createContext(null);
const useEventNav = () => useContext(EventNavContext);

// Aktuelles Event für Links (Einladungen), von StoreProvider/EventGate gesetzt.
let ACTIVE_EVENT_ID = null;
function inviteUrl(token) {
  const ev = ACTIVE_EVENT_ID ? `event=${encodeURIComponent(ACTIVE_EVENT_ID)}&` : "";
  return `${window.location.origin}${window.location.pathname}?${ev}invite=${token}`;
}

function lsGet(k) { try { return window.localStorage.getItem(k); } catch (_) { return null; } }
function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (_) { /* noop */ } }
function lsDel(k) { try { window.localStorage.removeItem(k); } catch (_) { /* noop */ } }

// Welches Event beim Start? 1) ?event= in der Adresse (geteilter Link,
// Reload) · 2) alter Einladungslink ohne Event -> e1 · 3) zuletzt auf diesem
// Gerät gewähltes Event · 4) Gerät war vor Stand 34 schon eingeloggt -> e1 ·
// sonst Event-Liste.
function initialEventId() {
  let params;
  try { params = new URLSearchParams(window.location.search); } catch (_) { params = new URLSearchParams(""); }
  if (params.has("buero")) return null; // Stand 37t: Büro-Direktlink → nie in ein gemerktes Event springen
  const fromUrl = params.get("event");
  if (fromUrl) return fromUrl;
  if (params.get("invite")) return LEGACY_EVENT_ID;
  const remembered = lsGet(EVENT_PICK_KEY);
  if (remembered) return remembered;
  if (lsGet(LOCAL_SESSION_KEY)) return LEGACY_EVENT_ID;
  return null;
}
function setUrlEvent(eventId) {
  try {
    const url = new URL(window.location.href);
    url.search = eventId ? `?event=${encodeURIComponent(eventId)}` : "";
    window.history.replaceState(null, "", url.toString());
  } catch (_) { /* noop */ }
}

function makeEventPins() {
  const rnd = () => {
    try { const a = new Uint32Array(1); window.crypto.getRandomValues(a); return a[0] % 10000; }
    catch (_) { return Math.floor(Math.random() * 10000); }
  };
  const fmt = (n) => String(n).padStart(4, "0");
  const headcoach = fmt(rnd());
  let coach = fmt(rnd());
  while (coach === headcoach) coach = fmt(rnd());
  let team = fmt(rnd()); // Stand 37p: Team-Handys kommen nur mit dem Team-Code ins Event
  while (team === headcoach || team === coach) team = fmt(rnd());
  return { headcoach, coach, team };
}
function todayIso() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
function fmtEventDate(datum) {
  if (!datum) return "";
  try { return new Date(datum).toLocaleDateString("de-DE", { day: "numeric", month: "short", year: "numeric" }); } catch (_) { return datum; }
}

// Code aus dem persönlichen Link EINMAL beim Laden merken (die Adresszeile wird danach bereinigt)
let _linkCode = (() => { try { const c = new URLSearchParams(window.location.search).get("code"); return c && /^\d{4,8}$/.test(c) ? c : null; } catch (_) { return null; } })();
function linkCode() { return _linkCode; }
function linkCodeVerbraucht() { _linkCode = null; }
function EventGate() {
  const [eventId, setEventId] = useState(() => initialEventId());
  const [intent, setIntent] = useState(null); // Stand 35: Absicht aus der Kachel-Uebersicht
  // Stand 37v: Einstiegs-Code (persönlicher Link ?event=…&code=… oder Code-Feld) -- wird im Login einmal eingelöst
  const [code, setCode] = useState(() => (initialEventId() && linkCode()) || null);
  useEffect(() => { if (linkCode()) { setUrlEvent(eventId); if (eventId) linkCodeVerbraucht(); } }, []); // eslint-disable-line react-hooks/exhaustive-deps -- Code nicht in der Adresszeile lassen
  const codeVerbraucht = useCallback(() => setCode(null), []);
  const choose = useCallback((id, opts = {}) => {
    // Stand 39: Büro öffnet ein Event → Headcoach-Sitzung vom Server holen (sonst bekäme das Gerät nur die Ansicht ohne Ergebnisse)
    if (opts.bueroCode) { const { bueroCode, ...rest } = opts; bueroSitzung(id, bueroCode).catch(() => null).finally(() => choose(id, rest)); return; }
    setIntent(opts.intent || null);
    setCode(opts.code || null);
    // Wer ein Event gerade selbst angelegt hat, ist dort Headcoach.
    if (opts.asHeadcoach) lsSet(sessionKey(id), JSON.stringify({ role: "headcoach", boundTeamId: null, boundDeviceId: null, view: "uebersicht" }));
    lsSet(EVENT_PICK_KEY, id);
    setUrlEvent(id);
    setEventId(id);
  }, []);
  const leave = useCallback(() => {
    lsDel(EVENT_PICK_KEY);
    setUrlEvent(null);
    setEventId(null);
  }, []);
  ACTIVE_EVENT_ID = eventId;
  useEffect(() => { uxKontext({ eventId: eventId || null }); }, [eventId]); // Stand 40
  const nav = useMemo(() => ({ eventId, choose, leave, intent, code, codeVerbraucht }), [eventId, choose, leave, intent, code, codeVerbraucht]);
  return (
    <EventNavContext.Provider value={nav}>
      {eventId
        ? <StoreProvider key={eventId} eventId={eventId}><Gate /></StoreProvider>
        : <EventListe />}
    </EventNavContext.Provider>
  );
}

function EventNotFound({ eventId }) {
  const nav = useEventNav();
  return (
    <div style={{ background: C.chalk, minHeight: "100vh", fontFamily: font, color: C.ink, display: "grid", placeItems: "center", padding: 20 }}>
      <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
      <div style={{ maxWidth: 420, textAlign: "center" }}>
        <div style={{ fontSize: 34 }}>🔎</div>
        <h1 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: "10px 0 6px" }}>Event nicht gefunden</h1>
        <p style={{ color: C.sub, fontSize: 14.5, lineHeight: 1.5, margin: "0 0 20px" }}>Dieses Event gibt es nicht (mehr) — vielleicht wurde es vom Büro gelöscht oder der Link ist unvollständig.</p>
        {nav && <button onClick={nav.leave} style={{ border: "none", background: C.play, color: "#fff", borderRadius: 12, padding: "13px 20px", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: display, letterSpacing: 0.5 }}>Zur Event-Liste →</button>}
        <div style={{ fontSize: 11.5, color: C.sub, marginTop: 14 }}>Event-ID: {eventId}</div>
      </div>
    </div>
  );
}

// Neues Event anlegen: Format (fix, Firmenstandard) + Name + Ort + Datum.
// Baut den Anfangsstand aus blankState() — mit eigenen Zugangs-Codes für
// genau dieses Event (ersetzt die festen PINs 4711/2468).
/* Stand 37u — EIN Ort für den Anfangsstand eines neuen Events. Benutzt vom Büro-Dialog (unten) UND vom Server
   (POST /api/events/aus-buchung lädt dafür public/anfangsstand.cjs, das beim Build aus dieser Datei entsteht).
   Keine Browser-Abhängigkeiten hier drin (kein window/document), damit es auch in Node läuft. */
export function formatInfo(id) {
  const f = formatById(id);
  return f ? { id: f.id, label: f.label, bereich: f.bereich, kind: f.kind, tiefe: f.tiefe || "schlank", ablauf: f.ablauf || null, tourUeberEvents: TOUR_UEBER_EVENTS.includes(f.id) } : null;
}
/* Stand 38 — Katalog (Schnittstellen-Vertrag §2): Dauer, Größe und Ablauf eines Formats kommen aus dem Playmaker-Katalog.
   Beim Anlegen wird der passende Eintrag eingefroren (meta.katalog + meta.katalogVersion). Fehlt der Katalog, bleibt alles wie bisher. */
const KATALOG_ALIAS = { geburtstag: "kindergeburtstag" }; // Matchday-Format-ID → Katalog-ID (nur Namen, keine Zahlen)
export function katalogEintrag(katalog, format) {
  const liste = katalog && Array.isArray(katalog.formate) ? katalog.formate : [];
  return liste.find((e) => e && (e.id === format || e.matchdayFormat === format)) || liste.find((e) => e && e.id === KATALOG_ALIAS[format]) || null;
}
function katalogSchnappschuss(e) {
  if (!e) return null;
  const n = (x) => (Number.isFinite(Number(x)) && x !== null && x !== "" ? Number(x) : null);
  return { id: String(e.id || ""), name: (e.namen && (e.namen.de || e.namen.en)) || "", dauerMin: n(e.dauerMin), maxKinderProBox: n(e.maxKinderProBox),
    ablauf: Array.isArray(e.ablauf) ? e.ablauf.filter((x) => x && x.id).map((x) => ({ id: String(x.id), min: n(x.min) || 0, name: (x.namen && (x.namen.de || x.namen.en)) || String(x.id) })) : [] };
}
export function neuerEventStand({ format, title, ort, datum, startzeit = "", endzeit = "", traeger = "", projekt = "", standortId = null, ortId = null, tourKey = "", demo = false, vorgangId = "", katalog = null }, pins) {
  const s = blankState();
  const tour = TOUR_UEBER_EVENTS.includes(format) && tourKey ? tourKey : "";
  s.tournament.meta = { ...s.tournament.meta, title, ort, date: datum, format,
    ...(standortId ? { standortId } : {}), ...(ortId ? { ortId } : {}), ...(demo ? { demo: true } : {}), ...(tour ? { tourKey: tour } : {}),
    ...(vorgangId ? { vorgangId } : {}), ...(endzeit ? { endzeit } : {}),
    traeger: traeger || traegerVorschlag(format), projekt: projekt || "" };
  if (tour) s.tour = { ...s.tour, name: tour };
  s.tournament.pins = pins;
  const fDef = formatById(format);
  s.tournament.config = { ...s.tournament.config, context: fDef && fDef.bereich === "schule" ? "schule" : "individuell" };
  if (fDef && fDef.tiefe !== "voll") s.factors = { ...s.factors, fairplay: 0, aufgaben: 0 }; // schlank: nur Tore
  if (fDef && fDef.ablauf === "birthday") s.tournament.ablauf = BIRTHDAY_ABLAUF.map((ph) => ({ ...ph }));
  if (startzeit) s.tournament.meta.startzeit = startzeit;
  // Stand 38: Katalog-Schnappschuss (eingefroren). Ablauf nur bei Formaten mit Ablauf-Ansicht (Geburtstag) übernehmen.
  const kEintrag = katalogSchnappschuss(katalogEintrag(katalog, format));
  if (kEintrag) {
    s.tournament.meta.katalog = kEintrag;
    if (katalog && katalog.katalogVersion != null) s.tournament.meta.katalogVersion = katalog.katalogVersion;
    if (fDef && fDef.ablauf && kEintrag.ablauf.length) {
      const alt = Object.fromEntries(BIRTHDAY_ABLAUF.map((ph) => [ph.id, ph]));
      s.tournament.ablauf = kEintrag.ablauf.map((x) => ({ id: x.id, emo: (alt[x.id] && alt[x.id].emo) || "•", label: x.name, min: x.min, info: (alt[x.id] && alt[x.id].info) || "" }));
    }
  }
  return s;
}

/* Stand 38 — Eventbericht (Vertrag §6): Ergebnis aus derselben Wertung wie die App, OHNE Kindernamen.
   Team-Formate: Teamnamen-Reihenfolge nach Gesamtwertung. Einzel-/Tour-Formate: keine Platzierungen (das wären Kinder). */
export function berichtErgebnis(state) {
  const st = state || {};
  const t = st.tournament || {}, m = t.meta || {};
  const fDef = formatById(m.format);
  const kind = fDef ? fDef.kind : "team";
  const live = st.live || {};
  const rounds = Array.isArray(live.rounds) ? live.rounds : [];
  let spielrunden = rounds.filter((r) => r && r.done).length;
  const br = st.ko && st.ko.bracket;
  if (br && Array.isArray(br.rounds)) spielrunden += br.rounds.reduce((n, r) => n + (Array.isArray(r) ? r.filter((x) => x && x.done).length : 0), 0);
  const teams = Array.isArray(st.teams) ? st.teams : [];
  const f = st.factors || DEFAULT_FACTORS;
  let ergebnis = null, fairplay = null;
  if (kind === "team" && teams.length && spielrunden > 0) {
    const reihe = teams.map((tm) => ({ name: String(tm.name || ""), total: teamScore({ tore: 0, teamspielTore: 0, fpStars: 0, aufgabenDone: 0, ...tm }, f).total })).sort((a, b) => b.total - a.total);
    ergebnis = { sieger: reihe[0] ? reihe[0].name : null, platzierungen: reihe.map((x) => x.name) };
  }
  if (fDef && fDef.tiefe === "voll" && teams.length > 1) {
    const werte = teams.map((tm) => fpRecompute({ fpFrom: {}, ...tm }, teams)).filter((x) => x.submitted > 0).map((x) => x.stars / Math.max(1, FAIRPLAY_CRITERIA.length));
    if (werte.length) fairplay = { durchschnitt: Math.round((werte.reduce((a, b) => a + b, 0) / werte.length) * 10) / 10, skala: "0–5 je Kriterium" };
  }
  return { spielrunden, ergebnis, fairplay };
}

function NeuesEventDialog({ open, onClose, onCreated, initialFormat, projektListe = [], bueroCode = "" }) {
  const startFormate = FORMATE.filter((f) => f.kind === "team" || f.kind === "tour");
  const [format, setFormat] = useState(startFormate[0] ? startFormate[0].id : "");
  const [title, setTitle] = useState("");
  const [ort, setOrt] = useState("");
  const [datum, setDatum] = useState(todayIso());
  const [startzeit, setStartzeit] = useState("14:00");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(null); // { event, pins }
  const [demo, setDemo] = useState(false); // Stand 37: Demo-Event mit festen Demo-PINs
  const [tourKey, setTourKey] = useState(""); // Stand 37f: Station einer Tour
  const [traeger, setTraeger] = useState(""); // Stand 37g: "" = Vorschlag nach Format
  const [projekt, setProjekt] = useState("");
  // Stand 37q: Orte aus dem Büro (Standort -> Veranstaltungsort), sonst frei eintippen
  const [orte, setOrte] = useState([]);
  const [standortId, setStandortId] = useState("");
  const [ortId, setOrtId] = useState(""); // "" = neuer Ort (eintippen)
  const [ortSpeichernAls, setOrtSpeichernAls] = useState(""); // Stand 37r: "" = einmalig | "ort" | "collab"
  useEffect(() => {
    if (!open || !bueroCode) return;
    listOrte(bueroCode).then((l) => {
      const akt = l.filter((o) => o.aktiv); setOrte(akt);
      const st = akt.filter((o) => o.typ === "standort"); setStandortId(st.length === 1 ? st[0].id : ""); setOrtId("");
    }).catch(() => setOrte([]));
  }, [open, bueroCode]);
  const standorte = orte.filter((o) => o.typ === "standort");
  const standortOrte = orte.filter((o) => o.typ === "ort" && standortId && o.standortId === standortId);
  const collabs = orte.filter((o) => o.typ === "collab");
  const weitereOrte = orte.filter((o) => o.typ === "ort" && !o.standortId);
  const ortListe = [...standortOrte, ...collabs, ...weitereOrte];
  // Stand 37r: Afterwork/Business starten bei den Collab-Spaces, Touren beim einmaligen Ort
  // (nur vorschlagen, solange noch kein Ort gewählt ist -- eine Wahl wird beim Formatwechsel nie überschrieben)
  useEffect(() => { if (!ortId && ["afterwork", "business-cup"].includes(format) && collabs.length) setOrtId(collabs[0].id); }, [format, orte]); // eslint-disable-line react-hooks/exhaustive-deps
  const gewOrt = ortListe.find((o) => o.id === ortId) || null;
  const ortText = gewOrt ? [gewOrt.name, gewOrt.adresse].filter(Boolean).join(", ") : ort;
  const [touren, setTouren] = useState([]);
  useEffect(() => { if (open) listTours().then(setTouren).catch(() => setTouren([])); }, [open]);
  // Stand 38: Katalog (Playmaker) — der Server liefert live oder den letzten Schnappschuss; ohne Katalog bleibt alles wie bisher
  const [katalog, setKatalog] = useState(null);
  useEffect(() => { if (open && bueroCode) ladeKatalog(bueroCode).then(setKatalog).catch(() => setKatalog(null)); }, [open, bueroCode]);
  useEffect(() => {
    if (open) { setTitle(""); setOrt(""); setDatum(todayIso()); setErr(""); setBusy(false); setDone(null); setDemo(false); if (initialFormat) setFormat(initialFormat); }
  }, [open, initialFormat]);
  if (!open) return null;
  const canSubmit = !busy && title.trim().length > 0 && ortText.trim().length > 0 && !!format;
  const submit = async () => {
    setBusy(true); setErr("");
    try {
      // Stand 37q: neuen Ort gleich in die Orte-Liste übernehmen (wenn gewünscht)
      let oid = gewOrt ? gewOrt.id : null;
      if (!gewOrt && ortSpeichernAls && bueroCode && ort.trim()) {
        try { oid = (await createOrt({ typ: ortSpeichernAls, standortId: ortSpeichernAls === "ort" ? standortId || null : null, name: ort.trim() }, bueroCode)).id; } catch (_) { oid = null; }
      }
      const pins = demo ? { ...DEMO_PINS } : makeEventPins();
      // Stand 37u: dieselbe Funktion baut den Anfangsstand auch am Server (POST /api/events/aus-buchung)
      const s = neuerEventStand({ format, title: title.trim(), ort: ortText.trim(), datum, startzeit: (formatById(format) || {}).ablauf === "birthday" ? startzeit : "",
        traeger, projekt: projekt.trim(), standortId, ortId: oid, tourKey: tourKey.trim(), demo, katalog }, pins);
      const res = await createEvent({ title: title.trim(), ort: ortText.trim(), datum, format, state: s }, bueroCode);
      setDone({ event: res.event, pins });
    } catch (e) {
      setErr("Anlegen hat nicht geklappt — " + (e.serverMessage || e.message));
    } finally { setBusy(false); }
  };
  const inp = { width: "100%", border: `1px solid ${C.line}`, borderRadius: 10, padding: "10px 12px", fontSize: 15, fontFamily: font, marginBottom: 14, boxSizing: "border-box", background: "#fff", color: C.ink };
  const lbl = { display: "block", fontSize: 12.5, fontWeight: 600, color: C.sub, marginBottom: 6 };
  return (
    <div onClick={done ? undefined : onClose} style={{ position: "fixed", inset: 0, zIndex: 200, background: "rgba(18,36,28,.45)", display: "grid", placeItems: "center", padding: 16 }}>
      <div data-neues-event-dialog="true" onClick={(e) => e.stopPropagation()} style={{ background: C.card, borderRadius: 18, padding: 22, width: "100%", maxWidth: 440, maxHeight: "92vh", overflowY: "auto", boxShadow: "0 20px 60px rgba(19,36,28,.25)", fontFamily: font, color: C.ink }}>
        {done ? (
          <>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: 20, marginBottom: 6 }}>✅ Event angelegt</div>
            <div style={{ fontSize: 14, color: C.sub, lineHeight: 1.5, marginBottom: 14 }}>
              <b style={{ color: C.ink }}>{done.event.title}</b> · {done.event.ort}{done.event.datum ? ` · ${fmtEventDate(done.event.datum)}` : ""}<br />
              Gib dem Headcoach den Headcoach-Code, den Coaches den Coach-Code. Spielen und Zählen geht sofort; öffentlich wird es erst nach Freigabe.
            </div>
            <div data-neue-codes="true" style={{ background: C.playSoft, borderRadius: 12, padding: "12px 14px", marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Zugangs-Codes — bitte notieren</div>
              <div style={{ display: "flex", gap: 18, flexWrap: "wrap", fontSize: 14.5 }}>
                <span>🎽 Headcoach: <b data-code-headcoach style={{ fontFamily: display, fontSize: 20, letterSpacing: 2 }}>{done.pins.headcoach}</b></span>
                <span>🧢 Coach: <b data-code-coach style={{ fontFamily: display, fontSize: 20, letterSpacing: 2 }}>{done.pins.coach}</b></span>
                {done.pins.team && (formatById(format) || {}).tiefe === "voll" && <span>📱 Team: <b data-code-team style={{ fontFamily: display, fontSize: 20, letterSpacing: 2 }}>{done.pins.team}</b></span>}
              </div>
              <div style={{ fontSize: 12, color: C.sub, marginTop: 6 }}>Du findest sie jederzeit im Büro unter „🔑 Codes" beim Event — und im Event unter „Jetzt", dort auch den Gäste-QR für Zuschauer:innen.</div>
            </div>
            <button onClick={() => onCreated(done.event)} style={{ width: "100%", border: "none", background: C.play, color: "#fff", borderRadius: 10, padding: "12px", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: display, letterSpacing: 0.5 }}>Zum Event →</button>
          </>
        ) : (
          <>
            <div style={{ fontFamily: display, fontWeight: 700, fontSize: 20, marginBottom: 4 }}>🆕 Neues Event anlegen</div>
            <div style={{ fontSize: 13, color: C.sub, marginBottom: 16, lineHeight: 1.5 }}>Format wählen, Name und Ort sind Pflicht — damit ihr das Event später im Archiv wiedererkennt.</div>
            <label style={lbl}>Format</label>
            <select data-event-format value={format} onChange={(e) => setFormat(e.target.value)} style={inp}>
              {["schule", "freizeit", "business"].map((b) => (
                <optgroup key={b} label={BEREICHE[b].title}>
                  {startFormate.filter((f) => f.bereich === b).map((f) => <option key={f.id} value={f.id}>{f.emo} {f.label}</option>)}
                </optgroup>
              ))}
            </select>
            <label style={lbl}>Name des Events</label>
            <input data-event-title autoFocus value={title} onChange={(e) => setTitle(e.target.value)} placeholder="z. B. Herbstturnier VS Wasnergasse" style={inp} />
            {standorte.length > 0 && (<>
              <label style={lbl}>🏠 Homebase</label>
              <select data-event-standort value={standortId} onChange={(e) => { setStandortId(e.target.value); setOrtId(""); }} style={inp}>
                <option value="">— keine Homebase —</option>
                {standorte.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
              </select>
            </>)}
            <label style={lbl}>Ort</label>
            {ortListe.length > 0 && (
              <select data-event-ortwahl value={ortId} onChange={(e) => setOrtId(e.target.value)} style={inp}>
                <option value="">⚡ Pop-up-Pitch (einmalig, eintippen) …</option>
                {standortOrte.length > 0 && <optgroup label={`🏠 ${(standorte.find((x) => x.id === standortId) || {}).name || "Standort"}`}>{standortOrte.map((o) => <option key={o.id} value={o.id}>{o.name}{o.art ? ` · ${ART_LABEL[o.art] || o.art}` : ""}</option>)}</optgroup>}
                {collabs.length > 0 && <optgroup label="🤝 Collab-Spaces">{collabs.map((o) => <option key={o.id} value={o.id}>{o.name}{o.art ? ` · ${ART_LABEL[o.art] || o.art}` : ""}</option>)}</optgroup>}
                {weitereOrte.length > 0 && <optgroup label="Weitere Orte">{weitereOrte.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}</optgroup>}
              </select>
            )}
            {!gewOrt && (<>
              <input data-event-ort value={ort} onChange={(e) => setOrt(e.target.value)} placeholder="z. B. VS Wasnergasse, Wien" style={inp} />
              {bueroCode && ort.trim() && (
                <label style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12.5, color: C.sub, margin: "-8px 0 14px", flexWrap: "wrap" }}>
                  Kommt wieder?
                  <select data-event-ort-speichern value={ortSpeichernAls} onChange={(e) => setOrtSpeichernAls(e.target.value)} style={{ border: `1px solid ${C.line}`, borderRadius: 8, padding: "4px 6px", fontFamily: font, fontSize: 12.5 }}>
                    <option value="">Nein, Pop-up-Pitch (einmalig)</option>
                    {standortId && <option value="ort">{`Ja, als Ort bei ${(standorte.find((x) => x.id === standortId) || {}).name || "Standort"}`}</option>}
                    <option value="collab">Ja, als Collab-Space</option>
                  </select>
                </label>
              )}
            </>)}
            <label style={lbl}>Träger & Projekt / Förderung</label>
            <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
              <select data-event-traeger value={traeger || traegerVorschlag(format)} onChange={(e) => setTraeger(e.target.value)} style={{ ...inp, marginBottom: 0, width: 120, flex: "none" }}>
                {Object.entries(TRAEGER).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
              </select>
              <input data-event-projekt list="ms-projekte" value={projekt} onChange={(e) => setProjekt(e.target.value)} placeholder="z. B. SBS #1700 (optional)" style={{ ...inp, marginBottom: 0 }} />
              <datalist id="ms-projekte">{(projektListe || []).map((p) => <option key={p} value={p} />)}</datalist>
            </div>
            <label style={lbl}>Datum</label>
            <input data-event-datum type="date" value={datum} onChange={(e) => setDatum(e.target.value)} style={inp} />
            {(formatById(format) || {}).ablauf === "birthday" && (<>
              <label style={lbl}>Startzeit</label>
              <input data-event-startzeit type="time" value={startzeit} onChange={(e) => setStartzeit(e.target.value)} style={inp} />
            </>)}
            {TOUR_UEBER_EVENTS.includes(format) && (<>
              <label style={lbl}>Gehört zur Tour (alle Stationen zählen zusammen)</label>
              <input data-event-tour list="ms-touren" value={tourKey} onChange={(e) => setTourKey(e.target.value)} placeholder="z. B. Bädertour 2027 — leer = eigene Rangliste" style={inp} />
              <datalist id="ms-touren">{touren.map((t) => <option key={t.name} value={t.name}>{t.stationen} Stationen</option>)}</datalist>
            </>)}
            <label data-event-demo style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13.5, marginBottom: 14, cursor: "pointer" }}>
              <input type="checkbox" checked={demo} onChange={(e) => setDemo(e.target.checked)} />
              <span>🧪 Demo-Event <span style={{ color: C.sub }}>(feste Demo-PINs {DEMO_PINS.headcoach} / {DEMO_PINS.coach}, werden beim Login angezeigt)</span></span>
            </label>
            {err && <div style={{ color: C.whistle, fontSize: 13, marginBottom: 12 }}>{err}</div>}
            <div style={{ display: "flex", gap: 10 }}>
              <button onClick={onClose} style={{ flex: 1, border: `1px solid ${C.line}`, background: "#fff", color: C.ink, borderRadius: 10, padding: "11px", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: font }}>Abbrechen</button>
              <button data-event-anlegen disabled={!canSubmit} onClick={submit}
                style={{ flex: 2, border: "none", background: canSubmit ? C.play : "#C7D3CC", color: "#fff", borderRadius: 10, padding: "11px", fontSize: 14, fontWeight: 700, cursor: canSubmit ? "pointer" : "default", fontFamily: display, letterSpacing: 0.5 }}>
                {busy ? "Wird angelegt…" : "Anlegen"}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

/* Stand 37r — Büro-Reiter „Orte" (Nutzer: „bringe da Ordnung rein", Namen vom Nutzer gewählt). Drei Arten:
   🏠 Homebase = Microsoccer-Standort · 🤝 Collab-Space · ⚡ Pop-up-Pitch = einmaliger Ort. Im Code heißen sie
   weiter typ "standort" / "collab" / (kein Eintrag) -- nur die Anzeige-Namen sind neu.
   🏠 Microsoccer-Standorte (eigene, z. B. Wasnergasse) mit ihren Orten rundherum (Schule, Halle, Park …),
   🤝 Collab-Spaces (Partner-Locations: Lokale mit Gastgarten/Raum, Platz + Partnerlokal, Brauerei …),
   📌 einmalige Orte (Bädertour-Station, Community-Tour-Stopp …) -- nur beim Event, nicht in der Liste.
   Archivieren statt löschen. */
const ORT_ARTEN = { schule: "Schule", halle: "Halle", park: "Park/Platz", bad: "Bad", sonstiges: "Sonstiges" };
const COLLAB_ARTEN = { gastgarten: "Lokal mit Gastgarten", raum: "Lokal mit Raum", platz: "Platz + Partnerlokal", brauerei: "Brauerei / Eventlocation", firma: "Firma", sonstiges: "Sonstiges" };
const ART_LABEL = { ...ORT_ARTEN, ...COLLAB_ARTEN, lokal: "Lokal" };
function OrtFormular({ typ, standortId = null, start = null, onSpeichern, onAbbrechen }) {
  const arten = typ === "collab" ? COLLAB_ARTEN : ORT_ARTEN;
  const [name, setName] = useState(start ? start.name : "");
  const [adresse, setAdresse] = useState(start ? start.adresse : "");
  const [art, setArt] = useState(start && start.art ? start.art : Object.keys(arten)[0]);
  const [partner, setPartner] = useState(start ? start.partner || "" : "");
  const [traeger, setTraeger] = useState(start ? start.traeger || "verein" : "verein");
  const inp = { border: `1px solid ${C.line}`, borderRadius: 8, padding: "7px 9px", fontSize: 14, fontFamily: font };
  const ok = name.trim().length > 0;
  const ph = typ === "standort" ? "Name, z. B. Wasnergasse" : typ === "collab" ? "Name, z. B. Ottakringer Brauerei" : "Name, z. B. VS Wasnergasse";
  return (
    <div data-ort-formular={typ} style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", background: C.chalk, borderRadius: 10, padding: 10, marginTop: 8 }}>
      <input data-ort-name autoFocus value={name} onChange={(e) => setName(e.target.value)} placeholder={ph} style={{ ...inp, flex: 1, minWidth: 150 }} />
      <input data-ort-adresse value={adresse} onChange={(e) => setAdresse(e.target.value)} placeholder="Adresse (optional)" style={{ ...inp, flex: 1, minWidth: 150 }} />
      {typ === "standort"
        ? <select data-ort-traeger value={traeger} onChange={(e) => setTraeger(e.target.value)} style={inp}>{Object.entries(TRAEGER).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        : <select data-ort-art value={art} onChange={(e) => setArt(e.target.value)} style={inp}>{Object.entries(arten).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>}
      {typ === "collab" && <input data-ort-partner value={partner} onChange={(e) => setPartner(e.target.value)} placeholder={art === "platz" ? "Partnerlokal in der Nähe" : "Kooperation / Kontakt (optional)"} style={{ ...inp, flex: 1, minWidth: 150 }} />}
      <button data-ort-speichern disabled={!ok} onClick={() => onSpeichern({ typ, standortId, name: name.trim(), adresse: adresse.trim(), ...(typ === "standort" ? { traeger } : { art }), ...(typ === "collab" ? { partner: partner.trim() } : {}) })}
        style={{ border: "none", background: ok ? C.play : "#C7D3CC", color: "#fff", borderRadius: 8, padding: "8px 14px", fontWeight: 700, cursor: ok ? "pointer" : "default", fontFamily: font }}>Speichern</button>
      <button onClick={onAbbrechen} style={{ border: "none", background: "none", color: C.sub, fontWeight: 700, cursor: "pointer", fontFamily: font }}>Abbrechen</button>
    </div>
  );
}
function OrteVerwaltung({ buero, onGeaendert }) {
  const [orte, setOrte] = useState(null);
  const [err, setErr] = useState("");
  const [form, setForm] = useState(null); // { typ, standortId } | { edit: ort }
  const [archivOffen, setArchivOffen] = useState(false);
  const laden = useCallback(() => listOrte(buero).then((l) => { setOrte(l); if (onGeaendert) onGeaendert(); }).catch((e) => setErr(e.serverMessage || e.message)), [buero, onGeaendert]);
  useEffect(() => { laden(); }, [laden]);
  const speichern = async (daten) => {
    setErr("");
    try { if (form && form.edit) await updateOrt(form.edit.id, daten, buero); else await createOrt(daten, buero); setForm(null); laden(); }
    catch (e) { setErr(e.serverMessage || e.message); }
  };
  const aktivSetzen = async (o, aktiv) => { setErr(""); try { await updateOrt(o.id, { aktiv }, buero); laden(); } catch (e) { setErr(e.serverMessage || e.message); } };
  if (orte === null) return <div style={{ color: C.sub, fontSize: 14 }}>{err || "Lädt…"}</div>;
  const akt = orte.filter((o) => o.aktiv), arch = orte.filter((o) => !o.aktiv);
  const standorte = akt.filter((o) => o.typ === "standort");
  const collabs = akt.filter((o) => o.typ === "collab");
  const orteVon = (sid) => akt.filter((o) => o.typ === "ort" && (o.standortId || null) === sid);
  const h = { fontSize: 11.5, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.6, margin: "22px 0 8px" };
  const box = { background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: "12px 14px", marginBottom: 10 };
  const klein = { border: `1px solid ${C.line}`, background: "#fff", color: C.ink, borderRadius: 8, padding: "4px 9px", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: font };
  const editHier = (o) => form && form.edit && form.edit.id === o.id ? <OrtFormular typ={o.typ} standortId={o.standortId} start={o} onSpeichern={speichern} onAbbrechen={() => setForm(null)} /> : null;
  const formHier = (typ, sid) => form && !form.edit && form.typ === typ && (form.standortId || null) === sid
    ? <OrtFormular typ={typ} standortId={sid} onSpeichern={speichern} onAbbrechen={() => setForm(null)} /> : null;
  const zeile = (o) => (
    <React.Fragment key={o.id}>
      <div data-ort={o.name} style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 0", borderTop: `1px solid ${C.line}`, flexWrap: "wrap" }}>
        <span style={{ flex: 1, minWidth: 150 }}>
          <b style={{ fontSize: 14 }}>{o.name}</b>{o.art ? <span style={{ color: C.sub, fontSize: 12.5 }}> · {ART_LABEL[o.art] || o.art}</span> : null}
          {(o.adresse || o.partner) && <span style={{ display: "block", fontSize: 12.5, color: C.sub }}>{[o.adresse, o.partner ? `🤝 ${o.partner}` : ""].filter(Boolean).join(" · ")}</span>}
        </span>
        <button style={klein} onClick={() => setForm({ edit: o })}>Ändern</button>
        <button data-ort-archivieren={o.name} style={klein} onClick={() => aktivSetzen(o, false)}>Archivieren</button>
      </div>
      {editHier(o)}
    </React.Fragment>
  );
  const kopfZeile = (emo, titel, text) => (
    <div style={{ display: "flex", gap: 10, alignItems: "flex-start", margin: "22px 0 8px" }}>
      <span style={{ fontSize: 22 }}>{emo}</span>
      <span><b style={{ fontFamily: display, fontSize: 17 }}>{titel}</b><span style={{ display: "block", fontSize: 12.5, color: C.sub, lineHeight: 1.45 }}>{text}</span></span>
    </div>
  );
  return (
    <div data-orte-verwaltung="true">
      {err && <div style={{ color: C.whistle, fontSize: 13, marginBottom: 8 }}>{err}</div>}

      {kopfZeile("🏠", `Homebases (${standorte.length})`, "Eure eigenen Microsoccer-Standorte, z. B. Wasnergasse — mit den Orten rundherum (Schulen, Hallen, Parks).")}
      {standorte.map((st) => (
        <div key={st.id} data-standort={st.name} style={box}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <span style={{ flex: 1, minWidth: 140 }}>
              <b style={{ fontFamily: display, fontSize: 16.5 }}>{st.name}</b>{st.traeger ? <span style={{ color: C.sub, fontSize: 12.5 }}> · {TRAEGER[st.traeger] || st.traeger}</span> : null}
              {st.adresse && <span style={{ display: "block", fontSize: 12.5, color: C.sub }}>{st.adresse}</span>}
            </span>
            <button style={klein} onClick={() => setForm({ edit: st })}>Ändern</button>
            <button data-ort-archivieren={st.name} style={klein} onClick={() => aktivSetzen(st, false)}>Archivieren</button>
          </div>
          {editHier(st)}
          <div style={{ marginTop: 8 }}>
            {orteVon(st.id).map(zeile)}
            {formHier("ort", st.id) || <button data-ort-neu={st.name} style={{ ...klein, marginTop: 6 }} onClick={() => setForm({ typ: "ort", standortId: st.id })}>+ Ort bei {st.name}</button>}
          </div>
        </div>
      ))}
      {formHier("standort", null) || <button data-standort-neu style={klein} onClick={() => setForm({ typ: "standort", standortId: null })}>+ Homebase</button>}

      {kopfZeile("🤝", `Collab-Spaces (${collabs.length})`, "Partner-Locations, mit denen ihr kooperiert: Lokale mit Gastgarten oder Raum, Plätze mit Partnerlokal in der Nähe, Locations wie die Ottakringer Brauerei. Für Afterwork, Business und mehr.")}
      <div data-collab-liste style={{ ...box, padding: "4px 14px 12px" }}>
        {collabs.map(zeile)}
        {formHier("collab", null) || <button data-collab-neu style={{ ...klein, marginTop: 8 }} onClick={() => setForm({ typ: "collab", standortId: null })}>+ Collab-Space</button>}
      </div>

      {kopfZeile("⚡", "Pop-up-Pitches", "Einmal bespielt: Bädertour-Station, Community-Tour-Stopp, Einzeltermin. Einfach beim Neuen Event eintippen — der Ort bleibt beim Event gespeichert, aber nicht in dieser Liste.")}

      {orteVon(null).length > 0 && (<>
        <div style={h}>Weitere gespeicherte Orte ({orteVon(null).length})</div>
        <div style={{ ...box, padding: "4px 14px 12px" }}>{orteVon(null).map(zeile)}</div>
      </>)}

      {arch.length > 0 && (<>
        <button data-orte-archiv onClick={() => setArchivOffen((v) => !v)} style={{ ...h, display: "block", background: "none", border: "none", padding: 0, cursor: "pointer", fontFamily: font }}>{archivOffen ? "▾" : "▸"} Archiviert ({arch.length})</button>
        {archivOffen && arch.map((o) => (
          <div key={o.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 0", opacity: 0.7 }}>
            <span style={{ flex: 1 }}>{o.typ === "standort" ? "🏠 " : o.typ === "collab" ? "🤝 " : ""}{o.name}</span>
            <button style={klein} onClick={() => aktivSetzen(o, true)}>wieder aktiv</button>
          </div>
        ))}
      </>)}
    </div>
  );
}

/* Stand 37s — Büro-Reiter „📊 Auswertung": ⏱️ Stunden (intern, mit Namen) und 📊 Wirkung (nur Summen, folgt).
   Eine Quelle für alles: die Einsätze aus Check-in/-out. Das Büro bestätigt (oder korrigiert) sie; nur Bestätigtes
   kommt in Zeitbestätigung, Freiwilligenpauschale-Liste, Honorar-Übersicht, Projekt-Nachweis und CSV.
   Zeiten werden auf die Viertelstunde ABgerundet (14:07 → 14:00, 17:52 → 17:45), wie in der Zeitbestätigungs-App.
   Keine Bank-/SV-Daten hier — die bleiben in Honorarnoten-Tool/Verwaltung. */
const STUNDEN_ARTEN = { honorar: "Honorar", freiwillig: "Freiwilligenpauschale", anstellung: "Anstellung", ehrenamt: "Ehrenamt" };
const viertel = (ms) => Math.floor(ms / 900000) * 900000;
const fmtH = (h) => (Math.round(h * 100) / 100).toLocaleString("de-AT", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
const fmtTag = (ms) => new Date(ms).toLocaleDateString("de-AT", { weekday: "short", day: "2-digit", month: "2-digit" });
const hhmm = (ms) => { const d = new Date(ms); return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`; };
const mitUhrzeit = (basisMs, t) => { const m = /^(\d{1,2}):(\d{2})$/.exec(t || ""); if (!m) return null; const d = new Date(basisMs); d.setHours(Number(m[1]), Number(m[2]), 0, 0); return d.getTime(); };
const personKey = (n) => String(n || "").trim().toLowerCase().replace(/\s+/g, " ");
function stundenZeile(z, personen) {
  const b = z.best || {};
  const name = (b.name || z.name || "").trim() || (z.rolle === "headcoach" ? "Headcoach (ohne Name)" : "Coach (ohne Name)");
  const ohneName = !(b.name || z.name || "").trim();
  const von = b.von != null ? b.von : z.von, bis = b.bis != null ? b.bis : z.bis;
  const pause = b.pauseMin || 0;
  const person = personen.find((p) => personKey(p.name) === personKey(name)) || null;
  const art = b.art || (person && person.art) || "";
  const h = bis ? Math.max(0, (viertel(bis) - viertel(von)) / 3600000 - pause / 60) : null;
  return { ...z, name, ohneName, vonE: von, bisE: bis, pause, art, person, h, status: (z.best && z.best.status) || "offen" };
}
function Druckblatt({ titel, unter, kopf, zeilen, fuss, unterschriften = [], onZu }) {
  return (
    <div data-druck="true" style={{ position: "fixed", inset: 0, background: "rgba(18,36,28,.45)", zIndex: 400, overflowY: "auto", padding: 16 }}>
      <style>{`@media print { body * { visibility: hidden !important; } [data-druck-blatt], [data-druck-blatt] * { visibility: visible !important; } [data-druck-blatt] { position: absolute; left: 0; top: 0; width: 100%; box-shadow: none !important; } .nodruck { display: none !important; } }`}</style>
      <div className="nodruck" style={{ maxWidth: 760, margin: "0 auto 10px", display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button data-druck-drucken onClick={() => { try { window.print(); } catch (_) { /* noop */ } }} style={{ border: "none", background: C.play, color: "#fff", borderRadius: 10, padding: "9px 14px", fontWeight: 700, cursor: "pointer", fontFamily: font }}>🖨️ Drucken / PDF</button>
        <button data-druck-zu onClick={onZu} style={{ border: "none", background: "#fff", color: C.ink, borderRadius: 10, padding: "9px 14px", fontWeight: 700, cursor: "pointer", fontFamily: font }}>Schließen</button>
      </div>
      <div data-druck-blatt="true" style={{ maxWidth: 760, margin: "0 auto", background: "#fff", borderRadius: 8, padding: "28px 30px", fontFamily: font, color: "#111", fontSize: 13, boxShadow: "0 10px 40px rgba(0,0,0,.25)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
          <div><div style={{ fontFamily: display, fontWeight: 700, fontSize: 20 }}>{titel}</div><div style={{ color: "#555", marginTop: 2 }}>{unter}</div></div>
          <div style={{ textAlign: "right", fontSize: 12, color: "#555" }}>Microsoccer<br />{new Date().toLocaleDateString("de-AT")}</div>
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 18 }}>
          <thead><tr>{kopf.map((k, i) => <th key={i} style={{ textAlign: i === kopf.length - 1 ? "right" : "left", borderBottom: "2px solid #111", padding: "5px 6px", fontSize: 12 }}>{k}</th>)}</tr></thead>
          <tbody>{zeilen.map((r, j) => <tr key={j}>{r.map((c, i) => <td key={i} style={{ textAlign: i === r.length - 1 ? "right" : "left", borderBottom: "1px solid #ddd", padding: "5px 6px" }}>{c}</td>)}</tr>)}</tbody>
        </table>
        {fuss && <div data-druck-summe style={{ textAlign: "right", fontWeight: 700, marginTop: 10, fontSize: 14 }}>{fuss}</div>}
        {unterschriften.length > 0 && (
          <div style={{ display: "flex", gap: 30, marginTop: 50 }}>
            {unterschriften.map((u) => <div key={u} style={{ flex: 1, borderTop: "1px solid #111", paddingTop: 4, fontSize: 12, color: "#555" }}>{u}</div>)}
          </div>
        )}
      </div>
    </div>
  );
}
function Auswertung({ buero, standorte = [], projekte = [] }) {
  const [teil, setTeil] = useState("stunden");
  return (
    <div data-auswertung={teil}>
      <div style={{ display: "flex", gap: 6, marginBottom: 14 }}>
        {[["stunden", "⏱️ Stunden"], ["wirkung", "📊 Wirkung"]].map(([k, l]) => (
          <button key={k} data-auswertung-teil={k} onClick={() => setTeil(k)} style={{ flex: 1, border: `1px solid ${teil === k ? C.play : C.line}`, background: teil === k ? C.playSoft : "#fff", color: C.ink, borderRadius: 12, padding: "9px 10px", fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: font }}>{l}</button>
        ))}
      </div>
      {teil === "stunden" ? <StundenListe buero={buero} standorte={standorte} projekte={projekte} /> : (
        <div data-wirkung-bald="true" style={{ fontSize: 13.5, color: C.sub, lineHeight: 1.55, border: `2px dashed ${C.line}`, borderRadius: 14, padding: "14px 16px" }}>
          <b style={{ color: C.ink }}>📊 Wirkung — nur Summen</b><br />
          Kommt als Nächstes: Events, Teilnehmende (nur Zahlen), Coach-Stunden und Stimmung je Monat/Quartal, je Projekt und Homebase — Gruppen unter 3 ausgeblendet, erst Entwurf, dann Freigabe, dann CSV/PDF für Fördergeber.
        </div>
      )}
    </div>
  );
}
function StundenListe({ buero, standorte = [], projekte = [] }) {
  const heute = todayIso();
  const [monat, setMonat] = useState(heute.slice(0, 7));
  const [daten, setDaten] = useState(null);
  const [err, setErr] = useState("");
  const [fTraeger, setFTraeger] = useState("");
  const [fProjekt, setFProjekt] = useState("");
  const [fStandort, setFStandort] = useState("");
  const [offen, setOffen] = useState({}); // Person aufgeklappt
  const [edit, setEdit] = useState(null); // { key, name, von, bis, pause, art }
  const [druck, setDruck] = useState(null);
  const [y, m] = monat.split("-").map(Number);
  const laden = useCallback(async () => {
    setErr("");
    try { setDaten(await listStunden({ von: new Date(y, m - 1, 1).getTime(), bis: new Date(y, m, 1).getTime() }, buero)); }
    catch (e) { setErr(e.serverMessage || e.message); }
  }, [y, m, buero]);
  useEffect(() => { laden(); }, [laden]);
  const shift = (n) => { const d = new Date(y, m - 1 + n, 1); setMonat(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`); };
  const personen = (daten && daten.personen) || [];
  const alle = ((daten && daten.zeilen) || []).map((z) => stundenZeile(z, personen))
    .filter((z) => (!fTraeger || z.traeger === fTraeger) && (!fProjekt || (z.projekt || "").trim() === fProjekt) && (!fStandort || (fStandort === "-" ? !z.standortId : z.standortId === fStandort)));
  const gruppen = [];
  for (const z of alle) { let g = gruppen.find((x) => personKey(x.name) === personKey(z.name)); if (!g) { g = { name: z.name, ohneName: z.ohneName, person: z.person, zeilen: [] }; gruppen.push(g); } g.zeilen.push(z); }
  gruppen.sort((a, b) => (a.ohneName - b.ohneName) || a.name.localeCompare(b.name));
  const summe = (zs, nurBest) => zs.reduce((s, z) => s + (z.h != null && (!nurBest || z.status === "bestaetigt") ? z.h : 0), 0);
  const zKey = (z) => z.eventId + "|" + z.einsatzId;
  const monatsName = `${MONATE[m - 1]} ${y}`;
  const filterText = [fTraeger ? TRAEGER[fTraeger] : "", fProjekt, fStandort ? (fStandort === "-" ? "ohne Homebase" : (standorte.find((s) => s.id === fStandort) || {}).name) : ""].filter(Boolean).join(" · ");
  const best = async (z, extra = {}) => {
    setErr("");
    try {
      await bestaetigeStunde({ eventId: z.eventId, einsatzId: z.einsatzId, status: "bestaetigt", name: z.ohneName ? "" : z.name, von: z.vonE, bis: z.bisE, pauseMin: z.pause, art: z.best && z.best.art ? z.best.art : "", ...extra }, buero);
      setEdit(null); laden();
    } catch (e) { setErr(e.serverMessage || e.message); }
  };
  const zuruecknehmen = async (z) => { try { await bestaetigeStunde({ eventId: z.eventId, einsatzId: z.einsatzId, status: "offen", name: (z.best && z.best.name) || "", von: z.best && z.best.von, bis: z.best && z.best.bis, pauseMin: z.pause, art: (z.best && z.best.art) || "" }, buero); laden(); } catch (e) { setErr(e.serverMessage || e.message); } };
  const personArt = async (g, art) => { try { await speicherePerson({ name: g.name, art, academyId: g.person ? g.person.academyId : "", satzCent: g.person ? g.person.satzCent : null }, buero); laden(); } catch (e) { setErr(e.serverMessage || e.message); } };
  const personSatz = async (g, euro) => { const c = euro === "" ? null : Math.round(Number(String(euro).replace(",", ".")) * 100); try { await speicherePerson({ name: g.name, art: g.person ? g.person.art : "", academyId: g.person ? g.person.academyId : "", satzCent: c }, buero); laden(); } catch (e) { setErr(e.serverMessage || e.message); } };
  const zeilenDruck = (zs, mitName) => zs.filter((z) => z.status === "bestaetigt" && z.h != null).map((z) => [...(mitName ? [z.name] : []), fmtTag(z.vonE), z.event, `${hhmm(viertel(z.vonE))}–${hhmm(viertel(z.bisE))}${z.pause ? ` (−${z.pause} min)` : ""}`, fmtH(z.h)]);
  const offeneHinweis = (zs) => { const n = zs.filter((z) => z.status !== "bestaetigt").length; return n ? ` · ${n} offen (nicht enthalten)` : ""; };
  const zeitbestaetigung = (g) => setDruck({ titel: `Zeitbestätigung · ${g.name}`, unter: `${monatsName}${g.person && g.person.academyId ? ` · ${g.person.academyId}` : ""}${filterText ? ` · ${filterText}` : ""}`, kopf: ["Tag", "Event", "Zeit", "Stunden"], zeilen: zeilenDruck(g.zeilen, false), fuss: `Summe: ${fmtH(summe(g.zeilen, true))} h${offeneHinweis(g.zeilen)}`, unterschriften: [g.name, "Einsatzleitung / Microsoccer"] });
  const listeNachArt = (art, titel) => {
    const gs = gruppen.filter((g) => g.zeilen.some((z) => z.art === art));
    const zs = gs.flatMap((g) => g.zeilen.filter((z) => z.art === art));
    if (art === "honorar") {
      const zeilen = gs.map((g) => { const h = summe(g.zeilen.filter((z) => z.art === art), true); const satz = g.person && g.person.satzCent != null ? g.person.satzCent / 100 : null; return [g.name, fmtH(h) + " h", satz != null ? satz.toLocaleString("de-AT", { style: "currency", currency: "EUR" }) : "—", satz != null ? (h * satz).toLocaleString("de-AT", { style: "currency", currency: "EUR" }) : "Satz fehlt"]; });
      return setDruck({ titel, unter: `${monatsName}${filterText ? ` · ${filterText}` : ""}`, kopf: ["Person", "Stunden", "Satz/h", "Betrag"], zeilen, fuss: `Grundlage für die Honorarnoten (Bankdaten im Honorarnoten-Tool)${offeneHinweis(zs)}` });
    }
    const tage = new Set(zs.filter((z) => z.status === "bestaetigt").map((z) => z.name + new Date(z.vonE).toDateString())).size;
    setDruck({ titel, unter: `${monatsName}${filterText ? ` · ${filterText}` : ""}`, kopf: ["Person", "Tag", "Event", "Zeit", "Stunden"], zeilen: zeilenDruck(zs, true), fuss: `${fmtH(summe(zs, true))} h · ${tage} Einsatztage${offeneHinweis(zs)}`, unterschriften: ["Einsatzleitung / Microsoccer"] });
  };
  const csv = () => {
    const q = (v) => `"${String(v == null ? "" : v).replace(/"/g, '""')}"`;
    const rows = [["Person", "Academy-ID", "Art", "Datum", "Event", "Rolle", "Träger", "Projekt", "Von", "Bis", "Pause (min)", "Stunden", "Status"]]
      .concat(alle.map((z) => [z.name, z.person ? z.person.academyId : "", STUNDEN_ARTEN[z.art] || "", new Date(z.vonE).toLocaleDateString("de-AT"), z.event, z.rolle, z.traeger ? TRAEGER[z.traeger] || z.traeger : "", z.projekt, hhmm(viertel(z.vonE)), z.bisE ? hhmm(viertel(z.bisE)) : "", z.pause, z.h != null ? fmtH(z.h) : "", z.status === "bestaetigt" ? "bestätigt" : "offen"]));
    const text = "﻿" + rows.map((r) => r.map(q).join(";")).join("\r\n");
    try { const a = document.createElement("a"); a.href = URL.createObjectURL(new Blob([text], { type: "text/csv;charset=utf-8" })); a.download = `stunden-${monat}.csv`; document.body.appendChild(a); a.click(); a.remove(); } catch (_) { /* noop */ }
    return text;
  };
  const sel = { border: `1px solid ${C.line}`, borderRadius: 8, padding: "6px 8px", fontFamily: font, fontSize: 13, background: "#fff" };
  const klein = { border: `1px solid ${C.line}`, background: "#fff", color: C.ink, borderRadius: 8, padding: "5px 9px", fontSize: 12.5, fontWeight: 700, cursor: "pointer", fontFamily: font };
  return (
    <div data-stunden="true">
      <div style={{ fontSize: 13, color: C.sub, lineHeight: 1.5, marginBottom: 10 }}>Aus Check-in/-out der Coaches. Prüfen, bestätigen — nur Bestätigtes kommt in Zeitbestätigung, Listen und CSV. Zeiten auf die Viertelstunde abgerundet.</div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <button data-stunden-zurueck onClick={() => shift(-1)} style={klein}>‹</button>
        <div data-stunden-monat={monat} style={{ flex: 1, textAlign: "center", fontFamily: display, fontWeight: 700, fontSize: 18 }}>{monatsName}</div>
        <button data-stunden-weiter onClick={() => shift(1)} style={klein}>›</button>
      </div>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
        <select data-stunden-traeger value={fTraeger} onChange={(e) => setFTraeger(e.target.value)} style={sel}><option value="">Alle Träger</option>{Object.entries(TRAEGER).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        <select data-stunden-projekt value={fProjekt} onChange={(e) => setFProjekt(e.target.value)} style={sel}><option value="">Alle Projekte</option>{projekte.map((p) => <option key={p} value={p}>{p}</option>)}</select>
        {standorte.length > 0 && <select data-stunden-standort value={fStandort} onChange={(e) => setFStandort(e.target.value)} style={sel}><option value="">Alle Homebases</option>{standorte.map((s) => <option key={s.id} value={s.id}>🏠 {s.name}</option>)}<option value="-">ohne Homebase</option></select>}
      </div>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
        <button data-stunden-csv onClick={csv} style={klein}>⬇︎ CSV</button>
        <button data-liste-freiwillig onClick={() => listeNachArt("freiwillig", "Freiwilligenpauschale · Stundenliste")} style={klein}>📄 Freiwilligenpauschale</button>
        <button data-liste-honorar onClick={() => listeNachArt("honorar", "Honorar-Übersicht")} style={klein}>📄 Honorare</button>
        {fProjekt && <button data-liste-projekt onClick={() => setDruck({ titel: `Stundennachweis · ${fProjekt}`, unter: `${monatsName}${filterText ? ` · ${filterText}` : ""}`, kopf: ["Person", "Tag", "Event", "Zeit", "Stunden"], zeilen: zeilenDruck(alle, true), fuss: `${fmtH(summe(alle, true))} h${offeneHinweis(alle)}`, unterschriften: ["Einsatzleitung / Microsoccer"] })} style={klein}>📄 Projekt-Nachweis</button>}
      </div>
      {err && <div style={{ color: C.whistle, fontSize: 13, marginBottom: 8 }}>{err}</div>}
      {daten === null ? <div style={{ color: C.sub, fontSize: 14 }}>Lädt…</div> : gruppen.length === 0 ? (
        <div style={{ color: C.sub, fontSize: 14, background: "#fff", border: `1px solid ${C.line}`, borderRadius: 14, padding: 14 }}>Keine Einsätze in {monatsName}{filterText ? ` (${filterText})` : ""}.</div>
      ) : (
        <div style={{ display: "grid", gap: 10 }}>
          <div data-stunden-gesamt style={{ fontSize: 13, color: C.sub }}><b style={{ color: C.ink }}>{fmtH(summe(alle, true))} h bestätigt</b> · {fmtH(summe(alle, false) - summe(alle, true))} h offen · {gruppen.length} Personen</div>
          {gruppen.map((g) => {
            const auf = !!offen[g.name];
            const nOffen = g.zeilen.filter((z) => z.status !== "bestaetigt").length;
            return (
              <div key={g.name} data-stunden-person={g.name} style={{ background: "#fff", border: `1px solid ${g.ohneName ? C.brk : C.line}`, borderRadius: 14, padding: "10px 12px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                  <button onClick={() => setOffen({ ...offen, [g.name]: !auf })} style={{ flex: 1, minWidth: 150, textAlign: "left", background: "none", border: "none", padding: 0, cursor: "pointer", fontFamily: font, color: C.ink }}>
                    <b style={{ fontSize: 15 }}>{auf ? "▾" : "▸"} {g.name}</b>
                    <span style={{ display: "block", fontSize: 12.5, color: C.sub }}>{fmtH(summe(g.zeilen, true))} h bestätigt{nOffen ? ` · ${nOffen} offen` : " · alles bestätigt"}{g.person && g.person.academyId ? ` · ${g.person.academyId}` : ""}</span>
                  </button>
                  {!g.ohneName && <select data-person-art={g.name} value={(g.person && g.person.art) || ""} onChange={(e) => personArt(g, e.target.value)} style={sel}><option value="">Art wählen …</option>{Object.entries(STUNDEN_ARTEN).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>}
                  {!g.ohneName && <button data-zeitbestaetigung={g.name} onClick={() => zeitbestaetigung(g)} style={klein}>📄 Zeitbestätigung</button>}
                </div>
                {g.ohneName && <div style={{ fontSize: 12.5, color: "#8A5A00", marginTop: 6 }}>Beim Check-in wurde kein Name erfasst — bei „Ändern" eintragen, dann landet der Einsatz bei der richtigen Person.</div>}
                {auf && g.person && g.person.art === "honorar" && (
                  <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 12.5, color: C.sub, marginTop: 8 }}>Stundensatz €
                    <input data-person-satz={g.name} defaultValue={g.person.satzCent != null ? String(g.person.satzCent / 100).replace(".", ",") : ""} onBlur={(e) => personSatz(g, e.target.value.trim())} style={{ ...sel, width: 80 }} />
                  </label>
                )}
                {auf && g.zeilen.map((z) => {
                  const k = zKey(z), ed = edit && edit.key === k;
                  return (
                    <div key={k} data-stunden-zeile={k} style={{ borderTop: `1px solid ${C.line}`, padding: "8px 0", marginTop: 6 }}>
                      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                        <span style={{ flex: 1, minWidth: 160, fontSize: 13.5 }}>
                          <b>{fmtTag(z.vonE)}</b> · {z.event}{z.rolle === "headcoach" ? " · 🎽" : ""}
                          <span style={{ display: "block", fontSize: 12.5, color: C.sub }}>
                            {z.bisE ? `${hhmm(viertel(z.vonE))}–${hhmm(viertel(z.bisE))}${z.pause ? ` − ${z.pause} min Pause` : ""} = ${fmtH(z.h)} h` : `seit ${hhmm(viertel(z.vonE))} · Check-out fehlt`}
                            {z.art ? ` · ${STUNDEN_ARTEN[z.art]}` : ""}{z.best && ((z.best.von != null && z.best.von !== z.von) || (z.best.bis != null && z.best.bis !== z.bis)) ? " · korrigiert" : ""}
                            {z.autoCheckout ? " · Auto-Check-out" : ""}
                          </span>
                          {z.verl && (
                            <span data-stunden-verl={z.verl.status} style={{ display: "block", fontSize: 12.5, color: z.verl.status === "nein" ? C.whistle : z.verl.status === "ok" ? C.play : "#8A5A00", marginTop: 2 }}>
                              🔧 {verlGrund(z.verl.grund)}{z.verl.text ? ` (${z.verl.text})` : ""} bis {hhmm(z.verl.bis)} · {z.verl.status === "ok" ? `✓ freigegeben (${z.verl.durch === "buero" ? "Büro" : "Headcoach"})` : z.verl.status === "nein" ? "✗ nicht freigegeben — gekürzt auf Ende + 15 Min" : z.rolle === "headcoach" ? "Headcoach-Verlängerung: Büro entscheidet" : "Headcoach hat nicht entschieden"}
                            </span>
                          )}
                        </span>
                        {z.status === "bestaetigt"
                          ? <><span data-stunden-status="bestaetigt" style={{ color: C.play, fontWeight: 700, fontSize: 12.5 }}>✓ bestätigt</span><button style={klein} onClick={() => zuruecknehmen(z)}>zurück</button></>
                          : <button data-stunden-bestaetigen={k} disabled={!z.bisE || z.ohneName} onClick={() => best(z)} style={{ ...klein, background: z.bisE && !z.ohneName ? C.play : "#C7D3CC", color: "#fff", borderColor: "transparent" }}>✓ Bestätigen</button>}
                        {z.verl && z.verl.status !== "nein" && z.eventEnde && z.status !== "bestaetigt" && (
                          <button data-stunden-kappen={k} title="Verlängerung nicht anerkennen" style={klein} onClick={() => best(z, { bis: Math.max(z.vonE, z.eventEnde + FEIERABEND_MIN * 60000) })}>nur bis {hhmm(z.eventEnde + FEIERABEND_MIN * 60000)}</button>
                        )}
                        <button data-stunden-aendern={k} style={klein} onClick={() => setEdit(ed ? null : { key: k, name: z.ohneName ? "" : z.name, von: hhmm(z.vonE), bis: z.bisE ? hhmm(z.bisE) : "", pause: String(z.pause || ""), art: (z.best && z.best.art) || "" })}>Ändern</button>
                      </div>
                      {ed && (
                        <div data-stunden-form style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", background: C.chalk, borderRadius: 10, padding: 8, marginTop: 6 }}>
                          <input data-sf-name value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} placeholder="Name" style={{ ...sel, flex: 1, minWidth: 120 }} />
                          <input data-sf-von type="time" value={edit.von} onChange={(e) => setEdit({ ...edit, von: e.target.value })} style={sel} />
                          <input data-sf-bis type="time" value={edit.bis} onChange={(e) => setEdit({ ...edit, bis: e.target.value })} style={sel} />
                          <input data-sf-pause value={edit.pause} onChange={(e) => setEdit({ ...edit, pause: e.target.value.replace(/[^0-9]/g, "") })} placeholder="Pause min" style={{ ...sel, width: 84 }} />
                          <select data-sf-art value={edit.art} onChange={(e) => setEdit({ ...edit, art: e.target.value })} style={sel}><option value="">Art wie Person</option>{Object.entries(STUNDEN_ARTEN).map(([a, l]) => <option key={a} value={a}>{l}</option>)}</select>
                          <button data-sf-speichern disabled={!edit.name.trim() || !edit.bis} onClick={() => best(z, { name: edit.name.trim(), von: mitUhrzeit(z.vonE, edit.von), bis: mitUhrzeit(z.vonE, edit.bis), pauseMin: Number(edit.pause) || 0, art: edit.art })}
                            style={{ border: "none", background: edit.name.trim() && edit.bis ? C.play : "#C7D3CC", color: "#fff", borderRadius: 8, padding: "7px 12px", fontWeight: 700, cursor: "pointer", fontFamily: font }}>Speichern & bestätigen</button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      )}
      {druck && <Druckblatt {...druck} onZu={() => setDruck(null)} />}
    </div>
  );
}

/* ---------- Stand 40: Usability-Bericht (Büro) ----------
   Automatisch gesammelt: Fehler, Wut-Tipps, falsche Wege, Hin-und-her, Herumsuchen + „Hier hakt's"-Meldungen.
   Gleiche Probleme an gleicher Stelle werden gebündelt; „erledigt" taucht wieder auf, wenn es nach dem Abhaken neu passiert. */
const UX_TYP = { fehler: ["⛔", "Fehler"], wut: ["👆", "Mehrfach getippt"], zurueck: ["↩️", "Gleich wieder raus"], hinundher: ["🔁", "Hin und her"], irrweg: ["🧭", "Sucht herum"], hakt: ["💬", "Hier hakt's"] };
function uxTitel(g) {
  const d = g.beispiel || {};
  if (g.typ === "fehler") return d.art === "server" ? `Server antwortet ${d.status} bei ${d.methode || ""} ${d.url || ""}` : d.art === "netz" ? `Keine Verbindung bei ${d.url || ""}${d.online === false ? " (offline)" : ""}` : `${d.art === "react" ? "Absturz" : "Skriptfehler"}: ${d.text || "?"}`;
  if (g.typ === "wut") return `${d.ziel || "?"}${d.aktiv === false ? " — reagiert nicht (kein Knopf)" : ""}`;
  return d.ziel || "?";
}
function uxZeit(ms) { const d = new Date(ms); return d.toLocaleDateString("de-AT", { day: "2-digit", month: "2-digit" }) + " " + d.toLocaleTimeString("de-AT", { hour: "2-digit", minute: "2-digit" }); }
function UsabilityBericht({ buero, events = [] }) {
  const [tage, setTage] = useState(14);
  const [eventId, setEventId] = useState("");
  const [daten, setDaten] = useState(null);
  const [err, setErr] = useState("");
  const [alle, setAlle] = useState(false);
  const [auf, setAuf] = useState({});
  const [kopie, setKopie] = useState("");
  const laden = useCallback(async () => {
    setErr("");
    try { setDaten(await uxBericht({ tage, eventId }, buero)); } catch (e) { setErr(e.serverMessage || e.message); }
  }, [tage, eventId, buero]);
  useEffect(() => { laden(); }, [laden]);
  const setze = async (fp, status) => { try { await uxStatusSetzen(fp, status, "", buero); laden(); } catch (e) { setErr(e.serverMessage || e.message); } };
  const gruppen = ((daten && daten.gruppen) || []).filter((g) => alle || g.status === "offen" || g.status === "wieder");
  const hakt = ((daten && daten.hakt) || []).filter((h) => alle || h.status !== "erledigt" && h.status !== "ignorieren");
  const offenN = ((daten && daten.gruppen) || []).filter((g) => g.status === "offen" || g.status === "wieder").length;
  const evName = (id) => { const e = events.find((x) => x.id === id); return e ? e.title : id; };
  const kopieren = () => {
    const z = [`Matchday · Usability-Liste (letzte ${tage} Tage${eventId ? ", " + evName(eventId) : ""}) · ${new Date().toLocaleDateString("de-AT")}`, ""];
    if (hakt.length) { z.push("## Hier hakt's (von Coaches/Headcoach/Büro)"); hakt.forEach((h) => z.push(`- [${h.kategorie}] ${h.text || "(ohne Text)"} — Bildschirm: ${h.bildschirm} · Rolle: ${h.rolle || "?"} · Weg: ${(h.weg || []).join(" → ")}`)); z.push(""); }
    z.push("## Automatisch erkannt (nach Gewicht)");
    gruppen.forEach((g, i) => z.push(`${i + 1}. ${UX_TYP[g.typ] ? UX_TYP[g.typ][1] : g.typ}${g.status === "wieder" ? " (WIEDER aufgetreten)" : ""}: ${uxTitel(g)} — Bildschirm: ${g.bildschirm} · ${g.n}× auf ${g.geraete} Geräten · Rollen: ${g.rollen.join(", ") || "?"}${g.beispiel && g.beispiel.weg ? " · Weg: " + g.beispiel.weg.join(" → ") : ""}`));
    const text = z.join("\n");
    setKopie(text);
    try { navigator.clipboard.writeText(text); } catch (_) { /* Feld unten */ }
  };
  const klein = { border: `1px solid ${C.line}`, background: "#fff", color: C.ink, borderRadius: 8, padding: "5px 9px", fontSize: 12.5, fontWeight: 700, cursor: "pointer", fontFamily: font };
  const chip = (on) => ({ ...klein, borderRadius: 999, background: on ? C.playSoft : "#fff", borderColor: on ? C.play : C.line });
  const karte = { background: "#fff", border: `1px solid ${C.line}`, borderRadius: 14, padding: "10px 12px" };
  const jb = Object.entries((daten && daten.jeBildschirm) || {}).sort((a, b) => b[1] - a[1]).slice(0, 6);
  const maxJb = jb.length ? jb[0][1] : 1;
  return (
    <div data-usability="true">
      <div style={{ fontSize: 13, color: C.sub, lineHeight: 1.5, marginBottom: 10 }}>Die App merkt sich leise, wo es hakt: Fehler, mehrfaches Tippen, falsche Wege, Herumsuchen — ohne Namen. Dazu die „💬 Hakt's?"-Meldungen der Coaches. Gleiches wird gebündelt.</div>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 8 }}>
        {[1, 7, 14, 30].map((t) => <button key={t} data-ux-tage={t} onClick={() => setTage(t)} style={chip(tage === t)}>{t === 1 ? "Heute" : `${t} Tage`}</button>)}
        <select data-ux-event value={eventId} onChange={(e) => setEventId(e.target.value)} style={{ ...klein, fontWeight: 600 }}>
          <option value="">Alle Events</option>
          {events.filter((e) => e.status !== "geloescht").map((e) => <option key={e.id} value={e.id}>{e.title || e.id}</option>)}
        </select>
      </div>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
        <button data-ux-kopieren onClick={kopieren} style={{ ...klein, background: C.ink, color: "#fff", borderColor: C.ink }}>📋 Liste für die Entwicklung kopieren</button>
        <button data-ux-alle onClick={() => setAlle(!alle)} style={klein}>{alle ? "Nur offene zeigen" : "Auch erledigte zeigen"}</button>
        <button onClick={laden} style={klein}>↻</button>
      </div>
      {kopie && <textarea data-ux-kopie readOnly value={kopie} onFocus={(e) => e.target.select()} rows={6} style={{ width: "100%", border: `1px solid ${C.line}`, borderRadius: 10, padding: 8, fontSize: 12, fontFamily: "monospace", marginBottom: 10 }} />}
      {kopie && <div style={{ fontSize: 12.5, color: C.play, fontWeight: 700, marginTop: -6, marginBottom: 10 }}>Kopiert — einfach in den Entwicklungs-Chat einfügen.</div>}
      {err && <div style={{ color: C.whistle, fontSize: 13, marginBottom: 8 }}>{err}</div>}
      {daten === null ? <div style={{ color: C.sub, fontSize: 14 }}>Lädt…</div> : (<>
        <div data-ux-summe style={{ fontSize: 13, color: C.sub, marginBottom: 10 }}><b style={{ color: C.ink }}>{offenN} offene Probleme</b> · {(daten.hakt || []).length} „Hakt's"-Meldungen · {daten.gesamt} Signale gesamt</div>
        {jb.length > 0 && (
          <div style={{ ...karte, marginBottom: 12 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 6 }}>Wo es am meisten hakt</div>
            {jb.map(([b, n]) => (
              <div key={b} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 12.5, padding: "3px 0" }}>
                <span style={{ width: 150, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{b}</span>
                <span style={{ flex: 1, background: C.chalk, borderRadius: 4, height: 10 }}><span style={{ display: "block", width: `${Math.max(4, (n / maxJb) * 100)}%`, height: 10, borderRadius: 4, background: C.play }} /></span>
                <span style={{ width: 28, textAlign: "right", fontVariantNumeric: "tabular-nums" }}>{n}</span>
              </div>
            ))}
          </div>
        )}
        {hakt.length > 0 && <div style={{ fontSize: 11.5, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.6, margin: "6px 0 8px" }}>💬 Hier hakt's ({hakt.length})</div>}
        <div style={{ display: "grid", gap: 8, marginBottom: 14 }}>
          {hakt.map((h) => (
            <div key={h.id} data-ux-hakt={h.fp} style={{ ...karte, opacity: h.status === "erledigt" ? 0.55 : 1 }}>
              <div style={{ fontSize: 14 }}><b>{(HAKT_ARTEN.find((x) => x[0] === h.kategorie) || [0, "💬 Sonstiges"])[1]}</b>{h.text ? ` — ${h.text}` : ""}</div>
              <div style={{ fontSize: 12, color: C.sub, marginTop: 3 }}>{uxZeit(h.at)} · {h.rolle || "?"} · {h.bildschirm}{h.eventId ? ` · ${evName(h.eventId)}` : ""}</div>
              {h.weg && h.weg.length > 0 && <div style={{ fontSize: 11.5, color: C.sub, marginTop: 3 }}>Weg: {h.weg.join(" → ")}</div>}
              <div style={{ marginTop: 6, display: "flex", gap: 6 }}>
                {h.status === "erledigt" ? <button style={klein} onClick={() => setze(h.fp, "offen")}>wieder offen</button> : <button data-ux-erledigt={h.fp} style={klein} onClick={() => setze(h.fp, "erledigt")}>✓ erledigt</button>}
              </div>
            </div>
          ))}
        </div>
        <div style={{ fontSize: 11.5, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.6, margin: "6px 0 8px" }}>Automatisch erkannt ({gruppen.length})</div>
        {gruppen.length === 0 ? <div style={{ ...karte, color: C.sub, fontSize: 14 }}>Nichts offen. 🎉</div> : (
          <div style={{ display: "grid", gap: 8 }}>
            {gruppen.map((g) => {
              const [emo, label] = UX_TYP[g.typ] || ["•", g.typ];
              const o = !!auf[g.fp];
              return (
                <div key={g.fp} data-ux-gruppe={g.typ} style={{ ...karte, borderColor: g.status === "wieder" ? C.whistle : g.typ === "fehler" ? "#F2C4C4" : C.line, opacity: g.status === "erledigt" || g.status === "ignorieren" ? 0.55 : 1 }}>
                  <button onClick={() => setAuf({ ...auf, [g.fp]: !o })} style={{ display: "block", width: "100%", textAlign: "left", background: "none", border: "none", padding: 0, cursor: "pointer", fontFamily: font, color: C.ink }}>
                    <div style={{ fontSize: 14 }}>{emo} <b>{label}</b>{g.status === "wieder" ? <span style={{ color: C.whistle, fontWeight: 800 }}> · wieder aufgetreten</span> : null} — {uxTitel(g)}</div>
                    <div style={{ fontSize: 12, color: C.sub, marginTop: 3 }}>{g.bildschirm} · <b>{g.n}×</b> auf {g.geraete} {g.geraete === 1 ? "Gerät" : "Geräten"}{g.events ? ` · ${g.events} Event${g.events === 1 ? "" : "s"}` : ""} · {g.rollen.join(", ") || "?"} · zuletzt {uxZeit(g.zuletzt)}</div>
                  </button>
                  {o && (
                    <div style={{ fontSize: 12, color: C.sub, marginTop: 6, borderTop: `1px solid ${C.line}`, paddingTop: 6, wordBreak: "break-word" }}>
                      {g.beispiel && g.beispiel.weg && g.beispiel.weg.length > 0 && <div>Weg: {g.beispiel.weg.join(" → ")}</div>}
                      {g.beispiel && g.beispiel.stack && <div style={{ fontFamily: "monospace", fontSize: 11, marginTop: 4, whiteSpace: "pre-wrap" }}>{g.beispiel.stack}</div>}
                      <div style={{ marginTop: 4 }}>Version {g.version || "?"} · erstmals {uxZeit(g.erst)}</div>
                    </div>
                  )}
                  <div style={{ marginTop: 6, display: "flex", gap: 6 }}>
                    {g.status === "erledigt" || g.status === "ignorieren"
                      ? <button style={klein} onClick={() => setze(g.fp, "offen")}>wieder offen</button>
                      : <><button data-ux-erledigt={g.fp} style={klein} onClick={() => setze(g.fp, "erledigt")}>✓ erledigt</button><button style={klein} onClick={() => setze(g.fp, "ignorieren")}>ignorieren</button></>}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </>)}
    </div>
  );
}

// Stand 37i: Teamticket-Abos (Afterwork) -- nur im Buero-Modus anlegen/beenden
function AboVerwaltung({ buero, startOffen = false }) {
  const [abos, setAbos] = useState(null);
  const [neu, setNeu] = useState({ firma: "", termine: 10, plaetze: 6, lokal: "", von: todayIso(), bis: "" });
  const [err, setErr] = useState("");
  const [offen, setOffen] = useState(startOffen);
  const laden = useCallback(() => listAbos().then(setAbos).catch((e) => setErr(e.message)), []);
  useEffect(() => { if (offen) laden(); }, [offen, laden]);
  const inp = { border: `1px solid ${C.line}`, borderRadius: 8, padding: "7px 9px", fontSize: 14, fontFamily: font };
  const anlegen = async () => {
    setErr("");
    try { await createAbo(neu, buero); setNeu({ ...neu, firma: "", notiz: "" }); laden(); }
    catch (e) { setErr(e.serverMessage || e.message); }
  };
  return (
    <div data-abo-verwaltung="true" style={{ marginTop: 22 }}>
      <button data-abo-toggle onClick={() => setOffen((v) => !v)} style={{ border: "none", background: "none", padding: 0, fontSize: 11.5, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.6, cursor: "pointer", fontFamily: font }}>
        {offen ? "▾" : "▸"} 🍻 Teamticket-Abos (Afterwork)
      </button>
      {offen && (
        <div style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: 14, marginTop: 10, fontFamily: font }}>
          <div style={{ fontSize: 12.5, color: C.sub, marginBottom: 10, lineHeight: 1.45 }}>Abo = Block von Terminen mit fixen Plätzen je Termin — günstiger, mit reserviertem Tisch und Getränkegutschein für alle Spieler:innen der Firma. Gezählt wird automatisch: jeder Afterwork-Termin, bei dem jemand mit dem Abo eingetragen ist.</div>
          {abos === null ? <div style={{ fontSize: 13, color: C.sub }}>Lädt…</div> : abos.length === 0 ? <div style={{ fontSize: 13, color: C.sub }}>Noch keine Abos.</div> : abos.map((a) => (
            <div key={a.id} data-abo={a.firma} style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 0", borderTop: `1px solid ${C.line}`, opacity: a.aktiv ? 1 : 0.55, flexWrap: "wrap" }}>
              <span style={{ flex: 1, minWidth: 160 }}>
                <b style={{ fontSize: 14.5 }}>{a.firma}</b>
                <span style={{ display: "block", fontSize: 12.5, color: C.sub }}>{a.termine}er-Block · {a.plaetze} Plätze/Termin{" · alle Partnerlokale"}{a.bis ? ` · bis ${fmtEventDate(a.bis)}` : ""}</span>
              </span>
              <span data-abo-rest={a.rest} style={{ fontFamily: display, fontWeight: 800, fontSize: 16 }}>{a.genutzt}/{a.termine}</span>
              <button onClick={async () => { try { await setAboAktiv(a.id, !a.aktiv, buero); laden(); } catch (e) { setErr(e.serverMessage || e.message); } }}
                style={{ border: `1px solid ${C.line}`, background: "#fff", borderRadius: 8, padding: "5px 10px", fontSize: 12.5, fontWeight: 700, cursor: "pointer", fontFamily: font }}>{a.aktiv ? "beenden" : "wieder aktiv"}</button>
            </div>
          ))}
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", borderTop: `1px solid ${C.line}`, paddingTop: 10, marginTop: 6 }}>
            <input data-abo-firma value={neu.firma} onChange={(e) => setNeu({ ...neu, firma: e.target.value })} placeholder="Firma" style={{ ...inp, flex: 1, minWidth: 140 }} />
            <select data-abo-termine value={neu.termine} onChange={(e) => setNeu({ ...neu, termine: Number(e.target.value) })} style={inp}>
              <option value={10}>10er-Block</option><option value={20}>20er-Block</option>
            </select>
            <label style={{ fontSize: 13 }}>Plätze <input data-abo-plaetze type="number" min={1} max={50} value={neu.plaetze} onChange={(e) => setNeu({ ...neu, plaetze: Number(e.target.value) })} style={{ ...inp, width: 64 }} /></label>
            <label style={{ fontSize: 13 }}>bis <input type="date" value={neu.bis} onChange={(e) => setNeu({ ...neu, bis: e.target.value })} style={inp} /></label>
            <button data-abo-anlegen disabled={!neu.firma.trim()} onClick={anlegen} style={{ border: "none", background: neu.firma.trim() ? C.play : "#C7D3CC", color: "#fff", borderRadius: 8, padding: "8px 14px", fontWeight: 700, cursor: "pointer", fontFamily: font }}>+ Abo</button>
          </div>
          {err && <div style={{ color: C.whistle, fontSize: 13, marginTop: 8 }}>{err}</div>}
        </div>
      )}
    </div>
  );
}

// Stand 37m: Büro ordnet Träger/Projekt direkt in der Übersicht zu — auch im Archiv, ohne Wiederöffnen.
function ZweckZeile({ ev, onSave }) {
  const [edit, setEdit] = useState(false);
  const [tr, setTr] = useState(ev.traeger || traegerVorschlag(ev.format));
  const [proj, setProj] = useState(ev.projekt || "");
  const [busy, setBusy] = useState(false);
  const zweck = [ev.traeger ? TRAEGER[ev.traeger] || ev.traeger : null, ev.projekt || null].filter(Boolean).join(" · ");
  const fehlt = !ev.traeger;
  if (!edit) return (
    <button data-zweck-bearbeiten={ev.id} onClick={() => { setTr(ev.traeger || traegerVorschlag(ev.format)); setProj(ev.projekt || ""); setEdit(true); }}
      style={{ border: `1px dashed ${fehlt ? C.whistle : C.line}`, background: fehlt ? C.whistleSoft : "#fff", color: fehlt ? C.whistle : C.ink, borderRadius: 9, padding: "6px 10px", fontSize: 12.5, fontWeight: 700, cursor: "pointer", fontFamily: font, textAlign: "left" }}>
      🏷️ <span data-event-zweck>{zweck || "Träger/Projekt zuordnen"}</span>{zweck && !ev.projekt ? <span style={{ color: C.sub, fontWeight: 400 }}> · Projekt fehlt</span> : null}
    </button>
  );
  const save = async () => { setBusy(true); try { await onSave({ traeger: tr, projekt: proj.trim() }); setEdit(false); } finally { setBusy(false); } };
  return (
    <div data-zweck-form={ev.id} style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", width: "100%" }}>
      <select data-zweck-form-traeger value={tr} onChange={(e) => setTr(e.target.value)} style={{ border: `1px solid ${C.line}`, borderRadius: 8, padding: "6px 8px", fontFamily: font }}>
        {Object.entries(TRAEGER).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      <input data-zweck-form-projekt list="ms-projekte-buero" value={proj} onChange={(e) => setProj(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") save(); }} placeholder="Projekt/Förderung (optional)"
        style={{ flex: 1, minWidth: 150, border: `1px solid ${C.line}`, borderRadius: 8, padding: "6px 10px", fontFamily: font }} />
      <button data-zweck-form-speichern disabled={busy} onClick={save} style={{ border: "none", background: C.play, color: "#fff", borderRadius: 8, padding: "7px 12px", fontWeight: 700, cursor: "pointer", fontFamily: font }}>{busy ? "…" : "Speichern"}</button>
      <button onClick={() => setEdit(false)} style={{ border: "none", background: "none", color: C.sub, fontWeight: 700, cursor: "pointer", fontFamily: font }}>Abbrechen</button>
    </div>
  );
}

function EventKarte({ ev, onOpen, buero, onBuero, standortName = "" }) {
  const [codes, setCodes] = useState(null); // Stand 37p: Büro sieht die Codes ohne das Event zu öffnen
  const zeigeCodes = async () => {
    if (codes) { setCodes(null); return; }
    try { const r = await loadState(ev.id, { bueroCode: buero }); setCodes((r && r.state && r.state.tournament && r.state.tournament.pins) || {}); } catch (_) { setCodes({}); }
  };
  const f = formatById(ev.format);
  const closed = ev.status === "abgeschlossen";
  const deleted = ev.status === "geloescht";
  const sub = [standortName ? `🏠 ${standortName}` : null, f ? f.label : null, ev.ort, fmtEventDate(ev.datum)].filter(Boolean).join(" · ");
  const small = { border: `1px solid ${C.line}`, background: "#fff", color: C.ink, borderRadius: 9, padding: "6px 10px", fontSize: 12.5, fontWeight: 700, cursor: "pointer", fontFamily: font };
  return (
    <div data-event-karte={ev.id} style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: "14px 16px", display: "flex", flexDirection: "column", gap: 10, opacity: deleted ? 0.65 : 1 }}>
      <button onClick={deleted ? undefined : () => onOpen(ev)} disabled={deleted}
        style={{ display: "flex", alignItems: "center", gap: 12, textAlign: "left", background: "none", border: "none", padding: 0, cursor: deleted ? "default" : "pointer", fontFamily: font, color: C.ink }}>
        <span style={{ fontSize: 26, lineHeight: 1 }}>{f ? f.emo : "⚽"}</span>
        <span style={{ flex: 1, minWidth: 0 }}>
          <span style={{ display: "block", fontFamily: display, fontWeight: 700, fontSize: 17 }}>{ev.title || "Ohne Namen"}</span>
          <span style={{ display: "block", fontSize: 13, color: C.sub }}>{sub || "—"}</span>
          {!closed && !deleted && <LivePill info={eventLiveInfo(ev)} />}
        </span>
        {closed && <span style={{ background: C.brkSoft, color: "#8A5A00", borderRadius: 999, padding: "3px 9px", fontSize: 11, fontWeight: 700 }}>🔒 Archiv</span>}
        {deleted && <span style={{ background: C.whistleSoft, color: C.whistle, borderRadius: 999, padding: "3px 9px", fontSize: 11, fontWeight: 700 }}>gelöscht</span>}
        {!closed && !deleted && ev.publicFreigabe && <span style={{ background: C.playSoft, color: C.play, borderRadius: 999, padding: "3px 9px", fontSize: 11, fontWeight: 700 }}>öffentlich</span>}
        {!deleted && <span style={{ color: C.play, fontFamily: display, fontWeight: 700, fontSize: 18 }}>→</span>}
      </button>
      {buero && (
        <div data-buero-aktionen={ev.id} style={{ display: "flex", gap: 8, flexWrap: "wrap", borderTop: `1px solid ${C.line}`, paddingTop: 10 }}>
          {!deleted && <ZweckZeile ev={ev} onSave={(z) => onBuero("zweck", ev, z)} />}
          {!deleted && <button data-buero-codes={ev.id} style={small} onClick={zeigeCodes}>🔑 Codes</button>}
          {codes && (
            <div data-buero-codes-zeile={ev.id} style={{ width: "100%", background: C.playSoft, borderRadius: 10, padding: "8px 12px", display: "flex", gap: 16, flexWrap: "wrap", fontSize: 13.5 }}>
              <span>🎽 Headcoach <b style={{ fontFamily: display, fontSize: 17, letterSpacing: 2 }}>{codes.headcoach || "—"}</b></span>
              <span>🧢 Coach <b style={{ fontFamily: display, fontSize: 17, letterSpacing: 2 }}>{codes.coach || "—"}</b></span>
              {codes.team && (formatById(ev.format) || {}).tiefe === "voll" && <span>📱 Team <b style={{ fontFamily: display, fontSize: 17, letterSpacing: 2 }}>{codes.team}</b></span>}
            </div>
          )}
          {!deleted && <button data-buero-oeffnen={ev.id} style={{ ...small, background: C.ink, color: "#fff", borderColor: C.ink }} onClick={() => onBuero("oeffnen", ev)}>🗂️ Als Büro öffnen</button>}
          {closed && <button style={small} onClick={() => onBuero("reopen", ev)}>🔓 Wieder öffnen</button>}
          {!deleted && <button style={small} onClick={() => onBuero("freigabe", ev)}>{ev.publicFreigabe ? "🙈 Freigabe zurücknehmen" : "🌐 Öffentlich freigeben"}</button>}
          {!deleted && <button style={{ ...small, color: C.whistle, borderColor: C.whistle }} onClick={() => onBuero("delete", ev)}>🗑️ Löschen</button>}
          {deleted && <button style={small} onClick={() => onBuero("undelete", ev)}>↩︎ Wiederherstellen</button>}
        </div>
      )}
    </div>
  );
}

/* Stand 37m — Büro-Kalender: alle Events (offen + Archiv) im Monat, Farbe nach
   Träger, dazu ein Abo-Link (iCal) für Google/Apple/Outlook. Schritt 1 des
   gemeinsamen Kalenders mit der Academy (siehe PROJEKT-UEBERGABE 37m). */
const KAL_FARBE = { verein: C.play, gmbh: C.tore };
const MONATE = ["Jänner", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];
function BueroKalender({ events, bueroCode, onOpen }) {
  const heute = todayIso();
  const [monat, setMonat] = useState(heute.slice(0, 7));
  const [link, setLink] = useState("");
  const [linkErr, setLinkErr] = useState("");
  const [kopiert, setKopiert] = useState(false);
  const [y, m] = monat.split("-").map(Number);
  const offset = (new Date(y, m - 1, 1).getDay() + 6) % 7;
  const tage = new Date(y, m, 0).getDate();
  const evs = (events || []).filter((e) => e.status !== "geloescht");
  const tagVon = (e) => { const d = /^\d{4}-\d{2}-\d{2}/.exec(e.datum || ""); return d ? d[0] : null; };
  const byDay = {};
  evs.forEach((e) => { const d = tagVon(e); if (d) (byDay[d] = byDay[d] || []).push(e); });
  const sortKey = (e) => (tagVon(e) || "") + " " + (e.startzeit || "99:99");
  const imMonat = evs.filter((e) => (tagVon(e) || "").startsWith(monat)).sort((a, b) => sortKey(a).localeCompare(sortKey(b)));
  const ohneDatum = evs.filter((e) => !tagVon(e));
  const shift = (n) => { const d = new Date(y, m - 1 + n, 1); setMonat(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`); };
  const farbe = (e) => KAL_FARBE[e.traeger] || C.whistle;
  const holeLink = async () => {
    setLinkErr("");
    try { setLink(await kalenderLink(bueroCode)); } catch (e) { setLinkErr(e.serverMessage || e.message || "Link nicht verfügbar"); }
  };
  const kopieren = async () => { try { await navigator.clipboard.writeText(link); setKopiert(true); setTimeout(() => setKopiert(false), 1800); } catch (_) { setKopiert(false); } };
  const nav = { border: `1px solid ${C.line}`, background: "#fff", borderRadius: 9, padding: "6px 12px", fontWeight: 700, cursor: "pointer", fontFamily: font, color: C.ink };
  const zeile = (e) => {
    const f = formatById(e.format); const closed = e.status === "abgeschlossen";
    const d = tagVon(e);
    return (
      <button key={e.id} data-kal-event={e.id} onClick={() => onOpen(e)} style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", textAlign: "left", background: "#fff", border: `1px solid ${C.line}`, borderLeft: `5px solid ${farbe(e)}`, borderRadius: 10, padding: "9px 12px", cursor: "pointer", fontFamily: font, color: C.ink, opacity: closed ? 0.6 : 1 }}>
        <span style={{ width: 54, flex: "none", fontSize: 12.5, color: C.sub, fontWeight: 700 }}>{d ? `${Number(d.slice(8, 10))}.${Number(d.slice(5, 7))}.` : "—"}<br />{e.startzeit || ""}</span>
        <span style={{ fontSize: 20 }}>{f ? f.emo : "⚽"}</span>
        <span style={{ flex: 1, minWidth: 0 }}>
          <span style={{ display: "block", fontWeight: 700, fontSize: 14.5 }}>{e.title || "Ohne Namen"}{closed ? " 🔒" : ""}</span>
          <span style={{ display: "block", fontSize: 12, color: C.sub }}>{[f ? f.label : null, e.ort, e.traeger ? TRAEGER[e.traeger] || e.traeger : "Träger fehlt", e.projekt || null].filter(Boolean).join(" · ")}</span>
        </span>
      </button>
    );
  };
  return (
    <div data-buero-kalender-ansicht="true">
      <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "4px 0 12px" }}>
        <button data-kal-zurueck onClick={() => shift(-1)} style={nav}>‹</button>
        <div data-kal-monat={monat} style={{ flex: 1, textAlign: "center", fontFamily: display, fontWeight: 700, fontSize: 19 }}>{MONATE[m - 1]} {y}</div>
        <button data-kal-weiter onClick={() => shift(1)} style={nav}>›</button>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 3, background: "#fff", border: `1px solid ${C.line}`, borderRadius: 14, padding: 6 }}>
        {["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"].map((t) => <div key={t} style={{ textAlign: "center", fontSize: 11, fontWeight: 700, color: C.sub, padding: "2px 0" }}>{t}</div>)}
        {Array.from({ length: offset }).map((_, i) => <div key={"x" + i} />)}
        {Array.from({ length: tage }).map((_, i) => {
          const iso = `${monat}-${String(i + 1).padStart(2, "0")}`;
          const list = byDay[iso] || [];
          return (
            <div key={iso} data-kal-tag={iso} style={{ minHeight: 46, borderRadius: 8, padding: 3, background: iso === heute ? C.playSoft : list.length ? "#F7FAF8" : "transparent", border: iso === heute ? `1px solid ${C.play}` : "1px solid transparent" }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: iso === heute ? C.play : C.sub }}>{i + 1}</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                {list.slice(0, 4).map((e) => { const f = formatById(e.format); return <span key={e.id} title={e.title} onClick={() => onOpen(e)} style={{ cursor: "pointer", fontSize: 13, lineHeight: "18px", width: 18, textAlign: "center", borderRadius: 5, background: farbe(e) + "33", borderBottom: `2px solid ${farbe(e)}`, opacity: e.status === "abgeschlossen" ? 0.55 : 1 }}>{f ? f.emo : "⚽"}</span>; })}
                {list.length > 4 && <span style={{ fontSize: 10, color: C.sub }}>+{list.length - 4}</span>}
              </div>
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", fontSize: 11.5, color: C.sub, margin: "8px 2px 0" }}>
        <span><b style={{ color: C.play }}>■</b> Verein</span><span><b style={{ color: C.tore }}>■</b> GmbH</span><span><b style={{ color: C.whistle }}>■</b> Träger fehlt</span><span>blass = abgeschlossen</span>
      </div>
      <div style={{ fontSize: 11.5, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.6, margin: "20px 0 8px" }}>{MONATE[m - 1]}: {imMonat.length ? `${imMonat.length} Event${imMonat.length === 1 ? "" : "s"}` : "keine Events"}</div>
      <div data-kal-liste style={{ display: "grid", gap: 8 }}>{imMonat.map(zeile)}</div>
      {ohneDatum.length > 0 && (<>
        <div style={{ fontSize: 11.5, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.6, margin: "20px 0 8px" }}>Ohne Datum ({ohneDatum.length})</div>
        <div style={{ display: "grid", gap: 8 }}>{ohneDatum.map(zeile)}</div>
      </>)}
      <div data-kal-abo style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 14, padding: 14, marginTop: 20, fontSize: 13.5 }}>
        <div style={{ fontWeight: 700, marginBottom: 4 }}>📲 Im eigenen Kalender sehen</div>
        <div style={{ color: C.sub, marginBottom: 10 }}>Ein Abo-Link für Google, Apple oder Outlook. Neue und geänderte Events kommen von selbst nach. Nur intern weitergeben.</div>
        {!link ? (
          <button data-kal-link-holen onClick={holeLink} style={{ border: "none", background: C.ink, color: "#fff", borderRadius: 10, padding: "9px 14px", fontWeight: 700, cursor: "pointer", fontFamily: font }}>🔗 Abo-Link anzeigen</button>
        ) : (
          <div style={{ display: "grid", gap: 8 }}>
            <input data-kal-link readOnly value={link} onFocus={(e) => e.target.select()} style={{ border: `1px solid ${C.line}`, borderRadius: 8, padding: "8px 10px", fontSize: 12.5, fontFamily: "monospace", width: "100%" }} />
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <button data-kal-kopieren onClick={kopieren} style={{ border: "none", background: C.play, color: "#fff", borderRadius: 10, padding: "8px 12px", fontWeight: 700, cursor: "pointer", fontFamily: font }}>{kopiert ? "✓ Kopiert" : "Kopieren"}</button>
              <a data-kal-webcal href={link.replace(/^https?:/, "webcal:")} style={{ border: `1px solid ${C.line}`, color: C.ink, borderRadius: 10, padding: "8px 12px", fontWeight: 700, textDecoration: "none", fontSize: 13.5 }}>In Kalender-App öffnen</a>
            </div>
            <div style={{ color: C.sub, fontSize: 12 }}>Google Kalender: „Weitere Kalender" → „Per URL" → Link einfügen. Apple/Outlook: „In Kalender-App öffnen".</div>
          </div>
        )}
        {linkErr && <div style={{ color: C.whistle, marginTop: 8 }}>{linkErr}</div>}
      </div>
    </div>
  );
}

/* Stand 37n — Kurz-Erklärung am Startbildschirm (Nutzer: Pop-up, nach 3x nicht
   mehr, oder ein „?" das nicht stört). Beides: die ersten 3 Besuche kommt sie von
   selbst (mit „Nicht mehr anzeigen"), danach jederzeit über das „?" oben rechts. */
const HILFE_KEY = "microsoccer_hilfe_start_v1";
const HILFE_MAX = 3;
function hilfeLesen() { try { const v = JSON.parse(window.localStorage.getItem(HILFE_KEY) || "{}"); return { n: Number(v.n) || 0, aus: !!v.aus }; } catch (_) { return { n: 0, aus: false }; } }
function hilfeSchreiben(v) { try { window.localStorage.setItem(HILFE_KEY, JSON.stringify(v)); } catch (_) { /* noop */ } }
const HILFE_PUNKTE = [
  ["🔑", "Code oder Link", "Du bekommst einen Link oder Code für dein Event (vom Büro bzw. Headcoach). Code eingeben → du bist direkt drin."],
  ["🧢", "Coach & Headcoach", "Die Anmeldung ist dein Check-in, vor dem Gehen checkst du unter „Ich\u201c aus."],
  ["📱", "Team-Handy", "Mit dem Team-Code von eurem Coach, dann euer Team antippen."],
  ["👀", "Zuschauen", "Über den QR-Code beim Event: Live-Tabelle und Ergebnisse, ohne Anmeldung."],
  ["⚡", "Im Event", "Unten immer drei Knöpfe: Jetzt (was gerade dran ist), Tabelle, Ich."],
];
function StartHilfe() {
  const [offen, setOffen] = useState(false);
  const [automatisch, setAutomatisch] = useState(false);
  useEffect(() => {
    const v = hilfeLesen();
    if (v.aus || v.n >= HILFE_MAX) return;
    try { if (new URLSearchParams(window.location.search).has("buero")) return; } catch (_) { /* noop */ } // Stand 37t: Büro-Direktlink ohne Erklär-Pop-up
    hilfeSchreiben({ ...v, n: v.n + 1 });
    setAutomatisch(true); setOffen(true);
  }, []);
  const zu = () => setOffen(false);
  const nieWieder = () => { hilfeSchreiben({ ...hilfeLesen(), aus: true }); setOffen(false); };
  return (
    <>
      <button data-hilfe-fragezeichen aria-label="Kurz erklärt" title="Kurz erklärt" onClick={() => { setAutomatisch(false); setOffen(true); }}
        style={{ position: "absolute", top: 14, right: 14, width: 34, height: 34, borderRadius: "50%", border: `1px solid ${C.line}`, background: "#fff", color: C.sub, fontFamily: display, fontWeight: 700, fontSize: 17, cursor: "pointer", boxShadow: "0 2px 6px rgba(0,0,0,.06)" }}>?</button>
      {offen && (
        <div data-hilfe-start="true" role="dialog" aria-modal="true" onClick={zu} style={{ position: "fixed", inset: 0, background: "rgba(19,36,28,.45)", display: "flex", alignItems: "flex-end", justifyContent: "center", zIndex: 1000, padding: 12 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: "#fff", borderRadius: 20, maxWidth: 520, width: "100%", maxHeight: "88vh", overflowY: "auto", padding: "20px 18px 16px", fontFamily: font, color: C.ink, boxShadow: "0 -6px 30px rgba(0,0,0,.18)" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
              <span style={{ fontSize: 24 }}>⚽</span>
              <h2 style={{ fontFamily: display, fontWeight: 700, fontSize: 20, margin: 0, flex: 1 }}>So funktioniert's</h2>
              <button aria-label="Schließen" onClick={zu} style={{ border: "none", background: "none", fontSize: 22, color: C.sub, cursor: "pointer", lineHeight: 1 }}>×</button>
            </div>
            <p style={{ color: C.sub, fontSize: 13.5, margin: "0 0 12px" }}>Matchday — die Microsoccer-App für den Eventtag: zählen, werten, feiern. Tipp einfach an, was du gerade machen willst.</p>
            <div style={{ display: "grid", gap: 10 }}>
              {HILFE_PUNKTE.map(([emo, titel, text]) => (
                <div key={titel} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                  <span style={{ fontSize: 20, width: 26, textAlign: "center", flex: "none" }}>{emo}</span>
                  <span style={{ fontSize: 13.5, lineHeight: 1.45 }}><b>{titel}</b> — {text}</span>
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: 10, marginTop: 16, alignItems: "center", flexWrap: "wrap" }}>
              <button data-hilfe-ok onClick={zu} style={{ flex: 1, minWidth: 140, border: "none", background: C.play, color: "#fff", borderRadius: 12, padding: "12px", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: display }}>Alles klar</button>
              {automatisch && <button data-hilfe-nie onClick={nieWieder} style={{ border: "none", background: "none", color: C.sub, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: font, textDecoration: "underline" }}>Nicht mehr anzeigen</button>}
            </div>
            <div style={{ fontSize: 11.5, color: C.sub, marginTop: 10, textAlign: "center" }}>Die Erklärung findest du jederzeit wieder unter dem <b>?</b> oben rechts.</div>
          </div>
        </div>
      )}
    </>
  );
}

// "Heute" vor dem Einstieg: alle laufenden Events, + Neues Event, Archiv.
// Für alle sichtbar (Coaches, Teamhandys, Zuschauer:innen) — hinein kommt
// man danach wie bisher über Startseite + Code DIESES Events.
function EventListe() {
  const nav = useEventNav();
  const [events, setEvents] = useState(null);
  const [err, setErr] = useState("");
  const [showNew, setShowNew] = useState(false);
  const [showArchiv, setShowArchiv] = useState(false);
  const [buero, setBuero] = useState(""); // Büro-Code, nur im Speicher dieser Seite
  const [intent, setIntent] = useState(null); // Stand 35: gewaehlte Einstiegskachel
  const [bereich, setBereich] = useState("heute"); // Stand 37: Schule/Freizeit/Business nur hier
  const [neuFormat, setNeuFormat] = useState(null);
  const [bueroAsk, setBueroAsk] = useState(false);
  // Stand 37t: Direktlink ?buero (Portal „Intern → Büro") → eigener Büro-Eingang: nur Code eingeben, keine Event-Liste
  const [bueroDirekt, setBueroDirekt] = useState(() => { try { return new URLSearchParams(window.location.search).has("buero"); } catch (_) { return false; } });
  const [bueroInput, setBueroInput] = useState("");
  const [bueroErr, setBueroErr] = useState("");
  const load = useCallback(async () => {
    setErr("");
    try { setEvents(await listEvents({ bueroCode: buero, includeDeleted: !!buero })); }
    catch (e) { setErr(e.message || "Event-Liste konnte nicht geladen werden"); }
  }, [buero]);
  useEffect(() => { load(); }, [load]);

  const open = (ev) => nav.choose(ev.id); // Stand 37p: erst Event, dann "Wer bist du?"
  const [bueroTab, setBueroTab] = useState("events"); // Stand 37p: Büro = eigener Bereich
  // Stand 37q: Standorte fürs Büro (Namen an den Karten + Filter)
  const [bueroOrte, setBueroOrte] = useState([]);
  const [standortFilter, setStandortFilter] = useState("");
  const ladeOrte = useCallback(() => { if (buero) listOrte(buero).then(setBueroOrte).catch(() => setBueroOrte([])); }, [buero]);
  useEffect(() => { ladeOrte(); }, [ladeOrte]);
  const loginBuero = async () => {
    setBueroErr("");
    try { await checkBuero(bueroInput.trim()); setBuero(bueroInput.trim()); setBueroAsk(false); setBueroInput(""); }
    catch (e) { setBueroErr(e.status === 503 ? "Büro-Code ist auf dem Server noch nicht eingerichtet." : "Büro-Code falsch."); }
  };
  const [kalender, setKalender] = useState(false); // Stand 37m: Büro-Kalender statt Liste
  const onBuero = async (what, ev, extra) => {
    // Stand 37f (Nutzer: "Büro soll überall Zugriff haben"): ins Event als Headcoach, ohne PIN
    if (what === "oeffnen") { lsSet(`microsoccer_buero_ev:${ev.id}`, "1"); nav.choose(ev.id, { asHeadcoach: true, bueroCode: buero }); return; }
    try {
      if (what === "delete") {
        let ok = false;
        try { ok = window.confirm(`„${ev.title}" löschen? Das Event verschwindet aus der Liste. Die Daten bleiben gespeichert und das Büro kann es wiederherstellen.`); } catch (_) { ok = false; }
        if (!ok) return;
        await deleteEvent(ev.id, buero);
      } else if (what === "undelete") await undeleteEvent(ev.id, buero);
      else if (what === "reopen") await reopenEvent(ev.id, { bueroCode: buero });
      else if (what === "freigabe") await setEventFreigabe(ev.id, !ev.publicFreigabe, buero);
      else if (what === "zweck") await setEventZweck(ev.id, extra || {}, buero);
      await load();
    } catch (e) {
      try { window.alert("Hat nicht geklappt: " + (e.serverMessage || e.message)); } catch (_) { /* noop */ }
    }
  };

  // Stand 40: Usability-Schleife -- Bildschirm außerhalb eines Events
  const uxSchirm = buero ? `buero/${bueroTab}` : bueroDirekt ? "buero/eingang" : "start/code";
  useEffect(() => { uxKontext({ rolle: buero ? "buero" : null, eventId: null }); uxBildschirm(uxSchirm); }, [uxSchirm, buero]);
  const list = events || [];
  const laufend = list.filter((e) => e.status === "offen");
  const liveJetzt = laufend.filter((e) => { const i = eventLiveInfo(e); return i && i.live; });
  const offenRest = laufend.filter((e) => !liveJetzt.includes(e));
  const archiv = list.filter((e) => e.status === "abgeschlossen");
  const geloescht = list.filter((e) => e.status === "geloescht");
  const h = { fontSize: 11.5, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.6, margin: "22px 0 10px" };
  const projektListe = Array.from(new Set(list.map((e) => (e.projekt || "").trim()).filter(Boolean)));
  const fehlerBox = err ? (
    <div style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: 16, fontSize: 14 }}>
      <div style={{ color: C.whistle, fontWeight: 700, marginBottom: 6 }}>Keine Verbindung zum Server.</div>
      <div style={{ color: C.sub, marginBottom: 12 }}>{err}</div>
      <button onClick={load} style={{ border: "none", background: C.play, color: "#fff", borderRadius: 10, padding: "9px 14px", fontWeight: 700, cursor: "pointer", fontFamily: font }}>Nochmal versuchen</button>
    </div>
  ) : null;
  const standortName = (id) => { const o = bueroOrte.find((x) => x.id === id); return o ? o.name : ""; };
  const imFilter = (ev) => !standortFilter || (standortFilter === "-" ? !ev.standortId : ev.standortId === standortFilter);
  const karten = (evs, alsBuero) => <div style={{ display: "grid", gap: 10 }}>{evs.filter((ev) => !alsBuero || imFilter(ev)).map((ev) => <EventKarte key={ev.id} ev={ev} onOpen={alsBuero ? (x) => onBuero("oeffnen", x) : open} buero={alsBuero} onBuero={onBuero} standortName={alsBuero ? standortName(ev.standortId) : ""} />)}</div>;
  const bueroStandorte = bueroOrte.filter((o) => o.typ === "standort" && o.aktiv);
  const kopf = (titel, unter) => (
    <div style={{ textAlign: "center", marginBottom: 22 }}>
      <div style={{ display: "inline-flex", background: C.play, borderRadius: 18, padding: "14px 18px", boxShadow: "0 6px 20px rgba(39,166,97,.25)" }}>
        <img src={LOGO_WHITE} alt={BRAND} style={{ height: 38, width: "auto" }} />
      </div>
      <h1 style={{ fontFamily: display, fontWeight: 700, fontSize: 26, margin: "16px 0 4px" }}>{titel}</h1>
      <div style={{ color: C.sub, fontSize: 14 }}>{unter}</div>
    </div>
  );

  /* ---------- Stand 37t: Büro-Eingang (Direktlink ?buero) — nur der Code, nichts anderes ---------- */
  if (!buero && bueroDirekt) {
    const zurListe = () => { setBueroDirekt(false); setBueroErr(""); try { const u = new URL(window.location.href); u.searchParams.delete("buero"); window.history.replaceState(null, "", u.toString()); } catch (_) { /* noop */ } };
    return (
      <div data-buero-eingang="true" style={{ background: C.chalk, minHeight: "100vh", fontFamily: font, color: C.ink, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
        <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
        <form onSubmit={(e) => { e.preventDefault(); loginBuero(); }} style={{ width: "100%", maxWidth: 380, background: C.card, borderRadius: 20, padding: "28px 22px", boxShadow: "0 10px 30px rgba(0,0,0,.08)", textAlign: "center", display: "flex", flexDirection: "column", gap: 14 }}>
          <div style={{ fontSize: 44, lineHeight: 1 }}>🗂️</div>
          <h1 style={{ fontFamily: display, fontWeight: 700, fontSize: 28, margin: 0 }}>Büro</h1>
          <div style={{ color: C.sub, fontSize: 14 }}>Events anlegen, Codes, Kalender, Orte, Stunden, Abos.</div>
          <input data-buero-code autoFocus value={bueroInput} onChange={(e) => setBueroInput(e.target.value)} type="password" placeholder="Büro-Code" autoComplete="current-password"
            style={{ border: `2px solid ${C.line}`, borderRadius: 12, padding: "13px 14px", fontSize: 17, fontFamily: font, textAlign: "center" }} />
          {bueroErr && <div role="alert" style={{ color: C.whistle, fontSize: 14, fontWeight: 700 }}>{bueroErr}</div>}
          <button type="submit" disabled={!bueroInput.trim()} style={{ border: "none", background: C.ink, color: "#fff", borderRadius: 999, padding: "14px", fontWeight: 800, fontSize: 16, cursor: "pointer", fontFamily: font, opacity: bueroInput.trim() ? 1 : 0.5 }}>Ins Büro</button>
          <button type="button" onClick={zurListe} style={{ border: "none", background: "none", color: C.sub, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: font, textDecoration: "underline" }}>Zum Start</button>
        </form>
      </div>
    );
  }

  /* ---------- Büro: eigener Bereich mit eigener Leiste ---------- */
  if (buero) {
    const BUERO_TABS = [
      { id: "events", label: "Events", emo: "🗂️" },
      { id: "kalender", label: "Kalender", emo: "📅" },
      { id: "orte", label: "Orte", emo: "📍" }, // Stand 37q
      { id: "auswertung", label: "Auswertung", emo: "📊" }, // Stand 37s: Stunden + Wirkung
      { id: "abos", label: "Abos", emo: "🍻" },
      { id: "usability", label: "Usability", emo: "🧭" }, // Stand 40
    ];
    return (
      <div data-event-liste="true" data-buero-bereich={bueroTab} style={{ background: C.chalk, minHeight: "100vh", fontFamily: font, color: C.ink, paddingBottom: 84 }}>
        <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
        <div style={{ maxWidth: 620, margin: "0 auto", padding: "20px 16px 48px" }}>
          <div data-buero-aktiv="true" style={{ background: "#14231B", color: "#fff", borderRadius: 12, padding: "10px 14px", display: "flex", alignItems: "center", gap: 10, marginBottom: 16, fontSize: 13.5 }}>
            <span style={{ flex: 1 }}>🗂️ <b>Büro</b> · Events, Kalender, Orte, Stunden, Abos</span>
            <button data-buero-beenden onClick={() => { setBuero(""); setBueroTab("events"); setBueroDirekt(false); setUrlEvent(null); }} style={{ border: "1px solid rgba(255,255,255,.5)", background: "transparent", color: "#fff", borderRadius: 8, padding: "5px 10px", fontSize: 12.5, fontWeight: 700, cursor: "pointer" }}>Beenden</button>
          </div>

          {bueroTab === "events" && (<>
            <button data-einstieg="neu" onClick={() => { setNeuFormat(null); setShowNew(true); }}
              style={{ width: "100%", border: "none", background: C.play, color: "#fff", borderRadius: 14, padding: "13px 16px", fontSize: 15, fontWeight: 700, cursor: "pointer", fontFamily: display, letterSpacing: 0.4 }}>🆕 Neues Event anlegen</button>
            <button data-formate-ansehen onClick={() => setBueroTab("neu")} style={{ display: "block", margin: "8px auto 0", border: "none", background: "none", color: C.sub, fontSize: 12.5, fontWeight: 700, cursor: "pointer", textDecoration: "underline", fontFamily: font }}>📚 Alle Formate ansehen</button>
            {bueroStandorte.length > 0 && (
              <div data-standort-filter style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 12 }}>
                {[{ id: "", name: "Alle" }, ...bueroStandorte, { id: "-", name: "ohne Homebase" }].map((o) => (
                  <button key={o.id || "alle"} data-standort-chip={o.id || "alle"} onClick={() => setStandortFilter(o.id)}
                    style={{ border: `1px solid ${standortFilter === o.id ? C.play : C.line}`, background: standortFilter === o.id ? C.playSoft : "#fff", color: C.ink, borderRadius: 999, padding: "5px 11px", fontSize: 12.5, fontWeight: 700, cursor: "pointer", fontFamily: font }}>{o.id && o.id !== "-" ? "🏠 " : ""}{o.name}</button>
                ))}
              </div>
            )}
            {fehlerBox || (events === null ? <div style={{ color: C.sub, fontSize: 14, marginTop: 16 }}>Lädt…</div> : (<>
              <div style={h}>Offen ({laufend.length})</div>
              {laufend.length ? karten([...liveJetzt, ...offenRest], true) : <div style={{ color: C.sub, fontSize: 14 }}>Gerade ist nichts offen.</div>}
              {archiv.length > 0 && (<><div style={h}>Archiv ({archiv.length})</div>{karten(archiv, true)}</>)}
              {geloescht.length > 0 && (<><div style={h}>Gelöscht ({geloescht.length})</div>{karten(geloescht, true)}</>)}
            </>))}
          </>)}
          {bueroTab === "kalender" && <BueroKalender events={list} bueroCode={buero} onOpen={(ev) => onBuero("oeffnen", ev)} />}
          {bueroTab === "neu" && (
            <div data-buero-neu="true">
              <button onClick={() => setBueroTab("events")} style={{ border: "none", background: "none", color: C.sub, fontSize: 13.5, fontWeight: 700, cursor: "pointer", fontFamily: font, padding: 0, marginBottom: 6 }}>← Events</button>
              <div style={{ fontSize: 13.5, color: C.sub, margin: "0 0 4px" }}>Format antippen → Name, Ort, Datum → fertig. Danach bekommst du die Codes zum Weitergeben.</div>
              {["schule", "freizeit", "business"].map((b) => (
                <div key={b} style={{ margin: "0 -20px" }}>
                  <BereichView bereich={b} currentFormatId={null} canPick pickLabel="Neues Event mit diesem Format →"
                    onPick={(f) => {
                      if (f.kind === "bald") return;
                      if (f.kind === "link") { try { window.open(f.href, "_blank", "noopener"); } catch (_) {} return; }
                      setNeuFormat(f.id); setShowNew(true);
                    }} />
                </div>
              ))}
            </div>
          )}
          {bueroTab === "orte" && <OrteVerwaltung buero={buero} onGeaendert={ladeOrte} />}
          {bueroTab === "auswertung" && <Auswertung buero={buero} standorte={bueroStandorte} projekte={projektListe} />}
          {bueroTab === "abos" && <AboVerwaltung buero={buero} startOffen />}
          {bueroTab === "usability" && <UsabilityBericht buero={buero} events={list} />}
        </div>
        <datalist id="ms-projekte-buero">{projektListe.map((p) => <option key={p} value={p} />)}</datalist>
        <MainTabBar tabs={BUERO_TABS} tab={bueroTab === "neu" ? "events" : bueroTab} onTab={setBueroTab} />
        <HaktKnopf unten={84} />
        <NeuesEventDialog open={showNew} bueroCode={buero} initialFormat={neuFormat} projektListe={projektListe} onClose={() => setShowNew(false)} onCreated={(ev) => { setShowNew(false); lsSet(`microsoccer_buero_ev:${ev.id}`, "1"); nav.choose(ev.id, { asHeadcoach: true, bueroCode: buero }); }} />
      </div>
    );
  }

  /* ---------- Stand 37v: Startseite für alle = nur „Dein Code" ----------
     (Nutzer: „Link + Code-Feld", „Büro verstecken bis Playmaker"). Keine Event-Liste, kein Büro-Knopf:
     Coaches/Headcoach kommen über ihren persönlichen Link oder den Code; Zuschauer:innen über den Gäste-QR;
     das Büro über matchday…/?buero (Portal → Intern). Die Liste lebt im Büro weiter. */
  return <CodeStart onTreffer={(t, c) => nav.choose(t.eventId, c ? { code: c } : {})} />;
}

function CodeStart({ onTreffer }) {
  const [code, setCode] = useState(() => linkCode() || ""); // auch Link nur mit ?code=…
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [auswahl, setAuswahl] = useState(null); // mehrere Events mit demselben Code
  const ROLLE = { headcoach: "🎽 Headcoach", coach: "🧢 Coach", team: "📱 Team-Handy", gast: "🧢 Coach (Gast)" };
  // Stand 39: Rückkehr vom Academy-Login (?sso=…) — Sitzungen merken, dann direkt ins Event (oder Auswahl)
  const [sso, setSso] = useState(null); // { person, treffer } | { fehler }
  useEffect(() => {
    let q; try { q = new URLSearchParams(window.location.search); } catch (_) { return; }
    const c = q.get("sso"), f = q.get("sso_fehler");
    if (!c && !f) return;
    try { window.history.replaceState(null, "", window.location.pathname); } catch (_) { /* noop */ }
    if (f) { setSso({ fehler: f }); return; }
    ssoEinloesen(c).then((d) => {
      for (const t of d.treffer || []) setzeSitzung(t.eventId, { token: t.token, rolle: t.rolle, personId: d.person.id, name: d.person.name });
      if ((d.treffer || []).length === 1) onTreffer(d.treffer[0], null); else setSso(d);
    }).catch((e) => setSso({ fehler: e.serverMessage || "Anmeldung abgelaufen — bitte nochmal." }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const los = async (e) => {
    if (e) e.preventDefault();
    const c = code.trim();
    if (!/^\d{4,8}$/.test(c)) { setErr("Der Code hat 4 bis 8 Ziffern."); return; }
    setBusy(true); setErr(""); setAuswahl(null);
    try {
      const t = await einstieg(c);
      if (t.length === 1) onTreffer(t[0], c); else setAuswahl(t.map((x) => ({ ...x, code: c })));
    } catch (ex) {
      setErr(ex.status === 429 ? "Zu viele falsche Codes — bitte in 15 Minuten nochmal." : ex.status === 404 ? "Diesen Code gibt es nicht (oder das Event ist schon vorbei)." : "Keine Verbindung — bitte nochmal.");
    } finally { setBusy(false); }
  };
  useEffect(() => { if (linkCode()) { linkCodeVerbraucht(); setUrlEvent(null); los(); } }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div data-event-liste="true" data-code-start="true" style={{ background: C.chalk, minHeight: "100vh", fontFamily: font, color: C.ink }}>
      <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
      <div style={{ maxWidth: 440, margin: "0 auto", padding: "48px 18px", position: "relative" }}>
        <StartHilfe />
        <div style={{ textAlign: "center", marginBottom: 26 }}>
          <div style={{ display: "inline-flex", background: C.play, borderRadius: 18, padding: "14px 18px", boxShadow: "0 6px 20px rgba(39,166,97,.25)" }}>
            <img src={LOGO_WHITE} alt={BRAND} style={{ height: 38, width: "auto" }} />
          </div>
          <h1 style={{ fontFamily: display, fontWeight: 700, fontSize: 28, margin: "16px 0 4px" }}>Matchday</h1>
          <div style={{ color: C.sub, fontSize: 14.5 }}>Gib deinen Code fürs Event ein.</div>
        </div>
        {/* Stand 39: Coaches melden sich mit ihrer Academy-Nummer (MS-xxxx) an und landen direkt bei ihrem Team */}
        <a data-academy-login href={academyLoginUrl()} style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, textDecoration: "none", background: C.ink, color: "#fff", borderRadius: 16, padding: "15px 16px", fontFamily: display, fontWeight: 800, fontSize: 17, marginBottom: 12 }}>
          🎓 Mit Academy anmelden <span style={{ fontFamily: font, fontWeight: 600, fontSize: 12.5, opacity: 0.8 }}>MS-Nummer</span>
        </a>
        {sso && sso.fehler && <div data-sso-fehler role="alert" style={{ color: C.whistle, fontSize: 13.5, textAlign: "center", marginBottom: 10 }}>{sso.fehler}</div>}
        {sso && sso.person && (
          <div data-sso-auswahl style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 18, padding: 14, marginBottom: 12, display: "grid", gap: 8 }}>
            <div style={{ fontSize: 14, textAlign: "center" }}>Hallo <b>{sso.person.name}</b> ({sso.person.id})</div>
            {sso.treffer.length === 0
              ? <div data-sso-kein-einsatz style={{ fontSize: 13.5, color: C.sub, textAlign: "center", lineHeight: 1.5 }}>Du bist heute keinem Event zugeteilt. Bitte beim Headcoach oder im Büro melden.</div>
              : sso.treffer.map((t) => (
                <button key={t.eventId} data-sso-treffer={t.eventId} onClick={() => onTreffer(t, null)}
                  style={{ display: "flex", alignItems: "center", gap: 12, textAlign: "left", background: C.chalk, border: `1px solid ${C.line}`, borderRadius: 14, padding: "12px 14px", cursor: "pointer", fontFamily: font, color: C.ink }}>
                  <span style={{ width: 36, height: 36, borderRadius: 10, background: (t.team && t.team.color) || C.play, display: "grid", placeItems: "center", fontSize: 20 }}>{t.team ? t.team.emoji : t.rolle === "headcoach" ? "🎽" : "🧢"}</span>
                  <span style={{ flex: 1 }}><b style={{ display: "block" }}>{t.title || "Event"}</b><span style={{ fontSize: 12.5, color: C.sub }}>{[t.rolle === "headcoach" ? "🎽 Headcoach" : t.team ? `🧢 Coach von ${t.team.name}` : "🧢 Coach (noch ohne Team)", t.ort, fmtEventDate(t.datum)].filter(Boolean).join(" · ")}</span></span>
                  <span style={{ color: C.play, fontWeight: 700 }}>→</span>
                </button>
              ))}
          </div>
        )}
        <div style={{ textAlign: "center", fontSize: 12.5, color: C.sub, margin: "4px 0 10px" }}>— oder mit Code (Gäste, Headcoach) —</div>
        <form onSubmit={los} style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 20, padding: "22px 18px", display: "flex", flexDirection: "column", gap: 12 }}>
          <input data-start-code value={code} onChange={(e) => { setCode(e.target.value.replace(/[^0-9]/g, "").slice(0, 8)); setErr(""); }}
            inputMode="numeric" autoComplete="one-time-code" placeholder="Code" aria-label="Code"
            style={{ width: "100%", textAlign: "center", fontFamily: display, fontWeight: 700, fontSize: 30, letterSpacing: 8, padding: "12px 10px", border: `2px solid ${err ? C.whistle : C.line}`, borderRadius: 14, color: C.ink, outline: "none" }} />
          {err && <div data-start-fehler role="alert" style={{ color: C.whistle, fontSize: 13.5, textAlign: "center" }}>{err}</div>}
          <button data-start-los type="submit" disabled={busy || code.length < 4}
            style={{ border: "none", background: code.length >= 4 ? C.play : "#C7D3CC", color: "#fff", borderRadius: 12, padding: "14px", fontSize: 16, fontWeight: 700, cursor: code.length >= 4 ? "pointer" : "default", fontFamily: display, letterSpacing: 0.5 }}>{busy ? "…" : "Los →"}</button>
        </form>
        {auswahl && (
          <div data-start-auswahl style={{ marginTop: 14, display: "grid", gap: 8 }}>
            <div style={{ fontSize: 13, color: C.sub, textAlign: "center" }}>Der Code passt zu mehreren Events — welches?</div>
            {auswahl.map((t) => {
              const f = formatById(t.format);
              return (
                <button key={t.eventId + t.rolle} data-start-treffer={t.eventId} onClick={() => onTreffer(t, t.code)}
                  style={{ display: "flex", alignItems: "center", gap: 12, textAlign: "left", background: "#fff", border: `1px solid ${C.line}`, borderRadius: 14, padding: "12px 14px", cursor: "pointer", fontFamily: font, color: C.ink }}>
                  <span style={{ fontSize: 22 }}>{f ? f.emo : "⚽"}</span>
                  <span style={{ flex: 1 }}><b style={{ display: "block" }}>{t.title || "Event"}</b><span style={{ fontSize: 12.5, color: C.sub }}>{[ROLLE[t.rolle], t.ort, fmtEventDate(t.datum)].filter(Boolean).join(" · ")}</span></span>
                  <span style={{ color: C.play, fontWeight: 700 }}>→</span>
                </button>
              );
            })}
          </div>
        )}
        <div style={{ marginTop: 22, fontSize: 13, color: C.sub, textAlign: "center", lineHeight: 1.6 }}>
          🧢 Code oder Link bekommst du vom Büro bzw. vom Headcoach.<br />
          📱 Team-Handys: Team-Code vom Coach.<br />
          👀 Zuschauen: QR-Code beim Event scannen.
        </div>
      </div>
    </div>
  );
}

/* =====================================================================
   STAND 36 — „JETZT" + „ZÄHLEN" (Bedienung für Jugendliche)
   ---------------------------------------------------------------------
   Leitidee: jede:r weiß in 3 Sekunden, was jetzt dran ist. Ein großer
   Knopf pro Bildschirm, Daumen-Bedienung, wenig Text. Regeln, Daten und
   Wertung bleiben unverändert — nur die Bedienung ist neu. Die 15 Bausteine
   bleiben unter „🧰 Alle Werkzeuge" erreichbar.
   ===================================================================== */
const fmtClock = (s) => `${Math.floor(Math.max(0, s) / 60)}:${String(Math.max(0, s) % 60).padStart(2, "0")}`;

// Spieluhr taktet die EINE Wahrheit (live/tick) — nur auf dem Gerät, das die
// Steuerung gerade offen hat (Headcoach in "Jetzt" oder in Headcoach-Live).
function useLiveTicker(active) {
  const { state, dispatch } = useStore();
  const running = !!(state.live && state.live.running);
  useEffect(() => {
    if (!active || !running) return;
    const t = setInterval(() => dispatch({ type: "live/tick" }), 1000);
    return () => clearInterval(t);
  }, [active, running, dispatch]);
}

// Restzeit fuer die Anzeige -- rendert jede halbe Sekunde neu, solange die Uhr laeuft.
function useLiveRemaining() {
  const { state } = useStore();
  const live = state.live || {};
  const [, force] = useState(0);
  useEffect(() => {
    if (!live.running) return;
    const t = setInterval(() => force((x) => x + 1), 500);
    return () => clearInterval(t);
  }, [live.running, live.runStartedAt]);
  return liveRemaining(live);
}
// Paarungen der aktuellen Runde — dieselbe Wahrheit wie currentOpponentTeamId.
function jetztPaarungen(state) {
  const teams = state.teams;
  if (teams.length < 2) return { pairs: [], pause: [] };
  const rr = wandRunden(teams.length, state.tournament.config.mode);
  const within = (((state.live && state.live.cur) || 0) % rr.length + rr.length) % rr.length;
  const pairs = (rr[within] || []).map(([a, b]) => [teams[a], teams[b]]).filter(([a, b]) => a && b);
  const inPair = new Set(pairs.flat().map((t) => t.id));
  return { pairs, pause: teams.filter((t) => !inPair.has(t.id)) };
}
// Wie viele Teams haben schon alle anderen fair bewertet?
function fairplayStand(state) {
  const teams = state.teams;
  const done = teams.filter((r) => teams.every((t) => t.id === r.id || (t.fpFrom && t.fpFrom[r.id]))).length;
  return { done, total: teams.length };
}

const J = {
  card: { background: "#fff", border: `1px solid ${C.line}`, borderRadius: 18, padding: 12 },
  big: { width: "100%", border: 0, borderRadius: 16, padding: "16px", fontFamily: display, fontWeight: 800, fontSize: 22, color: "#fff", background: C.play, boxShadow: "0 6px 0 #1E8A4F", letterSpacing: 0.4, cursor: "pointer" },
  ghost: { flex: 1, border: `1.5px solid ${C.line}`, background: "#fff", borderRadius: 14, padding: "11px", fontFamily: font, fontWeight: 700, fontSize: 14, color: C.ink, cursor: "pointer" },
  lbl: { fontSize: 11.5, fontWeight: 800, color: C.sub, textTransform: "uppercase", letterSpacing: 0.6 },
};

/* ---------- Stand 37: Handy-Plaetze, Zugangs-Codes, "Deine Aufgabe" ---------- */
// Nur der Headcoach gibt haengende Plaetze frei (kein Automatismus): ein Handy,
// dessen Seite zu ist, haelt seinen Platz sonst fest.
function HandyPlaetze() {
  const { state, dispatch } = useStore();
  const hc = state.role === "headcoach";
  const frei = (t, d) => {
    let ok = false;
    try { ok = window.confirm(`${d.kind === "medien" ? "Medien" : "Zähl"}-Platz von „${t.name}" freigeben? Das Handy dort wird abgemeldet, ein anderes kann beitreten.`); } catch (_) { ok = false; }
    if (ok) dispatch({ type: "device/patch", teamId: t.id, deviceId: d.id, patch: { connected: false, holder: null } });
  };
  return (
    <div data-handy-plaetze="true" style={{ ...J.card, marginBottom: 8 }}>
      <div style={J.lbl}>📱 Handy-Plätze</div>
      <div style={{ fontSize: 12.5, color: C.sub, margin: "4px 0 8px", lineHeight: 1.45 }}>Jedes Team hat einen ⚽ Zähl- und einen 📷 Medien-Platz. Hängt ein Platz (Handy aus, Seite zu), tippe auf „freigeben" — dann kann ein anderes Handy beitreten.</div>
      {state.teams.map((t) => (
        <div key={t.id} style={{ display: "flex", alignItems: "center", gap: 6, padding: "7px 0", borderTop: `1px solid ${C.line}`, flexWrap: "wrap" }}>
          <span style={{ flex: 1, minWidth: 110, fontWeight: 700, fontSize: 13.5 }}>{t.emoji} {t.name}</span>
          {(t.devices || []).map((d) => (
            <button key={d.id} data-slot={d.kind} data-slot-team={t.id} data-slot-belegt={d.connected ? "ja" : "nein"} disabled={!d.connected || !hc} onClick={() => frei(t, d)}
              style={{ border: `1px solid ${d.connected ? C.brk : C.line}`, background: d.connected ? "#FFF4E0" : "#fff", color: d.connected ? "#8A5A00" : C.sub, borderRadius: 999, padding: "5px 10px", fontSize: 12, fontWeight: 700, cursor: d.connected && hc ? "pointer" : "default", fontFamily: font }}>
              {d.kind === "medien" ? "📷" : "⚽"} {d.connected ? (hc ? "belegt · freigeben" : "belegt") : "frei"}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}
function ZugangsCodes() {
  const { state } = useStore();
  const p = state.tournament.pins || {};
  return (
    <div data-event-codes="true" style={{ ...J.card, marginBottom: 8 }}>
      <div style={J.lbl}>🔑 Zugangs-Codes dieses Events</div>
      <div style={{ display: "flex", gap: 18, flexWrap: "wrap", fontSize: 14, margin: "6px 0" }}>
        <span>🎽 Headcoach: <b style={{ fontFamily: display, fontSize: 20, letterSpacing: 2 }}>{p.headcoach}</b></span>
        <span>🧢 Coach: <b data-code-coach-jetzt style={{ fontFamily: display, fontSize: 20, letterSpacing: 2 }}>{p.coach}</b></span>
        {p.team && !isSchlank(state) && <span>📱 Team-Handys: <b data-code-team-jetzt style={{ fontFamily: display, fontSize: 20, letterSpacing: 2 }}>{p.team}</b></span>}
      </div>
      <div style={{ fontSize: 12.5, color: C.sub, lineHeight: 1.45 }}>Den Coach-Code an die Coaches geben{p.team && !isSchlank(state) ? ", den Team-Code an die Teams (Team-Handy → „Ich spiele mit“)" : ""}. Zuschauer:innen kommen über den Gäste-QR.</div>
    </div>
  );
}
function jetztPhaseVon(state) {
  const rounds = (state.live && state.live.rounds) || [];
  const allDone = rounds.length > 0 && rounds.every((r) => r.done || r.skipped);
  return state.tournament.status === "abgeschlossen" || allDone ? "ende" : tournamentStarted(state) ? "laeuft" : "vor";
}
// Was ist JETZT meine Aufgabe? Eine Zeile je Rolle und Phase.
function tourPhaseVon(state) {
  if (istAfterwork(state)) return awPhase(state); // Stand 37l
  const { bracket } = state.ko || {};
  const R = bracket ? bracket.rounds.length : 0;
  const fin = bracket && R > 0 ? bracket.rounds[R - 1][0] : null;
  if (state.tournament.status === "abgeschlossen" || (fin && fin.done)) return "ende";
  return bracket ? "laeuft" : "vor";
}
function deineAufgabeText(state) {
  const role = state.role;
  const fm = formatById(state.tournament.meta && state.tournament.meta.format);
  if (fm && fm.id === "afterwork" && (role === "headcoach" || role === "coach")) {
    const ph = awPhase(state);
    if (ph === "vor") return { emo: "🍻", titel: "Willkommen-Runde", text: role === "headcoach" ? "Leute eintragen (Firma + Name), dann die erste Runde starten — z. B. „Sieger bleibt“ zum Aufwärmen." : "Leute eintragen (Firma + Name). Der Headcoach startet die Runden." };
    if (ph === "laeuft") return { emo: "⚽", titel: "An der Box", text: "Ergebnisse eintragen. Nachzügler gleich eintragen — sie kommen automatisch dran." };
    return { emo: "🏆", titel: "Siegerehrung", text: "Tages- und Firmenwertung zeigen, Getränkegutscheine nicht vergessen." };
  }
  if (fm && fm.kind === "tour" && (role === "headcoach" || role === "coach")) {
    const ph = tourPhaseVon(state);
    if (ph === "vor") return { emo: role === "headcoach" ? "🎽" : "🧢", titel: "Namen sammeln, dann los", text: role === "headcoach" ? "Alle Mitspielenden eintragen, dann „KO starten“. Den Gäste-QR aufstellen." : "Hilf beim Namen-Eintragen. Der Headcoach startet das KO." };
    if (ph === "laeuft") return { emo: "🥅", titel: "KO läuft", text: "Nach jedem Spiel das Ergebnis im KO-Baum eintragen und bestätigen." };
    if (state.tournament.status === "abgeschlossen") return { emo: "🏁", titel: "Geschafft!", text: "Abgeschlossen — alle wurden dabei automatisch ausgecheckt." };
    return { emo: "🏆", titel: "Siegerehrung", text: role === "headcoach" ? "Siegerehrung machen, Ergebnis in die Tour-Rangliste übernehmen, dann abschließen." : "Der Headcoach macht die Siegerehrung." };
  }
  const phase = jetztPhaseVon(state);
  const schlank = isSchlank(state);
  const team = state.teams.find((t) => t.id === state.boundTeamId);
  const tn = team ? team.name : "dein Team";
  if (role === "headcoach") {
    if (phase === "vor") return { emo: "🎽", titel: "Du leitest das Turnier", text: schlank ? "Teams und Zeitplan prüfen, dann „Turnier starten“. Du hast die Uhr." : "Checkliste abarbeiten, den Coaches ihren Code geben, dann „Turnier starten“. Du hast die Uhr." };
    if (phase === "laeuft") return { emo: "⏱️", titel: "Du hast die Uhr", text: schlank ? "Anpfiff, Pause, Abpfiff. Tore zählen die Coaches an der Box." : "Anpfiff, Pause, Abpfiff. Tore zählen die Team-Handys bzw. die Coaches an der Box." };
    if (state.tournament.status === "abgeschlossen") return { emo: "🏁", titel: "Geschafft!", text: "Turnier ist abgeschlossen — alle wurden dabei automatisch ausgecheckt." };
    return { emo: "🏆", titel: "Jetzt kommt die Siegerehrung", text: "Erst Platz für Platz aufdecken, dann Urkunden & Medaillen. Ganz am Schluss abschließen." };
  }
  if (role === "coach") {
    if (phase === "vor") return { emo: "🧢", titel: `Du betreust ${tn}`, text: schlank ? "Kinder bereit machen. Sobald angepfiffen ist, zählst du an deiner Box die Tore." : "Kinder bereit machen, Team-Handys verbinden lassen („Ich spiele mit“). Dann wartest du auf den Anpfiff." };
    if (phase === "laeuft") return { emo: "⚽", titel: "Steh an der Box", text: schlank ? "Tippe bei jedem Tor auf den großen Knopf." : "Zählt kein Team-Handy, tippst du die Tore. Nach den Spielen: die Teams an Fairplay erinnern." };
    return { emo: "🥁", titel: "Gleich wird aufgedeckt", text: "Der Headcoach macht die Siegerehrung. Bring dein Team zusammen. Vor dem Gehen: in „Ich“ auschecken." };
  }
  if (role === "teamaccess") {
    const dev = team && team.devices.find((d) => d.id === state.boundDeviceId);
    if (dev && dev.kind === "medien") return { emo: "📷", titel: "Ihr seid das Medien-Handy", text: "Fotos und Videos zu euren Aufgaben hochladen. Und: die anderen Teams fair bewerten." };
    if (phase === "vor") return { emo: "📱", titel: "Ihr seid das Zähl-Handy", text: "Wartet auf den Anpfiff. Dann zählt ihr eure Tore mit dem großen Knopf." };
    if (phase === "laeuft") return { emo: "⚽", titel: "Tore zählen!", text: "Bei jedem Tor auf den großen Knopf. Nach dem Spiel: den Gegner fair bewerten." };
    return { emo: "🤫", titel: "Alle Spiele sind vorbei", text: "Jetzt wird bei der Siegerehrung aufgedeckt, wer gewonnen hat." };
  }
  return null;
}
function DeineAufgabe() {
  const { state } = useStore();
  const a = deineAufgabeText(state);
  if (!a) return null;
  return (
    <div data-deine-aufgabe={state.role} style={{ display: "flex", gap: 10, alignItems: "flex-start", background: C.playSoft, border: `1px solid ${C.play}`, borderRadius: 16, padding: "10px 12px", marginBottom: 12 }}>
      <span style={{ fontSize: 24, lineHeight: 1.1 }}>{a.emo}</span>
      <span style={{ flex: 1 }}>
        <span style={{ display: "block", fontSize: 11, fontWeight: 800, color: C.play, textTransform: "uppercase", letterSpacing: 0.6 }}>Deine Aufgabe</span>
        <b style={{ display: "block", fontSize: 15, margin: "1px 0 2px" }}>{a.titel}</b>
        <span style={{ fontSize: 13, color: C.sub, lineHeight: 1.45 }}>{a.text}</span>
      </span>
    </div>
  );
}

function JetztSchritt({ ok, info, titel, sub, aktion, onAktion, schluessel }) {
  return (
    <div data-jetzt-schritt={info ? "info" : ok ? "ok" : "todo"} data-schritt-key={schluessel} style={{ display: "flex", alignItems: "center", gap: 10, background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: "11px 12px", marginBottom: 8 }}>
      <span style={{ width: 34, height: 34, borderRadius: "50%", display: "grid", placeItems: "center", fontWeight: 800, flexShrink: 0,
        background: info ? C.chalk : ok ? C.play : "#FFF4E0", color: info ? C.sub : ok ? "#fff" : "#8A5A00", border: info ? `1.5px solid ${C.line}` : ok ? "none" : `2px solid ${C.brk}` }}>{info || (ok ? "✓" : "!")}</span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <b style={{ display: "block", fontSize: 14.5 }}>{titel}</b>
        <span style={{ fontSize: 12.5, color: C.sub }}>{sub}</span>
      </span>
      {aktion && <button onClick={onAktion} style={{ border: "none", background: "none", color: C.play, fontWeight: 800, fontSize: 13.5, cursor: "pointer", fontFamily: font, whiteSpace: "nowrap" }}>{aktion} →</button>}
    </div>
  );
}

function JetztView({ onWerkzeug, abschlussBlock }) {
  const { state, dispatch, gastToken } = useStore();
  const [offen, setOffen] = useState(null); // Stand 37: aufgeklappter Vorbereitungs-Schritt (codes/qr/handys)
  const role = state.role;
  useEndsignal(); // Stand 39: Endsignal (Ton) auch beim Headcoach
  const hc = role === "headcoach";
  const schlank = isSchlank(state);
  useLiveTicker(hc);
  const rem = useLiveRemaining();
  const t = state.tournament;
  const teams = state.teams;
  const live = state.live || { rounds: [], cur: 0, remaining: 0, running: false };
  const rounds = live.rounds || [];
  const round = rounds[live.cur];
  const allDone = rounds.length > 0 && rounds.every((r) => r.done || r.skipped);
  const closed = t.status === "abgeschlossen";
  const phase = closed || allDone ? "ende" : tournamentStarted(state) ? "laeuft" : "vor";
  const cfg = t.config;
  const boxes = cfg.boxOverride || boxesNeeded(teams.length, cfg.mode);

  // --- Vorbereitung: Checkliste ---
  const devTotal = teams.length * 2;
  const devOn = teams.reduce((s, tm) => s + (tm.devices || []).filter((d) => d.connected).length, 0);
  const ohneCoach = teams.filter((tm) => !(tm.coach || "").trim());
  const schritte = [
    { key: "teams", ok: teams.length >= 2, titel: `${teams.length} Teams`, sub: teams.length ? teams.map((tm) => tm.name).join(", ") : "Mindestens 2 Teams anlegen", aktion: teams.length >= 2 ? null : "Teams", view: "team-verwaltung" },
    { key: "zeit", ok: rounds.length > 0, titel: "Zeitplan", sub: `${boxes} ${boxes === 1 ? "Box" : "Boxen"} · ${rounds.length} Runden à ${rounds[0] ? String(rounds[0].dur / 60).replace(".", ",") : cfg.gameDur} Min${rounds[0] && rounds[0].dur < Math.round((Number(cfg.gameDur) || 3) * 60) ? " (gekürzt, damit alles ins Zeitfenster passt)" : ""}`, aktion: hc ? "ändern" : null, view: "zeitplaner" },
    { key: "coaches", panel: hc ? "einsatzteam" : undefined, ok: teams.length > 0 && ohneCoach.length === 0, titel: "Coaches", sub: ohneCoach.length ? `Noch ohne Coach: ${ohneCoach.map((tm) => tm.name).join(", ")}` : "Alle Teams haben einen Coach", aktion: ohneCoach.length && hc ? "zuordnen" : null, view: "team-verwaltung" },  // Stand 39: Coaches gibt es in jedem Team-Format
    ...(schlank ? [] : [
      { key: "handys", ok: devTotal > 0 && devOn >= devTotal, titel: "Handys verbinden", sub: `${devOn} von ${devTotal} · Teams tippen „Ich spiele mit"`, aktion: hc ? "Plätze" : null, panel: "handys", optional: true },
    ]),
    ...(role === "coach" && !schlank ? [
      { key: "meinteam", info: "👥", titel: "Dein Team", sub: "Kinder eintragen und prüfen", aktion: "öffnen", view: "team-verwaltung", optional: true },
    ] : []),
    ...(hc ? [
      { key: "codes", info: "🔑", titel: "Codes an die Coaches geben", sub: `Coach-Code ${(t.pins || {}).coach || "–"}`, aktion: "zeigen", panel: "codes", optional: true },
      ...(gastToken ? [{ key: "qr", info: "📲", titel: "Gäste-QR zeigen / drucken", sub: "Eltern & Gäste sehen live mit — ohne Anmeldung", aktion: "zeigen", panel: "qr", optional: true }] : []),
    ] : []),
  ];
  const pflicht = schritte.filter((s) => !s.optional);
  const okCount = schritte.filter((s) => s.ok && !s.info).length;
  const zaehlSchritte = schritte.filter((s) => !s.info);
  const startbar = pflicht.filter((s) => s.key !== "coaches").every((s) => s.ok);

  const head = (
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
      <span data-jetzt-format style={{ flex: 1, fontSize: 13, fontWeight: 700, color: C.sub }}>{(() => { const fm = formatById(t.meta.format); return fm ? `${fm.emo} ${fm.label}` : (t.meta.title || "Turnier"); })()}{phase === "laeuft" && round ? ` · ${round.phase}` : ""}</span>
      {phase === "laeuft" && <span style={{ fontSize: 11, fontWeight: 800, borderRadius: 999, padding: "3px 9px", background: "#FDECEC", color: "#B23B3B" }}>● LIVE</span>}
      {phase === "vor" && <span style={{ fontSize: 11, fontWeight: 800, borderRadius: 999, padding: "3px 9px", background: "#fff", border: `1px solid ${C.line}` }}>Vorbereitung</span>}
      {phase === "ende" && <span style={{ fontSize: 11, fontWeight: 800, borderRadius: 999, padding: "3px 9px", background: C.playSoft, color: C.play }}>Abschluss</span>}
    </div>
  );

  let body;
  if (phase === "vor") {
    const pct = Math.round((okCount / Math.max(1, zaehlSchritte.length)) * 100);
    body = (
      <>
        <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "2px 0 12px" }}>
          <div style={{ width: 58, height: 58, borderRadius: "50%", background: `conic-gradient(${C.play} 0 ${pct}%, ${C.line} ${pct}% 100%)`, display: "grid", placeItems: "center", flexShrink: 0 }}>
            <span style={{ width: 44, height: 44, borderRadius: "50%", background: C.chalk, display: "grid", placeItems: "center", fontFamily: display, fontWeight: 800, fontSize: 16 }}>{okCount}/{zaehlSchritte.length}</span>
          </div>
          <div>
            <b style={{ fontFamily: display, fontWeight: 800, fontSize: 22 }}>{okCount === zaehlSchritte.length ? "Alles startklar!" : startbar ? "Fast startklar!" : "Los geht's mit der Vorbereitung"}</b>
            <div style={{ fontSize: 12.5, color: C.sub }}>{startbar ? "Du kannst jederzeit anpfeifen." : "Erst die orangen Punkte erledigen."}</div>
          </div>
        </div>
        {schritte.map((s) => (
          <React.Fragment key={s.key}>
            <JetztSchritt schluessel={s.key} ok={s.ok} info={s.info} titel={s.titel} sub={s.sub} aktion={s.aktion && (s.panel && offen === s.panel ? "zu" : s.aktion)}
              onAktion={() => (s.panel ? setOffen((o) => (o === s.panel ? null : s.panel)) : onWerkzeug(s.view))} />
            {s.panel && offen === s.panel && (s.panel === "handys" ? <HandyPlaetze /> : s.panel === "codes" ? <ZugangsCodes /> : s.panel === "einsatzteam" ? <EinsatzteamPanel /> : <div style={{ marginBottom: 8 }}><GastQrKarte /></div>)}
          </React.Fragment>
        ))}
        {hc ? (
          <>
            <button data-jetzt-start="true" disabled={!startbar} onClick={() => dispatch({ type: "live/start" })} style={{ ...J.big, marginTop: 8, opacity: startbar ? 1 : 0.5, cursor: startbar ? "pointer" : "default" }}>▶ Turnier starten</button>
            {!schlank && <div style={{ fontSize: 12, color: C.sub, textAlign: "center", marginTop: 6 }}>Startet auch ohne alle Handys — dann zählt der Coach.</div>}
          </>
        ) : <div style={{ ...J.card, textAlign: "center", fontSize: 14, color: C.sub, marginTop: 8 }}>⏳ Wartet auf den Anpfiff durch den Headcoach.</div>}
      </>
    );
  } else if (phase === "laeuft") {
    const { pairs, pause } = jetztPaarungen(state);
    const nxt = hlNextPlanned(rounds, live.cur);
    const nxtRound = nxt >= 0 ? rounds[nxt] : null;
    const fp = fairplayStand(state);
    const many = rounds.length > 14;
    const zeitUm = rem <= 0;
    // Stand 37: klare Zustaende zwischen den Runden
    const bereit = !live.running && !zeitUm && round && rem === round.dur; // Runde geladen, noch nicht angepfiffen
    const zustand = live.running ? "laeuft" : zeitUm ? "zeitum" : bereit ? "bereit" : "pause";
    body = (
      <>
        <div data-jetzt-uhr="true" style={{ background: C.ink, color: "#fff", borderRadius: 20, padding: 14, textAlign: "center", marginBottom: 10 }}>
          <div data-runde-zustand={zustand} style={{ fontSize: 11, letterSpacing: 1.4, opacity: 0.75, textTransform: "uppercase" }}>Runde {round ? round.n : "–"} von {rounds.length}{zustand === "laeuft" ? " · läuft" : zustand === "zeitum" ? " · Zeit um" : zustand === "bereit" ? " · bereit zum Anpfiff" : " · Pause"}</div>
          <div style={{ fontFamily: display, fontWeight: 800, fontSize: 64, lineHeight: 1, margin: "4px 0", color: zeitUm ? "#FFB4B6" : "#fff" }}>{fmtClock(rem)}</div>
          {many ? (
            <div style={{ height: 6, borderRadius: 3, background: "rgba(255,255,255,.2)", overflow: "hidden", margin: "6px 8px 0" }}>
              <div style={{ width: `${(rounds.filter((r) => r.done || r.skipped).length / rounds.length) * 100}%`, height: "100%", background: C.play }} />
            </div>
          ) : (
            <div style={{ display: "flex", gap: 4, justifyContent: "center", marginTop: 6 }}>
              {rounds.map((r, i) => <i key={r.id} style={{ width: 20, height: 6, borderRadius: 3, background: i === live.cur ? "#fff" : (r.done || r.skipped) ? C.play : "rgba(255,255,255,.2)" }} />)}
            </div>
          )}
        </div>
        {pairs.map(([a, b], i) => (
          <div key={a.id + b.id} data-jetzt-box={i + 1} style={{ display: "flex", alignItems: "center", gap: 8, padding: "9px 10px", borderRadius: 14, background: "#fff", border: `1px solid ${C.line}`, marginBottom: 7 }}>
            <span style={{ width: 44, fontFamily: display, fontWeight: 800, fontSize: 12, color: C.sub, textTransform: "uppercase" }}>{(() => { const sp = begegnungenDerRunde(state, live.cur).spiele.find((x) => x.a === a.id || x.b === a.id); return sp ? `Box ${sp.box}` : `Spiel ${i + 1}`; })()}</span>
            <span style={{ flex: 1, minWidth: 0, fontWeight: 700, fontSize: 13.5 }}>{a.emoji} {a.name}</span>
            <span title="Tore gesamt" style={{ fontFamily: display, fontWeight: 800, fontSize: 19, background: C.chalk, borderRadius: 9, padding: "2px 8px" }}>{a.tore}:{b.tore}</span>
            <span style={{ flex: 1, minWidth: 0, fontWeight: 700, fontSize: 13.5, textAlign: "right" }}>{b.name} {b.emoji}</span>
          </div>
        ))}
        <div style={{ fontSize: 12, color: C.sub, textAlign: "center", margin: "2px 0 10px" }}>
          Zahlen = Tore gesamt{pause.length ? ` · Pause: ${pause.map((p) => p.name).join(", ")}` : ""}{nxtRound ? ` · danach Runde ${nxtRound.n}` : " · letzte Runde"}
        </div>
        {hc ? (
          <>
            {live.running
              ? <button data-jetzt-haupt="pause" onClick={() => dispatch({ type: "live/pause" })} style={J.big}>⏸ Pause</button>
              : zeitUm
                ? <button data-jetzt-haupt="abpfiff" onClick={() => dispatch({ type: "live/whistleEnd", idx: state.live.cur })} style={J.big}>{nxtRound ? `⏭ Abpfiff · Runde ${nxtRound.n} vorbereiten` : "🏁 Abpfiff · alle Spiele fertig"}</button>
                : <button data-jetzt-haupt="anpfiff" onClick={() => dispatch({ type: "live/start" })} style={J.big}>{bereit ? `▶ Anpfiff Runde ${round ? round.n : ""}` : `▶ Weiter (Runde ${round ? round.n : ""})`}</button>}
            <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
              <button data-jetzt-plus30 onClick={() => dispatch({ type: "live/adjust", delta: 30 })} style={J.ghost}>+30 s</button>
              {!zeitUm && !bereit && <button data-jetzt-abpfiff onClick={() => dispatch({ type: "live/whistleEnd", idx: state.live.cur })} style={J.ghost}>⏹ Abpfiff</button>}
              {!schlank && <button data-jetzt-handys onClick={() => setOffen((o) => (o === "handys" ? null : "handys"))} style={J.ghost}>📱 Handys</button>}
            </div>
            {offen === "handys" && <div style={{ marginTop: 10 }}><HandyPlaetze /></div>}
          </>
        ) : (
          <button data-jetzt-zaehlen onClick={() => onWerkzeug("live-zaehler")} style={J.big}>⚽ Tore zählen</button>
        )}
        {!schlank && teams.length > 1 && (
          <div style={{ ...J.card, marginTop: 10, display: "flex", gap: 10, alignItems: "center", padding: "10px 12px" }}>
            <span style={{ fontSize: 20 }}>🤝</span>
            <span style={{ flex: 1, fontSize: 13 }}><b>Fairplay:</b> {fp.done} von {fp.total} Teams haben alle bewertet</span>
            {fp.done < fp.total && <button onClick={() => onWerkzeug("fairplay")} style={{ border: `1px solid ${C.line}`, background: "#fff", borderRadius: 999, padding: "4px 10px", fontSize: 12, fontWeight: 800, cursor: "pointer", fontFamily: font }}>ansehen</button>}
          </div>
        )}
      </>
    );
  } else {
    // Spannung bis zum Schluss: die zusammengefuehrte Wertung (Tore + Fairplay
    // + Aufgaben) wird hier NICHT verraten -- erst bei der Siegerehrung.
    body = (
      <>
        <div data-jetzt-ende="true" style={{ background: C.ink, color: "#fff", borderRadius: 20, padding: 16, textAlign: "center", marginBottom: 10 }}>
          <div style={{ fontSize: 11, letterSpacing: 1.4, opacity: 0.75, textTransform: "uppercase" }}>{closed ? "Turnier abgeschlossen" : "Alle Runden gespielt"}</div>
          <div style={{ fontFamily: display, fontWeight: 800, fontSize: 28, margin: "6px 0 2px" }}>🏆 Wer hat gewonnen?</div>
          <div style={{ fontSize: 13, opacity: 0.85 }}>{schlank ? "Wird bei der Siegerehrung verkündet." : "Tore, Fairplay und Aufgaben werden erst bei der Siegerehrung zusammengezählt."}</div>
        </div>
        {!hc && <EnthuellungLive />}
        {hc && (enthAusstehend(state)
          ? <button data-jetzt-ehrung onClick={() => onWerkzeug("enthuellung")} style={J.big}>🥁 Siegerehrung starten · Aufdecken</button>
          : <button data-jetzt-ehrung onClick={() => onWerkzeug("siegerehrung")} style={J.big}>🥇 Zur Siegerehrung</button>)}
        <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
          {hc && <button onClick={() => onWerkzeug("showroom")} style={J.ghost}>📽️ Beamer</button>}
          <button onClick={() => onWerkzeug("website")} style={J.ghost}>🌐 Website</button>
        </div>
        {hc && <div style={{ marginTop: 12 }}>{abschlussBlock}</div>}
        {hc && !closed && allDone && (() => {
          // Stand 37: kleiner Korrektur-Knopf -- letzte gespielte Runde wieder oeffnen
          let last = -1; rounds.forEach((r, i) => { if (r.done || r.skipped) last = i; });
          if (last < 0) return null;
          return (
            <button data-runde-nochmal onClick={() => {
              let ok = false;
              try { ok = window.confirm(`Runde ${rounds[last].n} nochmal öffnen? Das Turnier geht dann zurück auf „läuft".`); } catch (_) { ok = false; }
              if (ok) dispatch({ type: "live/reopen", idx: last });
            }} style={{ display: "block", margin: "14px auto 0", border: "none", background: "none", color: C.sub, fontSize: 12.5, fontWeight: 700, textDecoration: "underline", cursor: "pointer", fontFamily: font }}>↩ Runde {rounds[last].n} nochmal öffnen (Korrektur)</button>
          );
        })()}
      </>
    );
  }

  return (
    <div data-jetzt="true" data-jetzt-phase={phase} style={{ maxWidth: 520, margin: "0 auto", padding: "14px 14px 30px", fontFamily: font, color: C.ink }}>
      {head}
      {!schlank && <FairplaySchritte phase={phase} closed={closed} />}
      <DeineAufgabe />
      {Array.isArray(t.ablauf) && t.ablauf.length > 0 && <div style={{ marginBottom: 12 }}><GeburtstagPanel /></div>}
      {body}
      {hc && <ProbelaufZuruecksetzen />}
      {hc && <button data-alle-werkzeuge="true" onClick={() => onWerkzeug(null)} style={{ ...J.ghost, width: "100%", marginTop: 16, color: C.sub }}>🧰 Alle Werkzeuge <span style={{ fontWeight: 600, fontSize: 12 }}>· Headcoach: Einstellungen, Korrekturen</span></button>}
    </div>
  );
}

// Stand 37: klarer naechster Schritt fuer Tour-Formate (Community Tour,
// Kick & Splash, Afterwork): Namen -> KO starten -> Ergebnisse -> Siegerehrung.
function TourJetzt({ onView }) {
  const { state, dispatch } = useStore();
  const hc = state.role === "headcoach";
  const { participants, bracket, savedEventId } = state.ko;
  const closed = state.tournament.status === "abgeschlossen";
  const R = bracket ? bracket.rounds.length : 0;
  const finalMatch = bracket && R > 0 ? bracket.rounds[R - 1][0] : null;
  const champion = finalMatch && finalMatch.done ? finalMatch.winner : null;
  const offen = bracket ? bracket.rounds.flat().filter((m) => m.a && m.b && !m.b.bye && !m.done).length + (bracket.smallFinal && !bracket.smallFinal.done && bracket.smallFinal.a && bracket.smallFinal.b ? 1 : 0) : 0;
  const phase = closed || champion ? "ende" : bracket ? "laeuft" : "vor";
  const big = { ...J.big, fontSize: 19, padding: "13px" };
  return (
    <div data-tour-jetzt={phase} style={{ border: `1px solid ${C.play}`, background: C.playSoft, borderRadius: 16, padding: 14, display: "flex", flexDirection: "column", gap: 8 }}>
      <div style={{ fontSize: 11, fontWeight: 800, color: C.play, textTransform: "uppercase", letterSpacing: 0.6 }}>⚡ Jetzt</div>
      {phase === "vor" && (<>
        <b style={{ fontSize: 16 }}>{participants.length < 2 ? "Wer spielt mit?" : `${participants.length} Spieler:innen bereit`}</b>
        {participants.length >= 2 && hc
          ? <button data-tour-start onClick={() => { dispatch({ type: "ko/start" }); onView("einzel-ko"); }} style={big}>▶ KO starten</button>
          : <button data-tour-namen onClick={() => onView("einzel-ko")} style={big}>✍️ Namen eintragen</button>}
        {participants.length >= 2 && hc && <button onClick={() => onView("einzel-ko")} style={{ ...J.ghost, flex: "none" }}>Namen bearbeiten</button>}
      </>)}
      {phase === "laeuft" && (<>
        <b style={{ fontSize: 16 }}>KO läuft · {offen} {offen === 1 ? "Spiel" : "Spiele"} offen</b>
        <button data-tour-baum onClick={() => onView("einzel-ko")} style={big}>🥅 Zum KO-Baum · Ergebnisse eintragen</button>
      </>)}
      {phase === "ende" && (<>
        <b style={{ fontSize: 16 }}>{champion ? `🏆 ${champion.name} gewinnt!` : "Abgeschlossen"}</b>
        {hc ? <button data-tour-ehrung onClick={() => { if (champion && !savedEventId && !closed) dispatch({ type: "ko/saveToTour", datum: state.tournament.meta.date || "", ort: state.tournament.meta.ort || "" }); onView("siegerehrung-tour"); }} style={big}>🥇 Zur Siegerehrung</button>
          : <div style={{ fontSize: 13.5, color: C.sub }}>Der Headcoach macht jetzt die Siegerehrung.</div>}
        {hc && savedEventId && <div style={{ fontSize: 12.5, color: C.sub }}>✓ Ergebnis ist in der Tour-Rangliste. Nach der Siegerehrung unten abschließen.</div>}
      </>)}
    </div>
  );
}

/* =====================================================================
   STAND 37l — AFTERWORK-ABEND: Runden mit verschiedenen Spielformen
   Nutzer: "nicht nur Einzel-KO … aber keine Komplexitaet wie beim Fairplay-
   Turnier". Spielformen: 🔁 Sieger bleibt am Platz · 🥅 Einzel-KO · 🏢 Firmen-
   Teams. Runde fuer Runde waehlbar; die Tageswertung sammelt alles.
   ===================================================================== */
const ABEND_LEER = { runden: [], aktivId: null, beendet: false };
const AW_FORMEN = {
  sieger: { emo: "🔁", label: "Sieger bleibt am Platz", sub: "1 gegen 1 · wer gewinnt, bleibt · Siege zählen" },
  ko: { emo: "🥅", label: "Einzel-KO", sub: "Turnierbaum · am Ende steht der Sieger fest" },
  firmen: { emo: "🏢", label: "Firmen-Teams", sub: "Firmen spielen als Team gegeneinander · Tabelle nach Toren" },
};
function istAfterwork(state) { return (state.tournament.meta && state.tournament.meta.format) === "afterwork"; }
function koSiegeJe(bracket) {
  const out = {};
  if (!bracket) return out;
  [...bracket.rounds.flat(), ...(bracket.smallFinal ? [bracket.smallFinal] : [])].forEach((m) => {
    if (m.done && m.winner && !m.byeWin && m.loser) out[m.winner.id] = (out[m.winner.id] || 0) + 1;
  });
  return out;
}
// Tageswertung: Siege aus allen Runden (Sieger bleibt + KO-Spiele), dazu Firmen-Siege je Mitspieler:in nicht -- die zaehlen fuer die Firma.
function awTageswertung(state) {
  const ab = state.abend || ABEND_LEER;
  const p = state.ko.participants;
  const siege = {}; const ko1 = {};
  ab.runden.forEach((r) => {
    if (r.form === "sieger") Object.entries(r.siege || {}).forEach(([id, n]) => { siege[id] = (siege[id] || 0) + n; });
    if (r.form === "ko") {
      const b = r.status === "fertig" ? r.bracket : state.ko.bracket;
      Object.entries(koSiegeJe(b)).forEach(([id, n]) => { siege[id] = (siege[id] || 0) + n; });
      const pl = koPlacements(b); if (pl[0]) ko1[pl[0].pid] = (ko1[pl[0].pid] || 0) + 1;
    }
  });
  return p.map((x) => ({ p: x, siege: siege[x.id] || 0, koSiege: ko1[x.id] || 0 }))
    .sort((a, b) => b.siege - a.siege || b.koSiege - a.koSiege || a.p.name.localeCompare(b.p.name));
}
function awFirmenwertung(state) {
  const ab = state.abend || ABEND_LEER;
  const f = {};
  const add = (name) => (f[name] = f[name] || { name, tore: 0, punkte: 0, spiele: 0, siege: 0 });
  ab.runden.filter((r) => r.form === "firmen").forEach((r) => {
    r.spiele.forEach((m) => {
      if (!m.done) return;
      const A = add(r.teams[m.a].name), Bt = add(r.teams[m.b].name);
      A.tore += m.ta; Bt.tore += m.tb; A.spiele++; Bt.spiele++;
      if (m.ta > m.tb) A.punkte += 3; else if (m.tb > m.ta) Bt.punkte += 3; else { A.punkte++; Bt.punkte++; }
    });
  });
  // Siege der Mitspielenden (Sieger bleibt/KO) zaehlen fuer ihre Firma mit
  awTageswertung(state).forEach(({ p, siege }) => { const n = (p.firma || "").trim(); if (n && siege) add(n).siege += siege; });
  return Object.values(f).filter((x) => x.name !== "Ohne Firma").sort((a, b) => b.punkte - a.punkte || b.tore - a.tore || b.siege - a.siege);
}
function awPhase(state) {
  const ab = state.abend || ABEND_LEER;
  if (state.tournament.status === "abgeschlossen" || ab.beendet) return "ende";
  return ab.runden.length ? "laeuft" : "vor";
}

// Tages- und Firmenwertung (Tabelle, Gaeste, Siegerehrung)
function AwWertung({ gross = false, max = 99 }) {
  const { state } = useStore();
  const tw = awTageswertung(state).slice(0, max);
  const fw = awFirmenwertung(state);
  const medal = (i) => (i < 3 ? ["🥇", "🥈", "🥉"][i] : `${i + 1}.`);
  const zeile = { display: "flex", alignItems: "center", gap: 10, padding: gross ? "10px 12px" : "7px 10px", borderRadius: 12, background: "#fff", border: `1px solid ${C.line}`, marginBottom: 6, fontSize: gross ? 18 : 14.5 };
  return (
    <div data-aw-wertung="true" style={{ fontFamily: font, color: C.ink }}>
      <div style={{ fontFamily: display, fontWeight: 800, fontSize: gross ? 26 : 18, margin: "0 0 8px" }}>🏆 Tageswertung</div>
      {tw.length === 0 ? <div style={{ color: C.sub, fontSize: 13.5 }}>Noch keine Spiele.</div> : tw.map((r, i) => (
        <div key={r.p.id} data-aw-platz={i + 1} style={zeile}>
          <span style={{ width: 34, textAlign: "center", fontFamily: display, fontWeight: 800 }}>{medal(i)}</span>
          <span style={{ flex: 1, minWidth: 0 }}><b>{r.p.name}</b>{r.p.firma ? <span style={{ color: C.sub, fontSize: gross ? 14 : 12 }}> · {r.p.firma}</span> : null}{r.koSiege ? " 🥅" : ""}</span>
          <span style={{ fontFamily: display, fontWeight: 800 }}>{r.siege}</span><span style={{ fontSize: 11, color: C.sub, width: 34 }}>Siege</span>
        </div>
      ))}
      {fw.length > 0 && (<>
        <div style={{ fontFamily: display, fontWeight: 800, fontSize: gross ? 22 : 16, margin: "16px 0 8px" }}>🏢 Firmenwertung</div>
        {fw.map((f, i) => (
          <div key={f.name} data-aw-firma-platz={i + 1} style={zeile}>
            <span style={{ width: 34, textAlign: "center", fontFamily: display, fontWeight: 800 }}>{medal(i)}</span>
            <span style={{ flex: 1 }}><b>{f.name}</b></span>
            <span style={{ fontSize: 12.5, color: C.sub }}>{f.spiele ? `${f.punkte} P · ${f.tore} Tore` : ""}{f.siege ? ` · ${f.siege} Siege` : ""}</span>
          </div>
        ))}
      </>)}
    </div>
  );
}

// Sieger bleibt am Platz -- ein Bildschirm, zwei grosse Knoepfe
function AwSiegerBox({ runde }) {
  const { state, dispatch } = useStore();
  const byId = (id) => state.ko.participants.find((p) => p.id === id);
  const [a, b] = runde.box.map(byId);
  if (!a || !b) return <div style={{ ...J.card, color: C.sub }}>Zu wenige Mitspielende in der Warteschlange.</div>;
  const btn = (p) => (
    <button data-aw-sieg={p.id} onClick={() => dispatch({ type: "abend/sieger/ergebnis", rundeId: runde.id, gewinnerId: p.id })}
      style={{ flex: 1, border: 0, borderRadius: 18, padding: "18px 10px", background: C.play, color: "#fff", fontFamily: display, fontWeight: 800, fontSize: 22, boxShadow: "0 6px 0 #1E8A4F", cursor: "pointer" }}>
      {p.name}<span style={{ display: "block", fontFamily: font, fontSize: 12.5, fontWeight: 700, opacity: 0.9 }}>gewinnt · {runde.siege[p.id] || 0} Siege{runde.serie[p.id] ? ` · ${runde.serie[p.id]} in Folge` : ""}</span>
    </button>
  );
  return (
    <div data-aw-sieger-box="true">
      <div style={{ fontSize: 12, fontWeight: 800, color: C.sub, textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 8, textAlign: "center" }}>In der Box · wer gewinnt?</div>
      <div style={{ display: "flex", gap: 10, alignItems: "stretch" }}>{btn(a)}<span style={{ alignSelf: "center", fontFamily: display, fontWeight: 800 }}>vs</span>{btn(b)}</div>
      <div style={{ fontSize: 13, color: C.sub, marginTop: 10, textAlign: "center" }}>
        Als Nächstes: {runde.queue.slice(0, 3).map((id) => (byId(id) || {}).name).filter(Boolean).join(" · ") || "—"}{runde.queue.length > 3 ? ` · +${runde.queue.length - 3}` : ""}
      </div>
      <div style={{ fontSize: 12, color: C.sub, textAlign: "center", marginTop: 4 }}>Nach {runde.maxSerie} Siegen in Folge geht's kurz in die Warteschlange — so kommen alle dran.</div>
      {runde.log.length > 0 && <button data-aw-rueck onClick={() => dispatch({ type: "abend/sieger/rueckgaengig", rundeId: runde.id })} style={{ display: "block", margin: "10px auto 0", border: "none", background: "none", color: C.sub, textDecoration: "underline", fontSize: 12.5, fontWeight: 700, cursor: "pointer", fontFamily: font }}>↩ letztes Ergebnis zurück</button>}
    </div>
  );
}

// Firmen-Teams -- Spiele mit Toren
function AwFirmen({ runde }) {
  const { dispatch } = useStore();
  const tb = (mi, seite, delta) => dispatch({ type: "abend/firmen/tor", rundeId: runde.id, mi, seite, delta });
  const k = { width: 34, height: 34, borderRadius: 10, border: `1px solid ${C.line}`, background: "#fff", fontWeight: 800, cursor: "pointer" };
  return (
    <div data-aw-firmen="true">
      {runde.spiele.map((m, i) => (
        <div key={i} data-aw-spiel={i} style={{ ...J.card, marginBottom: 8, opacity: m.done ? 0.65 : 1 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ flex: 1, fontWeight: 700 }}>{runde.teams[m.a].name}</span>
            {!m.done && <button style={k} onClick={() => tb(i, "ta", -1)}>−</button>}
            <b style={{ fontFamily: display, fontSize: 22 }}>{m.ta}:{m.tb}</b>
            {!m.done && <button style={k} onClick={() => tb(i, "tb", -1)}>−</button>}
            <span style={{ flex: 1, fontWeight: 700, textAlign: "right" }}>{runde.teams[m.b].name}</span>
          </div>
          {!m.done && (
            <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
              <button data-aw-tor-a={i} onClick={() => tb(i, "ta", 1)} style={{ ...J.ghost }}>+1 {runde.teams[m.a].name}</button>
              <button data-aw-tor-b={i} onClick={() => tb(i, "tb", 1)} style={{ ...J.ghost }}>+1 {runde.teams[m.b].name}</button>
            </div>
          )}
          <button data-aw-spiel-fertig={i} onClick={() => dispatch({ type: "abend/firmen/fertig", rundeId: runde.id, mi: i })} style={{ border: "none", background: "none", color: m.done ? C.sub : C.play, fontWeight: 800, fontSize: 13, cursor: "pointer", marginTop: 6, fontFamily: font }}>{m.done ? "↩ wieder öffnen" : "✓ Spiel fertig"}</button>
        </div>
      ))}
    </div>
  );
}

// Werkzeug "Laufende Runde"
function AwRunde() {
  const { state } = useStore();
  const ab = state.abend || ABEND_LEER;
  const r = ab.runden.find((x) => x.id === ab.aktivId);
  if (!r) return <div style={{ ...J.card, color: C.sub }}>Gerade läuft keine Runde. Starte eine in „Jetzt".</div>;
  if (r.form === "ko") return <EinzelKO />;
  return (
    <div style={{ maxWidth: 560, margin: "0 auto", fontFamily: font, color: C.ink }}>
      <div style={{ fontFamily: display, fontWeight: 800, fontSize: 22, marginBottom: 10 }}>{AW_FORMEN[r.form].emo} {AW_FORMEN[r.form].label}</div>
      {r.form === "sieger" ? <AwSiegerBox runde={r} /> : <AwFirmen runde={r} />}
    </div>
  );
}

// "Jetzt" fuer Afterwork
function AfterworkJetzt({ onWerkzeug, abschlussBlock }) {
  const { state, dispatch, gastToken } = useStore();
  const hc = state.role === "headcoach";
  const ab = state.abend || ABEND_LEER;
  const aktiv = ab.runden.find((x) => x.id === ab.aktivId) || null;
  const ph = awPhase(state);
  const n = state.ko.participants.length;
  const [koAuswahl, setKoAuswahl] = useState(false);
  const [offen, setOffen] = useState(null);
  const tw = awTageswertung(state);
  const firmen = new Set(state.ko.participants.map((p) => (p.firma || "").trim()).filter(Boolean));
  const starte = (form, teilnehmer) => { dispatch({ type: "abend/runde/start", form, teilnehmer }); setKoAuswahl(false); onWerkzeug("aw-runde"); };
  const big = { ...J.big, fontSize: 19, padding: "13px" };
  const formKnopf = (k, dis, onClick) => (
    <button key={k} data-aw-start={k} disabled={dis} onClick={onClick}
      style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", textAlign: "left", background: "#fff", border: `1.5px solid ${C.line}`, borderRadius: 14, padding: "11px 12px", marginBottom: 8, cursor: dis ? "default" : "pointer", opacity: dis ? 0.45 : 1, fontFamily: font, color: C.ink }}>
      <span style={{ fontSize: 24 }}>{AW_FORMEN[k].emo}</span>
      <span style={{ flex: 1 }}><b style={{ display: "block", fontSize: 15 }}>{AW_FORMEN[k].label}</b><span style={{ fontSize: 12.5, color: C.sub }}>{AW_FORMEN[k].sub}</span></span>
      <span style={{ color: C.play, fontWeight: 800 }}>▶</span>
    </button>
  );
  return (
    <div data-jetzt="true" data-jetzt-tour={ph} data-aw-jetzt={ph} style={{ maxWidth: 520, margin: "0 auto", padding: "14px 14px 30px", fontFamily: font, color: C.ink }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <span style={{ flex: 1, fontSize: 13, fontWeight: 700, color: C.sub }}>🍻 Afterwork</span>
        <span style={{ fontSize: 11, fontWeight: 800, borderRadius: 999, padding: "3px 9px", background: aktiv ? "#FDECEC" : ph === "ende" ? C.playSoft : "#fff", color: aktiv ? "#B23B3B" : ph === "ende" ? C.play : C.ink, border: !aktiv && ph !== "ende" ? `1px solid ${C.line}` : "none" }}>{aktiv ? "● LIVE" : ph === "ende" ? "Abschluss" : ph === "vor" ? "Vorbereitung" : "Pause"}</span>
      </div>
      <DeineAufgabe />
      <JetztSchritt schluessel="spieler" ok={n >= 2} titel={`${n} Mitspielende`} sub={firmen.size ? `${firmen.size} Firmen · jederzeit nachtragen` : "Firma (optional) + Name, jederzeit nachtragen"} aktion="eintragen" onAktion={() => onWerkzeug("aw-spieler")} />
      {aktiv ? (
        <div data-aw-aktiv={aktiv.form} style={{ ...J.card, borderColor: C.play, marginBottom: 10 }}>
          <div style={{ fontSize: 11, fontWeight: 800, color: C.play, textTransform: "uppercase", letterSpacing: 0.6 }}>⚡ Läuft gerade</div>
          <b style={{ display: "block", fontSize: 17, margin: "2px 0 8px" }}>{AW_FORMEN[aktiv.form].emo} {AW_FORMEN[aktiv.form].label}</b>
          <button data-aw-zur-box onClick={() => onWerkzeug("aw-runde")} style={big}>{aktiv.form === "sieger" ? "⚽ Zur Box · Sieger eintragen" : aktiv.form === "ko" ? "🥅 Zum KO-Baum" : "🏢 Zu den Firmen-Spielen"}</button>
          {hc && <button data-aw-runde-ende onClick={() => dispatch({ type: "abend/runde/ende" })} style={{ ...J.ghost, width: "100%", marginTop: 8, flex: "none" }}>⏹ Runde beenden</button>}
        </div>
      ) : ph !== "ende" && hc ? (
        <div style={{ marginBottom: 10 }}>
          <div style={{ ...J.lbl, margin: "6px 0 8px" }}>{ab.runden.length ? "Nächste Runde starten" : "Erste Runde starten"}</div>
          {formKnopf("sieger", n < 2, () => starte("sieger"))}
          {!koAuswahl ? formKnopf("ko", n < 2, () => (tw.some((r) => r.siege > 0) && n > 4 ? setKoAuswahl(true) : starte("ko")))
            : (
              <div data-aw-ko-wahl="true" style={{ ...J.card, marginBottom: 8 }}>
                <b style={{ fontSize: 14 }}>🥅 KO mit wem?</b>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginTop: 8 }}>
                  {[4, 8].filter((k) => k < n).map((k) => <button key={k} data-aw-ko-top={k} onClick={() => starte("ko", tw.slice(0, k).map((r) => r.p.id))} style={{ ...J.ghost, flex: "none" }}>Top {k} der Tageswertung</button>)}
                  <button data-aw-ko-alle onClick={() => starte("ko")} disabled={n > 16} style={{ ...J.ghost, flex: "none" }}>Alle ({n}){n > 16 ? " — max. 16" : ""}</button>
                </div>
              </div>
            )}
          {formKnopf("firmen", firmen.size < 2 && !(firmen.size === 1 && state.ko.participants.some((p) => !(p.firma || "").trim())), () => starte("firmen"))}
        </div>
      ) : null}
      {ab.runden.length > 0 && (
        <div style={{ ...J.card, marginBottom: 10 }}>
          <AwWertung max={5} />
          <button onClick={() => onWerkzeug("aw-ehrung")} style={{ ...J.ghost, width: "100%", marginTop: 6, flex: "none" }}>📽️ Ganze Wertung / Beamer</button>
        </div>
      )}
      {hc && ph === "vor" && (
        <div>
          {[{ key: "codes", info: "🔑", titel: "Codes an die Coaches geben", sub: `Coach-Code ${(state.tournament.pins || {}).coach || "–"}` },
            ...(gastToken ? [{ key: "qr", info: "📲", titel: "Gäste-QR zeigen / drucken", sub: "Gäste sehen Box, Tageswertung und Firmenwertung live" }] : [])].map((x) => (
            <React.Fragment key={x.key}>
              <JetztSchritt schluessel={x.key} info={x.info} titel={x.titel} sub={x.sub} aktion={offen === x.key ? "zu" : "zeigen"} onAktion={() => setOffen((o) => (o === x.key ? null : x.key))} />
              {offen === x.key && (x.key === "codes" ? <ZugangsCodes /> : <div style={{ marginBottom: 8 }}><GastQrKarte /></div>)}
            </React.Fragment>
          ))}
        </div>
      )}
      {hc && !aktiv && ab.runden.length > 0 && ph !== "ende" && (
        <button data-aw-abend-ende onClick={() => dispatch({ type: "abend/beenden", wert: true })} style={{ ...big, marginTop: 6, background: C.ink, boxShadow: "0 6px 0 #000" }}>🏆 Abend beenden · Siegerehrung</button>
      )}
      {ph === "ende" && (<>
        <button data-aw-ehrung onClick={() => onWerkzeug("aw-ehrung")} style={big}>🥇 Siegerehrung zeigen</button>
        {hc && state.tournament.status !== "abgeschlossen" && <button onClick={() => dispatch({ type: "abend/beenden", wert: false })} style={{ display: "block", margin: "10px auto 0", border: "none", background: "none", color: C.sub, textDecoration: "underline", fontSize: 12.5, fontWeight: 700, cursor: "pointer", fontFamily: font }}>↩ doch noch eine Runde spielen</button>}
        {hc && <div style={{ marginTop: 12 }}>{abschlussBlock}</div>}
      </>)}
      {hc && <button data-alle-werkzeuge="true" onClick={() => onWerkzeug(null)} style={{ ...J.ghost, width: "100%", marginTop: 16, color: C.sub }}>🧰 Alle Werkzeuge <span style={{ fontWeight: 600, fontSize: 12 }}>· Headcoach: Einstellungen, Korrekturen</span></button>}
    </div>
  );
}
function AwEhrung() {
  return <div style={{ maxWidth: 640, margin: "0 auto" }}><AwWertung gross /></div>;
}

// Stand 37b: aufgeraeumter "Jetzt"-Bildschirm fuer Tour-Formate (Community Tour,
// Kick & Splash, Afterwork) -- wie beim Teamturnier: ein Bildschirm, ein Knopf.
function TourJetztView({ onWerkzeug, abschlussBlock }) {
  const { state, gastToken } = useStore();
  const hc = state.role === "headcoach";
  const [offen, setOffen] = useState(null);
  const ph = tourPhaseVon(state);
  const fm = formatById(state.tournament.meta && state.tournament.meta.format);
  const n = (state.ko && state.ko.participants || []).length;
  return (
    <div data-jetzt="true" data-jetzt-tour={ph} style={{ maxWidth: 520, margin: "0 auto", padding: "14px 14px 30px", fontFamily: font, color: C.ink }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <span style={{ flex: 1, fontSize: 13, fontWeight: 700, color: C.sub }}>{fm ? `${fm.emo} ${fm.label}` : "Tour"}</span>
        <span style={{ fontSize: 11, fontWeight: 800, borderRadius: 999, padding: "3px 9px", background: ph === "laeuft" ? "#FDECEC" : ph === "ende" ? C.playSoft : "#fff", color: ph === "laeuft" ? "#B23B3B" : ph === "ende" ? C.play : C.ink, border: ph === "vor" ? `1px solid ${C.line}` : "none" }}>{ph === "laeuft" ? "● LIVE" : ph === "ende" ? "Abschluss" : "Vorbereitung"}</span>
      </div>
      <DeineAufgabe />
      <TourJetzt onView={onWerkzeug} />
      {hc && ph === "vor" && (
        <div style={{ marginTop: 12 }}>
          {[{ key: "codes", info: "🔑", titel: "Codes an die Coaches geben", sub: `Coach-Code ${(state.tournament.pins || {}).coach || "–"}` },
            ...(gastToken ? [{ key: "qr", info: "📲", titel: "Gäste-QR zeigen / drucken", sub: "Gäste sehen KO-Baum und Rangliste live" }] : [])].map((x) => (
            <React.Fragment key={x.key}>
              <JetztSchritt schluessel={x.key} info={x.info} titel={x.titel} sub={x.sub} aktion={offen === x.key ? "zu" : "zeigen"} onAktion={() => setOffen((o) => (o === x.key ? null : x.key))} />
              {offen === x.key && (x.key === "codes" ? <ZugangsCodes /> : <div style={{ marginBottom: 8 }}><GastQrKarte /></div>)}
            </React.Fragment>
          ))}
          {n > 0 && <div style={{ fontSize: 12.5, color: C.sub, textAlign: "center" }}>{n} {n === 1 ? "Name" : "Namen"} eingetragen</div>}
        </div>
      )}
      {hc && ph === "ende" && <div style={{ marginTop: 12 }}>{abschlussBlock}</div>}
      {hc && <button data-alle-werkzeuge="true" onClick={() => onWerkzeug(null)} style={{ ...J.ghost, width: "100%", marginTop: 16, color: C.sub }}>🧰 Alle Werkzeuge <span style={{ fontWeight: 600, fontSize: 12 }}>· Headcoach: Einstellungen, Korrekturen</span></button>}
    </div>
  );
}

// Stand 37: feste Schritt-Leiste nur im Fairplay-Turnier (Nutzer-Vorgabe).
function FairplaySchritte({ phase, closed }) {
  const { state } = useStore();
  const aktiv = closed ? 3 : phase === "ende" ? 2 : phase === "laeuft" ? 1 : 0;
  const schritte = ["Vorbereitung", "Turnier läuft", "Siegerehrung", "Archiv"];
  return (
    <div data-fairplay-schritte={aktiv} style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 12 }}>
      {schritte.map((n, i) => (
        <React.Fragment key={n}>
          <span style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3, flex: "0 0 auto", opacity: i > aktiv ? 0.5 : 1 }}>
            <span style={{ width: 24, height: 24, borderRadius: "50%", display: "grid", placeItems: "center", fontSize: 12, fontWeight: 800,
              background: i < aktiv ? C.playSoft : i === aktiv ? C.play : "#fff", color: i < aktiv ? C.play : i === aktiv ? "#fff" : C.sub, border: `1.5px solid ${i <= aktiv ? C.play : C.line}` }}>{i < aktiv ? "✓" : i + 1}</span>
            <span style={{ fontSize: 10.5, fontWeight: i === aktiv ? 800 : 600, color: i === aktiv ? C.ink : C.sub, whiteSpace: "nowrap" }}>{n}</span>
          </span>
          {i < schritte.length - 1 && <span style={{ flex: 1, height: 2, marginBottom: 14, background: i < aktiv ? C.play : C.line }} />}
        </React.Fragment>
      ))}
    </div>
  );
}

/* ---------- Zählen (Team-Handy und Coach an der Box) ---------- */
function ZaehlenGross({ lockedTeamId = null }) {
  const { state, dispatch, eventId } = useStore();
  // Stand 39: Tore zählt der Coach (über den Server, mit Server-Uhr). Team-Handys zählen nicht mehr.
  const viaServer = state.role === "coach";
  const nurCoach = state.role === "teamaccess";
  const [serverN, setServerN] = useState({});
  const [fehlerTor, setFehlerTor] = useState("");
  const teams = state.teams;
  const locked = lockedTeamId != null;
  const [selId, setSelId] = useState(locked ? lockedTeamId : (teams[0] ? teams[0].id : null));
  const team = teams.find((tm) => tm.id === (locked ? lockedTeamId : selId)) || null;
  const zaehlModus = state.tournament.config.zaehlModus || "eigen";
  const [hist, setHist] = useState([]);
  const [pending, setPending] = useState(-1);
  const [toast, setToast] = useState(null);
  const toastRef = useRef(null);
  const rem = useLiveRemaining();
  useEffect(() => () => clearTimeout(toastRef.current), []);
  if (!team) return <div style={{ ...J.card, margin: 16, color: C.sub, fontSize: 14 }}>Noch keine Teams angelegt.</div>;

  const gegnerId = currentOpponentTeamId(state, team.id);
  const gegner = gegnerId ? teams.find((tm) => tm.id === gegnerId) : null;
  const credit = zaehlModus === "gegner" && gegner ? gegner : team; // wofür gezählt wird
  const other = credit.id === team.id ? gegner : team;
  const live = state.live || {};
  const round = (live.rounds || [])[live.cur];

  const flash = (txt) => { setToast(txt); clearTimeout(toastRef.current); toastRef.current = setTimeout(() => setToast(null), 1600); };
  const lauf = Number(live.lauf || 0);
  const rundeN = (tid) => { const zz = round && round.zaehlung && round.zaehlung["frei:" + tid]; const k = `${lauf}:${live.cur}:${tid}`; return Math.max(zz ? Number(zz.n || 0) : 0, serverN[k] || 0); };
  const serverTor = async (delta) => {
    setFehlerTor("");
    try {
      const r = await zaehleTor(eventId, { runde: live.cur, lauf, delta, fuer: credit.id });
      setServerN((m) => ({ ...m, [`${lauf}:${live.cur}:${credit.id}`]: r.n }));
      if (delta > 0) { try { if (navigator.vibrate) navigator.vibrate(40); } catch (_) { /* noop */ } flash(`⚽ Tor für ${credit.name} — gespeichert ✓`); } else flash("↩︎ Letztes Tor zurückgenommen");
    } catch (e) { setFehlerTor(e.serverMessage || "Keine Verbindung — Tor nicht gezählt."); }
  };
  const addGoal = () => {
    if (viaServer) { serverTor(1); return; }
    dispatch({ type: "goal/add", teamId: credit.id, phase: "einzel", playerId: null });
    setPending(hist.length); setHist((h) => [...h, { playerId: null }]);
    try { if (navigator.vibrate) navigator.vibrate(40); } catch (_) { /* noop */ }
    flash(`⚽ Tor! ${credit.tore + 1}${other ? `:${other.tore}` : ""} — gespeichert ✓`);
  };
  const undo = () => {
    if (viaServer) { if (rundeN(credit.id) > 0) serverTor(-1); return; }
    if (!hist.length) return;
    const last = hist[hist.length - 1];
    dispatch({ type: "goal/undo", teamId: credit.id, phase: "einzel", playerId: last.playerId });
    setHist((h) => h.slice(0, -1)); setPending(-1); flash("↩︎ Letztes Tor zurückgenommen");
  };
  const attribute = (pid) => {
    if (pending < 0) return;
    dispatch({ type: "player/adjustGoals", teamId: credit.id, playerId: pid, delta: +1 });
    setHist((h) => h.map((g, i) => (i === pending ? { ...g, playerId: pid } : g))); setPending(-1);
  };
  const farbe = credit.color || C.play;
  return (
    <div data-zaehlen-gross="true" style={{ maxWidth: 520, margin: "0 auto", padding: "12px 12px 24px", fontFamily: font, color: C.ink }}>
      {enthStufe(state) > 0 && <EnthuellungLive />}
      {!locked && (
        <div style={{ display: "flex", gap: 6, overflowX: "auto", paddingBottom: 8, marginBottom: 6 }}>
          {teams.map((tm) => (
            <button key={tm.id} data-zaehlen-team={tm.id} onClick={() => { setSelId(tm.id); setHist([]); setPending(-1); }}
              style={{ flexShrink: 0, border: `2px solid ${tm.id === team.id ? tm.color : C.line}`, background: tm.id === team.id ? tm.color : "#fff", color: tm.id === team.id ? "#fff" : C.ink, borderRadius: 999, padding: "7px 12px", fontWeight: 800, fontSize: 13, cursor: "pointer", fontFamily: font }}>{tm.emoji} {tm.name}</button>
          ))}
        </div>
      )}
      <div style={{ background: farbe, color: "#fff", borderRadius: 20, padding: 12, textAlign: "center", marginBottom: 10 }}>
        <div style={{ fontSize: 11, letterSpacing: 1.3, opacity: 0.92, textTransform: "uppercase" }}>
          {round ? `Runde ${round.n}` : "Turnier"}{live.running ? ` · noch ${fmtClock(rem)}` : round && rem > 0 && tournamentStarted(state) ? " · Pause" : ""}
        </div>
        <div style={{ fontWeight: 800, fontSize: 16, marginTop: 4 }}>{credit.emoji} {credit.name}</div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12, marginTop: 2 }}>
          <span data-zaehlen-stand style={{ fontFamily: display, fontWeight: 800, fontSize: 56, lineHeight: 1 }}>{viaServer ? rundeN(credit.id) : credit.tore}</span>
          {other && !viaServer && <><span style={{ opacity: 0.7, fontSize: 22 }}>:</span><span style={{ fontFamily: display, fontWeight: 800, fontSize: 56, lineHeight: 1, opacity: 0.75 }}>{other.tore}</span></>}
        </div>
        <div style={{ fontSize: 12, opacity: 0.9 }}>{other ? `gegen ${other.emoji} ${other.name} · Tore gesamt` : "Tore gesamt"}{zaehlModus === "gegner" && gegner ? " · ihr zählt für den Gegner" : ""}</div>
      </div>
      {(() => { const ph = jetztPhaseVon(state); const grund = ph === "vor" ? "⏳ Zählen geht ab dem Anpfiff." : ph === "ende" ? "🏁 Alle Spiele sind vorbei — Korrekturen macht der Headcoach." : enthStufe(state) > 0 ? "🥁 Gerade wird aufgedeckt." : null;
        return grund ? <div data-zaehlen-gesperrt="true" style={{ ...J.card, textAlign: "center", fontSize: 14, color: C.sub, marginBottom: 10 }}>{grund}</div> : null; })()}
      {nurCoach && <div data-zaehlen-nur-coach style={{ ...J.card, textAlign: "center", fontSize: 14.5, marginBottom: 10 }}>🧢 Die Tore zählt euer Coach an der Box.</div>}
      {fehlerTor && <div data-zaehlen-fehler role="alert" style={{ background: "#FDECEC", color: "#B23B3B", borderRadius: 12, padding: "9px 12px", fontSize: 13.5, fontWeight: 700, marginBottom: 10 }}>{fehlerTor}</div>}
      {!nurCoach && <button data-zaehlen-plus="true" disabled={(viaServer ? !rundeOffen(state, serverJetzt()) : jetztPhaseVon(state) !== "laeuft") || enthStufe(state) > 0} onClick={addGoal}
        style={{ width: "100%", height: 220, borderRadius: 28, border: 0, background: (viaServer ? !rundeOffen(state, serverJetzt()) : jetztPhaseVon(state) !== "laeuft") || enthStufe(state) > 0 ? "#C7D3CC" : farbe, color: "#fff", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", boxShadow: "0 8px 0 rgba(0,0,0,.18)", fontFamily: display, fontWeight: 800, fontSize: 68, lineHeight: 1, touchAction: "manipulation" }}>
        +1<span style={{ fontFamily: font, fontWeight: 800, fontSize: 17, marginTop: 6 }}>TOR {locked && credit.id === team.id ? "für uns!" : `für ${credit.name}`}</span>
      </button>}
      {toast && <div data-zaehlen-toast="true" style={{ display: "table", margin: "12px auto 0", background: C.ink, color: "#fff", borderRadius: 999, padding: "6px 14px", fontWeight: 800, fontSize: 13 }}>{toast}</div>}
      {pending >= 0 && credit.players.length > 0 && (
        <div style={{ ...J.card, marginTop: 10 }}>
          <div style={{ ...J.lbl, marginBottom: 8 }}>Wer hat getroffen? (optional)</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            {credit.players.map((pl) => <button key={pl.id} onClick={() => attribute(pl.id)} style={{ border: `1px solid ${C.line}`, background: "#fff", borderRadius: 999, padding: "8px 13px", fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: font }}>{pl.name}</button>)}
            <button onClick={() => setPending(-1)} style={{ border: "none", background: "none", color: C.sub, fontWeight: 700, cursor: "pointer", fontFamily: font }}>ohne Namen</button>
          </div>
        </div>
      )}
      <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
        <button data-zaehlen-undo onClick={undo} disabled={viaServer ? rundeN(credit.id) <= 0 : !hist.length} style={{ ...J.ghost, opacity: (viaServer ? rundeN(credit.id) > 0 : hist.length) ? 1 : 0.5 }}>↩︎ Rückgängig</button>
      </div>
    </div>
  );
}

/* =====================================================================
   STAND 35 — CHAMPIONS BIRTHDAY EXPERIENCE (Kindergeburtstag)
   ---------------------------------------------------------------------
   Fixes Firmenformat (Flyer), 4 Stunden. Je Event anpassbar sind nur
   Startzeit und Minuten je Phase (Konzept §10.2: Formate fix, Anpassung
   pro Event). Die Uhrzeiten werden daraus abgeleitet — keine zweite Wahrheit.
   Wahrheit: tournament.ablauf ([{ id, label, emo, min, info }]),
   tournament.meta.startzeit ("14:00"), tournament.meta.videoUrl,
   state.trikots ({ [playerId]: "aus" | "zurueck" | "geschenkt" }).
   ===================================================================== */
const BIRTHDAY_ABLAUF = [
  { id: "checkin",  emo: "🎟️", label: "Ankommen & Champions Check-in", min: 15, info: "Trikot, Startnummer & Armband · Begrüßung durch die Coaches" },
  { id: "training", emo: "⚡", label: "Champions Training",            min: 30, info: "Challenges in Technik, Speed, Dribbling, Passspiel & Teamwork" },
  { id: "draft",    emo: "📸", label: "Team Draft & Foto",             min: 15, info: "Das Geburtstagskind wählt als Erstes · Teamnamen · Teamfoto" },
  { id: "cup",      emo: "🏆", label: "Microsoccer Champions Cup",     min: 90, info: "Turniermodus mit kurzen Spielen, Mini-Challenges & Finale" },
  { id: "ehrung",   emo: "🥇", label: "Siegerehrung",                  min: 10, info: "Pokale, Medaillen & Urkunden für alle · Fairplay Award" },
  { id: "presse",   emo: "🎤", label: "Pressekonferenz & Interviews",  min: 10, info: "Das Geburtstagskind stellt sich den Fragen der Presse" },
  { id: "party",    emo: "🎂", label: "Birthday Party",                min: 70, info: "Kuchen, Snacks & Getränke · Highlights & Fotos auf dem Bildschirm" },
];
const BIRTHDAY_TEAMNAMEN = ["Real Madrid", "FC Barcelona", "Liverpool FC", "Manchester City", "Borussia Dortmund", "FC Bayern", "Paris Saint-Germain", "Juventus", "SK Rapid Wien"];

function hhmmToMin(s) {
  const m = /^(\d{1,2}):(\d{2})$/.exec(String(s || "").trim());
  return m ? Number(m[1]) * 60 + Number(m[2]) : null;
}
function minToHhmm(n) {
  const x = ((Math.round(n) % 1440) + 1440) % 1440;
  return `${String(Math.floor(x / 60)).padStart(2, "0")}:${String(x % 60).padStart(2, "0")}`;
}
// Uhrzeiten + aktuelle Phase aus Startzeit, Minuten und Datum ableiten.
function ablaufZeiten(ablauf, startzeit, datum, now = new Date(), aktivId = null) {
  const start = hhmmToMin(startzeit);
  let t = start == null ? 0 : start;
  const rows = (ablauf || []).map((ph) => { const von = t; t += Math.max(0, Number(ph.min) || 0); return { ...ph, von, bis: t }; });
  const total = rows.reduce((s, r) => s + (Number(r.min) || 0), 0);
  let curIdx = -1, stand = "unbekannt";
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  if (start != null && datum === today) {
    const nowMin = now.getHours() * 60 + now.getMinutes();
    if (nowMin < start) stand = "vorher";
    else if (nowMin >= t) stand = "vorbei";
    else { stand = "laeuft"; curIdx = rows.findIndex((r) => nowMin >= r.von && nowMin < r.bis); }
  } else if (datum && datum < today) stand = "vorbei";
  else if (datum && datum > today) stand = "vorher";
  // Stand 37: vom Headcoach gestartete Phase hat Vorrang vor der Uhrzeit
  if (aktivId) {
    const i = rows.findIndex((r) => r.id === aktivId);
    if (aktivId === "_fertig") { stand = "vorbei"; curIdx = -1; }
    else if (i >= 0) { stand = "laeuft"; curIdx = i; }
  }
  return { rows, total, curIdx, stand, hasStart: start != null };
}
function useMinuteTick() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 30000); return () => clearInterval(t); }, []);
  return now;
}

function AblaufListe({ ablauf, startzeit, datum, edit, onMin, aktivId }) {
  const now = useMinuteTick();
  const z = ablaufZeiten(ablauf, startzeit, datum, now, aktivId);
  return (
    <div data-ablauf="true">
      {z.rows.map((r, i) => {
        const cur = i === z.curIdx;
        const done = z.stand === "vorbei" || (z.stand === "laeuft" && i < z.curIdx);
        return (
          <div key={r.id} data-ablauf-phase={r.id} data-aktuell={cur ? "true" : undefined}
            style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 10px", borderRadius: 12, margin: "2px -10px",
              background: cur ? C.playSoft : "transparent", opacity: done ? 0.55 : 1 }}>
            <span style={{ width: 46, fontFamily: display, fontWeight: 700, fontSize: 15, color: cur ? C.play : C.sub }}>{z.hasStart ? minToHhmm(r.von) : `+${r.von}`}</span>
            <span style={{ fontSize: 20 }}>{r.emo}</span>
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={{ display: "block", fontWeight: 700, fontSize: 14.5 }}>{r.label}{cur && <span style={{ marginLeft: 8, background: C.whistle, color: "#fff", borderRadius: 999, padding: "1px 7px", fontSize: 10.5, verticalAlign: "middle" }}>JETZT</span>}</span>
              {r.info && <span style={{ display: "block", fontSize: 12.5, color: C.sub, lineHeight: 1.35 }}>{r.info}</span>}
            </span>
            {edit ? (
              <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                <button aria-label="5 Minuten weniger" onClick={() => onMin(r.id, Math.max(0, r.min - 5))} style={{ width: 28, height: 28, borderRadius: 8, border: `1px solid ${C.line}`, background: "#fff", cursor: "pointer", fontWeight: 700 }}>–</button>
                <span data-ablauf-min={r.id} style={{ width: 44, textAlign: "center", fontFamily: display, fontWeight: 700 }}>{r.min}′</span>
                <button aria-label="5 Minuten mehr" onClick={() => onMin(r.id, r.min + 5)} style={{ width: 28, height: 28, borderRadius: 8, border: `1px solid ${C.line}`, background: "#fff", cursor: "pointer", fontWeight: 700 }}>+</button>
              </span>
            ) : <span style={{ fontSize: 12.5, color: C.sub }}>{r.min}′</span>}
          </div>
        );
      })}
      <div style={{ fontSize: 12, color: C.sub, marginTop: 6 }}>Gesamt {Math.floor(z.total / 60)}:{String(z.total % 60).padStart(2, "0")} h{z.hasStart ? ` · Ende ${minToHhmm(z.rows.length ? z.rows[z.rows.length - 1].bis : 0)}` : ""}</div>
    </div>
  );
}

// Stand 37: klarer Start-Knopf fuer den Ablauf -- der Headcoach schaltet die
// Phasen weiter (Eltern-Seite und alle Geraete sehen "JETZT" sofort).
function AblaufSteuerung() {
  const { state, dispatch } = useStore();
  const t = state.tournament;
  if (state.role !== "headcoach" || !Array.isArray(t.ablauf)) return null;
  const rows = t.ablauf;
  const idx = rows.findIndex((r) => r.id === t.ablaufAktiv);
  const fertig = t.ablaufAktiv === "_fertig";
  const next = fertig ? null : rows[idx + 1] || null;
  const setz = (id) => dispatch({ type: "ablauf/aktiv", id });
  const big = { border: 0, borderRadius: 14, padding: "12px 16px", fontFamily: display, fontWeight: 800, fontSize: 18, color: "#fff", background: C.play, boxShadow: "0 4px 0 #1E8A4F", cursor: "pointer", flex: 1 };
  return (
    <div data-ablauf-steuerung={t.ablaufAktiv || "start"} style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
      {fertig ? <span style={{ fontWeight: 700, fontSize: 14 }}>🎉 Ablauf geschafft!</span>
        : next ? <button data-ablauf-weiter onClick={() => setz(next.id)} style={big}>{idx < 0 ? `▶ Start: ${next.emo} ${next.label}` : `⏭ Weiter: ${next.emo} ${next.label}`}</button>
        : <button data-ablauf-weiter onClick={() => setz("_fertig")} style={big}>🏁 Ablauf beenden</button>}
      {(idx >= 0 || fertig) && <button data-ablauf-zurueck onClick={() => setz(fertig ? rows[rows.length - 1].id : idx > 0 ? rows[idx - 1].id : null)} style={{ border: `1px solid ${C.line}`, background: "#fff", borderRadius: 12, padding: "10px 12px", fontWeight: 700, fontSize: 13, cursor: "pointer", fontFamily: font }}>◀ zurück</button>}
      {rows[idx] && rows[idx].id === "cup" && <div style={{ width: "100%", fontSize: 12.5, color: C.sub }}>Den Cup selbst startest du in „Jetzt" mit „▶ Turnier starten".</div>}
    </div>
  );
}

// Team-Ansicht (Headcoach/Coach) im Tab "Heute" — nur bei Events mit Ablauf.
function GeburtstagPanel() {
  const { state, dispatch } = useStore();
  const t = state.tournament;
  const [open, setOpen] = useState("ablauf"); // ablauf | trikots | video
  if (!Array.isArray(t.ablauf) || t.ablauf.length === 0) return null;
  const hc = state.role === "headcoach";
  const players = state.teams.flatMap((tm) => tm.players.map((p) => ({ ...p, team: tm })));
  const trikots = state.trikots || {};
  const offen = players.filter((p) => (trikots[p.id] || "aus") === "aus").length;
  const tab = (id, label) => (
    <button key={id} data-gb-tab={id} onClick={() => setOpen(id)} style={{ border: `1px solid ${open === id ? C.play : C.line}`, background: open === id ? C.play : "#fff", color: open === id ? "#fff" : C.ink, borderRadius: 999, padding: "6px 12px", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: font }}>{label}</button>
  );
  const inp = { border: `1px solid ${C.line}`, borderRadius: 10, padding: "8px 10px", fontSize: 14.5, fontFamily: font };
  return (
    <div data-geburtstag-panel="true" style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: 14, display: "flex", flexDirection: "column", gap: 10 }}>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
        <span style={{ fontFamily: display, fontWeight: 700, fontSize: 16, marginRight: 4 }}>🎂 Birthday Experience</span>
        {tab("ablauf", "Ablauf")}
        {hc && tab("teams", `Teams · ${state.teams.length}`)}
        {tab("trikots", `Trikots${offen ? ` · ${offen} offen` : " ✓"}`)}
        {tab("video", "🎬 Video")}
      </div>
      {open === "ablauf" && (
        <>
          {hc && (
            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13.5, color: C.sub }}>
              Startzeit
              <input data-startzeit type="time" value={t.meta.startzeit || ""} onChange={(e) => dispatch({ type: "meta/patch", patch: { startzeit: e.target.value } })} style={inp} />
              <span style={{ fontSize: 12 }}>Minuten je Phase mit – / + anpassen</span>
            </label>
          )}
          <AblaufSteuerung />
          <AblaufListe ablauf={t.ablauf} startzeit={t.meta.startzeit} datum={t.meta.date} aktivId={t.ablaufAktiv} edit={hc} onMin={(id, min) => dispatch({ type: "ablauf/setMin", id, min })} />
        </>
      )}
      {open === "teams" && hc && (
        <div data-gb-teams="true">
          <div style={{ fontSize: 13.5, color: C.sub, marginBottom: 8 }}>Für den Team Draft: Vereinsnamen antippen legt das Team an. Kinder danach in der Team-Verwaltung zuordnen.</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {BIRTHDAY_TEAMNAMEN.filter((n) => !state.teams.some((tm) => tm.name.toLowerCase() === n.toLowerCase())).map((n) => (
              <button key={n} data-verein={n} onClick={() => dispatch({ type: "team/add", name: n })}
                style={{ border: `1px dashed ${C.play}`, background: "#fff", color: C.play, borderRadius: 999, padding: "6px 12px", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: font }}>+ {n}</button>
            ))}
          </div>
          {state.teams.length > 0 && <div style={{ fontSize: 13, marginTop: 10 }}>Angelegt: {state.teams.map((tm) => `${tm.emoji} ${tm.name}`).join(" · ")}</div>}
        </div>
      )}
      {open === "trikots" && (
        <div data-trikot-liste="true">
          {players.length === 0 ? (
            <div style={{ fontSize: 13.5, color: C.sub }}>Noch keine Kinder in Teams — beim Team Draft in der Team-Verwaltung eintragen, dann erscheinen sie hier.</div>
          ) : players.map((p) => {
            const st = trikots[p.id] || "aus";
            const b = (v, label) => (
              <button key={v} data-trikot={`${p.id}:${v}`} onClick={() => dispatch({ type: "trikot/set", playerId: p.id, status: v })}
                style={{ border: `1px solid ${st === v ? C.play : C.line}`, background: st === v ? C.playSoft : "#fff", color: C.ink, borderRadius: 8, padding: "4px 8px", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: font }}>{label}</button>
            );
            return (
              <div key={p.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 0", borderTop: `1px solid ${C.line}`, flexWrap: "wrap" }}>
                <span style={{ flex: 1, minWidth: 120, fontSize: 14 }}>{p.team.emoji} <b>{p.name}</b> <span style={{ color: C.sub, fontSize: 12.5 }}>· {p.team.name}</span></span>
                {b("aus", "👕 ausgegeben")}{b("zurueck", "✓ zurück")}{b("geschenkt", "🎁 geschenkt")}
              </div>
            );
          })}
        </div>
      )}
      {open === "video" && (
        <div>
          <div style={{ fontSize: 13.5, color: C.sub, marginBottom: 8, lineHeight: 1.45 }}>Link zum fertigen Experience-Video (z. B. Drive oder YouTube „nicht gelistet"). Erscheint danach auf der Gäste-Seite der Eltern — über denselben QR.</div>
          <input data-video-url value={t.meta.videoUrl || ""} disabled={!hc} placeholder="https://…" onChange={(e) => dispatch({ type: "meta/patch", patch: { videoUrl: e.target.value } })} style={{ ...inp, width: "100%" }} />
        </div>
      )}
    </div>
  );
}

// Gäste-Seite für Eltern: Ablauf live + Cup-Tabelle + Ehrung + Video.
function GastGeburtstag({ event, format }) {
  const { state } = useStore();
  if (enthAusstehend(state) && enthStufe(state) > 0) return <div style={{ padding: "16px 0 40px" }}><EnthuellungLive /></div>;
  return <GastGeburtstagInhalt event={event} format={format} />;
}
function GastGeburtstagInhalt({ event, format }) {
  const { state } = useStore();
  const t = state.tournament;
  const meta = t.meta;
  const ranked = state.teams.map((tm) => ({ tm, sc: teamScore(tm, state.factors) })).sort((a, b) => b.sc.total - a.sc.total);
  const awards = (state.awards || []).filter((a) => a.teamId);
  const card = { background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: 16, marginBottom: 12 };
  const lbl = { fontSize: 11.5, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 10 };
  const video = /^https?:\/\//i.test(meta.videoUrl || "") ? meta.videoUrl : null;
  return (
    <div style={{ fontFamily: font, color: C.ink }}>
      <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
      <div style={{ background: C.play, color: "#fff", padding: "22px 18px 20px", textAlign: "center" }}>
        <div style={{ fontSize: 12, letterSpacing: 1.5, opacity: 0.92, textTransform: "uppercase" }}>🎂 Champions Birthday Experience</div>
        <h1 style={{ fontFamily: display, fontWeight: 700, fontSize: 30, lineHeight: 1.05, margin: "6px 0 4px" }}>{meta.title || event.title}</h1>
        <div style={{ fontSize: 13.5, opacity: 0.92 }}>{[fmtEventDate(meta.date || event.datum), meta.startzeit ? `ab ${meta.startzeit}` : null, meta.ort || event.ort].filter(Boolean).join(" · ")}</div>
      </div>
      <div style={{ maxWidth: 560, margin: "0 auto", padding: 16 }}>
        {video && (
          <a data-gast-video="true" href={video} target="_blank" rel="noopener noreferrer"
            style={{ display: "block", textDecoration: "none", background: C.ink, color: "#fff", borderRadius: 16, padding: "16px 18px", marginBottom: 12, fontFamily: display, fontWeight: 700, fontSize: 20 }}>
            🎬 Euer Experience-Video ist da →
          </a>
        )}
        <div style={card}>
          <div style={lbl}>Ablauf</div>
          <AblaufListe ablauf={t.ablauf} startzeit={meta.startzeit} datum={meta.date} aktivId={t.ablaufAktiv} edit={false} />
        </div>
        {ranked.length > 0 && !ergebnisseOffen(state) && (
          <div data-gast-cup="spielplan" style={card}>
            <div style={lbl}>🏆 Champions Cup · wer gewinnt, gibt's bei der Siegerehrung 🤫</div>
            <SpielplanAnsicht />
          </div>
        )}
        {ranked.length > 0 && ergebnisseOffen(state) && (
          <div data-gast-cup="true" style={card}>
            <div style={lbl}>🏆 Champions Cup · Ergebnis</div>
            {ranked.map(({ tm, sc }, i) => (
              <div key={tm.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "7px 0", borderTop: i ? `1px solid ${C.line}` : "none", fontSize: 15 }}>
                <span style={{ width: 22, fontFamily: display, fontWeight: 700, color: i === 0 ? "#C99A1E" : C.sub }}>{i + 1}</span>
                <span style={{ fontSize: 18 }}>{tm.emoji}</span>
                <span style={{ flex: 1, fontWeight: i === 0 ? 700 : 400 }}>{tm.name}</span>
                <span style={{ fontFamily: display, fontWeight: 700, fontSize: 17 }}>{sc.total}</span>
              </div>
            ))}
          </div>
        )}
        {awards.length > 0 && (
          <div style={card}>
            <div style={lbl}>Auszeichnungen</div>
            {awards.map((a) => { const tm = state.teams.find((x) => x.id === a.teamId); return (
              <div key={a.id} style={{ display: "flex", gap: 10, padding: "5px 0", fontSize: 15 }}><span>{a.emoji}</span><span style={{ flex: 1 }}>{a.title}</span><b>{tm ? tm.name : ""}</b></div>
            ); })}
          </div>
        )}
        <div style={{ textAlign: "center", fontSize: 12, color: C.sub, marginTop: 14 }}>Aktualisiert sich von selbst · {BRAND}</div>
      </div>
    </div>
  );
}

/* =====================================================================
   STAND 35 — GÄSTE-QR + LIVE-EVENTSEITE + KACHEL-ÜBERSICHT
   ---------------------------------------------------------------------
   Gäste (Afterwork, Kindergeburtstag, Zuschauer:innen) scannen einen QR
   und sehen sofort die Live-Seite IHRES Events — ohne Login, ohne Auswahl,
   nur lesen. Der QR enthält einen geheimen Gäste-Schlüssel (?gast=...),
   der Server liefert dafür einen bereinigten Stand ohne Zugangs-Codes.
   Was die Seite zeigt, bestimmt das Format (kind team/tour).
   ===================================================================== */
function gastTokenFromUrl() {
  try { return new URLSearchParams(window.location.search).get("gast"); } catch (_) { return null; }
}
function gastUrl(token) {
  return `${window.location.origin}${window.location.pathname}?gast=${encodeURIComponent(token)}`;
}
function QrBild({ text, size = 220 }) {
  const svg = useMemo(() => {
    try {
      const q = qrcode(0, "M");
      q.addData(text);
      q.make();
      return q.createSvgTag({ cellSize: 4, margin: 2, scalable: true });
    } catch (_) { return ""; }
  }, [text]);
  return <div data-qr="true" style={{ width: size, height: size, background: "#fff", lineHeight: 0 }} dangerouslySetInnerHTML={{ __html: svg }} />;
}

// Kurzer Live-Status je Event in der Übersicht — rein aus ev.summary
// (vom Server aus dem letzten Stand abgeleitet).
function eventLiveInfo(ev) {
  const s = ev.summary;
  if (!s) return null;
  const f = formatById(ev.format);
  const kind = f && (f.kind === "team" || f.kind === "tour") ? f.kind : (s.koActive || s.koParticipants ? "tour" : "team");
  if (kind === "tour") {
    if (s.koFinished) return { live: false, text: "KO fertig · Sieger:in steht fest" };
    if (s.koActive) return { live: true, running: true, text: `KO läuft · ${s.koParticipants} Spieler:innen` };
    if (s.koParticipants) return { live: false, text: `Anmeldung · ${s.koParticipants} Spieler:innen` };
    return { live: false, text: "in Vorbereitung" };
  }
  if (s.started) {
    const mm = Math.floor(Math.max(0, s.remaining) / 60), ss = String(Math.max(0, s.remaining) % 60).padStart(2, "0");
    return { live: true, running: s.running, text: s.running ? `Runde ${s.cur} von ${s.rounds} · noch ${mm}:${ss}` : `Runde ${s.cur} von ${s.rounds} · Pause` };
  }
  return { live: false, text: s.teams ? `Vorbereitung · ${s.teams} Teams` : "in Vorbereitung" };
}
function LivePill({ info }) {
  if (!info) return null;
  const st = info.live
    ? (info.running ? { bg: "#FDECEC", fg: "#B23B3B", pre: "● " } : { bg: C.brkSoft, fg: "#8A5A00", pre: "❚❚ " })
    : { bg: C.chalk, fg: C.sub, pre: "" };
  return <span data-live-pill="true" style={{ display: "inline-block", marginTop: 6, background: st.bg, color: st.fg, borderRadius: 999, padding: "3px 9px", fontSize: 11.5, fontWeight: 700 }}>{st.pre}{info.text}</span>;
}

// Einstiegskacheln oben in der Übersicht. Die gewählte Absicht wird beim
// Antippen eines Events mitgegeben und führt dort direkt zum richtigen
// Schritt (Team wählen, Coach-Code, Zuschauen) — ohne Startseite dazwischen.
const EINSTIEG = [
  { id: "team", emo: "📱", label: "Ich spiele mit", sub: "Team-Handy verbinden", hint: "Jetzt unten dein Event antippen → Team wählen → zählen, Fairplay, Aufgaben. Kein Code nötig." },
  { id: "coach", emo: "🧢", label: "Ich bin Coach", sub: "mit Code des Events", hint: "Jetzt unten dein Event antippen → Coach-Code dieses Events → dein Team, Live-Zähler, Wertung." },
  { id: "public", emo: "👀", label: "Ich schaue zu", sub: "Live-Tabelle & Ergebnisse", hint: "Jetzt unten ein Event antippen → Live-Ergebnisse ohne Anmeldung. Gäste bekommen dafür auch einen QR-Code." },
  { id: "neu", emo: "🆕", label: "Neues Event", sub: "anlegen & Codes vergeben", hint: "" }, // Stand 37o: nur im Büro-Modus sichtbar
];
function EinstiegsKacheln({ intent, onIntent, onNeu, mitNeu = false }) {
  const cur = EINSTIEG.find((e) => e.id === intent);
  const kacheln = EINSTIEG.filter((e) => e.id !== "neu" || mitNeu);
  return (
    <div style={{ marginBottom: 6 }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        {kacheln.map((e, i) => {
          const on = e.id === intent;
          const breit = kacheln.length % 2 === 1 && i === kacheln.length - 1; // ungerade Anzahl: letzte Kachel ganze Breite
          return (
            <button key={e.id} data-einstieg={e.id} onClick={() => (e.id === "neu" ? onNeu() : onIntent(on ? null : e.id))}
              style={{ gridColumn: breit ? "1 / -1" : undefined, textAlign: "left", fontFamily: font, cursor: "pointer", background: "#fff", color: C.ink, borderRadius: 16, padding: "14px 12px",
                border: on ? `2px solid ${C.play}` : `1px solid ${C.line}`, boxShadow: on ? `0 0 0 3px ${C.playSoft}` : "none" }}>
              <span style={{ display: "block", fontSize: 26, lineHeight: 1 }}>{e.emo}</span>
              <span style={{ display: "block", fontFamily: display, fontWeight: 700, fontSize: 17, marginTop: 8 }}>{e.label}</span>
              <span style={{ display: "block", fontSize: 12.5, color: C.sub, lineHeight: 1.35, marginTop: 2 }}>{e.sub}</span>
            </button>
          );
        })}
      </div>
      {cur && <div data-einstieg-hint="true" style={{ fontSize: 13, color: C.ink, background: C.playSoft, borderRadius: 12, padding: "10px 12px", marginTop: 10, lineHeight: 1.45 }}>{cur.hint}</div>}
    </div>
  );
}

/* ---------- Gäste-QR für das Team (unter "Ich") ---------- */
function GastQrKarte() {
  const { state, gastToken } = useStore();
  const [print, setPrint] = useState(false);
  const [copied, setCopied] = useState(false);
  if (!gastToken) return null;
  const url = gastUrl(gastToken);
  const meta = state.tournament.meta;
  const f = formatById(meta.format);
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 1600); } catch (_) { /* noop */ }
  };
  const btn = { border: `1.5px solid ${C.line}`, background: "#fff", color: C.ink, fontFamily: font, fontWeight: 700, fontSize: 13.5, padding: "9px 12px", borderRadius: 10, cursor: "pointer" };
  return (
    <div data-gast-qr-karte="true" style={{ background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: 16 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 10 }}>Gäste-QR · Live-Seite dieses Events</div>
      <div style={{ display: "flex", gap: 16, alignItems: "center", flexWrap: "wrap" }}>
        <QrBild text={url} size={150} />
        <div style={{ flex: 1, minWidth: 180 }}>
          <div style={{ fontSize: 13.5, color: C.sub, lineHeight: 1.5, marginBottom: 10 }}>Gäste scannen und sehen sofort Ergebnisse und Rangliste — live, ohne Anmeldung, ohne Codes. Das Event steht dadurch nicht öffentlich auf der Website.</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <button style={btn} onClick={() => setPrint(true)}>🖨️ Aufsteller drucken</button>
            <button style={btn} onClick={copy}>{copied ? "✓ Kopiert" : "🔗 Link kopieren"}</button>
          </div>
        </div>
      </div>
      {print && (
        <div className="ms-qr-print" style={{ position: "fixed", inset: 0, zIndex: 500, background: "#fff", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 18, padding: 24, fontFamily: font, color: C.ink, textAlign: "center" }}>
          <style>{`@media print { body * { visibility: hidden !important; } .ms-qr-print, .ms-qr-print * { visibility: visible !important; } .ms-qr-print { position: fixed; inset: 0; } .ms-noprint { display: none !important; } }`}</style>
          <img src={LOGO_GREEN} alt={BRAND} style={{ height: 44, width: "auto" }} />
          <div style={{ fontFamily: display, fontWeight: 700, fontSize: 34, lineHeight: 1.05 }}>{meta.title}</div>
          <div style={{ fontSize: 16, color: C.sub }}>{[f ? `${f.emo} ${f.label}` : null, meta.ort].filter(Boolean).join(" · ")}</div>
          <QrBild text={url} size={300} />
          <div style={{ fontFamily: display, fontWeight: 700, fontSize: 24 }}>Scannen → Ergebnisse live 📱</div>
          <div style={{ fontSize: 13, color: C.sub }}>Ohne App, ohne Anmeldung.</div>
          <div className="ms-noprint" style={{ display: "flex", gap: 10, marginTop: 8 }}>
            <button onClick={() => { try { window.print(); } catch (_) { /* noop */ } }} style={{ border: "none", background: C.play, color: "#fff", borderRadius: 10, padding: "11px 18px", fontWeight: 700, fontSize: 15, cursor: "pointer", fontFamily: font }}>Drucken</button>
            <button onClick={() => setPrint(false)} style={{ ...btn }}>Schließen</button>
          </div>
        </div>
      )}
    </div>
  );
}

/* ---------- Gäste-Ansicht ---------- */
function GastGate({ token }) {
  const [data, setData] = useState(null); // { id, state, event }
  const [err, setErr] = useState(null);
  const idRef = useRef(null);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const d = await loadGast(token);
        if (!alive) return;
        idRef.current = d.id; setData(d); setErr(null);
      } catch (e) { if (alive) setErr(e); }
    };
    load();
    const timer = setInterval(async () => {
      try {
        const m = await pollGast(token);
        if (m && m.id !== idRef.current) load();
      } catch (_) { /* nächster Versuch beim nächsten Tick */ }
    }, POLL_INTERVAL_MS);
    return () => { alive = false; clearInterval(timer); };
  }, [token]);

  const wrap = (children) => (
    <div style={{ background: C.chalk, minHeight: "100vh", fontFamily: font, color: C.ink, display: "grid", placeItems: "center", padding: 20, textAlign: "center" }}>
      <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;}`}</style>
      <div style={{ maxWidth: 420 }}>{children}</div>
    </div>
  );
  if (err && !data) {
    return wrap(<>
      <img src={LOGO_GREEN} alt={BRAND} style={{ height: 40, width: "auto" }} />
      <h1 style={{ fontFamily: display, fontWeight: 700, fontSize: 24, margin: "16px 0 6px" }}>{err.status === 404 ? "Link ungültig" : "Keine Verbindung"}</h1>
      <p style={{ color: C.sub, fontSize: 14.5, lineHeight: 1.5 }}>{err.status === 404 ? "Dieser QR-Code gehört zu keinem Event (mehr). Bitte beim Team vor Ort nachfragen." : "Gerade keine Verbindung zum Server — die Seite versucht es gleich wieder."}</p>
    </>);
  }
  if (!data) return <InitialLoadScreen />;
  return <GastSeite data={data} />;
}

function GastSeite({ data }) {
  const ev = data.event || {};
  const f = formatById(ev.format);
  const base = blankState();
  const state = data.state
    ? { ...base, ...data.state, archivedTournaments: data.state.archivedTournaments || [], invitations: [], aufgabenZiehung: data.state.aufgabenZiehung || [], role: "public", view: "website", boundTeamId: null, boundDeviceId: null }
    : { ...base, role: "public", view: "website", tournament: { ...base.tournament, meta: { ...base.tournament.meta, title: ev.title || "", ort: ev.ort || "", date: ev.datum || "", format: ev.format } } };
  const kind = f && (f.kind === "team" || f.kind === "tour") ? f.kind
    : (state.ko && (state.ko.bracket || (state.ko.participants || []).length)) ? "tour" : "team";
  const store = { state, dispatch: () => {}, eventId: null, reopen: null, gastToken: null };
  return (
    <StoreContext.Provider value={store}>
      <div data-gast-seite={kind} style={{ background: C.chalk, minHeight: "100vh" }}>
        {Array.isArray(state.tournament.ablauf) && state.tournament.ablauf.length > 0
          ? <GastGeburtstag event={ev} format={f} />
          : kind === "tour" ? <GastTourLive event={ev} format={f} /> : <Website />}
      </div>
    </StoreContext.Provider>
  );
}

function GastTourLive({ event, format }) {
  const gastTour = useTourAnsicht(); // Stand 37f
  const { state } = useStore();
  const meta = state.tournament.meta;
  const ko = state.ko || { participants: [], bracket: null };
  const br = ko.bracket;
  const R = br ? br.rounds.length : 0;
  const placements = useMemo(() => koPlacements(br), [br]);
  const allMatches = br ? [
    ...br.rounds.flatMap((round, r) => round.map((m) => ({ m, label: koRoundName(r, R) }))),
    ...(br.smallFinal ? [{ m: br.smallFinal, label: "Spiel um Platz 3" }] : []),
  ] : [];
  const current = allMatches.find(({ m }) => !m.done && m.a && m.b && !m.a.bye && !m.b.bye) || null;
  const closed = state.tournament.status === "abgeschlossen";
  const dateStr = fmtEventDate(meta.date || event.datum);
  const card = { background: "#fff", border: `1px solid ${C.line}`, borderRadius: 16, padding: 16, marginBottom: 12 };
  const lbl = { fontSize: 11.5, fontWeight: 700, color: C.sub, textTransform: "uppercase", letterSpacing: 0.6, marginBottom: 10 };
  const nm = (p) => (p ? (p.bye ? "Freilos" : p.name) : "…");
  return (
    <div style={{ fontFamily: font, color: C.ink }}>
      <style>{`@import url('${FONT_IMPORT}'); *{box-sizing:border-box;} @keyframes msPulse{70%{box-shadow:0 0 0 8px rgba(229,72,77,0)}100%{box-shadow:0 0 0 0 rgba(229,72,77,0)}}`}</style>
      <div style={{ background: C.play, color: "#fff", padding: "22px 18px 20px", textAlign: "center" }}>
        <div style={{ fontSize: 12, letterSpacing: 1.5, opacity: 0.92, textTransform: "uppercase" }}>{format ? `${format.emo} ${format.label}` : "Microsoccer"}</div>
        <h1 style={{ fontFamily: display, fontWeight: 700, fontSize: 30, lineHeight: 1.05, margin: "6px 0 4px" }}>{meta.title || event.title}</h1>
        <div style={{ fontSize: 13.5, opacity: 0.92 }}>{[dateStr, meta.ort || event.ort].filter(Boolean).join(" · ")}</div>
      </div>
      <div style={{ maxWidth: 560, margin: "0 auto", padding: 16 }}>
        {istAfterwork(state) && (() => {
          const ab = state.abend || ABEND_LEER; const r = ab.runden.find((x) => x.id === ab.aktivId);
          const nm2 = (id) => (state.ko.participants.find((p) => p.id === id) || {}).name;
          return (<>
            {r && r.form === "sieger" && !closed && <div data-gast-box="true" style={card}><div style={lbl}>⚽ Jetzt in der Box</div><div style={{ fontFamily: display, fontWeight: 800, fontSize: 22, textAlign: "center" }}>{nm2(r.box[0])} <span style={{ color: C.sub }}>vs</span> {nm2(r.box[1])}</div><div style={{ fontSize: 13, color: C.sub, textAlign: "center", marginTop: 6 }}>Als Nächstes: {r.queue.slice(0, 3).map(nm2).filter(Boolean).join(" · ") || "—"}</div></div>}
            {ab.runden.length > 0 && <div style={card}><AwWertung max={10} /></div>}
          </>);
        })()}
        {placements.length > 0 && (
          <div data-gast-sieger="true" style={card}>
            <div style={lbl}>🏆 Ergebnis</div>
            {placements.map((p) => (
              <div key={p.placement} style={{ display: "flex", alignItems: "center", gap: 10, padding: "7px 0", borderTop: p.placement > 1 ? `1px solid ${C.line}` : "none", fontSize: 16 }}>
                <span style={{ width: 28, fontSize: 20 }}>{["🥇", "🥈", "🥉", "4."][p.placement - 1]}</span>
                <span style={{ flex: 1, fontWeight: p.placement === 1 ? 700 : 400 }}>{p.name}</span>
              </div>
            ))}
          </div>
        )}
        {current && !closed && (
          <div data-gast-jetzt="true" style={card}>
            <div style={{ ...lbl, display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ width: 8, height: 8, borderRadius: "50%", background: C.whistle, animation: "msPulse 1.6s infinite" }} /> Jetzt · {current.label}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, fontFamily: display, fontWeight: 700, fontSize: 22 }}>
              <span style={{ flex: 1, textAlign: "right" }}>{nm(current.m.a)}</span>
              <span style={{ background: C.chalk, borderRadius: 10, padding: "4px 12px", minWidth: 70, textAlign: "center" }}>{current.m.sa} : {current.m.sb}</span>
              <span style={{ flex: 1 }}>{nm(current.m.b)}</span>
            </div>
          </div>
        )}
        {br ? (
          <div style={card}>
            <div style={lbl}>Spiele</div>
            {[...br.rounds.map((round, r) => ({ label: koRoundName(r, R), ms: round })), ...(br.smallFinal ? [{ label: "Spiel um Platz 3", ms: [br.smallFinal] }] : [])].map((g) => (
              <div key={g.label} style={{ marginBottom: 10 }}>
                <div style={{ fontFamily: display, fontWeight: 700, fontSize: 15, color: C.sub, margin: "4px 0 6px" }}>{g.label}</div>
                {g.ms.filter((m) => !(m.b && m.b.bye)).map((m) => (
                  <div key={m.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 0", borderTop: `1px solid ${C.line}`, fontSize: 14.5 }}>
                    <span style={{ flex: 1, fontWeight: m.done && m.winner && m.a && m.winner.id === m.a.id ? 700 : 400 }}>{nm(m.a)}</span>
                    <span style={{ fontFamily: display, fontWeight: 700, color: m.done ? C.ink : C.sub }}>{m.done ? `${m.sa} : ${m.sb}` : "– : –"}</span>
                    <span style={{ flex: 1, textAlign: "right", fontWeight: m.done && m.winner && m.b && m.winner.id === m.b.id ? 700 : 400 }}>{nm(m.b)}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        ) : (
          <div style={card}>
            <div style={lbl}>Dabei ({(ko.participants || []).length})</div>
            {(ko.participants || []).length === 0
              ? <div style={{ color: C.sub, fontSize: 14.5 }}>Gleich geht's los — hier erscheinen die Spiele live.</div>
              : <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>{ko.participants.map((p) => <span key={p.id} style={{ background: C.playSoft, borderRadius: 999, padding: "5px 11px", fontSize: 14, fontWeight: 600 }}>{p.name}</span>)}</div>}
          </div>
        )}
        {gastTour && (gastTour.events || []).length > 0 && (
          <div style={card}>
            <div style={lbl}>Tour-Rangliste</div>
            {tourStandings(gastTour).slice(0, 10).map((r, i) => (
              <div key={r.kid.id} style={{ display: "flex", gap: 10, padding: "6px 0", borderTop: i ? `1px solid ${C.line}` : "none", fontSize: 14.5 }}>
                <span style={{ width: 22, color: C.sub, fontFamily: display, fontWeight: 700 }}>{i + 1}</span>
                <span style={{ flex: 1 }}>{r.kid.name}</span>
                <span style={{ fontFamily: display, fontWeight: 700 }}>{r.total}</span>
              </div>
            ))}
          </div>
        )}
        <div style={{ textAlign: "center", fontSize: 12, color: C.sub, marginTop: 14 }}>Aktualisiert sich von selbst · {BRAND}</div>
      </div>
    </div>
  );
}

export default function App() {
  // Stand 35: Gaeste-QR (?gast=...) -> nur die Live-Seite dieses Events.
  // Sonst (Stand 34): zuerst das Event, dann (je Event) Speicher + Einstieg.
  const [gast] = useState(() => gastTokenFromUrl());
  useEffect(() => { uxStart(); if (gast) { uxKontext({ rolle: "gast" }); uxBildschirm("gast"); } }, [gast]); // Stand 40: Usability-Schleife
  return <UxFehlerGrenze>{gast ? <GastGate token={gast} /> : <EventGate />}</UxFehlerGrenze>;
}

/* ---------- Stand 40: Fehlergrenze — statt weißer Seite ein Neu-laden-Knopf, und der Absturz wird gemeldet ---------- */
class UxFehlerGrenze extends React.Component {
  constructor(p) { super(p); this.state = { fehler: null }; }
  static getDerivedStateFromError(fehler) { return { fehler }; }
  componentDidCatch(err, info) { uxAbsturz(err, info); }
  render() {
    if (!this.state.fehler) return this.props.children;
    return (
      <div data-absturz="true" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: font, background: C.chalk, color: C.ink }}>
        <div style={{ maxWidth: 380, background: "#fff", borderRadius: 18, padding: 24, textAlign: "center", boxShadow: "0 10px 30px rgba(0,0,0,.08)" }}>
          <div style={{ fontSize: 40 }}>🙈</div>
          <h2 style={{ fontFamily: display, margin: "8px 0" }}>Da ist etwas schiefgelaufen</h2>
          <p style={{ color: C.sub, fontSize: 14, lineHeight: 1.5 }}>Der Fehler wurde automatisch gemeldet. Deine Daten sind gespeichert — einfach neu laden.</p>
          <button onClick={() => { try { window.location.reload(); } catch (_) { /* noop */ } }} style={{ border: "none", background: C.play, color: "#fff", borderRadius: 999, padding: "12px 20px", fontWeight: 800, fontSize: 15, cursor: "pointer", fontFamily: font }}>↻ Neu laden</button>
        </div>
      </div>
    );
  }
}

function Gate() {
  const { state } = useStore();
  // Einladungs-Link (Stand 30): ?invite=<token> in der URL fuehrt komplett AN
  // Login/Rollenwahl VORBEI, egal ob/als was man sonst eingeloggt waere -- der
  // Link selbst ist die Berechtigung (wie bei der PIN, nur personalisiert auf
  // genau einen Team-Slot). Einmal beim Erststart gelesen, kein Router noetig:
  // die App hat ohnehin keine weitere Navigation, die die URL veraendern wuerde.
  const [inviteToken] = useState(() => {
    try { return new URLSearchParams(window.location.search).get("invite"); } catch (_) { return null; }
  });
  // Stand 32 -- Startseite VOR der Rollen-Auswahl: nur ein UI-Zustand fuer
  // DIESEN Ladevorgang (bewusst nicht in localStorage gespiegelt), damit die
  // Erklaerung wirklich jedes Mal zu sehen ist, wenn gerade niemand
  // eingeloggt ist -- auch direkt nach "Abmelden".
  const nav = useEventNav();
  const [intent, setIntent] = useState(() => (nav && nav.intent) || null);
  const [pastStart, setPastStart] = useState(() => !!nav); // Stand 37p: aus der Event-Liste direkt zu "Wer bist du?" (Startseite bleibt fuer Alt-Aufrufe ohne Liste)
  useEffect(() => { if (state.role && intent) setIntent(null); }, [state.role, intent]);
  const uxSchirm = state.role ? null : !pastStart ? "startseite" : "login"; // Stand 40
  useEffect(() => { if (uxSchirm) { uxKontext({ rolle: null }); uxBildschirm(uxSchirm); } }, [uxSchirm]);
  if (inviteToken) {
    const inv = state.invitations.find((i) => i.token === inviteToken);
    return inv ? <InviteTeamSetup invitation={inv} /> : <InviteInvalid />;
  }
  if (!state.role && !pastStart) return <Startseite onContinue={() => setPastStart(true)} />;
  return state.role ? <Shell /> : <><FeierabendHinweis /><Login intent={intent} /></>;
}
